const $=s=>document.querySelector(s);
const $$=s=>[...document.querySelectorAll(s)];

/** Safe, shopper-facing Dutch copy — never pass through raw JSON or empty strings. */
function wsUserFacingMessage(err,fallback){
  if(err==null||err==='')return fallback;
  if(typeof err==='string'){
    const t=err.trim();
    if(!t||t==='undefined'||/^\[|^\{/.test(t))return fallback;
    return t;
  }
  if(err instanceof Error){
    const t=(err.message||'').trim();
    if(!t||t==='undefined'||/^\[|^\{/.test(t))return fallback;
    return t;
  }
  return fallback;
}

/** True when the browser reports a transport failure (app down, DNS, offline, CORS edge). */
function wsLooksLikeBrowserNetworkFailure(err){
  if(err==null)return false;
  const raw=(typeof err==='string')?err:(err instanceof Error?err.message:String(err));
  const m=String(raw||'').toLowerCase();
  if(!m)return false;
  return /failed to fetch|load failed|networkerror|network request failed|fetch is aborted|the internet connection appears|you are offline|offline|net::err|ecconnrefused|econnreset|socket hang up|terminated|blocked by extension|cors|ssl|certificate/.test(m);
}

function wsShopRoot(){
  return (typeof window.Shopify!=='undefined'&&window.Shopify.routes&&window.Shopify.routes.root)?window.Shopify.routes.root:'/';
}
function wsCartAddUrl(){return wsShopRoot()+'cart/add.js';}
/** WSC-04: reject welcome checkout reads that overlap a cart add. */
const wsCartWriteState={pending:0,epoch:0};

/** Canonical GET cart JSON (`item_count`, `items`, …) — https://shopify.dev/docs/api/ajax/reference/cart */
function wsCartJsUrl(){return wsShopRoot()+'cart.js';}

/** Path (+ optional query) for Cart API `sections_url`; must begin with `/` per Shopify Ajax Cart docs. */
function wsCartSectionsUrl(){
  const u=(typeof window.WS_CART_SECTIONS_URL==='string'?window.WS_CART_SECTIONS_URL:'').trim();
  if(u.charAt(0)==='/')return u.split('#')[0];
  if(u){
    try{
      const abs=new URL(u,window.location.origin);
      return abs.pathname+(abs.search||'');
    }catch(_){/* ignore */}
  }
  return '/cart';
}

/** Move `#toast` under `document.body` once — avoids fixed snackbar clipped inside `#wallstraight-generator { overflow:hidden }` (WebKit/Safari). */
function wsPortalToastToBody(){
  const toast=document.getElementById('toast');
  if(!toast||toast.dataset.wsPortaled==='1')return;
  if(toast.parentElement!==document.body)document.body.appendChild(toast);
  toast.dataset.wsPortaled='1';
}

(function wsInitToastPortal(){
  function run(){ wsPortalToastToBody(); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
})();

/* Portal the cart success <dialog> to document.body at DOM ready (same pattern as
   the toast portal above). Without this, the very first add-to-cart paints the
   dialog inside #wallstraight-generator { overflow:hidden } before our show fn
   has a chance to portal it — Safari then clips/hides the overlay. The portal
   helper is idempotent (dataset.wsPortaled flag). */
(function wsInitCartSuccessDialogPortal(){
  function run(){
    if(typeof wsPortalCartSuccessDialogToBody==='function')wsPortalCartSuccessDialogToBody();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
})();

/* Portal material-preview dialog to document.body — #wallstraight-generator uses
   overflow:hidden (see ws-generator.css) which clips showModal() overlays inside the section. */
(function wsInitMatSampleDialogPortal(){
  function run(){
    if(typeof wsPortalMatSampleDialogToBody==='function')wsPortalMatSampleDialogToBody();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
})();

/**
 * Update header cart icon via Ajax Cart **bundled section rendering** (`sections` / `sections_url` on `POST …/cart/add.js`).
 * Same mechanism as Shopify’s Cart API bundled sections (cart/add.js + sections parameter).
 */
function wsHydrateCartBubbleFromAddResponse(parsed){
  if(!parsed||typeof parsed!=='object'||!parsed.sections)return;
  const raw=parsed.sections['cart-icon-bubble'];
  if(typeof raw!=='string'||!raw)return;
  const host=document.getElementById('cart-icon-bubble');
  if(!host)return;
  let inner;
  try{
    inner=new DOMParser().parseFromString(raw,'text/html').querySelector('.shopify-section');
  }catch(_){return;}
  if(inner)host.innerHTML=inner.innerHTML;
}

/** Dawn `<cart-notification>` bundled section IDs — align with `getSectionsToRender()` → `section.id` in `assets/cart-notification.js`. */
const WS_CART_NOTIFICATION_BUNDLE_IDS=['cart-notification-product','cart-notification-button','cart-icon-bubble'];

/**
 * Opens header `cart-notification` when Shopify Cart Ajax returns non-null bundled section HTML for those IDs.
 * On failure (`null` sections per Shopify docs), missing DOM, or render throws — returns false; caller uses toast + bubble hydrate.
 */
function wsTryOpenCartNotificationFromAddResponse(parsed){
  if(!parsed||typeof parsed!=='object'||typeof parsed.sections!=='object'||!parsed.sections)return false;
  const cn=document.querySelector('cart-notification');
  if(!cn||typeof cn.renderContents!=='function')return false;
  let idx;
  for(idx=0;idx<WS_CART_NOTIFICATION_BUNDLE_IDS.length;idx++){
    const key=WS_CART_NOTIFICATION_BUNDLE_IDS[idx];
    const raw=parsed.sections[key];
    if(typeof raw!=='string'||!raw.trim())return false;
  }
  const item0=parsed.items&&parsed.items[0];
  let vid=parsed.id;
  if(vid==null&&item0!=null){
    vid=item0.variant_id!=null?item0.variant_id:item0.id;
  }
  const n=(typeof vid==='number'?vid:Number(vid));
  if(!Number.isFinite(n)||n<=0)return false;
  const payload=Object.assign({},parsed,{id:n});
  try{
    if(typeof cn.setActiveElement==='function')cn.setActiveElement(document.activeElement);
    cn.renderContents(payload);
    return true;
  }catch(err){
    if(typeof console!=='undefined'&&console.warn){
      console.warn('[Wallstraight] cart-notification.renderContents failed',err);
    }
    return false;
  }
}

/** Canonical app-proxy path — keep in sync with Shopify app [app_proxy] config. */
const WS_PROXY_GENERATE=(typeof window.WS_PROXY_GENERATE_URL==='string'&&window.WS_PROXY_GENERATE_URL)?window.WS_PROXY_GENERATE_URL:'/apps/wallstraight/ai/generate';
const WS_PROXY_GENERATE_NOTIFY=WS_PROXY_GENERATE.replace(/\/generate\/?$/,'/generate/notify');
const WS_PROXY_GENERATE_RECOVERY=WS_PROXY_GENERATE.replace(/\/generate\/?$/,'/generate/recovery');
/** R-AI-ONLY — upload-time subject verify (mirrors worker /proxy/ai/subject-verify). */
const WS_PROXY_SUBJECT_VERIFY=(typeof window.WS_PROXY_SUBJECT_VERIFY_URL==='string'&&window.WS_PROXY_SUBJECT_VERIFY_URL)?window.WS_PROXY_SUBJECT_VERIFY_URL:WS_PROXY_GENERATE.replace(/\/generate\/?$/,'/subject-verify');
const WS_AI_DETECTOR_NAME='server_ai_subject_verify';
const WS_AI_VERIFY_WAIT_MS=10000;
/** Speed Phase 1B — generate-time cap for `wsResolveVisionMeta` waiting on the upload-time
 * subject-verify prefetch. Worst-case pre-POST blocking drops from 10s → 2s when the verify
 * is still in-flight on Generate click; when `verifyCacheId` is already set the wait is
 * skipped entirely (cached). Worker re-verifies regardless of the wire field, so an
 * optimistic POST is correct (`docs/wallstraight-generate-api.md` L38). The 10s cap above
 * still bounds the upload-time prefetch path. */
const WS_VISION_META_GENERATE_WAIT_MS=2000;
/** Override optional; otherwise derived as `{generate}/status` with `job_id` appended at request time. */
const WS_PROXY_GENERATE_STATUS=(typeof window.WS_PROXY_GENERATE_STATUS_URL==='string'&&window.WS_PROXY_GENERATE_STATUS_URL)?window.WS_PROXY_GENERATE_STATUS_URL:'';

function wsSleep(ms){return new Promise(function(r){setTimeout(r,ms);});}

/**
 * R-FEED-1 — Client-side perf telemetry. Lightweight, defensive,
 * zero-dependency. Records named milestones via `performance.now()` so a
 * single generation can be reconstructed as a waterfall (face-detect wait
 * vs network RTT vs server queue vs polling vs image decode) without a
 * heavyweight tracer. Each call is O(1) and only allocates one object
 * lookup; the entire surface adds <1 KB to the bundle.
 *
 * Lifecycle:
 *   • `wsPerfStart()` opens a fresh run — clears prior marks so multiple
 *     reroll attempts do not bleed into each other's numbers.
 *   • `wsPerfMark(name)` stamps `name` with the current high-resolution
 *     timestamp. Repeated marks overwrite (we always want the latest).
 *   • `wsPerfDelta(from, to)` returns a non-negative integer millisecond
 *     delta or `null` if either mark is missing — never throws.
 *   • `wsPerfReport(extras)` mirrors the recorded marks, computes the
 *     canonical bucket deltas (`face_detect_ms`, `post_rtt_ms`, …), and
 *     attaches them to `window.__WS_LAST_PERF__` for DevTools inspection
 *     and to `S._perfMs` so the result page / dashboards can correlate
 *     with `ws_generation_meta.duration_ms`. Console pretty-print fires
 *     only when the shopper opted into debug via `?ws_perf=1` or the
 *     `window.__WS_PERF_DEBUG__===true` global — no console noise for
 *     real shoppers.
 *
 * The buckets emitted on the POST under `clientPerfPre` are intentionally
 * pre-POST only (`face_detect_ms`, `vision_to_post_ms`), since post-POST
 * timings cannot be known until the response arrives. Server is lenient
 * (unknown fields ignored) so this is safe to ship ahead of a coordinated
 * wallstraight-app reader update for `client_perf_pre`.
 */
const WS_PERF={marks:{}};
function wsPerfNow(){
  return (typeof performance!=='undefined'&&performance.now)?performance.now():Date.now();
}
function wsPerfStart(){
  WS_PERF.marks={};
  wsPerfMark('t_generate_start');
}
function wsPerfMark(name){
  if(!name||typeof name!=='string')return;
  WS_PERF.marks[name]=wsPerfNow();
}
function wsPerfDelta(from,to){
  const a=WS_PERF.marks[from];
  const b=WS_PERF.marks[to];
  if(typeof a!=='number'||typeof b!=='number')return null;
  const d=Math.max(0,Math.round(b-a));
  return Number.isFinite(d)?d:null;
}
function wsPerfDebugEnabled(){
  try{
    if(typeof window!=='undefined'&&window.__WS_PERF_DEBUG__===true)return true;
    if(typeof window!=='undefined'&&window.location&&typeof window.location.search==='string'){
      return /[?&]ws_perf=1\b/.test(window.location.search);
    }
  }catch(_){/* SSR / sandboxed contexts: silently disabled */}
  return false;
}
function wsPerfReport(extras){
  const buckets={
    face_detect_ms: wsPerfDelta('t_generate_start','t_vision_resolved'),
    vision_to_post_ms: wsPerfDelta('t_vision_resolved','t_post_started'),
    post_rtt_ms: wsPerfDelta('t_post_started','t_post_first_byte'),
    post_body_ms: wsPerfDelta('t_post_first_byte','t_post_body_parsed'),
    async_poll_ms: wsPerfDelta('t_post_body_parsed','t_async_resolved'),
    image_decode_ms: wsPerfDelta('t_async_resolved','t_image_decoded'),
    total_ms: wsPerfDelta('t_generate_start','t_image_decoded')
  };
  const part4Extras={};
  if(wsLoaderPart4Epoch>0){
    part4Extras.part4_elapsed_at_complete=Date.now()-wsLoaderPart4Epoch;
  }
  if(typeof wsLoaderRevealTapTimes!=='undefined'&&Array.isArray(wsLoaderRevealTapTimes)){
    part4Extras.tap_count=wsLoaderRevealTapTimes.length;
  }
  const notifySheet=document.getElementById('part4NotifySheet');
  if(notifySheet){
    part4Extras.email_sheet_shown=notifySheet.classList.contains('show');
  }
  if(typeof wsPart4NotifySubmitted!=='undefined'){
    part4Extras.email_captured=!!wsPart4NotifySubmitted;
  }
  const payload=Object.assign({marks:Object.assign({},WS_PERF.marks),buckets:buckets},part4Extras,extras||{});
  try{
    if(typeof window!=='undefined')window.__WS_LAST_PERF__=payload;
    if(typeof S==='object'&&S)S._perfMs=buckets;
  }catch(_){/* ignored — telemetry is best-effort */}
  if(wsPerfDebugEnabled()){
    try{
      const rows=Object.keys(buckets).filter(k=>buckets[k]!=null).map(k=>({bucket:k,ms:buckets[k]}));
      if(typeof console!=='undefined'&&console.table&&rows.length)console.table(rows);
      if(typeof console!=='undefined'&&console.info)console.info('[Wallstraight perf]',payload);
    }catch(_){/* ignored */}
  }
  return payload;
}

/**
 * Builds GET URL for async job polling. Preserves query string on the generate path (Shopify proxy params).
 */
function wsGenerationStatusFetchUrl(generateBase,jobId,cacheBust){
  const jid=String(jobId||'').trim().slice(0,120);
  if(!jid)return '';
  const hasOverride=!!(WS_PROXY_GENERATE_STATUS && String(WS_PROXY_GENERATE_STATUS).trim());
  const rawBase=((hasOverride?WS_PROXY_GENERATE_STATUS:generateBase)||'').trim();
  if(!rawBase)return '';
  const hasScheme=/^https?:\/\//i.test(rawBase);
  const origin=(typeof window!=='undefined'&&window.location&&window.location.origin)?window.location.origin:'http://localhost';
  var u;
  try{ u = hasScheme ? new URL(rawBase) : new URL(rawBase, origin); }
  catch(_){ return ''; }
  if(!hasOverride){
    u.pathname=String(u.pathname||'/').replace(/\/+$/,'')+'/status';
  }
  u.searchParams.set('job_id',jid);
  if(cacheBust!=null&&cacheBust!==''){
    u.searchParams.set('_',String(cacheBust));
  }
  if(hasScheme)return u.toString();
  return u.pathname+u.search;
}

/**
 * Narrow snippet strings from proxy JSON failures for billing/limit classifiers — observability-only shapes.
 */
function wsProxySnippetStringsFromParsed(d){
  var a=[];
  if(!d||typeof d!=='object'||Array.isArray(d))return a;
  if(typeof d.error==='object'&&d.error){
    if(typeof d.error.message==='string')a.push(d.error.message);
    if(typeof d.error.code==='string')a.push(String(d.error.code));
    if(typeof d.error.description==='string')a.push(d.error.description);
  }
  if(typeof d.message==='string')a.push(d.message);
  if(typeof d.code==='string')a.push(String(d.code));
  if(typeof d.description==='string')a.push(d.description);
  return a;
}

/**
 * Upstream-capacity billing guard (Gemini/OpenAI dashboards often surface literal “billing … hard limit” text).
 * False-positive control: requires “billing” + “hard … limit”, or canonical `billing_hard_limit` wire code.
 */
function wsLooksLikeUpstreamBillingHardLimit(httpStatus,code,primaryDetail,extraParts){
  void httpStatus;
  const cNorm=String(code||'').trim().toLowerCase();
  if(cNorm==='billing_hard_limit')return true;
  const parts=[];
  if(primaryDetail!=null&&String(primaryDetail).trim())parts.push(String(primaryDetail));
  var list=extraParts;
  if(list&&typeof list!=='object')list=[list];
  if(Array.isArray(list)){
    for(let i=0;i<list.length;i++){
      if(list[i]!=null&&String(list[i]).trim())parts.push(String(list[i]));
    }
  }
  const blob=parts.join(' \n ').toLowerCase().replace(/\s+/g,' ');
  if(!blob)return false;
  const hasBilling=/\bbilling\b/.test(blob);
  const hasHardCap=/billing\s+hard\s+limit|hard\s+billing\s+limit|\bhard[\s_-]+limit\b/.test(blob);
  return !!(hasBilling&&hasHardCap);
}

/**
 * Polls until JSON 200 (success), JSON error (failure), or deadline. Retries **OK** non-JSON / network errors
 * (transient app-proxy HTML) without finalizing quota — only the first JSON 200 does. HTTP **error** responses
 * (4xx/5xx) are **terminal** once the body is read so gateway HTML/JSON does not spin for 28 minutes.
 * Optional `on202` fires on processing responses (truthful coarse progress fields when the proxy sends them).
 * Each GET uses {@link WS_POLL_STATUS_FETCH_TIMEOUT_MS} so a stalled TCP/proxy response cannot freeze Part 4.
 */
const WS_POLL_STATUS_FETCH_TIMEOUT_MS=30000;
/** R1 LOADER-UNSTICK: cap blocking decode after poll 200; loader dismisses before this completes. */
const WS_SET_RES_IMAGE_DECODE_TIMEOUT_MS=8000;
/** POLL-HANDSHAKE — wake stalled poll sleeps / in-flight GET on focus or long 202 streak. */
const WS_POLL_STALL_WAKE_MS=12000;
const WS_POLL_LONG_JOB_ELAPSED_MS=55000;
/** No status GET activity — wake in-flight sleep/fetch (Safari tab throttle). */
const WS_POLL_STALL_RECOVER_MS=15000;
/** Last-resort one-shot status GET + fast-path inject into poll loop. */
const WS_POLL_EMERGENCY_COMPLETE_MS=22000;
const WS_POLL_WATCHDOG_INTERVAL_MS=4000;
let wsPollLoopWake=null;
let wsPollLoopFetchAbort=null;
let wsPollWatchdogBound=false;
let wsPollLastActivityAt=0;
let wsPollWatchdogTimer=null;
let wsPollFastPathResult=null;
let wsPollEmergencyFetchRunning=false;
function wsPollTouchActivity(){
  wsPollLastActivityAt=Date.now();
}
function wsPollWatchdogStop(){
  if(wsPollWatchdogTimer){
    clearInterval(wsPollWatchdogTimer);
    wsPollWatchdogTimer=null;
  }
}
async function wsPollFetchStatusOnce(jobId,extraHeaders,cacheBust){
  const url=wsGenerationStatusFetchUrl(WS_PROXY_GENERATE,jobId,cacheBust);
  if(!url)return null;
  var pollFetchAc=(typeof AbortController!=='undefined')?new AbortController():null;
  var pollFetchTimer=pollFetchAc?setTimeout(()=>{try{pollFetchAc.abort();}catch(_){/* ignore */}},WS_POLL_STATUS_FETCH_TIMEOUT_MS):0;
  try{
    const res=await fetch(url,{method:'GET',headers:Object.assign({'Accept':'application/json'},extraHeaders||{}),credentials:'same-origin',signal:pollFetchAc?pollFetchAc.signal:undefined});
    if(pollFetchTimer)clearTimeout(pollFetchTimer);
    var bodyText='';
    try{bodyText=await res.text();}catch(_){bodyText='';}
    var d=null;
    if(bodyText){
      try{d=JSON.parse(bodyText);}catch(_){d=null;}
    }
    return {res:res,d:d,bodyText:bodyText};
  }catch(_){
    if(pollFetchTimer)clearTimeout(pollFetchTimer);
    return null;
  }
}
async function wsPollEmergencyComplete(extraHeaders){
  if(wsPollEmergencyFetchRunning||wsPollFastPathResult)return;
  if(typeof S==='undefined'||!S||!S.busy||!S.inFlightAsyncJobId)return;
  if(!ldEl||!ldEl.classList.contains('show'))return;
  const jobId=String(S.inFlightAsyncJobId||'').trim();
  if(!jobId)return;
  wsPollEmergencyFetchRunning=true;
  wsPollLoopWakeNow();
  try{
    const polled=await wsPollFetchStatusOnce(jobId,extraHeaders,Date.now());
    wsPollTouchActivity();
    if(polled&&polled.res&&polled.res.status===200&&polled.d&&typeof polled.d==='object'&&!Array.isArray(polled.d)){
      wsPollFastPathResult={res:polled.res,d:polled.d};
      wsPollLoopWakeNow();
    }
  }finally{
    wsPollEmergencyFetchRunning=false;
  }
}
function wsPollWatchdogStart(extraHeaders){
  wsPollWatchdogStop();
  wsPollTouchActivity();
  wsPollWatchdogTimer=setInterval(function(){
    if(!wsPollWatchdogShouldWake())return;
    const idle=Date.now()-wsPollLastActivityAt;
    if(idle>=WS_POLL_EMERGENCY_COMPLETE_MS){
      void wsPollEmergencyComplete(extraHeaders||{});
      return;
    }
    if(idle>=WS_POLL_STALL_RECOVER_MS){
      wsPollLoopWakeNow();
    }
  },WS_POLL_WATCHDOG_INTERVAL_MS);
}
function wsPollLoopWakeNow(){
  try{if(wsPollLoopFetchAbort)wsPollLoopFetchAbort.abort();}catch(_){/* ignore */}
  wsPollLoopFetchAbort=null;
  if(typeof wsPollLoopWake==='function'){
    const wake=wsPollLoopWake;
    wsPollLoopWake=null;
    try{wake();}catch(_){/* ignore */}
  }
}
function wsPollLoopClearWake(){
  wsPollLoopWakeNow();
  wsPollLoopWake=null;
}
function wsPollInterruptibleSleep(ms){
  const n=Math.max(0,Math.floor(Number(ms)||0));
  if(n<=0)return Promise.resolve();
  return new Promise(function(resolve){
    const timer=setTimeout(function(){
      if(wsPollLoopWake===resolve)wsPollLoopWake=null;
      resolve();
    },n);
    wsPollLoopWake=function(){
      clearTimeout(timer);
      if(wsPollLoopWake===resolve)wsPollLoopWake=null;
      resolve();
    };
  });
}
function wsPollWatchdogShouldWake(){
  if(typeof S==='undefined'||!S||!S.busy||!S.inFlightAsyncJobId)return false;
  if(!ldEl||!ldEl.classList.contains('show'))return false;
  return true;
}
function wsPollWatchdogEnsureBound(){
  if(wsPollWatchdogBound||typeof window==='undefined'||typeof document==='undefined')return;
  wsPollWatchdogBound=true;
  const onWake=function(){
    if(!wsPollWatchdogShouldWake())return;
    wsPollTouchActivity();
    wsPollLoopWakeNow();
  };
  document.addEventListener('visibilitychange',function(){
    if(document.visibilityState==='visible')onWake();
  });
  window.addEventListener('focus',onWake);
}
function wsPollAdaptiveDelayMs(pollStartedAt){
  const elapsed=Date.now()-pollStartedAt;
  if(elapsed<10000)return 1000;
  if(elapsed<30000)return 2000;
  return 5000;
}
async function wsPollGenerationUntilReady(jobId,extraHeaders,on202){
  wsPollWatchdogEnsureBound();
  wsPollWatchdogStart(extraHeaders);
  const deadline=Date.now()+28*60*1000;
  var delay=650;
  var pollStartedAt=Date.now();
  var lastPollProgressAt=Date.now();
  var consecutive202=0;
  try{
  while(Date.now()<deadline){
    if(wsPollFastPathResult){
      const fast=wsPollFastPathResult;
      wsPollFastPathResult=null;
      wsPollTouchActivity();
      return fast;
    }
    wsPollTouchActivity();
    var cacheBust=(consecutive202>=8||Date.now()-lastPollProgressAt>=WS_POLL_STALL_WAKE_MS||Date.now()-pollStartedAt>=WS_POLL_LONG_JOB_ELAPSED_MS)?Date.now():'';
    var url=wsGenerationStatusFetchUrl(WS_PROXY_GENERATE,jobId,cacheBust);
    if(!url)throw new Error(wsT('err.unexpected'));
    var res;
    var pollFetchAc=(typeof AbortController!=='undefined')?new AbortController():null;
    wsPollLoopFetchAbort=pollFetchAc;
    var pollFetchTimer=pollFetchAc?setTimeout(()=>{try{pollFetchAc.abort();}catch(_){/* ignore */}},WS_POLL_STATUS_FETCH_TIMEOUT_MS):0;
    try{
      res=await fetch(url,{method:'GET',headers:Object.assign({'Accept':'application/json'},extraHeaders||{}),credentials:'same-origin',signal:pollFetchAc?pollFetchAc.signal:undefined});
    }catch(_){
      if(pollFetchTimer)clearTimeout(pollFetchTimer);
      wsPollLoopFetchAbort=null;
      await wsPollInterruptibleSleep(Math.min(delay,4000));
      delay=Math.min(Math.floor(delay*1.35),8000);
      continue;
    }
    if(pollFetchTimer)clearTimeout(pollFetchTimer);
    wsPollLoopFetchAbort=null;
    lastPollProgressAt=Date.now();
    wsPollTouchActivity();
    var bodyTextPoll='';
    try{bodyTextPoll=await res.text();}catch(_){bodyTextPoll='';}
    var trimmedPoll=(bodyTextPoll||'').trim();
    var pPoll=null;
    if(trimmedPoll){
      try{pPoll=JSON.parse(trimmedPoll);}catch(_){pPoll=null;}
    }
    var isObjPoll=pPoll&&typeof pPoll==='object'&&!Array.isArray(pPoll);
    if(res.status===200){
      if(isObjPoll){
        consecutive202=0;
        return {res:res,d:pPoll};
      }
      await wsPollInterruptibleSleep(Math.min(delay,4000));
      delay=Math.min(Math.floor(delay*1.35),8000);
      continue;
    }
    if(!res.ok){
      var wireCodePoll=isObjPoll&&pPoll.error&&typeof pPoll.error.code==='string'?String(pPoll.error.code):(isObjPoll&&typeof pPoll.code==='string'?String(pPoll.code):'');
      var msgPoll=isObjPoll&&typeof pPoll.error==='object'&&pPoll.error&&typeof pPoll.error.message==='string'?String(pPoll.error.message):(isObjPoll&&typeof pPoll.message==='string'?String(pPoll.message):'');
      var snipsPoll=isObjPoll?wsProxySnippetStringsFromParsed(pPoll):[];
      snipsPoll.push(bodyTextPoll);
      if(wsLooksLikeUpstreamBillingHardLimit(res.status,wireCodePoll,msgPoll,snipsPoll)){
        throw Object.assign(new Error(wsT('err.billing_upstream')),{status:res.status,code:'billing_upstream'});
      }
      if(isObjPoll)return {res:res,d:pPoll};
      var normPollCode=wireCodePoll||(res.status>=500?'provider_error':'');
      throw Object.assign(new Error(wsErrorMessage(res.status,wireCodePoll,msgPoll||(bodyTextPoll||'').slice(0,500))),{status:res.status,code:normPollCode});
    }
    var ct=(res.headers.get('content-type')||'').toLowerCase();
    if(!ct.includes('application/json')&&!isObjPoll){
      await wsPollInterruptibleSleep(Math.min(delay,4000));
      delay=Math.min(Math.floor(delay*1.35),8000);
      continue;
    }
    if(!isObjPoll){
      await wsPollInterruptibleSleep(Math.min(delay,4000));
      continue;
    }
    if(res.status===202){
      consecutive202++;
      if(typeof on202==='function'){
        try{ on202(pPoll); }catch(_){}
      }
      var serverElapsed=(pPoll&&typeof pPoll.ws_generation_elapsed_ms==='number'&&Number.isFinite(pPoll.ws_generation_elapsed_ms))?Math.max(0,pPoll.ws_generation_elapsed_ms):0;
      var r=(pPoll&&typeof pPoll.retry_after_ms==='number'&&pPoll.retry_after_ms>0)?pPoll.retry_after_ms:650;
      r=Math.max(wsPollAdaptiveDelayMs(pollStartedAt),Math.min(Math.max(200,r),8000));
      if(serverElapsed>=WS_POLL_LONG_JOB_ELAPSED_MS||consecutive202>=6||Date.now()-pollStartedAt>=WS_POLL_STALL_WAKE_MS){
        r=Math.min(r,350);
      }
      await wsPollInterruptibleSleep(r);
      delay=r;
      continue;
    }
    return {res:res,d:pPoll};
  }
  throw Object.assign(new Error(wsT('err.proxy_non_json')),{status:0,code:'poll_timeout'});
  }finally{
    wsPollLoopClearWake();
    wsPollWatchdogStop();
    wsPollFastPathResult=null;
  }
}
// Bumped to 12 for R-ROYAL-UNITY (May 2026): human royal "full package"
// — crown de-prime + outdoor terrace translation (Slice A); makeup
// deconflict (Slice B); painterly surface extended to held objects +
// glassware + accessories (Slice C); new `ROYAL_HUMAN_PROP_ADJUNCT`
// Bond-safe held-prop translator (Slice D); crown-optional default
// (Slice E); Avoid extended with held-prop + surface-mismatch negatives
// (Slice F). v11 solo-pet path (Jacky / Nana) FROZEN — zero edits to
// `ROYAL_PROMPT_BODY_PET_BASE`, `ROYAL_PROMPT_BODY_DUAL`, any `ROYAL_PET_*`,
// `wsBuildRoyalPetBody()`, or `ROYAL_STYLE_EDIT_SUFFIX` (shared on worker).
// See `~/.cursor/plans/portrait_unity_evidence_plan_a98e9eb1.plan.md`.
// R-PORTRAIT-COHERENCE v13 — cross-style global unity (people categories).
// Royal human v12 adjuncts remain primary; v13 adds thin recap + non-royal tails.
// See `.cursor/plans/universal_verify_unity_e6ea97db.plan.md`.
const WS_PROMPT_VERSION=58;
/**
 * Phase 2 / Slice 2a (May 2026) — `prompt_mode` wire field opt-in.
 *
 * When set to `'server_only'` (the post-Phase-2 default), the storefront
 * POST tells the worker that the theme is treating the `prompt` field as
 * a CARRIER for inscription + user notes + framed extras only — the
 * recipe body is owned by the worker via `KNOWN_STYLE_EDIT_LINES` +
 * `stitchedPromptForWallstraightGenerate`. The worker honours the flag by
 * rejecting unknown styles (`unsupported_style_for_server_only`) and
 * relaxing its `missing_prompt` gate so the carrier may legitimately be
 * empty (no inscription, no notes, no framed extra).
 *
 * Single-line rollback: set this constant to `null` (or any string other
 * than `'server_only'`) to revert to pre-Phase-2 wire shape — the worker
 * stays back-compatible with both modes.
 *
 * Plan: `simplify_portrait_funnel_73f8876b §4 Phase 2 (Single prompt
 * authority)` + §7 success criteria ("One authoritative prompt surface
 * (worker); theme meta-only behind flag"). Worker counterpart in
 * `wallstraight-app/wallstraight/app/lib/openai-image-edit.server.ts`
 * (Slice 2a-worker commit d64a729 on bitbucket/main).
 */
const WS_PROMPT_MODE='server_only';
const WS_LANG_STORAGE_KEY='ws_ui_lang';

/** NL / EN UI copy; EL merges EN and overrides selected keys (e.g. hero). Style tiles: {@link WS_STYLE_LABELS}. */
const WS_STR={
  nl:{
    'logo.tagline':'Portretkunst',
    'nav.shop_more':'Meer shoppen','nav.how':'Tips','nav.ex':'Voorbeelden','nav.pr':'Prijzen','nav.cta':'Maak gratis preview','nav.cta_short':'Gratis preview',
    'nav.menu_open':'Menu','nav.menu_close':'Sluit menu','nav.menu_title':'Navigatie',
    'wiz.ind1.title':'Categorie',
    'wiz.ind2.title':'Stijl',
    'wiz.ind3.title':'Upload',
    'wiz.dots_nav_aria':'Voortgang: portret maken',
    'wiz.breadcrumb_nav_aria':'Stappen: categorie, stijl, foto uploaden',
    'wiz.breadcrumb.s1':'Categorie kiezen',
    'wiz.breadcrumb.s2':'Stijl kiezen',
    'wiz.breadcrumb.s3':'Foto uploaden',
    'wiz.breadcrumb.s1_aria':'Stap 1: categorie kiezen',
    'wiz.breadcrumb.s2_aria':'Stap 2: stijl kiezen',
    'wiz.breadcrumb.s3_aria':'Stap 3: foto uploaden',
    'wiz.step_n_of_m':'Stap {0} van {1}',
    'wiz.step_title_sep':' · ',
    'wiz.back':'Terug',
    'wiz.back_aria':'Vorige stap',
    'wiz.chg_cat':'Wijzig categorie',
    'wiz.chg_cat_aria':'Ga naar stap 1 om de categorie te wijzigen',
    'cat.infer.detected_prefix':'Gedetecteerd:',
    'cat.infer.type_label':'Portrettype',
    'cat.infer.change':'Wijzig',
    'cat.infer.change_aria':'Categorie wijzigen',
    'style.infer.selected_suffix':'geselecteerd',
    'style.infer.selected_label':'Geselecteerde stijl',
    'cat.infer.choose':'Kies categorie',
    'cat.infer.close':'Sluiten',
    'cat.infer.confirm_needed':'Bevestig het type portret voor deze foto.',
    'cat.infer.mixed_prompt':'We zien een persoon én een huisdier. Wat wil je portret?',
    'cat.infer.mixed_include_both':'Persoon + huisdier',
    'cat.infer.mixed_pet_only':'Alleen huisdier',
    'cat.infer.mixed_person_only':'Alleen persoon',
    'cat.infer.focus_label':'Focus',
    'cat.infer.choose_focus':'Kies focus',
    'cat.infer.change_focus':'Wijzig focus',
    'cat.infer.change_focus_aria':'Portretfocus wijzigen',
    'cat.infer.done':'Klaar',
    'wiz.chg_style':'Wijzig stijl',
    'wiz.chg_style_aria':'Ga naar stap 2 om de stijl te wijzigen',
    'wiz.nav_aria':'Stappen navigatie',
    'wiz.summary.cat_lbl':'I. Categorie',
    'wiz.summary.style_lbl':'II. Stijl',
    'wiz.summary.style_lbl_infer':'I. Stijl',
    'wiz.summary.photo_lbl':'III. Foto',
    'wiz.summary.photo_lbl_infer':'II. Foto',
    'wiz.summary.not_chosen':'Niet gekozen',
    'wiz.summary.photo_none':'Nog niet geüpload',
    'wiz.summary.photo_ok':'Geüpload',
    'wiz.summary.jump_cat_aria':'Ga naar stap 1 om de categorie te wijzigen',
    'wiz.summary.jump_style_aria':'Ga naar stap 2 om de stijl te wijzigen',
    'wiz.summary.upload_photo_aria':'Kies een foto om te uploaden',
    'wiz.help1':'Kies wie op het portret staat.',
    'wiz.next1':'Volgende — stijl kiezen',
    'wiz.help2':'Kies een stijl voor je portret.',
    'wiz.next2':'Volgende — foto uploaden',
    'wizard.defaults_caption':'Tik op categorie of stijl in het overzicht hierboven om je keuze te wijzigen.',
    'pill.huisdier':'Huisdieren','pill.gezin':'Gezinnen','pill.koppel':'Koppels','pill.kind':'Kinderen','pill.zelf':'Zelfportret',
    'ex.before':'Voor',
    'ex.step2_before_alt':'Voorbeeld: originele foto',
    'ex.step2_after_alt':'Voorbeeld: AI-resultaat in gekozen stijl',
    'upload.pick':'Foto kiezen','upload.fmt':'JPG, PNG, WebP · Max 10MB','upload.chg':'Andere foto','upload.rm':'✕ Verwijder',
    'upload.reviews_aria':'Klantverhalen','upload.reviews_dots_aria':'Kies een verhaal','upload.review.dot_aria':'Ga naar verhaal {n} van {total}',
    'upload.review.claudia.who':'Claudia H.','upload.review.claudia.body':'Hij vond de canvas oprecht heel erg mooi. Hij stond er echt lang naar te kijken \u2014 mega groot, en toch zo mooi, ook al was mijn originele foto niet zo groot.',
    'upload.review.vic.who':'Victor L.','upload.review.vic.body':'Je hebt Nacho\u2019s speelsheid perfect vastgelegd en ik waardeer het dat ik alleen het digitale bestand kan kopen.',
    'upload.review.nancy.who':'Nancy D.','upload.review.nancy.body':'Ik ben volledig tevreden over het eindresultaat. Onze Bonnie is de perfecte prinses.',
    'upload.review.kween.who':'Mira S.','upload.review.kween.body':'Ik ben dol op deze site! Ik had niet verwacht dat het eindresultaat zo adembenemend en mega groot zou zijn.',
    'upload.review.queenie.who':'Sophie V.','upload.review.queenie.body':'Mijn 80-jarige moeder was helemaal weg van haar Koninklijke transformatie! Haar bijnaam is Queenie, dus haar in koninklijke gewaden geschilderd zien voor haar verjaardagsmijlpaal was precies het perfecte eerbetoon.',
    'upload.review.after_wc':'Zachte aquarel','upload.review.unboxing.cta':'Bestel de jouwe nu','upload.review.unboxing.alt':'Klant opent een ingelijst portret',
    'upload.add_more':'Voeg foto toe','upload.add_more_aria':'Voeg een extra referentiefoto toe (max 3 totaal)',
    'upload.role.person':'Persoon','upload.role.pet':'Huisdier',
    'upload.remove_aria':'Verwijder deze foto','upload.slots_aria':'Extra referentiefoto’s',
    'tip.multi_photo.distinct_subjects':'Elke extra foto is bedoeld voor een andere persoon die samen op het portret moet.',
    'tip.multi_photo.distinct_subjects_more':'Waarom?',
    'tip.multi_photo.distinct_subjects_detail':'Meerdere foto’s? Bedoel elke foto voor een ander persoon — niet meerdere selfies van jezelf voor “scherpte”. Dat ondersteunen we niet en het kan vreemd uitpakken.',
    // Slice B.3 — Royal scene-template picker (only visible for royal style + eligible category/N).
    'scene.legend.title':'Vertel het verhaal',
    'scene.legend.hint':'Optioneel - kies hoe het tafereel zich ontvouwt',
    'scene.noble_lineage.title':'Vorstelijke lijn',
    'scene.noble_lineage.desc':'Kroon op het oudste figuur, jongere generatie als prinsen en prinsessen',
    'scene.court_of_equals.title':'Hof van gelijken',
    'scene.court_of_equals.desc':'Iedereen als adellijke gelijke - geen alleenheerser',
    'scene.royal_romance.title':'Vorstelijke romance',
    'scene.royal_romance.desc':'Het paar als hertog en hertogin in vorstelijke verbondenheid',
    // R-FEED-5 — explicit royal casting presets. Visibility is gated client-
    // side by `wsRefreshScenePicker` and authoritatively gated server-side by
    // `royalSceneAugmentClause`. Keys MUST stay aligned with the Liquid
    // `data-i18n` attributes in `sections/wallstraight-generator.liquid`.
    'scene.monarchs_pair.title':'Koning en koningin',
    'scene.monarchs_pair.desc':'Twee soevereinen op gelijke hoogte - mantel, kroon en tiara',
    'scene.royal_heir_baby_prince.title':'Kroonprins (baby)',
    'scene.royal_heir_baby_prince.desc':'Ouder(s) met een pasgeboren of klein kind als kroonprins',
    'scene.royal_heir_baby_princess.title':'Kroonprinses (baby)',
    'scene.royal_heir_baby_princess.desc':'Ouder(s) met een pasgeboren of klein kind als kroonprinses',
    'scene.royal_children_court.title':'Vorstelijke kinderhof',
    'scene.royal_children_court.desc':'Meerdere prinsen en prinsessen in eigen hofkostuum',
    // R-FEED-2 — Optional first-run shopper notes (always visible; routed
    // through the same `extraPrompt` / sanitizer path as retry edits).
    'notes.toggle.title':'Voeg een persoonlijke notitie toe (optioneel)',
    'notes.label.hint':'Vertel ons iets wat we moeten weten over jouw portret. We gebruiken dit als extra hint bij het genereren.',
    'notes.placeholder':'Bv. \'warmere tinten\' of \'mijn vader draagt altijd een bril\'',
    'notes.clear':'Wissen',
    'pet.name.title':'Voeg de naam van je huisdier toe aan het portret','pet.name.placeholder':'Bv. Luna','pet.name.confirm':'Doe hen die eer','pet.name.skip':'Geen naam in het portret','pet.name.edit_link':'Naam wijzigen of verwijderen',
    'inscription.headline':'Voeg een naam toe','inscription.pet.title':'Hoe heet je huisdier?','inscription.pet.prompt':'Hoe heet je huisdier?','inscription.solo.prompt':'Voeg een naam toe','inscription.group.prompt':'Voeg een familienaam toe','inscription.bond.prompt':'Voeg een naam toe','inscription.subtitle':'We voegen het discreet toe in de hoek van je portret, als een kleine galerie-signatuur.','inscription.placeholder.pet':'bv. Luna','inscription.placeholder.solo':'bv. Emma','inscription.placeholder.group':'bv. Familie Jansen','inscription.confirm.empty':'Voeg naam toe','inscription.confirm.filled':'Gebruik “{name}”','inscription.confirm.pet.empty':'Doe de eer','inscription.confirm.pet.filled':'Doe de eer','inscription.skip':'Geen tekst in mijn portret','inscription.edit_link':'Handtekening toevoegen','inscription.edit_link.has_name':'Handtekening wijzigen','inscription.error.email':'Dit veld is voor een naam in je portret — geen e-mailadres.','inscription.error.url':'Gebruik geen link of webadres — alleen een korte naam.','inscription.error.phone':'Gebruik geen telefoonnummer — alleen een korte naam.','inscription.error.message':'Houd het kort: alleen een naam (bv. Emma of Familie Jansen).',
    'gen.btn':'Genereer gratis preview',
    'hint.detect.no_face':'Geen gezicht herkend. Probeer een duidelijkere foto of een andere upload.',
    'hint.detect.unknown':'We konden niet automatisch verifiëren wie er op de foto staat — we genereren op basis van je categorie.',
    'hint.detect.ok_pet':'Huisdier-portret · klaar voor styling.',
    'hint.detect.ok_solo_zelf':'1 persoon herkend · klaar voor Zelfportret.',
    'hint.detect.ok_couple':'Ziet er goed uit voor twee personen · klaar om te genereren.',
    'hint.detect.ok_family':'Ziet er goed uit voor Gezinnen · klaar om te genereren.',
    'hint.detect.ok_kids':'Ziet er goed uit voor Kinderen · klaar om te genereren.',
    'hint.detect.ok_kids_adult_note':'Tip: zit er een volwassene op de foto? Wissel dan naar Gezinnen voor de juiste compositie.',
    'hint.detect.count_caveat':'Kleinere gezichten (baby\u2019s, gedeeltelijke profielen, mensen verder weg) tellen we niet altijd mee, maar ze komen wel in je portret.',
    'hint.detect.solo_in_gezin':'Je koos Gezinnen. Dat werkt het best als meerdere personen samen op één foto staan.',
    'hint.detect.solo_in_koppel':'Je koos Koppels. Dat werkt het best met twee personen samen op één foto.',
    'hint.detect.solo_in_kind':'Je koos Kinderen. Als dit een kind is, ga gerust door — als het een volwassene is, kies dan Zelfportret. Onze automatische detectie kan geen leeftijd onderscheiden.',
    'hint.detect.crowd_in_zelf':'Meerdere personen op deze foto, maar je koos Zelfportret — dat richt zich op één subject. Kies de categorie die bij je groep past (tweepersoons, gezin, …), of ga door als je één subject wilt benadrukken.',
    'hint.detect.crowd_in_koppel':'Je koos Koppels. Koppel is bedoeld voor twee personen op één foto — Gezinnen past beter bij grotere groepen.',
    'hint.detect.crowd_in_kind':'Het lijkt erop dat je Kinderen koos. Bij Gezinnen krijgen je kinderen én de volwassenen elk hun plek in het portret.',
    'hint.detect.suggest_zelf':'Wissel naar Zelfportret',
    'hint.detect.suggest_gezin':'Wissel naar Gezinnen',
    'hint.detect.suggest_koppel':'Kies tweepersoonsmodus',
    'hint.detect.suggest_huisdier':'Wissel naar Huisdieren',
    /* Track H (slice p2h-ux) — fires when subjectClass=likely_pet on a people
       category. Never says "N personen" because the photo is animal-primary. */
    'hint.detect.pet_in_kind':'Dit lijkt op een huisdierfoto. Kinderen is voor mensen — wissel naar Huisdieren voor het beste resultaat.',
    'hint.detect.pet_in_zelf':'Dit lijkt op een huisdierfoto. Zelfportret is voor mensen — wissel naar Huisdieren voor het beste resultaat.',
    'hint.detect.pet_in_gezin':'Dit lijkt op een huisdierfoto. Gezin is voor mensen — wissel naar Huisdieren voor het beste resultaat.',
    'hint.detect.pet_in_koppel':'Dit lijkt op een huisdierfoto. Koppel is voor mensen — wissel naar Huisdieren voor het beste resultaat.',
    /* Phase 2 / Slice P2.D — R-MIX2 mixed-subject banner. The shopper uploaded
       a single photo containing BOTH a person AND a pet, then picked a
       people category. Default behavior drops the pet — these copy variants
       offer category-aware copy plus optional swap CTAs; storefront POST now
       implies mixed_single_photo from vision (Generate) without a bond button. */
    'hint.detect.ok_zelf_person_pet':'Persoon én huisdier herkend · klaar voor Zelfportret.',
    'hint.detect.mixed_in_kind':'We zien een persoon én een huisdier op deze foto. Wil je beiden in het Kinderen-portret?',
    'hint.detect.mixed_in_gezin':'We zien een persoon én een huisdier op deze foto. Wil je beiden in het Gezin-portret?',
    'hint.detect.mixed_in_gezin_one_detected_person':'Je koos Gezinnen met één zichtbare persoon én een huisdier. Die modus kan extra mensen verzinnen die niet op je foto staan. Overweeg Zelfportret voor jou plus huisdier - of genereer als je dit zo wilt.',
    'hint.detect.mixed_in_koppel':'We zien een persoon én een huisdier, maar je koos Koppels (2 personen). De AI kan een tweede persoon verzinnen die niet bestaat. Probeer "Jij + je huisdier (Bond)" of "Zelfportret".',
    'hint.detect.action_mixed_bond':'Beiden meenemen (jij + je huisdier)',
    /* Phase 2 / Slice P2.D — R-MIX8 huisdier inversion. Soft warn when the
       shopper picked Pet portrait but the classifier sees a person. Same
       suggest_zelf swap as the people-categories use. */
    'hint.detect.inversion_human':'Huisdierenportretten vieren eerst je dieren - mensen kunnen wegvallen. Met Gezinnen of Zelfportret blijft iedereen op de foto samen in beeld.',
    'hint.detect.keep':'Toch doorgaan',
    /* CAW.C — assistive-tech-readable contract for the "Toch doorgaan"
       button. Spells out the four positive promises the click makes:
       (a) the uploaded foto stays the sole reference; (b) the picked
       category survives; (c) the picked style survives; (d) the AI
       attempts that category+style for ANY mix and ANY headcount. The
       visible label stays short ("Toch doorgaan") to match the soft-warn
       UX convention; the aria-label carries the contract for screen
       readers, automated tests, and product QA. */
    'hint.detect.keep_aria':'Toch doorgaan met deze foto. Categorie, stijl en bewerking blijven hetzelfde voor alle aanwezige personen en huisdieren.',
    'hint.baroque_nudge.body':'Voor een natuurlijke hond in old-master stijl zonder kostuum: kies Nederlandse Gouden Eeuw.',
    'hint.baroque_nudge.action':'Kies Gouden Eeuw',
    'hint.baroque_nudge.dismiss':'Niet nu',
    /* Phase 3 / Slice P3.B (R-FAB6) — quality hint banners. Each variant
       maps to one canonical reason from WS_QUALITY_REASONS / wsDecidePhotoQualityReasons.
       Tone matches the "tip" framing (helpful, never accusatory) — we
       NEVER block the upload, only suggest. */
    'quality.hint.too_dark':'Deze foto is vrij donker. Een lichtere opname (bij een raam of buiten in de schaduw) geeft een veel sterker portret.',
    'quality.hint.too_bright':'Deze foto is overbelicht. Vermijd direct zonlicht; zacht raamlicht werkt het beste.',
    'quality.hint.too_blurry':'Deze foto lijkt onscherp. Een scherpe close-up zorgt ervoor dat de gelijkenis behouden blijft in het portret.',
    'quality.hint.face_too_small':'Het gedetecteerde gezicht lijkt ver weg. Een dichtere uitsnede (gezicht en schouders) geeft het beste portret.',
    'quality.hint.too_low_res':'De resolutie van deze foto is laag. Upload bij voorkeur het origineel, niet een schermafbeelding of een gecomprimeerde versie.',
    'quality.hint.action_reupload':'Andere foto kiezen',
    'quality.hint.keep':'Toch doorgaan met deze foto',
    /* Phase 3 / Slice P3.B (R-FAB6) — always-visible 3-bullet tip strip
       above the dropzone. Sets expectations BEFORE the upload so the
       quality scan is reinforcement, not surprise. */
    'tip.upload.heading':'Voor het beste portret',
    'tip.upload.s1':'Duidelijke close-up van het gezicht',
    'tip.upload.s2':'Zacht, natuurlijk licht (bij een raam of buiten in de schaduw)',
    'tip.upload.s3':'Scherpe foto in hoge resolutie - liefst het origineel',
    'loader.phase1':'Preview wordt gemaakt…','loader.phase2':'Stijl wordt toegepast…','loader.phase3':'Details worden verfijnd…','loader.phase4':'Laatste details…',
    /* Part 3 — seven-line status rotator (`loader.status.1` … `7`) ending in “bijna klaar”, then Part 4 fullscreen. */
    'loader.status.1':'Je geüploade foto wordt bestudeerd…',
    'loader.status.2':'Unieke kenmerken worden behouden…',
    'loader.status.3':'Je gekozen kunststijl wordt toegepast…',
    'loader.status.4':'Je portretpreview wordt geschilderd…',
    'loader.status.5':'Details worden verfijnd…',
    'loader.status.6':'Laatste finishing touches…',
    'loader.status.7':'Je portret is bijna klaar…',
    /* Legacy i18n — no code path references this key today (halftone flow uses `loader.late_*`). Safe to remove after grep across forks. */
    'loader.status.hold':'We werken nog aan je portret — even geduld als het wat langer duurt.',
    /* Legacy name `loader.poll.*` — strings are Part 4 `#ldMsg` only (wired in wsLoaderApplyRenderingHoldDom); polling does not swap message by phase anymore. `queued` is currently unused — keep or delete with search in admin copies. */
    'loader.poll.status.queued':'Je preview is aangenomen — we zijn ermee bezig.',
    'loader.poll.status.rendering_head':'Je portret wordt nu gerenderd…',
    'loader.poll.status.rendering_sub.v1':'De Mona Lisa lieten ze ook niet haasten — en jouw portret haasten we evenmin.',
    'loader.poll.status.rendering_sub.v2':'Het duurt iets langer dan verwacht, maar jouw foto verdient die extra zorg.',
    'loader.poll.status.rendering_sub.v3':'Onze AI is nu een echte perfectionist — passend voor een meesterwerk.',
    'loader.poll.status.rendering_sub.v4':'Je meesterwerk krijgt zijn laatste laag magie. Geen Da Vinci, maar elke penseelstreek krijgt aandacht op galerieniveau.',
    'loader.poll.status.rendering_sub.v5':'Misschien hang je het straks thuis, maar we zorgen dat het een museumwand waardig voelt.',
    'loader.part4.patience_sub':'Bedank voor het wachten — je portret wordt met extra zorg gemaakt. Laat dit tabblad open terwijl we de preview afronden.',
    'loader.part4.tap_reassure':'Je portret wordt al gemaakt. Nogmaals klikken start het niet opnieuw en versnelt het niet — we werken het scherm automatisch bij zodra het klaar is.',
    'loader.part4.long_wait_sub':'Nog bezig. Premium portretgeneratie kan iets langer duren wanneer we gelijkenis, stijl en printklare details bewaren. Je kunt dit tabblad open laten of je e-mail achterlaten — dan laten we het je weten.',
    'loader.part4.long_wait_sub_captured':'Nog bezig. Premium portretgeneratie kan iets langer duren wanneer we gelijkenis, stijl en printklare details bewaren. Laat dit tabblad open — we mailen je zodra het klaar is.',
    'loader.part4.already_generating':'Je portret wordt al gemaakt — even geduld.',
    'part4_notify.title':'Duurt ongeveer 30–60 seconden om jouw perfecte kunstwerk te maken',
    'part4_notify.body':'Je preview wordt nu gemaakt. Wil je een e-mail zodra het klaar is?',
    'part4_notify.body_account':'Je portret wordt nog verwerkt. We mailen {email} zodra deze preview klaar is.',
    'part4_notify.email_label':'E-mail',
    'part4_notify.submit':'Mail me wanneer het klaar is',
    'part4_notify.dismiss':'Ik wacht verder',
    'part4_notify.success_title':'Genoteerd',
    'part4_notify.success_body':'We mailen je zodra je portret klaar is. Je kunt dit tabblad open laten.',
    'part4_notify.err_submit':'Opslaan mislukt. Probeer opnieuw.',
    'loader.real.hope_working_aria':'Nog bezig met je portret',
    'loader.tap.still_working':'Nog bezig — laat dit tabblad open.',
    'loader.tap.still_working_escalation':'Je portret wordt nog gerenderd. Even geduld voorkomt een dubbele render.',
    'loader.title.accessible':'Meesterwerk wordt gecreëerd',
    'loader.title.dc':'M','loader.title.lead':'eesterwerk wordt ','loader.title.em':'gecreëerd',
    'loader.sub':'Gratis preview','loader.done':'Klaar!',
    'loader.progress_aria':'Voortgang van je preview',
    'loader.late_hold':'Bijna klaar! Laat dit tabblad open.',
    'loader.late_seq_craft':'Bezig met jouw portret…',
    'loader.late_seq_craft_pet':'Bezig met het portret van je huisdier…',
    'loader.status_rot_1':'Bijna klaar',
    'loader.status_rot_2':'Mengen',
    'loader.status_rot_3':'Het ironische',
    'loader.status_rot_4':'Echte vooruitgang',
    'loader.late_quote_1':'Het ironische is: vertragen brengt je verder dan haasten.',
    'loader.late_quote_2':'Echte vooruitgang is een stevige basis - geen snelle pleister.',
    'res.back':'← Terug','res.steps_aria':'Stappen','res.step1':'Upload','res.step2':'Preview','res.step3':'Premium HD-download of print',
    'res.title':'Jouw Meesterwerk is Klaar!','res.sub':'Kies hieronder je gewenste formaat','res.checkout_h2':'Je preview is klaar','res.finish_h2':'Kies jouw afwerking','res.jump.aria':'Spring naar afwerking','res.jump.plexiglas':'Plexiglas','res.jump.poster':'Poster','res.jump.canvas':'Canvas','res.jump.digital':'Digitaal download','res.display.t':'Gemaakt om op te hangen','res.display.p':'Ontworpen om mooi tot zijn recht te komen aan de muur, niet om te verdwijnen in je camerarol.','res.checkout_lede':'Alle opties bevatten je digitale bestand. Fysieke prints: binnen 1–3 dagen in NL en BE; gratis verzending vanaf €50 (NL en BE).','res.checkout_trust_pet':'Geen watermerk na aankoop · Veilig betalen met iDEAL · Handgemaakt voor jouw huisdier','res.checkout_trust_people':'Geen watermerk na aankoop · Veilig betalen met iDEAL','res.retry':'Opnieuw of bewerken','res.delivery_bar':'Binnen 1–3 dagen bezorgd in NL & BE','res.preview_history':'Eerdere previews','inspire.eyebrow':'Nog een idee nodig?','inspire.cta':'Probeer dit verhaal','inspire.victory_selfie.title':'Overwinningsselfie','inspire.victory_selfie.desc':'Vier het moment net na de overwinning — zelfde lach, zelfde sfeer.','inspire.rooftop_heroes.title':'Daken bij zonsondergang','inspire.rooftop_heroes.desc':'Een filmische daksfeer in gouden licht boven de stad.','inspire.sunset_guardians.title':'Helden bij zonsondergang','inspire.sunset_guardians.desc':'De slotscène van een epische film — gouden lucht, wapperende cape.','inspire.above_clouds.title':'Boven de wolken','inspire.above_clouds.desc':'Vlieg als een legende boven zachte gouden wolken.','inspire.guardian_leap.title':'Sprong van de beschermer','inspire.guardian_leap.desc':'Vang de beweging als een heroïsche sprong in gouden licht.','inspire.protector_family.title':'Beschermer van het gezin','inspire.protector_family.desc':'Een trouwe beschermer met heroïsche warmte.',
    'maatkeuze.trigger':'Maatkeuze hulp','maatkeuze.title':'Maatkeuze hulp','maatkeuze.h_size':'Kies het formaat','maatkeuze.advice':'Aan de muur lijkt een portret altijd net iets kleiner dan op je scherm. Twijfel je tussen twee formaten? Kies de grotere — onze klanten retourneren bijna alleen wanneer ze te klein hebben gekozen, vrijwel nooit wanneer ze té groot kozen.','maatkeuze.close_aria':'Sluiten','maatkeuze.preview_alt':'Voorbeeld: portret aan de muur in een klassiek interieur','maatkeuze.l_hint_landscape':'Liggend formaat','maatkeuze.none_enabled':'Geen koopbare formaten voor dit materiaal. Controleer voorraad of kies een ander product.','maatkeuze.open_failed':'Het formaathulpvenster ging niet open. Kies een formaat in het menu hierboven.','maatkeuze.add_to_cart':'Voeg {0} toe aan winkelwagen','maatkeuze.cta_generate_first':'Maak eerst je gratis preview','maatkeuze.cta_generating':'Bezig met genereren…','maatkeuze.need_preview':'Maak eerst je gratis preview. Kies stijl en upload je foto — daarna kun je dit formaat bestellen.',
    'modal.close':'Sluiten',
    'welcome.title':'Geniet van 20% korting','welcome.sub':'Laat je e-mail achter en ontvang je persoonlijke kortingscode.',
    'welcome.email_label':'E-mail','welcome.email_ph':'jij@voorbeeld.nl','welcome.submit':'Ontvang mijn code',
    'welcome.success_title':'Hier is je code','welcome.copy':'Kopieer code','welcome.apply_cart':'Verder met mijn code','welcome.choose_format':'Je code is bewaard. Kies een formaat en voeg je portret toe aan je winkelwagen.','welcome.cart_busy':'Je winkelwagen wordt bijgewerkt. Probeer het zo opnieuw.','welcome.cart_error':'We konden je winkelwagen niet controleren. Je code blijft bewaard. Probeer opnieuw.',
    'welcome.disclaimer':'Eén keer per klant bij checkout. Werkt de code niet? Dan is deze actie mogelijk eerder gebruikt.',
    'welcome.stack_hint':'Niet te combineren met andere kortingen. Neem contact op als je hulp nodig hebt.',
    'welcome.err_network':'Verbinding mislukt. Probeer opnieuw.','welcome.err_submit':'Aanmelden mislukt. Controleer je e-mail en probeer opnieuw.',
    'welcome.err_captcha':'Beveiligingscontrole mislukt. Vernieuw de pagina en probeer opnieuw, of meld je via de nieuwsbrief onderaan de site.',
    'welcome.err_wait':'Wacht een moment voordat je je e-mail verstuurt.',
    'welcome.err_rate':'Te veel pogingen in dit browservenster. Probeer het later opnieuw.',
    'welcome.copied':'Code gekopieerd.','welcome.email_invalid':'Vul een geldig e-mailadres in.',
    'welcome.consent_required':'Vink akkoord aan om door te gaan.',
    'welcome.consent_label':'Door je aan te melden ga je akkoord met marketing e-mails van WallStraight. Uitschrijven kan altijd.',
    'welcome.copy_manual':'Kopieer de code handmatig (selecteer de code hierboven).',
    'studio_recovery.title':'Het atelier zit vol.',
    'studio_recovery.body_p1':'We werken er snel aan dat iedereen een prachtig eigen portret krijgt - jij ook.',
    'studio_recovery.body_p2':'Laat hieronder je e-mail achter; we sturen je een seintje wanneer we weer bij zijn, zodat je je generatie kunt afronden.',
    'studio_recovery.submit':'Houd me op de hoogte',
    'studio_recovery.try_again':'Opnieuw proberen',
    'studio_recovery.success_title':'Begrepen!',
    'studio_recovery.success_body':'Je plek in de rij hebben we vastgelegd. We nemen snel contact op zodat je je portret kunt afmaken.',
    'studio_recovery.success_ok':'Sluiten',
    'photo_recovery.title':'We konden dit fotobestand niet lezen.',
    'photo_recovery.body_p1':'Soms kun je een foto op je telefoon wel bekijken, maar lukt het verwerken niet — bijvoorbeeld na export of een screenshot.',
    'photo_recovery.body_p2':'Upload een andere JPG, PNG of WebP, of laat je e-mail achter voor tips en een seintje (geen automatische generatie).',
    'photo_recovery.submit':'Houd me op de hoogte',
    'photo_recovery.try_again':'Andere foto kiezen',
    'photo_recovery.success_title':'Begrepen!',
    'photo_recovery.success_body':'We nemen contact op met tips. Je kunt ook meteen een andere foto uploaden.',
    'photo_recovery.success_ok':'Sluiten',
    'retry.title':'Opnieuw proberen','retry.remaining_suffix':' pogingen over in deze periode · Elke nieuwe preview telt als één',
    'retry.again.ttl':'Opnieuw','retry.again.desc':'Zelfde instellingen · nieuwe render',
    'retry.change_img.ttl':'Andere afbeelding','retry.change_img.desc':'Nieuwe upload',
    'retry.style.ttl':'Wijzig stijl','retry.style.desc':'Terug naar stap 2',
    'retry.startover.ttl':'Opnieuw beginnen','retry.startover.desc':'Categorie kiezen · nieuwe foto',
    'retry.sep':'of alleen aanpassing met tekst','retry.edit.ttl':'Beschrijf je aanpassing','retry.edit.desc':'Kleuren, items verwijderen, etc.',
    /* R-TRY2 (Try-again plan Tier 2 #3 — opt-in shopper boost). Single
       extra preview that adds a category-aware identity-anchor sentence
       to the existing prompt; rides on the same `User edit request:`
       sanitiser path and consumes one normal preview slot. R-WF3b
       telemetry surfaces this as `client_retry_kind: text_edit`
       (which covers BOTH boost clicks and free-form modal text edits
       — the column intentionally does not split them per R-TRY2's
       "no new wire field" promise). The canned text starts with the
       `Maximum identity fidelity rerender:` marker, but that marker
       sits at the END of the stitched prompt and so does NOT survive
       the 140-char truncation in `ws_generation_meta.prompt_head_ascii`.
       Dashboards that need to split boost vs free-form must match
       the full stitched prompt server-side via `GenerationLog.promptHash`
       (one SHA-256 per category × style × canned-line combination). */
    'retry.stronger.ttl':'Sterkere render proberen',
    'retry.stronger.desc':'Eén extra preview met extra identiteit-anchor voor deze categorie',
    'retry.text.placeholder':'Bijv. \'Maak achtergrond donkerder\' of \'Verwijder de hoed\'','retry.apply':'Toepassen ✦',
    'retry.limit1':'Je hebt alle pogingen gebruikt.','retry.limit2':'Download je huidige portret of bestel een print!',
    'retry.no_photo':'Je originele foto staat niet meer in dit tabblad. Upload opnieuw om een nieuwe preview te maken.',
    'err.file_big':'Je bestand is groter dan 10 MB. Kies een kleinere foto (JPG, PNG, of WebP).',
    'err.file_type':'Gebruik een JPG-, PNG- of WebP-foto.','err.file_read':'Deze foto kon niet worden gelezen. Probeer een andere JPG, PNG, of WebP.',
    'err.no_image':'Geen afbeelding ontvangen. Probeer opnieuw.','err.decode':'Afbeelding laden mislukt.',
    'toast.ready':'Meesterwerk klaar!','toast.edit_empty':'Voer een aanpassing in','toast.no_retries':'Geen pogingen meer over','toast.preview_restored':'Eerdere preview hersteld',
    'toast.link_copied':'Link gekopieerd — plak alleen de URL.',
    'toast.saved_link_copied':'Link gekopieerd — plak in een e-mail aan jezelf om later terug te komen.',
    'toast.share_failed':'Kon niet delen. Probeer het opnieuw.',
    /* Slice E.2 — Save for Later + Share split. Per RFC 6068 (mailto: URI scheme)
       we use {url} as a single literal placeholder which the JS handler
       string-replaces before opening the user's mail client. */
    'email.subject':'Mijn AI-portret op Wallstraight',
    'email.body':'Hoi!\n\nIk heb net een AI-portret gemaakt op Wallstraight. Bekijk het hier:\n\n{url}\n\n— Verstuurd via Wallstraight',
    'generic_err':'Er ging iets mis. Probeer het zo nog eens - je foto en keuzes staan hier nog klaar.',
    'err.unreachable':'We kunnen de preview-service op dit moment niet bereiken. Je foto en keuzes blijven hier - probeer het zo opnieuw.',
    'err.invalid_signature':'De preview-service is nog niet juist gekoppeld. Probeer later opnieuw.',
    'err.invalid_request':'Controleer je foto en probeer opnieuw.',
    'err.rate_limited':'Er is nu veel druk op onze servers (veel previews tegelijk). Je foto en keuzes blijven op deze pagina staan — probeer het zo meteen opnieuw.',
    'err.quota_weekly':'Je hebt het maximum aantal gratis previews voor deze periode bereikt. Probeer het later opnieuw of neem contact met ons op.',
    'err.quota_hard_cap':'De dagelijkse preview-limiet voor deze winkel is bereikt. Probeer het later opnieuw.',
    'err.provider_error':'Onze servers hebben het even zwaar; het atelier loopt vol. Je foto en keuzes blijven hier — probeer het over een moment opnieuw.',
    'err.billing_upstream':'Het atelier kan je preview nu even niet verwerken — er is tijdelijk geen vrij plek bij onze AI‑partner. Niets mis met jouw foto: je upload en je keuzes blijven hier staan — probeer het zo meteen nog eens of iets later opnieuw.',
    'err.proxy_non_json':'Uw meesterwerk vroeg iets meer tijd dan het scherm kon tonen. Uw foto staat nog klaar - probeer zo opnieuw.',
    'err.http404':'De preview-service is nog niet actief op deze shop. Probeer later opnieuw.',
    'err.http401':'De preview-service kon deze aanvraag niet verifiëren. Probeer later opnieuw.',
    'err.http413':'Je foto is te groot om te verwerken. Kies een kleinere JPG, PNG of WebP.',
    'err.unexpected':'Even onverwacht. Wacht een moment en probeer opnieuw.',
    'err.bad_json':'We konden je aanvraag niet verwerken. Ververs de pagina en probeer opnieuw.',
    'err.missing_prompt':'Selecteer eerst een stijl voordat je een preview maakt.',
    'err.missing_image':'Voeg eerst een foto toe (JPG, PNG of WebP) en probeer opnieuw.',
    'err.missing_style':'Kies eerst een stijl voor je portret.',
    'err.missing_category':'Kies eerst een categorie (bijv. huisdier of gezin).',
    'err.unsupported_image_type':'Gebruik een JPG-, PNG- of WebP-foto.',
    'err.image_too_large':'Je foto is groter dan 10 MB. Kies een kleinere JPG, PNG of WebP.',
    'err.image_decode_failed':'We konden je foto niet lezen. Probeer een andere JPG, PNG of WebP - of een scherpere versie van dezelfde foto.',
    'err.openai_unconfigured':'De preview-service is tijdelijk niet beschikbaar. Probeer het zo opnieuw.',
    'err.internal_error':'Er ging iets technisch mis aan onze kant bij het maken van je preview. Probeer het zo opnieuw.',
    'err.content_blocked':'We kunnen deze foto of opmerking niet verwerken. Probeer een andere foto of pas je tekst aan.',
    'cart.open_product':'De product-instelling wordt geopend voor dit formaat (alleen gebruikt als configuratie tijdelijk ontbreekt).',
    'cart.variant_missing':'Kon geen Shopify-variant voor dit formaat vinden. Controleer of het gekozen product varianten heeft (Poster, Canvas, Plexiglas, Digitaal) en of de sectie-handle klopt.',
    'cart.ok':'Je portret is toegevoegd.',
    'cart.fail':'Toevoegen aan de winkelwagen lukte niet. Probeer het opnieuw.',
    'cart.oos':'Dit product is niet op voorraad of niet beschikbaar. Controleer de voorraad in de winkel.',
    'cart.error_checkout':'Dit kon niet worden toegevoegd (vaak voorraad of beschikbaarheid).',
    'cart.checkout':'Naar afrekenen',
    'cart.view_cart':'Winkelwagen',
    'cart.adding':'Bezig met toevoegen…',
    'cart.fab_aria':'Naar afrekenen',
    'cart.remove_line':'Verwijderen',
    'cart.update_fail':'Winkelmandje bijwerken mislukt. Probeer opnieuw.',
    'cart.success_dlg_lede':'Klaar voor afrekenen \u2014 je HD-bestand of premium print wacht op je.',
    'cart.success.title.digital':'Je HD-bestand staat in je winkelwagen.',
    'cart.success.title.physical':'Je {0} staat in je winkelwagen.',
    'cart.success.title.physical_finish':'Je {0} met {1} staat in je winkelwagen.',
    'cart.success.lede.digital':'Klaar voor afrekenen \u2014 je bestand zonder watermerk wacht op je.',
    'cart.success.lede.physical':'Klaar voor afrekenen \u2014 inclusief je digitale bestand.',
    'cart.success.lede.physical_finish':'Klaar voor afrekenen \u2014 je print en afwerking wachten op je.',
    'toast.dismiss':'Sluiten',
    'ann.a':'Gratis preview zonder account','ann.b':'Gratis verzending vanaf €50 in NL & BE','ann.d':'Veilig betalen',
    'wk.oranje.ann':'🇳🇱 Oranje is door naar de knock-out! Vereeuwig jezelf, je kind of je maten in Oranje. Alleen tijdens het WK.',
    'wk.oranje.hero.eyebrow':'WK-editie 2026 · Limited',
    'wk.oranje.hero.h1':'Jij, je kind of je maten als Oranje aan de muur',
    'wk.oranje.hero.h1_pre_first':'J',
    'wk.oranje.hero.h1_line1':'ij, je kind',
    'wk.oranje.hero.h1_line2':'of je maten als',
    'wk.oranje.hero.h1_line3':' aan de muur',
    'wk.oranje.hero.lede':'Upload één foto en maak er een limited Oranje-portret van — voor kijkavonden, mancaves, gezinsmuren en voetbalgekke kids.',
    'wk.oranje.hero.btn1':'Maak gratis preview',
    'wk.oranje.hero.btn2':'Bekijk voorbeelden',
    'wk.oranje.hero.proof':'⚡ Preview in 30 seconden · geen account nodig · in NL geprint',
    'wk.oranje.hero.series_pre':'Oranje Series · ',
    'wk.oranje.hero.series_edition':'Limited WK-editie',
    'wk.oranje.hero.gal1.badge':'Bestseller',
    'wk.oranje.hero.gal1.label':'Stadionlegende','wk.oranje.hero.gal1.cap':'Oranje aan de muur',
    'wk.oranje.hero.gal2.label':'Sticker Hero','wk.oranje.hero.gal2.cap':'Collectible look',
    'wk.oranje.hero.gal3.label':'Mancave','wk.oranje.hero.gal3.cap':'Premium portret',
    'wk.oranje.voor_wie.eye':'Voor wie','wk.oranje.voor_wie.h2':'Voor elke soort supporter',
    'wk.oranje.audience.child.title':'Voor je kind','wk.oranje.audience.child.desc':'Een kleine Oranje-held vóór de finale',
    'wk.oranje.audience.self.title':'Voor jezelf','wk.oranje.audience.self.desc':'Word de 12e man, vereeuwigd',
    'wk.oranje.audience.mates.title':'Voor je maten','wk.oranje.audience.mates.desc':'Kijkavond die de muur verdient',
    'wk.oranje.audience.family.title':'Voor je gezin','wk.oranje.audience.family.desc':'Voetbalherinneringen boven de bank',
    'wk.oranje.audience.couple.title':'Voor koppels','wk.oranje.audience.couple.desc':'Elke wedstrijd samen',
    'wk.oranje.audience.pet.title':'Ook voor huisdieren','wk.oranje.audience.pet.desc':'Blijven huisdieren — Oranje-matchenergie, nooit een menselijk lichaam',
    'wk.oranje.voor_wie.r5':'🐾 En ja, ook je huisdier mag meedoen',
    'wk.oranje.showcase.lbl':'Gemaakt door klanten',
    'wk.oranje.gallery.eye':'Voorbeelden','wk.oranje.gallery.h2':'Zo hangt Oranje aan de muur',
    'wk.oranje.gallery.lede':'Kies een stijl. Kies een foto. Wij maken de Oranje-versie.',
    'wk.oranje.gallery.hover':'Genereer deze stijl',
    'wk.oranje.gallery.chip.mancave':'MANCAVE','wk.oranje.gallery.chip.gezin':'GEZIN','wk.oranje.gallery.chip.kind':'KIND','wk.oranje.gallery.chip.koppel':'KOPPEL','wk.oranje.gallery.chip.moment':'MOMENT',
    'wk.oranje.gallery.c1':'Bo & de mannen — kijkavond in de mancave',
    'wk.oranje.gallery.c2':'Familie de Vries — samen voor Oranje',
    'wk.oranje.gallery.c3':'Sven (8) — klaar voor de finale',
    'wk.oranje.gallery.c4':'Lisa & Mark — elke wedstrijd samen',
    'wk.oranje.gallery.c5':'2-1! — het moment vereeuwigd',
    'wk.oranje.styles.h2':'Kies jouw Oranje-editie',
    'wk.oranje.style.panini':'Sticker-held','wk.oranje.style.panini.desc':'Vintage collectible sticker — het best solo',
    'wk.oranje.style.stadion':'Stadionlegende','wk.oranje.style.stadion.desc':'Floodlit pitch-portret — solo, kind, gezin of groep',
    'wk.oranje.style.vintage':'Vintage Oranje-poster','wk.oranje.style.vintage.desc':'Retro halftone — ook groepen',
    'wk.oranje.style.mancave':'Mancave-portret','wk.oranje.style.mancave.desc':'Donker premium fanportret — solo of groep',
    'wk.oranje.style.disclaimer':'Voorbeelden tonen stijl en sfeer. Jouw kunstwerk volgt jouw upload, personen, pose en kadrering.',
    'wk.oranje.gensec.eye':'Oranje Generator','wk.oranje.gensec.h2':'Maak jouw Oranje-kunstwerk',
    'wk.oranje.gensec.lede':'Upload jezelf, je kind, je maten of je gezin — en bekijk gratis je preview.',
    'wk.oranje.how.eye':'Zo werkt het','wk.oranje.how.h2':'Van foto naar Oranje aan de muur in vier stappen',
    'wk.oranje.how.s1t':'1. Kies je Oranje-editie','wk.oranje.how.s1d':'Sticker, stadion, vintage of mancave',
    'wk.oranje.how.s2t':'2. Upload je foto','wk.oranje.how.s2d':'Jezelf, je kind of je maten',
    'wk.oranje.how.s3t':'3. Gratis preview','wk.oranje.how.s3d':'Direct, zonder account',
    'wk.oranje.how.s4t':'4. Aan je muur','wk.oranje.how.s4d':'Canvas, poster of acrylglas',
    'wk.oranje.pr.eye':'Bestellen','wk.oranje.pr.h2':'Hang \'m op vóór de finale',
    'wk.oranje.pr.lede':'Vandaag besteld — deze week aan je muur',
    'wk.oranje.pr.badge':'Meest gekozen',
    'wk.oranje.pr.canvas.nm':'Canvas',
    'wk.oranje.pr.canvas.d':'Galerie-canvas, direct ophangen. Geen lijst nodig.',
    'wk.oranje.pr.poster.nm':'Poster',
    'wk.oranje.pr.poster.d':'Premium mat papier',
    'wk.oranje.pr.digital.nm':'Alleen digitaal bestand',
    'wk.oranje.pr.digital.d':'Enkel een bestand — niet aan je muur',
    'wk.oranje.countdown.days':'{0} dagen',
    'wk.oranje.countdown.until':'tot de finale',
    'wk.oranje.countdown.final_label':'Finale vandaag',
    'wk.oranje.countdown.line':'Nog {0} dagen en {1} uur tot de finale (19 juli 2026)',
    'wk.oranje.countdown.done':'Finale 19 juli 2026 — bestel op tijd voor aan je muur',
    'wk.oranje.trust.printed':'In NL geprint',
    'wk.oranje.trust.checkout':'Veilig betalen · iDEAL',
    'wk.oranje.trust.shipping':'Gratis verzending vanaf €50',
    'wk.oranje.faq.q1':'Hoe snel heb ik \'m in huis?','wk.oranje.faq.a1':'In NL geprint, meestal 3-5 werkdagen — op tijd voor de finale.',
    'wk.oranje.faq.q2':'Werkt het met mezelf of mijn kind?','wk.oranje.faq.a2':'Ja, elke duidelijke foto werkt. Hele gezin? Bestel meerdere.',
    'wk.oranje.faq.q3':'Moet ik eerst betalen?','wk.oranje.faq.a3':'Nee, je maakt eerst gratis een preview zonder account.',
    'wk.oranje.faq.q4':'Is dit echt beperkt?','wk.oranje.faq.a4':'De Oranje-editie loopt alleen tijdens het WK 2026.',
    'wk.oranje.cta.h2':'Klaar om jezelf in Oranje te zien?','wk.oranje.cta.h2_pre':'Klaar om jezelf in ','wk.oranje.cta.h2_mark':'Oranje','wk.oranje.cta.h2_post':' te zien?','wk.oranje.cta.p':'Gratis preview in ongeveer 30 seconden.','wk.oranje.cta.btn':'Maak mijn Oranje-preview',
    'wk.oranje.ft.desc':'Oranje-editie 2026 · Limited portretkunst. In Nederland geprint.',
    'wk.oranje.ft.bot':'WallStraight · Oranje-editie 2026 · Limited portretkunst · In Nederland geprint.',
    'hero.badge':'Vertrouwd door 1.000+ klanten','hero.h1.pre_first':'M','hero.h1.line1_lead':'aak van\u00A0jouw\u00A0huisdier','hero.h1.line2':'een tijdloos portret','hero.h1.accessible':'Maak van jouw huisdier een tijdloos portret.',
    'hero.p_lead':'Upload een foto en bekijk gratis je persoonlijke preview in jouw favoriete stijl.','hero.p_em':' Geen account nodig.',
    'hero.btn1':'Maak gratis preview','hero.btn2':'Bekijk voorbeelden','hero.proof':'Poster vanaf €29,95 · Canvas · Acrylglas · Digitaal',
    'hero.gal1.p':'Gezinsportret cadeau','hero.gal2.p':'Op canvas besteld','hero.gal3.p':'Kind & huisdier',
    'hero.gal1.alt':'Klant thuis met een groot koninklijk gezinsportret op canvas','hero.gal2.alt':'Klant houdt een aquarel kattenportret op canvas vast','hero.gal3.alt':'Kind thuis met superheld-canvas — kind en golden retriever vliegend in gouden lucht',
    'hero.fin.eyebrow':'Aan je muur','hero.fin.aria':'Afwerkingen aan de muur',
    'showcase.lbl':'Gemaakt door klanten',
    'gensec.eye':'AI Generator','gensec.h2':'Maak jouw meesterwerk','gensec.lede':'Voor verjaardagen, herinneringen, nieuwe woningen, of gewoon omdat ze het verdienen om gevierd te worden.',
    'trust.priv.t':'Privacy','trust.priv.d':'Uploads worden gebruikt om je preview te maken. Zie ons privacybeleid voor bewaartermijnen.',
    'trust.fast.t':'Snel resultaat','trust.fast.d':'Preview meestal binnen 15–30 seconden, afhankelijk van drukte.',
    'trust.rev.t':'Reviews','trust.rev.d':'Bekijk geverifieerde beoordelingen op onze shop en via reviewpartners.',
    'exsec.eye':'Voorbeelden','exsec.h2':'Zie de transformatie','ba.orig':'Origineel','ba.mini.wc':'Aquarel',
    'ba.c1.p':'Rustige Noordse stijl — huisdierportret','ba.c2.p':'Kat in zachte wash','ba.c3.p':'Hond in grafische stijl',
    'mat.eye':'Materialen','mat.h2':'Kies de afwerking die bij je muur past','mat.canvas':'Canvas','mat.glass':'Acrylglas','mat.poster':'Poster',
    'mat.sizes_prefix':'Formaten:','mat.brand_sub':'Portretkunst',
    'mat.canvas.alt':'Canvas portret aan de muur','mat.glass.alt':'Plexiglas portret met afstandhouders aan de muur','mat.poster.alt':'Ingelijste poster aan de muur',
    'stat.del':'Levering','stat.del_note':'In NL meestal binnen 1–2 werkdagen geleverd','stat.sty':'Kunststijlen','stat.fmt':'Canvas · Poster · Acrylglas','stat.pre':'Gratis',
    'how.eye':'Uit het atelier','how.h2':'Tips voor je mooiste portret','how.lede':'Een scherpe foto en de juiste stijl maken het verschil. Hier lees je kort wat we aanraden vóór je je gratis preview maakt - en wat daarna volgt: watermerk op de preview, 4K (HD) na aankoop, óf een premium print zoals op de productpagina.',
    'how.s1t':'Foto: licht & scherpte','how.s1p':'Kies een duidelijke close-up met zacht, natuurlijk licht - vermijd harde schaduwen op het gezicht. Geen extreme groothoek; een rustig kader geeft meestal het sterkste portret.',
    'how.s2t':'Stijl die bij je muur past','how.s2p':'Elke look heeft eigen karakter - klassiek, zacht of grafisch. Denk aan je interieur en het gevoel dat je wilt uitstralen; het atelier hierboven helpt je de stijl te kiezen.',
    'how.s3t':'Preview, 4K & prints','how.s3p':'Je eerste render is een gratis preview met watermerk. Koop je 4K (HD), dan verdwijnt het watermerk. Liever aan de muur? Kies poster, canvas of plexiglas - dezelfde opties als in de shop.',
    'pr.eye':'Prijzen','pr.h2':'Kies jouw portret','pr.badge':'Meest gekozen','pr.badge.premium':'Premium keuze','pr.from':'Vanaf',
    'pr.promo_checkout_hint':'Jubileumactie: korting automatisch toegepast bij het afrekenen.',
    'pr.pos.d':'Scherpe fotoprint van jouw huisdierportret.','pr.pos.btn':'Kies poster',
    'pr.can.d':'Premium canvas met zichtbare structuur, klaar om op te hangen.','pr.can.btn':'Maak mijn portret op canvas',
    'pr.gls.d':'Luxe glanzende afwerking met extra diepte en helder detail.','pr.gls.btn':'Kies acrylglas',
    'rev.eye':'Reviews','rev.h2':'Wat klanten zeggen',
    'rev.q1':'Portret van onze hond is ongelooflijk. Veel beter dan verwacht.','rev.q2':'Een cadeau voor oma en ze was ontroerd. Fijn Wallstraight ontdekt te hebben. Het perfecte portret om cadeau te geven.','rev.q3':'Super makkelijk. Pronkstuk van de woonkamer!',
    'rev.q4':'Als fotograaf sceptisch. AI doet verbluffend werk.','rev.q5':'Het lachen van mijn zus zegt genoeg — ze vond het geweldig!','rev.q6':'Mijn vrouw was sprakeloos. Fenomenaal.',
    'rev.m1':'Huisdier · ✓ Geverifieerd','rev.m2':'Gezin · ✓ Geverifieerd','rev.m3':'Huisdier · ✓ Geverifieerd','rev.m4':'Zelfportret · ✓ Geverifieerd','rev.m5':'Gezinnen · ✓ Geverifieerd','rev.m6':'Koppel · ✓ Geverifieerd',
    'story.eye':'Gemaakt voor wie écht bij je hoort','story.h2':'Voor dierenliefhebbers, door dierenliefhebbers.','story.body1':'We weten dat een huisdierportret niet zomaar decoratie is. Het is het gezicht dat je thuis begroet, het karaktertje dat de kamer vult, en de herinnering die je dichtbij wilt houden.','story.body2':'Daarom maken we elk Wallstraight-portret persoonlijk, expressief en mooi genoeg voor een plek aan de muur.',
    'story.card1.t':'Hun karakter telt','story.card1.p':'De ogen, de uitdrukking, de kleine details — het portret moet nog steeds voelen als jouw dier.','story.card1.alt':'Voorbeeld: huisdierportret dat de persoonlijkheid van het dier vastlegt',
    'story.card2.t':'Gemaakt om op te hangen','story.card2.p':'Ontworpen om mooi tot zijn recht te komen aan de muur, niet om te verdwijnen in je camerarol.','story.card2.alt':'Voorbeeld: portret aan de muur, klaar om op te hangen',
    'story.card3.t':'Een cadeau met gevoel','story.card3.alt':'Voorbeeld: portret als persoonlijk cadeau',
    'story.cta':'Maak je portret',
    'story.unboxing.alt':'Klant opent een ingelijst portret',
    'faq.h2':'Veelgestelde vragen','faq.eye':'FAQ','faq.q1':'Hoe werkt het?','faq.a1':'Kies categorie en stijl, upload je foto en ontvang binnen seconden een gratis preview met watermerk. Bevalt het? Haal 4K (HD) zonder watermerk in huis, of laat je portret drukken op premium poster, canvas of plexiglas — geen account nodig.',
    'faq.q2':'Welke foto het beste?','faq.a2':'Scherpe close-up, goed licht. Natuurlijk daglicht ideaal.',
    'faq.q3':'Hoe snel geleverd?','faq.a3':'Digitaal direct na aankoop. Fysieke prints: meestal binnen 1–2 werkdagen bij je thuis in NL.',
    'faq.q4':'Niet helemaal naar wens?','faq.a4':'Elk portret wordt individueel voor je gemaakt. Bevalt je preview niet helemaal? Tik op «Opnieuw of bewerken»: opnieuw renderen, een andere foto of stijl, of beschrijf in tekst wat je anders wilt. Vóór je eerste preview kun je ook een optionele persoonlijke notitie toevoegen. Elke nieuwe preview telt als één poging. Nog hulp nodig? Mail info@wallstraight.nl.',
    'faq.q5_multi':'Waarvoor zijn meerdere foto’s?','faq.a5_multi':'Als je ‘Voeg foto toe’ ziet: gebruik die voor verschillende personen die samen op één portret moeten. Meerdere keren jezelf uploaden is geen ondersteunde manier om scherper te worden en kan gekke resultaten geven. Zie ‘Waarom?’ onder je foto voor meer uitleg.',
    'cta.h2':'Klaar voor je meesterwerk?','cta.p':'Gratis preview in seconden.','cta.btn':'✦ Begin nu - Gratis',
    'ft.policy.shipping-policy':'Verzending','ft.policy.refund-policy':'Retourbeleid','ft.policy.privacy-policy':'Privacybeleid','ft.policy.terms-of-service':'Algemene voorwaarden',
    'ft.desc':'AI-portretkunst. Haarlem, Nederland.','ft.print_options':'Printopties','ft.browse_catalog':'Alle producten','ft.info':'Info','ft.how':'Tips','ft.gids':'AI portret gids','ft.bot':'Tappersweg 52, 2031 EV Haarlem, Nederland','ft.dig':'Digitaal',
    'tier.pop':'Meest gekozen','tier.gift':'Premium keuze','tier.fmt':'Formaat','tier.fin':'Afwerking','tier.inc':'+ Inclusief digitale download',
    'finish.none':'Geen afwerking','finish.none.glass':'Zonder afstandhouders','finish.eyebrow.poster':'Kies je afwerking','finish.eyebrow.canvas':'Kies je lijst','finish.eyebrow.glass':'Ophangsysteem','finish.total_estimate':'Totaal indicatie',
    'finish.paid.photo_frame_30x40':'Fotolijst 30×40 cm','finish.paid.photo_frame_40x50':'Fotolijst 40×50 cm','finish.paid.photo_frame_50x70':'Fotolijst 50×70 cm',
    'finish.paid.poster_hanger':'Ophanglat (poster)','finish.paid.box_frame_wood':'Baklijst houtkleur','finish.paid.box_frame_black':'Baklijst zwart',
    'finish.paid.spacers':'Afstandhouders','finish.paid.frame_wood':'Baklijst houtkleur','finish.paid.frame_black':'Baklijst zwart',
    'finish.paid.hanger':'Ophanglat','finish.paid.frame':'Fotolijst','finish.paid.spacers_kind':'Afstandhouders',
    'tier.pf':'Geen lijst','tier.pf2':'Inclusief lijst (+€15)','tier.cf':'Zonder lijst','tier.cf2':'Met lijst',
    'tier.nm.g':'Acrylglas',
    'tier.ul.p1':'Premium fotopapier','tier.ul.p2':'3 formaten beschikbaar','tier.ul.p3':'Gratis verzending vanaf €50 (NL en BE)','tier.ul.p4':'Inclusief digitaal bestand','tier.ul.p5':'Binnen 1–3 dagen bezorgd in NL en BE',
'tier.ul.c1':'Klaar om direct op te hangen','tier.ul.c2':'Luxe canvasstructuur','tier.ul.c3':'Gratis verzending vanaf €50 (NL en BE)','tier.ul.c4':'Inclusief digitaal bestand','tier.ul.c5':'Binnen 1–3 dagen bezorgd in NL en BE',
'tier.ul.g1':'Premium acrylglas','tier.ul.g2':'Glanzende museumlook','tier.ul.g3':'Gratis verzending vanaf €50 (NL en BE)','tier.ul.g4':'Inclusief digitaal bestand','tier.ul.g5':'Binnen 1–3 dagen bezorgd in NL en BE',
    'tier.ul.d1':'Zonder watermerk (na betaling)','tier.ul.d2':'Direct downloaden na checkout (e-mail of link)','tier.ul.d3':'4K-bestand (HD)',
    'tier.btn.p':'Kies poster','tier.btn.c':'Maak mijn portret op canvas','tier.btn.g':'Kies acrylglas','tier.btn.dl':'Download digitaal',
    'tier.dig.nm':'Alleen digitaal','tier.dig.eyebrow':'Alleen digitaal ontvangen?','tier.dig.lede':'Ontvang je 4K-bestand zonder watermerk direct na aankoop.','tier.dig.d':'4K-bestand (HD) na betaling - delen of zelf printen',
    'tier.desc.p':'Scherpe fotoprint van jouw huisdierportret.','tier.desc.c':'Premium canvas met zichtbare structuur, klaar om op te hangen.','tier.desc.g':'Luxe acrylglas met diepe kleur, heldere details en een moderne glansafwerking.',
    'tier.mat_sample.canvas':'Close-up van premium canvasstructuur','tier.mat_sample.poster':'Close-up van fotoposterpapier','tier.mat_sample.glass':'Close-up: acrylglas dikte, glans en afstandhouder',
    'tier.mat_preview.canvas':'Premium canvas — voorbeeld aan de muur','tier.mat_preview.poster':'Poster — voorbeeld in lijst','tier.mat_preview.glass':'Acrylglas — glanzende museumlook','tier.mat_preview.digital':'Digitaal — voorbeeld op tablet',
    'tier.mat_sample.zoom_label.canvas':'Vergroot canvasvoorbeeld','tier.mat_sample.zoom_label.poster':'Vergroot postervoorbeeld','tier.mat_sample.zoom_label.glass':'Vergroot acrylglasvoorbeeld','tier.mat_sample.zoom_label.digital':'Vergroot digitaal voorbeeld',
    'tier.mat_sample.close':'Sluiten','tier.mat_sample.dialog_title':'Materiaal & voorbeeld','tier.mat_sample.mat_link':'Bekijk alle materialen','tier.mat_sample.sizes_label':'Beschikbare formaten',
    'sty.badge.staff_pick':'Staff pick','sty.badge.fan_favorite':'Fanfavorite','sty.badge.trending':'Trending','sty.badge.new':'Nieuw',
    'res.share.h':'Deel je portret','res.share.trust':'Zie reviews op wallstraight.nl','res.share.sub':'Bewaar voor later of deel met vrienden & familie',
    'res.share.send':'Delen','res.share.save':'Bewaar voor later','res.share.save_aria':'Bewaar voor later — verstuur een e-mail naar jezelf met de link',
    /* Slice R.3 — Portrait Recovery (landing layer). Banner appears when JS
       detects a recoverable session (sessionStorage or ?ws_job restore). */
    'res.recover.title':'Je laatste portret staat klaar',
    'res.recover.continue':'Bekijk →',
    'res.recover.continue_aria':'Open je laatste portret en ga naar afrekenen',
    'res.recover.dismiss_aria':'Verberg melding',
    'res.recover.failed':'We konden je portret niet herstellen. De link is ongeldig of verlopen.',
    'res.recover.expired':'Deze preview-link is verlopen. Maak een nieuw portret.',
    'cart.chip_aria':'Bekijk winkelwagen ({0})',
    'res.info1.h':'Wat klanten zeggen','res.info1.p':'Lees reviews op onze productpagina en via onze reviewpartners.',
    'share.page_blurb':'Bekijk mijn AI-portret op Wallstraight.',
    'res.info2.h':'Hulp nodig?','res.info3.h':'Ondersteun echte kunstenaars','res.info3.p':'Wallstraight, gemaakt door Atlantis Digital.',
    'res.info2.p':'info@wallstraight.nl - We helpen je graag!',
  },
  en:{
    'logo.tagline':'Portrait art',
    'nav.shop_more':'Shop more','nav.how':'Tips','nav.ex':'Examples','nav.pr':'Pricing','nav.cta':'Make free preview','nav.cta_short':'Free preview',
    'nav.menu_open':'Menu','nav.menu_close':'Close menu','nav.menu_title':'Navigation',
    'wiz.ind1.title':'Category',
    'wiz.ind2.title':'Style',
    'wiz.ind3.title':'Upload',
    'wiz.dots_nav_aria':'Progress: create your portrait',
    'wiz.breadcrumb_nav_aria':'Steps: category, style, photo upload',
    'wiz.breadcrumb.s1':'Choose category',
    'wiz.breadcrumb.s2':'Choose style',
    'wiz.breadcrumb.s3':'Upload photo',
    'wiz.breadcrumb.s1_aria':'Step 1: choose category',
    'wiz.breadcrumb.s2_aria':'Step 2: choose style',
    'wiz.breadcrumb.s3_aria':'Step 3: upload photo',
    'wiz.step_n_of_m':'Step {0} of {1}',
    'wiz.step_title_sep':' · ',
    'wiz.back':'Back',
    'wiz.back_aria':'Previous step',
    'wiz.chg_cat':'Change category',
    'wiz.chg_cat_aria':'Go to step 1 to change category',
    'cat.infer.detected_prefix':'Detected:',
    'cat.infer.type_label':'Portrait type',
    'cat.infer.change':'Change',
    'cat.infer.change_aria':'Change category',
    'style.infer.selected_suffix':'selected',
    'style.infer.selected_label':'Selected style',
    'cat.infer.choose':'Choose category',
    'cat.infer.close':'Close',
    'cat.infer.confirm_needed':'Confirm the portrait type for this photo.',
    'cat.infer.mixed_prompt':'We see a person and a pet. What should your portrait focus on?',
    'cat.infer.mixed_include_both':'Person + pet',
    'cat.infer.mixed_pet_only':'Pet portrait only',
    'cat.infer.mixed_person_only':'Person portrait only',
    'cat.infer.focus_label':'Focus',
    'cat.infer.choose_focus':'Choose focus',
    'cat.infer.change_focus':'Change focus',
    'cat.infer.change_focus_aria':'Change portrait focus',
    'cat.infer.done':'Done',
    'wiz.chg_style':'Change style',
    'wiz.chg_style_aria':'Go to step 2 to change style',
    'wiz.nav_aria':'Step navigation',
    'wiz.summary.cat_lbl':'I. Category',
    'wiz.summary.style_lbl':'II. Style',
    'wiz.summary.style_lbl_infer':'I. Style',
    'wiz.summary.photo_lbl':'III. Photo',
    'wiz.summary.photo_lbl_infer':'II. Photo',
    'wiz.summary.not_chosen':'Not chosen',
    'wiz.summary.photo_none':'Not uploaded',
    'wiz.summary.photo_ok':'Uploaded',
    'wiz.summary.jump_cat_aria':'Go to step 1 to change category',
    'wiz.summary.jump_style_aria':'Go to step 2 to change style',
    'wiz.summary.upload_photo_aria':'Choose a photo to upload',
    'wiz.help1':'Choose who the portrait is for.',
    'wiz.next1':'Continue — choose a style',
    'wiz.help2':'Pick a style for your portrait.',
    'wiz.next2':'Continue — upload your photo',
    'wizard.defaults_caption':'Tap category or style in the summary above to change your choice.',
    'pill.huisdier':'Pets','pill.gezin':'Families','pill.koppel':'Couples','pill.kind':'Children','pill.zelf':'Self-portrait',
    'ex.before':'Before',
    'ex.step2_before_alt':'Example: original photo',
    'ex.step2_after_alt':'Example: AI result in selected style',
    'upload.pick':'Choose photo','upload.fmt':'JPG, PNG, WebP · Max 10MB','upload.chg':'Change photo','upload.rm':'✕ Remove',
    'upload.reviews_aria':'Customer stories','upload.reviews_dots_aria':'Choose a story','upload.review.dot_aria':'Go to story {n} of {total}',
    'upload.review.claudia.who':'Claudia H.','upload.review.claudia.body':'He thought the canvas was genuinely beautiful \u2014 he stood there looking at it for ages. It\u2019s huge, and still looked so beautiful, even though my original photo wasn\u2019t very large.',
    'upload.review.vic.who':'Victor L.','upload.review.vic.body':'You perfectly captured Nacho\u2019s playfulness and I appreciate being able to purchase the digital file alone.',
    'upload.review.nancy.who':'Nancy D.','upload.review.nancy.body':'I am completely satisfied with the finished product. Our Bonnie is the perfect princess.',
    'upload.review.kween.who':'Mira S.','upload.review.kween.body':'Absolutely LOVE this site! I didn\u2019t expect the delivered piece to be breathtaking and huge.',
    'upload.review.queenie.who':'Sophie V.','upload.review.queenie.body':'My 80-year-old mother absolutely loved her Royal transformation! Her nickname is Queenie, so seeing her painted in royal robes for her milestone birthday was just the perfect tribute.',
    'upload.review.after_wc':'Soft watercolor','upload.review.unboxing.cta':'Get yours now','upload.review.unboxing.alt':'Customer unboxing a framed portrait',
    'upload.add_more':'Add another photo','upload.add_more_aria':'Add another reference photo (max 3 total)',
    'upload.role.person':'Person','upload.role.pet':'Pet',
    'upload.remove_aria':'Remove this photo','upload.slots_aria':'Additional reference photos',
    'tip.multi_photo.distinct_subjects':'Add each photo for a different person who should appear together in one portrait.',
    'tip.multi_photo.distinct_subjects_more':'Why?',
    'tip.multi_photo.distinct_subjects_detail':'If you use more than one photo, each should be a different person — not several selfies of yourself for “sharpness.” We don’t support that and it can look wrong.',
    // Slice B.3 — Royal scene-template picker (only visible for royal style + eligible category/N).
    'scene.legend.title':'Tell the story',
    'scene.legend.hint':'Optional - choose how the scene unfolds',
    'scene.noble_lineage.title':'Noble Lineage',
    'scene.noble_lineage.desc':'Crown on the eldest, younger figures as princes and princesses',
    'scene.court_of_equals.title':'Court of Equals',
    'scene.court_of_equals.desc':'All figures as noble peers - no single monarch',
    'scene.royal_romance.title':'Royal Romance',
    'scene.royal_romance.desc':'The couple as duke and duchess in regal connection',
    // R-FEED-5 — explicit royal casting presets. Mirror of the NL block above
    // and the Liquid `data-i18n` attributes; copy is locale-distinct so the
    // i18n test does not flag silent EN→NL fallthrough.
    'scene.monarchs_pair.title':'King and Queen',
    'scene.monarchs_pair.desc':'Two sovereigns at matched stature - mantle, crown and tiara',
    'scene.royal_heir_baby_prince.title':'Crown Prince (baby)',
    'scene.royal_heir_baby_prince.desc':'Parent(s) with a newborn or very young child as crown prince',
    'scene.royal_heir_baby_princess.title':'Crown Princess (baby)',
    'scene.royal_heir_baby_princess.desc':'Parent(s) with a newborn or very young child as crown princess',
    'scene.royal_children_court.title':'Court of Royal Children',
    'scene.royal_children_court.desc':'Multiple princes and princesses, each in their own court attire',
    // R-FEED-2 — Optional first-run shopper notes mirror; locale-distinct
    // copy so the i18n test does not flag silent EN→NL fallthrough.
    'notes.toggle.title':'Add a personal note (optional)',
    'notes.label.hint':'Tell us anything we should know about your portrait. We use this as an extra hint while generating.',
    'notes.placeholder':'e.g. \'warmer tones\' or \'my dad always wears glasses\'',
    'notes.clear':'Clear',
    'pet.name.title':'Add your pet’s name in the portrait','pet.name.placeholder':'e.g. Luna','pet.name.confirm':'Do the honor','pet.name.skip':'No name in the portrait','pet.name.edit_link':'Change or remove name in portrait',
    'inscription.headline':'Add a name','inscription.pet.title':'Enter your pet name','inscription.pet.prompt':'What\u2019s your pet\u2019s name?','inscription.solo.prompt':'Add a name','inscription.group.prompt':'Add a family name','inscription.bond.prompt':'Add a name','inscription.subtitle':'We\u2019ll add it discreetly in the corner of your artwork, like a small gallery signature.','inscription.placeholder.pet':'e.g. Luna','inscription.placeholder.solo':'e.g. Emma','inscription.placeholder.group':'e.g. The Janssens','inscription.confirm.empty':'Add name','inscription.confirm.filled':'Use \u201c{name}\u201d','inscription.confirm.pet.empty':'Do the honor','inscription.confirm.pet.filled':'Do the honor','inscription.skip':'No text in my portrait','inscription.edit_link':'Add signature','inscription.edit_link.has_name':'Change signature','inscription.error.email':'This field is for a name in your artwork — not an email address.','inscription.error.url':'Please don\u2019t use a link or web address — only a short name.','inscription.error.phone':'Please don\u2019t use a phone number — only a short name.','inscription.error.message':'Keep it short: just a name (e.g. Emma or The Janssens).',
    'gen.btn':'Generate free preview',
    'hint.detect.no_face':'No face detected. Try a clearer photo or a different upload.',
    'hint.detect.unknown':'We couldn\u2019t auto-verify who\u2019s in the photo \u2014 we\u2019ll generate based on your category.',
    'hint.detect.ok_pet':'Pet portrait \u00b7 ready for styling.',
    'hint.detect.ok_solo_zelf':'1 person detected \u00b7 ready for Self-portrait.',
    'hint.detect.ok_couple':'Looks good for two people \u00b7 ready to generate.',
    'hint.detect.ok_family':'Looks good for Families \u00b7 ready to generate.',
    'hint.detect.ok_kids':'Looks good for Children \u00b7 ready to generate.',
    'hint.detect.ok_kids_adult_note':'Tip: is one of them an adult? Switch to Families for the right framing.',
    'hint.detect.count_caveat':'Smaller faces (infants, partial profiles, people further back) may not be counted but will appear in your portrait.',
    'hint.detect.solo_in_gezin':'You picked Families. That mode works best when several people appear together in one photo.',
    'hint.detect.solo_in_koppel':'You picked Couples. That mode works best with two people together in one photo.',
    'hint.detect.solo_in_kind':'You picked Children. If this is a child, continue \u2014 if it\u2019s an adult, switch to Self-portrait. Our automatic detection can\u2019t tell age apart.',
    'hint.detect.crowd_in_zelf':'More than one person appears in this photo, but you picked Self-portrait — it focuses on one subject. Pick the category that fits your group (two people, family, …), or continue if you only want one subject emphasized.',
    'hint.detect.crowd_in_koppel':'You picked Couples. That mode fits two people together \u2014 Families works better when more than two appear in one photo.',
    'hint.detect.crowd_in_kind':'It looks like you picked Children. Families gives your kids and the adults each their place in the portrait.',
    'hint.detect.suggest_zelf':'Switch to Self-portrait',
    'hint.detect.suggest_gezin':'Switch to Families',
    'hint.detect.suggest_koppel':'Use two-person mode',
    'hint.detect.suggest_huisdier':'Switch to Pets',
    /* Track H (slice p2h-ux) — fires when subjectClass=likely_pet on a people
       category. Never says "N people" because the photo is animal-primary. */
    'hint.detect.pet_in_kind':'This looks like a pet photo. Children is for kids \u2014 switch to Pets for the best result.',
    'hint.detect.pet_in_zelf':'This looks like a pet photo. Self-portrait is for people \u2014 switch to Pets for the best result.',
    'hint.detect.pet_in_gezin':'This looks like a pet photo. Families is for people \u2014 switch to Pets for the best result.',
    'hint.detect.pet_in_koppel':'This looks like a pet photo. Couples is for people \u2014 switch to Pets for the best result.',
    /* Phase 2 / Slice P2.D — R-MIX2 mixed-subject banner. The shopper uploaded
       a single photo containing BOTH a person AND a pet, then picked a
       people category. Default behavior drops the pet \u2014 these copy variants
       offer category-aware copy plus optional swap CTAs; storefront POST now
       implies mixed_single_photo from vision (Generate) without a bond button. */
    'hint.detect.ok_zelf_person_pet':'Person and pet detected · ready for Self-portrait.',
    'hint.detect.mixed_in_kind':'We see a person AND a pet in this photo. Want both in your Children portrait?',
    'hint.detect.mixed_in_gezin':'We see a person AND a pet in this photo. Want both in your Family portrait?',
    'hint.detect.mixed_in_gezin_one_detected_person':'You chose Families with one visible person and a pet. That mode may invent extra people who are not in your photo. Consider Self-portrait for you plus your pet - or generate if you prefer it this way.',
    'hint.detect.mixed_in_koppel':'This photo has a person and a pet, but you picked Couples (2 people). The AI may invent a second person who is not real. Try \u201cYou + your pet (Bond)\u201d or \u201cSelf-portrait\u201d.',
    'hint.detect.action_mixed_bond':'Include both (you + your pet)',
    /* Phase 2 / Slice P2.D — R-MIX8 huisdier inversion. Soft warn when the
       shopper picked Pet portrait but the classifier sees a person. Same
       suggest_zelf swap as the people-categories use. */
    'hint.detect.inversion_human':'Pet portraits celebrate animals first - they may leave people out. With Families or Self-portrait, everyone in your photo stays in the frame together.',
    'hint.detect.keep':'Continue anyway',
    /* CAW.C — EN mirror. See NL note above for the four-promise contract. */
    'hint.detect.keep_aria':'Continue with this photo. Category, style, and treatment stay the same for every person and pet in the image.',
    'hint.baroque_nudge.body':'For a natural dog portrait in Old Master style without costume: choose Dutch Golden Age.',
    'hint.baroque_nudge.action':'Choose Dutch Golden Age',
    'hint.baroque_nudge.dismiss':'Not now',
    /* Phase 3 / Slice P3.B (R-FAB6) — quality hint banners. One canonical
       reason per variant; never blocks the upload (same dismissable
       pattern as the category hint). */
    'quality.hint.too_dark':'This photo looks quite dark. A brighter shot (near a window or outside in the shade) gives a much stronger portrait.',
    'quality.hint.too_bright':'This photo looks overexposed. Avoid direct sunlight; soft window light works best.',
    'quality.hint.too_blurry':'This photo looks blurry. A sharp close-up keeps the likeness intact in the portrait.',
    'quality.hint.face_too_small':'The detected face seems far away. A tighter crop (face and shoulders) gives the best portrait.',
    'quality.hint.too_low_res':'This photo is low resolution. Upload the original file rather than a screenshot or compressed copy.',
    'quality.hint.action_reupload':'Choose a different photo',
    'quality.hint.keep':'Continue with this photo anyway',
    /* Phase 3 / Slice P3.B (R-FAB6) — always-visible 3-bullet tip strip
       above the dropzone. Sets expectations BEFORE the upload. */
    'tip.upload.heading':'For the best portrait',
    'tip.upload.s1':'Clear close-up of the face',
    'tip.upload.s2':'Soft, natural light (near a window or outside in the shade)',
    'tip.upload.s3':'Sharp, high-resolution photo - prefer the original file',
    'loader.phase1':'Creating your preview…','loader.phase2':'Applying the style…','loader.phase3':'Refining details…','loader.phase4':'Final touches…',
    /* Part 3 — seven-line loader before Part 4 (see NL block + docs/part4-loader-requirements.md). */
    'loader.status.1':'Studying your uploaded photo…',
    'loader.status.2':'Preserving unique features…',
    'loader.status.3':'Applying your chosen art style…',
    'loader.status.4':'Painting your portrait preview…',
    'loader.status.5':'Refining the details…',
    'loader.status.6':'Adding the finishing touches…',
    'loader.status.7':'Your portrait is almost ready…',
    /* Legacy — unused in code (mirrors NL). */
    'loader.status.hold':'Still working on your portrait — quality can take a little while.',
    /* Legacy key names; Part 4 copy only. `queued` unused. */
    'loader.poll.status.queued':'Your preview is queued — we\'re on it.',
    'loader.poll.status.rendering_head':'Rendering your portrait now…',
    'loader.poll.status.rendering_sub.v1':'They didn\'t rush the Mona Lisa, and we\'re not rushing yours either.',
    'loader.poll.status.rendering_sub.v2':'This is taking a little longer than expected, but your photo deserves the extra care.',
    'loader.poll.status.rendering_sub.v3':'Our AI is being a perfectionist right now, which feels very appropriate for a masterpiece.',
    'loader.poll.status.rendering_sub.v4':'Your masterpiece is getting its final layer of magic. Not quite Da Vinci, but every brushstroke is getting gallery-level attention.',
    'loader.poll.status.rendering_sub.v5':'You may be planning to hang this at home, but we\'re making sure it feels worthy of a museum wall.',
    'loader.part4.patience_sub':'Thanks for waiting — your portrait is being created with extra care. Please keep this tab open while we prepare the final preview.',
    'loader.part4.tap_reassure':'Your portrait is already being created. Clicking again will not restart or speed it up — we\'ll update this screen automatically as soon as it\'s ready.',
    'loader.part4.long_wait_sub':'Still working on it. Premium portrait generation can take a little longer when preserving likeness, style, and print-ready detail. You can keep this tab open or leave your email and we\'ll notify you.',
    'loader.part4.long_wait_sub_captured':'Still working on it. Premium portrait generation can take a little longer when preserving likeness, style, and print-ready detail. You can keep this tab open — we\'ll email you when it\'s ready.',
    'loader.part4.already_generating':'Your portrait is already being created — please wait.',
    'part4_notify.title':'Taking a little longer than expected',
    'part4_notify.body':'Your portrait is still processing. Want us to email you as soon as it\'s ready?',
    'part4_notify.body_account':'Your portrait is still processing. We can email {email} when this preview is ready.',
    'part4_notify.email_label':'Email',
    'part4_notify.submit':'Email me when it\'s ready',
    'part4_notify.dismiss':'I\'ll keep waiting',
    'part4_notify.success_title':'Got it',
    'part4_notify.success_body':'We\'ll email you when your portrait is ready. You can keep this tab open.',
    'part4_notify.err_submit':'Could not save your email. Please try again.',
    'loader.real.hope_working_aria':'Still working on your portrait',
    'loader.tap.still_working':'Still working — keep this tab open.',
    'loader.tap.still_working_escalation':'Your portrait is still rendering. Waiting avoids a duplicate render.',
    'loader.title.accessible':'Creating your masterpiece',
    'loader.title.dc':'C','loader.title.lead':'reating your ','loader.title.em':'masterpiece',
    'loader.sub':'Free preview','loader.done':'Done!',
    'loader.progress_aria':'Preview progress',
    'loader.late_hold':'Almost there! Please keep this tab open.',
    'loader.late_seq_craft':'Crafting your portrait…',
    'loader.late_seq_craft_pet':'Crafting your pet\'s portrait…',
    'loader.status_rot_1':'Almost there',
    'loader.status_rot_2':'Blending',
    'loader.status_rot_3':'The irony',
    'loader.status_rot_4':'True progress',
    'loader.late_quote_1':'The irony is that slowing down will get you farther than rushing.',
    'loader.late_quote_2':'True progress is a stable foundation, not a quick fix.',
    'res.back':'← Back','res.steps_aria':'Steps','res.step1':'Upload','res.step2':'Preview','res.step3':'Premium HD download or print',
    'res.title':'Your masterpiece is ready!','res.sub':'Choose your format below','res.checkout_h2':'Your preview is ready','res.finish_h2':'Choose your finish','res.jump.aria':'Jump to finish','res.jump.plexiglas':'Acrylic glass','res.jump.poster':'Poster','res.jump.canvas':'Canvas','res.jump.digital':'Digital download','res.display.t':'Made to be displayed','res.display.p':'Designed to look beautiful on your wall, not hidden away in a camera roll.','res.checkout_lede':'Every option includes your digital file. Physical prints: within 1–3 business days in NL & BE; free shipping from €50 (NL & BE).','res.checkout_trust_pet':'No watermark after purchase · Secure checkout · Made for your pet','res.checkout_trust_people':'No watermark after purchase · Secure checkout','res.retry':'Retry or edit','res.delivery_bar':'Delivered within 1–3 business days in NL & BE','res.preview_history':'Previous previews','inspire.eyebrow':'Need another idea?','inspire.cta':'Try this story','inspire.victory_selfie.title':'Victory Selfie','inspire.victory_selfie.desc':'Celebrate the moment right after the win — same smiles, same vibe.','inspire.rooftop_heroes.title':'Rooftops at Sunset','inspire.rooftop_heroes.desc':'A cinematic rooftop scene in golden light above the city.','inspire.sunset_guardians.title':'Sunset Guardians','inspire.sunset_guardians.desc':'The closing scene of an epic film — golden sky, cape in the wind.','inspire.above_clouds.title':'Above the Clouds','inspire.above_clouds.desc':'Soar like a legend above soft golden clouds.','inspire.guardian_leap.title':"Guardian's Leap","inspire.guardian_leap.desc":'Catch the motion as a heroic mid-leap in golden light.','inspire.protector_family.title':'Family Protector','inspire.protector_family.desc':'A devoted protector with heroic warmth.',
    'maatkeuze.trigger':'Size guide','maatkeuze.title':'Size guide','maatkeuze.h_size':'Choose your size','maatkeuze.advice':'On a wall, a portrait always reads a touch smaller than it does on your screen. Torn between two sizes? Pick the larger one — our customers almost only return when they sized down, never when they sized up.','maatkeuze.close_aria':'Close','maatkeuze.preview_alt':'Preview: portrait on a wall in a classical interior','maatkeuze.l_hint_landscape':'Landscape','maatkeuze.none_enabled':'No purchasable sizes for this material. Check stock or try another option.','maatkeuze.open_failed':'The size guide could not open. Pick a size from the menu above.','maatkeuze.add_to_cart':'Add {0} to cart','maatkeuze.cta_generate_first':'Create your free preview first','maatkeuze.cta_generating':'Generating…','maatkeuze.need_preview':'Create your free preview first. Choose a style and upload your photo — then you can order this size.',
    'modal.close':'Close',
    'welcome.title':'Enjoy 20% off','welcome.sub':'Enter your email and get your personal discount code for your first order.',
    'welcome.email_label':'Email','welcome.email_ph':'you@example.com','welcome.submit':'Send me the code',
    'welcome.success_title':'Your code','welcome.copy':'Copy code','welcome.apply_cart':'Continue with my code','welcome.choose_format':'Your code is saved. Choose a format and add your portrait to your cart.','welcome.cart_busy':'Your cart is updating. Please try again in a moment.','welcome.cart_error':'We could not check your cart. Your code is still saved. Please try again.',
    'welcome.disclaimer':'One use per customer at checkout. If the code does not apply, you may have used this offer before.',
    'welcome.stack_hint':'Cannot combine with some other discounts. Contact us if you need help.',
    'welcome.err_network':'Connection failed. Try again.','welcome.err_submit':'Signup failed. Check your email and try again.',
    'welcome.err_captcha':'Security check failed. Refresh the page and try again, or use the newsletter signup in the footer.',
    'welcome.err_wait':'Please wait a moment before sending your email.',
    'welcome.err_rate':'Too many attempts in this browser window. Try again later.',
    'welcome.copied':'Code copied.','welcome.email_invalid':'Enter a valid email address.',
    'welcome.consent_required':'Please confirm consent to continue.',
    'welcome.consent_label':'By signing up you agree to marketing emails from WallStraight. You can unsubscribe anytime.',
    'welcome.copy_manual':'Copy the code manually (select it above).',
    'studio_recovery.title':'The studio is at full capacity.',
    'studio_recovery.body_p1':'We\'re working fast to ensure everyone gets their own beautiful portrait - including you.',
    'studio_recovery.body_p2':'Leave your email below and we\'ll ping you when we\'re caught up so you can finish your generation.',
    'studio_recovery.submit':'Notify me',
    'studio_recovery.try_again':'Try again',
    'studio_recovery.success_title':'Got it!',
    'studio_recovery.success_body':'We\'ve saved your spot in line. We\'ll reach out soon so you can finish your portrait.',
    'studio_recovery.success_ok':'Close',
    'photo_recovery.title':'We couldn\'t read this photo file.',
    'photo_recovery.body_p1':'Sometimes a photo opens on your phone but cannot be processed — common with exports or screenshots.',
    'photo_recovery.body_p2':'Upload another JPG, PNG, or WebP, or leave your email for tips and a follow-up (we won\'t auto-generate your portrait).',
    'photo_recovery.submit':'Notify me',
    'photo_recovery.try_again':'Choose another photo',
    'photo_recovery.success_title':'Got it!',
    'photo_recovery.success_body':'We\'ll reach out with tips. You can also upload a different photo right away.',
    'photo_recovery.success_ok':'Close',
    'retry.title':'Retry options','retry.remaining_suffix':' previews left this period · Each new preview counts as one',
    'retry.again.ttl':'Again','retry.again.desc':'Same settings · New render',
    'retry.change_img.ttl':'Change image','retry.change_img.desc':'New upload',
    'retry.style.ttl':'Change style','retry.style.desc':'Back to step 2',
    'retry.startover.ttl':'Start over','retry.startover.desc':'Pick category · new photo',
    'retry.sep':'or describe a tweak below','retry.edit.ttl':'Describe your change','retry.edit.desc':'Colours, remove items, etc.',
    /* R-TRY2 — opt-in shopper boost button (English). */
    'retry.stronger.ttl':'Try a stronger render',
    'retry.stronger.desc':'One extra preview with an identity anchor tailored to this category',
    'retry.text.placeholder':'e.g. \'Darken the background\' or \'Remove the hat\'','retry.apply':'Apply ✦',
    'retry.limit1':'You have used all attempts.','retry.limit2':'Download your current portrait or order a print!',
    'retry.no_photo':'This tab no longer has your original upload. Upload again to generate a new preview.',
    'err.file_big':'This file is larger than 10 MB. Please use a smaller JPG, PNG, or WebP.',
    'err.file_type':'Please use a JPG, PNG, or WebP photo.','err.file_read':'We could not read this photo. Try another JPG, PNG, or WebP.',
    'err.no_image':'No image was returned. Please try again.','err.decode':'Could not load the image.',
    'toast.ready':'All set!','toast.edit_empty':'Describe your change','toast.no_retries':'No retries left','toast.preview_restored':'Previous preview restored',
    'toast.link_copied':'Link copied — paste the URL only.',
    'toast.saved_link_copied':'Link copied — paste into an email to yourself to come back later.',
    'toast.share_failed':'Could not share. Please try again.',
    /* Slice E.2 — Save for Later + Share split. {url} is replaced by the JS
       handler with the actual share link before the mailto: URL opens. */
    'email.subject':'My AI portrait on Wallstraight',
    'email.body':'Hey!\n\nI just made an AI portrait on Wallstraight. View it here:\n\n{url}\n\n— Sent via Wallstraight',
    'generic_err':'Something went wrong. Please try again in a moment - your photo and choices are still here.',
    'err.unreachable':'We can’t connect to the preview service right now. Your photo and choices are still saved here - please try again shortly.',
    'err.invalid_signature':'The preview service is not linked correctly yet. Please try again later.',
    'err.invalid_request':'Check your photo and try again.',
    'err.rate_limited':'Our servers are under heavy load right now—we\'re processing a lot of previews. Everything is saved on this page; please try again in a moment.',
    'err.quota_weekly':'You have reached the free preview limit for this period. Try again later or contact us.',
    'err.quota_hard_cap':"This store's daily preview limit has been reached. Please try again later.",
    'err.provider_error':'Our servers are under heavy load right now and the studio is catching up. Your photo and choices are safe on this page—please try again shortly.',
    'err.billing_upstream':'The studio cannot start your preview right now—we have hit a temporary capacity pause at our AI provider. Nothing is wrong with your photo—your choices and upload remain right here—please try again in a moment or a little later.',
    'err.proxy_non_json':'Your portrait needed a little longer than the page could wait. Your photo is still here - please try again in a moment.',
    'err.http404':'The preview service is not active on this store yet. Please try again later.',
    'err.http401':'The preview service could not verify this request. Please try again later.',
    'err.http413':'Your photo is too large to process. Use a smaller JPG, PNG, or WebP.',
    'err.unexpected':'Something unexpected happened. Please wait a moment and try again.',
    'err.bad_json':'We could not process your request. Please refresh the page and try again.',
    'err.missing_prompt':'Please pick a style before generating a preview.',
    'err.missing_image':'Please add a photo (JPG, PNG, or WebP) and try again.',
    'err.missing_style':'Please pick a style for your portrait first.',
    'err.missing_category':'Please pick a category first (for example pet or family).',
    'err.unsupported_image_type':'Please use a JPG, PNG, or WebP photo.',
    'err.image_too_large':'Your photo is larger than 10 MB. Please use a smaller JPG, PNG, or WebP.',
    'err.image_decode_failed':'We could not read your photo. Try another JPG, PNG, or WebP - or a sharper version of the same photo.',
    'err.openai_unconfigured':'The preview service is temporarily unavailable. Please try again shortly.',
    'err.internal_error':'We couldn’t finish your preview because of a technical issue on our side. Please try again.',
    'err.content_blocked':'We can’t process this photo or note. Please try a different photo or rephrase your note.',
    'cart.open_product':'We would open product settings for this format (fallback only when config is unavailable).',
    'cart.variant_missing':'No variant found for this format. Check that the configured product has the expected options (Poster, Canvas, Plexiglas, Digital) and the section product handle is correct.',
    'cart.ok':'Your portrait has been added.',
    'cart.fail':'Could not add to cart. Try again.',
    'cart.oos':'This product is out of stock or unavailable.',
    'cart.error_checkout':'We could not add this to your cart - often due to stock or availability.',
    'cart.checkout':'Checkout',
    'cart.view_cart':'View cart',
    'cart.adding':'Adding…',
    'cart.fab_aria':'Go to checkout',
    'cart.remove_line':'Remove',
    'cart.update_fail':'Could not update your cart. Please try again.',
    'cart.success_dlg_lede':'Ready to checkout \u2014 your HD file or premium print awaits.',
    'cart.success.title.digital':'Your HD download is in your cart.',
    'cart.success.title.physical':'Your {0} is in your cart.',
    'cart.success.title.physical_finish':'Your {0} with {1} is in your cart.',
    'cart.success.lede.digital':'Ready to checkout \u2014 your watermark-free file awaits.',
    'cart.success.lede.physical':'Ready to checkout \u2014 includes your digital file.',
    'cart.success.lede.physical_finish':'Ready to checkout \u2014 your print and finishing await payment.',
    'toast.dismiss':'Close',
    'ann.a':'Free preview without an account','ann.b':'Free shipping from €50 in NL & BE','ann.d':'Secure checkout',
    'wk.oranje.ann':'🇳🇱 Oranje through to the knockouts! Immortalise yourself, your child or your mates in Oranje. World Cup only.',
    'wk.oranje.hero.eyebrow':'World Cup 2026 edition · Limited',
    'wk.oranje.hero.h1':'You, your child or your mates as Oranje on the wall',
    'wk.oranje.hero.h1_pre_first':'Y',
    'wk.oranje.hero.h1_line1':'ou, your child',
    'wk.oranje.hero.h1_line2':'or your mates as',
    'wk.oranje.hero.h1_line3':' on the wall',
    'wk.oranje.hero.lede':'Upload one photo and turn it into a limited Oranje portrait — for match nights, mancaves, family walls and football-mad kids.',
    'wk.oranje.hero.btn1':'Make free preview',
    'wk.oranje.hero.btn2':'View examples',
    'wk.oranje.hero.proof':'⚡ Preview in 30 seconds · no account needed · printed in NL',
    'wk.oranje.hero.series_pre':'Oranje Series · ',
    'wk.oranje.hero.series_edition':'Limited World Cup edition',
    'wk.oranje.hero.gal1.badge':'Bestseller',
    'wk.oranje.hero.gal1.label':'Stadium legend','wk.oranje.hero.gal1.cap':'Oranje on the wall',
    'wk.oranje.hero.gal2.label':'Sticker Hero','wk.oranje.hero.gal2.cap':'Collectible look',
    'wk.oranje.hero.gal3.label':'Mancave','wk.oranje.hero.gal3.cap':'Premium portrait',
    'wk.oranje.voor_wie.eye':'Who it\'s for','wk.oranje.voor_wie.h2':'For every kind of supporter',
    'wk.oranje.audience.child.title':'For your child','wk.oranje.audience.child.desc':'A little Oranje hero before the final',
    'wk.oranje.audience.self.title':'For yourself','wk.oranje.audience.self.desc':'Be the 12th man, immortalised',
    'wk.oranje.audience.mates.title':'For your mates','wk.oranje.audience.mates.desc':'A match night that deserves the wall',
    'wk.oranje.audience.family.title':'For your family','wk.oranje.audience.family.desc':'Football memories above the sofa',
    'wk.oranje.audience.couple.title':'For couples','wk.oranje.audience.couple.desc':'Every match together',
    'wk.oranje.audience.pet.title':'Pets welcome too','wk.oranje.audience.pet.desc':'Pets stay pets — Oranje match energy, never a human body',
    'wk.oranje.voor_wie.r5':'🐾 And yes, your pet can join in too',
    'wk.oranje.showcase.lbl':'Crafted by customers',
    'wk.oranje.gallery.eye':'Examples','wk.oranje.gallery.h2':'How Oranje looks on the wall',
    'wk.oranje.gallery.lede':'Pick a style. Pick a photo. We make the Oranje version.',
    'wk.oranje.gallery.hover':'Generate this style',
    'wk.oranje.gallery.chip.mancave':'MANCAVE','wk.oranje.gallery.chip.gezin':'FAMILY','wk.oranje.gallery.chip.kind':'CHILD','wk.oranje.gallery.chip.koppel':'COUPLE','wk.oranje.gallery.chip.moment':'MOMENT',
    'wk.oranje.gallery.c1':'Bo & the lads — match night in the mancave',
    'wk.oranje.gallery.c2':'The de Vries family — together for Oranje',
    'wk.oranje.gallery.c3':'Sven (8) — ready for the final',
    'wk.oranje.gallery.c4':'Lisa & Mark — every match together',
    'wk.oranje.gallery.c5':'2-1! — the moment captured forever',
    'wk.oranje.styles.h2':'Choose your Oranje edition',
    'wk.oranje.style.panini':'Sticker Hero','wk.oranje.style.panini.desc':'Vintage collectible sticker — best for solo',
    'wk.oranje.style.stadion':'Stadium legend','wk.oranje.style.stadion.desc':'Floodlit pitch portrait — solo, kids, families or groups',
    'wk.oranje.style.vintage':'Vintage Oranje Poster','wk.oranje.style.vintage.desc':'Retro halftone — groups too',
    'wk.oranje.style.mancave':'Mancave portrait','wk.oranje.style.mancave.desc':'Dark premium fan portrait — solo or groups',
    'wk.oranje.style.disclaimer':'Examples show the style and atmosphere. Your artwork follows your uploaded photo, subjects, pose and framing.',
    'wk.oranje.gensec.eye':'Oranje generator','wk.oranje.gensec.h2':'Create your Oranje artwork',
    'wk.oranje.gensec.lede':'Upload yourself, your child, your mates or your family — and preview free.',
    'wk.oranje.how.eye':'How it works','wk.oranje.how.h2':'From photo to Oranje on your wall in four steps',
    'wk.oranje.how.s1t':'1. Choose your Oranje edition','wk.oranje.how.s1d':'Sticker, stadium, vintage or mancave',
    'wk.oranje.how.s2t':'2. Upload your photo','wk.oranje.how.s2d':'Yourself, your child or your mates',
    'wk.oranje.how.s3t':'3. Free preview','wk.oranje.how.s3d':'Instant, no account',
    'wk.oranje.how.s4t':'4. On your wall','wk.oranje.how.s4d':'Canvas, poster or acrylic glass',
    'wk.oranje.pr.eye':'Order','wk.oranje.pr.h2':'Hang it before the final',
    'wk.oranje.pr.lede':'Order today — on your wall this week',
    'wk.oranje.pr.badge':'Most popular',
    'wk.oranje.pr.canvas.nm':'Canvas',
    'wk.oranje.pr.canvas.d':'Gallery canvas, ready to hang. No frame needed.',
    'wk.oranje.pr.poster.nm':'Poster',
    'wk.oranje.pr.poster.d':'Premium matte paper',
    'wk.oranje.pr.digital.nm':'Digital file only',
    'wk.oranje.pr.digital.d':'File only — not on your wall',
    'wk.oranje.countdown.days':'{0} days',
    'wk.oranje.countdown.until':'until the final',
    'wk.oranje.countdown.final_label':'Final today',
    'wk.oranje.countdown.line':'{0} days and {1} hours until the final (19 July 2026)',
    'wk.oranje.countdown.done':'Final 19 July 2026 — order in time to hang it',
    'wk.oranje.trust.printed':'Printed in NL',
    'wk.oranje.trust.checkout':'Secure checkout · iDEAL',
    'wk.oranje.trust.shipping':'Free shipping from €50',
    'wk.oranje.faq.q1':'How fast will I get it?','wk.oranje.faq.a1':'Printed in NL, usually 3–5 working days — in time for the final.',
    'wk.oranje.faq.q2':'Does it work with me or my child?','wk.oranje.faq.a2':'Yes, any clear photo works. Whole family? Order several.',
    'wk.oranje.faq.q3':'Do I pay first?','wk.oranje.faq.a3':'No — create a free preview first, no account needed.',
    'wk.oranje.faq.q4':'Is this really limited?','wk.oranje.faq.a4':'The Oranje edition runs only during World Cup 2026.',
    'wk.oranje.cta.h2':'Ready to see yourself in Oranje?','wk.oranje.cta.h2_pre':'Ready to see yourself in ','wk.oranje.cta.h2_mark':'Oranje','wk.oranje.cta.h2_post':'?','wk.oranje.cta.p':'Free preview in about 30 seconds.','wk.oranje.cta.btn':'Make my Oranje preview',
    'wk.oranje.ft.desc':'Oranje edition 2026 · Limited portrait art. Printed in the Netherlands.',
    'wk.oranje.ft.bot':'WallStraight · Oranje edition 2026 · Limited portrait art · Printed in the Netherlands.',
    'hero.badge':'Trusted by 1,000+ customers','hero.h1.pre_first':'T','hero.h1.line1_lead':'urn your pet','hero.h1.line2':' into a timeless portrait','hero.h1.accessible':'Turn your pet into a timeless portrait.',
    'hero.p_lead':'Upload a photo and preview yours free in your favourite style.','hero.p_em':' No account required.',
    'hero.btn1':'Make free preview','hero.btn2':'View examples','hero.proof':'Poster from €29.95 · Canvas · Acrylic glass · Digital',
    'hero.gal1.p':'Family gift portrait','hero.gal2.p':'Ordered on canvas','hero.gal3.p':'Child & pet',
    'hero.gal1.alt':'Customer at home with a large royal family portrait on canvas','hero.gal2.alt':'Customer holding a watercolor cat portrait on canvas','hero.gal3.alt':'Child at home with superhero canvas — child and golden retriever flying through golden sky',
    'hero.fin.eyebrow':'On your wall','hero.fin.aria':'Finishes on the wall',
    'showcase.lbl':'Crafted by customers',
    'gensec.eye':'AI Generator','gensec.h2':'Make your masterpiece','gensec.lede':'For birthdays, memorials, new homes, or simply because they deserve to be celebrated.',
    'trust.priv.t':'Privacy','trust.priv.d':'Uploads power your preview. See our privacy policy for retention details.',
    'trust.fast.t':'Fast turnaround','trust.fast.d':'Preview usually ready within 15–30 seconds depending on queue load.',
    'trust.rev.t':'Reviews','trust.rev.d':'Verified reviews on our shop and through review partners.',
    'exsec.eye':'Examples','exsec.h2':'See the transformation','ba.orig':'Original','ba.mini.wc':'Watercolour',
    'ba.c1.p':'Nordic calm pet portrait','ba.c2.p':'Cat in a soft wash','ba.c3.p':'Dog in graphic style',
    'mat.eye':'Materials','mat.h2':'Choose the finish that fits your wall','mat.canvas':'Canvas','mat.glass':'Acrylic glass','mat.poster':'Poster',
    'mat.sizes_prefix':'Sizes:','mat.brand_sub':'Portrait art',
    'mat.canvas.alt':'Canvas portrait hanging on a wall','mat.glass.alt':'Acrylic glass portrait with wall standoffs','mat.poster.alt':'Framed poster hanging on a wall',
    'stat.del':'Delivery','stat.del_note':'Usually delivered in NL within 1–2 business days','stat.sty':'Art styles','stat.fmt':'Canvas · Poster · Acrylic glass','stat.pre':'Free',
    'how.eye':'From the studio','how.h2':'Tips for your best portrait','how.lede':'A sharp photo and the right style go a long way. Here’s what we recommend before you create your free preview - and what comes next: a watermarked preview, 4K (HD) after purchase, or a premium print just like in the shop.',
    'how.s1t':'Photo: light & sharpness','how.s1p':'Use a clear close-up with soft, natural light - avoid harsh shadows on the face. Skip extreme wide angles; a calm frame usually gives the strongest portrait.',
    'how.s2t':'A style for your wall','how.s2p':'Every look has its own character - classic, soft, or graphic. Think about your room and the mood you want; the studio block above helps you pick a style.',
    'how.s3t':'Preview, 4K & prints','how.s3p':'Your first render is a free preview with a watermark. Buy 4K (HD) to remove it. Want it on the wall? Choose poster, canvas, or acrylic - the same options as in our store.',
    'pr.eye':'Pricing','pr.h2':'Choose your portrait','pr.badge':'Most chosen','pr.badge.premium':'Premium choice','pr.from':'From',
    'pr.promo_checkout_hint':'Anniversary sale discount automatically applied at checkout.',
    'pr.pos.d':'Sharp photo print of your pet portrait.','pr.pos.btn':'Choose poster',
    'pr.can.d':'Premium canvas with visible texture, ready to hang.','pr.can.btn':'Make my portrait on canvas',
    'pr.gls.d':'Luxurious glossy finish with extra depth and crisp detail.','pr.gls.btn':'Choose acrylic glass',
    'rev.eye':'Reviews','rev.h2':'What customers say',
    'rev.q1':'Our dog’s portrait is incredible - far better than expected.','rev.q2':'A gift for grandma and she was moved. Glad to find Wallstraight. The perfect portrait presents.','rev.q3':'So easy. It’s the centerpiece of our living room.',
    'rev.q4':'I’m a sceptical photographer - the AI is stunning.','rev.q5':'My sister’s laugh says it all — she absolutely loved it!','rev.q6':'My wife was speechless - phenomenal.',
    'rev.m1':'Pet · ✓ Verified','rev.m2':'Family · ✓ Verified','rev.m3':'Pet · ✓ Verified','rev.m4':'Self-portrait · ✓ Verified','rev.m5':'Families · ✓ Verified','rev.m6':'Couple · ✓ Verified',
    'story.eye':'Made for the ones who are family','story.h2':'For pet lovers, by pet lovers.','story.body1':'We know a pet portrait is not just another decoration. It is the face that greets you at the door, the little personality that fills the room, and the memory you want to keep close.','story.body2':'That is why every Wallstraight portrait is created to feel personal, expressive, and worthy of a place in your home.',
    'story.card1.t':'Their personality matters','story.card1.p':'The eyes, the expression, the tiny details — we want the portrait to still feel like them.','story.card1.alt':'Example pet portrait capturing personality and likeness',
    'story.card2.t':'Made to be displayed','story.card2.p':'Designed to look beautiful on your wall, not hidden away in a camera roll.','story.card2.alt':'Example portrait displayed on a wall at home',
    'story.card3.t':'A gift with feeling','story.card3.alt':'Example portrait as a meaningful gift',
    'story.cta':'Create your portrait',
    'story.unboxing.alt':'Customer unboxing a framed portrait',
    'faq.h2':'Frequently asked questions','faq.eye':'FAQ','faq.q1':'How does it work?','faq.a1':'Choose a category and style, upload your photo, and get a free watermarked preview in seconds. Love it? Get your hands on 4K (HD) without the watermark, or a premium poster, canvas, or acrylic glass print — no account required.',
    'faq.q2':'Which photo works best?','faq.a2':'Sharp close-up, good light. Natural daylight is ideal.',
    'faq.q3':'How fast is delivery?','faq.a3':'Digital right after purchase. Physical prints: usually at your door in the Netherlands within 1–2 business days.',
    'faq.q4':'What if I\u2019m not fully satisfied?','faq.a4':'Each portrait is made individually for you. Not quite happy with your preview? Tap «Retry or edit»: rerender, choose a different photo or style, or describe your tweak in words. Before your first preview you can also add an optional personal note. Each new preview counts as one attempt. Need more help? Write us at info@wallstraight.nl.',
    'faq.q5_multi':'What are multiple photos for?','faq.a5_multi':'If you see “Add another photo”, use it for different people who should appear in one portrait together. Uploading yourself several times is not a supported way to get a sharper likeness and can produce strange results. See Why? below your photo for more detail.',
    'cta.h2':'Ready for your masterpiece?','cta.p':'Free preview in seconds.','cta.btn':'✦ Start now - free',
    'ft.policy.shipping-policy':'Shipping','ft.policy.refund-policy':'Returns policy','ft.policy.privacy-policy':'Privacy policy','ft.policy.terms-of-service':'Terms of service',
    'ft.desc':'AI portrait art. Haarlem, Netherlands.','ft.print_options':'Print options','ft.browse_catalog':'All products','ft.info':'Info','ft.how':'Tips','ft.gids':'AI portrait guide','ft.bot':'Tappersweg 52, 2031 EV Haarlem, Netherlands','ft.dig':'Digital',
    'tier.pop':'Most chosen','tier.gift':'Premium choice','tier.fmt':'Size','tier.fin':'Finish','tier.inc':'+ Includes digital download',
    'finish.none':'No finishing','finish.none.glass':'Without standoffs','finish.eyebrow.poster':'Choose your finishing','finish.eyebrow.canvas':'Choose your frame','finish.eyebrow.glass':'Mounting','finish.total_estimate':'Estimated total',
    'finish.paid.photo_frame_30x40':'Photo frame 30×40 cm','finish.paid.photo_frame_40x50':'Photo frame 40×50 cm','finish.paid.photo_frame_50x70':'Photo frame 50×70 cm',
    'finish.paid.poster_hanger':'Poster hanging rail','finish.paid.box_frame_wood':'Wood-tone floating frame','finish.paid.box_frame_black':'Black floating frame',
    'finish.paid.spacers':'Standoffs','finish.paid.frame_wood':'Wood-tone floating frame','finish.paid.frame_black':'Black floating frame',
    'finish.paid.hanger':'Hanging rail','finish.paid.frame':'Photo frame','finish.paid.spacers_kind':'Standoffs',
    'tier.pf':'No frame','tier.pf2':'With frame (+€15)','tier.cf':'No frame','tier.cf2':'With frame',
    'tier.nm.g':'Acrylic glass',
    'tier.ul.p1':'Premium photo paper','tier.ul.p2':'Three sizes available','tier.ul.p3':'Free shipping from €50 (NL & BE)','tier.ul.p4':'Includes digital file',    'tier.ul.p5':'Delivered within 1–3 business days in NL & BE',
    'tier.ul.c1':'Ready to hang right away','tier.ul.c2':'Luxury canvas texture','tier.ul.c3':'Free shipping from €50 (NL & BE)','tier.ul.c4':'Includes digital file','tier.ul.c5':'Delivered within 1–3 business days in NL & BE',
    'tier.ul.g1':'Premium acrylic glass','tier.ul.g2':'Glossy gallery look','tier.ul.g3':'Free shipping from €50 (NL & BE)','tier.ul.g4':'Includes digital file','tier.ul.g5':'Delivered within 1–3 business days in NL & BE',
    'tier.ul.d1':'No watermark (after purchase)','tier.ul.d2':'Download right after checkout (email/link)','tier.ul.d3':'4K file (HD)',
    'tier.btn.p':'Choose poster','tier.btn.c':'Make my portrait on canvas','tier.btn.g':'Choose acrylic glass','tier.btn.dl':'Download digital',
    'tier.dig.nm':'Digital only','tier.dig.eyebrow':'Digital only?','tier.dig.lede':'Get your 4K file without a watermark right after purchase.','tier.dig.d':'4K (HD) file after purchase - share or print yourself',
    'tier.desc.p':'Sharp photo print of your pet portrait.','tier.desc.c':'Premium canvas with visible texture, ready to hang.','tier.desc.g':'Premium acrylic with rich colour, crisp detail, and a modern glossy finish.',
    'tier.mat_sample.canvas':'Close-up of premium canvas texture','tier.mat_sample.poster':'Close-up of photo poster paper','tier.mat_sample.glass':'Close-up: acrylic depth, gloss, and standoff',
    'tier.mat_preview.canvas':'Premium canvas — sample on the wall','tier.mat_preview.poster':'Poster — framed sample','tier.mat_preview.glass':'Acrylic glass — museum gloss finish','tier.mat_preview.digital':'Digital — sample on tablet',
    'tier.mat_sample.zoom_label.canvas':'Enlarge canvas sample','tier.mat_sample.zoom_label.poster':'Enlarge poster sample','tier.mat_sample.zoom_label.glass':'Enlarge acrylic glass sample','tier.mat_sample.zoom_label.digital':'Enlarge digital sample',
    'tier.mat_sample.close':'Close','tier.mat_sample.dialog_title':'Material & preview','tier.mat_sample.mat_link':'View all materials','tier.mat_sample.sizes_label':'Available sizes',
    'sty.badge.staff_pick':'Staff pick','sty.badge.fan_favorite':'Fan favorite','sty.badge.trending':'Trending','sty.badge.new':'New',
    'res.share.h':'Share your portrait','res.share.trust':'See reviews on wallstraight.nl','res.share.sub':'Save for later or share with friends & family',
    'res.share.send':'Share','res.share.save':'Save for Later','res.share.save_aria':'Save for Later — email yourself the link',
    /* Slice R.3 — Portrait Recovery (landing layer). Banner appears when JS
       detects a recoverable session (sessionStorage or ?ws_job restore). */
    'res.recover.title':'Your last portrait is ready',
    'res.recover.continue':'View →',
    'res.recover.continue_aria':'Open your last portrait and go to checkout',
    'res.recover.dismiss_aria':'Hide notification',
    'res.recover.failed':'We could not restore your portrait. The link is invalid or expired.',
    'res.recover.expired':'This preview link has expired. Create a new portrait.',
    'cart.chip_aria':'View cart ({0})',
    'res.info1.h':'What customers say','res.info1.p':'Read reviews on our product page and via review partners.',
    'share.page_blurb':'Check out my AI portrait on Wallstraight.',
    'res.info2.h':'Need help?','res.info3.h':'Support real artists','res.info3.p':'Wallstraight, by Atlantis Digital.',
    'res.info2.p':'info@wallstraight.nl - Happy to help!',
  },
};
/** Greek: merge English UI, override keys that need native copy (Weglot / lang=el). */
WS_STR.el=Object.assign({},WS_STR.en,{
  'welcome.apply_cart':'Συνέχεια με τον κωδικό μου','welcome.choose_format':'Ο κωδικός σου αποθηκεύτηκε. Διάλεξε μέγεθος και πρόσθεσε το πορτρέτο στο καλάθι.','welcome.cart_busy':'Το καλάθι ενημερώνεται. Δοκίμασε ξανά σε λίγο.','welcome.cart_error':'Δεν μπορέσαμε να ελέγξουμε το καλάθι. Ο κωδικός σου παραμένει αποθηκευμένος. Δοκίμασε ξανά.',
  'pet.name.title':'Προσθέστε το όνομα του κατοικιδίου σας στο πορτρέτο',
  'pet.name.confirm':'Τιμήστε τα',
  'pet.name.skip':'Χωρίς όνομα στο πορτρέτο',
  'pet.name.edit_link':'Αλλαγή ή αφαίρεση ονόματος στο πορτρέτο',
  'inscription.headline':'Προσθέστε ένα όνομα',
  'inscription.pet.title':'Πώς λέγεται το κατοικίδιό σας;',
  'inscription.pet.prompt':'Πώς λέγεται το κατοικίδιό σας;',
  'inscription.solo.prompt':'Προσθέστε ένα όνομα',
  'inscription.group.prompt':'Προσθέστε ένα οικογενειακό όνομα',
  'inscription.bond.prompt':'Προσθέστε ένα όνομα',
  'inscription.subtitle':'Θα το προσθέσουμε διακριτικά στην άκρη του έργου, σαν μια μικρή υπογραφή γκαλερί.',
  'inscription.placeholder.pet':'π.χ. Luna',
  'inscription.placeholder.solo':'π.χ. Emma',
  'inscription.placeholder.group':'π.χ. Οικογένεια Παπαδόπουλου',
  'inscription.confirm.empty':'Προσθέστε όνομα',
  'inscription.confirm.filled':'Χρησιμοποιήστε «{name}»',
  'inscription.confirm.pet.empty':'Κάντε την τιμή',
  'inscription.confirm.pet.filled':'Κάντε την τιμή',
  'inscription.skip':'Χωρίς κείμενο στο πορτρέτο μου',
  'inscription.edit_link':'Προσθήκη υπογραφής',
  'inscription.edit_link.has_name':'Αλλαγή υπογραφής',
  'inscription.error.message':'Σύντομα: μόνο ένα όνομα (π.χ. Emma ή Οικογένεια Παπαδόπουλου).',
  'hero.badge':'Μας εμπιστεύονται 1.000+ πελάτες',
  'faq.q4':'Δεν είναι ακριβώς όπως το φανταστήκατε;',
  'faq.a4':'Κάθε πορτρέτο δημιουργείται ατομικά για εσάς. Δεν σας αρέσει η προεπισκόπηση; Χρησιμοποιήστε την επιλογή επανάληψης ή επεξεργασίας στο αποτέλεσμα: νέα απόδοση, άλλη φωτογραφία ή στυλ, ή περιγράψτε με λόγια τι θέλετε να αλλάξει. Πριν την πρώτη προεπισκόπηση μπορείτε επίσης να προσθέσετε προαιρετική σημείωση. Κάθε νέα προεπισκόπηση μετρά ως μία προσπάθεια. Χρειάζεστε βοήθεια; info@wallstraight.nl',
  'ft.policy.shipping-policy':'Αποστολή','ft.policy.refund-policy':'Πολιτική επιστροφών','ft.policy.privacy-policy':'Πολιτική απορρήτου','ft.policy.terms-of-service':'Όροι χρήσης',
  'ft.print_options':'Επιλογές εκτύπωσης','ft.browse_catalog':'Όλα τα προϊόντα',
  'tier.nm.g':'Acrylglas',
  'nav.shop_more':'Περισσότερες αγορές','nav.how':'Συμβουλές','ft.how':'Συμβουλές',
  'how.eye':'Από το ατελιέ','how.h2':'Συμβουλές για ένα εξαιρετικό πορτρέτο',
  'how.lede':'Μια ευκρινής φωτογραφία και το κατάλληλο στυλ κάνουν τη διαφορά. Διαβάστε σύντομα τι προτείνουμε πριν τη δωρεάν προεπισκόπηση - και τι ακολουθεί: προεπισκόπιση με υδατογράφημα, 4K (HD) μετά την αγορά ή premium εκτύπωση όπως στο κατάστημα.',
  'how.s1t':'Φωτογραφία: φως & ευκρίνεια','how.s1p':'Κοντινό πλάνο με φυσικό, μαλακό φως - αποφύγετε σκληρές σκιές στο πρόσωπο. Ήρεμο κάδρο συνήθως δίνει το καλύτερο αποτέλεσμα.',
  'how.s2t':'Στυλ για τον τοίχο σας','how.s2p':'Κάθε εμφάνιση έχει χαρακτήρα - κλασικό, απαλό ή γραφικό. Σκεφτείτε το χώρο και τη διάθεση που θέλετε· το μπλοκ στούντιο παραπάνω σας βοηθά στην επιλογή.',
  'how.s3t':'Προεπισκόπηση, 4K & εκτυπώσεις','how.s3p':'Η πρώτη απόδοση είναι δωρεάν προεπισκόπηση με υδατογράφημα. Με την αγορά 4K (HD) εξαφανίζεται το υδατογράφημα. Για τον τοίχο: αφίσα, καμβάς ή plexiglas - οι ίδιες επιλογές με το κατάστημα.',
  'res.checkout_trust_pet':'Χωρίς υδατογράφημα μετά την αγορά · Ασφαλής ολοκλήρωση αγοράς · Για το κατοικίδιό σας',
  'res.checkout_trust_people':'Χωρίς υδατογράφημα μετά την αγορά · Ασφαλής ολοκλήρωση αγοράς',
  'err.rate_limited':'Οι διακομιστές μας έχουν υψηλό φόρτο αυτή τη στιγμή — επεξεργαζόμαστε πολλές προεπισκοπήσεις. Όλα είναι αποθηκευμένα σε αυτή τη σελίδα· δοκιμάστε ξανά σε λίγο.',
  'err.provider_error':'Υψηλός φόρτος στους διακομιστές· το ατελιέ «τρέχει» στο φουλ. Η φωτογραφία και οι επιλογές σας είναι εδώ — δοκιμάστε ξανά σύντομα.',
  'err.billing_upstream':'Το ατελιέ δεν μπορεί προσωρινά να ξεκινήσει την προεπισκόπησή σας — παύση χωρητικότητας στην πλευρά του συνεργάτη AI. Τίποτε δεν πάει λάθος με τη φωτογραφία σας· οι επιλογές σας μένουν εδώ — δοκιμάστε ξανά σε λίγο ή αργότερα.',
  'studio_recovery.title':'Το ατελιέ είναι πλήρες.',
  'studio_recovery.body_p1':'Δουλεύουμε γρήγορα ώστε όλοι να αποκτήσουν το δικό τους όμορφο πορτρέτο - συμπεριλαμβανομένου εσάς.',
  'studio_recovery.body_p2':'Αφήστε το email σας παρακάτω και θα σας ενημερώσουμε μόλις προλάβουμε, για να ολοκληρώσετε τη δημιουργία σας.',
  'studio_recovery.submit':'Ειδοποιήστε με',
  'studio_recovery.try_again':'Δοκιμάστε ξανά',
  'studio_recovery.success_title':'Το πήραμε!',
  'studio_recovery.success_body':'Κρατήσαμε τη θέση σας στην ουρά. Θα επικοινωνήσουμε σύντομα ώστε να ολοκληρώσετε το πορτρέτο σας.',
  'studio_recovery.success_ok':'Κλείσιμο',
  'photo_recovery.title':'Δεν μπορέσαμε να διαβάσουμε αυτό το αρχείο φωτογραφίας.',
  'photo_recovery.body_p1':'Μερικές φορές μια φωτογραφία ανοίγει στο τηλέφωνό σας αλλά δεν επεξεργάζεται — συχνό με εξαγωγές ή στιγμιότυπα.',
  'photo_recovery.body_p2':'Ανεβάστε άλλο JPG, PNG ή WebP, ή αφήστε email για συμβουλές (δεν δημιουργούμε αυτόματα πορτρέτο).',
  'photo_recovery.submit':'Ειδοποιήστε με',
  'photo_recovery.try_again':'Επιλέξτε άλλη φωτογραφία',
  'photo_recovery.success_title':'Το πήραμε!',
  'photo_recovery.success_body':'Θα επικοινωνήσουμε με συμβουλές. Μπορείτε επίσης να ανεβάσετε άλλη φωτογραφία τώρα.',
  'photo_recovery.success_ok':'Κλείσιμο',
});

/* Spanish (es) — premium brand voice, informal-but-elegant "tú". Full
   merge-over-EN: any key not listed here inherits the English value, so the
   funnel never shows a missing-key error. Placeholders ({0}, {name}, {n},
   {email}, {url}, € prices) and the brand name are preserved verbatim. */
WS_STR.es=Object.assign({},WS_STR.en,{
  'logo.tagline':'Arte de retrato',
  'nav.shop_more':'Ver más','nav.how':'Consejos','nav.ex':'Ejemplos','nav.pr':'Precios','nav.cta':'Crear vista previa gratis','nav.cta_short':'Vista previa gratis',
  'nav.menu_open':'Menú','nav.menu_close':'Cerrar menú','nav.menu_title':'Navegación',
  'wiz.ind1.title':'Categoría','wiz.ind2.title':'Estilo','wiz.ind3.title':'Subir foto',
  'wiz.dots_nav_aria':'Progreso: crea tu retrato',
  'wiz.breadcrumb_nav_aria':'Pasos: categoría, estilo, subir foto',
  'wiz.breadcrumb.s1':'Elige categoría','wiz.breadcrumb.s2':'Elige estilo','wiz.breadcrumb.s3':'Sube tu foto',
  'wiz.breadcrumb.s1_aria':'Paso 1: elige categoría','wiz.breadcrumb.s2_aria':'Paso 2: elige estilo','wiz.breadcrumb.s3_aria':'Paso 3: sube tu foto',
  'wiz.step_n_of_m':'Paso {0} de {1}','wiz.back':'Atrás','wiz.back_aria':'Paso anterior',
  'wiz.chg_cat':'Cambiar categoría','wiz.chg_cat_aria':'Ir al paso 1 para cambiar la categoría',
  'wiz.chg_style':'Cambiar estilo','wiz.chg_style_aria':'Ir al paso 2 para cambiar el estilo',
  'style.infer.selected_label':'Estilo seleccionado',
  'cat.infer.type_label':'Tipo de retrato',
  'cat.infer.focus_label':'Enfoque','cat.infer.choose_focus':'Elegir enfoque','cat.infer.change_focus':'Cambiar enfoque','cat.infer.change_focus_aria':'Cambiar el enfoque del retrato','cat.infer.done':'Listo',
  'wiz.nav_aria':'Navegación por pasos',
  'wiz.summary.cat_lbl':'I. Categoría','wiz.summary.style_lbl':'II. Estilo','wiz.summary.style_lbl_infer':'I. Estilo','wiz.summary.photo_lbl':'III. Foto','wiz.summary.photo_lbl_infer':'II. Foto',
  'wiz.summary.not_chosen':'Sin elegir','wiz.summary.photo_none':'Sin subir','wiz.summary.photo_ok':'Subida',
  'wiz.summary.jump_cat_aria':'Ir al paso 1 para cambiar la categoría','wiz.summary.jump_style_aria':'Ir al paso 2 para cambiar el estilo','wiz.summary.upload_photo_aria':'Elige una foto para subir',
  'wiz.help1':'Elige para quién es el retrato.','wiz.next1':'Continuar — elige un estilo',
  'wiz.help2':'Escoge un estilo para tu retrato.','wiz.next2':'Continuar — sube tu foto',
  'wizard.defaults_caption':'Toca la categoría o el estilo en el resumen para cambiar tu elección.',
  'pill.huisdier':'Mascotas','pill.gezin':'Familias','pill.koppel':'Parejas','pill.kind':'Niños','pill.zelf':'Autorretrato',
  'ex.before':'Antes','ex.step2_before_alt':'Ejemplo: foto original','ex.step2_after_alt':'Ejemplo: resultado con IA en el estilo elegido',
  'upload.pick':'Elegir foto','upload.fmt':'JPG, PNG, WebP · Máx 10MB','upload.chg':'Cambiar foto','upload.rm':'✕ Quitar',
  'upload.reviews_aria':'Historias de clientes','upload.reviews_dots_aria':'Elige una historia','upload.review.dot_aria':'Ir a la historia {n} de {total}',
  'upload.review.claudia.who':'Claudia H.','upload.review.claudia.body':'Le pareció realmente precioso en lienzo — se quedó mirándolo un buen rato. Es enorme y aun así se veía bellísimo, aunque mi foto original no era muy grande.',
  'upload.review.vic.who':'Victor L.','upload.review.vic.body':'Captasteis a la perfección lo juguetón que es Nacho, y agradezco poder comprar solo el archivo digital.',
  'upload.review.nancy.who':'Nancy D.','upload.review.nancy.body':'Estoy completamente satisfecha con el resultado. Nuestra Bonnie es la princesa perfecta.',
  'upload.review.kween.who':'Mira S.','upload.review.kween.body':'¡Me ENCANTA esta página! No esperaba que la pieza fuera tan impresionante y grande.',
  'upload.review.queenie.who':'Sophie V.','upload.review.queenie.body':'¡A mi madre de 80 años le encantó su transformación Real! Su apodo es Queenie, así que verla pintada con vestidura real para su cumpleaños fue el homenaje perfecto.',
  'upload.review.after_wc':'Acuarela suave','upload.review.unboxing.cta':'Consigue el tuyo','upload.review.unboxing.alt':'Cliente abriendo un retrato enmarcado',
  'upload.add_more':'Añadir otra foto','upload.add_more_aria':'Añade otra foto de referencia (máx 3 en total)',
  'upload.role.person':'Persona','upload.role.pet':'Mascota',
  'upload.remove_aria':'Quitar esta foto','upload.slots_aria':'Fotos de referencia adicionales',
  'tip.multi_photo.distinct_subjects':'Añade cada foto para una persona distinta que deba aparecer junta en un mismo retrato.',
  'tip.multi_photo.distinct_subjects_more':'¿Por qué?',
  'tip.multi_photo.distinct_subjects_detail':'Si usas más de una foto, cada una debe ser de una persona diferente — no varios selfies tuyos para “más nitidez”. Eso no lo admitimos y puede salir mal.',
  'scene.legend.title':'Cuenta la historia','scene.legend.hint':'Opcional: elige cómo se desarrolla la escena',
  'scene.noble_lineage.title':'Linaje noble','scene.noble_lineage.desc':'Corona para el mayor; los más jóvenes como príncipes y princesas',
  'scene.court_of_equals.title':'Corte de iguales','scene.court_of_equals.desc':'Todas las figuras como nobles de igual rango, sin un único monarca',
  'scene.royal_romance.title':'Romance real','scene.royal_romance.desc':'La pareja como duque y duquesa en conexión regia',
  'scene.monarchs_pair.title':'Rey y reina','scene.monarchs_pair.desc':'Dos soberanos a la misma altura: manto, corona y tiara',
  'scene.royal_heir_baby_prince.title':'Príncipe heredero (bebé)','scene.royal_heir_baby_prince.desc':'Madre o padre con un recién nacido o niño muy pequeño como príncipe heredero',
  'scene.royal_heir_baby_princess.title':'Princesa heredera (bebé)','scene.royal_heir_baby_princess.desc':'Madre o padre con un recién nacido o niña muy pequeña como princesa heredera',
  'scene.royal_children_court.title':'Corte de niños reales','scene.royal_children_court.desc':'Varios príncipes y princesas, cada uno con su atuendo de corte',
  'notes.toggle.title':'Añadir una nota personal (opcional)',
  'notes.label.hint':'Cuéntanos cualquier cosa que debamos saber sobre tu retrato. La usamos como pista extra al generar.',
  'notes.placeholder':'p. ej. ‘tonos más cálidos’ o ‘mi padre siempre lleva gafas’',
  'notes.clear':'Borrar',
  'pet.name.title':'Añade el nombre de tu mascota en el retrato','pet.name.placeholder':'p. ej. Luna','pet.name.confirm':'Hazle el honor','pet.name.skip':'Sin nombre en el retrato','pet.name.edit_link':'Cambiar o quitar el nombre del retrato',
  'inscription.headline':'Añade un nombre','inscription.pet.title':'Escribe el nombre de tu mascota','inscription.pet.prompt':'¿Cómo se llama tu mascota?','inscription.solo.prompt':'Añade un nombre','inscription.group.prompt':'Añade un apellido','inscription.bond.prompt':'Añade un nombre','inscription.subtitle':'Lo añadiremos con discreción en la esquina de tu obra, como una pequeña firma de galería.','inscription.placeholder.pet':'p. ej. Luna','inscription.placeholder.solo':'p. ej. Emma','inscription.placeholder.group':'p. ej. Los García','inscription.confirm.empty':'Añadir nombre','inscription.confirm.filled':'Usar “{name}”','inscription.confirm.pet.empty':'Hazle el honor','inscription.confirm.pet.filled':'Hazle el honor','inscription.skip':'Sin texto en mi retrato','inscription.edit_link':'Añadir firma','inscription.edit_link.has_name':'Cambiar firma','inscription.error.email':'Este campo es para un nombre en tu obra, no para un correo electrónico.','inscription.error.url':'No uses un enlace ni una dirección web, solo un nombre breve.','inscription.error.phone':'No uses un número de teléfono, solo un nombre breve.','inscription.error.message':'Que sea breve: solo un nombre (p. ej. Emma o Los García).',
  'gen.btn':'Generar vista previa gratis',
  'hint.detect.no_face':'No detectamos ninguna cara. Prueba con una foto más clara u otra imagen.',
  'hint.detect.unknown':'No pudimos verificar automáticamente quién aparece — generaremos según tu categoría.',
  'hint.detect.ok_pet':'Retrato de mascota · listo para estilizar.',
  'hint.detect.ok_solo_zelf':'1 persona detectada · listo para Autorretrato.',
  'hint.detect.ok_couple':'Se ven bien dos personas · listo para generar.',
  'hint.detect.ok_family':'Perfecto para Familias · listo para generar.',
  'hint.detect.ok_kids':'Perfecto para Niños · listo para generar.',
  'hint.detect.ok_kids_adult_note':'Consejo: ¿alguno es adulto? Cambia a Familias para el encuadre correcto.',
  'hint.detect.count_caveat':'Las caras más pequeñas (bebés, perfiles parciales, personas al fondo) quizá no se cuenten, pero aparecerán en tu retrato.',
  'hint.detect.solo_in_gezin':'Elegiste Familias. Ese modo funciona mejor cuando varias personas aparecen juntas en una foto.',
  'hint.detect.solo_in_koppel':'Elegiste Parejas. Ese modo funciona mejor con dos personas juntas en una foto.',
  'hint.detect.solo_in_kind':'Elegiste Niños. Si es un niño, continúa; si es un adulto, cambia a Autorretrato. Nuestra detección automática no distingue la edad.',
  'hint.detect.crowd_in_zelf':'Aparece más de una persona en esta foto, pero elegiste Autorretrato, que se centra en un solo sujeto. Elige la categoría que encaje con tu grupo (dos personas, familia…), o continúa si solo quieres destacar a uno.',
  'hint.detect.crowd_in_koppel':'Elegiste Parejas. Ese modo encaja con dos personas; Familias funciona mejor cuando aparecen más de dos en una foto.',
  'hint.detect.crowd_in_kind':'Parece que elegiste Niños. Familias da su lugar tanto a los niños como a los adultos en el retrato.',
  'hint.detect.pet_in_kind':'Esto parece una foto de mascota. Niños es para niños — cambia a Mascotas para el mejor resultado.',
  'hint.detect.pet_in_zelf':'Esto parece una foto de mascota. Autorretrato es para personas — cambia a Mascotas para el mejor resultado.',
  'hint.detect.pet_in_gezin':'Esto parece una foto de mascota. Familias es para personas — cambia a Mascotas para el mejor resultado.',
  'hint.detect.pet_in_koppel':'Esto parece una foto de mascota. Parejas es para personas — cambia a Mascotas para el mejor resultado.',
  'hint.detect.ok_zelf_person_pet':'Persona y mascota detectadas · listo para Autorretrato.',
  'hint.detect.mixed_in_kind':'Vemos una persona Y una mascota en esta foto. ¿Quieres ambos en tu retrato de Niños?',
  'hint.detect.mixed_in_gezin':'Vemos una persona Y una mascota en esta foto. ¿Quieres ambos en tu retrato de Familia?',
  'hint.detect.mixed_in_gezin_one_detected_person':'Elegiste Familias con una persona visible y una mascota. Ese modo puede inventar personas que no están en tu foto. Considera Autorretrato para ti y tu mascota, o genera si lo prefieres así.',
  'hint.detect.mixed_in_koppel':'Esta foto tiene una persona y una mascota, pero elegiste Parejas (2 personas). La IA podría inventar una segunda persona que no existe. Prueba “Tú + tu mascota (Vínculo)” o “Autorretrato”.',
  'hint.detect.action_mixed_bond':'Incluir ambos (tú + tu mascota)',
  'hint.detect.inversion_human':'Los retratos de mascota celebran primero a los animales y pueden dejar fuera a las personas. Con Familias o Autorretrato, todos en tu foto permanecen juntos en el encuadre.',
  'hint.detect.keep':'Continuar igualmente',
  'hint.detect.keep_aria':'Continúa con esta foto. La categoría, el estilo y el tratamiento se mantienen iguales para cada persona y mascota de la imagen.',
  'hint.baroque_nudge.body':'Para un retrato natural del perro al estilo de los antiguos maestros sin disfraz: elige Siglo de Oro neerlandés.',
  'hint.baroque_nudge.action':'Elegir Siglo de Oro neerlandés','hint.baroque_nudge.dismiss':'Ahora no',
  'quality.hint.too_dark':'Esta foto se ve bastante oscura. Una toma más luminosa (junto a una ventana o fuera a la sombra) da un retrato mucho más fuerte.',
  'quality.hint.too_bright':'Esta foto se ve sobreexpuesta. Evita la luz solar directa; la luz suave de ventana funciona mejor.',
  'quality.hint.too_blurry':'Esta foto se ve borrosa. Un primer plano nítido mantiene el parecido en el retrato.',
  'quality.hint.face_too_small':'La cara detectada parece lejana. Un encuadre más cerrado (cara y hombros) da el mejor retrato.',
  'quality.hint.too_low_res':'Esta foto es de baja resolución. Sube el archivo original en vez de una captura o copia comprimida.',
  'quality.hint.action_reupload':'Elegir otra foto','quality.hint.keep':'Continuar con esta foto igualmente',
  'tip.upload.heading':'Para el mejor retrato',
  'tip.upload.s1':'Primer plano nítido de la cara',
  'tip.upload.s2':'Luz suave y natural (junto a una ventana o fuera a la sombra)',
  'tip.upload.s3':'Foto nítida y de alta resolución — mejor el archivo original',
  'loader.phase1':'Creando tu vista previa…','loader.phase2':'Aplicando el estilo…','loader.phase3':'Refinando detalles…','loader.phase4':'Toques finales…',
  'loader.status.1':'Estudiando tu foto…','loader.status.2':'Preservando rasgos únicos…','loader.status.3':'Aplicando tu estilo artístico…','loader.status.4':'Pintando la vista previa de tu retrato…','loader.status.5':'Refinando los detalles…','loader.status.6':'Dando los toques finales…','loader.status.7':'Tu retrato casi está listo…',
  'loader.status.hold':'Seguimos trabajando en tu retrato — la calidad lleva su tiempo.',
  'loader.poll.status.queued':'Tu vista previa está en cola — manos a la obra.',
  'loader.poll.status.rendering_head':'Renderizando tu retrato…',
  'loader.poll.status.rendering_sub.v1':'A la Mona Lisa no la apuraron, y al tuyo tampoco.',
  'loader.poll.status.rendering_sub.v2':'Está tardando un poco más de lo previsto, pero tu foto merece este cuidado extra.',
  'loader.poll.status.rendering_sub.v3':'Nuestra IA está perfeccionista ahora mismo, muy apropiado para una obra maestra.',
  'loader.poll.status.rendering_sub.v4':'Tu obra recibe su capa final de magia. No es Da Vinci, pero cada pincelada recibe atención de galería.',
  'loader.poll.status.rendering_sub.v5':'Quizá lo cuelgues en casa, pero nos aseguramos de que sea digno de un museo.',
  'loader.part4.patience_sub':'Gracias por esperar — tu retrato se crea con especial cuidado. Mantén esta pestaña abierta mientras preparamos la vista previa final.',
  'loader.part4.tap_reassure':'Tu retrato ya se está creando. Volver a tocar no lo reinicia ni lo acelera — actualizaremos esta pantalla automáticamente en cuanto esté listo.',
  'loader.part4.long_wait_sub':'Seguimos en ello. La generación premium puede tardar algo más al preservar el parecido, el estilo y el detalle listo para imprimir. Mantén esta pestaña abierta o deja tu correo y te avisamos.',
  'loader.part4.long_wait_sub_captured':'Seguimos en ello. La generación premium puede tardar algo más al preservar el parecido, el estilo y el detalle listo para imprimir. Mantén esta pestaña abierta — te avisaremos por correo cuando esté listo.',
  'loader.part4.already_generating':'Tu retrato ya se está creando — espera un momento.',
  'part4_notify.title':'Está tardando un poco más de lo previsto',
  'part4_notify.body':'Tu retrato sigue procesándose. ¿Quieres que te avisemos por correo en cuanto esté listo?',
  'part4_notify.body_account':'Tu retrato sigue procesándose. Podemos avisar a {email} cuando esta vista previa esté lista.',
  'part4_notify.email_label':'Correo electrónico','part4_notify.submit':'Avísame cuando esté listo','part4_notify.dismiss':'Sigo esperando',
  'part4_notify.success_title':'Hecho','part4_notify.success_body':'Te avisaremos por correo cuando tu retrato esté listo. Puedes mantener esta pestaña abierta.',
  'part4_notify.err_submit':'No pudimos guardar tu correo. Inténtalo de nuevo.',
  'loader.real.hope_working_aria':'Seguimos trabajando en tu retrato',
  'loader.tap.still_working':'Seguimos trabajando — mantén esta pestaña abierta.',
  'loader.tap.still_working_escalation':'Tu retrato sigue renderizándose. Esperar evita un render duplicado.',
  'loader.title.accessible':'Creando tu obra maestra','loader.title.lead':'reando tu ','loader.title.em':'obra maestra',
  'loader.sub':'Vista previa gratis','loader.done':'¡Listo!','loader.progress_aria':'Progreso de la vista previa',
  'loader.late_hold':'¡Casi! Mantén esta pestaña abierta.','loader.late_seq_craft':'Creando tu retrato…','loader.late_seq_craft_pet':'Creando el retrato de tu mascota…',
  'loader.status_rot_1':'Casi listo','loader.status_rot_2':'Mezclando','loader.status_rot_3':'La ironía','loader.status_rot_4':'Verdadero progreso',
  'loader.late_quote_1':'La ironía es que ir más despacio te llevará más lejos que correr.','loader.late_quote_2':'El verdadero progreso es una base estable, no un arreglo rápido.',
  'res.back':'← Atrás','res.steps_aria':'Pasos','res.step1':'Subir','res.step2':'Vista previa','res.step3':'Descarga HD premium o impresión',
  'res.title':'¡Tu obra maestra está lista!','res.sub':'Elige tu formato abajo','res.checkout_h2':'Tu vista previa está lista','res.finish_h2':'Elige tu acabado','res.jump.aria':'Ir al acabado','res.jump.plexiglas':'Metacrilato','res.jump.poster':'Póster','res.jump.canvas':'Lienzo','res.jump.digital':'Descarga digital','res.display.t':'Hecho para lucir','res.display.p':'Diseñado para verse precioso en tu pared, no escondido en el carrete del móvil.','res.checkout_lede':'Todas las opciones incluyen tu archivo digital. Impresiones físicas: en 1–3 días laborables en NL y BE; envío gratis desde 50 € (NL y BE).','res.checkout_trust_pet':'Sin marca de agua tras la compra · Pago seguro · Hecho para tu mascota','res.checkout_trust_people':'Sin marca de agua tras la compra · Pago seguro','res.retry':'Repetir o editar','res.delivery_bar':'Entrega en 1–3 días en NL y BE','res.preview_history':'Vistas previas anteriores','inspire.eyebrow':'¿Otra idea?','inspire.cta':'Probar esta historia','inspire.victory_selfie.title':'Selfie de victoria','inspire.victory_selfie.desc':'Celebra el momento justo tras la victoria — la misma sonrisa, el mismo ambiente.','inspire.rooftop_heroes.title':'Azoteas al atardecer','inspire.rooftop_heroes.desc':'Una escena cinematográfica en la azotea con luz dorada sobre la ciudad.','inspire.sunset_guardians.title':'Guardianes del ocaso','inspire.sunset_guardians.desc':'La escena final de una película épica — cielo dorado, capa al viento.','inspire.above_clouds.title':'Sobre las nubes','inspire.above_clouds.desc':'Vuela como una leyenda sobre suaves nubes doradas.','inspire.guardian_leap.title':'El salto del guardián','inspire.guardian_leap.desc':'Captura el movimiento como un salto heroico con luz dorada.','inspire.protector_family.title':'Protector de la familia','inspire.protector_family.desc':'Un protector devoto con calidez heroica.',
  'maatkeuze.trigger':'Guía de tallas','maatkeuze.title':'Guía de tallas','maatkeuze.h_size':'Elige tu tamaño','maatkeuze.advice':'En la pared, un retrato siempre se ve un poco más pequeño que en pantalla. ¿Dudas entre dos tamaños? Elige el mayor — nuestros clientes casi solo se arrepienten cuando eligen el pequeño, nunca el grande.','maatkeuze.close_aria':'Cerrar','maatkeuze.preview_alt':'Vista previa: retrato en una pared de interior clásico','maatkeuze.l_hint_landscape':'Horizontal','maatkeuze.none_enabled':'No hay tamaños disponibles para este material. Comprueba el stock o prueba otra opción.','maatkeuze.open_failed':'No se pudo abrir la guía de tallas. Elige un tamaño en el menú de arriba.','maatkeuze.add_to_cart':'Añadir {0} al carrito','maatkeuze.cta_generate_first':'Crea primero tu vista previa gratis','maatkeuze.cta_generating':'Generando…','maatkeuze.need_preview':'Crea primero tu vista previa gratis. Elige un estilo y sube tu foto — luego podrás pedir este tamaño.',
  'modal.close':'Cerrar',
  'welcome.title':'Disfruta de un 20% de descuento','welcome.sub':'Introduce tu correo y recibe tu código de descuento personal para tu primer pedido.',
  'welcome.email_label':'Correo electrónico','welcome.email_ph':'tu@ejemplo.com','welcome.submit':'Enviarme el código',
  'welcome.success_title':'Tu código','welcome.copy':'Copiar código','welcome.apply_cart':'Continuar con mi código','welcome.choose_format':'Tu código está guardado. Elige un formato y añade tu retrato al carrito.','welcome.cart_busy':'Tu carrito se está actualizando. Inténtalo de nuevo en un momento.','welcome.cart_error':'No pudimos comprobar tu carrito. Tu código sigue guardado. Inténtalo de nuevo.',
  'welcome.disclaimer':'Un uso por cliente al pagar. Si el código no se aplica, puede que ya hayas usado esta oferta.',
  'welcome.stack_hint':'No combinable con algunos otros descuentos. Escríbenos si necesitas ayuda.',
  'welcome.err_network':'Falló la conexión. Inténtalo de nuevo.','welcome.err_submit':'Falló el registro. Revisa tu correo e inténtalo de nuevo.',
  'welcome.err_captcha':'Falló la verificación de seguridad. Recarga la página e inténtalo de nuevo, o usa el registro al boletín del pie de página.',
  'welcome.err_wait':'Espera un momento antes de enviar tu correo.','welcome.err_rate':'Demasiados intentos en esta ventana. Inténtalo más tarde.',
  'welcome.copied':'Código copiado.','welcome.email_invalid':'Introduce un correo válido.',
  'welcome.consent_required':'Confirma el consentimiento para continuar.',
  'welcome.consent_label':'Al registrarte aceptas recibir correos de marketing de WallStraight. Puedes darte de baja cuando quieras.',
  'welcome.copy_manual':'Copia el código manualmente (selecciónalo arriba).',
  'studio_recovery.title':'El estudio está a plena capacidad.',
  'studio_recovery.body_p1':'Trabajamos rápido para que todos reciban su propio retrato precioso — tú incluido.',
  'studio_recovery.body_p2':'Deja tu correo abajo y te avisamos cuando nos pongamos al día para que termines tu generación.',
  'studio_recovery.submit':'Avísame','studio_recovery.try_again':'Reintentar','studio_recovery.success_title':'¡Hecho!','studio_recovery.success_body':'Hemos guardado tu lugar en la cola. Te contactaremos pronto para que termines tu retrato.','studio_recovery.success_ok':'Cerrar',
  'photo_recovery.title':'No pudimos leer este archivo de foto.',
  'photo_recovery.body_p1':'A veces una foto se abre en el móvil pero no se puede procesar — común con exportaciones o capturas.',
  'photo_recovery.body_p2':'Sube otro JPG, PNG o WebP, o deja tu correo para consejos y seguimiento (no generaremos tu retrato automáticamente).',
  'photo_recovery.submit':'Avísame','photo_recovery.try_again':'Elegir otra foto','photo_recovery.success_title':'¡Hecho!','photo_recovery.success_body':'Te contactaremos con consejos. También puedes subir otra foto ahora mismo.','photo_recovery.success_ok':'Cerrar',
  'retry.title':'Opciones de repetición','retry.remaining_suffix':' vistas previas restantes este periodo · Cada nueva cuenta como una',
  'retry.again.ttl':'Otra vez','retry.again.desc':'Mismos ajustes · Nuevo render',
  'retry.change_img.ttl':'Cambiar imagen','retry.change_img.desc':'Nueva foto',
  'retry.style.ttl':'Cambiar estilo','retry.style.desc':'Volver al paso 2',
  'retry.startover.ttl':'Empezar de nuevo','retry.startover.desc':'Elige categoría · nueva foto',
  'retry.sep':'o describe un ajuste abajo','retry.edit.ttl':'Describe tu cambio','retry.edit.desc':'Colores, quitar elementos, etc.',
  'retry.stronger.ttl':'Probar un render más fuerte','retry.stronger.desc':'Una vista previa extra con un anclaje de identidad para esta categoría',
  'retry.text.placeholder':'p. ej. ‘Oscurece el fondo’ o ‘Quita el sombrero’','retry.apply':'Aplicar ✦',
  'retry.limit1':'Has usado todos los intentos.','retry.limit2':'¡Descarga tu retrato actual o pide una impresión!',
  'retry.no_photo':'Esta pestaña ya no tiene tu foto original. Súbela de nuevo para generar una nueva vista previa.',
  'err.file_big':'Este archivo supera los 10 MB. Usa un JPG, PNG o WebP más pequeño.',
  'err.file_type':'Usa una foto JPG, PNG o WebP.','err.file_read':'No pudimos leer esta foto. Prueba con otro JPG, PNG o WebP.',
  'err.no_image':'No se devolvió ninguna imagen. Inténtalo de nuevo.','err.decode':'No se pudo cargar la imagen.',
  'toast.ready':'¡Todo listo!','toast.edit_empty':'Describe tu cambio','toast.no_retries':'No quedan reintentos','toast.preview_restored':'Vista previa anterior restaurada',
  'toast.link_copied':'Enlace copiado — pega solo la URL.',
  'toast.saved_link_copied':'Enlace copiado — pégalo en un correo para ti mismo y vuelve más tarde.',
  'toast.share_failed':'No se pudo compartir. Inténtalo de nuevo.',
  'email.subject':'Mi retrato con IA en Wallstraight',
  'email.body':'¡Hola!\n\nAcabo de crear un retrato con IA en Wallstraight. Míralo aquí:\n\n{url}\n\n— Enviado vía Wallstraight',
  'generic_err':'Algo salió mal. Inténtalo de nuevo en un momento — tu foto y tus elecciones siguen aquí.',
  'err.unreachable':'Ahora mismo no podemos conectar con el servicio de vista previa. Tu foto y tus elecciones siguen guardadas aquí — inténtalo de nuevo en breve.',
  'err.invalid_signature':'El servicio de vista previa aún no está bien enlazado. Inténtalo más tarde.',
  'err.invalid_request':'Revisa tu foto e inténtalo de nuevo.',
  'err.rate_limited':'Nuestros servidores tienen mucha carga ahora mismo: procesamos muchas vistas previas. Todo está guardado en esta página; inténtalo de nuevo en un momento.',
  'err.quota_weekly':'Has alcanzado el límite de vistas previas gratis de este periodo. Inténtalo más tarde o escríbenos.',
  'err.quota_hard_cap':'Se ha alcanzado el límite diario de vistas previas de esta tienda. Inténtalo más tarde.',
  'err.provider_error':'Nuestros servidores tienen mucha carga y el estudio se está poniendo al día. Tu foto y tus elecciones están a salvo en esta página — inténtalo de nuevo en breve.',
  'err.billing_upstream':'El estudio no puede iniciar tu vista previa ahora mismo: hemos alcanzado una pausa temporal de capacidad en nuestro proveedor de IA. Tu foto no tiene ningún problema — tus elecciones y tu subida siguen aquí — inténtalo de nuevo en un momento.',
  'err.proxy_non_json':'Tu retrato necesitó algo más de lo que la página pudo esperar. Tu foto sigue aquí — inténtalo de nuevo en un momento.',
  'err.http404':'El servicio de vista previa aún no está activo en esta tienda. Inténtalo más tarde.',
  'err.http401':'El servicio de vista previa no pudo verificar esta solicitud. Inténtalo más tarde.',
  'err.http413':'Tu foto es demasiado grande para procesarla. Usa un JPG, PNG o WebP más pequeño.',
  'err.unexpected':'Ocurrió algo inesperado. Espera un momento e inténtalo de nuevo.',
  'err.bad_json':'No pudimos procesar tu solicitud. Recarga la página e inténtalo de nuevo.',
  'err.missing_prompt':'Elige un estilo antes de generar una vista previa.',
  'err.missing_image':'Añade una foto (JPG, PNG o WebP) e inténtalo de nuevo.',
  'err.missing_style':'Primero elige un estilo para tu retrato.',
  'err.missing_category':'Primero elige una categoría (por ejemplo, mascota o familia).',
  'err.unsupported_image_type':'Usa una foto JPG, PNG o WebP.',
  'err.image_too_large':'Tu foto supera los 10 MB. Usa un JPG, PNG o WebP más pequeño.',
  'err.image_decode_failed':'No pudimos leer tu foto. Prueba con otro JPG, PNG o WebP, o una versión más nítida de la misma foto.',
  'err.openai_unconfigured':'El servicio de vista previa no está disponible temporalmente. Inténtalo en breve.',
  'err.internal_error':'No pudimos terminar tu vista previa por un problema técnico de nuestro lado. Inténtalo de nuevo.',
  'err.content_blocked':'No podemos procesar esta foto o nota. Prueba con otra foto o reformula tu nota.',
  'cart.open_product':'Abriríamos los ajustes de producto para este formato (solo alternativa cuando la configuración no está disponible).',
  'cart.variant_missing':'No se encontró ninguna variante para este formato. Comprueba que el producto configurado tenga las opciones esperadas (Póster, Lienzo, Metacrilato, Digital) y que el handle del producto sea correcto.',
  'cart.ok':'Tu retrato se ha añadido.','cart.fail':'No se pudo añadir al carrito. Inténtalo de nuevo.','cart.oos':'Este producto está agotado o no disponible.',
  'cart.error_checkout':'No pudimos añadirlo a tu carrito — a menudo por stock o disponibilidad.',
  'cart.checkout':'Pagar','cart.view_cart':'Ver carrito','cart.adding':'Añadiendo…','cart.fab_aria':'Ir a pagar','cart.remove_line':'Quitar','cart.update_fail':'No pudimos actualizar tu carrito. Inténtalo de nuevo.',
  'cart.success_dlg_lede':'Listo para pagar — te espera tu archivo HD o impresión premium.',
  'cart.success.title.digital':'Tu descarga HD está en el carrito.','cart.success.title.physical':'Tu {0} está en el carrito.','cart.success.title.physical_finish':'Tu {0} con {1} está en el carrito.',
  'cart.success.lede.digital':'Listo para pagar — te espera tu archivo sin marca de agua.','cart.success.lede.physical':'Listo para pagar — incluye tu archivo digital.','cart.success.lede.physical_finish':'Listo para pagar — tu impresión y acabado esperan el pago.',
  'toast.dismiss':'Cerrar',
  'ann.a':'Vista previa gratis sin cuenta','ann.b':'Envío gratis desde 50 € en NL y BE','ann.d':'Pago seguro',
  'wk.oranje.ann':'🇳🇱 ¡Oranje pasa a eliminatorias! Inmortalízate, a tu hijo o a tus amigos en Oranje. Solo durante el Mundial.',
  'wk.oranje.hero.eyebrow':'Edición Mundial 2026 · Limitada',
  'wk.oranje.hero.h1':'Tú, tu hijo o tus amigos como Oranje en la pared',
  'wk.oranje.hero.h1_pre_first':'T',
  'wk.oranje.hero.h1_line1':'ú, tu hijo',
  'wk.oranje.hero.h1_line2':'o tus amigos como',
  'wk.oranje.hero.h1_line3':' en la pared',
  'wk.oranje.hero.lede':'Sube una foto y conviértela en un retrato Oranje limitado — para noches de partido, mancaves, paredes familiares y niños futboleros.',
  'wk.oranje.hero.btn1':'Crear vista previa gratis',
  'wk.oranje.hero.btn2':'Ver ejemplos',
  'wk.oranje.hero.proof':'⚡ Vista previa en 30 segundos · sin cuenta · impreso en NL',
  'wk.oranje.hero.series_pre':'Serie Oranje · ',
  'wk.oranje.hero.series_edition':'Edición WK limitada',
  'wk.oranje.hero.gal1.badge':'Más vendido',
  'wk.oranje.hero.gal1.label':'Leyenda del estadio','wk.oranje.hero.gal1.cap':'Oranje en la pared',
  'wk.oranje.hero.gal2.label':'Héroe Sticker','wk.oranje.hero.gal2.cap':'Look de colección',
  'wk.oranje.hero.gal3.label':'Mancave','wk.oranje.hero.gal3.cap':'Retrato premium',
  'wk.oranje.voor_wie.eye':'Para quién','wk.oranje.voor_wie.h2':'Para cada tipo de aficionado',
  'wk.oranje.audience.child.title':'Para tu hijo','wk.oranje.audience.child.desc':'Un pequeño héroe Oranje antes de la final',
  'wk.oranje.audience.self.title':'Para ti','wk.oranje.audience.self.desc':'Sé el 12.º hombre, inmortalizado',
  'wk.oranje.audience.mates.title':'Para tus amigos','wk.oranje.audience.mates.desc':'Una noche de partido que merece la pared',
  'wk.oranje.audience.family.title':'Para tu familia','wk.oranje.audience.family.desc':'Recuerdos de fútbol sobre el sofá',
  'wk.oranje.audience.couple.title':'Para parejas','wk.oranje.audience.couple.desc':'Cada partido juntos',
  'wk.oranje.audience.pet.title':'También mascotas','wk.oranje.audience.pet.desc':'Siguen siendo mascotas — energía Oranje, nunca un cuerpo humano',
  'wk.oranje.voor_wie.r5':'🐾 Y sí, tu mascota también puede unirse',
  'wk.oranje.showcase.lbl':'Creado por clientes',
  'wk.oranje.gallery.eye':'Ejemplos','wk.oranje.gallery.h2':'Así cuelga Oranje en la pared',
  'wk.oranje.gallery.lede':'Elige un estilo. Elige una foto. Nosotros hacemos la versión Oranje.',
  'wk.oranje.gallery.hover':'Generar este estilo',
  'wk.oranje.gallery.chip.mancave':'MANCAVE','wk.oranje.gallery.chip.gezin':'FAMILIA','wk.oranje.gallery.chip.kind':'NIÑO','wk.oranje.gallery.chip.koppel':'PAREJA','wk.oranje.gallery.chip.moment':'MOMENTO',
  'wk.oranje.gallery.c1':'Bo y los chicos — noche de partido en la mancave',
  'wk.oranje.gallery.c2':'Familia de Vries — juntos por Oranje',
  'wk.oranje.gallery.c3':'Sven (8) — listo para la final',
  'wk.oranje.gallery.c4':'Lisa y Mark — cada partido juntos',
  'wk.oranje.gallery.c5':'¡2-1! — el momento inmortalizado',
  'wk.oranje.styles.h2':'Elige tu edición Oranje',
  'wk.oranje.style.panini':'Héroe sticker','wk.oranje.style.panini.desc':'Sticker coleccionable vintage — mejor en solo',
  'wk.oranje.style.stadion':'Leyenda del estadio','wk.oranje.style.stadion.desc':'Retrato en el campo iluminado — solo, niños, familias o grupos',
  'wk.oranje.style.vintage':'Póster vintage Oranje','wk.oranje.style.vintage.desc':'Mediotono retro — también grupos',
  'wk.oranje.style.mancave':'Retrato mancave','wk.oranje.style.mancave.desc':'Retrato premium oscuro — solo o grupos',
  'wk.oranje.style.disclaimer':'Los ejemplos muestran el estilo y el ambiente. Tu obra sigue tu foto, personas, pose y encuadre.',
  'wk.oranje.gensec.eye':'Generador Oranje','wk.oranje.gensec.h2':'Crea tu obra Oranje',
  'wk.oranje.gensec.lede':'Sube tú, tu hijo, tus amigos o tu familia — y mira la vista previa gratis.',
  'wk.oranje.how.eye':'Cómo funciona','wk.oranje.how.h2':'De la foto a Oranje en la pared en cuatro pasos',
  'wk.oranje.how.s1t':'1. Elige tu edición Oranje','wk.oranje.how.s1d':'Sticker, estadio, vintage o mancave',
  'wk.oranje.how.s2t':'2. Sube tu foto','wk.oranje.how.s2d':'Tú, tu hijo o tus amigos',
  'wk.oranje.how.s3t':'3. Vista previa gratis','wk.oranje.how.s3d':'Al instante, sin cuenta',
  'wk.oranje.how.s4t':'4. En tu pared','wk.oranje.how.s4d':'Lienzo, póster o metacrilato',
  'wk.oranje.pr.eye':'Pedir','wk.oranje.pr.h2':'Cuélalo antes de la final',
  'wk.oranje.pr.lede':'Pedido hoy — en tu pared esta semana',
  'wk.oranje.pr.badge':'Más elegido',
  'wk.oranje.pr.canvas.nm':'Lienzo',
  'wk.oranje.pr.canvas.d':'Lienzo de galería, listo para colgar. Sin marco.',
  'wk.oranje.pr.poster.nm':'Póster',
  'wk.oranje.pr.poster.d':'Papel mate premium',
  'wk.oranje.pr.digital.nm':'Solo archivo digital',
  'wk.oranje.pr.digital.d':'Solo un archivo — no en tu pared',
  'wk.oranje.countdown.days':'{0} días',
  'wk.oranje.countdown.until':'hasta la final',
  'wk.oranje.countdown.final_label':'Final hoy',
  'wk.oranje.countdown.line':'{0} días y {1} horas hasta la final (19 julio 2026)',
  'wk.oranje.countdown.done':'Final 19 julio 2026 — pide a tiempo para colgarlo',
  'wk.oranje.trust.printed':'Impreso en NL',
  'wk.oranje.trust.checkout':'Pago seguro · iDEAL',
  'wk.oranje.trust.shipping':'Envío gratis desde 50 €',
  'wk.oranje.faq.q1':'¿Qué tan rápido lo recibo?','wk.oranje.faq.a1':'Impreso en NL, normalmente 3–5 días laborables — a tiempo para la final.',
  'wk.oranje.faq.q2':'¿Funciona conmigo o con mi hijo?','wk.oranje.faq.a2':'Sí, cualquier foto clara funciona. ¿Toda la familia? Pide varios.',
  'wk.oranje.faq.q3':'¿Pago primero?','wk.oranje.faq.a3':'No — primero crea una vista previa gratis sin cuenta.',
  'wk.oranje.faq.q4':'¿Es realmente limitado?','wk.oranje.faq.a4':'La edición Oranje solo durante el Mundial 2026.',
  'wk.oranje.cta.h2':'¿Listo para verte en Oranje?','wk.oranje.cta.h2_pre':'¿Listo para verte en ','wk.oranje.cta.h2_mark':'Oranje','wk.oranje.cta.h2_post':'?','wk.oranje.cta.p':'Vista previa gratis en unos 30 segundos.','wk.oranje.cta.btn':'Crear mi vista previa Oranje',
  'wk.oranje.ft.desc':'Edición Oranje 2026 · Arte de retrato limitado. Impreso en Países Bajos.',
  'wk.oranje.ft.bot':'WallStraight · Edición Oranje 2026 · Arte de retrato limitado · Impreso en Países Bajos.',
  'hero.badge':'Con la confianza de más de 1.000 clientes','hero.h1.line1_lead':'onvierte a tu mascota','hero.h1.pre_first':'C','hero.h1.line2':' en un retrato atemporal','hero.h1.accessible':'Convierte a tu mascota en un retrato atemporal.',
  'hero.p_lead':'Sube una foto y previsualiza el tuyo gratis en tu estilo favorito.','hero.p_em':' Sin cuenta.',
  'hero.btn1':'Crear vista previa gratis','hero.btn2':'Ver ejemplos','hero.proof':'Póster desde 29,95 € · Lienzo · Metacrilato · Digital',
  'hero.gal1.p':'Retrato familiar de regalo','hero.gal2.p':'Pedido en lienzo','hero.gal3.p':'Niño y mascota',
  'hero.gal1.alt':'Cliente en casa con un gran retrato familiar real en lienzo','hero.gal2.alt':'Cliente sosteniendo un retrato de gato en acuarela sobre lienzo','hero.gal3.alt':'Niño en casa con lienzo de superhéroe — niño y golden retriever volando en cielo dorado',
  'hero.fin.eyebrow':'En tu pared','hero.fin.aria':'Acabados en la pared',
  'showcase.lbl':'Creado por clientes',
  'gensec.eye':'Generador con IA','gensec.h2':'Crea tu obra maestra','gensec.lede':'Para cumpleaños, homenajes, nuevos hogares o simplemente porque merecen celebrarse.',
  'trust.priv.t':'Privacidad','trust.priv.d':'Tus subidas alimentan tu vista previa. Consulta nuestra política de privacidad para los detalles de conservación.',
  'trust.fast.t':'Entrega rápida','trust.fast.d':'La vista previa suele estar lista en 15–30 segundos según la carga.',
  'trust.rev.t':'Reseñas','trust.rev.d':'Reseñas verificadas en nuestra tienda y a través de socios de reseñas.',
  'exsec.eye':'Ejemplos','exsec.h2':'Mira la transformación','ba.orig':'Original','ba.mini.wc':'Acuarela',
  'ba.c1.p':'Retrato de mascota con calma nórdica','ba.c2.p':'Gato en acuarela suave','ba.c3.p':'Perro en estilo gráfico',
  'mat.eye':'Materiales','mat.h2':'Elige el acabado que encaja con tu pared','mat.canvas':'Lienzo','mat.glass':'Metacrilato','mat.poster':'Póster',
  'mat.sizes_prefix':'Tamaños:','mat.brand_sub':'Arte de retrato',
  'mat.canvas.alt':'Retrato en lienzo colgado en una pared','mat.glass.alt':'Retrato en metacrilato con separadores de pared','mat.poster.alt':'Póster enmarcado colgado en una pared',
  'stat.del':'Entrega','stat.del_note':'Normalmente entregado en NL en 1–2 días laborables','stat.sty':'Estilos artísticos','stat.fmt':'Lienzo · Póster · Metacrilato','stat.pre':'Gratis',
  'how.eye':'Desde el estudio','how.h2':'Consejos para tu mejor retrato','how.lede':'Una foto nítida y el estilo adecuado marcan la diferencia. Esto es lo que recomendamos antes de crear tu vista previa gratis — y lo que viene después: una vista previa con marca de agua, 4K (HD) tras la compra, o una impresión premium como en la tienda.',
  'how.s1t':'Foto: luz y nitidez','how.s1p':'Usa un primer plano claro con luz suave y natural — evita sombras duras en la cara. Evita los grandes angulares extremos; un encuadre tranquilo suele dar el retrato más fuerte.',
  'how.s2t':'Un estilo para tu pared','how.s2p':'Cada look tiene su carácter: clásico, suave o gráfico. Piensa en tu habitación y el ambiente que quieres; el bloque del estudio te ayuda a elegir un estilo.',
  'how.s3t':'Vista previa, 4K e impresiones','how.s3p':'Tu primer render es una vista previa gratis con marca de agua. Compra 4K (HD) para quitarla. ¿Lo quieres en la pared? Elige póster, lienzo o metacrilato — las mismas opciones que en nuestra tienda.',
  'pr.eye':'Precios','pr.h2':'Elige tu retrato','pr.badge':'El más elegido','pr.badge.premium':'Opción premium','pr.from':'Desde',
  'pr.promo_checkout_hint':'Descuento de aniversario aplicado automáticamente al pagar.',
  'pr.pos.d':'Impresión fotográfica nítida de tu retrato de mascota.','pr.pos.btn':'Elegir póster',
  'pr.can.d':'Lienzo premium con textura visible, listo para colgar.','pr.can.btn':'Crear mi retrato en lienzo',
  'pr.gls.d':'Acabado brillante de lujo con más profundidad y detalle nítido.','pr.gls.btn':'Elegir metacrilato',
  'rev.eye':'Reseñas','rev.h2':'Lo que dicen los clientes',
  'rev.q1':'El retrato de nuestro perro es increíble — mucho mejor de lo esperado.','rev.q2':'Un regalo para la abuela y se emocionó. Qué bien haber encontrado Wallstraight. El regalo de retrato perfecto.','rev.q3':'Muy fácil. Es la pieza central de nuestro salón.',
  'rev.q4':'Soy un fotógrafo escéptico — la IA es impresionante.','rev.q5':'¡La risa de mi hermana lo dice todo, le encantó!','rev.q6':'Mi mujer se quedó sin palabras — fenomenal.',
  'rev.m1':'Mascota · ✓ Verificado','rev.m2':'Familia · ✓ Verificado','rev.m3':'Mascota · ✓ Verificado','rev.m4':'Autorretrato · ✓ Verificado','rev.m5':'Familias · ✓ Verificado','rev.m6':'Pareja · ✓ Verificado',
  'story.eye':'Hecho para quienes son familia','story.h2':'Por amantes de las mascotas, para amantes de las mascotas.','story.body1':'Sabemos que un retrato de mascota no es una decoración más. Es la cara que te recibe en la puerta, la pequeña personalidad que llena la habitación y el recuerdo que quieres tener cerca.','story.body2':'Por eso cada retrato Wallstraight se crea para sentirse personal, expresivo y digno de un lugar en tu hogar.',
  'story.card1.t':'Su personalidad importa','story.card1.p':'Los ojos, la expresión, los pequeños detalles — queremos que el retrato siga siendo él.','story.card1.alt':'Ejemplo de retrato de mascota que capta personalidad y parecido',
  'story.card2.t':'Hecho para lucir','story.card2.p':'Diseñado para verse precioso en tu pared, no escondido en el carrete del móvil.','story.card2.alt':'Ejemplo de retrato expuesto en una pared en casa',
  'story.card3.t':'Un regalo con sentimiento','story.card3.alt':'Ejemplo de retrato como regalo con significado',
  'story.cta':'Crea tu retrato','story.unboxing.alt':'Cliente abriendo un retrato enmarcado',
  'faq.h2':'Preguntas frecuentes','faq.eye':'FAQ','faq.q1':'¿Cómo funciona?','faq.a1':'Elige una categoría y un estilo, sube tu foto y obtén una vista previa gratis con marca de agua en segundos. ¿Te encanta? Consigue el 4K (HD) sin marca de agua, o una impresión premium en póster, lienzo o metacrilato — sin necesidad de cuenta.',
  'faq.q2':'¿Qué foto funciona mejor?','faq.a2':'Primer plano nítido, buena luz. La luz natural de día es ideal.',
  'faq.q3':'¿Cuánto tarda la entrega?','faq.a3':'Digital justo tras la compra. Impresiones físicas: normalmente en tu puerta en los Países Bajos en 1–2 días laborables.',
  'faq.q4':'¿Y si no estoy del todo satisfecho?','faq.a4':'Cada retrato se hace individualmente para ti. ¿No del todo contento con tu vista previa? Toca «Repetir o editar»: vuelve a renderizar, elige otra foto o estilo, o describe tu ajuste con palabras. Antes de tu primera vista previa también puedes añadir una nota personal opcional. Cada nueva vista previa cuenta como un intento. ¿Necesitas más ayuda? Escríbenos a info@wallstraight.nl.',
  'faq.q5_multi':'¿Para qué sirven varias fotos?','faq.a5_multi':'Si ves “Añadir otra foto”, úsalo para personas distintas que deban aparecer juntas en un retrato. Subirte a ti mismo varias veces no es una forma admitida de mejorar el parecido y puede dar resultados extraños. Mira ¿Por qué? bajo tu foto para más detalle.',
  'cta.h2':'¿Listo para tu obra maestra?','cta.p':'Vista previa gratis en segundos.','cta.btn':'✦ Empieza ya — gratis',
  'ft.policy.shipping-policy':'Envíos','ft.policy.refund-policy':'Política de devoluciones','ft.policy.privacy-policy':'Política de privacidad','ft.policy.terms-of-service':'Términos del servicio',
    'ft.desc':'Arte de retrato con IA. Haarlem, Países Bajos.','ft.print_options':'Opciones de impresión','ft.browse_catalog':'Todos los productos','ft.info':'Información','ft.how':'Consejos','ft.gids':'Guía de retratos con IA','ft.bot':'Tappersweg 52, 2031 EV Haarlem, Países Bajos','ft.dig':'Digital',
  'tier.pop':'El más elegido','tier.gift':'Opción premium','tier.fmt':'Tamaño','tier.fin':'Acabado','tier.inc':'+ Incluye descarga digital',
  'finish.none':'Sin acabado','finish.none.glass':'Sin separadores','finish.eyebrow.poster':'Elige tu acabado','finish.eyebrow.canvas':'Elige tu marco','finish.eyebrow.glass':'Montaje','finish.total_estimate':'Total estimado',
  'finish.paid.photo_frame_30x40':'Marco de foto 30×40 cm','finish.paid.photo_frame_40x50':'Marco de foto 40×50 cm','finish.paid.photo_frame_50x70':'Marco de foto 50×70 cm',
  'finish.paid.poster_hanger':'Riel para colgar póster','finish.paid.box_frame_wood':'Marco flotante color madera','finish.paid.box_frame_black':'Marco flotante negro',
  'finish.paid.spacers':'Separadores','finish.paid.frame_wood':'Marco flotante color madera','finish.paid.frame_black':'Marco flotante negro',
  'finish.paid.hanger':'Riel para colgar','finish.paid.frame':'Marco de foto','finish.paid.spacers_kind':'Separadores',
  'tier.pf':'Sin marco','tier.pf2':'Con marco (+15 €)','tier.cf':'Sin marco','tier.cf2':'Con marco',
  'tier.nm.g':'Metacrilato',
  'tier.ul.p1':'Papel fotográfico premium','tier.ul.p2':'Tres tamaños disponibles','tier.ul.p3':'Envío gratis desde 50 € (NL y BE)','tier.ul.p4':'Incluye archivo digital',  'tier.ul.p5':'Entrega en 1–3 días laborables en NL y BE',
  'tier.ul.c1':'Listo para colgar al instante','tier.ul.c2':'Textura de lienzo de lujo','tier.ul.c3':'Envío gratis desde 50 € (NL y BE)','tier.ul.c4':'Incluye archivo digital','tier.ul.c5':'Entrega en 1–3 días laborables en NL y BE',
  'tier.ul.g1':'Metacrilato premium','tier.ul.g2':'Brillo de galería','tier.ul.g3':'Envío gratis desde 50 € (NL y BE)','tier.ul.g4':'Incluye archivo digital','tier.ul.g5':'Entrega en 1–3 días laborables en NL y BE',
  'tier.ul.d1':'Sin marca de agua (tras la compra)','tier.ul.d2':'Descarga justo tras pagar (correo/enlace)','tier.ul.d3':'Archivo 4K (HD)',
  'tier.btn.p':'Elegir póster','tier.btn.c':'Crear mi retrato en lienzo','tier.btn.g':'Elegir metacrilato','tier.btn.dl':'Descargar digital',
  'tier.dig.nm':'Solo digital','tier.dig.eyebrow':'¿Solo digital?','tier.dig.lede':'Recibe tu archivo 4K sin marca de agua justo tras la compra.','tier.dig.d':'Archivo 4K (HD) tras la compra — compártelo o imprímelo tú',
  'tier.desc.p':'Impresión fotográfica nítida de tu retrato de mascota.','tier.desc.c':'Lienzo premium con textura visible, listo para colgar.','tier.desc.g':'Metacrilato premium con color intenso, detalle nítido y un acabado brillante moderno.',
  'tier.mat_sample.canvas':'Primer plano de la textura del lienzo premium','tier.mat_sample.poster':'Primer plano del papel fotográfico del póster','tier.mat_sample.glass':'Primer plano: profundidad, brillo y separador del metacrilato',
  'tier.mat_preview.canvas':'Lienzo premium — muestra en la pared','tier.mat_preview.poster':'Póster — muestra enmarcada','tier.mat_preview.glass':'Metacrilato — acabado brillante de museo','tier.mat_preview.digital':'Digital — muestra en tablet',
  'tier.mat_sample.zoom_label.canvas':'Ampliar muestra de lienzo','tier.mat_sample.zoom_label.poster':'Ampliar muestra de póster','tier.mat_sample.zoom_label.glass':'Ampliar muestra de metacrilato','tier.mat_sample.zoom_label.digital':'Ampliar muestra digital',
  'tier.mat_sample.close':'Cerrar','tier.mat_sample.dialog_title':'Material y vista previa','tier.mat_sample.mat_link':'Ver todos los materiales','tier.mat_sample.sizes_label':'Tamaños disponibles',
  'sty.badge.staff_pick':'Selección del equipo','sty.badge.fan_favorite':'Favorito de los fans','sty.badge.trending':'Tendencia','sty.badge.new':'Nuevo',
  'res.share.h':'Comparte tu retrato','res.share.trust':'Lee reseñas en wallstraight.nl','res.share.sub':'Guárdalo para luego o compártelo con amigos y familia',
  'res.share.send':'Compartir','res.share.save':'Guardar para luego','res.share.save_aria':'Guardar para luego — envíate el enlace por correo',
  'res.recover.title':'Tu último retrato está listo','res.recover.continue':'Ver →','res.recover.continue_aria':'Abre tu último retrato y ve a pagar','res.recover.dismiss_aria':'Ocultar notificación',
  'res.recover.failed':'No pudimos restaurar tu retrato. El enlace no es válido o ha caducado.','res.recover.expired':'Este enlace de vista previa ha caducado. Crea un nuevo retrato.',
  'cart.chip_aria':'Ver carrito ({0})',
  'res.info1.h':'Lo que dicen los clientes','res.info1.p':'Lee reseñas en nuestra página de producto y a través de socios de reseñas.',
  'share.page_blurb':'Mira mi retrato con IA en Wallstraight.',
  'res.info2.h':'¿Necesitas ayuda?','res.info3.h':'Apoya a artistas reales','res.info3.p':'Wallstraight, de Atlantis Digital.',
  'res.info2.p':'info@wallstraight.nl — ¡Encantados de ayudar!',
});

/* Italian (it) — premium brand voice, informal-but-elegant "tu". Full
   merge-over-EN (missing keys inherit English). Typographic apostrophes (’)
   used for elisions to avoid single-quote escaping. */
WS_STR.it=Object.assign({},WS_STR.en,{
  'logo.tagline':'Arte del ritratto',
  'nav.shop_more':'Scopri di più','nav.how':'Consigli','nav.ex':'Esempi','nav.pr':'Prezzi','nav.cta':'Crea anteprima gratis','nav.cta_short':'Anteprima gratis',
  'nav.menu_open':'Menu','nav.menu_close':'Chiudi menu','nav.menu_title':'Navigazione',
  'wiz.ind1.title':'Categoria','wiz.ind2.title':'Stile','wiz.ind3.title':'Carica foto',
  'wiz.dots_nav_aria':'Avanzamento: crea il tuo ritratto',
  'wiz.breadcrumb_nav_aria':'Passaggi: categoria, stile, caricamento foto',
  'wiz.breadcrumb.s1':'Scegli categoria','wiz.breadcrumb.s2':'Scegli stile','wiz.breadcrumb.s3':'Carica foto',
  'wiz.breadcrumb.s1_aria':'Passo 1: scegli categoria','wiz.breadcrumb.s2_aria':'Passo 2: scegli stile','wiz.breadcrumb.s3_aria':'Passo 3: carica la foto',
  'wiz.step_n_of_m':'Passo {0} di {1}','wiz.back':'Indietro','wiz.back_aria':'Passo precedente',
  'wiz.chg_cat':'Cambia categoria','wiz.chg_cat_aria':'Vai al passo 1 per cambiare la categoria',
  'wiz.chg_style':'Cambia stile','wiz.chg_style_aria':'Vai al passo 2 per cambiare lo stile',
  'style.infer.selected_label':'Stile selezionato',
  'cat.infer.type_label':'Tipo di ritratto',
  'cat.infer.focus_label':'Focus','cat.infer.choose_focus':'Scegli focus','cat.infer.change_focus':'Cambia focus','cat.infer.change_focus_aria':'Cambia il focus del ritratto','cat.infer.done':'Fatto',
  'wiz.nav_aria':'Navigazione per passi',
  'wiz.summary.cat_lbl':'I. Categoria','wiz.summary.style_lbl':'II. Stile','wiz.summary.style_lbl_infer':'I. Stile','wiz.summary.photo_lbl':'III. Foto','wiz.summary.photo_lbl_infer':'II. Foto',
  'wiz.summary.not_chosen':'Non scelto','wiz.summary.photo_none':'Non caricata','wiz.summary.photo_ok':'Caricata',
  'wiz.summary.jump_cat_aria':'Vai al passo 1 per cambiare la categoria','wiz.summary.jump_style_aria':'Vai al passo 2 per cambiare lo stile','wiz.summary.upload_photo_aria':'Scegli una foto da caricare',
  'wiz.help1':'Scegli per chi è il ritratto.','wiz.next1':'Continua — scegli uno stile',
  'wiz.help2':'Scegli uno stile per il tuo ritratto.','wiz.next2':'Continua — carica la tua foto',
  'wizard.defaults_caption':'Tocca la categoria o lo stile nel riepilogo per cambiare la tua scelta.',
  'pill.huisdier':'Animali','pill.gezin':'Famiglie','pill.koppel':'Coppie','pill.kind':'Bambini','pill.zelf':'Autoritratto',
  'ex.before':'Prima','ex.step2_before_alt':'Esempio: foto originale','ex.step2_after_alt':'Esempio: risultato IA nello stile scelto',
  'upload.pick':'Scegli foto','upload.fmt':'JPG, PNG, WebP · Max 10MB','upload.chg':'Cambia foto','upload.rm':'✕ Rimuovi',
  'upload.reviews_aria':'Storie dei clienti','upload.reviews_dots_aria':'Scegli una storia','upload.review.dot_aria':'Vai alla storia {n} di {total}',
  'upload.review.claudia.who':'Claudia H.','upload.review.claudia.body':'Ha trovato la tela davvero bellissima — è rimasto a guardarla a lungo. È enorme e si vedeva comunque splendida, anche se la mia foto originale non era molto grande.',
  'upload.review.vic.who':'Victor L.','upload.review.vic.body':'Avete colto alla perfezione la giocosità di Nacho e apprezzo poter acquistare solo il file digitale.',
  'upload.review.nancy.who':'Nancy D.','upload.review.nancy.body':'Sono completamente soddisfatta del risultato. La nostra Bonnie è la principessa perfetta.',
  'upload.review.kween.who':'Mira S.','upload.review.kween.body':'Adoro questo sito! Non mi aspettavo che il pezzo consegnato fosse così mozzafiato e grande.',
  'upload.review.queenie.who':'Sophie V.','upload.review.queenie.body':'A mia madre di 80 anni è piaciuta tantissimo la sua trasformazione Reale! Il suo soprannome è Queenie, quindi vederla dipinta in abiti regali per il suo compleanno è stato l’omaggio perfetto.',
  'upload.review.after_wc':'Acquerello morbido','upload.review.unboxing.cta':'Prendi il tuo','upload.review.unboxing.alt':'Cliente che apre un ritratto incorniciato',
  'upload.add_more':'Aggiungi un’altra foto','upload.add_more_aria':'Aggiungi un’altra foto di riferimento (max 3 in totale)',
  'upload.role.person':'Persona','upload.role.pet':'Animale',
  'upload.remove_aria':'Rimuovi questa foto','upload.slots_aria':'Foto di riferimento aggiuntive',
  'tip.multi_photo.distinct_subjects':'Aggiungi ogni foto per una persona diversa che deve apparire insieme in un unico ritratto.',
  'tip.multi_photo.distinct_subjects_more':'Perché?',
  'tip.multi_photo.distinct_subjects_detail':'Se usi più di una foto, ognuna deve ritrarre una persona diversa — non più selfie di te stesso per “più nitidezza”. Non è supportato e può venire male.',
  'scene.legend.title':'Racconta la storia','scene.legend.hint':'Facoltativo: scegli come si sviluppa la scena',
  'scene.noble_lineage.title':'Nobile lignaggio','scene.noble_lineage.desc':'Corona al più grande; i più giovani come principi e principesse',
  'scene.court_of_equals.title':'Corte di pari','scene.court_of_equals.desc':'Tutte le figure come nobili di pari rango, senza un unico monarca',
  'scene.royal_romance.title':'Romanticismo reale','scene.royal_romance.desc':'La coppia come duca e duchessa in connessione regale',
  'scene.monarchs_pair.title':'Re e regina','scene.monarchs_pair.desc':'Due sovrani alla stessa altezza: mantello, corona e tiara',
  'scene.royal_heir_baby_prince.title':'Principe ereditario (neonato)','scene.royal_heir_baby_prince.desc':'Genitore/i con un neonato o bambino molto piccolo come principe ereditario',
  'scene.royal_heir_baby_princess.title':'Principessa ereditaria (neonata)','scene.royal_heir_baby_princess.desc':'Genitore/i con un neonato o bambina molto piccola come principessa ereditaria',
  'scene.royal_children_court.title':'Corte di bambini reali','scene.royal_children_court.desc':'Più principi e principesse, ognuno con il proprio abito di corte',
  'notes.toggle.title':'Aggiungi una nota personale (facoltativo)',
  'notes.label.hint':'Dicci tutto ciò che dovremmo sapere sul tuo ritratto. Lo usiamo come suggerimento extra durante la generazione.',
  'notes.placeholder':'es. ‘toni più caldi’ o ‘mio padre porta sempre gli occhiali’',
  'notes.clear':'Cancella',
  'pet.name.title':'Aggiungi il nome del tuo animale nel ritratto','pet.name.placeholder':'es. Luna','pet.name.confirm':'Rendigli onore','pet.name.skip':'Nessun nome nel ritratto','pet.name.edit_link':'Cambia o rimuovi il nome dal ritratto',
  'inscription.headline':'Aggiungi un nome','inscription.pet.title':'Inserisci il nome del tuo animale','inscription.pet.prompt':'Come si chiama il tuo animale?','inscription.solo.prompt':'Aggiungi un nome','inscription.group.prompt':'Aggiungi un cognome','inscription.bond.prompt':'Aggiungi un nome','inscription.subtitle':'Lo aggiungeremo con discrezione nell’angolo della tua opera, come una piccola firma da galleria.','inscription.placeholder.pet':'es. Luna','inscription.placeholder.solo':'es. Emma','inscription.placeholder.group':'es. Famiglia Rossi','inscription.confirm.empty':'Aggiungi nome','inscription.confirm.filled':'Usa “{name}”','inscription.confirm.pet.empty':'Rendigli onore','inscription.confirm.pet.filled':'Rendigli onore','inscription.skip':'Nessun testo nel mio ritratto','inscription.edit_link':'Aggiungi firma','inscription.edit_link.has_name':'Cambia firma','inscription.error.email':'Questo campo è per un nome nella tua opera, non per un indirizzo email.','inscription.error.url':'Non usare un link o un indirizzo web, solo un nome breve.','inscription.error.phone':'Non usare un numero di telefono, solo un nome breve.','inscription.error.message':'Tienilo breve: solo un nome (es. Emma o Famiglia Rossi).',
  'gen.btn':'Genera anteprima gratis',
  'hint.detect.no_face':'Nessun volto rilevato. Prova una foto più chiara o un’altra immagine.',
  'hint.detect.unknown':'Non siamo riusciti a verificare automaticamente chi è nella foto — genereremo in base alla tua categoria.',
  'hint.detect.ok_pet':'Ritratto di animale · pronto per lo stile.',
  'hint.detect.ok_solo_zelf':'1 persona rilevata · pronto per l’Autoritratto.',
  'hint.detect.ok_couple':'Due persone vanno bene · pronto per generare.',
  'hint.detect.ok_family':'Perfetto per Famiglie · pronto per generare.',
  'hint.detect.ok_kids':'Perfetto per Bambini · pronto per generare.',
  'hint.detect.ok_kids_adult_note':'Suggerimento: uno è adulto? Passa a Famiglie per l’inquadratura giusta.',
  'hint.detect.count_caveat':'I volti più piccoli (neonati, profili parziali, persone sullo sfondo) potrebbero non essere contati ma appariranno nel ritratto.',
  'hint.detect.solo_in_gezin':'Hai scelto Famiglie. Quella modalità funziona meglio quando più persone appaiono insieme in una foto.',
  'hint.detect.solo_in_koppel':'Hai scelto Coppie. Quella modalità funziona meglio con due persone insieme in una foto.',
  'hint.detect.solo_in_kind':'Hai scelto Bambini. Se è un bambino, continua; se è un adulto, passa ad Autoritratto. Il rilevamento automatico non distingue l’età.',
  'hint.detect.crowd_in_zelf':'In questa foto appare più di una persona, ma hai scelto Autoritratto, che si concentra su un solo soggetto. Scegli la categoria adatta al tuo gruppo (due persone, famiglia…), o continua se vuoi evidenziare un solo soggetto.',
  'hint.detect.crowd_in_koppel':'Hai scelto Coppie. Quella modalità è per due persone; Famiglie funziona meglio quando ne appaiono più di due in una foto.',
  'hint.detect.crowd_in_kind':'Sembra che tu abbia scelto Bambini. Famiglie dà il giusto spazio sia ai bambini sia agli adulti nel ritratto.',
  'hint.detect.pet_in_kind':'Questa sembra una foto di animale. Bambini è per i bambini — passa ad Animali per il miglior risultato.',
  'hint.detect.pet_in_zelf':'Questa sembra una foto di animale. Autoritratto è per le persone — passa ad Animali per il miglior risultato.',
  'hint.detect.pet_in_gezin':'Questa sembra una foto di animale. Famiglie è per le persone — passa ad Animali per il miglior risultato.',
  'hint.detect.pet_in_koppel':'Questa sembra una foto di animale. Coppie è per le persone — passa ad Animali per il miglior risultato.',
  'hint.detect.ok_zelf_person_pet':'Persona e animale rilevati · pronto per l’Autoritratto.',
  'hint.detect.mixed_in_kind':'Vediamo una persona E un animale in questa foto. Li vuoi entrambi nel tuo ritratto Bambini?',
  'hint.detect.mixed_in_gezin':'Vediamo una persona E un animale in questa foto. Li vuoi entrambi nel tuo ritratto di Famiglia?',
  'hint.detect.mixed_in_gezin_one_detected_person':'Hai scelto Famiglie con una persona visibile e un animale. Quella modalità può inventare persone non presenti nella foto. Valuta Autoritratto per te e il tuo animale, o genera se preferisci così.',
  'hint.detect.mixed_in_koppel':'Questa foto ha una persona e un animale, ma hai scelto Coppie (2 persone). L’IA potrebbe inventare una seconda persona inesistente. Prova “Tu + il tuo animale (Legame)” o “Autoritratto”.',
  'hint.detect.action_mixed_bond':'Includi entrambi (tu + il tuo animale)',
  'hint.detect.inversion_human':'I ritratti di animali celebrano prima gli animali e possono escludere le persone. Con Famiglie o Autoritratto, tutti nella tua foto restano insieme nell’inquadratura.',
  'hint.detect.keep':'Continua comunque',
  'hint.detect.keep_aria':'Continua con questa foto. Categoria, stile e trattamento restano uguali per ogni persona e animale dell’immagine.',
  'hint.baroque_nudge.body':'Per un ritratto naturale del cane in stile antichi maestri senza costume: scegli Secolo d’oro olandese.',
  'hint.baroque_nudge.action':'Scegli Secolo d’oro olandese','hint.baroque_nudge.dismiss':'Non ora',
  'quality.hint.too_dark':'Questa foto sembra piuttosto scura. Uno scatto più luminoso (vicino a una finestra o all’ombra all’aperto) dà un ritratto molto più forte.',
  'quality.hint.too_bright':'Questa foto sembra sovraesposta. Evita la luce solare diretta; la luce morbida della finestra è la migliore.',
  'quality.hint.too_blurry':'Questa foto sembra sfocata. Un primo piano nitido mantiene la somiglianza nel ritratto.',
  'quality.hint.face_too_small':'Il volto rilevato sembra lontano. Un’inquadratura più stretta (viso e spalle) dà il miglior ritratto.',
  'quality.hint.too_low_res':'Questa foto è a bassa risoluzione. Carica il file originale invece di uno screenshot o di una copia compressa.',
  'quality.hint.action_reupload':'Scegli un’altra foto','quality.hint.keep':'Continua comunque con questa foto',
  'tip.upload.heading':'Per il miglior ritratto',
  'tip.upload.s1':'Primo piano nitido del viso',
  'tip.upload.s2':'Luce morbida e naturale (vicino a una finestra o all’ombra all’aperto)',
  'tip.upload.s3':'Foto nitida e ad alta risoluzione — meglio il file originale',
  'loader.phase1':'Creazione dell’anteprima…','loader.phase2':'Applicazione dello stile…','loader.phase3':'Rifinitura dei dettagli…','loader.phase4':'Tocchi finali…',
  'loader.status.1':'Stiamo studiando la tua foto…','loader.status.2':'Preserviamo i tratti unici…','loader.status.3':'Applichiamo il tuo stile artistico…','loader.status.4':'Dipingiamo l’anteprima del tuo ritratto…','loader.status.5':'Rifiniamo i dettagli…','loader.status.6':'Diamo i tocchi finali…','loader.status.7':'Il tuo ritratto è quasi pronto…',
  'loader.status.hold':'Stiamo ancora lavorando al tuo ritratto — la qualità richiede un po’ di tempo.',
  'loader.poll.status.queued':'La tua anteprima è in coda — ci stiamo lavorando.',
  'loader.poll.status.rendering_head':'Stiamo renderizzando il tuo ritratto…',
  'loader.poll.status.rendering_sub.v1':'Non hanno avuto fretta con la Gioconda, e non l’avremo nemmeno col tuo.',
  'loader.poll.status.rendering_sub.v2':'Ci vuole un po’ più del previsto, ma la tua foto merita questa cura in più.',
  'loader.poll.status.rendering_sub.v3':'La nostra IA ora è perfezionista, molto appropriato per un capolavoro.',
  'loader.poll.status.rendering_sub.v4':'La tua opera riceve il suo ultimo strato di magia. Non è Da Vinci, ma ogni pennellata riceve attenzione da galleria.',
  'loader.poll.status.rendering_sub.v5':'Forse lo appenderai a casa, ma vogliamo che sia degno della parete di un museo.',
  'loader.part4.patience_sub':'Grazie per l’attesa — il tuo ritratto viene creato con cura speciale. Tieni aperta questa scheda mentre prepariamo l’anteprima finale.',
  'loader.part4.tap_reassure':'Il tuo ritratto è già in creazione. Toccare di nuovo non lo riavvia né lo accelera — aggiorneremo questa schermata automaticamente appena è pronto.',
  'loader.part4.long_wait_sub':'Stiamo ancora lavorando. La generazione premium può richiedere un po’ di più per preservare somiglianza, stile e dettaglio pronto per la stampa. Tieni aperta questa scheda o lascia la tua email e ti avvisiamo.',
  'loader.part4.long_wait_sub_captured':'Stiamo ancora lavorando. La generazione premium può richiedere un po’ di più per preservare somiglianza, stile e dettaglio pronto per la stampa. Tieni aperta questa scheda — ti avviseremo via email quando è pronto.',
  'loader.part4.already_generating':'Il tuo ritratto è già in creazione — attendi un momento.',
  'part4_notify.title':'Ci vuole un po’ più del previsto',
  'part4_notify.body':'Il tuo ritratto è ancora in elaborazione. Vuoi che ti avvisiamo via email appena è pronto?',
  'part4_notify.body_account':'Il tuo ritratto è ancora in elaborazione. Possiamo avvisare {email} quando questa anteprima è pronta.',
  'part4_notify.email_label':'Email','part4_notify.submit':'Avvisami quando è pronto','part4_notify.dismiss':'Continuo ad aspettare',
  'part4_notify.success_title':'Fatto','part4_notify.success_body':'Ti avviseremo via email quando il tuo ritratto è pronto. Puoi tenere aperta questa scheda.',
  'part4_notify.err_submit':'Non siamo riusciti a salvare la tua email. Riprova.',
  'loader.real.hope_working_aria':'Stiamo ancora lavorando al tuo ritratto',
  'loader.tap.still_working':'Stiamo ancora lavorando — tieni aperta questa scheda.',
  'loader.tap.still_working_escalation':'Il tuo ritratto è ancora in rendering. Aspettare evita un rendering duplicato.',
  'loader.title.accessible':'Creazione del tuo capolavoro','loader.title.lead':'reazione del tuo ','loader.title.em':'capolavoro',
  'loader.sub':'Anteprima gratis','loader.done':'Fatto!','loader.progress_aria':'Avanzamento dell’anteprima',
  'loader.late_hold':'Ci siamo quasi! Tieni aperta questa scheda.','loader.late_seq_craft':'Stiamo creando il tuo ritratto…','loader.late_seq_craft_pet':'Stiamo creando il ritratto del tuo animale…',
  'loader.status_rot_1':'Ci siamo quasi','loader.status_rot_2':'Fusione','loader.status_rot_3':'L’ironia','loader.status_rot_4':'Vero progresso',
  'loader.late_quote_1':'L’ironia è che rallentare ti porterà più lontano che correre.','loader.late_quote_2':'Il vero progresso è una base stabile, non una soluzione rapida.',
  'res.back':'← Indietro','res.steps_aria':'Passaggi','res.step1':'Carica','res.step2':'Anteprima','res.step3':'Download HD premium o stampa',
  'res.title':'Il tuo capolavoro è pronto!','res.sub':'Scegli il tuo formato qui sotto','res.checkout_h2':'La tua anteprima è pronta','res.finish_h2':'Scegli la finitura','res.jump.aria':'Vai alla finitura','res.jump.plexiglas':'Plexiglass','res.jump.poster':'Poster','res.jump.canvas':'Tela','res.jump.digital':'Download digitale','res.display.t':'Fatto per essere esposto','res.display.p':'Progettato per essere bellissimo sulla tua parete, non nascosto nel rullino del telefono.','res.checkout_lede':'Ogni opzione include il tuo file digitale. Stampe fisiche: entro 1–3 giorni lavorativi in NL e BE; spedizione gratis da 50 € (NL e BE).','res.checkout_trust_pet':'Senza filigrana dopo l’acquisto · Pagamento sicuro · Creato per il tuo animale','res.checkout_trust_people':'Senza filigrana dopo l’acquisto · Pagamento sicuro','res.retry':'Ripeti o modifica','res.delivery_bar':'Consegna in 1–3 giorni in NL e BE','res.preview_history':'Anteprime precedenti','inspire.eyebrow':'Un’altra idea?','inspire.cta':'Prova questa storia','inspire.victory_selfie.title':'Selfie della vittoria','inspire.victory_selfie.desc':'Celebra il momento subito dopo la vittoria — stesso sorriso, stessa atmosfera.','inspire.rooftop_heroes.title':'Tetti al tramonto','inspire.rooftop_heroes.desc':'Una scena cinematografica sul tetto nella luce dorata sopra la città.','inspire.sunset_guardians.title':'Guardiani del tramonto','inspire.sunset_guardians.desc':'La scena finale di un film epico — cielo dorato, mantello al vento.','inspire.above_clouds.title':'Sopra le nuvole','inspire.above_clouds.desc':'Vola come una leggenda sopra morbide nuvole dorate.','inspire.guardian_leap.title':'Il balzo del guardiano','inspire.guardian_leap.desc':'Cattura il movimento come un balzo eroico nella luce dorata.','inspire.protector_family.title':'Protettore della famiglia','inspire.protector_family.desc':'Un protettore devoto con calore eroico.',
  'maatkeuze.trigger':'Guida alle taglie','maatkeuze.title':'Guida alle taglie','maatkeuze.h_size':'Scegli la tua misura','maatkeuze.advice':'Sulla parete, un ritratto appare sempre un po’ più piccolo che sullo schermo. Indeciso tra due misure? Scegli la più grande — i nostri clienti si pentono quasi solo quando scelgono la più piccola, mai la più grande.','maatkeuze.close_aria':'Chiudi','maatkeuze.preview_alt':'Anteprima: ritratto su una parete in un interno classico','maatkeuze.l_hint_landscape':'Orizzontale','maatkeuze.none_enabled':'Nessuna misura acquistabile per questo materiale. Controlla la disponibilità o prova un’altra opzione.','maatkeuze.open_failed':'Impossibile aprire la guida alle taglie. Scegli una misura dal menu sopra.','maatkeuze.add_to_cart':'Aggiungi {0} al carrello','maatkeuze.cta_generate_first':'Crea prima la tua anteprima gratis','maatkeuze.cta_generating':'Generazione…','maatkeuze.need_preview':'Crea prima la tua anteprima gratis. Scegli uno stile e carica la tua foto — poi potrai ordinare questa misura.',
  'modal.close':'Chiudi',
  'welcome.title':'Approfitta del 20% di sconto','welcome.sub':'Inserisci la tua email e ricevi il tuo codice sconto personale per il primo ordine.',
  'welcome.email_label':'Email','welcome.email_ph':'tu@esempio.com','welcome.submit':'Inviami il codice',
  'welcome.success_title':'Il tuo codice','welcome.copy':'Copia codice','welcome.apply_cart':'Continua con il mio codice','welcome.choose_format':'Il tuo codice è salvato. Scegli un formato e aggiungi il ritratto al carrello.','welcome.cart_busy':'Il carrello si sta aggiornando. Riprova tra un momento.','welcome.cart_error':'Non siamo riusciti a controllare il carrello. Il codice è ancora salvato. Riprova.',
  'welcome.disclaimer':'Un solo utilizzo per cliente al pagamento. Se il codice non si applica, potresti aver già usato questa offerta.',
  'welcome.stack_hint':'Non combinabile con alcuni altri sconti. Scrivici se ti serve aiuto.',
  'welcome.err_network':'Connessione fallita. Riprova.','welcome.err_submit':'Registrazione fallita. Controlla l’email e riprova.',
  'welcome.err_captcha':'Controllo di sicurezza fallito. Ricarica la pagina e riprova, oppure usa l’iscrizione alla newsletter nel piè di pagina.',
  'welcome.err_wait':'Attendi un momento prima di inviare la tua email.','welcome.err_rate':'Troppi tentativi in questa finestra. Riprova più tardi.',
  'welcome.copied':'Codice copiato.','welcome.email_invalid':'Inserisci un’email valida.',
  'welcome.consent_required':'Conferma il consenso per continuare.',
  'welcome.consent_label':'Iscrivendoti accetti di ricevere email di marketing da WallStraight. Puoi annullare l’iscrizione quando vuoi.',
  'welcome.copy_manual':'Copia il codice manualmente (selezionalo sopra).',
  'studio_recovery.title':'Lo studio è al massimo della capacità.',
  'studio_recovery.body_p1':'Stiamo lavorando in fretta perché tutti ricevano il proprio bellissimo ritratto — te compreso.',
  'studio_recovery.body_p2':'Lascia la tua email qui sotto e ti avvisiamo quando siamo in pari, così potrai completare la generazione.',
  'studio_recovery.submit':'Avvisami','studio_recovery.try_again':'Riprova','studio_recovery.success_title':'Fatto!','studio_recovery.success_body':'Abbiamo salvato il tuo posto in coda. Ti contatteremo presto per completare il ritratto.','studio_recovery.success_ok':'Chiudi',
  'photo_recovery.title':'Non siamo riusciti a leggere questo file foto.',
  'photo_recovery.body_p1':'A volte una foto si apre sul telefono ma non può essere elaborata — comune con esportazioni o screenshot.',
  'photo_recovery.body_p2':'Carica un altro JPG, PNG o WebP, o lascia la tua email per consigli e follow-up (non genereremo il tuo ritratto automaticamente).',
  'photo_recovery.submit':'Avvisami','photo_recovery.try_again':'Scegli un’altra foto','photo_recovery.success_title':'Fatto!','photo_recovery.success_body':'Ti contatteremo con dei consigli. Puoi anche caricare subito un’altra foto.','photo_recovery.success_ok':'Chiudi',
  'retry.title':'Opzioni di ripetizione','retry.remaining_suffix':' anteprime rimaste in questo periodo · Ogni nuova conta come una',
  'retry.again.ttl':'Di nuovo','retry.again.desc':'Stesse impostazioni · Nuovo rendering',
  'retry.change_img.ttl':'Cambia immagine','retry.change_img.desc':'Nuova foto',
  'retry.style.ttl':'Cambia stile','retry.style.desc':'Torna al passo 2',
  'retry.startover.ttl':'Ricomincia','retry.startover.desc':'Scegli categoria · nuova foto',
  'retry.sep':'oppure descrivi una modifica qui sotto','retry.edit.ttl':'Descrivi la tua modifica','retry.edit.desc':'Colori, rimuovere elementi, ecc.',
  'retry.stronger.ttl':'Prova un rendering più forte','retry.stronger.desc':'Un’anteprima extra con un ancoraggio d’identità per questa categoria',
  'retry.text.placeholder':'es. ‘Scurisci lo sfondo’ o ‘Togli il cappello’','retry.apply':'Applica ✦',
  'retry.limit1':'Hai usato tutti i tentativi.','retry.limit2':'Scarica il tuo ritratto attuale o ordina una stampa!',
  'retry.no_photo':'Questa scheda non ha più la tua foto originale. Caricala di nuovo per generare una nuova anteprima.',
  'err.file_big':'Questo file supera i 10 MB. Usa un JPG, PNG o WebP più piccolo.',
  'err.file_type':'Usa una foto JPG, PNG o WebP.','err.file_read':'Non siamo riusciti a leggere questa foto. Prova un altro JPG, PNG o WebP.',
  'err.no_image':'Nessuna immagine restituita. Riprova.','err.decode':'Impossibile caricare l’immagine.',
  'toast.ready':'Tutto pronto!','toast.edit_empty':'Descrivi la tua modifica','toast.no_retries':'Nessun tentativo rimasto','toast.preview_restored':'Anteprima precedente ripristinata',
  'toast.link_copied':'Link copiato — incolla solo l’URL.',
  'toast.saved_link_copied':'Link copiato — incollalo in un’email a te stesso per tornare più tardi.',
  'toast.share_failed':'Impossibile condividere. Riprova.',
  'email.subject':'Il mio ritratto IA su Wallstraight',
  'email.body':'Ciao!\n\nHo appena creato un ritratto IA su Wallstraight. Guardalo qui:\n\n{url}\n\n— Inviato tramite Wallstraight',
  'generic_err':'Qualcosa è andato storto. Riprova tra un momento — la tua foto e le tue scelte sono ancora qui.',
  'err.unreachable':'Al momento non riusciamo a connetterci al servizio di anteprima. La tua foto e le tue scelte sono ancora salvate qui — riprova a breve.',
  'err.invalid_signature':'Il servizio di anteprima non è ancora collegato correttamente. Riprova più tardi.',
  'err.invalid_request':'Controlla la tua foto e riprova.',
  'err.rate_limited':'I nostri server sono molto carichi in questo momento: stiamo elaborando tante anteprime. Tutto è salvato in questa pagina; riprova tra un momento.',
  'err.quota_weekly':'Hai raggiunto il limite di anteprime gratis di questo periodo. Riprova più tardi o scrivici.',
  'err.quota_hard_cap':'È stato raggiunto il limite giornaliero di anteprime di questo negozio. Riprova più tardi.',
  'err.provider_error':'I nostri server sono molto carichi e lo studio sta recuperando. La tua foto e le tue scelte sono al sicuro in questa pagina — riprova a breve.',
  'err.billing_upstream':'Lo studio non può avviare la tua anteprima ora: abbiamo raggiunto una pausa temporanea di capacità presso il nostro fornitore IA. La tua foto non ha problemi — le tue scelte e il caricamento restano qui — riprova tra un momento.',
  'err.proxy_non_json':'Il tuo ritratto ha richiesto un po’ più di quanto la pagina potesse attendere. La tua foto è ancora qui — riprova tra un momento.',
  'err.http404':'Il servizio di anteprima non è ancora attivo in questo negozio. Riprova più tardi.',
  'err.http401':'Il servizio di anteprima non ha potuto verificare questa richiesta. Riprova più tardi.',
  'err.http413':'La tua foto è troppo grande da elaborare. Usa un JPG, PNG o WebP più piccolo.',
  'err.unexpected':'È successo qualcosa di inaspettato. Attendi un momento e riprova.',
  'err.bad_json':'Non siamo riusciti a elaborare la tua richiesta. Ricarica la pagina e riprova.',
  'err.missing_prompt':'Scegli uno stile prima di generare un’anteprima.',
  'err.missing_image':'Aggiungi una foto (JPG, PNG o WebP) e riprova.',
  'err.missing_style':'Prima scegli uno stile per il tuo ritratto.',
  'err.missing_category':'Prima scegli una categoria (per esempio animale o famiglia).',
  'err.unsupported_image_type':'Usa una foto JPG, PNG o WebP.',
  'err.image_too_large':'La tua foto supera i 10 MB. Usa un JPG, PNG o WebP più piccolo.',
  'err.image_decode_failed':'Non siamo riusciti a leggere la tua foto. Prova un altro JPG, PNG o WebP, o una versione più nitida della stessa foto.',
  'err.openai_unconfigured':'Il servizio di anteprima non è disponibile temporaneamente. Riprova a breve.',
  'err.internal_error':'Non siamo riusciti a completare la tua anteprima per un problema tecnico dalla nostra parte. Riprova.',
  'err.content_blocked':'Non possiamo elaborare questa foto o nota. Prova un’altra foto o riformula la nota.',
  'cart.open_product':'Apriremmo le impostazioni del prodotto per questo formato (solo ripiego quando la configurazione non è disponibile).',
  'cart.variant_missing':'Nessuna variante trovata per questo formato. Verifica che il prodotto configurato abbia le opzioni previste (Poster, Tela, Plexiglass, Digitale) e che l’handle del prodotto sia corretto.',
  'cart.ok':'Il tuo ritratto è stato aggiunto.','cart.fail':'Impossibile aggiungere al carrello. Riprova.','cart.oos':'Questo prodotto è esaurito o non disponibile.',
  'cart.error_checkout':'Non siamo riusciti ad aggiungerlo al carrello — spesso per disponibilità o stock.',
  'cart.checkout':'Vai al pagamento','cart.view_cart':'Vedi carrello','cart.adding':'Aggiunta…','cart.fab_aria':'Vai al pagamento','cart.remove_line':'Rimuovi','cart.update_fail':'Impossibile aggiornare il carrello. Riprova.',
  'cart.success_dlg_lede':'Pronto per il pagamento — ti aspetta il file HD o la stampa premium.',
  'cart.success.title.digital':'Il tuo download HD è nel carrello.','cart.success.title.physical':'Il tuo {0} è nel carrello.','cart.success.title.physical_finish':'Il tuo {0} con {1} è nel carrello.',
  'cart.success.lede.digital':'Pronto per il pagamento — ti aspetta il file senza filigrana.','cart.success.lede.physical':'Pronto per il pagamento — include il tuo file digitale.','cart.success.lede.physical_finish':'Pronto per il pagamento — la tua stampa e finitura attendono il pagamento.',
  'toast.dismiss':'Chiudi',
  'ann.a':'Anteprima gratis senza account','ann.b':'Spedizione gratis da 50 € in NL e BE','ann.d':'Pagamento sicuro',
  'wk.oranje.ann':'🇳🇱 Oranje passa agli eliminatori! Immortalati, tuo figlio o i tuoi amici in Oranje. Solo durante i Mondiali.',
  'wk.oranje.hero.eyebrow':'Edizione Mondiali 2026 · Limitata',
  'wk.oranje.hero.h1':'Tu, tuo figlio o i tuoi amici come Oranje sul muro',
  'wk.oranje.hero.h1_pre_first':'T',
  'wk.oranje.hero.h1_line1':'u, tuo figlio',
  'wk.oranje.hero.h1_line2':'o i tuoi amici come',
  'wk.oranje.hero.h1_line3':' sul muro',
  'wk.oranje.hero.lede':'Carica una foto e trasformala in un ritratto Oranje limitato — per serate partita, mancave, muri di famiglia e bambini calcistici.',
  'wk.oranje.hero.btn1':'Crea anteprima gratis',
  'wk.oranje.hero.btn2':'Vedi esempi',
  'wk.oranje.hero.proof':'⚡ Anteprima in 30 secondi · nessun account · stampato in NL',
  'wk.oranje.hero.series_pre':'Serie Oranje · ',
  'wk.oranje.hero.series_edition':'Edizione WK limitata',
  'wk.oranje.hero.gal1.badge':'Più venduto',
  'wk.oranje.hero.gal1.label':'Leggenda dello stadio','wk.oranje.hero.gal1.cap':'Oranje sul muro',
  'wk.oranje.hero.gal2.label':'Eroe Sticker','wk.oranje.hero.gal2.cap':'Look da collezione',
  'wk.oranje.hero.gal3.label':'Mancave','wk.oranje.hero.gal3.cap':'Ritratto premium',
  'wk.oranje.voor_wie.eye':'Per chi','wk.oranje.voor_wie.h2':'Per ogni tipo di tifoso',
  'wk.oranje.audience.child.title':'Per tuo figlio','wk.oranje.audience.child.desc':'Un piccolo eroe Oranje prima della finale',
  'wk.oranje.audience.self.title':'Per te','wk.oranje.audience.self.desc':'Sii il 12º uomo, immortalato',
  'wk.oranje.audience.mates.title':'Per i tuoi amici','wk.oranje.audience.mates.desc':'Una serata partita che merita il muro',
  'wk.oranje.audience.family.title':'Per la famiglia','wk.oranje.audience.family.desc':'Ricordi di calcio sopra il divano',
  'wk.oranje.audience.couple.title':'Per le coppie','wk.oranje.audience.couple.desc':'Ogni partita insieme',
  'wk.oranje.audience.pet.title':'Anche gli animali','wk.oranje.audience.pet.desc':'Restano animali — energia Oranje, mai un corpo umano',
  'wk.oranje.voor_wie.r5':'🐾 E sì, anche il tuo animale può partecipare',
  'wk.oranje.showcase.lbl':'Creato dai clienti',
  'wk.oranje.gallery.eye':'Esempi','wk.oranje.gallery.h2':'Così Oranje sta sul muro',
  'wk.oranje.gallery.lede':'Scegli uno stile. Scegli una foto. Noi creiamo la versione Oranje.',
  'wk.oranje.gallery.hover':'Genera questo stile',
  'wk.oranje.gallery.chip.mancave':'MANCAVE','wk.oranje.gallery.chip.gezin':'FAMIGLIA','wk.oranje.gallery.chip.kind':'BAMBINO','wk.oranje.gallery.chip.koppel':'COPPIA','wk.oranje.gallery.chip.moment':'MOMENTO',
  'wk.oranje.gallery.c1':'Bo e i ragazzi — serata partita in mancave',
  'wk.oranje.gallery.c2':'Famiglia de Vries — insieme per Oranje',
  'wk.oranje.gallery.c3':'Sven (8) — pronto per la finale',
  'wk.oranje.gallery.c4':'Lisa e Mark — ogni partita insieme',
  'wk.oranje.gallery.c5':'2-1! — il momento immortalato',
  'wk.oranje.styles.h2':'Scegli la tua edizione Oranje',
  'wk.oranje.style.panini':'Eroe sticker','wk.oranje.style.panini.desc':'Sticker collezionabile vintage — meglio in solo',
  'wk.oranje.style.stadion':'Leggenda dello stadio','wk.oranje.style.stadion.desc':'Ritratto sul campo illuminato — solo, bambini, famiglie o gruppi',
  'wk.oranje.style.vintage':'Poster vintage Oranje','wk.oranje.style.vintage.desc':'Mezzatinta retro — anche gruppi',
  'wk.oranje.style.mancave':'Ritratto mancave','wk.oranje.style.mancave.desc':'Ritratto premium scuro — solo o gruppi',
  'wk.oranje.style.disclaimer':'Gli esempi mostrano stile e atmosfera. La tua opera segue la tua foto, soggetti, posa e inquadratura.',
  'wk.oranje.gensec.eye':'Generatore Oranje','wk.oranje.gensec.h2':'Crea la tua opera Oranje',
  'wk.oranje.gensec.lede':'Carica te stesso, tuo figlio, i tuoi amici o la famiglia — e guarda l\'anteprima gratis.',
  'wk.oranje.how.eye':'Come funziona','wk.oranje.how.h2':'Dalla foto a Oranje sul muro in quattro passi',
  'wk.oranje.how.s1t':'1. Scegli la tua edizione Oranje','wk.oranje.how.s1d':'Sticker, stadio, vintage o mancave',
  'wk.oranje.how.s2t':'2. Carica la foto','wk.oranje.how.s2d':'Te stesso, tuo figlio o i tuoi amici',
  'wk.oranje.how.s3t':'3. Anteprima gratis','wk.oranje.how.s3d':'Subito, senza account',
  'wk.oranje.how.s4t':'4. Sul muro','wk.oranje.how.s4d':'Tela, poster o plexiglass',
  'wk.oranje.pr.eye':'Ordina','wk.oranje.pr.h2':'Appendilo prima della finale',
  'wk.oranje.pr.lede':'Ordinato oggi — sul muro questa settimana',
  'wk.oranje.pr.badge':'Più scelto',
  'wk.oranje.pr.canvas.nm':'Tela',
  'wk.oranje.pr.canvas.d':'Tela da galleria, pronta da appendere. Senza cornice.',
  'wk.oranje.pr.poster.nm':'Poster',
  'wk.oranje.pr.poster.d':'Carta opaca premium',
  'wk.oranje.pr.digital.nm':'Solo file digitale',
  'wk.oranje.pr.digital.d':'Solo un file — non sul muro',
  'wk.oranje.countdown.days':'{0} giorni',
  'wk.oranje.countdown.until':'fino alla finale',
  'wk.oranje.countdown.final_label':'Finale oggi',
  'wk.oranje.countdown.line':'{0} giorni e {1} ore alla finale (19 luglio 2026)',
  'wk.oranje.countdown.done':'Finale 19 luglio 2026 — ordina in tempo per appendere',
  'wk.oranje.trust.printed':'Stampato in NL',
  'wk.oranje.trust.checkout':'Pagamento sicuro · iDEAL',
  'wk.oranje.trust.shipping':'Spedizione gratis da 50 €',
  'wk.oranje.faq.q1':'Quanto tempo ci vuole?','wk.oranje.faq.a1':'Stampato in NL, di solito 3–5 giorni lavorativi — in tempo per la finale.',
  'wk.oranje.faq.q2':'Funziona con me o mio figlio?','wk.oranje.faq.a2':'Sì, ogni foto chiara funziona. Tutta la famiglia? Ordina più pezzi.',
  'wk.oranje.faq.q3':'Pago prima?','wk.oranje.faq.a3':'No — prima crea un\'anteprima gratis senza account.',
  'wk.oranje.faq.q4':'È davvero limitato?','wk.oranje.faq.a4':'L\'edizione Oranje solo durante i Mondiali 2026.',
  'wk.oranje.cta.h2':'Pronto a vederti in Oranje?','wk.oranje.cta.h2_pre':'Pronto a vederti in ','wk.oranje.cta.h2_mark':'Oranje','wk.oranje.cta.h2_post':'?','wk.oranje.cta.p':'Anteprima gratis in circa 30 secondi.','wk.oranje.cta.btn':'Crea la mia anteprima Oranje',
  'wk.oranje.ft.desc':'Edizione Oranje 2026 · Ritratto d\'arte limitato. Stampato nei Paesi Bassi.',
  'wk.oranje.ft.bot':'WallStraight · Edizione Oranje 2026 · Ritratto d\'arte limitato · Stampato nei Paesi Bassi.',
  'hero.badge':'Scelto da oltre 1.000 clienti','hero.h1.line1_lead':'rasforma il tuo animale','hero.h1.pre_first':'T','hero.h1.line2':' in un ritratto senza tempo','hero.h1.accessible':'Trasforma il tuo animale in un ritratto senza tempo.',
  'hero.p_lead':'Carica una foto e visualizza la tua anteprima gratis nel tuo stile preferito.','hero.p_em':' Nessun account richiesto.',
  'hero.btn1':'Crea anteprima gratis','hero.btn2':'Vedi esempi','hero.proof':'Poster da 29,95 € · Tela · Plexiglass · Digitale',
  'hero.gal1.p':'Ritratto di famiglia regalo','hero.gal2.p':'Ordinato su tela','hero.gal3.p':'Bambino e animale',
  'hero.gal1.alt':'Cliente a casa con un grande ritratto di famiglia reale su tela','hero.gal2.alt':'Cliente che tiene un ritratto di gatto ad acquerello su tela','hero.gal3.alt':'Bambino a casa con tela supereroe — bambino e golden retriever in volo nel cielo dorato',
  'hero.fin.eyebrow':'Sulla tua parete','hero.fin.aria':'Finiture sulla parete',
  'showcase.lbl':'Creato dai clienti',
  'gensec.eye':'Generatore IA','gensec.h2':'Crea il tuo capolavoro','gensec.lede':'Per compleanni, ricordi, nuove case, o semplicemente perché meritano di essere celebrati.',
  'trust.priv.t':'Privacy','trust.priv.d':'I tuoi caricamenti alimentano l’anteprima. Vedi la nostra informativa sulla privacy per i dettagli di conservazione.',
  'trust.fast.t':'Consegna rapida','trust.fast.d':'L’anteprima è di solito pronta in 15–30 secondi a seconda del carico.',
  'trust.rev.t':'Recensioni','trust.rev.d':'Recensioni verificate nel nostro negozio e tramite partner di recensioni.',
  'exsec.eye':'Esempi','exsec.h2':'Guarda la trasformazione','ba.orig':'Originale','ba.mini.wc':'Acquerello',
  'ba.c1.p':'Ritratto di animale con calma nordica','ba.c2.p':'Gatto in acquerello morbido','ba.c3.p':'Cane in stile grafico',
  'mat.eye':'Materiali','mat.h2':'Scegli la finitura adatta alla tua parete','mat.canvas':'Tela','mat.glass':'Plexiglass','mat.poster':'Poster',
  'mat.sizes_prefix':'Misure:','mat.brand_sub':'Arte del ritratto',
  'mat.canvas.alt':'Ritratto su tela appeso a una parete','mat.glass.alt':'Ritratto in plexiglass con distanziatori a parete','mat.poster.alt':'Poster incorniciato appeso a una parete',
  'stat.del':'Consegna','stat.del_note':'Di solito consegnato in NL in 1–2 giorni lavorativi','stat.sty':'Stili artistici','stat.fmt':'Tela · Poster · Plexiglass','stat.pre':'Gratis',
  'how.eye':'Dallo studio','how.h2':'Consigli per il tuo miglior ritratto','how.lede':'Una foto nitida e lo stile giusto fanno molto. Ecco cosa consigliamo prima di creare la tua anteprima gratis — e cosa viene dopo: un’anteprima con filigrana, 4K (HD) dopo l’acquisto, o una stampa premium come in negozio.',
  'how.s1t':'Foto: luce e nitidezza','how.s1p':'Usa un primo piano chiaro con luce morbida e naturale — evita ombre dure sul viso. Evita i grandangoli estremi; un’inquadratura tranquilla dà di solito il ritratto più forte.',
  'how.s2t':'Uno stile per la tua parete','how.s2p':'Ogni look ha il suo carattere: classico, morbido o grafico. Pensa alla tua stanza e all’atmosfera che vuoi; il blocco studio sopra ti aiuta a scegliere uno stile.',
  'how.s3t':'Anteprima, 4K e stampe','how.s3p':'Il tuo primo rendering è un’anteprima gratis con filigrana. Acquista 4K (HD) per rimuoverla. Lo vuoi alla parete? Scegli poster, tela o plexiglass — le stesse opzioni del nostro negozio.',
  'pr.eye':'Prezzi','pr.h2':'Scegli il tuo ritratto','pr.badge':'Il più scelto','pr.badge.premium':'Scelta premium','pr.from':'Da',
  'pr.promo_checkout_hint':'Sconto anniversario applicato automaticamente al pagamento.',
  'pr.pos.d':'Stampa fotografica nitida del tuo ritratto di animale.','pr.pos.btn':'Scegli poster',
  'pr.can.d':'Tela premium con texture visibile, pronta da appendere.','pr.can.btn':'Crea il mio ritratto su tela',
  'pr.gls.d':'Finitura lucida di lusso con profondità extra e dettaglio nitido.','pr.gls.btn':'Scegli plexiglass',
  'rev.eye':'Recensioni','rev.h2':'Cosa dicono i clienti',
  'rev.q1':'Il ritratto del nostro cane è incredibile — molto meglio del previsto.','rev.q2':'Un regalo per la nonna e si è commossa. Felice di aver scoperto Wallstraight. Il regalo-ritratto perfetto.','rev.q3':'Facilissimo. È il pezzo centrale del nostro salotto.',
  'rev.q4':'Sono un fotografo scettico — l’IA è strabiliante.','rev.q5':'La risata di mia sorella dice tutto — le è piaciuto tantissimo!','rev.q6':'Mia moglie è rimasta senza parole — fenomenale.',
  'rev.m1':'Animale · ✓ Verificato','rev.m2':'Famiglia · ✓ Verificato','rev.m3':'Animale · ✓ Verificato','rev.m4':'Autoritratto · ✓ Verificato','rev.m5':'Famiglie · ✓ Verificato','rev.m6':'Coppia · ✓ Verificato',
  'story.eye':'Fatto per chi è famiglia','story.h2':'Da amanti degli animali, per amanti degli animali.','story.body1':'Sappiamo che un ritratto di animale non è una decorazione qualsiasi. È il muso che ti accoglie alla porta, la piccola personalità che riempie la stanza e il ricordo che vuoi tenere vicino.','story.body2':'Per questo ogni ritratto Wallstraight è creato per sentirsi personale, espressivo e degno di un posto nella tua casa.',
  'story.card1.t':'La loro personalità conta','story.card1.p':'Gli occhi, l’espressione, i piccoli dettagli — vogliamo che il ritratto sembri ancora loro.','story.card1.alt':'Esempio di ritratto di animale che cattura personalità e somiglianza',
  'story.card2.t':'Fatto per essere esposto','story.card2.p':'Progettato per essere bellissimo sulla tua parete, non nascosto nel rullino del telefono.','story.card2.alt':'Esempio di ritratto esposto su una parete di casa',
  'story.card3.t':'Un regalo con sentimento','story.card3.alt':'Esempio di ritratto come regalo significativo',
  'story.cta':'Crea il tuo ritratto','story.unboxing.alt':'Cliente che apre un ritratto incorniciato',
  'faq.h2':'Domande frequenti','faq.eye':'FAQ','faq.q1':'Come funziona?','faq.a1':'Scegli una categoria e uno stile, carica la tua foto e ottieni un’anteprima gratis con filigrana in pochi secondi. Ti piace? Ottieni il 4K (HD) senza filigrana, o una stampa premium su poster, tela o plexiglass — senza bisogno di account.',
  'faq.q2':'Quale foto funziona meglio?','faq.a2':'Primo piano nitido, buona luce. La luce naturale del giorno è l’ideale.',
  'faq.q3':'Quanto è veloce la consegna?','faq.a3':'Digitale subito dopo l’acquisto. Stampe fisiche: di solito alla tua porta nei Paesi Bassi in 1–2 giorni lavorativi.',
  'faq.q4':'E se non sono del tutto soddisfatto?','faq.a4':'Ogni ritratto è realizzato individualmente per te. Non del tutto contento dell’anteprima? Tocca «Ripeti o modifica»: rigenera, scegli un’altra foto o stile, o descrivi la tua modifica a parole. Prima della prima anteprima puoi anche aggiungere una nota personale facoltativa. Ogni nuova anteprima conta come un tentativo. Serve aiuto? Scrivici a info@wallstraight.nl.',
  'faq.q5_multi':'A cosa servono più foto?','faq.a5_multi':'Se vedi “Aggiungi un’altra foto”, usalo per persone diverse che devono apparire insieme in un ritratto. Caricare te stesso più volte non è un modo supportato per una somiglianza più nitida e può dare risultati strani. Vedi Perché? sotto la tua foto per maggiori dettagli.',
  'cta.h2':'Pronto per il tuo capolavoro?','cta.p':'Anteprima gratis in pochi secondi.','cta.btn':'✦ Inizia ora — gratis',
  'ft.policy.shipping-policy':'Spedizioni','ft.policy.refund-policy':'Politica di reso','ft.policy.privacy-policy':'Informativa sulla privacy','ft.policy.terms-of-service':'Termini di servizio',
    'ft.desc':'Arte del ritratto con IA. Haarlem, Paesi Bassi.','ft.print_options':'Opzioni di stampa','ft.browse_catalog':'Tutti i prodotti','ft.info':'Info','ft.how':'Consigli','ft.gids':'Guida ai ritratti IA','ft.bot':'Tappersweg 52, 2031 EV Haarlem, Paesi Bassi','ft.dig':'Digitale',
  'tier.pop':'Il più scelto','tier.gift':'Scelta premium','tier.fmt':'Misura','tier.fin':'Finitura','tier.inc':'+ Include il download digitale',
  'finish.none':'Nessuna finitura','finish.none.glass':'Senza distanziatori','finish.eyebrow.poster':'Scegli la tua finitura','finish.eyebrow.canvas':'Scegli la tua cornice','finish.eyebrow.glass':'Montaggio','finish.total_estimate':'Totale stimato',
  'finish.paid.photo_frame_30x40':'Cornice 30×40 cm','finish.paid.photo_frame_40x50':'Cornice 40×50 cm','finish.paid.photo_frame_50x70':'Cornice 50×70 cm',
  'finish.paid.poster_hanger':'Asta per appendere poster','finish.paid.box_frame_wood':'Cornice flottante color legno','finish.paid.box_frame_black':'Cornice flottante nera',
  'finish.paid.spacers':'Distanziatori','finish.paid.frame_wood':'Cornice flottante color legno','finish.paid.frame_black':'Cornice flottante nera',
  'finish.paid.hanger':'Asta per appendere','finish.paid.frame':'Cornice','finish.paid.spacers_kind':'Distanziatori',
  'tier.pf':'Senza cornice','tier.pf2':'Con cornice (+15 €)','tier.cf':'Senza cornice','tier.cf2':'Con cornice',
  'tier.nm.g':'Plexiglass',
  'tier.ul.p1':'Carta fotografica premium','tier.ul.p2':'Tre misure disponibili','tier.ul.p3':'Spedizione gratis da 50 € (NL e BE)','tier.ul.p4':'Include file digitale',  'tier.ul.p5':'Consegna entro 1–3 giorni lavorativi in NL e BE',
  'tier.ul.c1':'Pronto da appendere subito','tier.ul.c2':'Texture di tela di lusso','tier.ul.c3':'Spedizione gratis da 50 € (NL e BE)','tier.ul.c4':'Include file digitale','tier.ul.c5':'Consegna entro 1–3 giorni lavorativi in NL e BE',
  'tier.ul.g1':'Plexiglass premium','tier.ul.g2':'Look lucido da galleria','tier.ul.g3':'Spedizione gratis da 50 € (NL e BE)','tier.ul.g4':'Include file digitale','tier.ul.g5':'Consegna entro 1–3 giorni lavorativi in NL e BE',
  'tier.ul.d1':'Senza filigrana (dopo l’acquisto)','tier.ul.d2':'Download subito dopo il pagamento (email/link)','tier.ul.d3':'File 4K (HD)',
  'tier.btn.p':'Scegli poster','tier.btn.c':'Crea il mio ritratto su tela','tier.btn.g':'Scegli plexiglass','tier.btn.dl':'Scarica digitale',
  'tier.dig.nm':'Solo digitale','tier.dig.eyebrow':'Solo digitale?','tier.dig.lede':'Ricevi il tuo file 4K senza filigrana subito dopo l’acquisto.','tier.dig.d':'File 4K (HD) dopo l’acquisto — condividilo o stampalo tu',
  'tier.desc.p':'Stampa fotografica nitida del tuo ritratto di animale.','tier.desc.c':'Tela premium con texture visibile, pronta da appendere.','tier.desc.g':'Plexiglass premium con colore intenso, dettaglio nitido e una moderna finitura lucida.',
  'tier.mat_sample.canvas':'Primo piano della texture della tela premium','tier.mat_sample.poster':'Primo piano della carta fotografica del poster','tier.mat_sample.glass':'Primo piano: profondità, lucentezza e distanziatore del plexiglass',
  'tier.mat_preview.canvas':'Tela premium — campione sulla parete','tier.mat_preview.poster':'Poster — campione incorniciato','tier.mat_preview.glass':'Plexiglass — finitura lucida da museo','tier.mat_preview.digital':'Digitale — campione su tablet',
  'tier.mat_sample.zoom_label.canvas':'Ingrandisci il campione di tela','tier.mat_sample.zoom_label.poster':'Ingrandisci il campione di poster','tier.mat_sample.zoom_label.glass':'Ingrandisci il campione di plexiglass','tier.mat_sample.zoom_label.digital':'Ingrandisci il campione digitale',
  'tier.mat_sample.close':'Chiudi','tier.mat_sample.dialog_title':'Materiale e anteprima','tier.mat_sample.mat_link':'Vedi tutti i materiali','tier.mat_sample.sizes_label':'Misure disponibili',
  'sty.badge.staff_pick':'Scelta del team','sty.badge.fan_favorite':'Preferito dai fan','sty.badge.trending':'Di tendenza','sty.badge.new':'Nuovo',
  'res.share.h':'Condividi il tuo ritratto','res.share.trust':'Leggi le recensioni su wallstraight.nl','res.share.sub':'Salvalo per dopo o condividilo con amici e famiglia',
  'res.share.send':'Condividi','res.share.save':'Salva per dopo','res.share.save_aria':'Salva per dopo — inviati il link via email',
  'res.recover.title':'Il tuo ultimo ritratto è pronto','res.recover.continue':'Vedi →','res.recover.continue_aria':'Apri il tuo ultimo ritratto e vai al pagamento','res.recover.dismiss_aria':'Nascondi notifica',
  'res.recover.failed':'Non siamo riusciti a ripristinare il tuo ritratto. Il link non è valido o è scaduto.','res.recover.expired':'Questo link di anteprima è scaduto. Crea un nuovo ritratto.',
  'cart.chip_aria':'Vedi carrello ({0})',
  'res.info1.h':'Cosa dicono i clienti','res.info1.p':'Leggi le recensioni sulla nostra pagina prodotto e tramite partner di recensioni.',
  'share.page_blurb':'Guarda il mio ritratto IA su Wallstraight.',
  'res.info2.h':'Serve aiuto?','res.info3.h':'Sostieni artisti veri','res.info3.p':'Wallstraight, di Atlantis Digital.',
  'res.info2.p':'info@wallstraight.nl — Felici di aiutare!',
});

const WS_STYLE_LABELS={
  nl:{
    royal:{nm:'Koninklijk',desc:'Hof & classics - hoogste conversie'},
    baroque:{nm:'Nederlandse Gouden Eeuw',desc:'Clair-obscur & olie - oude meesters'},
    watercolor:{nm:'Zachte aquarel',desc:'Warm, sentimenteel, herinnering'},
    popart:{nm:'Pop-art',desc:'Bold & grafisch - social-ready'},
    anime:{nm:'Anime‑inspired',desc:'Geïllustreerd - levendige kleuren, heldere lijnen'},
    nordic:{nm:'Noordse elegantie',desc:'Gedempte tinten, zacht daglicht - Scandi wall-art'},
    lineart:{nm:'Lijntekening',desc:'Minimalistisch, past overal'},
    superhero:{nm:'Superheld',desc:'Schilderachtige held — wandkunst'},
    vintage_fashion:{nm:'Vintage mode',desc:'Aquarel mode-kunst'},
    world_cup_football:{nm:'WK Voetbal',desc:'Schilderachtig stadionheld — wandkunst'},
  },
  en:{
    royal:{nm:'Royal / Renaissance',desc:'Court & oil - flagship look'},
    baroque:{nm:'Dutch Golden Age',desc:'Chiaroscuro oil - Old Master mood'},
    watercolor:{nm:'Soft watercolor',desc:'Gentle, sentimental, remembrance'},
    popart:{nm:'Pop art',desc:'Bold, graphic - social-ready'},
    anime:{nm:'Anime-inspired',desc:'Illustrated look - vivid colour & clean line art'},
    nordic:{nm:'Nordic calm',desc:'Muted tones & soft daylight - Scandinavian wall art'},
    lineart:{nm:'Line art',desc:'Minimal - fits any room'},
    superhero:{nm:'Superhero',desc:'Painterly hero wall art'},
    vintage_fashion:{nm:'Vintage fashion',desc:'Watercolor fashion-art'},
    world_cup_football:{nm:'World Cup Football',desc:'Painterly stadium hero wall art'},
  },
  es:{
    royal:{nm:'Real / Renacimiento',desc:'Corte y óleo — look insignia'},
    baroque:{nm:'Siglo de Oro neerlandés',desc:'Óleo en claroscuro — antiguos maestros'},
    watercolor:{nm:'Acuarela suave',desc:'Delicado, sentimental, recuerdo'},
    popart:{nm:'Pop art',desc:'Audaz y gráfico — listo para redes'},
    anime:{nm:'Inspiración anime',desc:'Look ilustrado — color vivo y línea limpia'},
    nordic:{nm:'Calma nórdica',desc:'Tonos suaves y luz natural — arte escandinavo'},
    lineart:{nm:'Línea',desc:'Minimalista — encaja en cualquier sala'},
    superhero:{nm:'Superhéroe',desc:'Arte de héroe pictórico'},
    vintage_fashion:{nm:'Moda vintage',desc:'Arte-moda en acuarela'},
    world_cup_football:{nm:'Copa del Mundo',desc:'Arte de héroe en el estadio'},
  },
  it:{
    royal:{nm:'Reale / Rinascimento',desc:'Corte e olio — look di punta'},
    baroque:{nm:'Secolo d’oro olandese',desc:'Olio in chiaroscuro — antichi maestri'},
    watercolor:{nm:'Acquerello morbido',desc:'Delicato, sentimentale, ricordo'},
    popart:{nm:'Pop art',desc:'Audace e grafico — pronto per i social'},
    anime:{nm:'Ispirazione anime',desc:'Look illustrato — colore vivido e linea pulita'},
    nordic:{nm:'Calma nordica',desc:'Toni tenui e luce naturale — arte scandinava'},
    lineart:{nm:'Linea',desc:'Minimal — si adatta a ogni stanza'},
    superhero:{nm:'Supereroe',desc:'Arte da eroe pittorico'},
    vintage_fashion:{nm:'Moda vintage',desc:'Arte-moda ad acquerello'},
    world_cup_football:{nm:'Mondiale calcio',desc:'Arte da eroe in stadio'},
  },
};

function wsClampLang(code){
  if(code==null||code==='')return null;
  const s=String(code).trim().split(/[-_]/)[0].toLowerCase();
  if(s==='en')return'en';
  if(s==='nl')return'nl';
  if(s==='el')return'el';
  if(s==='es')return'es';
  if(s==='it')return'it';
  return null;
}
/** Prefer Weglot or document lang when set; fall back to localStorage. */
function wsDetectLangFromProviders(){
  if(typeof window.Weglot!=='undefined'){
    try{
      const g=Weglot.getCurrentLang&&Weglot.getCurrentLang();
      const c=wsClampLang(g);
      if(c)return c;
    }catch(_){}
  }
  const fromHtml=wsClampLang(document.documentElement&&document.documentElement.getAttribute('lang'));
  if(fromHtml)return fromHtml;
  return wsGetLang();
}
function wsBindWeglot(){
  if(typeof window.Weglot==='undefined')return;
  try{
    const apply=(lng)=>{const x=wsClampLang(lng);if(x==='en'||x==='nl'||x==='el'||x==='es'||x==='it')wsApplyUiLang(x);};
    if(Weglot.on){
      Weglot.on('initialized',()=>apply(Weglot.getCurrentLang&&Weglot.getCurrentLang()));
      Weglot.on('languageChanged',apply);
    }
    if(Weglot.getCurrentLang){const cur=wsClampLang(Weglot.getCurrentLang());if(cur==='en'||cur==='nl'||cur==='el'||cur==='es'||cur==='it')wsApplyUiLang(cur);}
  }catch(_){}
}
/** Run after layout + delayed passes so late Weglot init / URL swaps still pick the right nl|en strings. */
function wsScheduleLangResync(){
  const sync=()=>{
    const lng=wsDetectLangFromProviders();
    if(lng==='en'||lng==='nl'||lng==='el'||lng==='es'||lng==='it')wsApplyUiLang(lng);
  };
  sync();
  [48,160,520,1400].forEach(ms=>setTimeout(sync,ms));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);
  window.addEventListener('load',sync);
}

function wsGetLang(){
  try{const s=localStorage.getItem(WS_LANG_STORAGE_KEY);if(s==='en'||s==='nl'||s==='el'||s==='es'||s==='it')return s;}catch(_){}
  return'nl';
}
/* i18n geo auto-language (Victor Jun 2026, plan i18n-3). Maps the Shopify
   storefront country (window.WS_GEO_COUNTRY) to a supported UI language on the
   FIRST visit only. Respects an explicit prior choice — a saved toggle
   (localStorage ws_ui_lang) or a Weglot cookie — so the shopper always wins
   (G3). Silent switch (G4): nl is the storefront default, so unmapped markets
   (and NL/BE) are a no-op; English markets, Spanish-speaking countries, and
   Italy get their native funnel UI. navigator.language is a soft fallback for
   markets we do not explicitly list. */
const WS_GEO_LANG_MAP={
  NL:'nl',BE:'nl',
  ES:'es',MX:'es',AR:'es',CO:'es',CL:'es',PE:'es',VE:'es',EC:'es',GT:'es',CU:'es',BO:'es',DO:'es',HN:'es',PY:'es',SV:'es',NI:'es',CR:'es',PA:'es',UY:'es',GQ:'es',
  IT:'it',SM:'it',VA:'it',
  GB:'en',US:'en',IE:'en',AU:'en',NZ:'en',CA:'en',ZA:'en',IN:'en',SG:'en',
};
function wsGeoSuggestLang(){
  try{
    /* G3 — explicit prior choice wins (saved toggle or Weglot cookie). */
    let saved=null;
    try{saved=localStorage.getItem(WS_LANG_STORAGE_KEY);}catch(_){}
    if(saved==='nl'||saved==='en'||saved==='el'||saved==='es'||saved==='it')return;
    if(typeof window!=='undefined'&&typeof window.Weglot!=='undefined'){
      try{if(wsClampLang(window.Weglot.getCurrentLang&&window.Weglot.getCurrentLang()))return;}catch(_){/* Weglot optional */}
    }
    const cc=String((typeof window!=='undefined'&&window.WS_GEO_COUNTRY)||'').trim().toUpperCase();
    let lang=cc?WS_GEO_LANG_MAP[cc]:null;
    /* Soft fallback: the browser's own language for unmapped markets. */
    if(!lang){
      const nav=wsClampLang(typeof navigator!=='undefined'&&navigator.language);
      if(nav==='es'||nav==='it'||nav==='en')lang=nav;
    }
    /* nl is the storefront default — no point re-applying it. */
    if(!lang||lang==='nl')return;
    wsApplyUiLang(lang);
  }catch(_){/* geo suggestion is best-effort, never blocks the funnel */}
}
function wsT(key){
  const lng=wsGetLang();
  const chain=lng==='en'?['en','nl']:lng==='el'?['el','en','nl']:lng==='es'?['es','en','nl']:lng==='it'?['it','en','nl']:['nl','en'];
  for(let i=0;i<chain.length;i++){
    const L=WS_STR[chain[i]];
    if(L&&L[key]!=null)return L[key];
  }
  return key;
}
/** Single hero codepath (Option A — EN morph retired): the first `.ws-hero-sr` is always the
 *  announced headline; the visual `.ws-hero-h1__lines` stack is decorative and
 *  `aria-hidden`. `lang` is accepted for caller compatibility (no per-lang branch). */
function wsSyncHeroH1A11y(lang){
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap)return;
  const sr=wrap.querySelector('.ws-hero-sr');
  const lines=wrap.querySelector('.ws-hero-h1__lines');
  if(sr)sr.removeAttribute('aria-hidden');
  if(lines)lines.setAttribute('aria-hidden','true');
}
/** Result checkout micro-trust row: pet-specific vs people portrait copy (depends on {@link S}.cat). */
function wsCheckoutTrustI18nKey(){
  return (typeof S!=='undefined'&&S&&S.cat==='huisdier')?'res.checkout_trust_pet':'res.checkout_trust_people';
}
function wsApplyCheckoutTrust(){
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap)return;
  const el=wrap.querySelector('.res-checkout-trust');
  if(!el)return;
  el.textContent=wsT(wsCheckoutTrustI18nKey());
}
/** Map transport failures to warm copy; never surface "Failed to fetch" to shoppers. */
function wsShopperSafeErrorMessage(err,fallback){
  if(wsLooksLikeBrowserNetworkFailure(err))return wsT('err.unreachable');
  return wsUserFacingMessage(err,fallback);
}
function wsLoaderMsgs(){
  return[wsT('loader.phase1'),wsT('loader.phase2'),wsT('loader.phase3'),wsT('loader.phase4')];
}
/** One message at a time in `#ldMsg` after ~85%: craft → almost there (halftone below `#ldMsg`); quotes removed — sequence stops on hold (see {@link WS_LOADER_LATE_STEP_COUNT}). */
function wsLoaderLateStepContent(step){
  if(step===0)return wsT(S&&S.cat==='huisdier'?'loader.late_seq_craft_pet':'loader.late_seq_craft');
  if(step===1)return wsT('loader.late_hold');
  return '';
}
function wsSyncLoaderMsgVisuals(step){
  const m=document.getElementById('ldMsg');
  if(!m)return;
  m.classList.remove('ld-msg--quote');
  m.classList.toggle('ld-msg--hold',step===1);
}

const S={file:null,b64:null,style:null,cat:null,busy:false,generateLock:false,generateIdempotencyKey:null,_generateIdempotencyFp:null,inFlightAsyncJobId:null,imgUrl:null,extraPrompt:'',/* R-FEED-2 — persistent first-run shopper notes. Survives across retries (only cleared explicitly via the panel's "Clear" button) so a refinement like "warmer tones" keeps shaping every reroll. Wired into `extraPrompt` as `User notes: …` only when no `User edit request: …` is queued (retry text wins). The 200-char cap is enforced both in the textarea (maxlength) and defensively in `wsApplyUserNotes` to match the sanitizer + retry budget. */userNotes:'',previewClientAttempt:0,lastJobId:'',lastPreviewUrl:'',petName:'',_pendingRetryExtraPrompt:null,previewHistory:[],baroqueNudgeDismissed:false,previewRemaining:null,faceCount:null,faceDetStatus:null,faceDetScore:null,faceDetName:null,faceDetCompletedAt:null,faceDetPromise:null,faceBoxes:null,faceDetPassStats:null,/* Track H (slice p2h-classifier) — pet-vs-human classifier verdict mirror for the primary slot. `null` = not classified yet; one of WS_SUBJECT_CLASSES once subjectClassPromise settles. */subjectClass:null,subjectClassStatus:null,/* Phase 2 / Slice P2.C — auxiliary signal. true when the primary slot's classifier saw a non-trivial pet bbox even when subjectClass='likely_human' (e.g. mom + cat in one photo). null until the classifier settles; false when no pet detected; true otherwise. Read by wsCategoryHintFromState (slice P2.D) and the wire visionMeta. */containsPetSubject:null,petClassifierMaxScore:null,/* R-AI-ONLY */aiVerifyPromise:null,aiVerifyResult:null,aiVerifyStatus:null,verifyCacheId:null,hintShownKey:null,hintAccepted:false,/* CAW.C — sticky true once the shopper explicitly clicks "Toch doorgaan" / "Continue anyway" on a category-hint banner. Distinguishes active dismissal from passive ignore so the wire `categoryHint.keptAfterWarn` field carries that nuance to the server's GenerationLog. Reset to false whenever the form state resets (`wsResetGeneratorState`) so a fresh upload starts clean. Server-side prompt is unchanged — TRUTH-IN-REFERENCE GUARD continues to fire on `accepted !== true`. */hintKeptAfterWarn:false,/* Phase 2 / Slice P2.D — opt-in composition flag set by wsAcceptMixedSubjectBond when the shopper clicks "Include both" on the mixed-subject banner. Default null (omit from wire). When 'mixed_single_photo' the generate POST carries compositionMode and the server (slice P2.E) routes to dual-subject treatment. */compositionMode:null,/* R-CAT-ROUTING (May 2026) — true once silent auto-route moved the shopper off Pets after `likely_human` detection; reset on new upload. */catAutoRouted:false,/* R-CAT-ROUTING — true when the shopper manually re-selects Pets after auto-route; suppresses re-auto-route for this upload. */catManualHuisdier:false,/* R-CAT-INFER Slice 2 — AI-inferred category mirrors (hidden-category funnel). */catInferredFromAi:false,catInferenceConfidence:null,catInferenceReason:null,catInferenceNeedsConfirm:false,catInferenceChoices:null,catInferMixedFocusOpen:false,catInferMixedFocusOpen:false,/* Phase 3 / Slice P3.A — primary-slot photo-quality mirrors. `qualityScore` is in [0,1] (1 = clean photo, 0 = ≥4 quality issues); `qualityReasons` is the union of canonical reason tokens (WS_QUALITY_REASONS) detected for the upload. Both stay `null` until `slot.qualityPromise` settles, then are populated by the wsCreateSlot mirror block (matching the subjectClass mirror precedent). UI consumers (Slice P3.B) read these to show contextual upload-quality banners; the wire visionMeta also carries them so the server can log them in ws_generation_meta and (Phase 4) gate auto-retry. */qualityScore:null,qualityReasons:null,/* Phase 3 / Slice P3.B — most-recent quality hint key surfaced by wsRenderQualityHint, mirrors the hintShownKey discipline used by the category hint. Lets the dismissed-state preserve across same-key re-renders and clear on content change. */qualityHintShownKey:null,slots:[],_slotIdSeq:0,/* Slice B.3 — royal scene-template picker; default mirrors server contract (undefined ≡ noble_lineage). */royalSceneTemplate:'noble_lineage',/* R-ROYAL-CLASSIC v17 — default premium-print pet Royal variant; fantasy remains opt-in via notes or future UI. */royalVariant:'classic',/* True after the shopper changes the scene radiogroup OR after a gezin/kind → koppel pivot while lineage/court stayed selected — suppresses the koppel+N=2 auto-default to royal_romance so parent+child on "Couple" can keep noble_lineage/court_of_equals. Cleared in wsClearUploadedPhoto. */royalSceneExplicitPick:false,/* R-PET-MULTI-2 (Layer A) — shopper-declared count of distinct companion animals in the reference photograph. Captured before prompt composition in `generate()` from `wsParseShopperAnimalCountFromNotes(S.userNotes)` so every prompt-builder consults the same number without re-parsing the notes string per call. `null` when the parser found no explicit "<N> dogs/cats/pets/honden/katten" pattern (R-MIX11: never claim a count we cannot back up). Forwarded on the wire as a top-level `shopperAnimalCount` integer; the worker re-validates via `readShopperAnimalCount`. */shopperAnimalCount:null};
/** Hard cap for awaiting browser face detection inside `generate()`. Beyond this we ship `visionMeta.detectionStatus = "timeout"` so the server still has signal but UX is not blocked on a slow device. Aligned with researcher plan §4 Phase A timing fix. */
const WS_FACE_DETECT_WAIT_MS=1500;
/**
 * Single-photo {@link wsResolveVisionMeta}: face → classifier → quality chain on
 * the same slot. One 1500ms cap on `Promise.allSettled` would often cut the
 * chain early vs the legacy three sequential {@link WS_FACE_DETECT_WAIT_MS}
 * races, omitting `subjectClass` / `qualityScore` on the wire and weakening
 * server hints — without improving prompt text. Match prior worst-case budget.
 */
const WS_VISION_META_SINGLE_PHOTO_MAX_MS=WS_FACE_DETECT_WAIT_MS*3;
/**
 * v2 (Track G/H) widened the wire format with optional `subjectClass` (top-level
 * + per-slot) so the storefront can tell the server "this looks like a pet"
 * even when the user picked a people category. v1 consumers (older app builds)
 * IGNORE the new field — `readVisionMeta` is a strict allow-list parser.
 *
 * Schema versions are monotonic + meaningful: bump only when the wire shape
 * grows (new optional field) or a value space changes. v1 = baseline (Slice
 * A.3). v2 = adds optional `subjectClass: 'likely_human' | 'likely_pet' |
 * 'unknown'` on `VisionMeta` and `VisionSlotMeta`. v3 (Phase 2 / Slice P2.C
 * — watercolor_family_gpt-image-1.5_febbcb2c §Phase 2 R-MIX1) = adds
 * optional `containsPetSubject: boolean` on both, an auxiliary signal
 * that says "this photo also has a non-trivial pet bbox" even when
 * `subjectClass='likely_human'`. v4 (Phase 3 / Slice P3.A — same plan
 * §Phase 3 R-FAB5) = adds optional `qualityScore: number ∈ [0,1]` and
 * `qualityReasons: string[]` on both, populated client-side from a
 * Canvas-based photo-quality scan (Laplacian-variance blur + mean-luma
 * brightness + largest-face-area ratio + native-resolution check).
 * v5 (May 2026) = optional `petClassifierMaxScore` (max dog/cat ObjectDetector
 * score, 0..1) for server tie-break when `containsPetSubject` is false.
 * Server tolerates v2–v5 payloads — `readVisionMeta` allow-lists each field.
 */
const WS_VISION_META_SCHEMA_VERSION=5;
/** Track G (slice p2g-detect): `@mediapipe/tasks-vision` FaceDetector WASM graph
 * is compiled for **short-range** BlazeFace (**896** anchor boxes). Loading the
 * `blaze_face_full_range.tflite` weights into that graph crashes at runtime with
 * `TensorsToDetectionsCalculator ... raw_box_tensor ... (2304 vs. 896)` — full-
 * range tensors encode **2304** anchors (verified user console 2026-05-10). Until
 * Google ships a Tasks Vision bundle whose graph matches full-range outputs,
 * we **must** keep the sanctioned short-range model URL below (npm FaceDetector
 * examples). Small-face / infant recall leans on **multi-scale upscale pass** +
 * IoU merge + tuned `minDetectionConfidence`, not on swapping weights alone.
 */
const WS_FACE_DETECTOR_NAME='mediapipe_face_detector_blaze_short_range';
/** Server `PET_CLASSIFIER_MIXED_SIGNAL_MIN` mirror — relaxed pet score floor when N≤2 faces + likely_human (R-BOND-IMPLICIT-2FACE follow-up). */
const WS_PET_MIXED_SIGNAL_MIN=0.32;
/** Sanctioned `subjectClass` values forwarded with `visionMeta` (schema v2,
 * Track H). The classifier itself lands in a later slice — slice 1 only widens
 * the wire shape so server + dev-proxy parsers can already accept it. */
const WS_SUBJECT_CLASSES=Object.freeze({HUMAN:'likely_human',PET:'likely_pet',UNKNOWN:'unknown'});
const uz=$('#uz'),fi=$('#fileIn'),prev=$('#preview'),genBtn=$('#genBtn'),errBox=$('#errBox');
/** Inline #errBox was below the fold on mobile; user-facing errors use the fixed toast. */
function wsToastHideIfError(){
  const el=$('#toast');
  if(el&&el.dataset.toastType==='error')wsToastHide();
}
function showErr(m){
  const msg=String(m||'').trim();
  if(errBox){errBox.textContent='';errBox.classList.remove('show');}
  if(!msg)return;
  const len=msg.length;
  const dur=Math.min(16000,Math.max(7000,5200+Math.floor(len/3)));
  wsToastShow({type:'error',message:msg,duration:dur});
}
function hideErr(){
  if(errBox){errBox.textContent='';errBox.classList.remove('show');}
  wsToastHideIfError();
}
let tt;
function wsToastHide(){
  clearTimeout(tt);
  tt=undefined;
  const el=$('#toast');
  if(!el)return;
  el.classList.remove('show');
}
function wsCartPageHref(){
  if(typeof window.WS_ROUTES==='object'&&window.WS_ROUTES&&typeof window.WS_ROUTES.cart==='string'&&window.WS_ROUTES.cart.trim())
    return window.WS_ROUTES.cart.trim();
  const b=String(wsShopRoot()||'/').replace(/\/$/,'');
  return(b||'')+'/cart';
}
/** Results FAB: cart page fallback when JS disabled; drawer opens via data-ws-cart-drawer-trigger. */
function wsSyncResCartFabHref(){
  const fab=document.getElementById('wsResCartFab');
  if(!fab)return;
  try{fab.setAttribute('href',wsCartPageHref());}catch(_){/* no-op */}
}

/** Shopify cart `item_count` / line `quantity` — same semantics as Liquid `cart.item_count` (https://shopify.dev/docs/api/liquid/objects/cart#cart-item_count). */
function wsSetResCartFabBadgeCount(n){
  const fab=document.getElementById('wsResCartFab');
  const badge=document.getElementById('wsResCartBadge');
  if(!badge)return;
  let v=typeof n==='number'&&Number.isFinite(n)?Math.round(n):NaN;
  if(!Number.isFinite(v))return;
  if(v<0)v=0;
  badge.textContent=v>99?'99+':String(v);
  badge.hidden=v===0;
  badge.setAttribute('aria-hidden','true');
  if(fab){
    const show=v>0;
    fab.hidden=!show;
    if(show)fab.removeAttribute('hidden');
    fab.setAttribute('aria-hidden',show?'false':'true');
    if(show){
      try{
        const label=wsT('cart.chip_aria').replace('{0}',String(v>99?'99+':v));
        fab.setAttribute('aria-label',label);
      }catch(_){/* i18n best-effort */}
    }
  }
}

/** Parse count from Ajax cart JSON: prefer `item_count`, else Σ `items[].quantity`. */
function wsCartItemCountFromParsedCartJson(data){
  if(!data||typeof data!=='object')return NaN;
  const raw=data.item_count;
  if(typeof raw==='number'&&Number.isFinite(raw))return Math.max(0,Math.round(raw));
  if(!Array.isArray(data.items))return NaN;
  let sum=0;
  let any=false;
  let i,q,n;
  for(i=0;i<data.items.length;i++){
    q=data.items[i]&&data.items[i].quantity;
    n=(typeof q==='number'&&Number.isFinite(q))?q:parseInt(String(q==null?'':q),10);
    if(Number.isFinite(n)){sum+=Math.max(0,Math.round(n));any=true;}
  }
  return any?sum:NaN;
}

/** `GET …/cart.js` — docs: shopify.dev/docs/api/ajax/reference/cart (GET cart.js). */
async function wsRefreshResCartFabBadge(){
  if(!document.getElementById('wsResCartBadge'))return;
  try{
    const res=await fetch(wsCartJsUrl(),{credentials:'same-origin',headers:{Accept:'application/json'}});
    if(!res.ok)return;
    const data=await res.json();
    const n=wsCartItemCountFromParsedCartJson(data);
    if(Number.isFinite(n))wsSetResCartFabBadgeCount(n);
  }catch(_){/* offline / transient */}
}

/** Prefer `parsed.item_count` from successful `cart/add.js` (bundled response includes full cart JSON per Shopify Ajax Cart docs). */
function wsApplyResCartFabBadgeFromCartAdd(parsed){
  if(!parsed||typeof parsed!=='object')return false;
  const n=wsCartItemCountFromParsedCartJson(parsed);
  if(!Number.isFinite(n))return false;
  wsSetResCartFabBadgeCount(n);
  return true;
}

(function wsBindResCartFabLifecycle(){
  const bump=()=>{
    const rp=document.getElementById('resPage');
    if(!rp||!rp.classList.contains('show'))return;
    void wsRefreshResCartFabBadge();
  };
  document.addEventListener('visibilitychange',()=>{
    if(document.hidden)return;
    bump();
  });
  window.addEventListener('pageshow',bump);
})();
function wsStoreCheckoutUrl(){
  const r=String(wsShopRoot()||'/');
  if(/^https?:\/\//i.test(r))return r.replace(/\/+$/,'')+'/checkout';
  const b=r.replace(/\/+$/,'');
  return(b||'')+'/checkout';
}
/** Shareable discount URL — Shopify applies code then redirects (help.shopify.com — managing discount codes, share link). */
function wsDiscountApplyUrl(code,redirectPath){
  const c=String(code||'').trim();
  if(!c)return'#';
  const root=String(wsShopRoot()||'/').replace(/\/$/,'');
  const r=String(redirectPath||'/cart');
  const path=r.startsWith('/')?r:'/'+r;
  return root+'/discount/'+encodeURIComponent(c)+'?redirect='+encodeURIComponent(path);
}
/** Same-origin checkout URL via `Shopify.routes.root` — never `shop.url` primary domain (breaks myshopify dev/preview carts). */
function wsCheckoutPageHref(){
  const fromRoutes=(typeof window.WS_ROUTES==='object'&&window.WS_ROUTES&&typeof window.WS_ROUTES.checkout==='string')?window.WS_ROUTES.checkout.trim():'';
  if(fromRoutes&&fromRoutes.charAt(0)==='/')return fromRoutes;
  return wsStoreCheckoutUrl();
}
/** Checkout CTA target — mirrors welcome-offer discount URL used by cart success UI. */
function wsCartSuccessCheckoutHref(){
  const unlocked=wsWelcomeOfferIsUnlocked();
  const cfg=typeof window.WS_WELCOME_OFFER==='object'&&window.WS_WELCOME_OFFER?window.WS_WELCOME_OFFER:null;
  const code=cfg&&String(cfg.discountCode||'').trim();
  const useDisc=!!(unlocked&&code);
  return useDisc?wsDiscountApplyUrl(code,'/checkout'):wsCheckoutPageHref();
}
const WS_WELCOME_SESSION_DONE='ws_welcome_offer_done';
const WS_WELCOME_SESSION_UNLOCKED='ws_welcome_offer_unlocked';
const WS_WELCOME_REVEALED_AT='ws_welcome_offer_revealed_at';
const wsWelcomeOfferState={timerId:null,scrollHandler:null,deferredCheckId:null,armEpoch:0,lastFocus:null,modalShownAt:0,checkoutBusy:false,checkoutEpoch:0,checkoutController:null,unlocked:false};
const WS_WELCOME_RL_ATTEMPTS='ws_welcome_offer_rl';
const WS_WELCOME_MIN_DWELL_MS=2500;
const WS_WELCOME_RL_WINDOW_MS=3600000;
const WS_WELCOME_RL_MAX=8;
const wsStudioRecoveryState={modalShownAt:0,lastFocus:null,variant:'capacity',capture:null};
const WS_STUDIO_RECOVERY_MODAL_TS='ws_studio_recovery_modal_ts';
const WS_STUDIO_RECOVERY_RL_ATTEMPTS='ws_studio_recovery_rl';
const WS_STUDIO_RECOVERY_RL_WINDOW_MS=3600000;
const WS_STUDIO_RECOVERY_RL_MAX=8;
const WS_STUDIO_RECOVERY_MODAL_COOLDOWN_MS=45000;
function wsWelcomeOfferMinDwellMs(){
  if(typeof window!=='undefined'&&window.__WS_CONTRACT_TEST__===true)return 0;
  return WS_WELCOME_MIN_DWELL_MS;
}
function wsWelcomeOfferRateLimitOk(){
  try{
    const raw=sessionStorage.getItem(WS_WELCOME_RL_ATTEMPTS);
    const arr=raw?JSON.parse(raw):[];
    const now=Date.now();
    const recent=arr.filter(t=>typeof t==='number'&&now-t<WS_WELCOME_RL_WINDOW_MS);
    return recent.length<WS_WELCOME_RL_MAX;
  }catch(_){
    return true;
  }
}
function wsWelcomeOfferRateLimitRecord(){
  try{
    const raw=sessionStorage.getItem(WS_WELCOME_RL_ATTEMPTS);
    const arr=raw?JSON.parse(raw):[];
    const now=Date.now();
    const recent=(Array.isArray(arr)?arr:[]).filter(t=>typeof t==='number'&&now-t<WS_WELCOME_RL_WINDOW_MS);
    recent.push(now);
    sessionStorage.setItem(WS_WELCOME_RL_ATTEMPTS,JSON.stringify(recent));
  }catch(_){}
}
function wsStudioRecoveryRateLimitOk(){
  try{
    const raw=sessionStorage.getItem(WS_STUDIO_RECOVERY_RL_ATTEMPTS);
    const arr=raw?JSON.parse(raw):[];
    const now=Date.now();
    const recent=arr.filter(t=>typeof t==='number'&&now-t<WS_STUDIO_RECOVERY_RL_WINDOW_MS);
    return recent.length<WS_STUDIO_RECOVERY_RL_MAX;
  }catch(_){
    return true;
  }
}
function wsStudioRecoveryRateLimitRecord(){
  try{
    const raw=sessionStorage.getItem(WS_STUDIO_RECOVERY_RL_ATTEMPTS);
    const arr=raw?JSON.parse(raw):[];
    const now=Date.now();
    const recent=(Array.isArray(arr)?arr:[]).filter(t=>typeof t==='number'&&now-t<WS_STUDIO_RECOVERY_RL_WINDOW_MS);
    recent.push(now);
    sessionStorage.setItem(WS_STUDIO_RECOVERY_RL_ATTEMPTS,JSON.stringify(recent));
  }catch(_){}
}
function wsStudioRecoveryModalCooldownOk(){
  try{
    const t=parseInt(sessionStorage.getItem(WS_STUDIO_RECOVERY_MODAL_TS)||'0',10)||0;
    return !t||(Date.now()-t>=WS_STUDIO_RECOVERY_MODAL_COOLDOWN_MS);
  }catch(_){
    return true;
  }
}
function wsStudioRecoveryModalCooldownTouch(){
  try{sessionStorage.setItem(WS_STUDIO_RECOVERY_MODAL_TS,String(Date.now()));}catch(_){}
}
function wsWelcomeOfferCfg(){
  const c=typeof window.WS_WELCOME_OFFER==='object'&&window.WS_WELCOME_OFFER?window.WS_WELCOME_OFFER:null;
  if(!c||c.enabled===false)return null;
  const delay=Number(c.delayMs);
  return{
    delayMs:Number.isFinite(delay)&&delay>=0?delay:10000,
    discountCode:String(c.discountCode||'WELCOME20').trim()||'WELCOME20',
    requireConsent:c.requireConsent!==false,
    consentLabel:String(c.consentLabel||'').trim(),
    suppressDays:Math.max(0,Math.floor(Number(c.suppressDays)||0)),
    customerEmail:String(c.customerEmail||'').trim()
  };
}
function wsStudioRecoveryCfg(){
  const c=typeof window.WS_STUDIO_RECOVERY==='object'&&window.WS_STUDIO_RECOVERY?window.WS_STUDIO_RECOVERY:null;
  if(!c||c.enabled===false)return null;
  return{
    requireConsent:c.requireConsent!==false,
    consentLabel:String(c.consentLabel||'').trim(),
    customerEmail:String(c.customerEmail||'').trim(),
    customerId:c.customerId!=null&&c.customerId!==''?String(c.customerId).trim():'',
    capacityContactTags:String(c.capacityContactTags||'newsletter,studio-recovery').trim(),
    photoRecoveryContactTags:String(c.photoRecoveryContactTags||'newsletter,photo-decode-recovery').trim()
  };
}
function wsRecoveryI18nPrefix(variant){
  return variant==='photo_decode'?'photo_recovery':'studio_recovery';
}
function wsRecoverySyncVariantCopy(variant){
  const p=wsRecoveryI18nPrefix(variant);
  const title=$('#studioRecoveryTitle');
  if(title){title.textContent=wsT(p+'.title');title.setAttribute('data-i18n',p+'.title');}
  const subs=document.querySelectorAll('#studioRecoveryPanelForm .sub');
  if(subs[0]){subs[0].textContent=wsT(p+'.body_p1');subs[0].setAttribute('data-i18n',p+'.body_p1');}
  if(subs[1]){subs[1].textContent=wsT(p+'.body_p2');subs[1].setAttribute('data-i18n',p+'.body_p2');}
  const subBtn=$('#studioRecoverySubmit');
  if(subBtn){subBtn.textContent=wsT(p+'.submit');subBtn.setAttribute('data-i18n',p+'.submit');}
  const tryA=$('#studioRecoveryTryAgain');
  if(tryA){tryA.textContent=wsT(p+'.try_again');tryA.setAttribute('data-i18n',p+'.try_again');}
  const okPanel=$('#studioRecoveryPanelSuccess');
  if(okPanel){
    const okTitle=okPanel.querySelector('h3');
    const okBody=okPanel.querySelector('.sub');
    if(okTitle){okTitle.textContent=wsT(p+'.success_title');okTitle.setAttribute('data-i18n',p+'.success_title');}
    if(okBody){okBody.textContent=wsT(p+'.success_body');okBody.setAttribute('data-i18n',p+'.success_body');}
    const okB=$('#studioRecoverySuccessOk');
    if(okB){okB.textContent=wsT(p+'.success_ok');okB.setAttribute('data-i18n',p+'.success_ok');}
  }
  const cfg=wsStudioRecoveryCfg();
  const form=document.getElementById('wsStudioRecoveryCustomerForm');
  const tagInput=form&&form.querySelector('input[name="contact[tags]"]');
  if(tagInput&&cfg){
    tagInput.value=variant==='photo_decode'?cfg.photoRecoveryContactTags:cfg.capacityContactTags;
  }
}
function wsWelcomeOfferSessionDone(){
  try{return sessionStorage.getItem(WS_WELCOME_SESSION_DONE)==='1';}catch(_){return false;}
}
function wsWelcomeOfferSetSessionDone(){
  try{sessionStorage.setItem(WS_WELCOME_SESSION_DONE,'1');}catch(_){}
}
function wsWelcomeOfferIsUnlocked(){
  if(wsWelcomeOfferState.unlocked)return true;
  try{return sessionStorage.getItem(WS_WELCOME_SESSION_UNLOCKED)==='1';}catch(_){return false;}
}
function wsWelcomeOfferSetUnlocked(){
  wsWelcomeOfferState.unlocked=true;
  try{sessionStorage.setItem(WS_WELCOME_SESSION_UNLOCKED,'1');}catch(_){}
}
function wsWelcomeOfferSupLongTerm(cfg){
  if(!cfg||cfg.suppressDays<=0)return false;
  let ts=0;
  try{ts=parseInt(localStorage.getItem(WS_WELCOME_REVEALED_AT)||'0',10)||0;}catch(_){}
  if(!ts)return false;
  return(Date.now()-ts)<cfg.suppressDays*86400000;
}
function wsWelcomeOfferMarkRevealed(){
  try{localStorage.setItem(WS_WELCOME_REVEALED_AT,String(Date.now()));}catch(_){}
}
function wsWelcomeOfferOtherUIBlocking(){
  const ld=$('#ld'),rm=$('#retryModal'),pm=$('#petNameModal'),sr=$('#studioRecoveryModal');
  if(ld&&ld.classList.contains('show'))return true;
  if(rm&&rm.classList.contains('show'))return true;
  if(pm&&pm.classList.contains('show'))return true;
  if(sr&&sr.classList.contains('show'))return true;
  return false;
}
function wsWelcomeOfferDisarmTimers(){
  if(wsWelcomeOfferState.timerId){
    clearTimeout(wsWelcomeOfferState.timerId);
    wsWelcomeOfferState.timerId=null;
  }
  if(wsWelcomeOfferState.scrollHandler){
    try{window.removeEventListener('scroll',wsWelcomeOfferState.scrollHandler,{capture:true});}catch(_){}
    wsWelcomeOfferState.scrollHandler=null;
  }
  if(wsWelcomeOfferState.deferredCheckId){
    clearInterval(wsWelcomeOfferState.deferredCheckId);
    wsWelcomeOfferState.deferredCheckId=null;
  }
}
function wsWelcomeOfferDisarm(){
  wsWelcomeOfferDisarmTimers();
}
function wsWelcomeOfferSyncMerchantCopy(){
  const cfg=wsWelcomeOfferCfg();
  const el=document.getElementById('welcomeOfferConsentText');
  if(!el)return;
  if(cfg&&cfg.requireConsent)el.textContent=cfg.consentLabel?cfg.consentLabel:wsT('welcome.consent_label');
  else el.textContent='';
  const wrap=document.getElementById('welcomeOfferConsentWrap');
  if(wrap)wrap.style.display=cfg&&cfg.requireConsent?'flex':'none';
  const em=document.getElementById('welcomeOfferEmail');
  if(em&&cfg&&cfg.customerEmail&&!em.value)em.value=cfg.customerEmail;
}
function wsWelcomeOfferScrollEnough(startY){
  const y=window.scrollY||window.pageYOffset||0;
  return Math.abs(y-startY)>28||y>16;
}
function wsWelcomeOfferResultActive(){
  const rp=$('#resPage');
  return rp&&rp.classList.contains('show');
}
function wsWelcomeOfferTryOpen(startY){
  const cfg=wsWelcomeOfferCfg();
  const modal=$('#welcomeOfferModal');
  if(!cfg||!modal)return;
  if(wsWelcomeOfferSessionDone())return;
  if(wsWelcomeOfferSupLongTerm(cfg))return;
  if(!wsWelcomeOfferResultActive())return;
  if(modal.classList.contains('show'))return;
  if(wsWelcomeOfferOtherUIBlocking()){
    if(wsWelcomeOfferState.deferredCheckId)return;
    let n=0;
    wsWelcomeOfferState.deferredCheckId=setInterval(()=>{
      n++;
      if(!wsWelcomeOfferResultActive()||wsWelcomeOfferSessionDone()){
        clearInterval(wsWelcomeOfferState.deferredCheckId);
        wsWelcomeOfferState.deferredCheckId=null;
        return;
      }
      if(!wsWelcomeOfferOtherUIBlocking()){
        clearInterval(wsWelcomeOfferState.deferredCheckId);
        wsWelcomeOfferState.deferredCheckId=null;
        wsWelcomeOfferOpen();
      }
      if(n>80){
        clearInterval(wsWelcomeOfferState.deferredCheckId);
        wsWelcomeOfferState.deferredCheckId=null;
      }
    },250);
    return;
  }
  wsWelcomeOfferOpen();
}
function wsWelcomeOfferOpen(){
  const cfg=wsWelcomeOfferCfg();
  const modal=$('#welcomeOfferModal');
  if(!cfg||!modal)return;
  wsWelcomeOfferState.modalShownAt=Date.now();
  const hp=document.getElementById('welcomeOfferHp');
  if(hp)hp.value='';
  wsWelcomeOfferSetSessionDone();
  wsWelcomeOfferSyncMerchantCopy();
  const formP=$('#welcomeOfferPanelForm'),okP=$('#welcomeOfferPanelSuccess'),err=$('#welcomeOfferErr');
  if(formP){formP.hidden=false;formP.removeAttribute('hidden');}
  if(okP){okP.hidden=true;okP.setAttribute('hidden','');}
  if(err){err.hidden=true;err.textContent='';}
  const email=$('#welcomeOfferEmail');
  if(email){
    if(cfg.customerEmail&&!email.value)email.value=cfg.customerEmail;
    email.disabled=false;
  }
  const sub=$('#welcomeOfferSubmit');
  if(sub)sub.disabled=false;
  modal.classList.add('show');
  modal.setAttribute('aria-hidden','false');
  wsWelcomeOfferState.lastFocus=document.activeElement;
  setTimeout(()=>{try{email&&email.focus();}catch(_){}},30);
}
function wsWelcomeOfferCloseFromBackdrop(e,modal){
  if(e.target===modal)wsWelcomeOfferShut();
}
function wsWelcomeOfferShut(){
  wsWelcomeOfferCancelCheckout();
  const modal=$('#welcomeOfferModal');
  if(modal){
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden','true');
  }
  const prev=wsWelcomeOfferState.lastFocus;
  wsWelcomeOfferState.lastFocus=null;
  if(prev&&typeof prev.focus==='function'){
    try{prev.focus();}catch(_){}
  }
}
function wsWelcomeOfferArmFromGenerationSuccess(){
  const cfg=wsWelcomeOfferCfg();
  if(!cfg||!$('#welcomeOfferModal'))return;
  if(wsWelcomeOfferSessionDone())return;
  if(wsWelcomeOfferSupLongTerm(cfg))return;
  wsWelcomeOfferDisarmTimers();
  wsWelcomeOfferState.armEpoch=Date.now();
  const startY=window.scrollY||window.pageYOffset||0;
  let scrollOk=false;
  let timerOk=false;
  const check=()=>{
    if(wsWelcomeOfferSessionDone()||!wsWelcomeOfferResultActive())return;
    if(scrollOk&&timerOk)wsWelcomeOfferTryOpen(startY);
  };
  wsWelcomeOfferState.scrollHandler=()=>{
    if(wsWelcomeOfferScrollEnough(startY))scrollOk=true;
    check();
  };
  window.addEventListener('scroll',wsWelcomeOfferState.scrollHandler,{passive:true,capture:true});
  wsWelcomeOfferState.timerId=setTimeout(()=>{
    wsWelcomeOfferState.timerId=null;
    timerOk=true;
    check();
  },cfg.delayMs);
}
function wsWelcomeOfferOnLeaveResultView(){
  wsWelcomeOfferDisarm();
  const modal=$('#welcomeOfferModal');
  if(modal&&modal.classList.contains('show')){
    wsWelcomeOfferShut();
    wsWelcomeOfferSetSessionDone();
  }
}
function wsWelcomeOfferLooksLikeCaptcha(html){
  const t=String(html||'');
  if(/missing\s+captcha\s+token|ontbrekende.*captcha|captcha.*ontbreekt/i.test(t))return true;
  return /h-captcha|hcaptcha|data-hcaptcha|grecaptcha|recaptcha\/api|challenge-platform|cf-turnstile|cdn-cgi\/l\/email-protection/i.test(t);
}
function wsWelcomeOfferStripTags(s){
  return String(s||'').replace(/<script[\s\S]*?<\/script>/gi,'').replace(/<style[\s\S]*?<\/style>/gi,'').replace(/<[^>]+>/g,' ').replace(/\s+/g,' ').trim();
}
function wsWelcomeOfferExtractContactError(html){
  const t=String(html||'');
  const tryChunk=(chunk)=>{
    if(!chunk||!/icon-error/i.test(chunk))return '';
    const txt=wsWelcomeOfferStripTags(chunk);
    if(txt.length>=4&&txt.length<=220)return txt.slice(0,200);
    return '';
  };
  let m=t.match(/<small[^>]*class="[^"]*newsletter-form__message[^"]*"[^>]*>([\s\S]*?)<\/small>/i);
  if(m){const s=tryChunk(m[0]);if(s)return s;}
  m=t.match(/<h2[^>]*class="[^"]*form-status[^"]*"[^>]*role="alert"[^>]*>([\s\S]*?)<\/h2>/i);
  if(m){const s=tryChunk(m[0]);if(s)return s;}
  m=t.match(/<ul[^>]*class="[^"]*form-status-list[^"]*"[^>]*role="list"[^>]*>([\s\S]*?)<\/ul>/i);
  if(m){const s=tryChunk(m[0]);if(s)return s;}
  return '';
}
function wsWelcomeOfferCustomerResponseOk(html){
  const t=String(html||'');
  if(!t.trim())return false;
  if(/newsletter-form__message--success/i.test(t))return true;
  if(/Thanks for subscribing|Thank you for subscribing|Bedankt voor het abonneren|Bedankt voor je aanmelding/i.test(t))return true;
  if(/posted_successfully/i.test(t))return true;
  if(/Bedankt dat je contact met ons hebt opgenomen|Thanks for contacting us/i.test(t))return true;
  if(/icon-success|class="icon icon-success"/i.test(t)){
    if(/newsletter-form__message[\s\S]{0,900}?icon-error/i.test(t))return false;
    if(/form-status[\s\S]{0,400}?icon-error/i.test(t)&&!/form-status[\s\S]{0,400}?icon-success/i.test(t))return false;
    if(/(newsletter-form__message|form-status-list form__message)/i.test(t))return true;
  }
  if(wsWelcomeOfferLooksLikeCaptcha(t))return false;
  if(/(controleer je e-?mail|check your (e-?mail|inbox)|bevestig je abonnement|bevestigingsmail)/i.test(t)&&!/icon-error|Pas het volgende aan|form-status-list[\s\S]{0,1200}?icon-error/i.test(t))return true;
  if(/succesvol\s+(?:ingeschreven|aangemeld)|je\s+bent\s+(?:nu\s+)?ingeschreven/i.test(t))return true;
  if(/newsletter-form__message[\s\S]{0,800}?icon-error/i.test(t))return false;
  if(/newsletter-form__message--error/i.test(t))return false;
  if(/Pas het volgende aan|templates\.contact\.form\.error_heading|The following errors|De volgende fouten/i.test(t))return false;
  if(/field--error|input--error|contact__field-error/i.test(t)&&!/icon-success|newsletter-form__message--success/i.test(t))return false;
  if(/aria-invalid="true"/i.test(t)&&!/newsletter-form__message--success|icon-success/i.test(t))return false;
  return false;
}
/**
 * Shared POST for Shopify `{% form 'customer' %}` newsletter capture (fetch + HTML parse + optional CAPTCHA).
 * @see https://shopify.dev/docs/storefronts/themes/trust-security/captcha
 */
async function wsShopifyCustomerNewsletterSubmit(spec){
  const form=spec.form;
  const mirror=spec.mirrorInput;
  const emailEl=spec.emailInput;
  const errEl=spec.errEl;
  const subBtn=spec.submitBtn;
  const hpEl=spec.hpInput||null;
  const consentEl=spec.consentInput||null;
  const requireConsent=!!spec.requireConsent;
  const msgs=spec.messages;
  const minDwellMs=typeof spec.minDwellMs==='number'?spec.minDwellMs:0;
  const modalShownAt=typeof spec.modalShownAt==='number'?spec.modalShownAt:0;
  const rateLimitOkFn=spec.rateLimitOk;
  const rateLimitRecordFn=spec.rateLimitRecord;
  const onSuccess=spec.onSuccess;
  if(!form||!mirror||!emailEl||!msgs)return;
  const raw=String(emailEl.value||'').trim();
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw)){
    if(errEl){errEl.hidden=false;errEl.textContent=msgs.emailInvalid;}
    return;
  }
  if(requireConsent&&consentEl&&!consentEl.checked){
    if(errEl){errEl.hidden=false;errEl.textContent=msgs.consentRequired;}
    return;
  }
  if(hpEl&&String(hpEl.value||'').trim()){
    if(errEl){errEl.hidden=false;errEl.textContent=msgs.errSubmit;}
    return;
  }
  if(minDwellMs>0&&modalShownAt&&(Date.now()-modalShownAt)<minDwellMs){
    if(errEl){errEl.hidden=false;errEl.textContent=msgs.errWait;}
    return;
  }
  if(typeof rateLimitOkFn==='function'&&!rateLimitOkFn()){
    if(errEl){errEl.hidden=false;errEl.textContent=msgs.errRate;}
    return;
  }
  if(errEl){errEl.hidden=true;errEl.textContent='';}
  mirror.value=raw;
  if(subBtn)subBtn.disabled=true;
  emailEl.disabled=true;
  if(typeof rateLimitRecordFn==='function')rateLimitRecordFn();
  const runPost=async()=>{
    try{
      const fd=new FormData(form);
      const res=await fetch(form.action,{method:'POST',body:fd,credentials:'same-origin',headers:{'Accept':'text/html','X-Requested-With':'XMLHttpRequest'}});
      const html=await res.text();
      const captcha=wsWelcomeOfferLooksLikeCaptcha(html);
      const responseOk=wsWelcomeOfferCustomerResponseOk(html);
      if(!res.ok||!responseOk){
        let msg=msgs.errSubmit;
        if(captcha)msg=msgs.errCaptcha;
        else{
          const extracted=wsWelcomeOfferExtractContactError(html);
          if(extracted)msg=extracted;
        }
        if(errEl){errEl.hidden=false;errEl.textContent=msg;}
        if(subBtn)subBtn.disabled=false;
        emailEl.disabled=false;
        return;
      }
      await onSuccess();
    }catch(e){
      const msg=wsLooksLikeBrowserNetworkFailure(e)?msgs.errNetwork:msgs.errSubmit;
      if(errEl){errEl.hidden=false;errEl.textContent=msg;}
      if(subBtn)subBtn.disabled=false;
      emailEl.disabled=false;
    }
  };
  try{
    const Shop=typeof window.Shopify==='object'&&window.Shopify?window.Shopify:null;
    if(Shop&&Shop.captcha&&typeof Shop.captcha.protect==='function'){
      Shop.captcha.protect(form,()=>{void runPost();});
    }else{
      await runPost();
    }
  }catch(e){
    const msg=wsLooksLikeBrowserNetworkFailure(e)?msgs.errNetwork:msgs.errSubmit;
    if(errEl){errEl.hidden=false;errEl.textContent=msg;}
    if(subBtn)subBtn.disabled=false;
    emailEl.disabled=false;
  }
}
/**
 * Newsletter POST: uses fetch after Shopify hCaptcha is ready when available.
 * @see https://shopify.dev/docs/storefronts/themes/trust-security/captcha (Shopify.captcha.protect; h-captcha-response in POST body when protection is on)
 */
async function wsWelcomeOfferSubmitEmail(){
  const cfg=wsWelcomeOfferCfg();
  const form=document.getElementById('wsWelcomeOfferCustomerForm');
  const mirror=document.getElementById('wsWelcomeOfferEmailField');
  const emailEl=$('#welcomeOfferEmail');
  const errEl=$('#welcomeOfferErr');
  const subBtn=$('#welcomeOfferSubmit');
  const hpEl=document.getElementById('welcomeOfferHp');
  if(!cfg||!form||!mirror||!emailEl)return;
  await wsShopifyCustomerNewsletterSubmit({
    form,
    mirrorInput:mirror,
    emailInput:emailEl,
    errEl,
    submitBtn:subBtn,
    hpInput:hpEl,
    consentInput:$('#welcomeOfferConsent'),
    requireConsent:cfg.requireConsent,
    messages:{
      emailInvalid:wsT('welcome.email_invalid'),
      consentRequired:wsT('welcome.consent_required'),
      errSubmit:wsT('welcome.err_submit'),
      errCaptcha:wsT('welcome.err_captcha'),
      errNetwork:wsT('welcome.err_network'),
      errRate:wsT('welcome.err_rate'),
      errWait:wsT('welcome.err_wait'),
    },
    minDwellMs:wsWelcomeOfferMinDwellMs(),
    modalShownAt:wsWelcomeOfferState.modalShownAt,
    rateLimitOk:wsWelcomeOfferRateLimitOk,
    rateLimitRecord:wsWelcomeOfferRateLimitRecord,
    onSuccess:async()=>{
      wsWelcomeOfferMarkRevealed();
      wsWelcomeOfferSetUnlocked();
      const formP=$('#welcomeOfferPanelForm'),okP=$('#welcomeOfferPanelSuccess'),codeEl=$('#welcomeOfferCodeDisplay');
      if(formP){formP.hidden=true;formP.setAttribute('hidden','');}
      if(okP){okP.hidden=false;okP.removeAttribute('hidden');}
      if(codeEl)codeEl.textContent=cfg.discountCode;
      const live=$('#welcomeOfferLive');
      if(live)live.textContent='';
      setTimeout(()=>{try{codeEl&&codeEl.focus();}catch(_){}},50);
    },
  });
}
/** A current job wins over storage; never combine identities from different portraits. */
function wsWelcomeOfferPortraitIdentity(){
  const currentJob=String(S.lastJobId||'').trim();
  const currentPreview=String(S.lastPreviewUrl||'').trim();
  const saved=typeof wsPortraitSessionRead==='function'?wsPortraitSessionRead():null;
  if(currentJob){
    return {jobId:currentJob,previewUrl:currentPreview||(saved&&saved.jobId===currentJob?String(saved.previewUrl||''):'')};
  }
  if(currentPreview)return {jobId:'',previewUrl:currentPreview};
  return {jobId:String(saved&&saved.jobId||'').trim(),previewUrl:String(saved&&saved.previewUrl||'').trim()};
}
function wsWelcomeOfferCartHasPortrait(cart,portrait){
  if(!portrait.jobId||!/^https:\/\//i.test(portrait.previewUrl))return false;
  return cart.items.some(item=>{
    const props=item&&item.properties;
    return Number(item&&item.quantity)>0&&props&&typeof props==='object'&&!Array.isArray(props)&&
      !props._addon_for&&String(props._ws_job_id||'').trim()===portrait.jobId&&
      /^https:\/\//i.test(String(props._ws_preview_url||''));
  });
}
function wsWelcomeOfferCartBusy(){
  return wsCartWriteState.pending>0||!!document.querySelector('#ws-cart-drawer .is-loading');
}
/** Dismissing the offer cancels its navigation intent, even if fetch ignores abort. */
function wsWelcomeOfferCancelCheckout(){
  wsWelcomeOfferState.checkoutEpoch++;
  const controller=wsWelcomeOfferState.checkoutController;
  wsWelcomeOfferState.checkoutController=null;
  if(controller)controller.abort();
  wsWelcomeOfferState.checkoutBusy=false;
  const button=$('#welcomeOfferApplyCart');
  if(button){button.disabled=false;button.removeAttribute('aria-busy');}
}
/** No cart writes: only the verified intended portrait may use the discount checkout link. */
async function wsWelcomeOfferContinue(){
  if(wsWelcomeOfferState.checkoutBusy)return;
  const cfg=wsWelcomeOfferCfg();
  if(!cfg||!wsWelcomeOfferIsUnlocked())return;
  const button=$('#welcomeOfferApplyCart'),live=$('#welcomeOfferLive');
  if(live)live.textContent='';
  if(wsWelcomeOfferCartBusy()){
    if(live)live.textContent=wsT('welcome.cart_busy');
    return;
  }
  wsWelcomeOfferState.checkoutBusy=true;
  const continuation=++wsWelcomeOfferState.checkoutEpoch;
  if(button){button.disabled=true;button.setAttribute('aria-busy','true');}
  let navigating=false;
  const epoch=wsCartWriteState.epoch;
  const portrait=wsWelcomeOfferPortraitIdentity();
  let funnelEpoch=null;try{funnelEpoch=window.wsFunnelAnalytics?.capture()??null;}catch(_){}
  const controller=new AbortController();
  wsWelcomeOfferState.checkoutController=controller;
  const timeout=setTimeout(()=>controller.abort(),10000);
  try{
    const res=await fetch(wsCartJsUrl(),{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal});
    if(!res.ok)throw new Error('cart_read_failed');
    const cart=await res.json();
    if(continuation!==wsWelcomeOfferState.checkoutEpoch)return;
    if(!cart||!Array.isArray(cart.items)||cart.items.some(item=>!item||typeof item!=='object'||!Number.isFinite(item.quantity)||item.quantity<0))throw new Error('cart_read_invalid');
    if(wsWelcomeOfferCartBusy()||epoch!==wsCartWriteState.epoch){
      if(live)live.textContent=wsT('welcome.cart_busy');
      return;
    }
    const selected=wsWelcomeOfferPortraitIdentity();
    if(selected.jobId===portrait.jobId&&selected.previewUrl===portrait.previewUrl&&wsWelcomeOfferCartHasPortrait(cart,portrait)){
      try{window.wsFunnelAnalytics?.record('checkout_click',{wsJobId:portrait.jobId},funnelEpoch);}catch(_){}
      window.location.assign(wsDiscountApplyUrl(cfg.discountCode,'/checkout'));
      navigating=true;
      return;
    }
    wsWelcomeOfferShut();
    const finish=document.getElementById('resFinish');
    if(finish){
      finish.setAttribute('tabindex','-1');
      finish.focus({preventScroll:true});
      wsScrollElIntoView(finish,'start');
    }
    wsToastShow({type:'info',message:wsT('welcome.choose_format'),duration:8000});
  }catch(_){
    if(continuation===wsWelcomeOfferState.checkoutEpoch&&live)live.textContent=wsT('welcome.cart_error');
  }finally{
    clearTimeout(timeout);
    if(continuation===wsWelcomeOfferState.checkoutEpoch)wsWelcomeOfferState.checkoutController=null;
    if(continuation===wsWelcomeOfferState.checkoutEpoch&&!navigating){
      wsWelcomeOfferState.checkoutBusy=false;
      if(button){button.disabled=false;button.removeAttribute('aria-busy');}
    }
  }
}
/** Keep the unlocked code on the existing drawer checkout without changing its cart behavior. */
function wsWelcomeOfferApplyDrawerDiscount(e){
  const link=e.target&&e.target.closest?e.target.closest('[data-ws-cart-drawer-checkout]'):null;
  if(link&&wsWelcomeOfferIsUnlocked())link.href=wsCartSuccessCheckoutHref();
}
async function wsWelcomeOfferCopyCode(){
  const cfg=wsWelcomeOfferCfg();
  const code=cfg?cfg.discountCode:'';
  const live=$('#welcomeOfferLive');
  if(!code)return;
  try{
    if(navigator.clipboard&&navigator.clipboard.writeText){
      await navigator.clipboard.writeText(code);
      if(live)live.textContent=wsT('welcome.copied');
      return;
    }
  }catch(_){}
  const el=document.getElementById('welcomeOfferCodeDisplay');
  if(el){
    const sel=window.getSelection();
    const r=document.createRange();
    r.selectNodeContents(el);
    sel.removeAllRanges();
    sel.addRange(r);
    try{document.execCommand('copy');if(live)live.textContent=wsT('welcome.copied');}catch(_){
      if(live)live.textContent=wsT('welcome.copy_manual');
    }
  }
}
(function wsWelcomeOfferInit(){
  const modal=$('#welcomeOfferModal');
  if(!modal)return;
  const closeB=$('#welcomeOfferClose');
  const sub=$('#welcomeOfferSubmit');
  const copyB=$('#welcomeOfferCopy');
  const continueB=$('#welcomeOfferApplyCart');
  if(closeB)closeB.addEventListener('click',()=>{wsWelcomeOfferShut();});
  modal.addEventListener('click',e=>wsWelcomeOfferCloseFromBackdrop(e,modal));
  modal.addEventListener('keyup',e=>{
    if(e.code==='Escape')wsWelcomeOfferShut();
  });
  if(sub)sub.addEventListener('click',()=>{void wsWelcomeOfferSubmitEmail();});
  if(copyB)copyB.addEventListener('click',()=>{void wsWelcomeOfferCopyCode();});
  if(continueB)continueB.addEventListener('click',()=>{void wsWelcomeOfferContinue();});
  document.addEventListener('click',wsWelcomeOfferApplyDrawerDiscount,{capture:true});
  window.addEventListener('pageshow',e=>{
    if(!e.persisted)return;
    wsWelcomeOfferCancelCheckout();
  });
  wsWelcomeOfferSyncMerchantCopy();
})();
function wsIsPhotoDecodeRecoveryClass(meta){
  return String(meta&&meta.code||'')==='image_decode_failed';
}
function wsPhotoDecodeRecoveryShouldOfferModal(meta){
  if(!wsStudioRecoveryCfg())return false;
  if(!document.getElementById('studioRecoveryModal'))return false;
  if(!wsIsPhotoDecodeRecoveryClass(meta))return false;
  if(wsIsStudioRecoveryClass(meta))return false;
  return wsStudioRecoveryModalCooldownOk();
}
function wsStudioRecoveryShouldOfferModal(meta){
  if(!wsStudioRecoveryCfg())return false;
  if(!document.getElementById('studioRecoveryModal'))return false;
  if(!wsIsStudioRecoveryClass(meta))return false;
  return wsStudioRecoveryModalCooldownOk();
}
function wsStudioRecoverySyncMerchantCopy(){
  const cfg=wsStudioRecoveryCfg();
  const el=document.getElementById('studioRecoveryConsentText');
  if(!el)return;
  if(cfg&&cfg.requireConsent)el.textContent=cfg.consentLabel?cfg.consentLabel:wsT('welcome.consent_label');
  else el.textContent='';
  const wrap=document.getElementById('studioRecoveryConsentWrap');
  if(wrap)wrap.style.display=cfg&&cfg.requireConsent?'flex':'none';
  const em=document.getElementById('studioRecoveryEmail');
  if(em&&cfg&&cfg.customerEmail&&!em.value)em.value=cfg.customerEmail;
}
function wsStudioRecoveryOpen(variant){
  const cfg=wsStudioRecoveryCfg();
  const modal=$('#studioRecoveryModal');
  if(!cfg||!modal)return;
  wsStudioRecoveryState.variant=variant==='photo_decode'?'photo_decode':'capacity';
  wsStudioRecoveryState.modalShownAt=Date.now();
  const hp=document.getElementById('studioRecoveryHp');
  if(hp)hp.value='';
  wsStudioRecoverySyncMerchantCopy();
  wsApplyUiLang(wsDetectLangFromProviders());
  wsRecoverySyncVariantCopy(wsStudioRecoveryState.variant);
  const formP=$('#studioRecoveryPanelForm'),okP=$('#studioRecoveryPanelSuccess'),err=$('#studioRecoveryErr');
  if(formP){formP.hidden=false;formP.removeAttribute('hidden');}
  if(okP){okP.hidden=true;okP.setAttribute('hidden','');}
  if(err){err.hidden=true;err.textContent='';}
  const email=$('#studioRecoveryEmail');
  if(email){
    if(cfg.customerEmail&&!email.value)email.value=cfg.customerEmail;
    email.disabled=false;
  }
  const sub=$('#studioRecoverySubmit');
  if(sub)sub.disabled=false;
  modal.classList.add('show');
  modal.setAttribute('aria-hidden','false');
  wsStudioRecoveryState.lastFocus=document.activeElement;
  setTimeout(()=>{
    try{
      if(wsStudioRecoveryState.variant==='photo_decode'){
        const tryA=$('#studioRecoveryTryAgain');
        if(tryA&&typeof tryA.focus==='function')tryA.focus();
      }else if(email&&typeof email.focus==='function')email.focus();
    }catch(_){}
  },30);
}
function wsStudioRecoveryShut(){
  const modal=$('#studioRecoveryModal');
  if(modal){
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden','true');
  }
  const prev=wsStudioRecoveryState.lastFocus;
  wsStudioRecoveryState.lastFocus=null;
  if(prev&&typeof prev.focus==='function'){
    try{prev.focus();}catch(_){}
  }
}
async function wsStudioRecoverySubmitEmail(){
  const cfg=wsStudioRecoveryCfg();
  const form=document.getElementById('wsStudioRecoveryCustomerForm');
  const mirror=document.getElementById('studioRecoveryEmailField');
  const emailEl=$('#studioRecoveryEmail');
  const errEl=$('#studioRecoveryErr');
  const subBtn=$('#studioRecoverySubmit');
  const hpEl=document.getElementById('studioRecoveryHp');
  const consentEl=$('#studioRecoveryConsent');
  if(!cfg||!form||!mirror||!emailEl)return;
  const email=String(emailEl.value||'').trim();
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
    if(errEl){errEl.hidden=false;errEl.textContent=wsT('welcome.email_invalid');}
    return;
  }
  if(cfg.requireConsent&&consentEl&&!consentEl.checked){
    if(errEl){errEl.hidden=false;errEl.textContent=wsT('welcome.consent_required');}
    return;
  }
  if(errEl){errEl.hidden=true;errEl.textContent='';}
  if(subBtn)subBtn.disabled=true;
  const capture=wsStudioRecoveryState.capture||wsCaptureJobContext({code:''});
  const consentGiven=cfg.requireConsent?!!consentEl?.checked:true;
  try{
    const payload={
      email,
      consent:consentGiven,
      flow:wsStudioRecoveryState.variant==='photo_decode'?'photo_decode':'studio_recovery',
      style:capture.style,
      category:capture.category,
      error_code:capture.errorCode
    };
    if(capture.asyncJobId)payload.async_job_id=capture.asyncJobId;
    if(capture.wsJobId)payload.ws_job_id=capture.wsJobId;
    if(cfg.customerId)payload.shopify_customer_id=cfg.customerId;
    const res=await fetch(WS_PROXY_GENERATE_RECOVERY,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify(payload)
    });
    const d=await readProxyJson(res);
    if(!res.ok)throw new Error((d&&d.error&&d.error.message)||wsT('welcome.err_submit'));
    if(d&&(d.shopify_customer_bound===false||d.note_written===false)&&typeof console!=='undefined'&&console.warn){
      console.warn('[Wallstraight] Studio recovery: worker customer bind incomplete.',d);
    }
  }catch(recErr){
    if(typeof console!=='undefined'&&console.warn){
      console.warn('[Wallstraight] Studio recovery worker POST failed',recErr);
    }
  }
  await wsShopifyCustomerNewsletterSubmit({
    form,
    mirrorInput:mirror,
    emailInput:emailEl,
    errEl,
    submitBtn:subBtn,
    hpInput:hpEl,
    consentInput:consentEl,
    requireConsent:cfg.requireConsent,
    messages:{
      emailInvalid:wsT('welcome.email_invalid'),
      consentRequired:wsT('welcome.consent_required'),
      errSubmit:wsT('welcome.err_submit'),
      errCaptcha:wsT('welcome.err_captcha'),
      errNetwork:wsT('welcome.err_network'),
      errRate:wsT('welcome.err_rate'),
      errWait:wsT('welcome.err_wait'),
    },
    minDwellMs:0,
    modalShownAt:wsStudioRecoveryState.modalShownAt,
    rateLimitOk:wsStudioRecoveryRateLimitOk,
    rateLimitRecord:wsStudioRecoveryRateLimitRecord,
    onSuccess:async()=>{
      const formP=$('#studioRecoveryPanelForm'),okP=$('#studioRecoveryPanelSuccess'),live=$('#studioRecoveryLive');
      if(formP){formP.hidden=true;formP.setAttribute('hidden','');}
      if(okP){okP.hidden=false;okP.removeAttribute('hidden');}
      if(live)live.textContent='';
      const okB=$('#studioRecoverySuccessOk');
      setTimeout(()=>{try{okB&&okB.focus();}catch(_){}},50);
    },
  });
}
(function wsStudioRecoveryInit(){
  const modal=$('#studioRecoveryModal');
  if(!modal)return;
  const closeB=$('#studioRecoveryClose');
  const sub=$('#studioRecoverySubmit');
  const tryA=$('#studioRecoveryTryAgain');
  const okB=$('#studioRecoverySuccessOk');
  if(closeB)closeB.addEventListener('click',()=>{wsStudioRecoveryShut();});
  modal.addEventListener('click',e=>{if(e.target===modal)wsStudioRecoveryShut();});
  modal.addEventListener('keyup',e=>{
    if(e.code==='Escape')wsStudioRecoveryShut();
  });
  if(sub)sub.addEventListener('click',()=>{void wsStudioRecoverySubmitEmail();});
  if(tryA)tryA.addEventListener('click',()=>{
    const variant=wsStudioRecoveryState.variant;
    wsStudioRecoveryShut();
    if(variant==='photo_decode'){
      const uzEl=document.getElementById('uz');
      const fiEl=document.getElementById('fi');
      if(uzEl&&typeof uzEl.click==='function'){try{uzEl.click();}catch(_){}}
      else if(fiEl&&typeof fiEl.click==='function'){try{fiEl.click();}catch(_){}}
      return;
    }
    const g=document.getElementById('genBtn');
    if(g&&typeof g.focus==='function'){try{g.focus();}catch(_){}}
  });
  if(okB)okB.addEventListener('click',()=>{wsStudioRecoveryShut();});
  wsStudioRecoverySyncMerchantCopy();
})();
function wsIsSoldOutDescription(s){
  return(/sold out|already sold out|uitverkocht|out of stock|niet op voorraad|geen voorraad|niet beschikbaar|is niet beschikbaar|not available|unavailable/i).test(String(s||''));
}
function wsCartErrorUserMessage(parsed){
  const raw=String(parsed&&(parsed.description!=null?parsed.description:parsed.message)||'').trim();
  if(wsIsSoldOutDescription(raw))return wsT('cart.oos');
  if(Number(parsed&&parsed.status)===422)return raw?`${wsT('cart.error_checkout')} ${raw}`:wsT('cart.error_checkout');
  if(raw)return raw;
  return wsT('cart.fail');
}
function wsToastBind(){
  const d=$('#toastDismiss');
  if(d&&!d.dataset.wsBound){
    d.dataset.wsBound='1';
    d.addEventListener('click',()=>wsToastHide());
  }
}
function wsToastShow(opts){
  wsPortalToastToBody();
  const el=$('#toast');
  if(!el)return;
  wsToastBind();
  clearTimeout(tt);
  const type=opts.type||'info';
  const message=String(opts.message||'');
  const actions=opts.actions;
  const duration=opts.duration!=null?opts.duration:(actions&&actions.length?8200:3200);
  el.dataset.toastType=type;
  el.setAttribute('aria-live',type==='error'?'assertive':'polite');
  el.setAttribute('role',type==='error'?'alert':'status');
  const msgEl=el.querySelector('.toast-msg');
  const actEl=el.querySelector('.toast-actions');
  const disEl=el.querySelector('.toast-dismiss');
  if(msgEl)msgEl.textContent=message;
  if(actEl){
    actEl.textContent='';
    if(actions&&actions.length){
      for(let i=0;i<actions.length;i++){
        const a=actions[i];
        if(a&&a.href){
          const link=document.createElement('a');
          link.href=a.href;
          link.className=a.primary?'toast-btn toast-btn--primary':'toast-btn toast-btn--secondary';
          link.textContent=a.label;
          actEl.appendChild(link);
        }
      }
    }
  }
  const hasActs=!!(actEl&&actEl.childNodes.length);
  if(disEl){
    disEl.hidden=!(hasActs||type==='error');
    disEl.setAttribute('aria-label',wsT('toast.dismiss'));
  }
  el.classList.add('show');
  let ms=opts.duration;
  if(ms==null)ms=type==='error'?7000:duration;
  tt=setTimeout(()=>wsToastHide(),ms);
}
function toast(m){
  wsToastShow({type:'info',message:String(m||'')});
}
function wsCartSuccessProductName(material){
  if(material==='glass')return wsT('mat.glass')||wsT('tier.nm.g');
  if(material==='canvas')return wsT('mat.canvas');
  if(material==='poster')return wsT('mat.poster');
  return wsT('mat.poster');
}
/** Contextual cart-success copy from last addToCart (material + optional paid finishing). */
function wsCartSuccessCopy(ctx){
  const c=ctx&&typeof ctx==='object'?ctx:{};
  if(c.isDigital||c.material==='digital'){
    return{title:wsT('cart.success.title.digital'),lede:wsT('cart.success.lede.digital')};
  }
  const product=wsCartSuccessProductName(c.material);
  const finish=String(c.finishLabel||'').trim();
  if(c.hasPaidFinish&&finish){
    return{
      title:wsT('cart.success.title.physical_finish').replace(/\{0\}/g,product).replace(/\{1\}/g,finish),
      lede:wsT('cart.success.lede.physical_finish').replace(/\{0\}/g,product).replace(/\{1\}/g,finish),
    };
  }
  return{
    title:wsT('cart.success.title.physical').replace(/\{0\}/g,product),
    lede:wsT('cart.success.lede.physical').replace(/\{0\}/g,product),
  };
}
function wsBuildCartAddSuccessCtx(material,isDigital){
  const ctx={material:material||'',isDigital:material==='digital'||!!isDigital,hasPaidFinish:false,finishLabel:''};
  if(!ctx.isDigital){
    try{
      const fin=wsFinishingSelected(material);
      if(fin&&fin.isPaid&&fin.option){
        ctx.hasPaidFinish=true;
        ctx.finishLabel=wsFinishingPaidLabel(fin.option);
      }
    }catch(_){/* noop */}
  }
  return ctx;
}
function wsPaintCartSuccessCopy(dlg,ctx){
  if(!dlg)return;
  let parsed=ctx;
  if(!parsed&&dlg.dataset.wsLastSuccessCtx){
    try{parsed=JSON.parse(dlg.dataset.wsLastSuccessCtx);}catch(_){parsed=null;}
  }
  const copy=wsCartSuccessCopy(parsed);
  const titleEl=dlg.querySelector('#wsCartSuccessTitle')||dlg.querySelector('.ws-cart-success-dlg__title');
  const ledeEl=dlg.querySelector('.ws-cart-success-dlg__lede');
  if(titleEl)titleEl.textContent=copy.title;
  if(ledeEl)ledeEl.textContent=copy.lede;
}
function wsToastCartSuccess(ctx){
  const checkoutHref=wsCartSuccessCheckoutHref();
  const copy=wsCartSuccessCopy(ctx);
  const msg=copy.lede?copy.title+' '+copy.lede:copy.title;
  wsToastShow({
    type:'success',
    message:msg,
    duration:8200,
    actions:[
      {href:checkoutHref,label:wsT('cart.checkout'),primary:true}
    ]
  });
}
/** Move cart-success `<dialog>` under `document.body` once (avoids clipping in WebKit). */
function wsPortalCartSuccessDialogToBody(){
  const dlg=document.getElementById('wsCartSuccessDialog');
  if(!dlg||dlg.dataset.wsPortaled==='1')return;
  if(dlg.parentElement!==document.body)document.body.appendChild(dlg);
  dlg.dataset.wsPortaled='1';
}
function wsApplyCartSuccessDialogI18n(){
  const dlg=document.getElementById('wsCartSuccessDialog');
  if(!dlg)return;
  dlg.querySelectorAll('[data-i18n]').forEach(el=>{
    const k=el.getAttribute('data-i18n');
    if(!k)return;
    if(k==='cart.ok'||k==='cart.success_dlg_lede')return;
    el.textContent=wsT(k);
  });
  dlg.querySelectorAll('[data-i18n-aria-label]').forEach(el=>{
    const k=el.getAttribute('data-i18n-aria-label');
    if(k)el.setAttribute('aria-label',wsT(k));
  });
  wsPaintCartSuccessCopy(dlg);
}
function wsApplyCartDrawerI18n(){
  const drawer=document.getElementById('ws-cart-drawer');
  if(!drawer)return;
  drawer.querySelectorAll('[data-i18n]').forEach(el=>{
    const k=el.getAttribute('data-i18n');
    if(k)el.textContent=wsT(k);
  });
}
function wsCloseCartSuccessDialog(){
  const dlg=document.getElementById('wsCartSuccessDialog');
  if(!dlg)return;
  dlg.classList.remove('is-open');
  delete dlg.dataset.wsOpenedAt;
  try{dlg.close();}catch(_){/* no-op */}
  if(dlg.dataset.wsScrollLock==='1'){
    document.body.style.overflow='';
    delete dlg.dataset.wsScrollLock;
  }
  const fab=document.getElementById('wsResCartFab');
  if(fab&&fab.dataset.wsModalSilenced==='1'){
    fab.removeAttribute('aria-hidden');
    fab.removeAttribute('tabindex');
    delete fab.dataset.wsModalSilenced;
  }
  /* Return focus to invoker (W3C WAI-ARIA APG Dialog Pattern). Skip if the
     invoker has been removed from the DOM in the meantime (defensive). */
  const prev=dlg.__wsReturnFocus;
  dlg.__wsReturnFocus=null;
  if(prev&&typeof prev.focus==='function'&&document.contains(prev)){
    try{prev.focus({preventScroll:true});}catch(_){try{prev.focus();}catch(__){}}
  }
}
/**
 * Normalize `POST …/cart/add.js` JSON — Shopify may return `{ items }`, a cart object with
 * `item_count`, or (legacy) a bare line-item array. See shopify.dev/docs/api/ajax/reference/cart.
 */
function wsNormalizeCartAddJson(body){
  if(body==null)return null;
  if(Array.isArray(body))return{items:body};
  if(typeof body!=='object')return null;
  if(Array.isArray(body.items))return body;
  if(body.id!=null&&(body.variant_id!=null||body.quantity!=null||body.key))return{items:[body]};
  return body;
}
function wsCartAddSucceeded(res,parsed){
  if(!res||!res.ok)return false;
  if(parsed!=null&&Number(parsed.status)===422)return false;
  if(!parsed||typeof parsed!=='object')return false;
  if(Array.isArray(parsed.items)&&parsed.items.length>0)return true;
  if(typeof parsed.item_count==='number'&&parsed.item_count>0)return true;
  if(parsed.id!=null&&(parsed.variant_id!=null||parsed.key))return true;
  return false;
}
/**
 * Guaranteed shopper-visible success on the AI funnel (no Dawn header / cart-notification).
 * Uses CSS `.is-open` overlay only — avoids WebKit top-layer / hidden-ancestor edge cases
 * with `<dialog>.showModal()` after `await fetch` (WHATWG html#12287, WebKit PR #35990).
 * Dialog is portaled to `document.body` so the overflow:hidden funnel ancestor cannot clip it.
 */
function wsShowCartSuccessDialog(ctx){
  wsPortalCartSuccessDialogToBody();
  const dlg=document.getElementById('wsCartSuccessDialog');
  const goChk=document.getElementById('wsCartSuccessCheckout');
  if(goChk)goChk.setAttribute('href',wsCartSuccessCheckoutHref());
  if(dlg&&ctx&&typeof ctx==='object'){
    try{dlg.dataset.wsLastSuccessCtx=JSON.stringify(ctx);}catch(_){delete dlg.dataset.wsLastSuccessCtx;}
  }
  wsApplyCartSuccessDialogI18n();
  if(dlg&&ctx)wsPaintCartSuccessCopy(dlg,ctx);
  if(!dlg){
    wsToastCartSuccess(ctx);
    return;
  }
  if(dlg.open){try{dlg.close();}catch(_){/* no-op */}}
  /* Remember the invoker so focus can return there on close (W3C WAI-ARIA APG
     Dialog Pattern). Stored as a non-enumerable global; null when no element
     has focus (e.g. add-to-cart was triggered via touch on iOS Safari which
     does not move focus to <button> by default). */
  try{
    const prev=document.activeElement;
    if(prev&&prev!==document.body)dlg.__wsReturnFocus=prev;
    else dlg.__wsReturnFocus=null;
  }catch(_){dlg.__wsReturnFocus=null;}
  dlg.classList.add('is-open');
  dlg.dataset.wsOpenedAt=String(Date.now());
  document.body.style.overflow='hidden';
  dlg.dataset.wsScrollLock='1';
  /* Manual modal a11y: hide the results-page FAB from AT + tab order while
     the dialog is open so screen readers do not announce two checkout CTAs
     and keyboard users cannot tab to the inert background. */
  const fab=document.getElementById('wsResCartFab');
  if(fab&&!fab.dataset.wsModalSilenced){
    fab.dataset.wsModalSilenced='1';
    fab.setAttribute('aria-hidden','true');
    fab.setAttribute('tabindex','-1');
  }
  /* Initial focus on the primary CTA (W3C APG: "set focus to the element that
     is likely to be most frequently used, such as an OK or Continue button"
     — checkout is exactly that). rAF avoids racing the .is-open paint. */
  requestAnimationFrame(()=>{
    if(!dlg.classList.contains('is-open'))return;
    if(goChk&&typeof goChk.focus==='function'){try{goChk.focus({preventScroll:true});}catch(_){try{goChk.focus();}catch(__){}}}
  });
  if(typeof console!=='undefined'&&console.info&&/ws_debug=1/.test(String(location.search||''))){
    console.info('[Wallstraight] cart success dialog open',dlg.classList.contains('is-open'));
  }
}
/**
 * Returns true only when the cart-success dialog overlay AND its inner panel are
 * laid out and visually present. Inspects the panel (the actual UI the shopper
 * reads) — the overlay container is always inset:0 even if the panel itself has
 * collapsed to 0×0 (e.g. stale CSS, theme override, or WebKit late-layout).
 *
 * Equivalent to `Element.checkVisibility({opacityProperty:true,visibilityProperty:true})`
 * but works on Safari < 17.4 (checkVisibility is Baseline 2024 per MDN).
 */
function wsDialogPaintedOk(dlg){
  if(!dlg||!dlg.classList||!dlg.classList.contains('is-open'))return false;
  const panel=dlg.querySelector('.ws-cart-success-dlg__panel')||dlg;
  const r=panel.getBoundingClientRect();
  if(!(r.width>=8)||!(r.height>=8))return false;
  if(typeof getComputedStyle!=='function')return true;
  const cs=getComputedStyle(panel);
  if(cs.display==='none'||cs.visibility==='hidden')return false;
  const op=Number(cs.opacity);
  if(Number.isFinite(op)&&op<0.05)return false;
  return true;
}
/**
 * Dawn notification when present; otherwise funnel success dialog. If the dialog
 * fails to paint within ~2 animation frames (iOS Safari late layout, missing CSS,
 * overflow-clip regression) we close the overlay and surface the enlarged toast
 * fallback so the shopper is never left with FAB-only silence.
 */
function wsNotifyCartAddSuccess(ctx){
  wsPortalToastToBody();
  const dlg=document.getElementById('wsCartSuccessDialog');
  if(!dlg){
    wsToastCartSuccess(ctx);
    return;
  }
  wsShowCartSuccessDialog(ctx);
  /* Double rAF + tiny settle gives Mobile Safari enough time to finalize layout
     after `await fetch` before we decide the dialog is broken. */
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    setTimeout(()=>{
      if(wsDialogPaintedOk(dlg))return;
      try{wsCloseCartSuccessDialog();}catch(_){/* no-op */}
      wsToastCartSuccess(ctx);
    },32);
  }));
}
(function wsBindCartSuccessDialog(){
  const dlg=document.getElementById('wsCartSuccessDialog');
  if(!dlg)return;
  /* Backdrop dismiss debounce: on touch devices the `mousedown→click` chain
     that triggered the add-to-cart button can bubble onto the freshly painted
     overlay and instantly dismiss it. Require a 250ms quiet window after open
     before backdrop clicks count (the X button + Esc are never debounced). */
  dlg.addEventListener('click',e=>{
    if(e.target!==dlg)return;
    const openedAt=Number(dlg.dataset.wsOpenedAt||0);
    if(openedAt&&(Date.now()-openedAt)<250)return;
    wsCloseCartSuccessDialog();
  });
  const x=document.getElementById('wsCartSuccessClose');
  if(x)x.addEventListener('click',()=>{wsCloseCartSuccessDialog();});
  /* Native `cancel` only fires for showModal-opened <dialog>; since the funnel uses
     a CSS `.is-open` overlay (no showModal), bind Esc on document while open. */
  dlg.addEventListener('cancel',e=>{
    e.preventDefault();
    wsCloseCartSuccessDialog();
  });
  document.addEventListener('keydown',e=>{
    if(e.key!=='Escape')return;
    if(!dlg.classList.contains('is-open'))return;
    e.preventDefault();
    wsCloseCartSuccessDialog();
  });
})();
const ldEl=$('#ld'),ldPct=$('#ldPct'),ldMsg=$('#ldMsg'),ldSub=$('#ldSubtitle');
const apiBox=$('#apiBox');
const landing=$('#landingPage'),resPage=$('#resPage'),resImg=$('#resImg'),resTag=$('#resTag');

async function wsSetResImage(el,url){
  try{const observedJobId=S.lastJobId,observedUpload=S.b64;if(el===resImg)window.wsFunnelAnalytics?.observePreview(el,url,observedJobId,{style:S.style,category:S.cat},()=>wsGenerateImageStillCurrent(observedJobId,url)&&S.b64===observedUpload&&resPage?.classList.contains('show'));}catch(_){}
  if(!el||!url)return;
  el.removeAttribute('srcset');
  el.src='';
  void el.offsetWidth;
  if(typeof el.decode==='function'){
    el.src=url;
    try{await el.decode();}catch(_){throw new Error(wsT('err.decode'));}
    return;
  }
  await new Promise((res,rej)=>{
    const ok=()=>{el.onload=el.onerror=null;res();};
    const bad=()=>{el.onload=el.onerror=null;rej(new Error(wsT('err.decode')));};
    el.onload=ok;
    el.onerror=bad;
    el.src=url;
    if(el.complete&&el.naturalWidth>0)ok();
  });
}

/** True when no newer generate has replaced job/image since success payload applied. */
function wsGenerateImageStillCurrent(jobId,imgUrl){
  return String(S.lastJobId||'')===String(jobId||'')&&String(S.imgUrl||'')===String(imgUrl||'');
}

/**
 * Set `#resImg.src` immediately, then await decode with timeout (R1).
 * Returns true when decode completed; false on timeout/decode error (src may still load).
 */
async function wsSetResImageWithTimeout(el,url,ms){
  try{const observedJobId=S.lastJobId,observedUpload=S.b64;if(el===resImg)window.wsFunnelAnalytics?.observePreview(el,url,observedJobId,{style:S.style,category:S.cat},()=>wsGenerateImageStillCurrent(observedJobId,url)&&S.b64===observedUpload&&resPage?.classList.contains('show'));}catch(_){}
  ms=Number.isFinite(ms)&&ms>0?ms:WS_SET_RES_IMAGE_DECODE_TIMEOUT_MS;
  if(!el||!url)return false;
  el.removeAttribute('srcset');
  el.src='';
  void el.offsetWidth;
  const decodeWork=(async function(){
    if(typeof el.decode==='function'){
      el.src=url;
      try{await el.decode();}catch(_){throw new Error(wsT('err.decode'));}
      return;
    }
    await new Promise(function(res,rej){
      const ok=function(){el.onload=el.onerror=null;res();};
      const bad=function(){el.onload=el.onerror=null;rej(new Error(wsT('err.decode')));};
      el.onload=ok;
      el.onerror=bad;
      el.src=url;
      if(el.complete&&el.naturalWidth>0)ok();
    });
  })();
  const timer=new Promise(function(_,rej){
    setTimeout(function(){rej(new Error('ws_set_res_image_timeout'));},ms);
  });
  try{
    await Promise.race([decodeWork,timer]);
    return true;
  }catch(_){
    if(!el.src)el.src=url;
    return false;
  }
}

/** Deter casual save/copy on opted-in preview zones via ws-preview-protect.js (not DRM). */
function wsProtectPreviewInteraction(){
  const frame=document.getElementById('resImgFrame');
  if(frame&&!frame.hasAttribute('data-ws-protected-preview')){
    frame.setAttribute('data-ws-protected-preview','');
  }
  const img=document.getElementById('resImg');
  if(img)img.setAttribute('draggable','false');
  if(typeof window.wsPreviewProtectInit==='function')window.wsPreviewProtectInit();
}

/**
 * Preview chrome only — pet names must appear inside the model image (see
 * `wsPetPortraitPromptContext`). A DOM text overlay hid missing in-image
 * lettering and made DevTools / “Result” thumbnails disagree with the shopper.
 */
function wsRefreshPreviewBranding(){
  wsProtectPreviewInteraction();
  const petEl=document.getElementById('resPetNameLine');
  const frame=document.getElementById('resImgFrame');
  if(frame)frame.classList.remove('has-pet-name');
  if(!petEl)return;
  petEl.textContent='';
  petEl.hidden=true;
  petEl.removeAttribute('aria-label');
}

/** API key code removed - server-side processing */
/** Gold ticker: duplicate spans so `animation:sc` loop is seamless. Showcase uses scroll-snap (no DOM clone). */
(function duplicateAnnMarquee(){
  const ann=$('#annT');
  if(ann)ann.innerHTML+=ann.innerHTML;
})();

/**
 * Funnel header nav drawer (<dialog>) — tablet/phone ≤1023px.
 * Native showModal: inert backdrop, Esc, focus trap (MDN HTMLDialogElement.showModal).
 */
(function wsHdrMenuDialog(){
  const root=typeof document!=='undefined'?document.getElementById('wallstraight-generator'):null;
  if(!root||typeof HTMLDialogElement==='undefined')return;
  const pairs=[];
  root.querySelectorAll('.hdr-menu-btn').forEach(btn=>{
    const id=btn.getAttribute('aria-controls');
    if(!id)return;
    const dlg=document.getElementById(id);
    if(!dlg||dlg.tagName!=='DIALOG')return;
    pairs.push({btn,dlg});
  });
  if(!pairs.length)return;
  const closePair=({btn,dlg},returnFocus=true)=>{
    if(!dlg.open)return;
    dlg.close();
    btn.setAttribute('aria-expanded','false');
    if(returnFocus)try{btn.focus();}catch(_){/* focus unavailable */}
  };
  const openPair=({btn,dlg})=>{
    if(dlg.open)return;
    dlg.showModal();
    btn.setAttribute('aria-expanded','true');
    const first=dlg.querySelector('.hdr-menu-link');
    if(first)try{first.focus();}catch(_){/* */ }
  };
  pairs.forEach(pair=>{
    const {btn,dlg}=pair;
    btn.addEventListener('click',()=>{
      if(dlg.open)closePair(pair);
      else openPair(pair);
    });
    dlg.addEventListener('cancel',e=>{
      e.preventDefault();
      closePair(pair);
    });
    dlg.addEventListener('click',e=>{
      if(e.target===dlg)closePair(pair);
    });
    dlg.querySelectorAll('[data-hdr-menu-close]').forEach(el=>{
      el.addEventListener('click',()=>closePair(pair));
    });
    dlg.querySelectorAll('.hdr-menu-link').forEach(link=>{
      link.addEventListener('click',()=>{
        const href=link.getAttribute('href')||'';
        if(href.charAt(0)==='#'){
          const rp=document.getElementById('resPage');
          if(rp&&rp.classList.contains('show')&&typeof showLanding==='function'){
            showLanding();
            const id=href.slice(1);
            if(id){
              requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                  const el=document.getElementById(id);
                  if(el)try{el.scrollIntoView({behavior:'smooth',block:'start'});}catch(_){/* */}
                });
              });
            }
          }
        }
        closePair(pair,false);
      });
    });
  });
})();

/**
 * “Crafted by customers” rail: one slow intro drift after the section enters viewport.
 * Uses rAF + scrollLeft; intro adds `.ws-sc-intro` so snap/smooth CSS does not block tiny steps.
 * Drift caps at ~4 tiles so lazy imgs beyond stay unloaded until the shopper scrolls.
 * Any pointer / wheel / touch / key on the rail cancels permanently; PRM skips entirely.
 *
 * Deferred `ws-generator.js` + first paint: scrollWidth may be 0 for a frame — we double-rAF
 * and warm up until `scrollWidth > clientWidth` (or timeout). Ultra-wide viewports where the
 * whole strip fits have nowhere to scroll; intro exits quietly.
 *
 * While drifting, `.ws-sc-intro` turns off snap + smooth scroll (CSS); otherwise mandatory
 * snap ignores sub-tile scrollLeft steps and the rAF loop exits immediately.
 */
(function wsShowcaseIntroAutoscroll(){
  const root=typeof document!=='undefined'?document.getElementById('wallstraight-generator'):null;
  if(!root)return;
  const showcase=root.querySelector('.showcase');
  const rail=root.querySelector('.showcase .sc-w');
  if(!rail||!showcase)return;
  try{
    if(typeof window.matchMedia==='function'&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  }catch(_){/* matchMedia unavailable */}
  let rafId=0;
  let stopped=false;
  let introMaxLeft=0;
  let viewportIo=null;
  let lastT=(typeof performance!=='undefined'&&typeof performance.now==='function')?performance.now():Date.now();
  let warmupFrames=0;
  /** ~32px/s — capped to ~4 tiles so lazy imgs beyond stay unloaded until user scrolls. */
  const PX_PER_SEC=32;
  const INTRO_TILE_CAP=4;
  const WARMUP_MAX_FRAMES=90;
  const maxScroll=()=>Math.max(0,rail.scrollWidth-rail.clientWidth);
  const end=()=>{
    if(stopped)return;
    stopped=true;
    rail.classList.remove('ws-sc-intro');
    if(rafId)cancelAnimationFrame(rafId);
    rafId=0;
    if(viewportIo){try{viewportIo.disconnect();}catch(_){/* IO unavailable */}viewportIo=null;}
    document.removeEventListener('visibilitychange',onVis);
    rail.removeEventListener('pointerdown',onUser);
    rail.removeEventListener('wheel',onUser,{capture:true});
    rail.removeEventListener('touchstart',onUser,{passive:true});
    rail.removeEventListener('keydown',onUser);
  };
  const onUser=()=>{end();};
  const onVis=()=>{
    if(document.hidden){
      if(rafId)cancelAnimationFrame(rafId);
      rafId=0;
    }else if(!stopped){
      lastT=(typeof performance!=='undefined'&&typeof performance.now==='function')?performance.now():Date.now();
      rafId=requestAnimationFrame(tick);
    }
  };
  const tick=t=>{
    if(stopped)return;
    const now=t;
    const dt=Math.min(0.064,(now-lastT)/1000);
    lastT=now;
    const max=maxScroll();
    if(max<1){end();return;}
    const before=rail.scrollLeft;
    const capLeft=introMaxLeft>0?Math.min(max,introMaxLeft):max;
    const target=Math.min(capLeft,before+PX_PER_SEC*dt);
    rail.scrollLeft=target;
    const after=rail.scrollLeft;
    if(target>before+0.01&&after<=before+0.01){end();return;}
    if(after>=capLeft-0.75){end();return;}
    rafId=requestAnimationFrame(tick);
  };
  const startAfterLayout=()=>{
    if(stopped)return;
    const max=maxScroll();
    if(max<2){
      if(++warmupFrames>WARMUP_MAX_FRAMES){end();return;}
      rafId=requestAnimationFrame(startAfterLayout);
      return;
    }
    const firstCard=rail.querySelector('.sc-c');
    const tileStep=firstCard?Math.max(1,firstCard.offsetWidth+10):146;
    introMaxLeft=Math.min(max,rail.scrollLeft+tileStep*INTRO_TILE_CAP);
    rail.classList.add('ws-sc-intro');
    lastT=(typeof performance!=='undefined'&&typeof performance.now==='function')?performance.now():Date.now();
    rafId=requestAnimationFrame(tick);
  };
  const kickoff=()=>{
    if(stopped)return;
    document.addEventListener('visibilitychange',onVis);
    rail.addEventListener('pointerdown',onUser);
    rail.addEventListener('wheel',onUser,{passive:true,capture:true});
    rail.addEventListener('touchstart',onUser,{passive:true});
    rail.addEventListener('keydown',onUser);
    warmupFrames=0;
    requestAnimationFrame(()=>requestAnimationFrame(startAfterLayout));
  };
  const armKickoff=()=>{
    if(typeof IntersectionObserver!=='function'){
      kickoff();
      return;
    }
    viewportIo=new IntersectionObserver(entries=>{
      if(stopped)return;
      const hit=entries.some(e=>e&&e.isIntersecting);
      if(!hit)return;
      try{viewportIo.disconnect();}catch(_){/* IO unavailable */}
      viewportIo=null;
      kickoff();
    },{root:null,rootMargin:'0px 0px 12% 0px',threshold:0.08});
    viewportIo.observe(showcase);
  };
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',armKickoff,{once:true});
  }else{
    armKickoff();
  }
})();

/** Step 3 — fixed 4-slide review carousel; pause on hover/focus; PRM disables auto-advance (WCAG 2.2.2). */
function wsUploadReviewsCarousel(){
  const root=document.getElementById('wsUploadReviews');
  if(!root||root.dataset.wsReviewsInit==='1')return;
  root.dataset.wsReviewsInit='1';
  const track=root.querySelector('.ws-upload-reviews__track');
  const slides=track?Array.from(track.querySelectorAll('.ws-upload-reviews__slide')):[];
  const dots=Array.from(root.querySelectorAll('.ws-upload-reviews__dot'));
  if(!slides.length||slides.length!==dots.length)return;
  const SLIDE_COUNT=slides.length;
  const INTERVAL_MS=7000;
  let active=0;
  let timer=null;
  let pausedInteract=false;
  let stepVisible=false;
  let reduceMotion=false;
  try{
    reduceMotion=typeof window.matchMedia==='function'&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }catch(_){/* matchMedia unavailable */}
  const dotLabel=i=>{
    return String(wsT('upload.review.dot_aria')).replace('{n}',String(i+1)).replace('{total}',String(SLIDE_COUNT));
  };
  const refreshDotAria=()=>{dots.forEach((d,i)=>d.setAttribute('aria-label',dotLabel(i)));};
  window.wsRefreshUploadReviewDotAria=refreshDotAria;
  refreshDotAria();
  const setActive=i=>{
    const idx=((i%SLIDE_COUNT)+SLIDE_COUNT)%SLIDE_COUNT;
    active=idx;
    slides.forEach((s,j)=>{
      const on=j===idx;
      s.classList.toggle('is-active',on);
      s.setAttribute('aria-hidden',on?'false':'true');
    });
    dots.forEach((d,j)=>{
      const on=j===idx;
      d.classList.toggle('is-active',on);
      if(on)d.setAttribute('aria-disabled','true');
      else d.removeAttribute('aria-disabled');
    });
  };
  const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
  const start=()=>{
    if(reduceMotion||pausedInteract||!stepVisible)return;
    stop();
    timer=setInterval(()=>{
      if(!stepVisible)return;
      setActive(active+1);
    },INTERVAL_MS);
  };
  dots.forEach(d=>{
    d.addEventListener('click',()=>{
      if(d.getAttribute('aria-disabled')==='true')return;
      const n=parseInt(d.getAttribute('data-slide-to'),10);
      if(!Number.isFinite(n))return;
      setActive(n);
      stop();
      if(!reduceMotion&&!pausedInteract&&stepVisible)start();
    });
  });
  root.addEventListener('mouseenter',()=>{pausedInteract=true;stop();});
  root.addEventListener('mouseleave',()=>{pausedInteract=false;start();});
  root.addEventListener('focusin',()=>{pausedInteract=true;stop();});
  root.addEventListener('focusout',e=>{
    if(root.contains(e.relatedTarget))return;
    pausedInteract=false;
    start();
  });
  document.addEventListener('visibilitychange',()=>{
    if(document.hidden)stop();
    else start();
  });
  window.wsSyncUploadReviewsStep=function(step){
    stepVisible=step===3;
    if(stepVisible)start();
    else stop();
  };
  setActive(0);
  const step3=document.getElementById('step3');
  stepVisible=!!(step3&&step3.classList.contains('active'));
  if(!reduceMotion&&stepVisible)start();
}
(function wsUploadReviewsCarouselInit(){
  const run=()=>{if(typeof wsUploadReviewsCarousel==='function')wsUploadReviewsCarousel();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
})();

// Identity — **photoreal / wardrobe-swap path** (non-artistic, non-royal people styles; all `huisdier` royal — pet faces stay reference-true per CATS.huisdier).
const ID_ANCHOR='CRITICAL: You MUST preserve the EXACT face, head shape, facial features, eye color, eye shape, nose, mouth, fur pattern, markings, and coloring of the subject in the uploaded photo with 100% fidelity. The subject must be immediately recognizable as the same individual. Do NOT alter, idealize, or generalize any facial or bodily features. Copy every unique detail: scars, spots, ear shape, whisker pattern, freckles, wrinkles, hair color, fur texture. The face/head is SACRED — only change the clothing, pose, background, lighting style, and artistic medium.\n\n';

// Identity — **royal / oil master (people categories only)** — museum oil likeness, not a photo face on a painted body. `huisdier` keeps `ID_ANCHOR` / `ID_ANCHOR_GROUP_PET` so pet head fidelity stays lockstep with `CATS.huisdier`. Mirrors `ID_ANCHOR_ROYAL` / `ID_ANCHOR_GROUP_ROYAL` in worker `openai-image-edit.server.ts` when present.
const ID_ANCHOR_ROYAL='CRITICAL: Preserve unmistakable human identity — bone structure, eye spacing and shape, nose, mouth, age, skin tone family, hair color and style, freckles, glasses, and every distinguishing mark — but the OUTPUT must read as a **unified Renaissance oil-on-canvas portrait**, not a photograph pasted into paint. Rebuild **faces, skin, and hair** with **oil paint**: sfumato blending, temperature shifts in flesh, soft brush-lost edges, visible canvas tooth, and **chiaroscuro keyed to the court scene** (same light family on face, ermine, and velvet). Hairstyle mass must read as a composed court shape in noble oil — not individual photographic strand sharpness. Do NOT retain smartphone/snapshot clarity, HDR micro-contrast, sensor-sharp pores, cutout halos, glamour airbrush, or intact photographic facial texture. Do NOT idealize into a generic, doll-like, or stock portrait face. The subject must remain immediately recognizable through **painted** likeness only.\n\n';

const ID_ANCHOR_GROUP_ROYAL='CRITICAL: The reference image can contain MULTIPLE PEOPLE. Preserve EACH person as a DISTINCT individual — unique facial structure, skin tone, hair, facial hair, glasses, marks, and proportions. Do NOT reuse, clone, or duplicate one person\'s identity across multiple bodies. Render **every human face** fully IN **noble oil paint** — sfumato, glazing, brush-integrated edges — with **one consistent key light** across the group; never a photographic face on a painted body. Do NOT retain snapshot skin texture, flash mismatches, cutout halos, or phone-sharp facial detail. Do NOT collapse anyone into anonymous interchangeable courtiers. Preserve natural grouping — linked arms, rows, overlap — while translating wardrobe, throne-room setting, and medium into a **single museum-quality** composition.\n\n';

// Identity — **watercolor / popart / anime / nordic / lineart**: recognizable subject, deliberate **artwork** (matches server stitched prompts + DALL·E clamp path).
const ID_ANCHOR_ARTISTIC='CRITICAL: Preserve who the subject is — breed, markings, or human identity must stay unmistakable — but the OUTPUT must be a **deliberate non-photographic artwork** in the selected style. Stylize fur, skin, faces, and forms as **paint, ink, or illustration** as directed. Do NOT deliver an unedited photograph or a snapshot with only a background swap.\n\n';

/** Multi-figure **family/couple** categories: override singular ID_ANCHOR (photoreal path for non-royal). */
const ID_ANCHOR_GROUP='CRITICAL: The reference image can contain MULTIPLE PEOPLE. Preserve EACH person as a DISTINCT individual with their own facial structure, skin tone, hair, facial hair, glasses, and proportions. Do NOT reuse one person\'s facial identity for another figure. Do NOT clone or duplicate one face across multiple bodies. Each visible head in the reference must map to ONE uniquely recognizable painted figure. Preserve natural grouping — linked arms, rows, overlap, flash lighting — when translating into the artwork; only wardrobe into period dress, setting, background, and painterly medium change.\n\n';

const ID_ANCHOR_GROUP_ARTISTIC='CRITICAL: Multiple people may appear in the reference. Render EACH as a clearly DISTINCT illustrated character — different faces, hair, accessories — in the chosen art style. Do NOT copy one face onto multiple figures. Keep everyone recognizable as themselves while staying visibly **painted/illustrated**, not a raw photo.\n\n';

/** R-PET-MULTI-2 (Layer A) — multi-pet identity anchor (royal / oil
 *  master path). Mirrors `ID_ANCHOR_GROUP` (multi-people) for the pet
 *  pillar so the singular `ID_ANCHOR` "single primary subject" framing
 *  is replaced when the shopper declared two or more animals. The
 *  worker stitch uses its own compact identity prefix
 *  (`DALLE_COMPACT_IDENTITY_PREFIX`) and is not byte-aligned with this
 *  block — instead, the worker leans on the multi-animal SUBJECT-COUNT
 *  GUARD (emitted by `visionReconciliationClause`) to carry the
 *  preservation contract to the wire. The theme-side block here keeps
 *  the storefront-stitched prompt (used for proxy logs / fallback) and
 *  the `petPortraitFromClient` segment internally consistent. */
const ID_ANCHOR_GROUP_PET='CRITICAL: The reference image can contain MULTIPLE PET ANIMALS. Preserve EACH animal as a DISTINCT individual with its own breed, fur color, fur pattern, markings, ear shape, eye color, and unique physical traits. Do NOT reuse one animal\'s facial identity, fur pattern, or markings for another body. Do NOT clone or duplicate one animal across multiple figures. Do NOT invent extra animals not present in the reference photograph. Each visible animal must map to ONE uniquely recognizable painted figure preserving the natural grouping (lateral spacing, foreground / mid / back plane, overlap) translated into the artwork; only wardrobe, setting, background, and painterly medium change.\n\n';

const ID_ANCHOR_GROUP_PET_ARTISTIC='CRITICAL: Multiple pet animals may appear in the reference. Render EACH as a clearly DISTINCT illustrated figure — different breed, markings, fur, color, and accessories where present — in the chosen art style. Do NOT clone one animal\'s identity onto another. Do NOT invent extra animals not present in the reference photograph. Keep every animal recognizable as itself while staying visibly **painted/illustrated**, not a raw photo.\n\n';

// Prompt recipes match server `KNOWN_STYLE_EDIT_LINES` — royal resolves dynamically so Gezin never parallels animal-regalia cues unless Bond (`people`+`pet` slots) or category=`huisdier`.
// Phase 2 Slice 2c-2 (May 28 2026): `ROYAL_PROMPT_BODY_DUAL`,
// `ROYAL_PROMPT_BODY_PEOPLE_ONLY`, and `ROYAL_PROMPT_BODY_PET_BASE`
// deleted from the theme — the worker is the sole authority over the
// royal recipe body via `ROYAL_STYLE_EDIT_BODY_DUAL_SUBJECT`,
// `ROYAL_STYLE_EDIT_BODY_PEOPLE_ONLY`, and `ROYAL_STYLE_EDIT_BODY_PET_ONLY`
// in `wallstraight-app/wallstraight/app/lib/openai-image-edit.server.ts`
// (commits 5d9162a + 008865f + 246708f on bitbucket/main). Plan §4
// Phase 2 + §3.7 ("Phase 2 — `prompt_mode: server_only` flag + theme
// constants become read-only mirrors → DELETED in 2c-2 since the worker
// is fully lockstep").
//
// R19/R20 (`tasks/todo.md` §2.F, 2026-05-10): people-only royal recipe drops
// the 6-noun negation enumeration ("do NOT invent pets, cats, dogs, birds,
// heraldic beasts, or upright anthropomorphic animal companions") AND the
// sentence-fragment seam (". gold embroidery,…"). The body now flows as one
// comma list into the suffix; the human-only constraint is one positive
// sentence appended last. Mirror server `ROYAL_STYLE_EDIT_LINE_PEOPLE_ONLY`
// in `wallstraight-app/.../openai-image-edit.server.ts` when that repo is checked out (R21 lockstep).
//
// Phase 2 Slice 2c-2: `ROYAL_PROMPT_BODY_PEOPLE_ONLY` deleted. Worker
// `ROYAL_STYLE_EDIT_BODY_PEOPLE_ONLY` (`openai-image-edit.server.ts:131`)
// is authoritative; the historical R-ROYAL-UNITY v12 Slice A intent
// (crown de-prime + outdoor terrace translation) lives there.

/**
 * R-ROYAL-WARDROBE (May 2026) — fashion-brief Royal upgrade.
 *
 * Why this slice exists. The base `ROYAL_PROMPT_BODY_*` recipes lead with
 * `jeweled crown / ermine-trimmed robes / coronet for animal subjects`,
 * which biases the model toward the cliché "red robe + pasted crown"
 * look reported by stakeholders. We layer a curated wardrobe pick + an
 * identity-first human adjunct (hair / makeup / glasses / gesture / crown
 * integration) AFTER the recipe body. The adjunct keeps existing identity
 * anchors untouched (ID_ANCHOR_ROYAL preserves glasses + hair + age) and
 * never introduces gender from pixels — gender + makeup intensity are
 * sourced from optional shopper notes only (mirrors R-MIX11 /
 * `wsParseShopperAnimalCountFromNotes` philosophy: false negatives OK,
 * false positives forbidden). Server mirror lives in
 * `wallstraight-app/.../openai-image-edit.server.ts` ROYAL_HUMAN_STYLING_*.
 *
 * Tradeoffs documented in `.cursor/plans/royal_wardrobe_prompt_upgrade_*.plan.md`
 * §3C. Verification & guardrails in §3D / §3E. OpenAI cookbook guidance on
 * "explicit preserve-list + labeled constraint segments" for image edits:
 * https://developers.openai.com/cookbook/examples/multimodal/image-gen-1.5-prompting_guide
 * https://developers.openai.com/cookbook/examples/generate_images_with_high_input_fidelity
 */

/** Pet wardrobe pool — collar / doublet / vest / mantle / chain vocabulary; never crown-first.
 *  Last two entries (R-ROYAL-PET-BUST, May 2026) are bust-safe: lead with
 *  collar / medallion / mantle drape, no sleeves or doublet language, so a
 *  bust crop upload (Fenna exemplar) cannot inherit human-bodice priming
 *  from a randomly picked entry. The without-replacement picker preserves
 *  existing variants for full-body uploads. */
const ROYAL_WARDROBE_VARIANTS_PET=Object.freeze([
  'embroidered gold brocade waistcoat with dark velvet vest and ivory silk sleeves',
  'deep emerald velvet noble jacket with antique gold embroidery and pearl trim',
  'ivory and antique-gold brocade doublet with pearl trim and soft cream silk sleeves',
  'cream silk Renaissance doublet with bronze embroidery and soft antique fabric texture',
  'champagne silk court vest with delicate gold passementerie and ivory lawn collar',
  'burgundy velvet court vest with antique silver thread and satin cravat',
  'cream Renaissance noble jacket with muted bronze embroidery and jeweled chain',
  'jeweled ceremonial collar with ivory ermine mantle drape over the shoulders and an antique gold pendant medallion',
  'embroidered champagne brocade mantle with pearl-trimmed edge, deep velvet shoulder drape, and a refined jeweled chain of office'
]);

/** R-ROYAL-CLASSIC v17 — default premium-print solo pet wardrobe pool.
 *  Keeps Royal legibility while avoiding sleeve/doublet/pearl-chain priming
 *  that can turn pets into generic human court figures or busy AI costume art. */
const ROYAL_WARDROBE_VARIANTS_PET_CLASSIC=Object.freeze([
  'deep velvet ceremonial collar with restrained antique-gold embroidery and a small integrated pendant',
  'soft brocade mantle draped around the natural neck and chest contour with muted gold trim',
  'refined burgundy velvet shoulder drape with one tasteful jeweled clasp, face unobstructed',
  'warm umber court collar with subtle embroidered filigree and painterly fabric texture',
  'cream-and-gold heirloom mantle accent shaped to the animal chest and natural shoulder line'
]);

/** Female-coded wardrobe pool — gowns / bodices / mantles. Applied only when shopper notes carry an explicit female signal. */
const ROYAL_WARDROBE_VARIANTS_FEMALE=Object.freeze([
  'deep burgundy velvet gown with ermine-trimmed mantle, gold embroidery, and ruby jewelry',
  'ivory and gold brocade gown with pearl detailing, lace neckline, and refined ceremonial jewelry',
  'emerald velvet noble dress with antique gold trim and elegant jeweled necklace',
  'navy and gold aristocratic gown with embroidered bodice and soft fur-trimmed mantle',
  'champagne silk court dress with delicate lace, pearl accents, and regal embroidered sleeves'
]);

/** Male-coded wardrobe pool — doublets / coats / vests. Applied only when shopper notes carry an explicit male signal. */
const ROYAL_WARDROBE_VARIANTS_MALE=Object.freeze([
  'black velvet doublet with gold brocade slashing and white lawn collar',
  'deep navy ceremonial coat with ermine mantle and jeweled chain of office',
  'burgundy velvet noble jacket with antique gold embroidery and satin cravat',
  'emerald velvet court vest with bronze filigree and ivory silk sleeves',
  'charcoal aristocratic coat with muted gold passementerie and pearl stickpin'
]);

/** Neutral wardrobe pool — used when no explicit gender signal exists (solo zelf/kind default). */
const ROYAL_WARDROBE_VARIANTS_NEUTRAL=Object.freeze([
  'rich velvet and brocade noble attire with gold embroidery and tasteful jewel trim',
  'deep jewel-tone court garment with antique metallic thread and ceremonial tailoring',
  'ivory and gold Renaissance noble attire with lace or lawn detail',
  'navy and gold aristocratic ensemble with embroidered bodice or doublet front',
  'champagne and bronze court attire with pearl accents and a fur-trimmed mantle'
]);

/** R-ROYAL-PET-POSE (May 2026) — pet-specific finish clause. Replaces the
 *  legacy `ROYAL_FINISH_CLAUSE` for the solo-pet path so we no longer
 *  append "dignified centered pose" to every pet body — that wording
 *  flattened foreshortened paw-forward / leaning sources (Nana exemplar).
 *  Species-neutral; pose preservation lives in `ROYAL_PET_POSE_ADJUNCT`.
 *  Mirrors plan §4D split-finish design. Only referenced by
 *  `wsBuildRoyalPetBody`; the human recipe bodies carry their own finish
 *  language (`ROYAL_PROMPT_BODY_PEOPLE_ONLY` / `ROYAL_PROMPT_BODY_DUAL`). */
const ROYAL_FINISH_CLAUSE_PET=' Use warm Old Master oil-painting lighting, soft chiaroscuro, rich painterly brushwork, and a warm neutral umber or soft gallery background suitable for home display that frames the animal with timeless heirloom-portrait feel. Preserve the pet\'s gentle rustic outdoor character and natural coat texture where visible — refine into noble presentation without erasing sturdy farm or countryside energy.';

/** Human-specific Avoid block — extends the universal anti-cliché floor with human-portrait negatives (makeup, anatomy, identity drift). */
// R-ROYAL-UNITY v12 (May 2026), Slice F — Avoid extended with held-prop +
// surface-mismatch negatives that pair with the new `ROYAL_HUMAN_PROP_ADJUNCT`
// and the Slice C painterly props extension. OpenAI guidance: dual
// reinforcement via constraint sentences + Avoid negatives reduces drift
// (https://developers.openai.com/cookbook/examples/multimodal/image-gen-1.5-prompting_guide
//  §Constraints, verified 2026-05-20). All pre-v12 negatives preserved
// byte-for-byte so existing pins continue to pass.
const ROYAL_AVOID_CLAUSE_HUMAN=' Avoid: cheap cosplay styling, plastic-looking crowns pasted on top, thin male tiara or headband crowns, identical red-robes-only repetition across subjects, overly stiff generic poses, distorted hands, elongated spindly fingers, veiny aged hands mismatched to a youthful face, invented second hero hand when the reference shows one contact point, over-smoothed skin, age erasure, altered ethnicity, changed facial structure, heavy Instagram glam, harsh contour, glitter makeup, metallic highlighter, overdrawn lips, exaggerated false lashes, beauty-filter skin, pageant-style makeup, oily forehead shine, lip-gloss wetness, cosmetic specular on cheeks, photo-real face pasted into the painting, smartphone-sharp skin texture on the face, snapshot HDR micro-contrast on the head, inconsistent texture between face and clothing (face still looks photographic while the rest is painted), photo-sharp glass or drinkware inside the painting, photo-real held objects pasted into the painted scene, face or hands rendered sharper than clothing and background, photographic finger detail while the rest of the portrait is painted, windblown casual outdoor hair, sharp snapshot flyaway strands at the temples, unstyled long hair hanging like the outdoor source photograph, or a portrait that no longer resembles the uploaded person.';

/** R-ROYAL-PET-POSE (May 2026) — pet-specific Avoid block. Extends the v8
 *  breed/anatomy fidelity contract with **pose / perspective** negatives
 *  caught by the Nana paw-forward exemplar audit (plan §2). Species-
 *  neutral. Paired with `CATS.huisdier`, `petAnatomyGuard`, and the new
 *  `ROYAL_PET_POSE_ADJUNCT` so positive guidance + Avoid speak the same
 *  pose contract. */
const ROYAL_AVOID_CLAUSE_PET=' Avoid: generic red royal robes, oversized crowns dominating the head, cheap costume details, fantasy armor, changed breed, altered fur markings, cartoon anatomy, human-like uncanny features on the pet, flattened perspective that erases foreshortening present in the source, stiff generic posing that ignores the original viewpoint, paws replaced by hands or human-form limbs, or a swap of the source camera angle for an unrelated frontal bust, shortened body, generic seated bust that ignores a standing source stance, human-like upright chest, cartoon king headgear, or a stereotypical dark costume-drama template look, formal velvet cushion or throne pose when the source shows field-seated grounded posture, relocating a grounded grass pose to cushion or throne, or over-glamorized show-dog smoothing that erases rustic coat character, vertical human bodice or stiff human shoulders on the pet, ermine cape draped on invented human-shape shoulders, sleeves or noble jacket geometry on a head-and-upper-chest bust crop, lower torso invented below the visible crop of a bust source, stern monarch gaze replacing a sweet or playful original expression, cold ceremonial severity that loses the pet\'s personality, or any human-monarch body template grafted onto the animal head.';

/** R-ROYAL-CLASSIC v17 — random text/signature ban for both Classic and Fantasy.
 *  Customer QA flagged generated artist signatures / random pet names (e.g. "Kiki")
 *  as a checkout-confidence risk unless explicitly requested by the shopper. */
const ROYAL_PET_TEXT_SIGNATURE_AVOID=' No text, no random pet name, no Dutch generic pet words (Poes, Kat, Hond), no invented signature, no artist monogram, no POES-style corner lettering, no watermark, no decorative lettering, and no inscription unless the shopper explicitly requested exact painted dedication text in this prompt (MANDATORY PET NAME IN THE IMAGE, PORTRAIT DEDICATION, SHARED DEDICATION PLATE, or the user instruction block).';

/** R-ROYAL-CLASSIC v20 — default premium-print pet Royal stack (restraint pass). */
const ROYAL_CLASSIC_PET_BASE='Create a refined royal Old Master oil portrait of the uploaded pet as a premium living-room heirloom. Preserve exact pet identity first: breed or species, coat color, fur pattern, facial markings, ear shape, muzzle shape, eye color, eye shape, expression, and personality must remain owner-recognizable. Use dramatic chiaroscuro with slightly brighter key light on the face, warm umber accents, and a darker simplified background — not gold-on-gold clutter. The pet\'s face is the emotional center and must win at thumbnail and print size. Royal styling may include a restrained collar, shoulder drape, or mantle that follows the animal\'s natural contour — not a human court bodice. Regalia must never hide the face, flatten markings, invent human shoulders, or become the main subject. Keep ornamentation roughly 20–30% restrained versus fantasy royal; calm negative space over busy palace detail.';
const ROYAL_CLASSIC_CLUTTER_ADJUNCT=' Classic clutter translation: remove or soften casual phone-photo distractions such as bicycle handlebars, brake levers, cables, plastic pet beds, laundry, harsh household clutter, busy window blinds, and random foreground objects. MANDATORY when the reference shows a utilitarian wicker bicycle basket, plain pet carrier, or plastic pet bed: replace that support with a refined royal prop — a velvet- or silk-lined ceremonial basket with subtle gold trim, or a plush court cushion — while preserving the seated pose and paw placement; the output MUST NOT show raw utilitarian wicker weave, exposed bicycle hardware, or modern plastic. For other identity-supporting ledges or garden stone (not baskets or carriers), keep a simplified refined motif only. Never let props compete with the pet\'s face.';
const ROYAL_CLASSIC_POSE_ADJUNCT=' Classic composition: preserve the source camera angle, head tilt, gaze, seated/standing/lying posture, and foreshortening — including front-facing upright sits, paw-forward leans, and ground contact. Reframe only when the source is accidentally rotated, severely cluttered, or an unusable crop; never replace a clear seated pet with a generic human bust. If paws or full body matter to identity, keep natural animal proportions and placement.';
/* Audit Fix L1 (2026-05-23) — extended likeness preserve list per BA-001
   external reviewer + BA-005 (open-mouth smile). Lockstep with worker. */
const ROYAL_CLASSIC_LIKENESS_ADJUNCT=' Classic likeness: do not idealize into a slimmer, more symmetrical, younger, smoother, or generic show-pet version. Preserve blaze shapes, muzzle length, ear asymmetry, coat roughness, whisker pads, eye softness, and quirky owner-recognizable features even under painterly royal styling. Preserve the EXACT eye color from the reference (do not glossy-blue a brown-eyed dog); preserve grey muzzle and any age markers; preserve the original mouth set, including a relaxed open-mouth smile or playful tongue when present (do not flatten a happy expression into stern monarch severity).';
const ROYAL_CLASSIC_ANATOMY_ADJUNCT=' Classic anatomy: the animal keeps its species-real body — natural neck length, chest width, haunch placement, and visible paws when present in the source. Drape velvet or brocade around that anatomy like a royal cloth, not a human monarch torso. For seated or loaf poses facing the camera, preserve the compact sitting silhouette, front paws planted naturally, and avoid broad human shoulders or vertical doublet geometry.';
/* Audit Fix L1 (2026-05-23) — print separation extended for dark coats
   (BA-005 black Lab) + 10-15% face-area composition cue (BA-001 reviewer).
   Lockstep with worker. */
const ROYAL_CLASSIC_PRINT_ADJUNCT=' Classic print separation: brighten the face and whisker pad slightly against a darker, simpler background; keep orange, tabby, or light fur readable against robe and backdrop; avoid muddy all-gold atmosphere that collapses in print. For black or dark coats, add a soft warm edge-light along the muzzle, ear crest, and shoulder line so the silhouette separates from the painted ground at thumbnail size. Compose so the face occupies roughly 10–15% of the printable area (not lost in palace clutter), with restrained palace background and clear face-to-background tonal contrast for living-room wall art.';
/* Audit Fix B0 (2026-05-23) — stakeholder crown policy for solo pet.
   Stakeholder accepts crowns when worn-not-pasted, proportionate, and
   naturally angled (audit §3a). Reverses "default to NO crown" while
   keeping every NO-floating / NO-pasted / NO-human-head negation.
   Lockstep with worker. */
const ROYAL_CLASSIC_CROWN_ADJUNCT=' Crown integration: include a small, tasteful royal circlet by default — it must look worn on the skull (cranially seated, tilt axis matching the head\'s roll/pitch/yaw), pet-scaled (~8–12% of head width, not oversized for the breed or ear silhouette), warmly lit as part of the same painted surface, and never floating, pasted, or chrome-bright. Default a subtle circlet on every royal pet portrait, including tight bust crops; do not satisfy royalty with collar, mantle drape, or fabric alone. Omit only when integration would distort the ears or anatomy. Any crown stays secondary to the face, soft gold (not chrome-bright), minimal jewel detail, and never forced into a human head shape.';
const ROYAL_CLASSIC_FINISH_CLAUSE_PET=' Finish as museum-worthy printable wall art: one coherent painted surface, gentle atmospheric depth, readable face at thumbnail and print size, muted background detail, and refined Old Master texture. Final check: pet first, royal second; one clear subject hierarchy, no clutter, no random text.';
const ROYAL_CLASSIC_AVOID_CLAUSE_PET=' Avoid: heraldic crests competing with the pet, busy palace colonnades, crowded golden backgrounds, excessive pearl chains, jewelry covering the face or second pet, foreground bicycle parts, cables, brake levers, raw wicker bicycle baskets, exposed bicycle hardware, utilitarian plastic pet carriers, random household clutter, invented text, random names, artist signatures, watermarks, generic pet face, over-smoothed show-pet idealization, human shoulders, vertical human bodice, pasted costume seams, distorted animal anatomy, or a result that feels like stock AI fantasy instead of the shopper\'s own pet as a premium royal portrait.';

/** R-ROYAL-CLASSIC v24 — consolidated solo-pet Classic brief (ROYAL-SLIM + composition retention + GEN-B micro-patches). Lockstep worker `ROYAL_CLASSIC_PET_BRIEF`. */
const ROYAL_CLASSIC_PET_BRIEF='PRESERVE: Exact breed, coat, markings, eyes, expression, camera angle, head tilt, pose, paw placement, and foreshortening; preserve emotional warmth — no stern monarch face or generic show-pet idealization; bust crops stay head-and-upper-chest only with no invented lower torso, throne, cushion, or human bodice. TRANSFORM: Refined Old Master oil — dramatic chiaroscuro, brighter face key, muted simplified background (salon, garden court, or umber ground — not busy gold-on-gold clutter); remove or soften incidental foreground clutter that blocks the subject; velvet, silk, or brocade on natural anatomy, not human court bodice; preserve accessory hue and basket wicker shape; fabric draped, not armor; paws on ledge → plush velvet cushion; utilitarian wicker basket, carrier, or plastic bed → velvet- or silk-lined ceremonial basket or court cushion while preserving seated pose, paw placement, and reference head yaw, pitch, roll, and eye line — do not rotate the pet to face the camera if the source did not; grass or field → noble garden turf; outdoor light → terrace or garden court, not a dark indoor throne room; a small royal circlet by default, worn naturally on the skull with matching tilt, pet-scaled, same painted surface — omit only when integration would distort ears; nobility also via collar, mantle, or fabric. DO NOT: human shoulders, pasted costume, floating or chrome-bright crown, busy colonnades, props, baskets, or regalia blocking, occluding, or competing with the face, eyes, or focal mass, invented text, random names, signatures, or watermarks unless this prompt contains MANDATORY PET NAME IN THE IMAGE, PORTRAIT DEDICATION, SHARED DEDICATION PLATE, or MULTI-ANIMAL NAME PLATE. FINISH: one coherent painted surface, pet first, royal second, clear subject hierarchy,';

/** R-ROYAL-PET-POSE (May 2026) — pet pose / viewpoint preservation block.
 *  Species-neutral (cat, dog, rabbit, etc.); no human pose vocabulary;
 *  R-MIX11-safe (no pixel-derived pose detection — language is always-on
 *  for the solo-pet path). Reflects OpenAI GPT-Image-1.5 prompting
 *  guidance on "Composition: specify framing and viewpoint /
 *  perspective" (verified
 *  https://developers.openai.com/cookbook/examples/multimodal/image-gen-1.5-prompting_guide
 *  fetched 2026-05-20). */
const ROYAL_PET_POSE_ADJUNCT=' Pose & viewpoint: preserve the EXACT camera angle, framing, head tilt, body orientation, and any foreshortening present in the reference image (photograph, watercolor, or any painterly source). If the source shows paws extending toward the camera, a chest-forward lean, a side-glance, or a relaxed lying pose, render that same geometry in the painted portrait — do not reframe into a generic centered bust. If forelimbs extend toward the camera, preserve that foreshortening exactly — closer paws slightly larger, chest-forward lean and emotional warmth intact. If the source shows a standing or semi-standing full-body animal, preserve that stance, long-body proportions, leg length, and grounded scale — do NOT reframe into a seated royal bust or upright human-like torso. If the source shows a long-bodied dog or cat seated or crouched in grass or field, preserve the diagonal body axis, haunch-to-ground contact, and relaxed field posture — translate grass to aristocratic garden turf or terrace ground, not an upright bust or cushion throne. The animal stays an animal: paws, forelimbs, and natural anatomy keep their original placement and depth relationships.';

/** R-ROYAL-PET-POSE (May 2026) — garment-to-fur integration block. Forbids
 *  pasted-on costume reads and asks the model to drape attire over the
 *  natural animal body without crushing identifying markings. Pairs with
 *  `petAnatomyGuard` (no human limbs) and `petCoronetGuard` (crown
 *  geometry) on the server stitch chain. */
const ROYAL_PET_INTEGRATION_ADJUNCT=' Garment integration: tailor the chosen court attire to the animal\'s actual body shape so velvet, brocade, silk, and trim drape naturally over fur and natural anatomy — never pasted on top, never flattened against the chest. Keep facial markings, ear shape, and chest fur visible above the collar; ceremonial chains and trim follow the contour of the neck and shoulders. Blend neck fur into the collar opening; no hard cut between head and costume; shoulder mass follows real animal anatomy. Prefer cape, mantle, jeweled collar, or chest harness over a human noble jacket with sleeves when the body is visible.';

/** R-ROYAL-PET-PREMIUM (May 2026) — default-no-crown pet regalia block.
 *  Nobility reads through garment, collar, setting — not headgear. Complements
 *  server `petCoronetGuard` (cranial-axis geometry when a crown is rendered). */
const ROYAL_PET_CROWN_ADJUNCT=' Include a small, tasteful royal circlet by default — pet-scaled (~8–12% of head width), centered between or above the ears, cranially seated with the skull\'s tilt, the same warmly lit painted surface as the portrait, never covering eyes, crushing ears, floating, pasted, or chrome-bright. Default a subtle circlet on every royal pet portrait, including tight bust crops; do not rely on garment, jeweled collar, fabric, or grounded posture alone when a clean circlet fits. Omit only when integration would distort the ears or anatomy.';

/** R-ROYAL-PET-EXPRESSION (May 2026) — expression warmth preservation.
 *  Researcher feedback (Fenna exemplar): the v15 royal output shifted a
 *  "sweet expressive dog" into a "serious monarch" face. PET_BASE already
 *  asks for "expression completely unaltered" but that single-line
 *  preserve was being overridden by the implicit "regal / ceremonial"
 *  tone of the rest of the body. This dedicated adjunct repeats the
 *  preserve list (OpenAI cookbook §2 Constraints, verified 2026-05-20
 *   https://developers.openai.com/cookbook/examples/multimodal/image-gen-1.5-prompting_guide)
 *  and explicitly forbids ceremonial severity. Species-neutral — eye
 *  warmth and emotional character apply to any pet. */
const ROYAL_PET_EXPRESSION_ADJUNCT=' Expression: preserve the emotional warmth, eye softness, mouth set, and approachable character visible in the reference. Noble dignity must not become cold, stern, austere, or generic ceremonial severity — the pet keeps its original personality (sweet, playful, calm, or alert as in the source) and never adopts a human monarch\'s commanding gaze.';

/** R-ROYAL-PET-BUST (May 2026) — bust / artwork source composition guard.
 *  Closes the "head-and-upper-chest reference → invented human-monarch torso"
 *  failure mode (Fenna exemplar; commercial bust upload generated a vertical
 *  human bodice + ermine on human shoulders). Activates as an always-on
 *  conditional clause on the solo-pet royal path; when the reference shows
 *  paws, full body, or grounded field posture the existing pose adjunct
 *  branches dominate and this clause is a redundant preserve list.
 *  Species-neutral (dog, cat, rabbit, bird, other pet). Mirrors OpenAI
 *  gpt-image-1.5 cookbook guidance on "change only X" + repeat preserve list
 *  (verified 2026-05-20
 *   https://developers.openai.com/cookbook/examples/multimodal/image-gen-1.5-prompting_guide
 *  §2 Constraints + Composition).
 *  Lockstep: mirror in `wallstraight-app/.../openai-image-edit.server.ts`
 *  `royalPetStylingAdjunct` slot. */
const ROYAL_PET_BUST_SOURCE_ADJUNCT=' Bust and artwork sources: when the reference shows only head and upper chest (bust crop, white or simple background, no visible paws, haunches, or full body), preserve that exact front-facing bust composition and crop — do not invent a lower torso, throne, cushion, or seated court figure. Communicate royalty only within the visible neck and chest area through regal ceremonial collar, jeweled medallion, embroidered mantle drape, or refined shoulder covering that follows the animal\'s natural chest and neck contour. Do not create a human-like monarch body, vertical human bodice, stiff human shoulders, or sleeves on the visible silhouette. The animal must still read unmistakably as the same species and individual as the reference (any pet — dog, cat, rabbit, bird, or other). Change only style, regalia, and background — keep composition, crop, and expression the same.';

/** R-ROYAL-HAIR v15 (May 2026) — gender-split court hair. Researcher correction: do NOT force a pompous updo on every woman. */
const ROYAL_HUMAN_HAIR_MALE_ADJUNCT=' Hair: preserve the subject\'s original hair color and length character. Refine scalp hair into neat, period-appropriate court grooming — controlled side part, tidy hairline, trimmed length respecting short or long hair — integrated with beard or moustache when present. Do not style updos, chignons, pinned tendrils, half-up feminine arrangements, or any hairstyle that feminizes the subject. Do not leave hair looking casual, windblown, or unkempt.';
const ROYAL_HUMAN_HAIR_FEMALE_NEUTRAL_ADJUNCT=' Hair: preserve the subject\'s original hair color and overall hair character. Refine into a court-polished, intentionally composed noble hairstyle suited to the source photo — half-up noble styling, an elegant low chignon, pinned-back court hair with controlled romantic waves, or a polished arrangement. Long hair must be gathered, braided, or pinned into court shape — do not leave long hair hanging loose to respect length. Softly styled loose waves only when the source already shows a controlled wave, not windblown outdoor hair. Do not leave hair looking casual, flat, windblown, or unfinished like an outdoor snapshot, and do not create an extreme hairstyle that makes the person unrecognizable.';
const ROYAL_HUMAN_HAIR_FLYAWAY_POLISH_ADJUNCT=' Flyaway polish: temple and cheek wisps must read as soft painted S-curls or coiled court tendrils integrated into the same oil layer as the hairstyle — no sharp individual hairs, no smartphone flyaways, no frizz halo outside the hairstyle mass. If hair is already up, refine wisps only; do not rebuild the whole updo.';
const ROYAL_HUMAN_HAIR_BOND_EMPHASIS=' Bond portrait: the human\'s hairstyle must read as nobility in a palace portrait, not outdoor casual hair, even while holding or cradling the pet.';
const ROYAL_HUMAN_HAIR_NOTES_UPDO_EMPHASIS=' Shopper requested elegant court hair: prioritize gathered, pinned, or half-up noble styling over casual loose length for this render.';

/** Gesture / composition adjunct — preserve meaningful poses, hands. */
const ROYAL_HUMAN_GESTURE_ADJUNCT=' Composition: match the source storytelling. Anatomy beats gesture — preserve a meaningful pose only when physically plausible. Close-up sources become a graceful bust or half-length royal portrait. Elevate visible gestures into a dignified aristocratic pose; do not crop away important gestures when anatomy stays believable. Hands: five fingers, natural knuckles and wrists, no fused or mitten shapes, no elongated digits.';
const PEOPLE_BODY_PROPORTION_MARKER='Proportion:';
const PEOPLE_BODY_PROPORTION_ADJUNCT=' Proportion: preserve reference head, neck, shoulders, torso, hips, and posture — no tiny head, oversized shoulders, distorted build, or pasted costume; hands and fingers scaled to the face with age-consistent skin; limbs connected naturally; period dress drapes the reference silhouette; if a visible hand or limb would distort, simplify painterly, hide in sleeve or folds, or crop to a natural bust — never stretch anatomy for gesture, architecture, or scene translation.';
const ROYAL_HUMAN_BODY_PROPORTION_ADJUNCT=PEOPLE_BODY_PROPORTION_ADJUNCT;
const PEOPLE_SOLO_CONTACT_MARKER='Solo contact:';
const PEOPLE_SOLO_CONTACT_ADJUNCT=' Solo contact: when the reference shows one hand on architecture or a vertical edge, keep one relaxed contact at believable elbow height — do not stretch the arm, elongate fingers, invent a second display hand, or reach retitled frames; hide the off hand in sleeve, mantle, or folds when needed.';
const ROYAL_HUMAN_SOURCE_ATTIRE_ADJUNCT=' Attire: preserve visible outfit cues — lace, soft/white fabric, traditional dress, collars, bows, headwear — elevate into royal details (lace collar, pearl trim, embroidered bodice, harmonized headpiece); do not copy literally or swap for generic queen costume unless requested.';
const ROYAL_HUMAN_TEXT_SIGNATURE_AVOID=' No text, signature, monogram, watermark, or corner lettering unless the shopper explicitly requested exact painted dedication text in this prompt (MANDATORY PET NAME IN THE IMAGE, PORTRAIT DEDICATION, SHARED DEDICATION PLATE, MULTI-ANIMAL NAME PLATE, or the user instruction block).';

/** Glasses adjunct — restate ID_ANCHOR_ROYAL preserve-list as actionable instruction so the model holds eyewear under stylization. */
const ROYAL_HUMAN_GLASSES_ADJUNCT=' If the subject wears glasses central to their identity, preserve and integrate eyewear into the royal portrait — frames and lenses painted into scene chiaroscuro, not photo-sharp glass pasted on skin. Do not remove glasses by default.';

/** CROWN-3H (Prompt v51) — role-aware human crown hierarchy (mirror worker `buildRoyalHumanCrownAdjunct`). */
const HUMAN_CORONET_GUARD_MARKER='HUMAN CORONET GUARD';
const HUMAN_KING_CROWN_SPEC=' Male sovereign: structured monarch crown (rim, height, arches) on skull ellipse behind hairline — never forehead tiara; same oil as hair/face.';
function wsParseCrownRequestFromNotes(notesRaw){
  if(typeof notesRaw!=='string')return false;
  const t=notesRaw.toLowerCase();
  if(!t.trim())return false;
  return /\b(crown|kroon|coronet|tiara|king|queen|koning|koningin|monarch)\b/.test(t);
}
/** Mirror worker `buildRoyalHumanCrownAdjunct` — theme grep/tests only under server_only. */
function wsBuildRoyalHumanCrownAdjunct(gender){
  const ck=(S&&S.cat||'').trim().toLowerCase();
  const faceN=S&&S.faceDetStatus==='ok'&&typeof S.faceCount==='number'&&Number.isFinite(S.faceCount)?Math.floor(S.faceCount):0;
  const tpl=S&&S.royalSceneTemplate;
  const notesCrown=wsParseCrownRequestFromNotes(S&&S.userNotes);
  const verifyRes=S&&S.aiVerifyResult&&S.aiVerifyResult.result;
  const sourceHeadwear=verifyRes&&verifyRes.humanWearingHeadgear===true;
  const male=gender==='male';
  const base=' '+HUMAN_CORONET_GUARD_MARKER+': Equal royalty ≠ identical headpieces; never thin male tiara/headband; reinterpret source headwear; glasses — integrate or prefer chain/collar if crown distorts.';
  if(tpl==='court_of_equals')return base+' No mandatory crowns — nobility via robes, collars, chains, brooches, setting.';
  if(tpl==='monarchs_pair'&&ck==='koppel'&&faceN===2)return base+HUMAN_KING_CROWN_SPEC+' King and queen: monarch headpieces; consort distinct; both equally royal.';
  if(tpl==='royal_romance'&&ck==='koppel'&&faceN===2)return base+' Optional coronets; equal nobility via robes/jewels; no identical headpieces.';
  if(tpl==='noble_lineage'&&ck==='koppel'&&faceN===2)return base+(male?HUMAN_KING_CROWN_SPEC:'')+' Complementary crowns/coronets; distinct, not copy-paste.';
  if((ck==='gezin'&&faceN>=3)||(ck==='kind'&&faceN>=3))return base+' Hierarchy: leaders may wear crowns; others age-scaled circlets/collars/ribbons; never copy-paste crowns.';
  if(ck==='gezin'&&faceN===2)return base+(male?HUMAN_KING_CROWN_SPEC:'')+' Two adults: complementary regalia when reference shows two adults; no forced parent+infant heir headpieces unless infant in reference.';
  if((ck==='zelf'||ck==='kind')&&faceN<=1){
    const headpiece=notesCrown||sourceHeadwear?' headpiece when source headwear or notes request it.':' optional headpiece only when integration is clean.';
    return base+' Solo noble: prefer robe, collar, chain, setting;'+headpiece+(male&&(notesCrown||sourceHeadwear)?HUMAN_KING_CROWN_SPEC:'');
  }
  if(faceN>=2)return base+(male?HUMAN_KING_CROWN_SPEC:'')+' Leading adults: headpieces when role/scene require; others royal via garments/insignia.';
  return base+' Nobility via robes, collars, chains, setting; headpiece optional unless source, notes, or monarch scene require.'+(male&&notesCrown?HUMAN_KING_CROWN_SPEC:'');
}
const PEOPLE_BOND_CONTACT_EXTENSION=' Preserve inter-human and hand-to-pet contact with connected wrists and sleeves; no floating hands or paw-shaped shoulders.';
const ROYAL_BOND_GROUP_CONTACT_EXTENSION=PEOPLE_BOND_CONTACT_EXTENSION;

/** Regency-inspired makeup base — period-drama radiance, identity-preserving. NEVER use a trademark show name.
 *
 *  R-ROYAL-UNITY v12 (May 2026), Slice B — `realistic skin texture` wording
 *  removed. It contradicted the universal `ROYAL_HUMAN_PAINTERLY_SURFACE_ADJUNCT`
 *  ("rebuild the face, skin, neck, and hands as a true Old Master oil"),
 *  and was the **female/neutral** counterpart of the male-grooming photo-
 *  literal seam fixed in the original R-ROYAL-PAINTERLY ship. Replaced
 *  with painted-skin massing language so makeup blocks describe pigment
 *  placement on a painted surface rather than competing photo-real
 *  skin (researcher Gino exemplar photo-collage root cause). */
const ROYAL_HUMAN_MAKEUP_BASE=' Makeup: preserve the subject\'s natural facial identity — face shape, eyes, nose, lips, skin tone, expression, and age-appropriate details must remain recognizable. Apply refined Regency-inspired aristocratic makeup for a premium royal portrait: painted-skin massing with subtle brush texture and scene-keyed oil highlights (no photographic pore detail, oily T-zone shine, or smartphone flash on skin), soft rose or peach blush, softly defined brows, delicate taupe eye shading, subtle liner, natural lashes, and rose or berry lips as glazed pigment — expensive, painterly, romantic, not Instagram glam. If identity-defining makeup is present (bold red lipstick, winged liner, distinctive brows, glasses), preserve hue and shape as soft-edged ruby or berry oil glaze with brush feathering — never lip-gloss wetness or cosmetic specular. Do not erase identity-defining features.';

/** R-ROYAL-PAINTERLY (May 2026) — male-coded grooming adjunct. Applied
 *  when explicit male gender signal is present, in place of the full
 *  female-coded makeup block. Plan §3C requires removal of the
 *  legacy "realistic skin texture" wording — it conflicted with the
 *  intended painterly surface and was the root-cause flag for male
 *  subjects rendering photo-literal inside an otherwise painted
 *  scene (Ravi exemplar audit). Replaced with painterly-medium
 *  language; the universal `ROYAL_HUMAN_PAINTERLY_SURFACE_ADJUNCT`
 *  then provides the cross-gender oil-paint unification layer. */
const ROYAL_HUMAN_GROOMING_ADJUNCT=' Grooming: noble oil-paint skin rendering with controlled tonal shaping (no photographic skin texture), period-appropriate tidy brows and (if present in the source) tidy beard or moustache integrated into the same painted surface as the rest of the portrait; do not feminize features or over-smooth the skin.';

/** R-ROYAL-PAINTERLY (May 2026) — universal painterly-surface adjunct.
 *  Fires for EVERY people-category royal path (male grooming, female
 *  makeup tiers, neutral) so face, skin, and hands are rebuilt as a
 *  true Old Master oil surface that matches the painted clothing and
 *  background — closing the female-Instagram-glam and male-photo-
 *  literal seams in one shared block. Identity preservation language
 *  is repeated locally to reinforce `ID_ANCHOR_ROYAL`; the adjunct
 *  speaks about rendering medium, NOT pigment placement or hair, so
 *  it does not contradict the gender-routed makeup / grooming block
 *  above it. Wording aligned with OpenAI GPT-Image-1.5 Prompting Guide
 *  § Constraints: "repeat the preserve list on each iteration to
 *  reduce drift" (verified
 *  https://developers.openai.com/cookbook/examples/multimodal/image-gen-1.5-prompting_guide
 *  fetched 2026-05-20) and § Style: "rendering medium ... oil, brush
 *  texture, chiaroscuro". gpt-image-2 omits `input_fidelity` (verified
 *  https://platform.openai.com/docs/guides/image-generation
 *  L928 fetched 2026-05-20) — this adjunct does NOT fight native
 *  high-fidelity face preservation; it speaks to surface medium only. */
const ROYAL_HUMAN_PAINTERLY_SURFACE_ADJUNCT=' Painterly surface (all subjects): preserve identity strongly — face shape, eyes, nose, lips, skin tone, expression, age, ethnicity, and hands stay recognizable — but rebuild face, skin, neck, and hands as true Old Master oil: softened edges, controlled tonal massing, subtle brush texture, chiaroscuro keyed to scene lighting. Hand skin matches face age and glaze — no veiny aged hands on a youthful face. Unify face, hands, clothing, jewelry, and background into one painted surface — no smartphone sharpness, HDR micro-contrast, oily T-zone, snapshot lighting, or photo skin on face or hands while the rest is painted. Lips and cheeks are glazed pigment on the same canvas as velvet. Extend the same oil surface to held objects, glassware, and jewellery — painted ceremonial items in scene chiaroscuro, never photo-sharp objects pasted into the painting.';

/**
 * R-ROYAL-UNITY v12 (May 2026), Slice D — held-prop adjunct.
 *
 * Closes the researcher Gino exemplar gap: the painterly surface block
 * (Slice C now) covers face / hands / clothing / jewellery / background,
 * but the model still rendered a modern glass photo-sharp inside the
 * otherwise painted royal scene. This adjunct adds explicit IF-language
 * to translate any meaningful HELD prop (glass, cup, bottle, phone,
 * book, instrument, sunglasses held in hand, etc.) into a painted
 * aristocratic equivalent rendered in the same oil-paint brush layer
 * as the face and clothing.
 *
 * Bond / companion guardrail: this block explicitly EXCLUDES the pet-
 * companion case. When the human is holding a pet, `ROYAL_HUMAN_HOLD_ADJUNCT`
 * (gated on `wsHasRoyalPetCompanion()`) covers the protective hold
 * geometry separately. Wording carefully omits `animal`, `paw`,
 * `collar`, `quadruped` so the model does not conflate the two slots.
 *
 * Wording aligned with OpenAI GPT-Image-1.5 Prompting Guide § 5.1
 * Style Transfer ("describe what must stay consistent (style cues)
 * and what must change (new content), add hard constraints") and
 * § Constraints ("`change only X` + repeat preserve list", verified
 * https://developers.openai.com/cookbook/examples/multimodal/image-gen-1.5-prompting_guide
 * fetched 2026-05-20).
 *
 * Inserted in the `wsBuildRoyalHumanAdjunct` block order between
 * `ROYAL_HUMAN_GESTURE_ADJUNCT` (preserves gesture) and
 * `ROYAL_HUMAN_CROWN_ADJUNCT` (CROWN-2H default integrated headpiece). Worker
 * mirror lives in `royalHumanStylingAdjunct` (
 * `wallstraight-app/wallstraight/app/lib/openai-image-edit.server.ts`).
 */
const ROYAL_HUMAN_PROP_ADJUNCT=' Held prop: when source shows a meaningful held object (glass, cup, bottle, phone, book, sunglasses — NOT pet), preserve hand gesture; reinterpret as painted aristocratic equivalent in scene chiaroscuro (goblet, flask, locket, leather volume). Never photo-pasted.';

/** R-ROYAL-BOND-COMPANION (May 2026) — protective-hold preservation block.
 *  Fires alongside the companion adjunct so the model treats the hand
 *  placement that defines the bond (cradle, chest-hold, shoulder-rest)
 *  as an invariant. Kept separate from `ROYAL_HUMAN_GESTURE_ADJUNCT` so
 *  the v8 gesture pin (regex-pinned in `royal-human-adjunct.test.js`)
 *  stays untouched. Always-on inside the companion path; suppressed
 *  outside it via the `wsHasRoyalPetCompanion()` gate so solo-human
 *  flows stay byte-identical to v8. */
const ROYAL_HUMAN_HOLD_ADJUNCT=' Hold: if the person holds, cradles, leans into, or rests their hand on the pet, preserve that exact hand placement, protective hold geometry, and any wrapping of fingers around the animal\'s body. Render hands with anatomically correct fingers, knuckles, and natural wrapping around the pet — the bond pose is part of the subject\'s identity.';

/** Audit Fix E2 / BA-011 (May 2026) — NO-INVENT-SUBJECT guard for people-category
 *  royal when no pet routing signal. Mirror worker `noInventSubjectGuard`
 *  (`openai-image-edit.server.ts` ORCH-3). Marker substring detected for
 *  `no_invent_subject_guard_fired` telemetry. OpenAI cookbook §2 Constraints:
 *  PRESERVE / TRANSFORM / DO-NOT + explicit exclusions
 *  (https://developers.openai.com/cookbook/examples/multimodal/image-gen-models-prompting-guide). */
const NO_INVENT_SUBJECT_GUARD_MARKER='NO-INVENT-SUBJECT GUARD';
const NO_INVENT_SUBJECT_GUARD_CLAUSE=' NO-INVENT-SUBJECT GUARD: the reference photograph shows human subjects only — no dog, cat, bird, or other animal is visible in the upload. PRESERVE: every human figure actually present in the reference with exact likeness — face, skin tone, hair, glasses, pose, and inter-subject contact (linked arms, hands on shoulders) as captured. TRANSFORM: only clothing, regalia, environment, lighting medium, and artistic style into the royal portrait look. DO NOT invent dogs, cats, birds, lapdogs, court pets, heraldic beasts, quadrupeds, pet collars, paws, muzzles, whiskers, animal tails, or anthropomorphic animal courtiers. DO NOT add a companion animal, foreground pet, or royal lapdog trope to fill empty center space. The photograph defines who is in the portrait — the category defines the styling, not additional subjects. ';
/** HALL-1 / Self inverse — pet-only upload on a people storefront category. Mirror
 *  worker `noInventHumanGuard` + ANTI-INVERSION substring in
 *  `visionReconciliationClause`. Marker for `no_invert_species_guard_fired`. */
const NO_INVENT_HUMAN_GUARD_MARKER='NO-INVENT-HUMAN GUARD';
const NO_INVENT_HUMAN_GUARD_CLAUSE=' NO-INVENT-HUMAN GUARD: the reference photograph shows an animal subject only — no human person, child, adult, hand, arm, courtier, lap-holder, or silhouette figure is visible in the upload. PRESERVE: the animal\'s exact breed or species, fur color, fur pattern, facial markings, ear shape, eye color, muzzle, expression, pose, and every unique physical trait with maximum fidelity. TRANSFORM: only clothing, regalia, collar, environment, lighting medium, and artistic style into the pet portrait look. DO NOT invent humans, human hands, human arms, human torsos, human faces, courtiers, nobles, lap-holders, silhouettes, or anthropomorphic human anatomy on the animal. DO NOT add a human figure to hold the pet or fill empty center space. The photograph defines who is in the portrait — the category informs styling, not additional species. ';

/** BA-011 — couple/group contact pose anatomy when no pet companion is present. */
const PEOPLE_COUPLE_CONTACT_MARKER='Preserve arm-around-shoulder';
const PEOPLE_COUPLE_CONTACT_ADJUNCT=' Preserve arm-around-shoulder and embrace with limbs on correct torsos; no floating hands. Overlap/clasp — simplify painterly; plausible anatomy; hide ambiguous fingers in sleeves/folds. Eyewear on nose bridge. ';
const ROYAL_COUPLE_CONTACT_ADJUNCT=PEOPLE_COUPLE_CONTACT_ADJUNCT;

/** BA-011 — translate source indoor/window key light into unified painted chiaroscuro. */
const ROYAL_SOURCE_LIGHTING_TRANSLATION_ADJUNCT=' Source lighting translation: read the warm or cool key-light direction and shadow ratio visible in the reference (indoor tungsten, window light, or flash). Translate into painted Old Master chiaroscuro that keeps the same emotional warmth and shadow direction on every visible face — one consistent key light across the group. Do NOT apply symmetric front studio glare, HDR face blowout, or mismatched lighting between subjects. ';

/** R-ROYAL-BOND-COMPANION (May 2026) — human + pet companion adjunct.
 *  Closes the Ravi + puppy exemplar gap from R-ROYAL-WARDROBE v8 (plan
 *  §2B). For human-on-people-category uploads with a visible companion
 *  pet, v8 emitted no positive pet-styling guidance:
 *  `wsBuildRoyalHumanAdjunct` short-circuited only for `huisdier`;
 *  `wsBuildRoyalPetBody` only reached for solo `huisdier`. The
 *  companion adjunct sits inside the human adjunct and tells the model
 *  to treat the pet as a co-subject — subtle accessories (collar /
 *  medallion / ribbon / mini blanket) proportional to the animal\'s
 *  size, never a forced oversized crown on a tiny or short-snouted
 *  animal. Stylistic unification (same painterly brush layer for pet
 *  and human) is explicit so the pet does not read as a photo pasted
 *  into paint. Species- and size-neutral. Gated by
 *  `wsHasRoyalPetCompanion()`. Wording aligned with OpenAI GPT-Image-1.5
 *  Prompting Guide § Constraints: "use 'change only X' + 'keep
 *  everything else the same' and repeat the preserve list" (verified
 *  https://developers.openai.com/cookbook/examples/multimodal/image-gen-1.5-prompting_guide
 *  fetched 2026-05-20). */
const ROYAL_HUMAN_PET_COMPANION_ADJUNCT=' Companion pet: this is a royal portrait of the person AND the pet together, not a human portrait with an accessory animal. Give the pet a subtle royal companion detail proportional to its size — a small velvet collar, a delicate jewelled medallion, an embroidered ribbon, a miniature ceremonial blanket, or another tasteful aristocratic accessory — so it visibly belongs to the same kingdom as the human subject. Do NOT cover the pet\'s face, do NOT force a large crown on a small or short-snouted animal, and do NOT age the pet up or overdress it. Preserve the pet\'s natural size, innocence, breed, fur color, fur pattern, facial markings, ear shape, and eye color exactly. Render the pet in the same painterly Old Master brush layer, lighting key, and tonal palette as the human — both subjects share one unified canvas, neither pasted in.';

/** Makeup intensity tier clauses. Default is `refined`. `natural` and `queen` selected only via explicit notes keywords. */
const ROYAL_MAKEUP_INTENSITY_NATURAL=' Intensity: very soft aristocratic makeup — gentle blush, neutral eyes, natural rose lips.';
const ROYAL_MAKEUP_INTENSITY_REFINED=' Intensity: polished Regency makeup — rose blush, softly defined eyes, elegant berry or rose lips.';
const ROYAL_MAKEUP_INTENSITY_QUEEN=' Intensity: regal formal makeup — defined brows, soft smoky taupe eyes, refined ruby or berry lips; tasteful, never modern glam.';

/** Pure helper: returns N distinct random picks (without replacement) from a frozen variant pool. Bounded by `pool.length`. */
function wsPickRoyalWardrobeVariants(pool,count){
  const arr=Array.isArray(pool)?pool.slice():[];
  if(arr.length===0)return [];
  const want=Math.max(1,Math.min(Number(count)||1,arr.length));
  for(let i=arr.length-1;i>0;i--){
    const j=Math.floor(Math.random()*(i+1));
    const tmp=arr[i];arr[i]=arr[j];arr[j]=tmp;
  }
  return arr.slice(0,want);
}

/** Format wardrobe picks as a single prompt clause. One pick → "Wardrobe: …";
 *  multiple → numbered per-subject list + cohesive-palette hint that mirrors
 *  the server `PER_PERSON_WARDROBE_GUARD` language so the theme + worker
 *  surfaces send the model a single, consistent contract. */
function wsBuildRoyalWardrobeClause(picks){
  if(!Array.isArray(picks)||picks.length===0)return '';
  if(picks.length===1)return ' Wardrobe: '+picks[0]+'.';
  const parts=[];
  for(let i=0;i<picks.length;i++)parts.push('subject '+(i+1)+' in '+picks[i]);
  return ' Wardrobe (per visible subject, distinct per individual): '+parts.join('; ')+
         '. Cohesive palette across the group; each garment is a separate commissioned piece, never copy-paste regalia.';
}

/**
 * Parse an explicit gender signal from optional shopper notes.
 * Returns `'female' | 'male' | null`. **Never inferred from pixels** (R-MIX11).
 * Conservative — false negatives OK, false positives forbidden. Mirrors the
 * worker reader `readRoyalGenderSignal`.
 *
 * Keywords (lowercased, word-bounded):
 *   female: she, her, hers, woman, wife, mother, mom, daughter, sister, girl,
 *           ma'am, queen, princess; NL: zij, haar, vrouw, moeder, mam,
 *           dochter, zus, meisje, prinses
 *   male:   he, him, his, man, husband, father, dad, son, brother, boy,
 *           sir, king, prince; NL: hij, hem, zijn, man, vader, pap, zoon,
 *           broer, jongen, prins
 *
 * Conflicting signals → `null` (defer to neutral pool).
 */
function wsParseGenderSignalFromNotes(notesRaw){
  if(typeof notesRaw!=='string')return null;
  const text=notesRaw.toLowerCase();
  if(!text.trim())return null;
  const FEMALE=/\b(she|her|hers|woman|wife|mother|mom|mum|daughter|sister|girl|ma'am|queen|princess|zij|haar|vrouw|moeder|mam|dochter|zus|meisje|prinses)\b/;
  const MALE=/\b(he|him|his|man|husband|father|dad|son|brother|boy|sir|king|prince|hij|hem|zijn|vader|pap|papa|zoon|broer|jongen|prins)\b/;
  const f=FEMALE.test(text);
  const m=MALE.test(text);
  if(f&&!m)return 'female';
  if(m&&!f)return 'male';
  return null;
}

/**
 * R-VERIFY-2 (May 2026) — read a typed `presentedGender` field off the
 * AI verify cached result. The worker's `server-subject-verify.server.ts`
 * `SUBJECT_VERIFY_JSON_SCHEMA` is the source of truth for the field; until
 * it ships the schema extension this reader is a strict no-op (returns
 * `null` for missing / unknown values) so the existing notes → template →
 * neutral ladder is byte-identical.
 *
 * R-MIX11 nuance: R-MIX11 bans pixel-heuristic inference from the theme
 * (face boxes, subjectClass scores, raw bitmaps). A typed JSON field
 * produced by a structured-output classifier (worker → OpenAI Structured
 * Outputs, `gpt-4o-mini` per docs/requirements-human-portraits.md) is
 * different in kind: the field is enumerated (`'female' | 'male' |
 * 'neutral' | 'mixed' | undefined`), schema-validated, and arrives over
 * the same trusted server channel that already supplies `hasHuman`,
 * `hasPet`, and `estimatedHumanFaces` (read by `wsApplyAiVerifyToState`
 * around L4183). Only `'female'` and `'male'` are honoured here so a
 * `'mixed'` group falls through to the explicit-template / neutral
 * branches and Phase 1c per-subject splitting (see plan §1c) owns the
 * eventual mixed-gender styling.
 *
 * Forward-compatible: returns `null` whenever the field is absent,
 * mis-typed, or any value other than `'female' | 'male'`.
 */
function wsParseGenderSignalFromVerify(result){
  if(!result||typeof result!=='object')return null;
  const v=result.presentedGender;
  if(v==='female'||v==='male')return v;
  return null;
}

/**
 * R-VERIFY-ATTIRE v19 — typed attire flags from subject-verify JSON.
 * Only honours high/medium confidence and strict `true` booleans.
 */
function wsParseAttireSignalsFromVerify(result){
  if(!result||typeof result!=='object')return {headwear:false,lace:false,traditional:false};
  const conf=result.confidence;
  if(conf!=='high'&&conf!=='medium')return {headwear:false,lace:false,traditional:false};
  return {
    headwear:result.humanWearingHeadgearInSource===true,
    lace:result.visibleLaceOrWhiteFabric===true,
    traditional:result.visibleTraditionalOrCeremonialDress===true,
  };
}

/** Dynamic 1-line elevation when verify confirms distinctive attire/headwear. */
function wsBuildRoyalVerifyAttireAdjunct(signals){
  if(!signals||typeof signals!=='object')return '';
  const headwear=signals.headwear===true;
  const lace=signals.lace===true;
  const traditional=signals.traditional===true;
  if(!headwear&&!lace&&!traditional)return '';
  const cues=[];
  if(traditional)cues.push('traditional or ceremonial dress');
  if(lace)cues.push('lace or soft white fabric');
  if(headwear)cues.push('distinct headwear');
  return ' Attire (verify): source shows '+cues.join(', ')+' — elevate these cues into refined royal collar, pearl trim, embroidered bodice, and a headpiece inspired by the original silhouette; do not erase them for a generic queen costume.';
}

/**
 * Resolve the gender signal for Royal styling. Precedence ladder
 * (highest → lowest):
 *   1. Explicit shopper notes keyword (`wsParseGenderSignalFromNotes`).
 *   2. Explicit scene-template casting (`royal_heir_baby_princess` →
 *      female; `royal_heir_baby_prince` → male).
 *   3. AI verify typed `presentedGender` (R-VERIFY-2, forward-compatible —
 *      no-op until worker ships the schema extension).
 *   4. Neutral default.
 *
 * Pixels are NEVER consulted directly from the theme (R-MIX11). The verify
 * read at rung 3 is a typed JSON field, not a pixel heuristic — see
 * `wsParseGenderSignalFromVerify` for the policy nuance. Returns one of
 * `'female' | 'male' | 'neutral'`. Mirrors worker `inferRoyalGenderSignal`
 * (same precedence ladder so theme and worker agree on the picked pool).
 */
function wsInferRoyalGenderSignal(){
  const notesSignal=wsParseGenderSignalFromNotes(S&&S.userNotes);
  if(notesSignal)return notesSignal;
  const tpl=S&&S.royalSceneTemplate;
  if(tpl==='royal_heir_baby_princess')return 'female';
  if(tpl==='royal_heir_baby_prince')return 'male';
  const verifyResult=(S&&S.aiVerifyResult&&typeof S.aiVerifyResult==='object')?S.aiVerifyResult.result:null;
  const verifySignal=wsParseGenderSignalFromVerify(verifyResult);
  if(verifySignal)return verifySignal;
  return 'neutral';
}

/**
 * Parse makeup intensity tier from optional shopper notes. Returns
 * `'natural' | 'queen' | null`. `null` → caller defaults to `'refined'`.
 * Conservative parser; mirrors worker `readRoyalMakeupIntensity`.
 *
 *   natural triggers: "natural makeup", "minimal makeup", "light makeup",
 *                     NL: "natuurlijke make-up", "weinig make-up"
 *   queen triggers:   "bold makeup", "red lipstick", "formal makeup",
 *                     "rode lippenstift", "felle make-up"
 */
function wsParseMakeupIntensityFromNotes(notesRaw){
  if(typeof notesRaw!=='string')return null;
  const t=notesRaw.toLowerCase();
  if(!t.trim())return null;
  const NAT=/\b(natural\s+makeup|natural\s+make[\s-]?up|minimal\s+make[\s-]?up|light\s+make[\s-]?up|no\s+makeup|natuurlijke\s+make[\s-]?up|weinig\s+make[\s-]?up|minimale\s+make[\s-]?up)\b/;
  const QN=/\b(bold\s+make[\s-]?up|red\s+lipstick|formal\s+make[\s-]?up|dramatic\s+make[\s-]?up|rode\s+lippenstift|felle\s+make[\s-]?up|formele\s+make[\s-]?up)\b/;
  if(QN.test(t))return 'queen';
  if(NAT.test(t))return 'natural';
  return null;
}

/** Resolve the makeup intensity for this generate turn. Defaults to `refined`. */
function wsResolveRoyalMakeupIntensity(){
  const tier=wsParseMakeupIntensityFromNotes(S&&S.userNotes);
  return tier||'refined';
}

/** Map gender signal → wardrobe variant pool. */
function wsRoyalWardrobePoolForGender(sig){
  if(sig==='female')return ROYAL_WARDROBE_VARIANTS_FEMALE;
  if(sig==='male')return ROYAL_WARDROBE_VARIANTS_MALE;
  return ROYAL_WARDROBE_VARIANTS_NEUTRAL;
}

/**
 * R-ROYAL-WARDROBE — resolve the random wardrobe picks + gender + makeup
 * intensity for this generate turn and write them onto `S`. Called once
 * from `generate()` BEFORE `wsComposeStylePrompt` so every builder reads
 * the same picks (mirrors `wsParseShopperAnimalCountFromNotes` precedence
 * for `S.shopperAnimalCount`).
 *
 * For `huisdier`: pool is pet; pick count tracks shopperAnimalCount when
 * present (Layer B consumes per-pet picks). For people categories: pool
 * is gender-routed; pick count is 1 for solo, 0 for groups with an active
 * scene template (server `royalSceneAugmentClause` owns per-person wardrobe).
 */
/** R-ROYAL-WARDROBE-BOND (May 2026) — positive predicate for "true solo-pet
 *  huisdier" so the wardrobe resolver does not assign the PET pool when the
 *  category is huisdier but the upload is human-primary (P0), explicit Bond
 *  (slots), or implicit mixed_single_photo (vision-confirmed human+pet on a
 *  single photo). Mirrors the routing already encoded by `wsRoyalPromptBody`:
 *   - `wsIsHumanPrimaryOnPetCategory()` → people-only royal body
 *   - `wsSlotsBondComposition() || wsImplicitMixedSinglePhotoBond()` → DUAL body
 *  In those cells the human adjunct (people wardrobe pool) is the source of
 *  truth, so the resolver must fall through to the gender-routed branch
 *  rather than short-circuiting to PET. */
function wsIsRoyalPetSoloHuisdier(){
  if(S.cat!=='huisdier'&&!wsIsPetPrimaryOnPeopleCategory())return false;
  if(wsIsPetPrimaryOnPeopleCategory())return true;
  if(typeof wsIsHumanPrimaryOnPetCategory==='function'&&wsIsHumanPrimaryOnPetCategory())return false;
  if(typeof wsSlotsBondComposition==='function'&&wsSlotsBondComposition())return false;
  if(typeof wsImplicitMixedSinglePhotoBond==='function'&&wsImplicitMixedSinglePhotoBond())return false;
  return true;
}

function wsResolveRoyalVariant(){
  const explicit=S&&S.royalVariant;
  if(explicit==='fantasy')return 'fantasy';
  const notes=typeof (S&&S.userNotes)==='string'?S.userNotes:'';
  if(/\b(fantasy\s+royal|ornate\s+royal|palace\s+fantasy|fairytale\s+royal|fantasie|sprookjesachtig)\b/i.test(notes))return 'fantasy';
  return 'classic';
}

function wsResolveRoyalWardrobePicks(){
  S.royalWardrobePicks=[];
  S.royalGenderSignal=null;
  S.royalMakeupIntensity=null;
  if(wsNormalizeStyleKey(S&&S.style)!=='royal')return;
  if(wsIsRoyalPetSoloHuisdier()){
    const n=wsIsMultiAnimalShopperDeclared()?Math.max(1,Math.floor(S.shopperAnimalCount||1)):1;
    const pool=wsResolveRoyalVariant()==='classic'?ROYAL_WARDROBE_VARIANTS_PET_CLASSIC:ROYAL_WARDROBE_VARIANTS_PET;
    S.royalWardrobePicks=wsPickRoyalWardrobeVariants(pool,Math.min(n,pool.length));
    return;
  }
  const gender=wsInferRoyalGenderSignal();
  S.royalGenderSignal=gender;
  S.royalMakeupIntensity=wsResolveRoyalMakeupIntensity();
  const pool=wsRoyalWardrobePoolForGender(gender);
  // R-ROYAL-WARDROBE-QA1 (§11) — eligibility-true suppression.
  //
  // Previously this resolver suppressed the wardrobe accent whenever the
  // category was {gezin, koppel, kind} AND a scene template was on the wire,
  // on the assumption that the server `royalSceneAugmentClause` would own
  // per-person wardrobe in that cell. That predicate was BROADER than the
  // server augment's actual eligibility table
  // (`royalSceneAugmentClause` 1806–1819, lockstep `royalGroupOwnsWardrobeViaAugment`):
  //   - gezin + N>=2
  //   - koppel + N=2
  //   - kind   + N>=3
  // For the non-eligible cells (kind+N=2, koppel+N=1, gezin+N=1, kind+N=1)
  // the suppression dropped the solo accent AND the server augment never
  // fired, so the prompt left the royal portrait with no wardrobe
  // specification and the model fell back to the recipe's generic
  // "jeweled crown / ornate noble regalia" — the cliché that the whole
  // slice was meant to break.
  //
  // Fix: mirror the server's eligibility table exactly. When the augment
  // truly owns the cell → 0 picks. Otherwise pick min(faceCount, pool)
  // distinct variants WITHOUT replacement so multi-subject cells get
  // distinct garments, and solo cells keep their single random pick.
  const aggCount=wsAggregatedPeopleFaceCount(S&&S.slots);
  const faceCount=typeof aggCount==='number'&&Number.isFinite(aggCount)&&aggCount>0
    ?aggCount
    :(typeof S.faceCount==='number'&&Number.isFinite(S.faceCount)&&S.faceCount>0?S.faceCount:1);
  const templateOnWire=typeof S.royalSceneTemplate==='string'&&
                       (typeof WS_ROYAL_TEMPLATE_SET==='undefined'||WS_ROYAL_TEMPLATE_SET.has(S.royalSceneTemplate));
  const augmentEligible=templateOnWire&&(
    (S.cat==='gezin'&&faceCount>=2)||
    (S.cat==='koppel'&&faceCount===2)||
    (S.cat==='kind'&&faceCount>=3)
  );
  if(augmentEligible)return;
  const want=Math.max(1,Math.min(faceCount,pool.length));
  S.royalWardrobePicks=wsPickRoyalWardrobeVariants(pool,want);
}

/**
 * R-ROYAL-BOND-COMPANION (May 2026) — companion-pet presence gate for
 * the Royal human adjunct. Returns true when the upload contains a
 * visible companion pet alongside the human subject, using ONLY pre-
 * existing vision signals: Bond slots OR explicit
 * `compositionMode === 'mixed_single_photo'` opt-in OR
 * `containsPetSubject === true` aux flag OR the client-side
 * pet-classifier tie-break. R-MIX11-safe: no pixel-derived gender /
 * age / pose / holding-pose inference. Mirrors server
 * `isRoyalPetCompanionPresent` (Slice E lockstep). When true,
 * `wsBuildRoyalHumanAdjunct` appends companion + hold blocks; when
 * false, the human adjunct stays byte-identical to v8 for solo-human
 * flows (the dominant >99% of traffic).
 */
function wsHasRoyalPetCompanion(){
  if(wsSlotsBondComposition())return true;
  if(S.compositionMode==='mixed_single_photo')return true;
  if(wsVerifySaysNoCompanionPet())return false;
  if(typeof S.estimatedPetCount==='number'&&Number.isFinite(S.estimatedPetCount)&&S.estimatedPetCount>=1)return true;
  const r=S.aiVerifyResult&&S.aiVerifyResult.result;
  if(r&&r.petHeldByHuman===true)return true;
  if(S.containsPetSubject===true&&wsIsIntentionalHumanPetPortrait())return true;
  if(typeof wsClientPetClassifierTiebreak==='function'&&wsClientPetClassifierTiebreak()&&wsIsIntentionalHumanPetPortrait())return true;
  return false;
}

/** True when shopper notes ask for court hair / updo emphasis (optional turn boost). */
function wsParseHairStyleFromNotes(notesRaw){
  if(typeof notesRaw!=='string')return false;
  const t=notesRaw.toLowerCase();
  if(!t.trim())return false;
  const HAIR=/\b(elegant\s+hair|polished\s+hair|court\s+hair|formal\s+hair|updo|up-do|half[\s-]?up|pinned[\s-]?back|chignon|bun\s+up|elegant\s+kapsel|opgestoken|hofkapsel|koninklijk\s+kapsel)\b/;
  return HAIR.test(t);
}

/** Gender-routed court hair: core → flyaway → optional notes → bond emphasis. */
function wsBuildRoyalHumanHairAdjunct(gender){
  let hair=gender==='male'?ROYAL_HUMAN_HAIR_MALE_ADJUNCT:ROYAL_HUMAN_HAIR_FEMALE_NEUTRAL_ADJUNCT;
  if(S&&S.cat==='kind'&&gender!=='male'){
    hair+=' Age-appropriate neat court styling for a child — princess polish, not an adult ball-gown updo.';
  }
  hair+=ROYAL_HUMAN_HAIR_FLYAWAY_POLISH_ADJUNCT;
  if(wsParseHairStyleFromNotes(S&&S.userNotes))hair+=ROYAL_HUMAN_HAIR_NOTES_UPDO_EMPHASIS;
  if(wsHasRoyalPetCompanion())hair+=ROYAL_HUMAN_HAIR_BOND_EMPHASIS;
  return hair;
}

/**
 * Build the royal human styling adjunct for people categories. Stitched
 * AFTER the recipe body / category tail / count guard and BEFORE the
 * Layer B multi-animal clause (which is empty for people). Suppresses
 * itself for `huisdier`. Mirrors worker `royalHumanStylingAdjunct`.
 *
 * Block order (face-level → composition-level → companion → wardrobe → avoid):
 *   hair → makeup (or grooming for male) → painterly surface →
 *   glasses → gesture → crown →
 *   companion + hold (only when `wsHasRoyalPetCompanion()`) → wardrobe →
 *   Avoid(human)
 *
 * R-ROYAL-BOND-COMPANION (May 2026): companion + hold blocks fire only
 * when a companion pet is detected via the gate; solo-human flows stay
 * byte-identical to v8 (the gate returns '').
 * R-ROYAL-PAINTERLY (May 2026): painterly surface block fires
 * unconditionally on every people-category royal path so the face,
 * skin, and hands are unified into the same painted medium as the
 * clothing and background — closes the female-Instagram-glam and
 * male-photo-literal seams in one block.
 */
function wsBuildRoyalHumanAdjunct(){
  if(wsNormalizeStyleKey(S&&S.style)!=='royal')return '';
  // R-CAT-ROUTING v12.1 — solo pet royal keeps the pet body; lone human on
  // Pets (`wsIsHumanPrimaryOnPetCategory`) still receives the full v12 human
  // adjunct stack even while `S.cat==='huisdier'` (before silent auto-route).
  if(wsIsPetPrimaryOnPeopleCategory())return '';
  if(S.cat==='huisdier'&&!wsIsHumanPrimaryOnPetCategory())return '';
  const gender=S.royalGenderSignal||wsInferRoyalGenderSignal();
  let makeup;
  if(gender==='male'){
    makeup=ROYAL_HUMAN_GROOMING_ADJUNCT;
  }else{
    const tier=S.royalMakeupIntensity||wsResolveRoyalMakeupIntensity();
    const tierClause=tier==='natural'?ROYAL_MAKEUP_INTENSITY_NATURAL
                    :tier==='queen'?ROYAL_MAKEUP_INTENSITY_QUEEN
                    :ROYAL_MAKEUP_INTENSITY_REFINED;
    makeup=ROYAL_HUMAN_MAKEUP_BASE+tierClause;
  }
  // R-ROYAL-PAINTERLY (May 2026) — universal painterly surface block,
  // applied after the gender-routed makeup/grooming so the face, skin,
  // and hands are explicitly rebuilt as Old Master oil on every people
  // path. No gate: this is the unification layer for both genders.
  const painterly=ROYAL_HUMAN_PAINTERLY_SURFACE_ADJUNCT;
  // R-ROYAL-WARDROBE-QA1 (§11) — emit wardrobe whenever the resolver
  // produced picks. `wsResolveRoyalWardrobePicks` already enforces the
  // "0 picks when server augment owns" contract, so the adjunct trusts
  // the picks array as-is: 1 pick → solo clause; N picks → enumerated
  // per-subject clause + cohesive-palette hint. Empty array → no
  // wardrobe block (server augment will speak for the group).
  const wardrobe=Array.isArray(S.royalWardrobePicks)&&S.royalWardrobePicks.length>0
    ?wsBuildRoyalWardrobeClause(S.royalWardrobePicks)
    :'';
  // R-ROYAL-BOND-COMPANION (May 2026) — companion + hold adjunct gated
  // on `wsHasRoyalPetCompanion()` so the dominant solo-human path stays
  // byte-identical to v8. Companion first (subtle pet styling + pet-
  // identity preserve list), then hold (hand-placement preservation).
  const petCompanion=wsHasRoyalPetCompanion()
    ?ROYAL_HUMAN_PET_COMPANION_ADJUNCT+ROYAL_HUMAN_HOLD_ADJUNCT+
      (S.faceDetStatus==='ok'&&typeof S.faceCount==='number'&&Number.isFinite(S.faceCount)&&S.faceCount>=2
        ?ROYAL_BOND_GROUP_CONTACT_EXTENSION
        :'')
    :'';
  // R-ROYAL-UNITY v12 (May 2026), Slice D — `ROYAL_HUMAN_PROP_ADJUNCT`
  // inserted between gesture and crown so the held-prop IF-language fires
  // after the model has read the gesture / hand-placement preservation
  // block but before the (now-optional) crown block. Block order pin
  // updated in `app-proxy/royal-human-adjunct.test.js`.
  // R-VERIFY-1 — never translate cradled pets into held props when companion signal is active.
  const propBlock=wsHasRoyalPetCompanion()?'':ROYAL_HUMAN_PROP_ADJUNCT;
  const verifyAttire=wsBuildRoyalVerifyAttireAdjunct(wsParseAttireSignalsFromVerify((S&&S.aiVerifyResult&&S.aiVerifyResult.result)||null));
  const royalSourceAttireElev=(verifyAttire||ROYAL_HUMAN_SOURCE_ATTIRE_ADJUNCT)+ROYAL_HUMAN_TEXT_SIGNATURE_AVOID;
  const royalPeopleCat=S.cat==='zelf'||S.cat==='kind'||S.cat==='gezin'||S.cat==='koppel';
  const humanOnPetsRepair=(royalPeopleCat||S.catAutoRouted===true||wsIsHumanPrimaryOnPetCategory())
    ?ROYAL_HUMAN_BODY_PROPORTION_ADJUNCT
    :'';
  const hair=wsBuildRoyalHumanHairAdjunct(gender);
  const coupleContact=(!wsHasRoyalPetCompanion()&&S.cat!=='huisdier'&&S.faceDetStatus==='ok'&&typeof S.faceCount==='number'&&Number.isFinite(S.faceCount)&&S.faceCount>=2)?ROYAL_COUPLE_CONTACT_ADJUNCT:'';
  const soloContact=(!wsHasRoyalPetCompanion()&&S.faceDetStatus==='ok'&&typeof S.faceCount==='number'&&Number.isFinite(S.faceCount)&&S.faceCount<=1&&(S.cat==='zelf'||S.cat==='kind'))?PEOPLE_SOLO_CONTACT_ADJUNCT:'';
  const outdoorVerify=S.serverOutdoorLeisureScene===true
    ?' Scene emphasis (upload verified outdoor leisure): translate pool, garden, terrace, sunlit-casual, grotto, cave, or reflective water to a noble palazzo loggia, garden court, palace garden cave, reflective water terrace, or classical estate exterior — never a dark indoor throne room.'
    :'';
  const crownBlock=wsBuildRoyalHumanCrownAdjunct(gender);
  return hair+makeup+painterly+outdoorVerify+ROYAL_SOURCE_LIGHTING_TRANSLATION_ADJUNCT+ROYAL_HUMAN_GLASSES_ADJUNCT+
         ROYAL_HUMAN_GESTURE_ADJUNCT+soloContact+coupleContact+royalSourceAttireElev+humanOnPetsRepair+propBlock+crownBlock+
         petCompanion+wardrobe+ROYAL_AVOID_CLAUSE_HUMAN;
}

/**
 * Pet-specific Royal body. Replaces the dual-body wardrobe sentence
 * (which led with "jeweled collar, mantle, and crown for animal
 * subjects") with the fashion-brief Old-Master pet wardrobe.
 *
 * R-ROYAL-PET-POSE (May 2026) — block order:
 *   base → wardrobe → POSE → INTEGRATION → CROWN(optional) → FINISH(pet) → AVOID(pet)
 * The three new blocks close gaps identified in the Nana solo-pet
 * exemplar (paw-forward perspective flattened; garments pasted-on; pet
 * Avoid silent on perspective/pose). Wardrobe picks come from
 * `S.royalWardrobePicks` (resolved earlier); an empty picks list falls
 * back to neutral wording. Mirrors server `royalPetStylingAdjunct` slot.
 */
// Phase 2 Slice 2c-2: `ROYAL_PROMPT_BODY_PET_BASE` + `wsBuildRoyalPetBody`
// deleted. Worker `ROYAL_STYLE_EDIT_BODY_PET_ONLY` +
// `ROYAL_STYLE_EDIT_BODY_PET_CLASSIC` + `royalPetWardrobeClause` own the
// solo-pet royal recipe + variant routing now
// (`openai-image-edit.server.ts:179-188 + 1480`). The CROWN-1a welcome-
// optional opener lives in the worker mirror; theme `ROYAL_PET_*_ADJUNCT`
// constants (Pose / Integration / Expression / Crown / Bust / Finish /
// Avoid / Text-signature-avoid) are kept intact as §3.14 regression
// pins even though they're no longer concatenated into the wire prompt.

function wsSlotsBondComposition(){
  const arr=Array.isArray(S.slots)?S.slots:[];
  if(arr.length<2)return false;
  let people=false,pet=false;
  for(let i=0;i<arr.length;i++){
    const r=arr[i]&&arr[i].role;
    if(r==='people')people=true;
    if(r==='pet')pet=true;
  }
  return people&&pet;
}

/** R-PET-MULTI-1 (P0) — true when the shopper sits on `huisdier` but the
 *  classifier confidently reports the upload is a human (no Bond, no
 *  mixed_single_photo opt-in). Mirrors the server `isHumanPrimaryOnPetCategory`
 *  predicate so theme + worker pick the same royal recipe and emit the same
 *  ANTI-HYBRID GUARD substring. */
function wsIsHumanPrimaryOnPetCategory(){
  if(S.cat!=='huisdier')return false;
  if(S.subjectClass!=='likely_human')return false;
  if(wsSlotsBondComposition())return false;
  if(S.compositionMode==='mixed_single_photo')return false;
  // R-CAT-ROUTING P2 / R-VERIFY-1 — human+pet on Pets uses DUAL, not lone-human people-only.
  if(wsHasPetRoutingSignal())return false;
  return true;
}
/** HALL-1 — inverse of `wsIsHumanPrimaryOnPetCategory`: pet photo on a people
 *  storefront category (Self / Families / …) with verify `likely_pet` and no
 *  human in frame. Mirrors server `isPetPrimaryOnPeopleCategory`. */
function wsIsPetPrimaryOnPeopleCategory(){
  const cat=S.cat;
  if(cat==='huisdier')return false;
  if(cat!=='zelf'&&cat!=='gezin'&&cat!=='koppel'&&cat!=='kind')return false;
  if(S.subjectClass!=='likely_pet')return false;
  if(wsSlotsBondComposition())return false;
  if(S.compositionMode==='mixed_single_photo')return false;
  return true;
}
/** Single-photo implicit human+pet bond — mirrors generate() `implicitMixedBond`
 *  and server `isMixedSinglePhotoComposition` / `isHuisdierVisionHumanPetDual`
 *  so the storefront royal recipe picks DUAL before the people-only / pet floor. */
function wsImplicitMixedSinglePhotoBond(){
  const slotsArr=Array.isArray(S.slots)?S.slots:[];
  if(slotsArr.length>1)return false;
  if(S.compositionMode==='mixed_single_photo')return true;
  if(!wsIsIntentionalHumanPetPortrait())return false;
  if(S.subjectClass!=='likely_human')return false;
  if(!wsHasPetRoutingSignal())return false;
  return S.cat==='huisdier'||S.cat==='zelf'||S.cat==='gezin'||S.cat==='kind'||S.cat==='koppel';
}
// Phase 2 Slice 2c-2: `wsRoyalPromptBody` deleted. Worker
// `resolveRoyalStyleRecipeLine` (`openai-image-edit.server.ts:1295+`)
// owns recipe routing (PEOPLE_ONLY / DUAL / PET_ONLY / PET_CLASSIC)
// based on the structured wire fields (`category`, `visionMeta`,
// `compositionMode`, `royalVariant`). Theme routing predicates
// (`wsIsHumanPrimaryOnPetCategory`, `wsSlotsBondComposition`,
// `wsImplicitMixedSinglePhotoBond`, `wsIsPetPrimaryOnPeopleCategory`)
// stay in this file — they're consumed by category-banner UX +
// auto-route guards before the POST is built.

/** R-PET-MULTI-2 (Layer A) — shopper-declared multi-pet count parser.
 *  Reads `S.userNotes` (the persistent shopper voice, not retry text)
 *  and returns the summed integer count when at least one explicit
 *  number-of-pets pattern matches. Returns `null` when no pattern
 *  matches OR when the cumulative count exceeds 99 / falls below 1
 *  (R-MIX11: never claim a count we cannot back up).
 *
 *  Patterns recognised: ASCII digit OR English / Dutch number word
 *  (`one … ten`, `twee … tien`) immediately followed by a pet noun
 *  (`dog(s)`, `cat(s)`, `pet(s)`, `puppy / puppies`, `kitten(s)`,
 *  `kittie(s)`, `animal(s)`, `hond(en)`, `kat(ten)`, `huisdier(en)`).
 *  Permits "three dogs" / "3 cats" / "2 of my dogs" / "drie honden".
 *
 *  Intentionally conservative — phrases without an explicit number
 *  (`my pets`, `all my dogs`, `Spike + Bella`) return `null` and the
 *  prompt falls back to the singular path. False negatives are fine;
 *  false positives are not.
 *
 *  Stays in lockstep with the worker reader `readShopperAnimalCount`
 *  (`[1, 99]` integer range). Theme parses → caps → posts on the wire
 *  as `shopperAnimalCount`; worker re-validates and uses the number.
 */
function wsParseShopperAnimalCountFromNotes(notesRaw){
  if(typeof notesRaw!=='string')return null;
  const text=notesRaw;
  if(!text||!text.trim())return null;
  const NUM_WORDS={one:1,two:2,three:3,four:4,five:5,six:6,seven:7,eight:8,nine:9,ten:10,twee:2,drie:3,vier:4,vijf:5,zes:6,zeven:7,acht:8,negen:9,tien:10};
  const NUM_WORDS_KEYS=Object.keys(NUM_WORDS);
  const PET_NOUN='(?:dogs?|cats?|pets?|puppies|puppy|kittens?|kitties|kittie|animals?|honden|hond|katten|kat|huisdieren|huisdier)';
  const re=new RegExp('\\b(?:(\\d{1,2})|('+NUM_WORDS_KEYS.join('|')+'))\\s+(?:of\\s+(?:my\\s+|the\\s+|our\\s+)?)?'+PET_NOUN+'\\b','gi');
  let total=0;let matched=false;
  for(const m of text.matchAll(re)){
    let n=null;
    if(m[1])n=parseInt(m[1],10);
    else if(m[2]){
      const w=m[2].toLowerCase();
      if(Object.prototype.hasOwnProperty.call(NUM_WORDS,w))n=NUM_WORDS[w];
    }
    if(typeof n==='number'&&Number.isFinite(n)&&n>=1&&n<=99){
      total+=n;matched=true;
    }
  }
  if(!matched)return null;
  if(total<1||total>99)return null;
  return total;
}

/** R-PET-MULTI-2 (Layer A) — predicate mirror of the worker
 *  `isMultiAnimalShopperDeclared`. Same matrix cell: `huisdier ∧
 *  shopperAnimalCount >= 2 ∧ NOT P0 ∧ NOT Bond ∧ NOT mixed_single_photo`.
 *  Reads `S.shopperAnimalCount` (captured before prompt composition
 *  inside `generate()` from `wsParseShopperAnimalCountFromNotes`) so
 *  every prompt-builder in this file consults the same number without
 *  re-parsing the notes string per call. */
function wsIsMultiAnimalShopperDeclared(){
  if(S.cat!=='huisdier')return false;
  const n=S.shopperAnimalCount;
  if(typeof n!=='number'||!Number.isFinite(n)||n<2)return false;
  if(wsIsHumanPrimaryOnPetCategory())return false;
  if(wsSlotsBondComposition())return false;
  if(S.compositionMode==='mixed_single_photo')return false;
  return true;
}

function wsIsIllustratedNaturalCoatPetStyle(stKey){
  return stKey==='watercolor'||stKey==='popart'||stKey==='anime'||stKey==='nordic'||stKey==='lineart';
}
function wsIsCostumeFunPetStyle(stKey){
  const s=wsNormalizeStyleKey(stKey);
  return s==='superhero'||s==='vintage_fashion'||s==='world_cup_football';
}
function wsIsWorldCupFootballStyle(stKey){return wsNormalizeStyleKey(stKey)==='world_cup_football';}
function wsIsVintageFashionStyle(stKey){return wsNormalizeStyleKey(stKey)==='vintage_fashion';}
/** NAT-COAT-REFINE — illustrated huisdier only; appended in wsComposeStylePrompt, not on people categories. */
const ILLUSTRATED_PET_NATURAL_COAT_RECIPE_TAIL=' PRESERVE visible reference accessories (collar, leash, tag) when present in the upload. DO NOT ADD pet costumes, capes, crowns, or jewelry the animal was not wearing — keep natural anatomy and coat.';
const ILLUSTRATED_PET_NATURAL_COAT_CATS_MID='preserve visible reference accessories (collar, leash, tag) from the upload; do not add costumes, crowns, capes, jewelry, or ceremonial drapery not present in the reference';

// Phase 2 Slice 2c-2 (May 28 2026): `PROMPT_BODY.royal` deleted along
// with the `ROYAL_PROMPT_BODY_*` constants. The worker's
// `KNOWN_STYLE_EDIT_LINES.royal` is authoritative
// (`openai-image-edit.server.ts:305`). The remaining `PROMPT_BODY`
// entries (baroque / watercolor / popart / anime / nordic / lineart)
// are kept for any client-side preview UI that may still call
// `wsComposeStylePrompt` — generate() no longer does (Slice 2c-1).
const PROMPT_BODY={
  baroque:'Now transform ONLY the style into a Dutch Golden Age / Baroque oil portrait on canvas: rich impasto and soft glazing, deep umber or olive-brown ground, strong chiaroscuro with a single directional key light, atmospheric background melting into shadow, visible brushwork and fine craquelure where appropriate. Subjects read as painted masterworks — not pasted photos — while preserving each face, fur pattern, and figure placement from the reference. Do not use court throne-room staging, crowns, coronets, tiaras, ermine mantles, ceremonial sashes, or state-portrait regalia; do not add pet costumes, collars of office, capes, or jewelry dressing on animals — keep natural anatomy and coat. Preserve the framing, pose, and grouping of the reference; do not force a tight bust crop or vertical-only composition unless the reference already suggests it.',
  watercolor:'Now transform ONLY the style into a luminous fine-art watercolor portrait: wet pigment blooms on cold-press cotton paper, soft granulation, feathered edges, airy negative space, tender pastel mood light. Faces and fur are rendered IN watercolor (washes, granulation, feathered edges) while preserving each subject\'s exact facial structure, skin tone, hair, and distinguishing features — painterly, not photographic, but identity-faithful, never anonymous, doll-like, or a generic stock-watercolor face. Avoid plastic skin, harsh outlines, or a snapshot look.',
  popart:'Now transform ONLY the style into bold editorial pop art **from each subject through the background**: thick confident ink outlines, flat high-saturation color planes, Ben-Day / halftone, and poster / silkscreen energy. **Every subject in the reference** must stay clearly recognizable — preserve approximate likeness per figure (feature layout, age, hair or fur pattern and color family, breed and markings on animals, obvious accessories like sunglasses) **without** demanding photoreal or pixel-perfect sameness (bold stylization is the goal; avoid over-constraining microscopic match). Stylize with ink and color; **do not** caricature or swap in a generic comic face that erases identity. On **faces and muzzles**, use **finer or sparser halftone** (or flat skin or fur planes) so each figure stays identifiable; **bolder** dots and graphic shadows may dominate clothing and background. Ban muddy dot noise that makes any subject unrecognizable. No beauty-filter snapshot with only a thin outline; print-ready wall art.',
  anime:'Now transform ONLY the style into a polished anime-inspired illustration: full-scene cel shading with **hard-edged light wraps on cheeks, jaw, and hair locks**, clean tapering line art, expressive but **identity-grounded** illustrated eyes (do not swap in unrelated character archetypes), and stylized fur or fabric folds. Faces are simplified **planes** of cel color — not softened photographic skin — while preserving age, bone structure, and distinguishing marks. Soft whimsical background; collectible wall-art finish. Visibly **not** a photograph; do not name or copy any commercial anime studio or franchise. The subject must remain unmistakable.',
  nordic:'Now transform ONLY the style into a refined Scandinavian editorial portrait illustration: restrained muted palette (warm greys, dusty sage, oatmeal, sand), airy negative space, matte painted pigment with faint linen/paper tooth. Gentle soft gradients and diffuse daylight as in a serene Nordic interior; subtle brass or honey accent allowed only if minimal. Visible brush craft—clearly handcrafted wall art suitable for Scandinavian homes; unmistakable likeness through calm painterly treatment—never an unedited photograph.',
  lineart:'Now transform ONLY the style into premium editorial ink line art on warm cream paper: confident black ink with variable stroke weight — bolder outer contours, finer interior lines — plus controlled contour hatching and cross-hatching for fur mass and facial depth; tone from ink line density only, never solid gray fills or watercolor wash. Single soft directional light implied through hatching; expressive eyes with small highlight. Generous negative space; unmistakable likeness through breed markings and structure; high-craft hand-inked gallery portrait — not a photo filter or flat coloring-book trace.',
  superhero:'Now transform ONLY the style into a painterly superhero portrait: cinematic illustrated brushwork, rich color, directional heroic light. People may wear fitted heroic apparel with a flowing cape and at most a small generic geometric chest emblem — no trademarked characters or logos. On pet animals, add only a naturally fitted neck cape (and at most a small emblem that does not obscure the muzzle); preserve quadruped anatomy and unmistakable breed likeness — never bipedal pose, human hands, or a humanoid body. Default warm golden-hour heroic flight with cape updraft and soft cloud atmosphere. Preserve believable weight, species-true limbs, grouping, and bond contact — bonded subjects fly together when the reference shows touch. Read the reference moment: keep celebratory props, candid gestures, and bonding, amplifying dynamic poses into heroic action — never a stiff posed substitute. No royal crowns, throne rooms, or pop-art halftone. Identity-faithful, warm gallery wall art.',
  vintage_fashion:'Now transform ONLY the style into a vintage fashion-art portrait: luminous watercolor and soft editorial paint with paper tooth, granulating washes, speckle texture, and a gentle vignette in nostalgic dusty-rose, mauve, ochre, and pearl tones. On pet animals, add ONE hero vintage accessory fitted to natural head and neck anatomy — a single period millinery or headwear piece (floral wide-brim hat, beret, flat cap, or patterned bandana) or a fascinator with pearl strands — chosen to suit the pet and never stacked; preserve quadruped anatomy, muzzle, ears, and unmistakable breed likeness — never bipedal pose, human hands, or full human evening dress on the body. On people, period glamour wardrobe integrated into the same painterly medium. The whole image reads as commissioned fashion wall art, not a filtered photograph. No royal crowns or throne-room regalia, no pop-art halftone, no modern street signage. Identity-faithful, print-ready.',
  world_cup_football:'Now transform ONLY the style into a painterly cinematic World Cup Football portrait: visible brushwork, stadium rim light, frozen peak action, gallery wall art — not broadcast TV, not pop-art, not royal oil. People may wear a generic fitted football kit with cleats — solid or two-tone blocks only; no national crests, federation badges, sponsor logos, FIFA marks, official tournament logos, player names, or real national team kits — dynamic pose on grass: strike, dribble, volley, or arms-raised celebration. On pet animals, ball-play only — paws on or chasing a ball, mid-pounce with grass spray; optional one light neck bib or bandana with a generic number stripe; preserve quadruped anatomy and unmistakable breed likeness — never bipedal stance, human legs, or humanoid kick. Read the reference moment: keep celebratory props, candid gestures, and bonding, amplifying into a match-winning hero beat — never a stiff mannequin pose. Reference-conditional pitch atmosphere with abstract crowd bokeh and golden floodlight or sunset rim — never named stadiums or city skylines. No royal crowns or pop-art halftone. Identity-faithful, print-ready.',
};
/** R-PORTRAIT-COHERENCE v13 — Layer 4 global unity tails for people categories. */
const PORTRAIT_UNITY_MARKER='Portrait unity:';
const ROYAL_PORTRAIT_UNITY_RECAP=' Portrait unity recap: unify face, hands, clothing, held props, and background into one Old Master painted surface — no photographic sharpness or pasted-in objects breaking the scene.';
const PORTRAIT_UNITY_ADJUNCT={
  baroque:' Portrait unity: apply Dutch Golden Age oil treatment uniformly — face, skin, hands, clothing, props, and background share the same chiaroscuro key light, painterly brushwork, and umber ground; no photographic sharpness, no HDR snapshot islands, no pasted-photo face in a baroque painted scene.',
  watercolor:' Portrait unity: apply watercolor wash and granulation to the entire portrait — face, skin, hands, clothing, props, and background share the same wet-on-wet medium; no photo-sharp facial features on a watercolor ground.',
  popart:' Portrait unity: render face, clothing, hands, and any held props with the same flat graphic planes, bold ink outlines, and halftone texture — every element belongs to one pop-art composition, never a photographic face pasted onto stylized blocks.',
  anime:' Portrait unity: use consistent cel shading, line weight, and color planes on face, hair, clothing, hands, and props — no photographic skin texture or HDR snapshot islands in an otherwise illustrated portrait.',
  nordic:' Portrait unity: apply the same matte pigment tooth, calm tonal massing, and restrained editorial finish to face, hands, clothing, props, and background — one coherent Nordic illustration, never mixed photo and wash.',
  lineart:' Portrait unity: use one ink-line language — variable stroke weight plus contour hatching for depth — across face, hands, clothing, props, and background; no photo-real shading breaking the line-art medium.',
  superhero:' Portrait unity: apply painterly heroic illustration consistently — face, skin, hands, costume, cape, and background share the same cinematic brushwork and directional light; no photographic face pasted onto illustrated costume.',
  vintage_fashion:' Portrait unity: apply luminous watercolor and soft editorial paint consistently — face, skin, hands, wardrobe, accessory, and background share the same granulating wash, paper tooth, and vignette; no photographic face pasted onto a painted fashion ground.',
  world_cup_football:' Portrait unity: apply painterly cinematic sports illustration consistently — face, skin, hands, kit, ball, pitch, and crowd share the same brushwork and stadium rim light; no photographic face pasted onto illustrated kit.',
};
/** R-PORTRAIT-COHERENCE v13b — pet-safe unity tails (huisdier × non-royal). */
const PORTRAIT_UNITY_ADJUNCT_PET={
  baroque:' Portrait unity: apply Dutch Golden Age oil treatment uniformly — muzzle, fur coat, paws, and background share the same chiaroscuro key light, painterly brushwork, and umber ground; no photographic muzzle texture or HDR snapshot islands in an otherwise oil-painted pet portrait.',
  watercolor:' Portrait unity: apply watercolor wash and granulation across the pet\'s muzzle, fur, paws, and background — one wet-on-wet medium; no photo-sharp fur or muzzle on a watercolor ground.',
  popart:' Portrait unity: render muzzle, fur, paws, and background with the same flat graphic planes, bold ink outlines, and halftone texture — one pop-art pet portrait, never a photographic muzzle pasted onto stylized blocks.',
  anime:' Portrait unity: use consistent cel shading and color planes on muzzle, fur, ears, and paws — no photographic fur texture or HDR snapshot islands in an otherwise illustrated pet portrait.',
  nordic:' Portrait unity: apply the same matte pigment tooth and calm tonal massing to muzzle, fur coat, paws, and background — one coherent Nordic pet illustration, never mixed photo and wash.',
  lineart:' Portrait unity: use one ink-line language — variable stroke weight plus contour hatching — across muzzle, ears, fur mass, and paws; no photo-real muzzle texture breaking the line-art medium.',
  superhero:' Portrait unity: apply painterly heroic illustration across muzzle, fur, cape drape, and background — one illustrated medium; no photo-sharp muzzle on an illustrated heroic ground.',
  vintage_fashion:' Portrait unity: apply luminous watercolor and granulating wash across muzzle, fur, accessory, and background — one fashion-art medium; no photo-sharp muzzle on a painted ground.',
  world_cup_football:' Portrait unity: apply painterly sports illustration across muzzle, fur, bib, ball, and pitch — one illustrated medium; no photo-sharp muzzle on a painted ground.',
};
/** G-CONV-LITE-GATE — solo royal classic pet (Elvis path). Not bond/DUAL/multi-pet/fantasy. */
function wsIsRoyalClassicSoloPetCell(cat,styleKey){
  if(wsNormalizeStyleKey(styleKey)!=='royal')return false;
  if(wsResolveRoyalVariant()!=='classic')return false;
  if(wsIsMultiAnimalShopperDeclared())return false;
  if(cat==='huisdier')return wsIsRoyalPetSoloHuisdier();
  if(wsIsPetPrimaryOnPeopleCategory())return true;
  return false;
}
/** G-INSC-GATE — inscription carve-out + classic lettering (huisdier solo only). */
function wsIsRoyalClassicSoloHuisdierInscriptionCell(cat,styleKey){
  if(cat!=='huisdier')return false;
  return wsIsRoyalClassicSoloPetCell(cat,styleKey);
}
/** R-ROYAL-INSC v29 — unified Royal inscription lettering (all Royal + name paths). Lockstep worker `inscriptionStyleClauseRoyal`. */
function wsInscriptionStyleClauseRoyal(){
  return 'Lettering style: paint the name into existing background negative space — soft umber ground or an unobtrusive velvet-edge already present in the scene — aged gilt or raw-sienna script with controlled impasto and a single soft key-light catch on the letterforms, sized for a gallery heirloom (legible at print size; never bold display type, never sticker-like, never chrome emboss); wet-into-wet on the same brush layer as the portrait; never invent a foreground stone sill, plinth, ledge, or slab to host it; never placed atop gold embroidery or jewel focal points; harmonized with scene chiaroscuro.';
}
/** Lockstep worker `inscriptionStyleClauseRoyalClassicPet` — alias for unified Royal lettering. */
function wsInscriptionStyleClauseRoyalClassicPet(){
  return wsInscriptionStyleClauseRoyal();
}
const ROYAL_INSCRIPTION_REGALIA_SURFACE=' REGALIA-INSCRIPTION: reserve the lower-right corner for the painted name — no mantle embroidery, jeweled clasp, or fabric fold crossing that corner; regalia must not compete with the inscription. INSCRIPTION SURFACE: use a calm, lighter, unpatterned area of the EXISTING background in the scene\'s key light — not deep shadow, busy rug weave, or dark grass; do not invent a foreground ledge, plinth, or stone block for the text.';
const ROYAL_INSCRIPTION_PEOPLE_SURFACE=' INSCRIPTION SURFACE: use a calm, lighter, unpatterned area of the EXISTING background in the scene\'s key light — not deep shadow or busy patterned ground; do not invent a foreground ledge, plinth, or stone block for the text.';
const ROYAL_INSCRIPTION_LEGIBILITY=' The painted dedication must be clearly readable at print size while remaining integrated oil-paint lettering subordinate to the subject — not a floating overlay or watermark, and never enlarged or given an added surface to improve legibility.';
/** CONV-CORE — generalized conversion quality (BA-014 / BA-015). Royal classic solo pet gets CONV-lite (core+pet only); Royal people get v36 coherence + people/group pillars (v37). */
const PORTRAIT_CONVERSION_CORE=' Conversion quality: preserve emotional warmth and recognizable personality — never flatten into generic stock portraiture or exaggerated AI glamour. Preserve reference camera distance; do not over-zoom unless the upload is already tight.';
const PORTRAIT_CONVERSION_CORE_SUPERHERO=' Conversion quality: preserve emotional warmth and recognizable personality — never flatten into generic stock portraiture or exaggerated AI glamour.';
const PORTRAIT_CONVERSION_COHERENCE=' Every subject, human or pet, must show coherent natural anatomy and posture and sit as one integrated portrait — matched lighting, scale, and edges with the scene, never pasted, floating, or stuck on.';
const PORTRAIT_CONVERSION_PET=' Pet conversion: preserve breed markings, eye color, mouth set and tongue when visible, paw placement and ground contact; never merge the body into the background surface.';
const PORTRAIT_CONVERSION_PET_FLIGHT=' Pet conversion: preserve breed markings, eye color, and mouth set; in heroic flight paws may leave ground with believable weight — never merge body into background.';
const PORTRAIT_CONVERSION_CORE_FOOTBALL=' Conversion quality: preserve emotional warmth and recognizable personality — never flatten into generic stock portraiture or exaggerated AI glamour.';
const PORTRAIT_CONVERSION_PET_BALL=' Pet conversion: preserve breed markings, eye color, and mouth set; in pitch action paws may leave ground with believable weight — never merge body into background.';
const PORTRAIT_CONVERSION_PEOPLE=' People conversion: preserve expression, smile lines, and age markers; connected natural anatomy on every visible body part; no extra, merged, or floating fingers; natural head–neck–shoulder scale; period dress drapes reference silhouette.';
const PORTRAIT_CONVERSION_GROUP=' Group conversion: keep each distinct with grouping and overlap; never drop or hero-wash; preserve closeness and travel warmth, not stiff strangers.';
const SUPERHERO_EPIC_SCALE_MARKER='Superhero scale:';
const SUPERHERO_EPIC_SCALE_ADJUNCT=' Superhero scale: recompose tight selfies to medium-wide flight — subject(s) upper-center, golden sky and soft clouds above, warm horizon silhouette below — never named buildings. Solo ~half frame height; groups keep every face legible. Mid-leap or hover even from ground references; pets stay quadruped. One pose and camera angle per figure — never pasted face on mismatched body.';
function wsSuperheroEpicScaleAdjunct(styleKey,cat){
  if(wsNormalizeStyleKey(styleKey)!=='superhero')return '';
  const ck=(cat||'').trim().toLowerCase();
  if(ck==='huisdier')return '';
  return SUPERHERO_EPIC_SCALE_ADJUNCT;
}
const SUPERHERO_PET_FLIGHT_MARKER='Superhero pet flight:';
const SUPERHERO_PET_FLIGHT_ADJUNCT=' Superhero pet flight: MANDATORY sustained powered flight — not a ground sit, rooftop, ledge, jump, or takeoff. Recompose medium-wide at high altitude — camera beside the subject, open sky surrounds the pet, cloud deck clearly BELOW, distant generic skyline miniature far beneath when shown — never rooftops at subject height, never named landmarks. Subject upper-center ~half frame height. Quadruped spine, natural paw shape and leg joints, cape from neck and shoulders — never bipedal torso, human arms, boots, or gloves. Calm seated or standing references → gentle guardian lift-off (paws may leave ground, cape updraft, slight upward angle); motion references → heroic mid-leap or soar with believable weight. One pose per figure — never pasted face on mismatched body.';
function wsSuperheroPetFlightAdjunct(styleKey,cat){
  if(wsNormalizeStyleKey(styleKey)!=='superhero')return '';
  if((cat||'').trim().toLowerCase()!=='huisdier')return '';
  return SUPERHERO_PET_FLIGHT_ADJUNCT;
}
const FOOTBALL_ACTION_SCALE_MARKER='Football scale:';
const FOOTBALL_ACTION_SCALE_ADJUNCT=' Football scale: recompose static or indoor references to medium-wide pitch hero action — subject(s) upper-center, stadium light and crowd bokeh above, green pitch and touchline below — never named stadiums. Solo ~half frame height; groups keep every face legible. Peak frozen moment even from seated references — strike, dribble, celebration, or pet pounce on ball; pets stay quadruped. One pose and camera angle per figure — never pasted face on mismatched athlete body.';
function wsFootballActionScaleAdjunct(styleKey){
  return wsNormalizeStyleKey(styleKey)==='world_cup_football'?FOOTBALL_ACTION_SCALE_ADJUNCT:'';
}
const PORTRAIT_CONVERSION_GROUP_MULTI=' Arrange the group toward the upper two-thirds so faces are the largest, clearest elements and any foreground surface stays shallow; keep every face, including back rows, lit enough to read at print and thumbnail size.';
const PORTRAIT_CONVERSION_FINISH={
  baroque:' Baroque finish: strong chiaroscuro with warm golden key on deep umber ground; dignified emotional warmth; gallery-ready Old Master oil with controlled impasto that must not distort muzzle, paws, or limbs; dark background frames subject; never royal regalia or pet costume.',
  nordic:' Nordic finish: calm matte editorial tooth; no muddy over-texture on faces or muzzle.',
  watercolor:' Watercolor finish: luminous granulating washes, airy negative space, tender sentimental mood; bond pairs keep equal likeness and closeness; clutter softens into wash; no photo-sharp islands on faces or muzzle.',
  popart:' Pop-art finish: bold flat planes with identifiable faces; no muddy halftone soup.',
  anime:' Anime finish: cel planes with expressive but identity-grounded eyes.',
  lineart:' Line-art finish: expressive ink contour with controlled hatching for likeness depth; generous negative space; no flat trace or empty coloring-book look.',
  superhero:' Superhero finish: warm golden-hour painterly color, cinematic key light, and soft cloud atmosphere; cape, emblem, and sky stay subordinate to likeness and never flatten the face or muzzle; no trademark logos, royal regalia, or pop-art halftone.',
  vintage_fashion:' Vintage fashion finish: luminous granulating watercolor with soft vignette and nostalgic muted palette; the hero accessory and wash stay subordinate to likeness and never flatten the face or muzzle; no royal regalia, pop-art halftone, or modern signage.',
  world_cup_football:' World Cup Football finish: stadium key light and painterly grass texture stay subordinate to likeness and never flatten the face or muzzle; no muddy motion smear, FIFA marks, official tournament logos, or sponsor branding.',
};
function wsPortraitConversionIsGroupSubject(cat){
  if(cat==='gezin'||cat==='koppel')return true;
  if(S&&S.compositionMode==='mixed_single_photo')return true;
  if(cat==='huisdier'&&typeof wsInscriptionModalCell==='function'&&wsInscriptionModalCell('huisdier')==='bond')return true;
  return false;
}
function wsIsRoyalPeopleCategoryForConv(cat){
  const ck=String(cat||'').trim().toLowerCase();
  return ck==='gezin'||ck==='koppel'||ck==='kind'||ck==='zelf';
}
function wsIsPeopleAnatomyContactEligible(cat,styleKey){
  const st=wsNormalizeStyleKey(styleKey);
  if(st==='royal')return false;
  const ck=String(cat||'').trim().toLowerCase();
  if(wsIsHumanPrimaryOnPetCategory())return true;
  if(ck!=='gezin'&&ck!=='koppel'&&ck!=='kind'&&ck!=='zelf')return false;
  if(wsIsPetPrimaryOnPeopleCategory())return false;
  return true;
}
function wsPeopleAnatomyContactAdjunct(cat,styleKey){
  if(!wsIsPeopleAnatomyContactEligible(cat,styleKey))return '';
  const n=S&&S.faceDetStatus==='ok'&&typeof S.faceCount==='number'&&Number.isFinite(S.faceCount)?Math.floor(S.faceCount):0;
  if(wsHasRoyalPetCompanion())return PEOPLE_BOND_CONTACT_EXTENSION;
  if(n<2){
    const ck=(cat||'').trim().toLowerCase();
    if(ck==='zelf'||ck==='kind')return PEOPLE_SOLO_CONTACT_ADJUNCT;
    return '';
  }
  return PEOPLE_COUPLE_CONTACT_ADJUNCT;
}
function wsPortraitConversionAdjunct(cat,styleKey){
  const st=wsNormalizeStyleKey(styleKey);
  const ck=String(cat||'').trim().toLowerCase();
  if(st==='royal'){
    if(wsIsRoyalClassicSoloPetCell(cat,styleKey)){
      return PORTRAIT_CONVERSION_CORE+PORTRAIT_CONVERSION_PET;
    }
    if(wsIsRoyalPeopleCategoryForConv(cat)){
      let out=PORTRAIT_CONVERSION_COHERENCE;
      if(wsPortraitConversionIsGroupSubject(cat)){
        out+=PORTRAIT_CONVERSION_GROUP;
        const okN=S&&S.faceDetStatus==='ok'&&typeof S.faceCount==='number'&&Number.isFinite(S.faceCount)?Math.floor(S.faceCount):0;
        if(okN>=3)out+=PORTRAIT_CONVERSION_GROUP_MULTI;
        if(ck==='gezin'||ck==='koppel')out+=PORTRAIT_CONVERSION_PEOPLE;
      }else if(ck==='zelf'||ck==='kind'){
        out+=PORTRAIT_CONVERSION_PEOPLE;
      }
      return out;
    }
    return '';
  }
  let out=(st==='superhero'?PORTRAIT_CONVERSION_CORE_SUPERHERO:st==='world_cup_football'?PORTRAIT_CONVERSION_CORE_FOOTBALL:PORTRAIT_CONVERSION_CORE)+PORTRAIT_CONVERSION_COHERENCE;
  const humanOnPets=wsIsHumanPrimaryOnPetCategory();
  const petPillar=(cat==='huisdier'&&!humanOnPets)||wsIsPetPrimaryOnPeopleCategory();
  if(wsPortraitConversionIsGroupSubject(cat)){
    out+=PORTRAIT_CONVERSION_GROUP;
    const okN=S&&S.faceDetStatus==='ok'&&typeof S.faceCount==='number'&&Number.isFinite(S.faceCount)?Math.floor(S.faceCount):0;
    if(okN>=3)out+=PORTRAIT_CONVERSION_GROUP_MULTI;
    if(ck==='gezin'||ck==='koppel'||humanOnPets)out+=PORTRAIT_CONVERSION_PEOPLE;
  }else if(petPillar)out+=st==='superhero'?PORTRAIT_CONVERSION_PET_FLIGHT:st==='world_cup_football'?PORTRAIT_CONVERSION_PET_BALL:PORTRAIT_CONVERSION_PET;
  else if(humanOnPets||cat==='zelf'||cat==='kind')out+=PORTRAIT_CONVERSION_PEOPLE;
  const finish=PORTRAIT_CONVERSION_FINISH[st];
  if(finish)out+=finish;
  return out;
}
function wsPortraitUnityAdjunct(cat,styleKey){
  if(wsIsPetPrimaryOnPeopleCategory())return wsPortraitUnityAdjunct('huisdier',styleKey);
  const ck=String(cat||'').trim().toLowerCase();
  const st=wsNormalizeStyleKey(styleKey);
  if(st==='royal'){
    if(ck==='huisdier')return '';
    if(ck!=='gezin'&&ck!=='koppel'&&ck!=='kind'&&ck!=='zelf')return '';
    return ROYAL_PORTRAIT_UNITY_RECAP;
  }
  if(ck==='huisdier')return PORTRAIT_UNITY_ADJUNCT_PET[st]||'';
  if(ck!=='gezin'&&ck!=='koppel'&&ck!=='kind'&&ck!=='zelf')return '';
  return PORTRAIT_UNITY_ADJUNCT[st]||'';
}
const CATS={
  huisdier:' The subject is a PET ANIMAL. Preserve the exact breed characteristics, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Dress the animal body in period costume while keeping the head and face completely unaltered and true to the original photo. The pet must be instantly recognizable to its owner.',
  gezin:' This is a FAMILY or GROUP portrait. MULTI-PERSON RULE: Every visible person must keep a separate, accurate likeness — do not merge faces, do not repeat one person\'s features on another body, and do not average identities. Preserve overlap (arms around shoulders), staggered rows, sunglasses, and harsh flash as the scene requires while restyling into the art look.',
  koppel:' This is a TWO-PERSON portrait. TWO DISTINCT PEOPLE: preserve each person\'s unique facial structure, hair, skin tone, and accessories; never duplicate one face for both. Use a natural, connected pose without collapsing two identities into one.',
  kind:' This is a CHILDREN\'s portrait. Preserve each child\'s identity and gentle character; apply the **full portrait treatment** to face, clothing, and setting as one cohesive **painted or noble** artwork — not a raw snapshot with only wardrobe changed. Warm, innocent, classical composition.',
  zelf:' This is a SELF-PORTRAIT. Preserve the subject\'s exact facial features, skin tone, hair color and style, and every distinguishing characteristic with maximum fidelity. The face must be an unmistakable likeness. Distinguished, confident composition.'
};

/** R-AI-ONLY — MediaPipe pet-score tiebreak retired; server AI sets containsPetSubject. */
function wsClientPetClassifierTiebreak(){
  return false;
}

/** R-SELF-1b — verify reports zero companion pets (BA-012b stale flags). */
function wsVerifySaysNoCompanionPet(state){
  const st=state||S;
  if(typeof st.estimatedPetCount==='number'&&Number.isFinite(st.estimatedPetCount)&&st.estimatedPetCount===0)return true;
  const r=st.aiVerifyResult&&st.aiVerifyResult.result;
  if(!r||typeof r!=='object')return false;
  if(r.hasPet===true||r.petHeldByHuman===true)return false;
  if(typeof r.estimatedPetCount==='number'&&Number.isFinite(r.estimatedPetCount)&&r.estimatedPetCount>=1)return false;
  if(r.hasPet===false)return true;
  return false;
}

/** R-AI-ONLY — pet signal from server AI verify mirrored on S.* */
function wsHasPetRoutingSignal(state){
  const st=state||S;
  if(st.containsPetSubject===true)return true;
  const r=st.aiVerifyResult&&st.aiVerifyResult.result;
  if(!r||typeof r!=='object')return false;
  if(r.hasPet===true||r.petHeldByHuman===true)return true;
  if(typeof r.estimatedPetCount==='number'&&r.estimatedPetCount>=1)return true;
  return false;
}

/** INTENT-A / A2 — Bond or mixed_single_photo opt-in only on `huisdier`.
 *  Verify petHeldByHuman alone does not opt in. Mirrors worker
 *  `isIntentionalHumanPetPortrait`. */
function wsIsIntentionalHumanPetPortrait(state, visionMeta){
  const st=state||S;
  if(wsSlotsBondComposition())return true;
  if(st.compositionMode==='mixed_single_photo')return true;
  if(st.cat==='huisdier')return false;
  if(st.cat==='zelf'||st.cat==='gezin'||st.cat==='kind'||st.cat==='koppel'){
    if(st.subjectClass==='likely_pet')return false;
    if(wsVerifySaysNoCompanionPet(st))return false;
    return wsHasPetRoutingSignal(st);
  }
  return false;
}

function wsShouldClearPetNameOnCategoryLeave(nextCat){
  if(nextCat==='huisdier')return false;
  return !wsHasPetRoutingSignal();
}

/** Portrait inscription modal — pure gate (Slice A / §3 matrix). Testable via optional `state`. */
function wsShouldOfferPortraitInscription(state){
  const st=state||S;
  if(!st.cat||!st.b64)return false;
  if(/^User\s+edit\s+request:/i.test(String(st.extraPrompt||'').trim()))return false;
  const peopleCats=['zelf','kind','gezin','koppel'];
  if(peopleCats.indexOf(st.cat)>=0)return true;
  if(st.cat!=='huisdier')return false;
  if(st.catManualHuisdier===true&&st.subjectClass==='likely_human'&&!wsHasPetRoutingSignal(st))return false;
  if(st.subjectClass!=='likely_human')return true;
  const slotsArr=Array.isArray(st.slots)?st.slots:[];
  if(slotsArr.length>=2){
    let people=false,pet=false;
    for(let i=0;i<slotsArr.length;i++){
      const r=slotsArr[i]&&slotsArr[i].role;
      if(r==='people')people=true;
      if(r==='pet')pet=true;
    }
    if(people&&pet)return true;
  }
  if(st.compositionMode==='mixed_single_photo')return true;
  if(wsHasPetRoutingSignal(st))return true;
  return false;
}

/** Idempotent vision + human-on-Pets auto-route for one generate attempt (Slice A). */
async function wsPrepareGenerateBeforePrompt(){
  if(S._generatePrepDone&&S._generatePrepAttemptId===S._generateAttemptId){
    return S._generateVisionMetaCache||null;
  }
  const visionMeta=await wsResolveVisionMeta();
  wsPerfMark('t_vision_resolved');
  wsSyncStyleAndCategoryFromDom();
  wsAutoRouteHumanOnPetsBeforeGenerate();
  wsAutoRoutePetOnPeopleBeforeGenerate();
  S._generatePrepDone=true;
  S._generatePrepAttemptId=S._generateAttemptId;
  S._generateVisionMetaCache=visionMeta;
  return visionMeta;
}

/** R-AI-ONLY — visionMeta pet signal (AI-derived only). */
function wsVisionMetaHasPetSignal(vm){
  if(!vm||typeof vm!=='object')return false;
  if(vm.containsPetSubject===true)return true;
  if(vm.serverPetHeldByHuman===true)return true;
  if(typeof vm.serverEstimatedPetCount==='number'&&vm.serverEstimatedPetCount>=1)return true;
  return false;
}

/** R-BOND‑IMPLICIT (May 2026): when detection sees one human face BUT the aux
 *  pet signal (or Bond opt-in) is true, plain `CATS.gezin/koppel/kind/zelf`
 *  misleads models ("multi-person family" / children plural) toward inventing
 *  extra humans. Replace the static tail ONLY for that deterministic shape —
 *  keeps byte-identical prompts for every other path. Mirrored server-side in
 *  `visionReconciliationClause` (wallstraight-app). */
function wsCatsTail(cat,styleKey){
  if(wsIsPetPrimaryOnPeopleCategory())return wsCatsTail('huisdier',styleKey);
  const base=(CATS&&CATS[cat])||'';
  if(!cat)return base;
  // Baroque Slice 1 (canonical baroque slug) — style-gated huisdier tail
  // overrides. Baroque is "natural coat" oil — no costume / collar / crown
  // / cape / jewelry on animals (see `PROMPT_BODY.baroque`). Gating mirrors
  // the existing huisdier branches: singular vs multi-pet routes through
  // `wsIsMultiAnimalShopperDeclared`. Other styles (royal + artistic five)
  // keep their pre-baroque copy via the fall-throughs below.
  const stKey=wsNormalizeStyleKey(styleKey);
  // R-PET-MULTI-2 (Layer A) — huisdier × shopper-declared N>=2 rewrites
  // the singular "The subject is a PET ANIMAL" tail to a plural MULTI-
  // ANIMAL RULE block parallel to gezin's MULTI-PERSON RULE. Gated by
  // `wsIsMultiAnimalShopperDeclared` so P0, Bond, and mixed_single_photo
  // all keep the legacy singular tail. Mirrors server `buildCategoryTail`
  // huisdier multi-pet branch byte-for-byte (R-dual-surface).
  if(cat==='huisdier'&&wsIsMultiAnimalShopperDeclared()){
    const N=Math.floor(S.shopperAnimalCount);
    if(stKey==='baroque'){
      return ' The subjects are '+N+' distinct PET ANIMALS. MULTI-ANIMAL RULE: every visible animal must keep a separate, accurate likeness — do not merge breed patterns, do not clone one animal\'s face or fur pattern onto another\'s body, and do not average identities across the group. Preserve each animal\'s exact breed, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Keep each animal in its natural coat and anatomy — no costumes, collars, crowns, capes, jewelry, or ceremonial drapery; apply only painterly oil treatment — while keeping every head and face completely unaltered and true to the original photo. Each pet must be instantly recognizable to its owner.';
    }
    if(stKey==='superhero'){
      return ' The subjects are '+N+' distinct PET ANIMALS. MULTI-ANIMAL RULE: every visible animal must keep a separate, accurate likeness — do not merge breed patterns, do not clone one animal\'s face or fur pattern onto another\'s body, and do not average identities across the group. Preserve each animal\'s exact breed, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Fit each animal with its OWN flowing heroic cape in a DISTINCT hue from every other animal — optional small chest emblem per pet that does not obscure the muzzle; preserve natural quadruped anatomy — shared high-altitude heroic flight per Superhero pet flight; calm grounded refs lift off gently — never bipedal standing or humanoid body — while keeping every head and face completely unaltered and true to the original photo. Each pet must be instantly recognizable to its owner.';
    }
    if(stKey==='vintage_fashion'){
      return ' The subjects are '+N+' distinct PET ANIMALS. MULTI-ANIMAL RULE: every visible animal must keep a separate, accurate likeness — do not merge breed patterns, do not clone one animal\'s face or fur pattern onto another\'s body, and do not average identities across the group. Preserve each animal\'s exact breed, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Give each animal its OWN single hero vintage accessory in a DISTINCT style and hue from every other animal — a period hat, beret, cap, bandana, or fascinator with pearls, never stacked; preserve natural quadruped anatomy — never bipedal standing or humanoid body — while keeping every head and face completely unaltered and true to the original photo. Each pet must be instantly recognizable to its owner.';
    }
    if(stKey==='world_cup_football'){
      return ' The subjects are '+N+' distinct PET ANIMALS. MULTI-ANIMAL RULE: every visible animal must keep a separate, accurate likeness — do not merge breed patterns, do not clone one animal\'s face or fur pattern onto another\'s body, and do not average identities across the group. Preserve each animal\'s exact breed, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Give each animal its OWN light neck bib or bandana in a DISTINCT hue from every other animal — shared pitch ball-play with paws on or chasing the ball; preserve natural quadruped anatomy — never bipedal standing or humanoid kick — while keeping every head and face completely unaltered and true to the original photo. Each pet must be instantly recognizable to its owner.';
    }
    if(wsIsIllustratedNaturalCoatPetStyle(stKey)){
      return ' The subjects are '+N+' distinct PET ANIMALS. MULTI-ANIMAL RULE: every visible animal must keep a separate, accurate likeness — do not merge breed patterns, do not clone one animal\'s face or fur pattern onto another\'s body, and do not average identities across the group. Preserve each animal\'s exact breed, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Keep each animal in its natural coat and anatomy — '+ILLUSTRATED_PET_NATURAL_COAT_CATS_MID+'; apply only the chosen illustrated art medium — while keeping every head and face completely unaltered and true to the original photo. Each pet must be instantly recognizable to its owner.';
    }
    return ' The subjects are '+N+' distinct PET ANIMALS. MULTI-ANIMAL RULE: every visible animal must keep a separate, accurate likeness — do not merge breed patterns, do not clone one animal\'s face or fur pattern onto another\'s body, and do not average identities across the group. Preserve each animal\'s exact breed, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Dress each animal body in period costume while keeping every head and face completely unaltered and true to the original photo. Each pet must be instantly recognizable to its owner.';
  }
  // Baroque Slice 1 — singular huisdier × baroque uses natural-coat tail.
  // Replaces the static `CATS.huisdier` "Dress the animal body in period
  // costume" sentence with baroque-aware "no costume / collar / crown".
  if(cat==='huisdier'&&stKey==='baroque'){
    return ' The subject is a PET ANIMAL. Preserve the exact breed characteristics, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Keep the animal in its natural coat and anatomy — no costume, collar, crown, cape, jewelry, or ceremonial drapery; apply only painterly oil treatment — while keeping the head and face completely unaltered and true to the original photo. The pet must be instantly recognizable to its owner.';
  }
  // R-ROYAL-CATS — singular huisdier × royal classic: subtle drape, not period costume.
  if(cat==='huisdier'&&stKey==='royal'){
    return ' The subject is a PET ANIMAL. Preserve the exact breed characteristics, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Apply refined Old Master court attire as subtle shoulder drape, ceremonial collar, or neck mantle shaped to natural anatomy — not a full period costume takeover — while keeping the head and face completely unaltered and true to the original photo. The pet must be instantly recognizable to its owner.';
  }
  if(cat==='huisdier'&&stKey==='superhero'){
    return ' The subject is a PET ANIMAL. Preserve the exact breed characteristics, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Fit a naturally draped heroic cape at the neck and shoulders (and at most a small generic geometric chest emblem that does not obscure the muzzle); preserve natural quadruped anatomy and limb count — reinterpret calm seated or standing references as gentle aerial hover or lift-off per Superhero pet flight, not a ground portrait — never bipedal standing, human hands, or a humanoid torso. Keep the head and face completely unaltered and true to the original photo. The pet must be instantly recognizable to its owner.';
  }
  if(cat==='huisdier'&&stKey==='vintage_fashion'){
    return ' The subject is a PET ANIMAL. Preserve the exact breed characteristics, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Add ONE hero vintage accessory fitted to natural head and neck anatomy — a single period hat, beret, cap, bandana, or fascinator with pearls, never stacked and never a full outfit; preserve natural quadruped anatomy and species-true posture — never bipedal standing, human hands, or a humanoid torso. Keep the head and face completely unaltered and true to the original photo. The pet must be instantly recognizable to its owner.';
  }
  if(cat==='huisdier'&&stKey==='world_cup_football'){
    return ' The subject is a PET ANIMAL. Preserve the exact breed characteristics, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Show natural ball-play — paws on or chasing a ball, mid-pounce on grass with believable weight; optional one light neck bib or bandana with a generic number stripe — never a full kit on the body; preserve natural quadruped anatomy, species-true posture, and limb count — never bipedal standing, human hands, human legs, or a humanoid kick. Keep the head and face completely unaltered and true to the original photo. The pet must be instantly recognizable to its owner.';
  }
  if(cat==='huisdier'&&wsIsIllustratedNaturalCoatPetStyle(stKey)){
    return ' The subject is a PET ANIMAL. Preserve the exact breed characteristics, fur color, fur pattern, facial markings, ear shape, eye color, and every unique physical trait. Keep the animal in its natural coat and anatomy — '+ILLUSTRATED_PET_NATURAL_COAT_CATS_MID+'; apply only the chosen illustrated art medium — while keeping the head and face completely unaltered and true to the original photo. The pet must be instantly recognizable to its owner.';
  }
  const n=S.faceCount;
  const detOk=S.faceDetStatus==='ok';
  const mixedPet=S.containsPetSubject===true||S.compositionMode==='mixed_single_photo'||wsClientPetClassifierTiebreak();
  const petTailNOk=(cat==='kind'?n===1:(cat==='gezin'||cat==='koppel'||cat==='zelf')&&(n===1||n===2));
  if(!detOk||typeof n!=='number'||!mixedPet||!petTailNOk)return base;
  if(cat==='gezin'){
    return' This is a FAMILY-STYLE composition for ONE visible human together with ONE companion pet in the same photograph. Render both with faithful identity — the person and the animal must both appear. Do NOT add an invented partner, baby, extended family, crowd, or silhouette people; do NOT replace the pet with extra humans or merge identities.';
  }
  if(cat==='koppel'){
    return' This is a TWO-PERSON-STYLE framing for ONE visible human together with ONE companion pet in the same photograph. Render both faithfully. Do NOT invent a second adult, children, or filler figures; do NOT remove or replace the pet with a human.';
  }
  if(cat==='kind'){
    return' This is a CHILDREN-STYLE composition for ONE visible child together with ONE companion pet in the same frame. Preserve both the child and the pet; do NOT invent siblings, classmates, or extra children; do NOT erase the animal.';
  }
  if(cat==='zelf'){
    return' This SELF-PORTRAIT reference includes ONE primary person with a visible companion pet. Preserve both with maximum fidelity; do NOT drop the pet or add invented people.';
  }
  return base;
}

/**
 * Researcher plan §6 Q3 / §7.G: visual evidence wins on count.
 * - `gezin`/`koppel` default to the GROUP identity anchor (multi-person photos
 *   are the dominant case), but a confident "exactly 1 face" detection flips
 *   to the SINGULAR anchor so the model is not told to paint extra relatives.
 * - `kind` only uses the GROUP anchor when detection confidently sees >=2.
 * - Inconclusive detection (`null` / timeout / error) keeps the historical
 *   default — the server stitch's count guard (`visionReconciliationClause`)
 *   stays silent in that case, so we do not invent a count claim either.
 */
function wsUsesGroupIdentityAnchor(cat){
  const n=S.faceCount;
  const detOk=S.faceDetStatus==='ok';
  const multiPhotoNonPanelBond=Array.isArray(S.slots)&&S.slots.length>=2&&!wsSlotsBondComposition();
  if(cat==='gezin'||cat==='koppel'){
    if(detOk&&typeof n==='number'&&n===1)return false;
    if(detOk&&typeof n==='number'&&n===2&&(S.containsPetSubject===true||wsClientPetClassifierTiebreak())&&!multiPhotoNonPanelBond)return false;
    return true;
  }
  if(cat==='kind'&&typeof n==='number'&&n>=2)return true;
  // R-PET-MULTI-2 (Layer A) — huisdier × shopper-declared N>=2 routes
  // to the multi-pet identity anchor (ID_ANCHOR_GROUP_PET) so the
  // theme-stitched prompt overrides the singular ID_ANCHOR "single
  // primary subject" framing. Predicate gates out P0 / Bond /
  // mixed_single_photo.
  if(cat==='huisdier'&&wsIsMultiAnimalShopperDeclared())return true;
  return false;
}
/** Audit Fix E2 / BA-011 — people-category NO-INVENT guard (all styles). */
function wsNoInventSubjectGuard(cat,styleKey){
  if(cat==='huisdier')return '';
  if(wsIsPetPrimaryOnPeopleCategory())return '';
  if(wsSlotsBondComposition())return '';
  if(S.compositionMode==='mixed_single_photo')return '';
  if(S.containsPetSubject===true&&!wsVerifySaysNoCompanionPet())return '';
  return NO_INVENT_SUBJECT_GUARD_CLAUSE;
}
/** HALL-1 — pet-only reference on people category; all styles. */
function wsNoInventHumanGuard(cat,styleKey){
  if(cat==='huisdier')return '';
  if(!wsIsPetPrimaryOnPeopleCategory())return '';
  return NO_INVENT_HUMAN_GUARD_CLAUSE;
}
function wsIdentityAnchorFor(cat,styleKey){
  const st=wsNormalizeStyleKey(styleKey);
  // Baroque Slice 1 — `baroque` joins the artistic identity-anchor set
  // (oil-on-canvas treatment, not court state-portrait). Royal stays
  // separate via `royalPeopleOil` to preserve `ID_ANCHOR_ROYAL` semantics.
  const artistic=['watercolor','popart','anime','nordic','lineart','baroque','superhero','vintage_fashion','world_cup_football'].includes(st);
  /** Royal oil integration applies to people pillars only — pet uploads use ID_ANCHOR. */
  const royalPeopleOil=st==='royal'&&cat!=='huisdier'&&!wsIsPetPrimaryOnPeopleCategory();
  if(wsUsesGroupIdentityAnchor(cat)){
    // R-PET-MULTI-2 (Layer A) — pet-pillar group anchor when multi-pet
    // fires on huisdier. Mirrors the people-pillar branch above.
    if(cat==='huisdier')return artistic?ID_ANCHOR_GROUP_PET_ARTISTIC:ID_ANCHOR_GROUP_PET;
    if(royalPeopleOil)return ID_ANCHOR_GROUP_ROYAL;
    return artistic?ID_ANCHOR_GROUP_ARTISTIC:ID_ANCHOR_GROUP;
  }
  if(royalPeopleOil)return ID_ANCHOR_ROYAL;
  return artistic?ID_ANCHOR_ARTISTIC:ID_ANCHOR;
}
// Phase 2 Slice 2c-2 (May 28 2026): `wsComposeStylePrompt` is no longer
// called by generate() — the wire prompt is carrier-only (inscription +
// notes + framed extras). The function is kept defined for any future
// preview UI / Try-again helper that may still call it; the royal
// branch now uses an empty body (worker authoritative for royal).
function wsComposeStylePrompt(cat,styleKey){
  const st=wsNormalizeStyleKey(styleKey);
  let body=PROMPT_BODY[st]||'';
  const coatCat=wsIsPetPrimaryOnPeopleCategory()?'huisdier':cat;
  if(coatCat==='huisdier'&&wsIsIllustratedNaturalCoatPetStyle(st))body+=ILLUSTRATED_PET_NATURAL_COAT_RECIPE_TAIL;
  return wsIdentityAnchorFor(cat,styleKey)+wsNoInventSubjectGuard(cat,styleKey)+wsNoInventHumanGuard(cat,styleKey)+body+wsPortraitUnityAdjunct(cat,styleKey)+wsPortraitConversionAdjunct(cat,styleKey)+wsPeopleAnatomyContactAdjunct(cat,styleKey);
}
/** How inscription lettering should look in-painting for each normalized style key. */
function wsInscriptionStyleClause(st){
  switch(st){
    case 'royal':
      return wsInscriptionStyleClauseRoyal();
    case 'baroque':
      return 'Lettering style: warm ivory or soft gold-leaf script integrated wet-into-wet into the painted ground — small, understated, and secondary to the subject like a discreet Old Master signature; legible at print size while subordinate, never larger or louder than the face, never bold display type, never sticker-like, never chrome emboss, embossed seal, or UI sans-serif overlay; harmonized with the scene chiaroscuro.';
    case 'watercolor':
      return 'Lettering style: soft watercolor pigment on the paper — granulating wash, slightly feathered edges, no sharp vector outlines.';
    case 'popart':
      return 'Lettering style: bold graphic hand-lettered forms consistent with flat pop-art planes — high clarity but visibly painted, not system UI typography.';
    case 'anime':
      return 'Lettering style: clean illustrated title lettering matching cel-ink and fill — readable wall-art caption energy, not embossed metallic chrome.';
    case 'nordic':
      return 'Lettering style: restrained matte pigment or pencil on paper with faint tooth — muted ink tone, calm Nordic editorial restraint.';
    case 'lineart':
      return 'Lettering style: fine confident ink monoline signature — minimalist contour, integrated with the line-art language of the piece.';
    case 'superhero':
      return 'Lettering style: bold painted heroic caption lettering — integrated brush texture matching the portrait medium, legible at print size, never chrome emboss or UI sans-serif overlay.';
    case 'vintage_fashion':
      return 'Lettering style: delicate vintage cursive script in soft watercolor pigment integrated into existing negative space — feathered edges, muted tone, legible at print size, never chrome emboss or UI sans-serif overlay.';
    case 'world_cup_football':
      return 'Lettering style: bold painted sports caption lettering — integrated brush texture matching the portrait medium, legible at print size, never chrome emboss or UI sans-serif overlay.';
    default:
      return 'Lettering style: match the dominant medium and brush texture of the chosen style exactly.';
  }
}
function wsPetInscriptionStyleClause(st){return wsInscriptionStyleClause(st);}

/** INSC-COMP v35 — subject-first inscription guard is inlined here (SUBJECT-FIRST INSCRIPTION:)
 *  so the function stays self-contained for isolated `vm` unit tests. The dedication is painted
 *  into EXISTING negative space; the model must never invent a foreground plinth/pedestal/ledge/
 *  slab/stone block/plaque/cartouche to host the text, and must never truncate or reframe the
 *  subject to make room. Composition + likeness win; the name stays subordinate. Travels in the
 *  theme carrier and is read back by the worker (`extractPetPortraitSegmentFromClientPrompt`). */
function wsPortraitInscriptionSharedComposition(){
  return ' PET PORTRAIT COMPOSITION: Keep the lower-right background area (calm lighter ground or simple existing texture in key light—not deep shadow, busy rug weave, or dark grass—not any subject’s face, eyes, or body mass) visually calm and uncluttered so the dedication can be painted into the existing background; avoid placing a subject’s tail or focal detail in that corner when composition allows. SUBJECT-FIRST INSCRIPTION: integrate the dedication into existing background negative space only; do NOT invent or add a foreground plinth, pedestal, ledge, slab, stone block, plaque, banner, or cartouche to carry the text, and do NOT truncate, shrink, crop, or reframe the subject (body, torso, robe, paws, or hands) to make room for it. The subject and composition take priority; the painted name remains small and subordinate, never a competing focal object. ';
}

function wsPortraitInscriptionEmptyNoText(cat){
  const petExtra=(cat==='huisdier')?' generic Dutch pet words (Poes, Kat),':'';
  return ' NO IN-IMAGE TEXT WHEN NO NAME WAS PROVIDED: The shopper did not supply a portrait dedication or name. Do not paint, letter, emboss, carve, or otherwise render any readable text in the artwork — no names, nicknames,'+petExtra+' artist signatures, mottos, Latin or religious phrases, dates, monograms, watermarks, studio or vendor bylines, coat-of-arms lettering, corner captions, or faux hand-painted lettering in the reserved area. Keep that corner as painted texture and background only, not typography. ';
}

/** INS-1 — reject contact-shaped inscription text before prompt embed (modal + prompt builder).
 *  B3 name-only — additionally reject sentence-shaped input so the modal accepts only
 *  signature names (Emma, Luna, "Familie Jansen", "Tim & Tom") and not full messages
 *  like "Dit is voor mama!". Theme-side guard only — shared app-proxy/inscription-
 *  eligibility.js keeps the historical permissive rules so legacy preview prompts and
 *  the worker sanitizer do not regress. */
function wsIsIneligibleInscriptionText(raw){
  const x=String(raw||'').trim();
  if(!x)return false;
  if(/@/.test(x))return 'email';
  if(/^https?:\/\//i.test(x)||/\bwww\./i.test(x))return 'url';
  if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(x))return 'email';
  if(/^[\d\s+\-().]{8,}$/.test(x)&&x.replace(/\D/g,'').length>=8)return 'phone';
  if(x.length>30)return 'message';
  if(/[.!?;:,]/.test(x))return 'message';
  if(x.split(/\s+/).length>4)return 'message';
  return false;
}

function wsInscriptionErrorI18nKey(reason){
  if(reason==='url')return 'inscription.error.url';
  if(reason==='phone')return 'inscription.error.phone';
  if(reason==='message')return 'inscription.error.message';
  return 'inscription.error.email';
}

function wsSyncInscriptionInputError(inp,reason){
  const errEl=document.getElementById('petNameInputError');
  if(!inp)return reason||null;
  if(reason){
    inp.setAttribute('aria-invalid','true');
    if(errEl){
      errEl.hidden=false;
      errEl.textContent=wsT(wsInscriptionErrorI18nKey(reason));
      errEl.setAttribute('data-i18n',wsInscriptionErrorI18nKey(reason));
      inp.setAttribute('aria-describedby','petNameInputError');
    }else{
      inp.removeAttribute('aria-describedby');
    }
    return reason;
  }
  inp.removeAttribute('aria-invalid');
  /* Name-only modal hides the subtitle paragraph, so there is no static
     describedby target; only inline error attaches when validation fails. */
  inp.removeAttribute('aria-describedby');
  if(errEl){
    errEl.hidden=true;
    errEl.textContent='';
    errEl.removeAttribute('data-i18n');
  }
  return null;
}

/**
 * Portrait inscription prompt segment when the shopper entered valid dedication text.
 * Marker `PET PORTRAIT COMPOSITION:` preserved for worker `extractPetPortraitSegmentFromClientPrompt`.
 * INSC-CORNER-GATE (May 2026): empty/ineligible name → '' (no corner reservation without text).
 */
function wsPortraitInscriptionContext(cat,styleKey,nameRaw){
  const composition=wsPortraitInscriptionSharedComposition();
  const x=String(nameRaw||'').trim().slice(0,48).replace(/[\r\n<>\"]/g,'');
  if(!x||wsIsIneligibleInscriptionText(x))return '';
  const st=wsNormalizeStyleKey(styleKey);
  const medium=wsInscriptionStyleClause(st);
  const royalSurface=st==='royal'?(cat==='huisdier'?ROYAL_INSCRIPTION_REGALIA_SURFACE:ROYAL_INSCRIPTION_PEOPLE_SURFACE):'';
  const royalLegibility=st==='royal'?ROYAL_INSCRIPTION_LEGIBILITY:'';
  const letterSpell=!wsIsIneligibleInscriptionText(x)&&(x.length>12||/[^a-zA-ZÀ-ÿ0-9 \-'&]/.test(x))?' Spell the painted dedication exactly letter-by-letter as quoted; do not substitute or reorder characters.':'';
  if(cat==='huisdier'){
    if(wsIsMultiAnimalShopperDeclared()){
      return composition+royalSurface+' MULTI-ANIMAL NAME PLATE: The reference photograph shows multiple distinct animals. The shopper supplied the name “'+x+'” — paint it as a single SHARED inscription / signature line in the lower-right reserved area (real pixels in the artwork — not a caption bar, sticker, or overlay). '+medium+royalLegibility+' Do NOT use this name to anchor or elevate one specific animal as “the named hero”; all visible animals share equal portrait emphasis and distinct likeness.'+letterSpell+' Hard negatives: no per-animal name tags floating beside individual subjects, no extra words, slogans, dates, watermarks, studio or vendor bylines, or crisp system typography; do not cover any animal’s face, eyes, or main focal mass.';
    }
    if(wsInscriptionModalCell('huisdier')==='bond'){
      return composition+royalSurface+' SHARED DEDICATION PLATE: Paint the shopper’s dedication “'+x+'” as a single SHARED inscription line in the lower-right reserved area (real pixels in the artwork — not a caption bar, sticker, or overlay). '+medium+royalLegibility+' Do NOT use this dedication to anchor or elevate one person or animal as “the named hero”; preserve equal portrait emphasis for every visible subject.'+letterSpell+' Hard negatives: no per-subject name tags floating beside individuals, no extra words, slogans, dates, watermarks, studio or vendor bylines, or crisp system typography; do not cover any face, eyes, or main focal mass.';
    }
    return composition+royalSurface+' MANDATORY PET NAME IN THE IMAGE: The output MUST integrate the pet’s name “'+x+'” as a painted dedication in the lower-right, part of the same brush layer as the portrait (real pixels in the artwork — not a caption bar, sticker, or separate overlay look), without adding any prop or surface to host it.'+letterSpell+' '+medium+royalLegibility+' The ONLY name text allowed is “'+x+'” (exact spelling and casing). Owner refers to this pet as “'+x+'”. Hard negatives: no extra words, slogans, dates, watermarks, studio or vendor bylines, or crisp system typography; do not cover the pet’s face, eyes, or main focal mass.';
  }
  if(cat==='gezin'||cat==='koppel'){
    return composition+royalSurface+' SHARED DEDICATION PLATE: Paint the shopper’s shared dedication “'+x+'” as a single SHARED inscription line in the lower-right reserved area (real pixels in the artwork — not a caption bar, sticker, or overlay). '+medium+royalLegibility+' Do NOT use this dedication to anchor or elevate one person as “the named hero”; every visible person shares equal portrait emphasis and distinct likeness.'+letterSpell+' Hard negatives: no per-person name tags floating beside individual subjects, no extra words, slogans, dates, watermarks, studio or vendor bylines, or crisp system typography; do not cover any face, eyes, or main focal mass.';
  }
  return composition+royalSurface+' PORTRAIT DEDICATION: The output MUST integrate the dedication “'+x+'” as a painted dedication in the lower-right, part of the same brush layer as the portrait (real pixels in the artwork — not a caption bar, sticker, or separate overlay look), without adding any prop or surface to host it.'+letterSpell+' '+medium+royalLegibility+' Dedication text only — do not invent a live pet or name-bearer subject not visible in the reference. The ONLY dedication text allowed is “'+x+'” (exact spelling and casing). Hard negatives: no extra words, slogans, dates, watermarks, studio or vendor bylines, or crisp system typography; do not cover the subject’s face, eyes, or main focal mass.';
}

/** @deprecated alias — huisdier-only callers; prefer wsPortraitInscriptionContext. */
function wsPetPortraitPromptContext(styleKey,petNameRaw){
  return wsPortraitInscriptionContext('huisdier',styleKey,petNameRaw);
}
/** R-BOND-MULTI v30 — multi-pet bond / mixed_single_photo count fidelity. */
function wsBondMultiPetCountGuard(){
  if(!wsIsIntentionalHumanPetPortrait(S,null))return '';
  const n=S.estimatedPetCount;
  if(typeof n!=='number'||!Number.isFinite(n)||n<2)return '';
  const count=Math.floor(n);
  return ' BOND MULTI-PET COUNT GUARD: the reference shows at least '+count+' distinct animals — render EACH with its own breed, fur color, fur pattern, markings, ear shape, eye color, and body; do NOT merge bodies, clone one animal onto another, or collapse multiple pets into one hero. Do NOT invent additional animals beyond those visible in the reference photograph.';
}
/**
 * Vision-driven prompt hint, mirrors the server `visionReconciliationClause`
 * so the client-built prompt and the server stitch agree even on the legacy
 * theme-only path (researcher plan §7.G dual-surface). Silent when detection
 * is inconclusive (null / timeout / error) — never invent a count claim.
 */
function wsFaceHintFromDetect(){
  const n=S.faceCount;
  const cat=S.cat;
  const detOk=S.faceDetStatus==='ok';
  /* R-MIX8 / inversion fallback: Pet category tail stresses animals only; when
     pixels say likely_human, anchor preservation so Continue anyway does not
     silently drop visible people (theme prompt mirrors intent; server may add guards).
     R-PET-MULTI-1 (P0): lone-human-on-Pets (no Bond, no mixed_single_photo)
     emits the ANTI-HYBRID GUARD substring to mirror the server stitch
     (`humanPrimaryOnPetCategoryGuard`). Source-grep parity is pinned by
     `app-proxy/face-prompt-mirror.test.js` and
     `app-proxy/anti-hybrid-prompt.test.js`. */
  if(cat==='huisdier'){
    if(S.subjectClass==='likely_human'){
      if(wsIsHumanPrimaryOnPetCategory()){
        return' ANTI-HYBRID GUARD: the storefront category is "Pets" (huisdier) but the storefront classifier confidently reports the primary subject as a HUMAN. Treat the reference as a human portrait, not a pet portrait. PRESERVE: the person\'s exact human face, skin tone, hair, eyes, mouth, ear shape, freckles, and child-appropriate body proportions exactly as captured; render human limbs (hands with fingers, arms, shoulders), human posture, and human-anatomy joints. TRANSFORM: only the clothing, accessories, environment, lighting, and painting medium — apply human royal regalia ONLY (ermine-trimmed robes, jewels, an upright coronet or crown seated on a human head per standard people-portrait geometry — never a pet cranial-axis coronet, never a jewelled collar, never an animal mantle) when royal styling applies; otherwise apply the chosen art style to the human subject only. DO NOT paint paws, fur-body limbs, quadruped forelimbs, a muzzle, whiskers, an animal tail, a jewelled pet collar, a horizon-locked floating pet coronet, or an anthropomorphic animal courtier alongside the human. DO NOT blend human and animal anatomy into a hybrid figure. The chosen category informs styling vocabulary; the photograph dictates species. ';
      }
      if(wsIsIntentionalHumanPetPortrait()){
        return' SUBJECT PRESERVATION (pet category; people visible in the reference): Preserve every visible person and every visible animal with faithful identity. Pet-forward styling may emphasize animals but must NOT remove, crop out, or replace any visible person. ';
      }
      return'';
    }
    /* R-PET-MULTI-2 (Layer A) — multi-animal SUBJECT-COUNT GUARD. Fires
       when the shopper declared N>=2 distinct animals in the notes
       (parsed by wsParseShopperAnimalCountFromNotes) AND none of the
       explicit dual-subject opt-ins are active (the predicate excludes
       P0, Bond, and mixed_single_photo). Mirrors server
       `multiAnimalSubjectCountGuard` byte-for-byte — substring `MULTI-
       ANIMAL SUBJECT-COUNT GUARD` is the marker scanned by
       `buildWallstraightGenerationMeta` for `multi_animal_guard_fired`. */
    if(wsIsMultiAnimalShopperDeclared()){
      const N=Math.floor(S.shopperAnimalCount);
      return ' MULTI-ANIMAL SUBJECT-COUNT GUARD: the shopper declared '+N+' distinct animals in this photograph. Render EVERY visible animal as its own separately recognizable subject — preserve each animal\'s breed, fur color, fur pattern, ear shape, eye color, and unique markings exactly as captured in the reference. Do NOT collapse multiple animals into a single hero, do NOT clone or duplicate one animal\'s likeness onto another\'s body, do NOT merge breed patterns or markings across bodies, do NOT invent additional animals not present in the reference photograph. If the reference genuinely shows fewer animals than declared, render only the animals ACTUALLY visible in the photograph — the photograph defines the count, the declaration is a fidelity floor. Species-neutral: this rule applies whether all animals are the same breed (give each unique markings, spacing, and pose so the figures remain distinct) or a mix of species (preserve each species\' anatomy faithfully).';
    }
    return'';
  }
  if(wsIsPetPrimaryOnPeopleCategory()){
    return' ANTI-INVERSION GUARD: the storefront category is a people portrait mode but the classifier confidently reports the primary subject as an ANIMAL only — no human is visible in the reference. Treat the reference as a solo pet portrait, not a human royal portrait. PRESERVE: the animal\'s exact breed or species, fur color, fur pattern, facial markings, ear shape, eye color, muzzle, expression, pose, paws, and tail exactly as captured; render quadruped anatomy, fur texture, and natural pet proportions faithfully. TRANSFORM: only pet-appropriate regalia (collar, mantle on natural animal contour, jeweled medallion), environment, lighting, and painting medium — never human court bodice, ermine robes sized for a human, or lap-holder composition. DO NOT paint human figures, human hands, human arms, human faces, courtiers, nobles, lap-holders, silhouettes, or anthropomorphic human limbs on the animal. DO NOT blend human and animal anatomy into a hybrid figure. The photograph dictates species; styling must stay pet-forward. ';
  }
  if(!detOk||typeof n!=='number')return'';
  const multiPhotoNonPanelBond=Array.isArray(S.slots)&&S.slots.length>=2&&!wsSlotsBondComposition();
  if(
    n===2&&(S.containsPetSubject===true||wsClientPetClassifierTiebreak())&&S.compositionMode!=='mixed_single_photo'&&!multiPhotoNonPanelBond&&
    (cat==='gezin'||cat==='koppel'||cat==='kind'||cat==='zelf')
  ){
    const label=cat==='koppel'?'couple-style':cat==='kind'?'children-style':cat==='zelf'?'self-portrait treatment':'family-style';
    return' SUBJECT-COUNT GUARD: the storefront face detector reported 2 faces while a recognizable companion animal (dog or cat) is visible in-frame — one tally may be the animal\'s head, not a second human. Render every human ACTUALLY visible in the reference photo alongside the animal — including any not enumerated above — preserving both people and pet faithfully in the chosen '+label+'. Do NOT treat the count as proof of a multi-adult family or invent relatives, partners, infants, siblings, classmates, crowd fillers, or background families who are NOT visible in the reference photo. Do NOT replace the pet with imaginary humans or remove the animal. If the reference genuinely shows only one person with one pet, keep the scene to that pair. The category informs styling; the photograph dictates subjects. ';
  }
  if(n>=2){
    if(cat==='kind'){
      // R-FEED-8c — mirror server `visionReconciliationClause`:
      // "AT LEAST N visible" + "render EVERY visible child" so that
      // small / partial faces in the reference are still preserved.
      // Wording matches openai-image-edit.server.ts kind+N>=2 branch.
      return ' SUBJECT-COUNT GUARD: AT LEAST '+n+' distinct individuals detected in the reference (small or partial faces may not be enumerated above but ARE visible — render them too). Render EVERY visible child as a separate, uniquely recognizable figure with their own facial features — including any not enumerated above. Do NOT collapse the group into a single hero child or duplicate one face onto multiple bodies. Do NOT invent dogs, cats, birds, lapdogs, court pets, or any animal companions not visible in the reference photograph. ';
    }
    if(cat==='gezin'||cat==='koppel'){
      // R-FEED-8c — see kind-branch comment above. Strictly more
      // permissive than the prior "preserve all N" wording; cannot
      // reduce likeness, can only improve it for undercounted subjects.
      // "small or partial faces" (NOT "infant") matches the server-side
      // koppel safety contract: koppel must not contain "infant" or
      // "toddler" so the model never invents a child between two
      // adult partners (vision-gezin-age-awareness.test.ts).
      return ' SUBJECT-COUNT GUARD: AT LEAST '+n+' distinct people detected in the reference (small or partial faces may not be enumerated above but ARE visible — render them too). Preserve EVERY visible person as a separate figure with unique faces, hair, and accessories — including any not enumerated above. Do NOT merge identities or duplicate one face across multiple bodies. Do NOT invent dogs, cats, birds, lapdogs, court pets, or any animal companions not visible in the reference photograph. ';
    }
    if(cat==='zelf'){
      return ' SUBJECT-COUNT GUARD: AT LEAST '+n+' distinct people detected in the reference (small or partial faces may not be enumerated above but ARE visible — render them too). Preserve EVERY visible person as a separate figure with unique faces, hair, and accessories — including any not enumerated above. Do NOT merge identities or duplicate one face across multiple bodies. Do NOT invent dogs, cats, birds, lapdogs, court pets, or any animal companions not visible in the reference photograph. ';
    }
    return ' MULTI-SUBJECT LIKENESS (AT LEAST '+n+' face(s) detected in the reference): Each individual must stay visually distinct in the output. Do NOT reuse one face for multiple figures. ';
  }
  if(n===1&&(cat==='gezin'||cat==='koppel')){
    const mixedPet=S.containsPetSubject===true||S.compositionMode==='mixed_single_photo'||wsClientPetClassifierTiebreak();
    if(mixedPet){
      // R-FEED-9 — mirror server visionReconciliationClause
      // mixed_single_photo + N=1 wording shift. Anchor truth to the
      // reference image (which gpt-image-1.5 sees), not the detector
      // count. Closes the May 2026 case (3 sisters + dog on `kind`,
      // detector counted 1, model dropped 2 visible siblings; job
      // a3320fef-3be3-481a-880f-c9cc812bdb19). The "infants" noun is
      // intentionally kept in the do-NOT-invent enumeration so the
      // genuine couple+pet case is not regressed (the qualifier
      // "NOT visible in the reference" scopes anti-invention to
      // absent-from-reference figures only). Koppel safety contract
      // still preserved by the qualifier.
      return' SUBJECT-COUNT GUARD: the storefront face detector identified 1 person alongside a visible companion pet, but small / partial / side-facing faces in the reference may not have been counted. Render every person ACTUALLY visible in the reference photo alongside the pet — including any not enumerated above — preserving both the human(s) and the pet. Do NOT invent additional human family members, partners, infants, relatives, or background crowds who are NOT visible in the reference photo. Do NOT remove the pet or substitute it with imaginary humans. ';
    }
    const label=cat==='koppel'?'couple-style':'family-style';
    // R-FEED-9 — mirror server gezin/koppel + N=1 wording shift.
    // Genuine-solo fallback preserved by "if the reference genuinely
    // shows only 1 person" clause. Koppel safety contract preserved
    // (no age-band nouns in this branch — the source-grep test in
    // app-proxy/face-prompt-mirror.test.js pins this).
    return' SUBJECT-COUNT GUARD: the storefront face detector identified 1 person, but small / partial / side-facing faces in the reference may not have been counted. Render every person ACTUALLY visible in the reference photo — including any not enumerated above — preserving each person\'s exact identity in the chosen '+label+' composition. If the reference genuinely shows only 1 person, render a single-subject '+label+' portrait. Do NOT invent or paint additional relatives, partners, children, hands, or background figures who are NOT visible in the reference photo. Do NOT invent dogs, cats, birds, lapdogs, court pets, or any animal companions not visible in the reference photograph. ';
  }
  if(n===1&&(cat==='kind'||cat==='zelf')){
    const mixedPet=S.containsPetSubject===true||S.compositionMode==='mixed_single_photo'||wsClientPetClassifierTiebreak();
    if(!mixedPet)return'';
    if(cat==='kind'){
      // R-FEED-9 — mirror server kind + N=1 + mixed wording. R-MIX6
      // single-child contract preserved by the "if the reference
      // genuinely shows only 1 child" fallback.
      return' SUBJECT-COUNT GUARD: the storefront face detector identified 1 child alongside a visible companion pet, but small / partial / side-facing faces in the reference may not have been counted. Render every child ACTUALLY visible in the reference photo alongside the pet — including any not enumerated above — preserving both the child(ren) and the pet. If the reference genuinely shows only 1 child, render a single-subject children-style portrait with that child. Do NOT invent siblings, classmates, or extra children who are NOT visible in the reference photo. ';
    }
    // R-FEED-9 — mirror server zelf + N=1 + mixed wording.
    return' SUBJECT-COUNT GUARD: the storefront face detector identified 1 primary person alongside a visible companion pet, but small / partial / side-facing faces in the reference may not have been counted. Render every person ACTUALLY visible in the reference photo alongside the pet — including any not enumerated above — preserving both the human(s) and the pet. Do NOT invent additional figures who are NOT visible in the reference photo. ';
  }
  return '';
}

/**
 * R-PET-MULTI-3 (Layer B) — theme mirror of the worker's
 * `multiAnimalLikenessClause`. Fires on the same activation matrix as
 * the Slice 3 Layer A guard (`wsIsMultiAnimalShopperDeclared`) so Layer
 * A and Layer B always agree on which cell they apply to.
 *
 * Substring marker `MULTI-ANIMAL LIKENESS GUARD` is byte-aligned with
 * the server (`MULTI_ANIMAL_LIKENESS_GUARD_MARKER`) so the
 * `multi_animal_likeness_guard_fired` telemetry flag and the rollup
 * `style_adjunct_fired` flag both detect the same emission on the
 * stitched prompt regardless of which surface built it.
 *
 * Per-style tails mirror the worker's six canonical slugs verbatim
 * (`royal`, `watercolor`, `popart`, `anime`, `nordic`, `lineart`) so a
 * future copy desk pass on either side will be caught by
 * `app-proxy/multi-pet-layer-b.test.js`. Defensive fallback handles any
 * future style slug that lands in code before its per-style copy ships.
 *
 * Source-grep parity pin: `app-proxy/multi-pet-layer-b.test.js`.
 */
function wsMultiAnimalLikenessClause(styleKey){
  if(!wsIsMultiAnimalShopperDeclared())return'';
  const st=wsNormalizeStyleKey(styleKey);
  let styleTail;
  if(st==='royal'){
    styleTail=' Treat the styling as state-portrait oil for a court of companion animals: each visible animal receives its OWN regal garment, mantle, sash, or cape with a DISTINCT hue family from every other animal in the frame — no duplicated gold-on-ermine twinning across two pets, no copy-paste coronet, no mirrored regalia. A shared throne, court setting, or coronet motif is fine, but the per-animal regalia must read uniquely. A subtle warm bearing is allowed; do not force a uniform clone court.';
  }else if(st==='baroque'){
    styleTail=' Treat the styling as a classical multi-animal oil study in chiaroscuro: each visible animal owns its own light/shadow shape on the canvas with distinct tonal separation — no duplicated twin-catchlights or copy-paste fur stacks across two pets. Natural coats and breed silhouettes stay legible per subject; depth and atmosphere are fine, but do not crown, cape, or costume the animals.';
  }else if(st==='watercolor'){
    styleTail=' Treat the styling as transparent watercolor wash for a multi-animal study: each visible animal sits in its OWN contained wash with distinct edge softness and palette weight; preserve figure separation through value and pigment rather than through tight outlines. No pigment bleed merging two animals into a shared body silhouette.';
  }else if(st==='popart'){
    styleTail=' Treat the styling as bold pop-art planes for a multi-animal poster: each visible animal occupies its OWN flat color block and graphic plane; halftone or screen-tone patterns vary per animal so no two pets read as duplicated prints. Keep the breed silhouette legible per subject — no symmetric copy-paste of one body onto another.';
  }else if(st==='anime'){
    styleTail=' Treat the styling as cel-anime portrait for a multi-animal cast: each visible animal gets distinct cel shading, eye-highlight, and accent color; preserve breed silhouette and unique markings so no two animals collapse into a single cel-ink template.';
  }else if(st==='nordic'){
    styleTail=' Treat the styling as muted Nordic editorial for a multi-animal study: calm spacing between each animal, restrained palette, distinct soft tonal blocks per body — preserve breed silhouette through pose, palette, and tonal grouping rather than through high-contrast outlines.';
  }else if(st==='lineart'){
    styleTail=' Treat the styling as editorial ink line-art for a multi-animal composition: each visible animal gets its OWN distinct contour pocket and hatching rhythm; variable stroke weight with contour hatching for depth; do not merge silhouettes; preserve breed markings per subject.';
  }else if(st==='superhero'){
    styleTail=' Treat the styling as painterly heroic illustration for a multi-animal cast: each visible animal gets its OWN flowing cape in a DISTINCT hue from every other animal — optional small chest emblem per pet that does not obscure the muzzle; preserve quadruped anatomy and breed markings in shared heroic flight; never merge two pets into one humanoid hero body.';
  }else if(st==='vintage_fashion'){
    styleTail=' Treat the styling as vintage fashion-art paint for a multi-animal sitting: each visible animal gets its OWN single hero accessory in a DISTINCT style and hue — a period hat, beret, cap, bandana, or fascinator with pearls, never stacked; preserve quadruped anatomy and breed markings; never merge two pets into one body.';
  }else if(st==='world_cup_football'){
    styleTail=' Treat the styling as painterly sports illustration for a multi-animal cast: each visible animal gets its OWN light neck bib or bandana in a DISTINCT hue — shared pitch ball-play with paws on or chasing the ball; preserve quadruped anatomy and breed markings; never merge two pets into one humanoid hero body.';
  }else{
    styleTail=' Apply the chosen style consistently across the visible group but keep each animal\'s identity distinguishable through palette, pose, and rendered breed cues — never merge two animals into one hero figure.';
  }
  return' MULTI-ANIMAL LIKENESS GUARD: the reference photograph shows multiple distinct animals — lock each animal\'s identity (breed reads, fur color, fur pattern, ear shape, eye color, body silhouette) to the matching individual in the reference. Do NOT swap markings between animals, merge two pets into one hero figure, or reuse one breed pattern across separate bodies.'+styleTail;
}

let _wsFaceDetPromise=null;
function wsShouldSkipFaceDetect(){
  if(typeof window==='undefined')return true;
  return window.__WS_CONTRACT_TEST__===true;
}
/**
 * Multi-photo (A1 Bond-extended) helpers — Slice A.3.
 *
 * S.slots is the multi-photo source of truth. Slot 0 mirrors the existing
 * top-level state (S.b64 / S.faceCount / S.faceDetStatus / …) so the
 * single-photo back-compat path is untouched. Slots 1..N are extras added via
 * the "+ Add another photo" CTA from Slice A.2.
 *
 * Each slot has shape:
 *   { id, isPrimary, file, dataUrl, b64, role, faceCount, faceDetScore,
 *     faceDetStatus, faceDetCompletedAt, faceDetPromise }
 *
 * `role` is 'people' | 'pet'. The primary slot derives its role from S.cat
 * (`huisdier` → 'pet'; everything else → 'people'). Extras default to 'pet'
 * because Bond (people + pet) is the dominant v1 use case; the user can flip
 * via the role chip on each thumbnail.
 *
 * Pet slots skip face detection (status: 'skipped_pet') — symmetric with the
 * existing top-level `cat === 'huisdier'` short-circuit in wsResolveVisionMeta.
 */

/** v1 cap mirrors the server constant `MAX_TOTAL_IMAGES_PER_GENERATION` (3 total). */
const WS_MAX_TOTAL_PHOTOS=3;

/** Sum of `people`-role faceCounts across the slot stack; null if every slot is inconclusive. */
function wsAggregatedPeopleFaceCount(slots){
  const arr=Array.isArray(slots)?slots:[];
  let sum=0;let any=false;
  for(const s of arr){
    if(!s||s.role!=='people')continue;
    if(typeof s.faceCount==='number'&&Number.isFinite(s.faceCount)&&s.faceCount>=0){
      sum+=s.faceCount;any=true;
    }
  }
  return any?sum:null;
}

/**
 * Track H (slice p2h-ux / p2h-server) — coalesce per-slot subjectClass into a
 * single top-level verdict for the soft-gate AND the wire `visionMeta`. Mirror
 * of `effectiveSubjectClass` on the server (R17 — same evidence drives banner
 * and prompt clause):
 *
 *   - any people-role slot tagged 'likely_pet' wins (the photo is animal-
 *     primary even though the user picked a people category);
 *   - else if every people-role slot is 'likely_human' ⇒ 'likely_human';
 *   - else if at least one people-role slot has a verdict but they disagree
 *     or include 'unknown' ⇒ 'unknown' (never fabricate a single class);
 *   - else (no people-role slot has a verdict yet) ⇒ null.
 *
 * `null` is distinct from `'unknown'`: null = "no signal yet" (don't render
 * pet variant); 'unknown' = "classifier ran, was inconclusive" (still don't
 * render pet variant, but downstream may log the distinction).
 */
function wsAggregatedPeopleSubjectClass(slots){
  const arr=Array.isArray(slots)?slots:[];
  const verdicts=[];
  for(const s of arr){
    if(!s||s.role!=='people')continue;
    const v=wsNormaliseSubjectClass(s.subjectClass);
    if(v)verdicts.push(v);
  }
  if(verdicts.length===0)return null;
  if(verdicts.includes('likely_pet'))return 'likely_pet';
  if(verdicts.every(v=>v==='likely_human'))return 'likely_human';
  return 'unknown';
}

/**
 * Coalesce slot detection statuses into a single status for the soft-gate.
 *   - any 'pending'  → 'pending' (don't show alarm before all detectors finish)
 *   - all 'ok'       → 'ok'      (best case)
 *   - any 'timeout'  → 'timeout' (degraded but actionable)
 *   - any 'error'    → 'error'
 *   - else           → 'unknown'
 * Pet-only slots ('skipped_pet') don't influence the gate (the soft-gate is about
 * human-face counting; the pet slot's role is encoded separately in slots[]).
 */
function wsAggregatedDetStatus(slots){
  const arr=Array.isArray(slots)?slots:[];
  const peopleSlots=arr.filter(s=>s&&s.role==='people');
  if(peopleSlots.length===0)return null;
  if(peopleSlots.some(s=>s.faceDetStatus==='pending'))return 'pending';
  if(peopleSlots.every(s=>s.faceDetStatus==='ok'))return 'ok';
  if(peopleSlots.some(s=>s.faceDetStatus==='timeout'))return 'timeout';
  if(peopleSlots.some(s=>s.faceDetStatus==='error'))return 'error';
  return 'unknown';
}

/**
 * Build a slot record and start its detection promise. Pet-role slots short-
 * circuit to `skipped_pet` and never call MediaPipe. People-role slots run
 * `wsCountFacesFromDataUrl` and write back when the promise settles.
 *
 * @param {File} file  Original File from the upload picker.
 * @param {string} dataUrl  data:image/* URL (output of FileReader.readAsDataURL).
 * @param {string} b64  base64 payload extracted from the dataUrl.
 * @param {'people'|'pet'} role
 * @param {boolean} isPrimary
 * @returns {object} new slot
 */
function wsCreateSlot(file,dataUrl,b64,role,isPrimary){
  const id=++S._slotIdSeq;
  // Track G (slice p2g-detect): `faceBoxes` carries normalised 0..1 face
  // bboxes for downstream consumers (Track H subjectClass overlap rule).
  // Track H (slice p2h-classifier): `subjectClass` + `subjectClassPromise`
  // carry the pet-vs-human classifier verdict for people-role slots. Pet-
  // role slots short-circuit to `likely_pet` (the user already declared
  // species) so the gate / server clause never accuses them of being human.
  const slot={
    id,isPrimary:!!isPrimary,file,dataUrl,b64,role,
    faceCount:null,faceDetScore:null,faceDetStatus:'pending',
    faceDetCompletedAt:null,faceDetPromise:null,faceBoxes:null,faceDetPassStats:null,
    subjectClass:null,subjectClassStatus:'pending',subjectClassPromise:null,
    /* Phase 2 / Slice P2.C — null while classifier pending; boolean once it settles. */
    containsPetSubject:null,
    /* v5 vision meta — max dog/cat ObjectDetector score (0..1) for server R-BOND-IMPLICIT-2FACE tie-break. */
    petClassifierMaxScore:null,
    /* Phase 3 / Slice P3.A — null until `qualityPromise` resolves; then a
       `{score, reasons}` shape (or `null` if scoring failed). qualityStatus
       distinguishes 'pending' (waiting), 'ok' (scored / reasons may be empty),
       'error' (decode/canvas failed), 'skipped_pet' (multi-photo flipped slot /
       mirrored pet-only short-circuit), 'skipped_test' (when wsShouldSkipFaceDetect
       — unit-test mode). */
    qualityScore:null,qualityReasons:null,qualityStatus:'pending',qualityPromise:null,
  };
  if(role==='pet'){
    /* R-GOAL-4 / Phase 7 (May 2026) — pre-Phase-7 the pet-role branch
       short-circuited to `subjectClass='likely_pet'` and skipped face
       detection + the classifier entirely (because "the user already
       declared species via the category"). The May 2026 inversion case
       proved that wrong: a shopper picked `huisdier` (Pet portrait),
       uploaded three humans, saw "Pet portrait · ready for styling"
       (`ok_pet`), the wire carried `subjectClass:'likely_pet'` with
       `detectionStatus:'skipped_pet'`, and the server applied the pet
       tail to a human reference — producing a generic dog portrait of
       strangers. R-MIX8 (`huisdier && likely_human` ⇒ `inversion_human`)
       was already wired into `wsCategoryHintFromState` but could never
       fire because the state never carried `likely_human` on this
       path. Fix: fall through to the full people-role detection +
       classifier pipeline below. `role:'pet'` is preserved on the
       slot so role-based aggregations (`wsAggregatedPeopleFaceCount`,
       multi-photo Bond) still exclude this slot from human counts.
       Photo-quality heuristics (luma / Laplacian / resolution) still run for
       primary pet uploads — **`face_too_small` is omitted** by passing `null`
       face boxes into `wsComputePhotoQualityFromDataUrl` so BlazeFace geometry
       on mammals does not drive the people-only “step closer” cue. The mirrored S.* short-circuit in `handleFile` is also
       removed in this slice so the pending classifier verdict — not
       a hardcoded declaration — drives the gate + wire. */
    // Fall through — qualityPromise runs Laplacian/luma/resolution scan;
    // `face_too_small` suppressed via null face boxes passed to scorer.
  }
  slot.faceDetPromise=(async()=>{
    if(slot.isPrimary&&S.aiVerifyPromise){
      try{await S.aiVerifyPromise;}catch(_){/* non-fatal */}
      if(!Array.isArray(S.slots)||!S.slots.find(x=>x===slot))return {count:null,status:'unknown'};
      slot.faceCount=S.faceCount;
      slot.faceDetStatus=S.faceDetStatus||'unknown';
      slot.subjectClass=S.subjectClass;
      slot.subjectClassStatus=S.subjectClassStatus||'unknown';
      slot.containsPetSubject=S.containsPetSubject===true;
      return {count:slot.faceCount,status:slot.faceDetStatus};
    }
    slot.faceDetStatus='skipped_extra';
    slot.faceCount=null;
    return {count:null,status:'skipped_extra'};
  })();
  // R-AI-ONLY — subject class follows AI verify on primary slot only.
  slot.subjectClassPromise=(async()=>{
    try{await slot.faceDetPromise;}catch(_){}
    return null;
  })();
  /* Phase 3 / Slice P3.A (R-FAB5) — chain photo-quality scoring AFTER face
     detection so `slot.faceBoxes` is available for the `face_too_small`
     reason on **people-role** uploads; **`null` bbox is passed for pet-role**
     so the same heuristic set runs without people-only bbox sizing. Runs in parallel with the subject classifier (both await
     `faceDetPromise`); both share the WS_FACE_DETECT_WAIT_MS ceiling
     in `wsResolveVisionMeta`. Defensive: any failure leaves `qualityScore`
     null (server reader treats absence === no signal; UI banner stays
     hidden). */
  slot.qualityPromise=(async()=>{
    try{await slot.faceDetPromise;}catch(_){/* still score — bbox branch may be suppressed */}
    if(!Array.isArray(S.slots)||!S.slots.find(x=>x===slot))return null;
    const faceBoxesForQuality=(role==='pet'||role==='unknown')?null:slot.faceBoxes;
    const q=await wsComputePhotoQualityFromDataUrl(dataUrl,faceBoxesForQuality);
    if(!Array.isArray(S.slots)||!S.slots.find(x=>x===slot))return q;
    if(q&&typeof q==='object'&&Number.isFinite(q.score)&&Array.isArray(q.reasons)){
      slot.qualityScore=q.score;
      slot.qualityReasons=q.reasons.slice();
      slot.qualityStatus='ok';
    }else{
      slot.qualityStatus='error';
    }
    if(slot.isPrimary){
      S.qualityScore=slot.qualityScore;
      S.qualityReasons=slot.qualityReasons;
    }
    return q;
  })();
  return slot;
}

/** Resolve the role of an EXTRA slot (slot index ≥ 1). Default = 'pet' to favour Bond. */
function wsDefaultExtraRole(){
  // If primary is a pet (cat=huisdier), default the extra to 'people' (e.g. owner photo);
  // otherwise default to 'pet' (e.g. add the family pet to a couple/family photo).
  return (S.cat==='huisdier')?'people':'pet';
}

/**
 * DOM render of the extras strip (#ws-photo-slots). Slot 0 (primary) is rendered
 * by the existing #preview <img>; this function ONLY renders slot index ≥ 1.
 * Idempotent: safe to call after every state change. WCAG 2.5.5 tap targets are
 * enforced via CSS in `assets/ws-generator.css` (see Slice A.2).
 */
function wsRenderPhotoSlots(){
  const grid=document.getElementById('ws-photo-slots');
  if(!grid)return;
  while(grid.firstChild)grid.removeChild(grid.firstChild);
  const extras=(Array.isArray(S.slots)?S.slots:[]).slice(1);
  for(const slot of extras){
    const wrap=document.createElement('div');wrap.className='ws-photo-slot';wrap.setAttribute('role','listitem');
    const img=document.createElement('img');img.className='ws-photo-slot__img';img.alt='';img.src=slot.dataUrl;
    const role=document.createElement('select');role.className='ws-photo-slot__role';
    const optP=document.createElement('option');optP.value='people';optP.textContent=wsT('upload.role.person');
    const optX=document.createElement('option');optX.value='pet';optX.textContent=wsT('upload.role.pet');
    role.appendChild(optP);role.appendChild(optX);role.value=slot.role;
    role.addEventListener('change',()=>{
      const newRole=role.value==='pet'?'pet':'people';
      if(newRole===slot.role)return;
      slot.role=newRole;
      // If role flipped TO 'pet', cancel detection signal; flipping back to
      // 'people' on a slot that already finished detection requires re-running.
      if(newRole==='pet'){
        slot.faceDetStatus='skipped_pet';slot.faceCount=null;slot.faceDetScore=null;slot.faceDetCompletedAt=Date.now();slot.faceDetPromise=null;slot.faceBoxes=null;slot.faceDetPassStats=null;
        // Track H — flipping a slot to `pet` is the user explicitly declaring
        // species, so the classifier verdict becomes `likely_pet` immediately
        // (matches the wsCreateSlot pet-role short-circuit). No reclassify.
        slot.subjectClass='likely_pet';slot.subjectClassStatus='skipped_pet';slot.subjectClassPromise=null;
        // Phase 2 / Slice P2.C — same rationale as the wsCreateSlot pet-role
        // short-circuit: the slot IS the pet, so the mixed-subject signal
        // collapses to false.
        slot.containsPetSubject=false;
        slot.petClassifierMaxScore=null;
        // Phase 3 / Slice P3.A — pet-role short-circuit also for quality
        // (matches wsCreateSlot). Quality is people-only at first ship.
        slot.qualityScore=null;slot.qualityReasons=null;slot.qualityStatus='skipped_pet';slot.qualityPromise=null;
      }
      else if(slot.dataUrl){
        slot.faceDetStatus='pending';slot.faceCount=null;slot.faceDetScore=null;slot.faceDetCompletedAt=null;slot.faceBoxes=null;slot.faceDetPassStats=null;
        slot.subjectClass=null;slot.subjectClassStatus='pending';slot.subjectClassPromise=null;
        // Phase 2 / Slice P2.C — re-pending until the classifier settles again.
        slot.containsPetSubject=null;
        slot.petClassifierMaxScore=null;
        // Phase 3 / Slice P3.A — re-pending quality alongside subjectClass on
        // role flip TO 'people'; new qualityPromise wired below.
        slot.qualityScore=null;slot.qualityReasons=null;slot.qualityStatus='pending';slot.qualityPromise=null;
        slot.faceDetPromise=(async()=>{
          const r=await wsCountFacesFromDataUrl(slot.dataUrl);
          if(!S.slots.find(x=>x===slot))return r;
          slot.faceCount=(r&&typeof r.count==='number')?r.count:null;
          slot.faceDetScore=(r&&typeof r.avgScore==='number'&&Number.isFinite(r.avgScore))?r.avgScore:null;
          slot.faceDetStatus=(r&&r.status)?r.status:'error';
          slot.faceDetCompletedAt=Date.now();
          slot.faceBoxes=Array.isArray(r&&r.boxes)?r.boxes:null;
          slot.faceDetPassStats=(r&&r.passStats&&typeof r.passStats==='object')?r.passStats:null;
          return r;
        })();
        // Track H — re-run the subject classifier on the same image; uses
        // the new face-detection promise so bbox overlap stays meaningful.
        slot.subjectClassPromise=(async()=>{
          try{await slot.faceDetPromise;}catch(_){/* still classify */}
          if(!S.slots.find(x=>x===slot))return null;
          const r=await wsClassifySubjectFromDataUrl(slot.dataUrl,slot.faceBoxes);
          if(!S.slots.find(x=>x===slot))return r;
          slot.subjectClass=(r&&r.subjectClass)?r.subjectClass:'unknown';
          slot.subjectClassStatus=(r&&r.status)?r.status:'error';
          // Phase 2 / Slice P2.C — keep the aux signal in lockstep with
          // the role-flip reclassify. Same defensive default as wsCreateSlot.
          slot.containsPetSubject=(r&&r.containsPetSubject===true);
          const pcmR=(r&&typeof r.petClassifierMaxScore==='number'&&Number.isFinite(r.petClassifierMaxScore))?r.petClassifierMaxScore:null;
          slot.petClassifierMaxScore=pcmR;
          return r;
        })();
        // Phase 3 / Slice P3.A — re-run quality scoring on role flip TO
        // 'people'; mirrors the wsCreateSlot wiring (chained after
        // faceDetPromise so faceBoxes are present for face_too_small).
        slot.qualityPromise=(async()=>{
          try{await slot.faceDetPromise;}catch(_){/* still score */}
          if(!S.slots.find(x=>x===slot))return null;
          const q=await wsComputePhotoQualityFromDataUrl(slot.dataUrl,slot.faceBoxes);
          if(!S.slots.find(x=>x===slot))return q;
          if(q&&typeof q==='object'&&Number.isFinite(q.score)&&Array.isArray(q.reasons)){
            slot.qualityScore=q.score;
            slot.qualityReasons=q.reasons.slice();
            slot.qualityStatus='ok';
          }else{
            slot.qualityStatus='error';
          }
          return q;
        })();
        void slot.faceDetPromise.then(()=>{if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();}).catch(()=>{});
        // Track H — also re-render after the classifier verdict lands so the
        // pet-in-people banner can flip from `unknown` to `pet_in_people`
        // (or back) without waiting for the next state change.
        if(slot.subjectClassPromise)void slot.subjectClassPromise.then(()=>{if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();}).catch(()=>{});
        // Phase 3 / Slice P3.B — also refresh after the quality scan settles
        // on role-flip TO 'people' so the new ws-quality-hint banner can
        // appear / dismiss without waiting for another state change.
        if(slot.qualityPromise)void slot.qualityPromise.then(()=>{if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();}).catch(()=>{});
      }
      if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();
    });
    const rm=document.createElement('button');rm.type='button';rm.className='ws-photo-slot__remove';rm.textContent='×';
    const ariaRm=wsT('upload.remove_aria');if(ariaRm)rm.setAttribute('aria-label',ariaRm);
    rm.addEventListener('click',()=>wsRemoveSlot(slot.id));
    wrap.appendChild(img);wrap.appendChild(role);wrap.appendChild(rm);
    grid.appendChild(wrap);
  }
  if(typeof wsRefreshAddPhotoCta==='function')wsRefreshAddPhotoCta();
}

/**
 * Validate + append a new slot from a File (typically dispatched by the
 * #fileInExtra change handler). Caps total at WS_MAX_TOTAL_PHOTOS and silently
 * ignores excess. Mirrors the validation rules of `handleFile` (size, MIME).
 */
function wsApplyExtraSlotUpload(file,dataUrl,b64,roleHint,funnelEpoch){
    const role=(roleHint==='people'||roleHint==='pet')?roleHint:wsDefaultExtraRole();
    const slot=wsCreateSlot(file,dataUrl,b64,role,/*isPrimary=*/false);
    S.slots.push(slot);
    try{window.wsFunnelAnalytics?.record('photo_uploaded',{style:S.style,category:S.cat,slotCount:S.slots.length},funnelEpoch);}catch(_){}
    wsRenderPhotoSlots();
    if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();
    if(slot.faceDetPromise)void slot.faceDetPromise.then(()=>{if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();}).catch(()=>{});
    if(slot.subjectClassPromise)void slot.subjectClassPromise.then(()=>{if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();}).catch(()=>{});
    if(slot.qualityPromise)void slot.qualityPromise.then(()=>{if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();}).catch(()=>{});
}
function wsAddSlotFromFile(file,roleHint){
  if(!file)return;
  if(!Array.isArray(S.slots))S.slots=[];
  if(S.slots.length>=WS_MAX_TOTAL_PHOTOS){try{window.wsFunnelAnalytics?.record('upload_rejected',{reason:'too_many_files'});}catch(_){}showErr(wsT('err.file_big'));return;}
  if(file.size>10485760){try{window.wsFunnelAnalytics?.record('upload_rejected',{reason:'file_too_large'});}catch(_){}showErr(wsT('err.file_big'));return;}
  if(!file.type.match(/^image\/(jpeg|png|webp)$/)){try{window.wsFunnelAnalytics?.record('upload_rejected',{reason:'invalid_file'});}catch(_){}showErr(wsT('err.file_type'));return;}
  void wsLoadUploadFile(file,(loadedFile,dataUrl,b64,funnelEpoch)=>{
    wsApplyExtraSlotUpload(loadedFile,dataUrl,b64,roleHint,funnelEpoch);
  });
}

/** Remove an extra slot (by id). Slot 0 (primary) cannot be removed via this path
 *  — that flow goes through wsClearUploadedPhoto which clears the entire stack. */
function wsRemoveSlot(id){
  if(!Array.isArray(S.slots))return;
  const idx=S.slots.findIndex(s=>s&&s.id===id);
  if(idx<=0)return;// guard against removing primary or missing slot
  S.slots.splice(idx,1);
  wsRenderPhotoSlots();
  if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();
  hideErr();
}

/**
 * Resolve the in-flight detection promise (started by `handleFile`) within
 * `WS_FACE_DETECT_WAIT_MS` and return a sealed `visionMeta` block aligned with
 * the server contract in `parseGeneratePayload` (see researcher plan §11).
 * Never throws: a slow / failed detector becomes `detectionStatus: 'timeout'`
 * or `'error'` so the worker can still log + reconcile.
 *
 * Multi-photo (Slice A.3): when `S.slots.length > 1` we wait for ALL slot
 * promises (bounded by the same timeout) and emit a `slots[]` array on the
 * returned visionMeta. Top-level `detectedFaceCount` becomes the SUM across
 * `people`-role slots so server-side reconciliation (Slice A.5) sees one
 * coherent total.
 */
/** Track H — guard against accidentally emitting `'unknown'` as if it were a
 *  positive classifier verdict. The schema accepts it (semantically: classifier
 *  ran, was inconclusive), but downstream readers (server clause, hint matrix)
 *  treat `'unknown'` identically to "absent" so they never branch on uncertain
 *  output. We still emit it when the classifier ran successfully so analytics
 *  can distinguish "no classifier yet" from "ran, no winner". */
function wsNormaliseSubjectClass(value){
  return (value==='likely_human'||value==='likely_pet'||value==='unknown')?value:null;
}


/**
 * R-AI-ONLY — start server subject verify on primary upload.
 */
function wsStartAiSubjectVerify(b64,mimeType){
  S.verifyCacheId=null;
  S.aiVerifyResult=null;
  S.aiVerifyStatus='pending';
  if(!b64||typeof b64!=='string'){
    S.aiVerifyPromise=Promise.resolve(null);
    return S.aiVerifyPromise;
  }
  const mime=(typeof mimeType==='string'&&mimeType)?mimeType:'image/jpeg';
  S.aiVerifyPromise=(async()=>{
    try{
      const res=await fetch(WS_PROXY_SUBJECT_VERIFY,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({image:b64,mimeType:mime}),
      });
      const j=await res.json();
      S.verifyCacheId=(j&&typeof j.verifyCacheId==='string')?j.verifyCacheId:null;
      S.aiVerifyResult=j;
      S.aiVerifyStatus=(j&&j.ok===true)?'ok':'failed';
      wsApplyAiVerifyToState(j&&j.result?j.result:null);
      if(S.aiVerifyStatus!=='ok')wsTryApplyInferredCategoryFromVerify();
      return j;
    }catch(_e){
      S.aiVerifyStatus='failed';
      S.aiVerifyResult={ok:false,reason:'network_error'};
      wsTryApplyInferredCategoryFromVerify();
      return S.aiVerifyResult;
    }
  })();
  return S.aiVerifyPromise;
}

function wsPrimarySlotRoleAtUpload(){
  if(S.cat==='huisdier')return 'pet';
  if(S.cat==null)return 'unknown';
  return 'people';
}

/** R-CAT-INFER Slice 2 — slot role from category slug. */
function wsSlotRoleForCategory(cat){
  return cat==='huisdier'?'pet':'people';
}

/**
 * R-CAT-INFER Slice 2 — re-role primary slot after category inference or manual override.
 * Excludes `unknown` from people-face aggregation until resolved.
 */
function wsReRolePrimarySlot(newRole){
  if(newRole!=='people'&&newRole!=='pet')return false;
  const slotsArr=Array.isArray(S.slots)?S.slots:[];
  const primary=slotsArr.find(s=>s&&s.isPrimary);
  if(!primary||primary.role===newRole)return false;
  const prevRole=primary.role;
  primary.role=newRole;
  if(prevRole==='unknown'&&newRole==='people'&&primary.dataUrl){
    void (async()=>{
      try{
        await primary.faceDetPromise;
      }catch(_){/* non-fatal */}
      if(!Array.isArray(S.slots)||!S.slots.find(x=>x===primary))return;
      const q=await wsComputePhotoQualityFromDataUrl(primary.dataUrl,primary.faceBoxes||null);
      if(!Array.isArray(S.slots)||!S.slots.find(x=>x===primary))return;
      if(q&&typeof q==='object'&&Number.isFinite(q.score)&&Array.isArray(q.reasons)){
        primary.qualityScore=q.score;
        primary.qualityReasons=q.reasons.slice();
        primary.qualityStatus='ok';
        S.qualityScore=primary.qualityScore;
        S.qualityReasons=primary.qualityReasons;
      }
      if(typeof upd==='function')upd();
    })();
  }
  return true;
}

/**
 * R-CAT-INFER Slice 2 — apply inference output to S.cat + primary slot role when eligible.
 * Does not run when shopper already picked a category (manual funnel).
 */
function wsTryApplyInferredCategoryFromVerify(){
  if(S.cat!=null)return null;
  const infer=wsInferCategoryFromVerifyState({
    verifyStatus:S.aiVerifyStatus,
    result:S.aiVerifyResult&&S.aiVerifyResult.result?S.aiVerifyResult.result:null,
  });
  S.catInferenceReason=infer.reason;
  S.catInferenceConfidence=infer.confidence;
  S.catInferenceNeedsConfirm=infer.needsConfirm===true;
  S.catInferenceChoices=infer.choices||null;
  if(infer.needsConfirm||!infer.category){
    S.catInferredFromAi=false;
    if(typeof wsRenderCategoryInferChip==='function')wsRenderCategoryInferChip();
    return infer;
  }
  S.cat=infer.category;
  S.catInferredFromAi=true;
  S.catAutoRouted=true;
  if(infer.compositionMode==='mixed_single_photo')S.compositionMode='mixed_single_photo';
  else if(infer.compositionMode==null&&infer.reason!=='mixed_subject')S.compositionMode=null;
  wsReRolePrimarySlot(wsSlotRoleForCategory(infer.category));
  wsSyncCategoryPillDom(infer.category);
  if(infer.reason==='mixed_auto_both'){
    try{
      wsRecordFunnelEvent('category_infer_auto_mixed',{confidence:infer.confidence||null});
    }catch(_){/* telemetry */}
  }
  if(typeof wsRenderCategoryInferChip==='function')wsRenderCategoryInferChip();
  return infer;
}

/** R-CAT-INFER Slice 3 — hidden-category funnel gate (theme setting / window global). */
function wsIsCategoryInferEnabled(){
  return typeof window!=='undefined'&&window.WS_CATEGORY_INFER_ENABLED===true;
}

/** R-CAT-INFER Slice 4 — style→upload (cold) vs upload→style (campaign). */
function wsFunnelOrder(){
  if(typeof window!=='undefined'&&window.WS_FUNNEL_ORDER==='upload_style')return 'upload_style';
  return 'style_upload';
}

function wsLogicalWizardStepCount(){
  return wsIsCategoryInferEnabled()?2:3;
}

function wsResolvePhysicalStepId(logicalStep){
  const n=typeof logicalStep==='number'?logicalStep:1;
  if(!wsIsCategoryInferEnabled())return n;
  if(wsFunnelOrder()==='upload_style'){
    if(n===1)return 3;
    if(n===2)return 2;
    return n;
  }
  if(n===1)return 2;
  if(n===2)return 3;
  return n;
}

function wsShouldClearUploadOnWizardStep(logicalStep){
  if(wsIsCategoryInferEnabled())return false;
  return logicalStep===1;
}

const WS_CATEGORY_INFER_SLUGS=['huisdier','gezin','koppel','kind','zelf'];

function wsSyncCategoryPillDom(slug){
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap||!slug)return;
  wrap.querySelectorAll('.pill').forEach(p=>{
    p.classList.toggle('on',p.getAttribute('data-c')===slug);
  });
}

/**
 * R-CAT-INFER Slice 3 — apply category without showStep(1) (preserves upload).
 */
function wsApplyCategorySelection(slug,opts){
  if(!slug||WS_CATEGORY_INFER_SLUGS.indexOf(slug)<0)return;
  const o=opts&&typeof opts==='object'?opts:{};
  const prev=S.cat;
  S.cat=slug;
  if(o.inferred===true){
    S.catInferredFromAi=true;
    S.catAutoRouted=true;
  }else{
    S.catInferredFromAi=false;
    if(o.fromManualPicker===true){
      S.catAutoRouted=false;
      if(slug==='huisdier'&&prev!==slug)S.catManualHuisdier=true;
      else if(slug!=='huisdier')S.catManualHuisdier=false;
    }
  }
  if(o.compositionMode==='mixed_single_photo')S.compositionMode='mixed_single_photo';
  else if(o.clearComposition===true)S.compositionMode=null;
  S.catInferenceNeedsConfirm=false;
  S.catInferenceChoices=null;
  S.catInferMixedFocusOpen=false;
  wsReRolePrimarySlot(wsSlotRoleForCategory(slug));
  wsSyncCategoryPillDom(slug);
  if(typeof wsRenderCategoryInferChip==='function')wsRenderCategoryInferChip();
  if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();
  if(typeof wsRefreshScenePicker==='function')wsRefreshScenePicker();
  if(typeof updateGenerateButton==='function')updateGenerateButton();
  try{
    if(slug!==prev&&typeof wsRecordFunnelEvent==='function'){
      wsRecordFunnelEvent('category_infer_selected',{category:slug,inferred:o.inferred===true});
    }
  }catch(_){/* telemetry */}
}

function wsApplyCategoryInferChoice(choice){
  if(!choice||typeof choice!=='object')return;
  wsApplyCategorySelection(choice.category,{
    inferred:choice.id==='include_both'&&S.catInferenceReason==='mixed_auto_both',
    fromManualPicker:true,
    compositionMode:choice.compositionMode||null,
    clearComposition:!choice.compositionMode,
  });
  if(choice.id==='include_both'&&S.compositionMode==='mixed_single_photo'){
    S.catInferenceReason='mixed_auto_both';
  }else if(S.catInferenceReason==='mixed_auto_both'||S.catInferenceReason==='mixed_subject'){
    S.catInferenceReason='mixed_subject_resolved';
  }
  S.catInferMixedFocusOpen=false;
  const chooser=document.getElementById('ws-cat-infer-chooser');
  if(chooser)chooser.hidden=true;
}

function wsOpenCategoryInferChooser(){
  S.catInferMixedFocusOpen=false;
  const chooser=document.getElementById('ws-cat-infer-chooser');
  if(!chooser)return;
  chooser.removeAttribute('data-mode');
  wsBuildCategoryInferChooserPills(chooser);
  chooser.hidden=false;
  chooser.setAttribute('data-open','true');
}

function wsCloseCategoryInferChooser(){
  const chooser=document.getElementById('ws-cat-infer-chooser');
  if(!chooser)return;
  chooser.hidden=true;
  chooser.removeAttribute('data-open');
  chooser.removeAttribute('data-mode');
}

function wsInferMixedSubjectChoices(){
  return[
    {id:'include_both',category:'zelf',compositionMode:'mixed_single_photo'},
    {id:'pet_only',category:'huisdier',compositionMode:null},
    {id:'person_only',category:'zelf',compositionMode:null},
  ];
}

/** R-CAT-INFER Slice 9 — auto person+pet when bonded single-human shot is unambiguous. */
function wsInferShouldAutoApplyMixedBoth(result,verifyConf,n){
  if(!result||typeof result!=='object'||verifyConf==='low')return false;
  if(typeof n==='number'&&Number.isFinite(n)&&n>=2)return false;
  if(result.petHeldByHuman===true)return true;
  if(n===1&&verifyConf==='high'&&result.hasPet===true)return true;
  return false;
}

function wsActiveMixedFocusChoiceId(){
  if(S.cat==='huisdier')return 'pet_only';
  if(S.cat==='zelf'&&S.compositionMode==='mixed_single_photo')return 'include_both';
  if(S.cat==='zelf'&&!S.compositionMode)return 'person_only';
  return null;
}

function wsShowMixedFocusChip(){
  /* Slice 9 silent path — auto mixed focus chip hidden for now; override UI returns when re-enabled. */
  if(S.catInferenceReason==='mixed_auto_both')return false;
  return wsIsCategoryInferEnabled()&&!!S.b64&&S.cat==='zelf'&&S.compositionMode==='mixed_single_photo';
}

function wsOpenMixedFocusChooser(){
  const chooser=document.getElementById('ws-cat-infer-chooser');
  if(!chooser)return;
  S.catInferMixedFocusOpen=true;
  wsBuildMixedFocusChooser(chooser,{open:true,compact:wsShowMixedFocusChip()});
}

function wsCloseMixedFocusChooser(){
  S.catInferMixedFocusOpen=false;
  const chooser=document.getElementById('ws-cat-infer-chooser');
  if(!chooser)return;
  chooser.hidden=true;
  chooser.removeAttribute('data-open');
  chooser.removeAttribute('data-mode');
  chooser.classList.remove('ws-cat-infer-chooser--mixed-focus');
}

/** True when infer mode must surface chooser / tri-choice (not happy-path quiet chip). */
function wsCategoryInferNeedsChooserUI(){
  if(!wsIsCategoryInferEnabled()||!S.b64)return false;
  if(S.catInferenceNeedsConfirm&&S.catInferenceReason==='mixed_subject')return true;
  if(S.catInferenceNeedsConfirm&&!S.cat)return true;
  return false;
}

function wsInferComposerShowsInlineStyle(){
  return wsIsCategoryInferEnabled()&&wsFunnelOrder()==='upload_style'&&!!S.b64;
}

function wsInferComposerStyleNodes(){
  const nodes=[];
  if(typeof wsIsWkOranjeMode==='function'&&wsIsWkOranjeMode()){
    const h=document.getElementById('wkStylesHeading');
    const g=document.getElementById('wkOranjeStyleGrid');
    if(h)nodes.push(h);
    if(g)nodes.push(g);
    return nodes;
  }
  const g=document.getElementById('styleGrid');
  if(g)nodes.push(g);
  return nodes;
}

/** Style-first infer — keep grids in step2; park is hidden and must not hold live UI. */
function wsRestoreInferStyleNodesHome(){
  const step2=document.getElementById('step2');
  if(!step2)return;
  const anchor=document.getElementById('styleGrid');
  wsInferComposerStyleNodes().forEach(node=>{
    if(!node||node.parentElement===step2)return;
    if(anchor&&node!==anchor)step2.insertBefore(node, anchor);
    else step2.appendChild(node);
  });
}

function wsInferGenerateStepOk(){
  if(!wsIsCategoryInferEnabled())return typeof currentStep==='number'&&currentStep===3;
  if(wsFunnelOrder()==='upload_style'){
    return typeof currentStep==='number'&&currentStep===1&&!!S.b64;
  }
  return typeof currentStep==='number'&&currentStep===wsLogicalWizardStepCount();
}

/** Style-first infer upload step — quiet selected-style metadata above upload. */
function wsRenderInferStyleReminder(){
  const el=document.getElementById('ws-infer-style-reminder');
  if(!el)return;
  while(el.firstChild)el.removeChild(el.firstChild);
  try{wsSyncStyleAndCategoryFromDom();}catch(_){/* non-fatal */}
  const show=wsIsCategoryInferEnabled()
    &&wsFunnelOrder()==='style_upload'
    &&typeof currentStep==='number'
    &&currentStep===wsLogicalWizardStepCount();
  if(!show||!S.style){
    el.hidden=true;
    return;
  }
  el.hidden=false;
  const stack=document.createElement('div');
  stack.className='ws-infer-style-reminder__stack';
  const k=document.createElement('p');
  k.className='ws-infer-style-reminder__k';
  k.textContent=wsT('style.infer.selected_label');
  const row=document.createElement('div');
  row.className='ws-infer-style-reminder__row';
  const name=document.createElement('span');
  name.className='ws-infer-style-reminder__name';
  name.textContent=wsStyleName(S.style);
  const chg=document.createElement('button');
  chg.type='button';
  chg.className='ws-infer-style-reminder__change';
  chg.textContent=wsT('wiz.chg_style');
  chg.setAttribute('aria-label',wsT('wiz.chg_style_aria'));
  chg.onclick=()=>wsWizardGoToStep(1);
  row.appendChild(name);
  row.appendChild(chg);
  stack.appendChild(k);
  stack.appendChild(row);
  el.appendChild(stack);
}

/** R-CAT-INFER composer — vertical upload → style → generate; hide wizard chrome. */
function wsSyncInferComposerLayout(){
  const wrap=document.getElementById('wallstraight-generator');
  const infer=wsIsCategoryInferEnabled();
  if(wrap)wrap.classList.toggle('ws-infer-composer',infer);
  const nav=document.getElementById('ws-wizard-nav');
  if(nav)nav.hidden=!!infer;
  const sum=document.getElementById('ws-wizard-choice-summary');
  const sumPark=document.getElementById('ws-wizard-summary-park');
  if(infer&&sum){
    sum.hidden=true;
    if(sumPark&&sum.parentElement!==sumPark)sumPark.appendChild(sum);
  }
  const composer=document.getElementById('ws-infer-composer-style');
  const slot=document.getElementById('ws-infer-composer-style-slot');
  const park=document.getElementById('ws-infer-composer-style-park');
  const showInline=wsInferComposerShowsInlineStyle();
  if(composer)composer.hidden=!showInline;
  const labelEl=document.getElementById('ws-infer-composer-style-label');
  if(labelEl){
    if(showInline){
      const title=wsT(wsWizardStepTitleKey(2));
      const sep=wsT('wiz.step_title_sep')||' · ';
      labelEl.textContent=wsFormatStepNOfM(2,wsLogicalWizardStepCount())+(title?sep+title:'');
      labelEl.hidden=false;
    }else{
      labelEl.textContent='';
      labelEl.hidden=true;
    }
  }
  const nodes=wsInferComposerStyleNodes();
  if(slot&&park&&nodes.length){
    if(showInline){
      nodes.forEach(node=>{
        if(node&&node.parentElement!==slot)slot.appendChild(node);
      });
      if(typeof wsPreloadStyletilesOnce==='function')wsPreloadStyletilesOnce();
      if(typeof wsFireStyleCardExposure==='function')wsFireStyleCardExposure();
    }else{
      wsRestoreInferStyleNodesHome();
    }
  }
}

/** Premium portrait-type prompt — matches ws-infer-style-reminder / focus chip. */
function wsAppendCatInferFocusPrompt(chip,opts){
  const o=opts&&typeof opts==='object'?opts:{};
  chip.classList.add('ws-cat-infer-chip--focus');
  const stack=document.createElement('div');
  stack.className='ws-cat-infer-focus__stack';
  const k=document.createElement('p');
  k.className='ws-cat-infer-focus__k';
  k.textContent=wsT('cat.infer.type_label');
  stack.appendChild(k);
  if(o.body){
    const body=document.createElement('p');
    body.className='ws-cat-infer-chip__body';
    body.textContent=o.body;
    stack.appendChild(body);
  }
  if(o.name){
    const row=document.createElement('div');
    row.className='ws-cat-infer-focus__row';
    const name=document.createElement('span');
    name.className='ws-cat-infer-focus__name';
    name.textContent=o.name;
    row.appendChild(name);
    if(o.changeLabel&&typeof o.onChange==='function'){
      const chg=document.createElement('button');
      chg.type='button';
      chg.className='ws-cat-infer-focus__change';
      chg.textContent=o.changeLabel;
      if(o.changeAria)chg.setAttribute('aria-label',o.changeAria);
      chg.onclick=o.onChange;
      row.appendChild(chg);
    }
    stack.appendChild(row);
  }
  if(o.actionLabel&&typeof o.onAction==='function'){
    const btn=document.createElement('button');
    btn.type='button';
    btn.className='ws-cat-infer-focus__change';
    btn.textContent=o.actionLabel;
    if(o.actionAria)btn.setAttribute('aria-label',o.actionAria);
    btn.onclick=o.onAction;
    stack.appendChild(btn);
  }
  chip.appendChild(stack);
}

function wsRenderCategoryInferChip(){
  const chip=document.getElementById('ws-cat-infer-chip');
  const chooser=document.getElementById('ws-cat-infer-chooser');
  if(!chip)return;
  chip.classList.remove('ws-cat-infer-chip--quiet','ws-cat-infer-chip--focus','ws-cat-infer-chip--confirm');
  while(chip.firstChild)chip.removeChild(chip.firstChild);
  if(chooser){
    while(chooser.firstChild)chooser.removeChild(chooser.firstChild);
    chooser.removeAttribute('data-mode');
  }
  if(!wsIsCategoryInferEnabled()||!S.b64){
    chip.hidden=true;
    if(chooser)chooser.hidden=true;
    return;
  }
  if(S.catInferenceNeedsConfirm&&S.catInferenceReason==='mixed_subject'&&Array.isArray(S.catInferenceChoices)){
    chip.hidden=false;
    wsAppendCatInferFocusPrompt(chip,{
      body:wsT('cat.infer.mixed_prompt'),
      actionLabel:wsT('cat.infer.choose_focus'),
      actionAria:wsT('cat.infer.change_focus_aria'),
      onAction:()=>wsOpenMixedFocusChooser(),
    });
    wsBuildMixedFocusChooser(chooser,{open:S.catInferMixedFocusOpen===true,compact:false});
    return;
  }
  if(S.catInferenceNeedsConfirm&&!S.cat){
    chip.hidden=false;
    wsAppendCatInferFocusPrompt(chip,{
      body:wsT('cat.infer.confirm_needed'),
      actionLabel:wsT('cat.infer.choose'),
      actionAria:wsT('cat.infer.change_aria'),
      onAction:()=>wsOpenCategoryInferChooser(),
    });
    wsBuildCategoryInferChooserPills(chooser);
    return;
  }
  if(!S.cat){
    chip.hidden=true;
    if(chooser)chooser.hidden=true;
    return;
  }
  if(wsIsCategoryInferEnabled()&&S.catInferenceReason==='mixed_auto_both'){
    chip.hidden=true;
    if(chooser)chooser.hidden=true;
    S.catInferMixedFocusOpen=false;
    return;
  }
  if(wsShowMixedFocusChip()){
    chip.hidden=false;
    chip.classList.add('ws-cat-infer-chip--focus');
    if(S.catInferMixedFocusOpen===true)chip.classList.add('is-expanded');
    const stack=document.createElement('div');
    stack.className='ws-cat-infer-focus__stack';
    const k=document.createElement('p');
    k.className='ws-cat-infer-focus__k';
    k.textContent=wsT('cat.infer.focus_label');
    const row=document.createElement('div');
    row.className='ws-cat-infer-focus__row';
    const label=document.createElement('span');
    label.className='ws-cat-infer-focus__name';
    label.textContent=wsT('cat.infer.mixed_include_both');
    const chg=document.createElement('button');
    chg.type='button';
    chg.className='ws-cat-infer-focus__change';
    chg.textContent=wsT('cat.infer.change_focus');
    chg.setAttribute('aria-label',wsT('cat.infer.change_focus_aria'));
    chg.onclick=()=>wsOpenMixedFocusChooser();
    row.appendChild(label);
    row.appendChild(chg);
    stack.appendChild(k);
    stack.appendChild(row);
    chip.appendChild(stack);
    wsBuildMixedFocusChooser(chooser,{open:S.catInferMixedFocusOpen===true,compact:true});
    return;
  }
  /* Confident happy path — category applied silently (no "Detected" status bar). */
  chip.hidden=true;
  if(chooser)chooser.hidden=true;
  wsBuildCategoryInferChooserPills(chooser);
}

function wsBuildMixedFocusChooser(chooserEl,opts){
  if(!chooserEl)return;
  const o=opts&&typeof opts==='object'?opts:{};
  const compact=o.compact===true;
  while(chooserEl.firstChild)chooserEl.removeChild(chooserEl.firstChild);
  chooserEl.setAttribute('data-mode','mixed-focus');
  chooserEl.classList.add('ws-cat-infer-chooser--mixed-focus');
  const choices=Array.isArray(S.catInferenceChoices)&&S.catInferenceChoices.length
    ?S.catInferenceChoices
    :wsInferMixedSubjectChoices();
  if(!compact){
    const hint=document.createElement('p');
    hint.className='ws-cat-infer-focus-chooser__hint';
    hint.textContent=wsT('cat.infer.mixed_prompt');
    chooserEl.appendChild(hint);
  }
  const k=document.createElement('p');
  k.className='ws-cat-infer-focus__k';
  k.textContent=wsT('cat.infer.choose_focus');
  chooserEl.appendChild(k);
  const grid=document.createElement('div');
  grid.className='ws-cat-infer-focus-chooser__opts';
  grid.setAttribute('role','listbox');
  grid.setAttribute('aria-label',wsT('cat.infer.change_focus_aria'));
  const labelKeys={
    include_both:'cat.infer.mixed_include_both',
    pet_only:'cat.infer.mixed_pet_only',
    person_only:'cat.infer.mixed_person_only',
  };
  const activeId=wsActiveMixedFocusChoiceId();
  choices.forEach(choice=>{
    const btn=document.createElement('button');
    btn.type='button';
    btn.className='ws-cat-infer-focus-chooser__opt'+(activeId===choice.id?' is-active':'');
    btn.setAttribute('data-focus',choice.id);
    btn.setAttribute('role','option');
    btn.setAttribute('aria-selected',activeId===choice.id?'true':'false');
    btn.textContent=wsT(labelKeys[choice.id]||'cat.infer.choose');
    btn.onclick=()=>{
      wsApplyCategoryInferChoice(choice);
      if(typeof upd==='function')upd();
    };
    grid.appendChild(btn);
  });
  chooserEl.appendChild(grid);
  const dismiss=document.createElement('button');
  dismiss.type='button';
  dismiss.className='ws-cat-infer-focus-chooser__done';
  dismiss.textContent=wsT('cat.infer.done');
  dismiss.onclick=()=>wsCloseMixedFocusChooser();
  chooserEl.appendChild(dismiss);
  chooserEl.hidden=!o.open;
  if(o.open)chooserEl.setAttribute('data-open','true');
  else chooserEl.removeAttribute('data-open');
}

function wsBuildCategoryInferChooserPills(chooserEl){
  if(!chooserEl)return;
  while(chooserEl.firstChild)chooserEl.removeChild(chooserEl.firstChild);
  chooserEl.removeAttribute('data-mode');
  chooserEl.classList.remove('ws-cat-infer-chooser--mixed-focus');
  const title=document.createElement('p');
  title.className='ws-cat-infer-chooser__title';
  title.textContent=wsT('cat.infer.choose');
  chooserEl.appendChild(title);
  const grid=document.createElement('div');
  grid.className='ws-cat-infer-chooser__pills';
  WS_CATEGORY_INFER_SLUGS.forEach(slug=>{
    const btn=document.createElement('button');
    btn.type='button';
    btn.className='pill ws-cat-infer-chooser__pill'+(S.cat===slug?' on':'');
    btn.setAttribute('data-c',slug);
    const txt=document.createElement('span');
    txt.className='pill-txt';
    txt.textContent=wsT('pill.'+slug);
    btn.appendChild(txt);
    btn.onclick=()=>{
      wsApplyCategorySelection(slug,{fromManualPicker:true,clearComposition:true});
      wsCloseCategoryInferChooser();
    };
    grid.appendChild(btn);
  });
  chooserEl.appendChild(grid);
  const dismiss=document.createElement('button');
  dismiss.type='button';
  dismiss.className='ws-cat-infer-chooser__dismiss';
  dismiss.textContent=wsT('cat.infer.close');
  dismiss.onclick=()=>wsCloseCategoryInferChooser();
  chooserEl.appendChild(dismiss);
  chooserEl.hidden=!chooserEl.getAttribute('data-open');
}

function wsApplyAiVerifyToState(result){
  if(!result||typeof result!=='object'){
    S.faceDetStatus='unknown';
    S.subjectClassStatus='error';
    wsTryApplyInferredCategoryFromVerify();
    return;
  }
  const hasHuman=result.hasHuman===true;
  const hasPet=result.hasPet===true||result.petHeldByHuman===true||
    (typeof result.estimatedPetCount==='number'&&Number.isFinite(result.estimatedPetCount)&&result.estimatedPetCount>=1);
  S.faceCount=(typeof result.estimatedHumanFaces==='number'&&Number.isFinite(result.estimatedHumanFaces))
    ?Math.max(0,Math.floor(result.estimatedHumanFaces)):null;
  S.faceDetStatus='ok';
  S.faceDetName=WS_AI_DETECTOR_NAME;
  S.faceDetCompletedAt=Date.now();
  S.subjectClassStatus='ok';
  if(hasPet&&!hasHuman)S.subjectClass='likely_pet';
  else if(hasHuman)S.subjectClass='likely_human';
  else S.subjectClass='unknown';
  S.containsPetSubject=hasPet;
  if(typeof result.estimatedPetCount==='number'&&Number.isFinite(result.estimatedPetCount)&&result.estimatedPetCount>=0){
    S.estimatedPetCount=Math.floor(result.estimatedPetCount);
  }else{
    S.estimatedPetCount=null;
  }
  if(hasHuman&&S.estimatedPetCount===0&&result.hasPet!==true&&result.petHeldByHuman!==true){
    S.containsPetSubject=false;
  }
  if(result.heldObjectType==='sports_ball'){
    const liveSize=result.petSizeClass;
    if(liveSize!=='tiny'&&liveSize!=='small'&&liveSize!=='medium'&&liveSize!=='large'){
      S.containsPetSubject=false;
    }
  }
  if(result.outdoorLeisureScene===true)S.serverOutdoorLeisureScene=true;
  else if(result.outdoorLeisureScene===false)S.serverOutdoorLeisureScene=false;
  if(S.subjectClass==='likely_human'&&hasPet&&wsIsIntentionalHumanPetPortrait(S,null))S.compositionMode='mixed_single_photo';
  wsTryApplyInferredCategoryFromVerify();
}

/**
 * R-CAT-INFER Slice 1 — pet signal from a subject-verify result object (pure).
 * Mirrors {@link wsHasPetRoutingSignal} field reads without touching `S.*`.
 */
function wsVerifyResultHasPetSignal(result){
  if(!result||typeof result!=='object')return false;
  if(result.heldObjectType==='sports_ball'){
    const pc=result.petSizeClass;
    if(pc==='tiny'||pc==='small'||pc==='medium'||pc==='large')return true;
    return false;
  }
  if(result.hasPet===true||result.petHeldByHuman===true)return true;
  if(typeof result.estimatedPetCount==='number'&&Number.isFinite(result.estimatedPetCount)&&result.estimatedPetCount>=1)return true;
  return false;
}

/**
 * R-CAT-INFER Slice 1 — infer storefront category from AI subject-verify output.
 * Pure function: does not mutate `S.*`. Callers apply when hidden-category funnel
 * is enabled (Slice 3+). Never returns `kind` (no age inference). Human+pet
 * auto-applies person+pet when unambiguous (Slice 9); ambiguous mixed paths
 * set `needsConfirm:true`.
 *
 * @param {{ verifyStatus: string|null, result: object|null }} input
 * @returns {{
 *   category: string|null,
 *   confidence: 'high'|'medium'|'low'|null,
 *   needsConfirm: boolean,
 *   reason: string,
 *   compositionMode: string|null,
 *   choices: Array<{id:string,category:string,compositionMode:string|null}>|null
 * }}
 */
function wsInferCategoryFromVerifyState(input){
  const verifyStatus=input&&input.verifyStatus;
  const result=input&&input.result;
  const pendingOut={
    category:null,confidence:null,needsConfirm:true,reason:'verify_pending',
    compositionMode:null,choices:null,
  };
  const unavailableOut={
    category:null,confidence:null,needsConfirm:true,reason:'verify_unavailable',
    compositionMode:null,choices:null,
  };
  if(verifyStatus==='pending'||verifyStatus==null)return pendingOut;
  if(verifyStatus!=='ok'||!result||typeof result!=='object')return unavailableOut;
  const confRaw=result.confidence;
  const verifyConf=(confRaw==='high'||confRaw==='medium'||confRaw==='low')?confRaw:'low';
  const hasHuman=result.hasHuman===true;
  const hasPet=wsVerifyResultHasPetSignal(result);
  let n=0;
  if(typeof result.estimatedHumanFaces==='number'&&Number.isFinite(result.estimatedHumanFaces)){
    n=Math.max(0,Math.min(20,Math.floor(result.estimatedHumanFaces)));
  }
  if(hasHuman&&hasPet){
    const choices=wsInferMixedSubjectChoices();
    if(wsInferShouldAutoApplyMixedBoth(result,verifyConf,n)){
      return{
        category:'zelf',
        confidence:verifyConf,
        needsConfirm:false,
        reason:'mixed_auto_both',
        compositionMode:'mixed_single_photo',
        choices:choices,
      };
    }
    return{
      category:null,confidence:null,needsConfirm:true,reason:'mixed_subject',
      compositionMode:null,
      choices:choices,
    };
  }
  if(hasPet&&!hasHuman){
    const lowConf=verifyConf==='low';
    return{
      category:'huisdier',
      confidence:lowConf?'medium':'high',
      needsConfirm:lowConf,
      reason:'pet_only',
      compositionMode:null,
      choices:null,
    };
  }
  if(hasHuman&&!hasPet){
    if(n<=0){
      return{
        category:null,confidence:null,needsConfirm:true,reason:'human_faces_unknown',
        compositionMode:null,choices:null,
      };
    }
    const lowConf=verifyConf==='low';
    const conf=lowConf?'medium':'high';
    if(n===1){
      return{
        category:'zelf',confidence:conf,needsConfirm:lowConf,reason:'solo_human',
        compositionMode:null,choices:null,
      };
    }
    if(n===2){
      return{
        category:'koppel',confidence:conf,needsConfirm:lowConf,reason:'two_humans',
        compositionMode:null,choices:null,
      };
    }
    return{
      category:'gezin',confidence:conf,needsConfirm:lowConf,reason:'group_humans',
      compositionMode:null,choices:null,
    };
  }
  return{
    category:null,confidence:null,needsConfirm:true,reason:'indeterminate',
    compositionMode:null,choices:null,
  };
}

function wsBuildVisionMetaFromAi(){
  const meta={
    schemaVersion:WS_VISION_META_SCHEMA_VERSION,
    detectorName:WS_AI_DETECTOR_NAME,
    detectionStatus:S.aiVerifyStatus==='ok'?'ok':(S.aiVerifyStatus==='pending'?'timeout':'unknown'),
    detectionCompletedAtMs:Date.now(),
  };
  if(typeof S.faceCount==='number'&&Number.isFinite(S.faceCount))meta.detectedFaceCount=S.faceCount;
  if(S.subjectClass==='likely_human'||S.subjectClass==='likely_pet'||S.subjectClass==='unknown')meta.subjectClass=S.subjectClass;
  if(S.containsPetSubject===true)meta.containsPetSubject=true;
  else if(S.containsPetSubject===false)meta.containsPetSubject=false;
  if(typeof S.estimatedPetCount==='number'&&Number.isFinite(S.estimatedPetCount)&&S.estimatedPetCount>=0){
    meta.serverEstimatedPetCount=S.estimatedPetCount;
  }
  if(S.serverOutdoorLeisureScene===true)meta.serverOutdoorLeisureScene=true;
  if(typeof S.qualityScore==='number'&&Number.isFinite(S.qualityScore)&&Array.isArray(S.qualityReasons)){
    meta.qualityScore=S.qualityScore;
    meta.qualityReasons=S.qualityReasons.slice();
  }
  const slotsArr=Array.isArray(S.slots)?S.slots:[];
  if(slotsArr.length>1){
    const slots=slotsArr.map(s=>{
      const out={role:s&&s.role?s.role:'other'};
      if(out.role==='people'){
        out.detectedFaceCount=meta.detectedFaceCount??null;
        out.detectionStatus='ok';
        if(meta.subjectClass)out.subjectClass=meta.subjectClass;
        if(meta.containsPetSubject===true)out.containsPetSubject=true;
      }else if(out.role==='pet'){
        out.detectionStatus='skipped_pet';
      }
      return out;
    });
    meta.slots=slots;
    const total=wsAggregatedPeopleFaceCount(slotsArr);
    if(typeof total==='number'&&Number.isFinite(total))meta.detectedFaceCount=total;
  }
  return meta;
}


async function wsResolveVisionMeta(){
  // Speed Phase 1B — tiered verify wait. When `verifyCacheId` is already set
  // the prefetch has settled and `wsBuildVisionMetaFromAi` reads cached state
  // — no race needed. When still in-flight cap at 2000ms (down from 10000) so
  // generate is not blocked beyond the perceptual budget; worker re-verifies
  // regardless (`docs/wallstraight-generate-api.md` L38), so optimistic POST
  // with stale verify is safe. Upload-time prefetch keeps its 10s tolerance.
  if(S.aiVerifyPromise&&typeof S.aiVerifyPromise.then==='function'&&!S.verifyCacheId){
    let timer;
    const timeout=new Promise(res=>{timer=setTimeout(()=>res({__ws_timed_out:true}),WS_VISION_META_GENERATE_WAIT_MS);});
    try{await Promise.race([S.aiVerifyPromise,timeout]);}finally{if(timer)clearTimeout(timer);}
  }
  // Speed Phase 1A — quality-scan wait removed from generate critical path.
  // `slot.qualityPromise` still runs async in `wsCreateSlot`; banners surface
  // via the chained `wsRenderQualityHint` callbacks (L4343, L4369) when the
  // scan resolves — independently of the POST. Quality fields on the wire
  // populate from cached state once the scan completes; the worker's quality
  // gates run server-side regardless.
  return wsBuildVisionMetaFromAi();
}
/**
 * Track H (slice p2h-classifier) — LEGACY_REMOVED R-AI-ONLY 2026-05-20 MediaPipe ObjectDetector; restore from git if rollback.
 — lazy-loaded MediaPipe Tasks Vision
 * `ObjectDetector` with the COCO-trained EfficientDet-Lite0 head, used to
 * tell pet uploads (dog / cat) apart from human uploads even when the
 * shopper picked a people category. URL verified 2026-05-10 (HEAD 200) at
 * the curated `mediapipe-models/object_detector/...` namespace and matches
 * the same `tasks-vision` TFLite + task-metadata format used by
 * `FaceDetector.createFromOptions`. `scoreThreshold: 0.30` is intentionally
 * permissive — `wsClassifySubjectFromDataUrl` enforces the *decision*
 * thresholds (animal vs person dominance) so we keep raw signal and don't
 * tune two knobs at once.
 */
// LEGACY_REMOVED R-AI-ONLY
async function wsGetObjectDetector(){return null;}

/**
 * Track H — pure decision tree mapping fused detector signals to a
 * `subjectClass`: `'likely_human' | 'likely_pet' | 'unknown'`.
 *
 * Inputs:
 *   • `scores` — `{ dog, cat, person }` max top-1 scores from ObjectDetector.
 *   • `faceBoxesNorm` — face-detector bboxes (0..1 of source dims), or `null`.
 *   • `petBoxesNorm` — dog/cat bboxes from ObjectDetector (0..1), or `[]`.
 *
 * Branches (conservative — false positives are worse than `unknown`):
 *   1. Strong pet, weak person ⇒ `likely_pet` (Walter / dog-only).
 *   2. Strong person, weak pet ⇒ `likely_human` (typical mom+baby / portrait).
 *   3. Moderate pet, weak person, AND a face-detector bbox sits inside a pet
 *      bbox (containment ≥ 0.50 OR IoU ≥ 0.30) ⇒ `likely_pet`. Catches the
 *      "BlazeFace fired on a Labrador" case (R14/R15) — the human face
 *      detector picked up a head-shaped region the object detector says is
 *      a dog. This wires bbox overlap into the rule per plan §H1.
 *   4. Mixed scene with strong person ⇒ `likely_human` (people win when
 *      both signals are present and person score is high).
 *   5. Else ⇒ `unknown` — plan §5.9 / §5.10: never accuse a shopper of the
 *      wrong species on a noisy / inconclusive image.
 *
 * Pure function — no DOM, no I/O — so it's directly testable. The async
 * wrapper `wsClassifySubjectFromDataUrl` is only responsible for normalising
 * detector output into the inputs shape this function expects.
 */
function wsDecideSubjectClassFromSignals(scores,faceBoxesNorm,petBoxesNorm){
  const dogScore=Number(scores&&scores.dog)||0;
  const catScore=Number(scores&&scores.cat)||0;
  const personScore=Number(scores&&scores.person)||0;
  const petScore=Math.max(dogScore,catScore);
  if(petScore>=0.55&&personScore<0.45)return 'likely_pet';
  if(personScore>=0.55&&petScore<0.45)return 'likely_human';
  if(petScore>=0.45&&personScore<0.45&&Array.isArray(faceBoxesNorm)&&faceBoxesNorm.length&&Array.isArray(petBoxesNorm)&&petBoxesNorm.length){
    for(const fb of faceBoxesNorm){
      for(const pb of petBoxesNorm){
        if(wsBoxContainment(fb,pb)>=0.50||wsBoxIoU(fb,pb)>=0.30)return 'likely_pet';
      }
    }
  }
  if(personScore>=0.55)return 'likely_human';
  return 'unknown';
}

/**
 * Phase 2 / Slice P2.C — auxiliary signal that says "this photo contains a
 * non-trivial pet bbox" even when `wsDecideSubjectClassFromSignals` resolved
 * to `likely_human` (because the human face dominated). Pure function,
 * orthogonal to subjectClass — mirrors the server `VisionMeta.containsPetSubject`
 * field.
 *
 * Why a separate signal: the May 2026 case (woman + cat, royal + zelf)
 * correctly resolved to `subjectClass='likely_human'` because the woman's
 * face dominated the classifier scores. Today's banner system has no concept
 * of "human AND pet present in the same photo" — so no warning fires and
 * the people-only royal recipe silently drops the cat. With
 * `containsPetSubject=true` the storefront banner can offer an "Include
 * both" affordance (slice P2.D) and the server can route to dual-subject
 * treatment when accepted (slice P2.E).
 *
 * Conservative thresholds:
 *   - Default `petScore >= 0.40` — slightly below the 0.45 overlap floor in
 *     `wsDecideSubjectClassFromSignals` rule #4 — small dogs held close
 *     to a person often score 0.40–0.44 while `subjectClass` stays
 *     `likely_human`) — under this we treat detector noise as "no pet".
 *     Stuffed-toy false positives at ~0.31 stay excluded.
 *   - **Relaxed** when `ctx.subjectClass === 'likely_human'` and
 *     `ctx.faceCount` is 1 or 2: floor **`WS_PET_MIXED_SIGNAL_MIN` (0.32)**
 *     so 1H+1P with BlazeFace N=2 still sets `containsPetSubject` for
 *     R-BOND-IMPLICIT-2FACE server parity (May 2026 practitioner repro).
 *   - At least one entry in `petBoxesNorm` — defensive backup so a stale
 *     scores object without bboxes never claims "pet present".
 *
 * Returns `false` for empty inputs (defensive). Never throws.
 */
function wsDeriveContainsPetSubject(scores,petBoxesNorm,ctx){
  const dogScore=Number(scores&&scores.dog)||0;
  const catScore=Number(scores&&scores.cat)||0;
  const petScore=Math.max(dogScore,catScore);
  if(!Array.isArray(petBoxesNorm)||petBoxesNorm.length===0)return false;
  const strictMin=0.40;
  const relaxedOk=ctx&&ctx.subjectClass==='likely_human'&&typeof ctx.faceCount==='number'&&Number.isFinite(ctx.faceCount)&&ctx.faceCount>=1&&ctx.faceCount<=2;
  const minScore=relaxedOk?WS_PET_MIXED_SIGNAL_MIN:strictMin;
  if(petScore<minScore)return false;
  return true;
}

/**
 * Phase 3 / Slice P3.A (R-FAB5) — canonical reason tokens emitted by the
 * client-side photo-quality scan. Server-side parser whitelists this exact
 * set; pre-Phase-3 themes omit the wire field entirely (back-compat).
 *
 *   - `too_dark`        — mean luma below 60 (out of 255). Indoor with
 *                          poor lighting, backlit selfies.
 *   - `too_bright`      — mean luma above 220. Overexposed phone shots,
 *                          direct-sunlight wash-outs.
 *   - `too_blurry`      — Laplacian-variance below 30 on a 256px-max-edge
 *                          downsample. Camera shake, autofocus miss.
 *   - `face_too_small`  — largest face bbox is < 2% of the image area.
 *                          Far-away group shots, full-body framing.
 *                          Only fires when faceBoxes are present (face
 *                          detection succeeded).
 *   - `too_low_res`     — native max(width,height) < 512 px. Thumbnails,
 *                          screenshots of small images.
 *
 * Thresholds intentionally LENIENT (only catch the worst offenders) so
 * the post-upload banner (Slice P3.B) never triggers on artistic /
 * stylized / film-grain shots that would still produce a good preview.
 * The full Fable-parity guidance ("close-up, well-lit, sharp") is also
 * surfaced unconditionally as the always-visible 3-bullet tip strip
 * (Slice P3.B) so shoppers see best-practice copy regardless of any
 * specific quality reason firing.
 */
const WS_QUALITY_REASONS=Object.freeze(['too_dark','too_bright','too_blurry','face_too_small','too_low_res']);

/**
 * Phase 3 / Slice P3.A (R-FAB5) — pure: largest face bounding-box area as a
 * fraction of the image area. Each `b` is `{x,y,w,h}` in 0..1 units (matches
 * `wsCountFacesFromDataUrl` output). Returns `null` for empty / non-array
 * input so the caller can SKIP the `face_too_small` reason rather than
 * pretending the face was missing (different signal).
 */
function wsLargestFaceAreaRatio(faceBoxesNorm){
  if(!Array.isArray(faceBoxesNorm)||faceBoxesNorm.length===0)return null;
  let best=0;
  for(const b of faceBoxesNorm){
    if(!b||typeof b!=='object')continue;
    const w=Number(b.w),h=Number(b.h);
    if(!Number.isFinite(w)||!Number.isFinite(h))continue;
    const area=Math.max(0,w)*Math.max(0,h);
    if(area>best)best=area;
  }
  return best;
}

/**
 * Phase 3 / Slice P3.A (R-FAB5) — pure: roll up the four metrics into a
 * `{score, reasons}` shape. Score is 1 - 0.25 * reasons.length, clamped to
 * [0,1] (so 0 reasons → 1.0; 4+ reasons → 0). Each metric is OPTIONAL —
 * pass `null` / `undefined` / non-finite to skip its branch.
 *
 * Thresholds (see WS_QUALITY_REASONS docstring for rationale):
 *   lumaMean              < 60   → 'too_dark'
 *   lumaMean              > 220  → 'too_bright'
 *   lumaVariance          < 30   → 'too_blurry' (Laplacian variance on 256px luma)
 *   largestFaceAreaRatio  < 0.02 → 'face_too_small'
 *   nativeMaxDim          < 512  → 'too_low_res'
 */
function wsDecidePhotoQualityReasons(input){
  // `null` / `undefined` for any metric means "no signal for this dimension"
  // and the corresponding reason MUST NOT fire (different from "we measured
  // and it was 0" — the latter would indicate a real problem). Note that
  // `Number(null) === 0` so an explicit null/undefined check is required
  // BEFORE coercion; without it, `largestFaceAreaRatio: null` would trip
  // the `<0.02` branch and falsely fire `face_too_small`.
  function readMetric(value){
    if(value===null||value===undefined)return null;
    const n=Number(value);
    return Number.isFinite(n)?n:null;
  }
  const reasons=[];
  const lumaMean=input?readMetric(input.lumaMean):null;
  const lumaVariance=input?readMetric(input.lumaVariance):null;
  const faceArea=input?readMetric(input.largestFaceAreaRatio):null;
  const maxDim=input?readMetric(input.nativeMaxDim):null;
  if(lumaMean!==null){
    if(lumaMean<60)reasons.push('too_dark');
    else if(lumaMean>220)reasons.push('too_bright');
  }
  if(lumaVariance!==null&&lumaVariance<30)reasons.push('too_blurry');
  if(faceArea!==null&&faceArea<0.02)reasons.push('face_too_small');
  if(maxDim!==null&&maxDim<512)reasons.push('too_low_res');
  const score=Math.max(0,Math.min(1,1-0.25*reasons.length));
  return {score,reasons};
}

/**
 * Phase 3 / Slice P3.A (R-FAB5) — browser wrapper that decodes a data URL,
 * downsamples to a 256-px-max-edge canvas, computes (mean luma, Laplacian
 * variance) on the luma channel, and combines with the (already-known)
 * face boxes + native resolution into a `{score, reasons}` verdict.
 *
 * Returns `null` on any decode / canvas / read failure so callers can
 * fall through to "no signal" rather than block the upload — same
 * defensive contract as `wsClassifySubjectFromDataUrl`. The 256-px cap
 * keeps the cost on the worst-case mobile device under ~50 ms; full-
 * resolution scoring is deferred to a server-side `sharp` pass (Slice
 * P3.B) where it can run inside the existing async generate worker.
 */
async function wsComputePhotoQualityFromDataUrl(dataUrl,faceBoxesNorm){
  if(wsShouldSkipFaceDetect())return null;
  try{
    const img=await wsLoadImageElementFromDataUrl(dataUrl);
    const W=img.naturalWidth||img.width;
    const H=img.naturalHeight||img.height;
    if(!W||!H)return null;
    const maxEdge=256;
    const scale=Math.min(1,maxEdge/Math.max(W,H));
    const cw=Math.max(2,Math.round(W*scale));
    const ch=Math.max(2,Math.round(H*scale));
    const canvas=document.createElement('canvas');
    canvas.width=cw;canvas.height=ch;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});
    if(!ctx)return null;
    ctx.drawImage(img,0,0,cw,ch);
    const data=ctx.getImageData(0,0,cw,ch).data;
    const luma=new Float32Array(cw*ch);
    let lumaSum=0;
    for(let i=0,j=0;i<data.length;i+=4,j++){
      const y=0.299*data[i]+0.587*data[i+1]+0.114*data[i+2];
      luma[j]=y;
      lumaSum+=y;
    }
    const lumaMean=lumaSum/luma.length;
    let lapSum=0,lapSumSq=0,lapCount=0;
    for(let y=1;y<ch-1;y++){
      for(let x=1;x<cw-1;x++){
        const i=y*cw+x;
        const lap=4*luma[i]-luma[i-1]-luma[i+1]-luma[i-cw]-luma[i+cw];
        lapSum+=lap;
        lapSumSq+=lap*lap;
        lapCount++;
      }
    }
    const lapMean=lapCount>0?lapSum/lapCount:0;
    const lumaVariance=lapCount>0?(lapSumSq/lapCount)-(lapMean*lapMean):null;
    const largestFaceAreaRatio=wsLargestFaceAreaRatio(faceBoxesNorm);
    const nativeMaxDim=Math.max(W,H);
    return wsDecidePhotoQualityReasons({lumaMean,lumaVariance,largestFaceAreaRatio,nativeMaxDim});
  }catch(_){
    return null;
  }
}

/**
 * Track H — fuse ObjectDetector output with face-detector bboxes into a
 * `subjectClass` decision via `wsDecideSubjectClassFromSignals`. Decision-tree
 * docs live on the pure helper above.
 *
 * `faceBoxesNorm` is in 0..1 of source dims (matches `wsCountFacesFromDataUrl`
 * `boxes` output). When `null` (face detection failed / pending), the
 * face-overlap branch is skipped — the score-only branches still fire.
 */
async function wsClassifySubjectFromDataUrl(dataUrl,faceBoxesNorm){
  if(wsShouldSkipFaceDetect())return {subjectClass:'unknown',containsPetSubject:false,status:'skipped_test',scores:null};
  try{
    const det=await wsGetObjectDetector();
    if(!det)return {subjectClass:'unknown',containsPetSubject:false,status:'error',scores:null};
    const img=await wsLoadImageElementFromDataUrl(dataUrl);
    const W=img.naturalWidth||img.width;
    const H=img.naturalHeight||img.height;
    if(!W||!H)return {subjectClass:'unknown',containsPetSubject:false,status:'error',scores:null};
    const result=det.detect(img);
    const dets=result&&result.detections?result.detections:[];
    if(!Array.isArray(dets))return {subjectClass:'unknown',containsPetSubject:false,status:'error',scores:null};

    let dogScore=0,catScore=0,personScore=0;
    const petBoxesNorm=[];
    // R-GOAL-1 / Phase 1 — collect `person` bboxes so callers can reconcile
    // BlazeFace face detections against the regions where humans actually
    // are. Pre-Phase-1 builds only kept `personScore`; the bboxes were
    // dropped on the floor even though MediaPipe ObjectDetector emits the
    // same `boundingBox` shape (`originX/originY/width/height`) for every
    // category. Normalised to 0..1 of source dimensions so downstream
    // geometry helpers reason in the same units as `slot.faceBoxes` /
    // `petBoxesNorm` (`wsCountFacesFromDataUrl` normalises pixel boxes to
    // 0..1 at line ~3030; pet boxes are also normalised here).
    const personBoxesNorm=[];
    for(const d of dets){
      const cats=d&&d.categories;
      if(!Array.isArray(cats)||!cats.length)continue;
      const top=cats[0];
      const name=String(top&&top.categoryName||'').toLowerCase();
      const score=Number(top&&top.score);
      if(!Number.isFinite(score))continue;
      const bb=d.boundingBox;
      if(name==='dog'){
        if(score>dogScore)dogScore=score;
        if(bb)petBoxesNorm.push({x:Number(bb.originX)/W,y:Number(bb.originY)/H,w:Number(bb.width)/W,h:Number(bb.height)/H});
      }else if(name==='cat'){
        if(score>catScore)catScore=score;
        if(bb)petBoxesNorm.push({x:Number(bb.originX)/W,y:Number(bb.originY)/H,w:Number(bb.width)/W,h:Number(bb.height)/H});
      }else if(name==='person'){
        if(score>personScore)personScore=score;
        if(bb)personBoxesNorm.push({x:Number(bb.originX)/W,y:Number(bb.originY)/H,w:Number(bb.width)/W,h:Number(bb.height)/H});
      }
    }
    const scores={dog:dogScore,cat:catScore,person:personScore};
    const subjectClass=wsDecideSubjectClassFromSignals(scores,faceBoxesNorm,petBoxesNorm);
    const petClassifierMaxScore=Math.max(dogScore,catScore);
    const faceCount=Array.isArray(faceBoxesNorm)?faceBoxesNorm.length:0;
    // Phase 2 / Slice P2.C — orthogonal aux signal so callers can detect
    // single-photo mixed-subject (person dominant + pet visible) without
    // changing the existing subjectClass branches.
    const containsPetSubject=wsDeriveContainsPetSubject(scores,petBoxesNorm,{subjectClass,faceCount});
    // R-GOAL-1 / Phase 1 — `personBoxesNorm` is additive (new return key);
    // existing destructuring of this function is `r.subjectClass /
    // .containsPetSubject / .status / .scores / .petClassifierMaxScore`
    // (grep `wsClassifySubjectFromDataUrl` in this file: only call site is
    // `wsCreateSlot` line ~1897). Pre-Phase-1 callers ignore unknown keys
    // (no closed-key destructure anywhere) so this stays back-compat.
    return {subjectClass,containsPetSubject,status:'ok',scores,petClassifierMaxScore,personBoxesNorm,petBoxesNorm};
  }catch(_){
    return {subjectClass:'unknown',containsPetSubject:false,status:'error',scores:null};
  }
}

async function wsGetFaceDetector(){
  if(wsShouldSkipFaceDetect())return null;
  if(_wsFaceDetPromise)return _wsFaceDetPromise;
  _wsFaceDetPromise=(async()=>{
    try{
      const {FaceDetector,FilesetResolver}=await import(/* webpackIgnore: true */ 'https://esm.sh/@mediapipe/tasks-vision@0.10.14');
      const fileset=await FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm');
      return await FaceDetector.createFromOptions(fileset,{
        // MUST stay `blaze_face_short_range` for tasks-vision@0.10.14 — the WASM
        // pipeline expects 896 anchors; full_range `.tflite` emits 2304 → graph
        // RET_CHECK (user-visible INTERNAL tensor shape mismatch). Infant recall
        // uses multi-scale `wsCountFacesFromDataUrl` + IoU merge instead.
        baseOptions:{modelAssetPath:'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite'},
        runningMode:'IMAGE',
        // CAW.B — constructor floor lowered from 0.40 to 0.30 so the recall
        // passes (pass 3 downscale) can surface sub-0.40 small-face
        // activations. Pass 1 (native) and pass 2 (upscale) are post-filtered
        // back up to 0.40 at the call site so the primary signal keeps its
        // original noise budget; only pass 3 retains the 0.30 floor. Range
        // is `Float [0, 1]` with documented default 0.5 per Google MediaPipe
        // Face Detector docs (https://ai.google.dev/edge/mediapipe/solutions/vision/face_detector).
        minDetectionConfidence:0.30,
      });
    }catch(e){
      console.warn('[Wallstraight] FaceDetector unavailable — multi-face hint skipped.',e);
      return null;
    }
  })();
  return _wsFaceDetPromise;
}

/**
 * Track G (slice p2g-detect) — extract MediaPipe Tasks Vision face-detection
 * results into a normalised box list `{x, y, w, h, score}` in PIXEL coords of
 * the source image. Tasks Vision exposes `detection.boundingBox` with
 * `originX/originY/width/height` and `detection.categories[0].score`; we keep
 * the score so downstream IoU merge can prefer the higher-confidence box.
 */
function wsExtractFaceBoxes(result){
  const list=result&&result.detections?result.detections:[];
  if(!Array.isArray(list))return [];
  const out=[];
  for(const d of list){
    const bb=d&&d.boundingBox;
    if(!bb)continue;
    const x=Number(bb.originX);
    const y=Number(bb.originY);
    const w=Number(bb.width);
    const h=Number(bb.height);
    if(!Number.isFinite(x)||!Number.isFinite(y)||!Number.isFinite(w)||!Number.isFinite(h))continue;
    if(w<=0||h<=0)continue;
    let score=0;
    const cats=d&&d.categories;
    if(Array.isArray(cats)&&cats.length){
      const s=Number(cats[0]&&cats[0].score);
      if(Number.isFinite(s))score=s;
    }
    out.push({x,y,w,h,score});
  }
  return out;
}

/** IoU between two pixel-coord boxes. 0 when disjoint, 1 when identical. */
function wsBoxIoU(a,b){
  const x1=Math.max(a.x,b.x),y1=Math.max(a.y,b.y);
  const x2=Math.min(a.x+a.w,b.x+b.w),y2=Math.min(a.y+a.h,b.y+b.h);
  if(x2<=x1||y2<=y1)return 0;
  const inter=(x2-x1)*(y2-y1);
  const ua=a.w*a.h+b.w*b.h-inter;
  return ua>0?inter/ua:0;
}

/** Containment ratio: area(intersection) / min(area(a), area(b)). Catches the
 *  case where the upscaled pass returns a *larger* box that swallows a smaller
 *  duplicate from pass 1 (low IoU but high containment ⇒ same face). */
function wsBoxContainment(a,b){
  const x1=Math.max(a.x,b.x),y1=Math.max(a.y,b.y);
  const x2=Math.min(a.x+a.w,b.x+b.w),y2=Math.min(a.y+a.h,b.y+b.h);
  if(x2<=x1||y2<=y1)return 0;
  const inter=(x2-x1)*(y2-y1);
  const minA=Math.min(a.w*a.h,b.w*b.h);
  return minA>0?inter/minA:0;
}

/**
 * R-GOAL-1 / Phase 1 — pure geometry: filter BlazeFace face boxes to those
 * that plausibly belong to a human `person` region detected by the
 * COCO-trained MediaPipe ObjectDetector. Reconciles two orthogonal
 * pipelines (face path + object path; see `Implementation design` mermaid in
 * `/Users/jhpalen/.cursor/plans/vision_face-count_reconciliation_a642badd.plan.md`)
 * so `visionMeta.detectedFaceCount` stops claiming N=4 humans on a `1 human +
 * 1 dog + background clutter` upload (R-FACT-6 archetype).
 *
 * Inputs:
 *   - `faceBoxesNorm`: array of `{x,y,w,h[,score]}` in 0..1 source-relative
 *     units (matches `slot.faceBoxes` shape emitted by `wsCountFacesFromDataUrl`).
 *   - `personBoxesNorm`: array of `{x,y,w,h}` in 0..1 source-relative units
 *     (matches `wsClassifySubjectFromDataUrl`'s new return key).
 *   - `opts.dilate`: optional dilation factor on person box width/height
 *     (default 0.10 — `±10%` per side). MediaPipe ObjectDetector COCO
 *     `person` bboxes typically end at the chin/shoulders for tightly-
 *     cropped portraits, so a face's center can land slightly *outside*
 *     the raw bbox even though the face IS the person. Dilation lets the
 *     center-in test catch those without admitting boxes from distant
 *     background clutter.
 *   - `opts.iouMin`: optional minimum IoU between a face and any (raw,
 *     non-dilated) person bbox to admit the face when the center-in test
 *     fails. Defaults to 0.05 — small because faces are ~10–30% of a person
 *     bbox; setting too high rejects valid faces with imperfect overlap.
 *
 * Decision rule (per face box):
 *   1. If centre of face lies inside the dilated union of person bboxes ⇒
 *      keep (most reliable signal — face is "on" a human silhouette).
 *   2. Else if IoU(face, any raw person bbox) ≥ `iouMin` ⇒ keep (face
 *      overlaps a person region even though its center fell just outside).
 *   3. Else ⇒ drop (face has no person association — couch pillow,
 *      jacket-graphic pareidolia, distant signage etc.).
 *
 * Fallbacks (R-SAFE-1 / R-SAFE-2 are applied at the *caller* — this helper
 * is pure / advisory):
 *   - **No person boxes**: the helper returns `faceBoxesNorm.slice()`
 *     unchanged. The caller still has the raw count.
 *   - **No face boxes**: returns `[]` trivially (nothing to filter).
 *   - **All faces filtered out**: caller must apply R-SAFE-2 (monotonic
 *     reduce only) and keep raw if `filtered.length === 0 && raw > 0`.
 *
 * Pure / no DOM / no I/O — directly testable in `app-proxy/face-reconcile.test.js`.
 * Reuses existing `wsBoxIoU` (defined above) so the IoU semantics match the
 * rest of the pipeline.
 */
function wsFaceBoxesLikelyHumans(faceBoxesNorm,personBoxesNorm,opts){
  if(!Array.isArray(faceBoxesNorm)||faceBoxesNorm.length===0)return [];
  if(!Array.isArray(personBoxesNorm)||personBoxesNorm.length===0)return faceBoxesNorm.slice();
  const dilate=(opts&&Number.isFinite(opts.dilate))?opts.dilate:0.10;
  const iouMin=(opts&&Number.isFinite(opts.iouMin))?opts.iouMin:0.05;
  const dilated=[];
  for(const p of personBoxesNorm){
    if(!p||!Number.isFinite(p.x)||!Number.isFinite(p.y)||!Number.isFinite(p.w)||!Number.isFinite(p.h))continue;
    const dw=p.w*dilate;
    const dh=p.h*dilate;
    const x=Math.max(0,p.x-dw/2);
    const y=Math.max(0,p.y-dh/2);
    const w=Math.max(0,Math.min(1-x,p.w+dw));
    const h=Math.max(0,Math.min(1-y,p.h+dh));
    if(w<=0||h<=0)continue;
    dilated.push({x,y,w,h});
  }
  if(dilated.length===0)return faceBoxesNorm.slice();
  const out=[];
  for(const fb of faceBoxesNorm){
    if(!fb||!Number.isFinite(fb.x)||!Number.isFinite(fb.y)||!Number.isFinite(fb.w)||!Number.isFinite(fb.h))continue;
    const cx=fb.x+fb.w/2;
    const cy=fb.y+fb.h/2;
    let keep=false;
    for(const pp of dilated){
      if(cx>=pp.x&&cx<=pp.x+pp.w&&cy>=pp.y&&cy<=pp.y+pp.h){keep=true;break;}
    }
    if(!keep){
      for(const pp of personBoxesNorm){
        if(!pp||!Number.isFinite(pp.x))continue;
        if(wsBoxIoU(fb,pp)>=iouMin){keep=true;break;}
      }
    }
    if(keep)out.push(fb);
  }
  return out;
}

/**
 * R-GOAL-3 / Phase 2 — pure geometry: drop face boxes whose containment
 * inside a detected pet (dog / cat) bbox crosses `opts.petContainMin`
 * (default **0.70**). Addresses the **R-LIMIT-1** held-pet case where
 * Phase 1 alone is insufficient: a tight or wide COCO `person` bbox often
 * wraps the held animal, so the dog frontal face + fur pareidolia
 * activations remain INSIDE the dilated person union and survive
 * `wsFaceBoxesLikelyHumans`. ObjectDetector independently emits the pet
 * region (already used by `wsDecideSubjectClassFromSignals` overlap rule
 * #4) — this helper reuses that signal to drop face activations that are
 * essentially **on** the animal.
 *
 * Decision rule (per face box):
 *   1. Compute the max containment ratio of the face against any pet bbox
 *      via `wsBoxContainment(face, pet) = area(intersection) /
 *      min(area(face), area(pet))`. For a small face fully inside a
 *      much-larger dog bbox the ratio is 1.0; for a face that only clips
 *      a corner the ratio is small.
 *   2. If `bestPet >= petContainMin` (default 0.70) ⇒ drop. Threshold is
 *      deliberately high so legitimate human faces standing next to a
 *      dog (containment ~0.0–0.5) are never dropped. The "2 humans + 1
 *      dog" archetype is therefore preserved — a regression test under
 *      `app-proxy/face-reconcile.test.js` pins this.
 *
 * Fallbacks:
 *   - Empty / missing `petBoxesNorm` ⇒ face boxes returned unchanged
 *     (caller's R-SAFE-1 fallback still applies).
 *   - Empty / null face boxes ⇒ `[]`.
 *
 * Caller must still apply **R-SAFE-2** (monotonic reduce): use the
 * filtered result only when `0 < filtered.length < raw.length`.
 *
 * Pure / no DOM / no I/O — directly testable in
 * `app-proxy/face-reconcile.test.js` (Phase 2 block). Reuses existing
 * `wsBoxContainment` so semantics match the IoU merge / classifier
 * overlap rule.
 */
function wsFaceBoxesExcludePetOverlap(faceBoxesNorm,petBoxesNorm,opts){
  if(!Array.isArray(faceBoxesNorm)||faceBoxesNorm.length===0)return [];
  if(!Array.isArray(petBoxesNorm)||petBoxesNorm.length===0)return faceBoxesNorm.slice();
  const petContainMin=(opts&&Number.isFinite(opts.petContainMin))?opts.petContainMin:0.70;
  const out=[];
  for(const fb of faceBoxesNorm){
    if(!fb||!Number.isFinite(fb.x)||!Number.isFinite(fb.y)||!Number.isFinite(fb.w)||!Number.isFinite(fb.h))continue;
    let bestPet=0;
    for(const pb of petBoxesNorm){
      if(!pb||!Number.isFinite(pb.x))continue;
      const c=wsBoxContainment(fb,pb);
      if(c>bestPet)bestPet=c;
    }
    if(bestPet>=petContainMin)continue;
    out.push(fb);
  }
  return out;
}

/**
 * Track G (slice p2g-detect) — greedy NMS-style merge for face boxes coming
 * from multiple detection passes (native + upscaled). Sorts by score
 * descending, keeps the first box, and suppresses subsequent boxes that
 * meaningfully overlap (IoU >= 0.40 OR containment >= 0.70 — captures both
 * "same face, slightly different bbox" and "upscaled pass returned an
 * envelope around the native pass's box").
 *
 * Without this dedupe, the lower minDetectionConfidence (0.42 → 0.40) plus
 * the upscaled second pass would inflate `count` for every photo, which
 * would FALSELY suggest crowd-mismatch banners on legitimate solo / couple
 * uploads. With it, the multi-scale retry only adds *new* faces the native
 * pass missed (e.g. the infant the adult was holding).
 */
function wsMergeFaceBoxes(boxes){
  const sorted=[...boxes].sort((a,b)=>(b.score||0)-(a.score||0));
  const kept=[];
  for(const b of sorted){
    let dup=false;
    for(const k of kept){
      if(wsBoxIoU(b,k)>=0.40||wsBoxContainment(b,k)>=0.70){dup=true;break;}
    }
    if(!dup)kept.push(b);
  }
  return kept;
}

/**
 * R-FEED-8b.P0 — crop recall regions for dense group / infant undercounts.
 *
 * Whole-frame resizes keep the same face-to-frame ratio, so they cannot fully
 * rescue moderate-resolution uploads such as 704×1024 / 768×1024 where the
 * downscale pass is skipped and an infant or tucked-back face still occupies
 * only a small fraction of the detector input. These overlapping upper-body
 * crops make real faces larger for BlazeFace while avoiding arbitrary tiling
 * across floor/background regions that would raise false positives.
 */
function wsFaceRecallCropRegions(W,H){
  if(!Number.isFinite(W)||!Number.isFinite(H)||W<=0||H<=0)return [];
  const defs=[
    {x:0,y:0,w:1,h:0.72,name:'upper_full'},
    {x:0.12,y:0.02,w:0.76,h:0.72,name:'upper_center'},
    {x:0,y:0,w:0.62,h:0.82,name:'left_overlap'},
    {x:0.38,y:0,w:0.62,h:0.82,name:'right_overlap'},
    {x:0,y:0.10,w:1,h:0.70,name:'mid_full'},
  ];
  const out=[];
  const seen=new Set();
  for(const d of defs){
    const x=Math.max(0,Math.min(W-1,Math.round(d.x*W)));
    const y=Math.max(0,Math.min(H-1,Math.round(d.y*H)));
    const w=Math.max(1,Math.min(W-x,Math.round(d.w*W)));
    const h=Math.max(1,Math.min(H-y,Math.round(d.h*H)));
    if(w<96||h<96)continue;
    const key=x+','+y+','+w+','+h;
    if(seen.has(key))continue;
    seen.add(key);
    out.push({x,y,w,h,name:d.name});
  }
  return out;
}

/**
 * Crop recall runs at a permissive 0.30 floor, so a NEW face box must either
 * be corroborated by another overlapping crop or be high-confidence on its
 * own. This keeps the P0 recall lift while bounding solo-photo false positives
 * from single crop-only activations.
 */
function wsSupportedCropRecallBoxes(boxes,opts){
  const standaloneScore=(opts&&Number.isFinite(opts.standaloneScore))?opts.standaloneScore:0.50;
  const out=[];
  for(let i=0;i<boxes.length;i++){
    const b=boxes[i];
    let supported=Number.isFinite(b.score)&&b.score>=standaloneScore;
    if(!supported){
      for(let j=0;j<boxes.length;j++){
        if(i===j)continue;
        const o=boxes[j];
        if(wsBoxIoU(b,o)>=0.25||wsBoxContainment(b,o)>=0.60){supported=true;break;}
      }
    }
    if(supported)out.push(b);
  }
  return out;
}

function wsFaceScoreRange(boxes){
  let min=null,max=null;
  if(!Array.isArray(boxes))return {min,max};
  for(const b of boxes){
    const s=b&&b.score;
    if(!Number.isFinite(s))continue;
    min=min==null?s:Math.min(min,s);
    max=max==null?s:Math.max(max,s);
  }
  return {min,max};
}

/** Decode a data URL into an `Image` element ready for `det.detect(img)`.
 *  Centralised so multi-scale and future classifiers share one decode + onload
 *  contract; rejects on browser decode failure so callers can fall through
 *  to `status: 'error'`. */
function wsLoadImageElementFromDataUrl(dataUrl){
  return new Promise((res,rej)=>{
    const img=new Image();
    img.onload=()=>res(img);
    img.onerror=()=>rej(new Error('img'));
    img.crossOrigin='anonymous';
    img.src=dataUrl;
  });
}

async function wsCountFacesFromDataUrl(dataUrl){
  if(wsShouldSkipFaceDetect())return {count:null,avgScore:null,status:'skipped_test',boxes:null};
  try{
    const det=await wsGetFaceDetector();
    if(!det)return {count:null,avgScore:null,status:'error',boxes:null};
    const img=await wsLoadImageElementFromDataUrl(dataUrl);
    const W=img.naturalWidth||img.width;
    const H=img.naturalHeight||img.height;
    if(!W||!H)return {count:null,avgScore:null,status:'error',boxes:null};

    // Pass 1 — native resolution. Primary signal for typical phone-camera
    // uploads (long-edge ~3000–4000 px).
    const r1=det.detect(img);
    const raw1=wsExtractFaceBoxes(r1);
    // CAW.B — post-filter at score >= 0.40 so pass 1 keeps its pre-CAW.B
    // noise budget even though the detector constructor floor was lowered
    // to 0.30 (only pass 3 below benefits from the lower floor).
    const boxes1=raw1.filter(b=>!Number.isFinite(b.score)||b.score>=0.40);

    // R-FEED-8b — multi-scale recall (always-on for people uploads).
    //
    // Background: MediaPipe BlazeFace short-range has a 128×128 input shape
    // (verified against https://ai.google.dev/edge/mediapipe/solutions/vision/face_detector
    // 2026-05-11). Faces that occupy a small fraction of the source frame
    // (infants in arms, back-row figures, distant subjects) collapse to a
    // handful of pixels at the network's input scale and fall under the
    // detector's effective receptive field. The single-pass approach
    // systematically undercounts these, which produced the practitioner's
    // 2026-05-11 "2 detected, baby visible" mismatch.
    //
    // Pre-Slice-B behavior gated the upscale recall pass behind a heuristic
    // (longEdge<1280 OR shortEdge<800) so it never fired for typical phone
    // uploads (≥3000 px long edge). Slice B drops that gate. The detector
    // is already loaded once at module scope; running an extra `det.detect`
    // call against a canvas is the same cost regardless of how the gate is
    // written. The IoU + containment merger (`wsMergeFaceBoxes`) collapses
    // duplicates so legitimate solo / couple uploads don't get inflated.
    //
    // Pass 2 — UPSCALE recall: target long edge ≈ 2000 px when source is
    // under-resolution (caller's phone may have downsampled, or the upload
    // is a thumbnail). Capped at 3× to avoid aliasing artefacts. Always
    // attempted for any source up to 2000 px long edge.
    //
    // Pass 3 — DOWNSCALE recall: target long edge ≈ 1024 px when source is
    // OVER-resolution (≥2400 px long edge — typical phone camera). Because
    // MediaPipe preprocesses inputs (including resizing), this is mainly an
    // anti-aliasing / memory-bounding recall step; pass 4 below is the
    // stronger lever for moderate-resolution clear-but-undercounted uploads.
    //
    // Pass 4 — CROP recall: overlapping upper-body crops for moderate
    // resolution uploads (e.g. 704×1024 / 768×1024 screenshots) where
    // whole-frame resizing preserves face proportions and still undercounts
    // clear infants / dense groups. New low-score crop boxes must be
    // corroborated across overlapping crops before they can affect the count.
    //
    // R-HUMAN safety: this slice can ONLY add detection boxes the merger
    // didn't already have. It cannot remove a face from the count. The
    // server prompt's "AT LEAST N visible" wording (Slice C) treats N as
    // a lower bound, not a closed set, so undercounted images already
    // render every visible person — the recall passes simply make the
    // visible UI banner more honest about the count.
    const longEdge=Math.max(W,H);
    const shortEdge=Math.min(W,H);
    let boxes2=[];
    let raw2Count=0;
    let pass2Ran=false;
    {
      // Target long edge for upscale: 2000 px (just past the BlazeFace
      // sweet spot at 1500–2000). Capped at 3× the source to bound
      // bilinear-resample artefacts.
      const targetUp=Math.max(longEdge,2000);
      const scaleUp=Math.min(targetUp/longEdge,3);
      if(scaleUp>1.05){
        pass2Ran=true;
        try{
          const cw=Math.max(1,Math.round(W*scaleUp));
          const ch=Math.max(1,Math.round(H*scaleUp));
          const c=document.createElement('canvas');
          c.width=cw;c.height=ch;
          const ctx=c.getContext('2d');
          ctx.drawImage(img,0,0,cw,ch);
          const r2=det.detect(c);
          const raw2=wsExtractFaceBoxes(r2);
          raw2Count=raw2.length;
          // CAW.B — same 0.40 post-filter as pass 1. Upscale operates near
          // native resolution; the noise floor is the same.
          boxes2=raw2
            .filter(b=>!Number.isFinite(b.score)||b.score>=0.40)
            .map(b=>({x:b.x/scaleUp,y:b.y/scaleUp,w:b.w/scaleUp,h:b.h/scaleUp,score:b.score}));
        }catch(_){
          // Canvas failure (extremely large source, OOM on low-end mobile);
          // fall through — pass 1 + pass 3 still contribute.
        }
      }
    }

    let boxes3=[];
    let raw3Count=0;
    if(longEdge>2400){
      // Target long edge for downscale: 1024 px. Brings small faces
      // closer to BlazeFace's input-scale sweet spot. Cheap (canvas
      // resample is well-optimised in browsers) and the dominant
      // recall lever for typical phone uploads (3000–4000 px source).
      const scaleDown=1024/longEdge;
      try{
        const cw=Math.max(1,Math.round(W*scaleDown));
        const ch=Math.max(1,Math.round(H*scaleDown));
        const c=document.createElement('canvas');
        c.width=cw;c.height=ch;
        const ctx=c.getContext('2d');
        ctx.drawImage(img,0,0,cw,ch);
        const r3=det.detect(c);
        const raw3=wsExtractFaceBoxes(r3);
        raw3Count=raw3.length;
        // CAW.B — pass 3 retains the 0.30 constructor floor. Downscale to
        // 1024 px is the dominant recall lever for ≥ 3000 px phone uploads
        // (group selfies where BlazeFace short-range's selfie-trained bias
        // collapses to the dominant foreground face at native resolution).
        // The IoU 0.40 + containment 0.70 merge (wsMergeFaceBoxes) below
        // dedupes any pass-3 box that overlaps a pass-1 / pass-2 box, so a
        // legitimate solo upload cannot have its count inflated by a low-
        // score pass-3 redetection of the same foreground face.
        boxes3=raw3
          .filter(b=>!Number.isFinite(b.score)||b.score>=0.30)
          .map(b=>({x:b.x/scaleDown,y:b.y/scaleDown,w:b.w/scaleDown,h:b.h/scaleDown,score:b.score}));
      }catch(_){
        // Same fallthrough policy as pass 2.
      }
    }

    const preCropMerged=wsMergeFaceBoxes(boxes1.concat(boxes2).concat(boxes3));
    let boxes4=[];
    let cropRawCount=0;
    let cropSupportedCount=0;
    let cropScoreRange={min:null,max:null};
    if(preCropMerged.length<6){
      const cropRegions=wsFaceRecallCropRegions(W,H);
      const cropBoxes=[];
      for(const region of cropRegions){
        try{
          const cropLong=Math.max(region.w,region.h);
          const scaleCrop=Math.min(Math.max(1024/cropLong,0.5),2);
          const cw=Math.max(1,Math.round(region.w*scaleCrop));
          const ch=Math.max(1,Math.round(region.h*scaleCrop));
          const c=document.createElement('canvas');
          c.width=cw;c.height=ch;
          const ctx=c.getContext('2d');
          ctx.drawImage(img,region.x,region.y,region.w,region.h,0,0,cw,ch);
          const r4=det.detect(c);
          const raw4=wsExtractFaceBoxes(r4);
          for(const b of raw4){
            if(Number.isFinite(b.score)&&b.score<0.30)continue;
            cropBoxes.push({
              x:region.x+(b.x/scaleCrop),
              y:region.y+(b.y/scaleCrop),
              w:b.w/scaleCrop,
              h:b.h/scaleCrop,
              score:b.score,
            });
          }
        }catch(_){
          // A failed crop is non-fatal; earlier full-frame passes still stand.
        }
      }
      cropRawCount=cropBoxes.length;
      cropScoreRange=wsFaceScoreRange(cropBoxes);
      // Archetype C / P1 — if every full-frame pass merged to zero, we are
      // already in a high-risk "no face" UX path. Allow moderately strong
      // crop-only detections to rescue the banner from N=0 while keeping the
      // original 0.50 standalone floor for normal solo/couple photos. For
      // crowded groups, a slightly lower standalone floor helps recover the
      // last expressive / partially occluded face without admitting one-off
      // 0.30 noise.
      const standaloneScore=preCropMerged.length===0?0.40:(preCropMerged.length>=3?0.45:0.50);
      boxes4=wsSupportedCropRecallBoxes(cropBoxes,{standaloneScore});
      cropSupportedCount=boxes4.length;
    }

    const merged=wsMergeFaceBoxes(preCropMerged.concat(boxes4));
    const passStats={
      native:{raw:raw1.length,kept:boxes1.length,score:wsFaceScoreRange(raw1)},
      upscale:{ran:pass2Ran,raw:raw2Count,kept:boxes2.length,score:wsFaceScoreRange(boxes2)},
      downscale:{ran:longEdge>2400,raw:raw3Count,kept:boxes3.length,score:wsFaceScoreRange(boxes3)},
      crop:{ran:preCropMerged.length<6,raw:cropRawCount,supported:cropSupportedCount,kept:boxes4.length,score:cropScoreRange},
    };
    if(merged.length===0)return {count:0,avgScore:null,status:'ok',boxes:[],passStats};
    let scoreSum=0,scoreN=0;
    for(const b of merged){if(Number.isFinite(b.score)){scoreSum+=b.score;scoreN++;}}
    const avgScore=scoreN>0?scoreSum/scoreN:null;
    // Normalise boxes to 0..1 of source dimensions so downstream consumers
    // (Track H subjectClass classifier, future logging) can reason without
    // re-decoding the image. Keep raw pixel boxes off the wire — privacy.
    const normBoxes=merged.map(b=>({x:b.x/W,y:b.y/H,w:b.w/W,h:b.h/H,score:b.score}));
    return {count:merged.length,avgScore,status:'ok',boxes:normBoxes,passStats};
  }catch(_){
    return {count:null,avgScore:null,status:'error',boxes:null};
  }
}

/**
 * Canonical map of marketing-label (English / Dutch) → API category slug.
 * The right-hand side is what the storefront POSTs and what the Shopify
 * app's `KNOWN_CATEGORY_TAIL` keys on (researcher plan §15.5). New
 * categories MUST land in this map, the theme `CATS` table, and
 * `KNOWN_CATEGORY_TAIL` (+ stylized variant) in the same change so the
 * dual-surface stitch never drifts. Bond ("people + pet") is NOT a new
 * slug in v1 — it is composed at runtime from `visionMeta.slots` carrying
 * both a `people` role and a `pet` role; see researcher plan §15.4.
 */
const WS_CATEGORY_SLUGS=Object.freeze({
  pets:'huisdier',
  family:'gezin',
  families:'gezin',
  couple:'koppel',
  couples:'koppel',
  kids:'kind',
  child:'kind',
  children:'kind',
  self:'zelf',
  selfportrait:'zelf',
  'self-portrait':'zelf',
});

/**
 * Soft-gate UX hint matrix: maps {category × detected face count × detection
 * status} → a banner variant the storefront can render above the Generate
 * button. Pure function — no DOM, no global state read — so it is testable in
 * isolation (see `app-proxy/category-hint.test.js`). Mirrors the server-side
 * `visionReconciliationClause` thresholds in `openai-image-edit.server.ts` so
 * the prompt-level guard (researcher plan §7.G) and the shopper-facing soft
 * gate (§6 Q3 #4) cannot disagree.
 *
 * Input: `state = { cat, faceCount, faceDetStatus, hasUpload, subjectClass? }`.
 * `subjectClass` (Track H, slice p2h-ux) is one of `'likely_human' |
 * 'likely_pet' | 'unknown'` or omitted; missing is treated identically to
 * `'unknown'` so pre-Track-H storefronts keep behaving exactly as before.
 *
 * Returns `null` when there is no signal to show (no upload yet, no category
 * yet, or detection still pending). Otherwise returns
 * `{variant, category, count, suggest?, suggestSecondary?, key, ...}` where:
 *   - `variant` ∈ {ok_pet, ok_solo, ok_group, mismatch_solo, mismatch_crowd,
 *     mismatch_pet, unknown}.  (Legacy `no_face` is no longer returned —
 *     `faceCount===0` yields `null`: no shopper banner; avoids noisy false zeros.)
 *   - `key` is the i18n key for the banner body copy
 *   - `suggest` / optional `suggestSecondary` are category slugs for soft-swap
 *     CTAs (`wsRenderCategoryHint` renders both when present).
 */
function wsCategoryHintFromState(state){
  const cat=state&&state.cat;
  const n=state&&state.faceCount;
  const st=state&&state.faceDetStatus;
  const hasUpload=!!(state&&state.hasUpload);
  const subjectClass=state&&state.subjectClass;
  // R-GOAL-4 / Phase 7 — classifier status threaded so the huisdier
  // branch can WAIT for pixel evidence before flashing `ok_pet`. Pre-
  // Phase-7 pet-role short-circuited to `subjectClass='likely_pet'`
  // synchronously, so `ok_pet` fired immediately; now we wait for the
  // ObjectDetector so the inversion case (`huisdier` + `likely_human`)
  // can rule out a false-confidence banner. `null` / missing values
  // fall back to today's `ok_pet` for back-compat with callers that
  // do not thread this field.
  const subjectClassStatus=state&&state.subjectClassStatus;
  // Phase 2 / Slice P2.C — the auxiliary "this photo also has a pet bbox"
  // signal. Always normalised to boolean (omitted / null / non-true → false)
  // so back-compat callers without this field keep their pre-Phase-2
  // behaviour byte-for-byte.
  const containsPetSubject=!!(state&&state.containsPetSubject);
  if(!cat||!hasUpload)return null;
  // Phase 2 / Slice P2.D — R-MIX8: huisdier + likely_human inversion. Fires
  // BEFORE the unconditional ok_pet short-circuit so a person photo on
  // Pet portrait gets a soft warning ("we see a person, not a pet") with
  // a one-click swap to Self-portrait. Pre-Phase-7 R-MIX8 was wired but
  // NEVER fired because the state never carried `likely_human` on the
  // huisdier path (the slot short-circuited to `likely_pet` without
  // running the classifier). R-GOAL-4 removes that short-circuit so this
  // branch can finally do its job.
  if(cat==='huisdier'&&subjectClass==='likely_human'&&!containsPetSubject){
    // Royal koppel / UX parity (May 2026): inversion is not “solo only” —
    // two+ detected humans should route to Families + Self-portrait; solo
    // stays Self-portrait. Until face count is `ok` with n≥2, offer only
    // Self-portrait so we do not steer a two-face undercount toward Gezinnen.
    const base={variant:'inversion_human',category:'huisdier',count:null,key:'hint.detect.inversion_human'};
    if(st==='ok'&&typeof n==='number'&&Number.isFinite(n)&&n>=2){
      return{...base,suggest:'gezin',suggestSecondary:'zelf'};
    }
    return{...base,suggest:'zelf'};
  }
  if(cat==='huisdier'){
    // R-GOAL-4 / Phase 7 — wait for pixel evidence before claiming
    // `ok_pet`. Three buckets:
    //   1. Classifier returned `likely_pet` or `unknown` ⇒ trust the
    //      shopper's declared species, surface `ok_pet` (matches pre-
    //      Phase-7 behaviour for confirmed-pet uploads).
    //   2. Classifier explicitly errored / timed out / was skipped
    //      (unit-test mode) ⇒ also fall back to `ok_pet` — we cannot
    //      tell, default to the user's category declaration to avoid
    //      blocking legitimate pet uploads on a classifier outage.
    //   3. Otherwise (status pending / null / unknown shape) ⇒ return
    //      null so the banner stays silent until the classifier
    //      resolves. The .then(upd) chain in handleFile re-renders the
    //      hint when the promise settles, so the user sees the right
    //      banner ~500 ms after upload.
    if(subjectClass==='likely_pet'||subjectClass==='unknown'){
      return{variant:'ok_pet',category:'huisdier',count:null,suggest:null,key:'hint.detect.ok_pet'};
    }
    if(subjectClassStatus==='error'||subjectClassStatus==='timeout'||subjectClassStatus==='skipped_test'){
      return{variant:'ok_pet',category:'huisdier',count:null,suggest:null,key:'hint.detect.ok_pet'};
    }
    // Back-compat for callers that DON'T thread subjectClassStatus
    // (any pre-Phase-7 test fixture or legacy consumer): if the
    // status field is absent entirely AND subjectClass is null, we
    // treat it as "pre-classifier mode" and keep ok_pet so no
    // existing UI surface flips silently to null. State emitted by
    // `wsCategoryDetectionHint` always includes the field after
    // Phase 7.
    if(subjectClass==null&&subjectClassStatus==null){
      return{variant:'ok_pet',category:'huisdier',count:null,suggest:null,key:'hint.detect.ok_pet'};
    }
    return null;
  }
  // Phase 2 / Slice P2.D — R-MIX2 / R-MIX4: mixed-subject banner on Kinderen,
  // Gezinnen, Koppel only. (`zelf` + human + pet uses implicit
  // `mixed_single_photo` on generate — no storefront bond CTA.)
  // Before the pending / unknown gate so a late-arriving pet bbox can
  // still surface the banner without the shopper retouching the form.
  // Generate POSTs `compositionMode:'mixed_single_photo'` implicitly when
  // vision shows likely_human + containsPet (single-photo); TRUTH-IN-REFERENCE
  // suppression uses the same accepted wire shape — no Include both / Continue
  // anyway row (mirror inversion_human consent: Generate only).
  if(subjectClass==='likely_human'&&containsPetSubject&&(cat==='kind'||cat==='gezin'||cat==='koppel')){
    const altSuggest=(()=>{
      if(cat==='koppel')return'zelf';
      // Families + exactly one counted face + pet — steer to Self-portrait
      // (avoids invented extra family members).
      if(cat==='gezin'&&st==='ok'&&typeof n==='number'&&Number.isFinite(n)&&n===1)return'zelf';
      // Multi-human + pet: Pets swap misleads (animal-only framing).
      if(cat==='gezin'&&st==='ok'&&typeof n==='number'&&Number.isFinite(n)&&n>=2)return null;
      return'huisdier';
    })();
    const mixKey=
      cat==='gezin'&&st==='ok'&&typeof n==='number'&&Number.isFinite(n)&&n===1
        ?'hint.detect.mixed_in_gezin_one_detected_person'
        :'hint.detect.mixed_in_'+cat;
    // R-FEED-9c — count_caveat under the banner for undercount honesty
    // (e.g. N=1 counted face but more people visible + pet).
    return{variant:'mismatch_mixed_subject',category:cat,count:null,suggest:altSuggest,key:mixKey,countCaveat:true};
  }
  // Track H — when the storefront's pet/human classifier returned a confident
  // `likely_pet` verdict on a PEOPLE category, route to the pet-in-people
  // variant BEFORE any face-count-based branch fires. This prevents the dog-
  // photo-on-Children case (R14) from going through the "We see 1 person"
  // mismatch_solo path. We branch BEFORE the pending / unknown gate because
  // the classifier verdict can land before face-count finalises and the user
  // benefits from immediate feedback. `'unknown'` and missing fall through
  // to today's behaviour (plan §5.9 — never accuse on noisy classifier).
  if(subjectClass==='likely_pet'&&(cat==='kind'||cat==='zelf'||cat==='gezin'||cat==='koppel')){
    return{variant:'mismatch_pet',category:cat,count:null,suggest:'huisdier',key:'hint.detect.pet_in_'+cat};
  }
  if(st==='pending'||st==null)return null;
  if(st==='timeout'||st==='error'||st==='unknown'||typeof n!=='number'||!Number.isFinite(n)){
    return{variant:'unknown',category:cat,count:null,suggest:null,key:'hint.detect.unknown'};
  }
  if(n===0)return null;
  if(cat==='zelf'){
    if(n===1)return{variant:'ok_solo',category:cat,count:1,suggest:null,key:'hint.detect.ok_solo_zelf'};
    // Person + pet tallied as two faces (common BlazeFace shape) — OK for
    // Self-portrait; do not flash crowd_in_zelf.
    if(n===2&&subjectClass==='likely_human'&&containsPetSubject){
      return{variant:'ok_solo',category:cat,count:null,suggest:null,key:'hint.detect.ok_zelf_person_pet'};
    }
    // n === 2 → `koppel` is the two-subject people mode (not romance detection); closer fit than gezin.
    // n >= 3 → suggest gezin (multi-figure framing).
    // Royal koppel parity: body copy lists “family, two people, …” — offer
    // both Families and two-person mode for N=2 with truth reassurance.
    if(n===2)return{variant:'mismatch_crowd',category:cat,count:null,suggest:'gezin',suggestSecondary:'koppel',key:'hint.detect.crowd_in_zelf'};
    return{variant:'mismatch_crowd',category:cat,count:null,suggest:'gezin',key:'hint.detect.crowd_in_zelf'};
  }
  if(cat==='gezin'){
    if(n===1)return{variant:'mismatch_solo',category:cat,count:null,suggest:'zelf',key:'hint.detect.solo_in_gezin'};
    // Ok path: no face-count line (unreliable at 128²); no count_caveat (would
    // reintroduce "counting" anxiety). Server TRUTH-IN-REFERENCE GUARD unchanged.
    return{variant:'ok_group',category:cat,count:null,suggest:null,key:'hint.detect.ok_family'};
  }
  if(cat==='koppel'){
    if(n===1)return{variant:'mismatch_solo',category:cat,count:null,suggest:'zelf',key:'hint.detect.solo_in_koppel'};
    if(n===2)return{variant:'ok_group',category:cat,count:null,suggest:null,key:'hint.detect.ok_couple'};
    return{variant:'mismatch_crowd',category:cat,count:null,suggest:'gezin',key:'hint.detect.crowd_in_koppel'};
  }
  if(cat==='kind'){
    // Storefront no longer surfaces age-disclaimer soft-gate for solo-face Kinderen (hint.detect.solo_in_kind).
    if(n===1)return null;
    if(n===2)return{variant:'ok_group',category:cat,count:null,suggest:null,key:'hint.detect.ok_kids',adultNote:true};
    return{variant:'mismatch_crowd',category:cat,count:null,suggest:'gezin',key:'hint.detect.crowd_in_kind'};
  }
  return null;
}

/**
 * Live-state wrapper: pulls the current S into `wsCategoryHintFromState`.
 *
 * Track H (slice p2h-ux): also threads `subjectClass` through. For multi-photo
 * uploads we mirror the same aggregation rule wsResolveVisionMeta uses on the
 * wire: any people-role slot tagged `likely_pet` wins; if all people slots
 * agree on `likely_human` we surface that; otherwise the gate stays neutral
 * (`unknown`). This keeps the visible banner and the server prompt clause
 * reading from the same evidence (plan R17).
 */
function wsCategoryDetectionHint(){
  const slotsArr=Array.isArray(S.slots)?S.slots:[];
  const hasExtras=slotsArr.length>1;
  const aggCount=hasExtras?wsAggregatedPeopleFaceCount(slotsArr):S.faceCount;
  const aggStatus=hasExtras?(wsAggregatedDetStatus(slotsArr)||'unknown'):S.faceDetStatus;
  const subjectClass=hasExtras
    ?wsAggregatedPeopleSubjectClass(slotsArr)
    :wsNormaliseSubjectClass(S.subjectClass);
  // R-GOAL-4 / Phase 7 — thread classifier status so the huisdier
  // branch can distinguish "classifier pending" (don't fire ok_pet
  // yet) from "classifier resolved" (decide ok_pet vs inversion_human).
  // For single-photo we read directly off `S`; for multi-photo we
  // use the primary slot's status (the huisdier branch only fires on
  // single-photo / `slots.length <= 1` paths in wsResolveVisionMeta,
  // so the primary-slot status is the right signal). Defaults to
  // `null` when no primary slot exists yet — `wsCategoryHintFromState`
  // treats null + null as the legacy "pre-classifier" shape.
  const primarySlot=slotsArr.find(s=>s&&s.isPrimary);
  const subjectClassStatus=hasExtras
    ?(primarySlot?primarySlot.subjectClassStatus:null)
    :S.subjectClassStatus;
  // Phase 2 / Slice P2.D — aggregate the new aux signal with the same
  // policy as `wsResolveVisionMeta`: true iff ANY people-role slot fired
  // it (or the single-photo primary fired it). Pet-role slots are
  // ignored — those carry species declaration via `role:'pet'` and would
  // otherwise noisily flip the aggregate on every Bond upload. Mirrors
  // the wire visionMeta exactly so the banner and the server prompt
  // read from the same evidence (R17).
  const containsPetSubject=hasExtras
    ?slotsArr.some(s=>s&&s.role==='people'&&s.containsPetSubject===true)
    :S.containsPetSubject===true;
  return wsCategoryHintFromState({cat:S.cat,faceCount:aggCount,faceDetStatus:aggStatus,hasUpload:!!S.b64,subjectClass,subjectClassStatus,containsPetSubject});
}

/**
 * Renders `wsCategoryDetectionHint()` into the `#ws-detect-hint` banner above
 * the Generate button. Idempotent — safe to call from `updateGenerateButton()`
 * on every state change. Uses `textContent` (not `innerHTML`) so the i18n table
 * cannot smuggle markup into the page even if a future merchant override is
 * added. Records the most recent variant key into `S.hintShownKey` so the
 * generate POST can carry a `categoryHint.shown` field for ops dashboards
 * (researcher plan §13.B).
 */
function wsShouldShowBaroqueStyleNudge(){
  if(!S.b64||S.cat!=='huisdier')return false;
  if(S.baroqueNudgeDismissed)return false;
  if(wsNormalizeStyleKey(S.style)!=='royal')return false;
  if(S.subjectClass!=='likely_pet')return false;
  if(S.compositionMode==='mixed_single_photo'||wsSlotsBondComposition())return false;
  if(wsIsMultiAnimalShopperDeclared()&&(Number(S.shopperAnimalCount)||0)>=2)return false;
  return true;
}
function wsAcceptBaroqueStyleNudge(){
  S.style='baroque';
  S.baroqueNudgeDismissed=true;
  $$('.sty').forEach(x=>{
    x.classList.toggle('on',wsNormalizeStyleKey(x.dataset.s)==='baroque');
  });
  if(typeof wsRefreshScenePicker==='function')wsRefreshScenePicker();
  wsRecordFunnelEvent('style_nudge_accepted',{nudge_target:'baroque'});
  wsRenderBaroqueStyleNudge();
}
function wsRenderBaroqueStyleNudge(){
  const el=document.getElementById('ws-baroque-nudge');
  if(!el)return;
  while(el.firstChild)el.removeChild(el.firstChild);
  if(!wsShouldShowBaroqueStyleNudge()){
    el.hidden=true;
    return;
  }
  if(!el.dataset.wsNudgeLogged){
    wsRecordFunnelEvent('style_nudge_shown',{nudge_target:'baroque'});
    el.dataset.wsNudgeLogged='1';
  }
  el.hidden=false;
  el.setAttribute('data-variant','baroque_natural_coat');
  const body=document.createElement('div');
  body.className='ws-detect-hint__body';
  body.textContent=wsT('hint.baroque_nudge.body');
  el.appendChild(body);
  const act=document.createElement('div');
  act.className='ws-detect-hint__act';
  const btn=document.createElement('button');
  btn.type='button';
  btn.className='ws-detect-hint__btn ws-detect-hint__btn--primary';
  btn.textContent=wsT('hint.baroque_nudge.action');
  btn.onclick=()=>wsAcceptBaroqueStyleNudge();
  act.appendChild(btn);
  const dismiss=document.createElement('button');
  dismiss.type='button';
  dismiss.className='ws-detect-hint__keep';
  dismiss.textContent=wsT('hint.baroque_nudge.dismiss');
  dismiss.onclick=()=>{
    S.baroqueNudgeDismissed=true;
    el.hidden=true;
    wsRecordFunnelEvent('style_nudge_dismissed',{nudge_target:'baroque'});
  };
  act.appendChild(dismiss);
  el.appendChild(act);
}
function wsRenderCategoryHint(){
  const el=document.getElementById('ws-detect-hint');
  if(!el)return;
  if(wsIsCategoryInferEnabled()&&S.b64&&S.cat&&!wsCategoryInferNeedsChooserUI()){
    while(el.firstChild)el.removeChild(el.firstChild);
    el.hidden=true;
    el.removeAttribute('data-variant');
    el.classList.remove('ws-detect-hint--dismissed');
    S.hintShownKey=null;
    if(typeof wsRenderQualityHint==='function')wsRenderQualityHint();
    wsRenderBaroqueStyleNudge();
    return;
  }
  const h=wsCategoryDetectionHint();
  while(el.firstChild)el.removeChild(el.firstChild);
  if(!h){
    el.hidden=true;
    el.removeAttribute('data-variant');
    el.classList.remove('ws-detect-hint--dismissed');
    S.hintShownKey=null;
    if(typeof wsRenderQualityHint==='function')wsRenderQualityHint();
    wsRenderBaroqueStyleNudge();
    return;
  }
  // Clear the dismissed state whenever the banner *content* changes — otherwise
  // a shopper who clicked "Continue anyway" on `gezin+1` and then uploads a
  // different photo (e.g. `koppel+3`) would see the new banner copy with no
  // way to act on the new suggestion. Same-key re-renders preserve dismissal.
  // CAW.C — same staleness applies to `hintKeptAfterWarn`: if the banner key
  // changes we MUST reset the keptAfterWarn flag so the next POST does not
  // claim consent for a banner the shopper never saw.
  if(S.hintShownKey!==h.key){el.classList.remove('ws-detect-hint--dismissed');S.hintKeptAfterWarn=false;}
  el.hidden=false;
  el.setAttribute('data-variant',h.variant);
  S.hintShownKey=h.key;
  const body=document.createElement('div');
  body.className='ws-detect-hint__body';
  body.textContent=String(wsT(h.key)||'').replace(/\{0\}/g,String(h.count!=null?h.count:''));
  el.appendChild(body);
  if(h.adultNote){
    const note=document.createElement('div');
    note.className='ws-detect-hint__note';
    note.textContent=wsT('hint.detect.ok_kids_adult_note');
    el.appendChild(note);
  }
  // R-FEED-8a — count caveat for multi-figure people scenes. Short-range
  // BlazeFace at 128×128 inference resolution undercounts small faces
  // (infants, partial profiles, distant figures); the closed-set count
  // line was misleading the shopper into expecting the AI would only
  // paint the enumerated faces. The actual generation passes image bytes
  // to /v1/images/edits and renders every visible person. Caveat reads
  // as a separate `__note` line so existing CSS spacing applies.
  if(h.countCaveat){
    const cav=document.createElement('div');
    cav.className='ws-detect-hint__note';
    cav.textContent=wsT('hint.detect.count_caveat');
    el.appendChild(cav);
  }
  if(h.suggest||h.suggestSecondary||h.mixedBondAction){
    const act=document.createElement('div');
    act.className='ws-detect-hint__act';
    // Phase 2 / Slice P2.D — optional legacy bond CTA when `mixedBondAction`
    // is true (today unused by `wsCategoryHintFromState`; kept for harness /
    // merchant forks). Storefront default: implicit bond on Generate.
    if(h.mixedBondAction){
      const bond=document.createElement('button');
      bond.type='button';
      bond.className='ws-detect-hint__btn ws-detect-hint__btn--primary';
      bond.textContent=wsT('hint.detect.action_mixed_bond');
      bond.onclick=()=>wsAcceptMixedSubjectBond();
      act.appendChild(bond);
    }
    if(h.suggest){
      const btn=document.createElement('button');
      btn.type='button';
      btn.className='ws-detect-hint__btn';
      btn.textContent=wsT('hint.detect.suggest_'+h.suggest);
      btn.onclick=()=>wsSwitchCategoryFromHint(h.suggest,h.category);
      act.appendChild(btn);
    }
    if(h.suggestSecondary){
      const btn2=document.createElement('button');
      btn2.type='button';
      btn2.className='ws-detect-hint__btn ws-detect-hint__btn--secondary';
      btn2.textContent=wsT('hint.detect.suggest_'+h.suggestSecondary);
      btn2.onclick=()=>wsSwitchCategoryFromHint(h.suggestSecondary,h.category);
      act.appendChild(btn2);
    }
    /* R-MIX8 inversion_human + mismatch_mixed_subject + HALL-1 mismatch_pet:
       no "Continue anyway" — Generate is the passive-consent path; implicit
       mixed_single_photo on POST pairs with categoryHint.accepted (same bucket
       as Include both). Switch CTAs remain where the variant suggests another
       category. Pet-on-people must not POST with human self-portrait stack. */
    if(h.variant!=='inversion_human'&&h.variant!=='mismatch_mixed_subject'&&h.variant!=='mismatch_pet'){
      const keep=document.createElement('button');
      keep.type='button';
      keep.className='ws-detect-hint__keep';
      keep.textContent=wsT('hint.detect.keep');
      keep.setAttribute('aria-label',wsT('hint.detect.keep_aria'));
      keep.onclick=()=>{
        S.hintKeptAfterWarn=true;
        el.classList.add('ws-detect-hint--dismissed');
      };
      act.appendChild(keep);
    }
    el.appendChild(act);
  }
  // Slice B.3: piggyback the scene-picker refresh on every soft-gate render so
  // the picker visibility/eligibility stays in lock-step with the resolved
  // face count + category. Same cadence as `wsRefreshAddPhotoCta`.
  if(typeof wsRefreshScenePicker==='function')wsRefreshScenePicker();
  // Phase 3 / Slice P3.B (R-FAB6) — also refresh the quality hint on the
  // same update cycle. Quality hint is independent of category hint
  // (different DOM node, different concern) but shares the same upstream
  // signals (faceDet + classifier + quality promises) so a single render
  // entry-point keeps them in lockstep.
  if(typeof wsRenderQualityHint==='function')wsRenderQualityHint();
  wsRenderBaroqueStyleNudge();
}

/**
 * One-click category swap from the hint banner. Mirrors the existing pill-
 * onclick state effects (clear other `.on`, set `S.cat`, drop `petName` for
 * non-`huisdier`) but deliberately avoids `.click()` on the pill: the pill
 * onclick wrapper at step-1 advances the wizard, which would be wrong here
 * (the shopper is on step 3 by the time detection has settled).
 */
function wsSwitchCategoryFromHint(slug,fromCat){
  if(!slug||slug===fromCat)return false;
  const target=document.querySelector('.pill[data-c="'+slug+'"]');
  if(!target)return false;
  document.querySelectorAll('.pill').forEach(x=>x.classList.remove('on'));
  target.classList.add('on');
  if(slug==='koppel'&&(fromCat==='gezin'||fromCat==='kind')){
    const r=S.royalSceneTemplate;
    if(r==='noble_lineage'||r==='court_of_equals'||r==='royal_heir_baby_prince'||r==='royal_heir_baby_princess')S.royalSceneExplicitPick=true;
  }
  S.cat=slug;
  if(wsShouldClearPetNameOnCategoryLeave(slug))S.petName='';
  S.hintAccepted=true;
  if(typeof updateGenerateButton==='function')updateGenerateButton();
  else if(typeof upd==='function')upd();
  return true;
}

function wsAutoRouteHumanOnPetsBeforeGenerate(){
  const h=wsCategoryDetectionHint();
  if(!h||h.variant!=='inversion_human'||!h.suggest)return false;
  if(S.catManualHuisdier===true)return false;
  const from=S.cat;
  if(!wsSwitchCategoryFromHint(h.suggest,h.category||from))return false;
  if(S.cat===from)return false;
  S.catAutoRouted=true;
  S.catManualHuisdier=false;
  S.hintAccepted=true;
  S.hintKeptAfterWarn=false;
  if(typeof wsRecordFunnelEvent==='function')wsRecordFunnelEvent('category_auto_routed',{from,to:S.cat,reason:h.variant});
  if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();
  return true;
}

/** HALL-1 — symmetric auto-route: pet photo on people category → Pets. */
function wsAutoRoutePetOnPeopleBeforeGenerate(){
  const h=wsCategoryDetectionHint();
  if(!h||h.variant!=='mismatch_pet'||!h.suggest)return false;
  const from=S.cat;
  if(!wsSwitchCategoryFromHint(h.suggest,h.category||from))return false;
  if(S.cat===from)return false;
  S.catAutoRouted=true;
  S.hintAccepted=true;
  S.hintKeptAfterWarn=false;
  if(typeof wsRecordFunnelEvent==='function')wsRecordFunnelEvent('category_auto_routed',{from,to:S.cat,reason:h.variant});
  if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();
  return true;
}

/**
 * R-AI-ONLY — broad silent category auto-route removed. Generate-time
 * corrections only: human-on-Pets → Self, pet-on-people → Pets.
 */
function wsAutoRouteCategoryFromDetection(){}

/**
 * Phase 2 / Slice P2.D — "Include both" action from the mixed-subject banner
 * (R-MIX2 / R-MIX3). The shopper has a single photo with both a person AND
 * a pet, picked a people category, and chose to include both subjects rather
 * than dropping the pet (current default) or swapping to a different category.
 *
 * Effect:
 *   - Sets `S.compositionMode = 'mixed_single_photo'` so the generate POST
 *     forwards the new wire field. Server (slice P2.E) reads this and
 *     routes to the dual-subject royal recipe + MIXED-SUBJECT GUARD so
 *     the cat is preserved alongside the person.
 *   - Marks `S.hintAccepted = true` so the server-side TRUTH-IN-REFERENCE
 *     GUARD (slice P2.B) does NOT also fire. The shopper acted on the
 *     warning; they did not ignore it. Without this, the model would
 *     receive contradictory instructions (dual-subject recipe + truth
 *     guard saying "render only what is in the photo").
 *   - Stays on the original category (Self-portrait, Couple, Family,
 *     Children) — the chosen category still drives styling and framing.
 *   - Dismisses the banner so the shopper sees the action took effect
 *     (matches the dismiss semantics of the Keep button).
 *
 * Defensive: if the document is unavailable (test harness), only the
 * state mutations run — the banner DOM update is a no-op. Same shape as
 * `wsSwitchCategoryFromHint` for testability.
 */
function wsAcceptMixedSubjectBond(){
  S.compositionMode='mixed_single_photo';
  S.hintAccepted=true;
  if(typeof document!=='undefined'&&document.getElementById){
    const el=document.getElementById('ws-detect-hint');
    if(el)el.classList.add('ws-detect-hint--dismissed');
  }
  if(typeof updateGenerateButton==='function')updateGenerateButton();
  else if(typeof upd==='function')upd();
}

/**
 * Phase 3 / Slice P3.B (R-FAB6) — pure decision helper. Picks ONE quality
 * hint variant from the canonical reason set (`WS_QUALITY_REASONS`),
 * priority-ordered, so the banner shows the most actionable issue first
 * rather than dumping all reasons on the shopper.
 *
 * Priority (most → least actionable):
 *   1. too_blurry      — hardest to recover from; re-shoot is the only fix.
 *   2. too_dark        — easy fix (window light, lamp).
 *   3. too_bright      — easy fix (avoid direct sun, indoor light).
 *   4. face_too_small  — re-frame closer; valuable identity signal recovery.
 *   5. too_low_res     — re-shoot at higher resolution OR upload original.
 *
 * Returns `{key, primaryReason, allReasons}` or `null`. `null` means the
 * banner should NOT show (no upload, no quality scan, or scan came back
 * clean). Tested in `app-proxy/quality-hint.test.js`.
 */
const WS_QUALITY_HINT_PRIORITY=Object.freeze(['too_blurry','too_dark','too_bright','face_too_small','too_low_res']);
function wsQualityHintFromState(state){
  const hasUpload=!!(state&&state.hasUpload);
  if(!hasUpload)return null;
  const reasons=Array.isArray(state&&state.qualityReasons)?state.qualityReasons:null;
  if(!reasons||reasons.length===0)return null;
  const reasonSet=new Set(reasons.filter(r=>typeof r==='string'));
  let primary=null;
  for(const r of WS_QUALITY_HINT_PRIORITY){
    if(reasonSet.has(r)){primary=r;break;}
  }
  if(!primary)return null;
  return{
    primaryReason:primary,
    allReasons:Array.from(reasonSet),
    key:'quality.hint.'+primary,
  };
}

/**
 * Phase 3 / Slice P3.B (R-FAB6) — live-state wrapper. Reads from `S` (or the
 * aggregated multi-photo equivalents). Mirrors the wire-aggregation rules
 * from `wsResolveVisionMeta` so the banner and the wire visionMeta read
 * from the same evidence (R17 evidence-symmetry):
 *   - Multi-photo: union of `qualityReasons` across uploaded slots with
 *     computed quality (people + pet; **`face_too_small` omitted on pet-role**
 *     at slot level so BlazeFace bbox does not size mammals).
 *   - Single-photo: mirrors `S.qualityReasons` (set by the primary slot
 *     when its qualityPromise resolved).
 */
function wsQualityDetectionHint(){
  const slotsArr=Array.isArray(S.slots)?S.slots:[];
  const hasExtras=slotsArr.length>1;
  let aggReasons=null;
  if(hasExtras){
    const reasonSet=new Set();
    for(const s of slotsArr){
      if(!s)continue;
      if(!Array.isArray(s.qualityReasons)||s.qualityReasons.length===0)continue;
      for(const r of s.qualityReasons){if(typeof r==='string')reasonSet.add(r);}
    }
    if(reasonSet.size>0)aggReasons=Array.from(reasonSet);
  }else{
    aggReasons=Array.isArray(S.qualityReasons)?S.qualityReasons:null;
  }
  return wsQualityHintFromState({hasUpload:!!S.b64,qualityReasons:aggReasons});
}

/**
 * Phase 3 / Slice P3.B (R-FAB6) — DOM render of the quality hint banner.
 * Renders into `<div id="ws-quality-hint">` (separate DOM node from
 * `ws-detect-hint` so quality + category banners can show independently).
 * Idempotent — safe to call from `wsRenderCategoryHint` on every state
 * change. Uses `textContent` to keep the same XSS-safe contract as the
 * category hint render.
 *
 * The banner offers ONE action — "Use a different photo" — which wires to
 * the existing #fileIn picker (single-photo flow) or the primary slot
 * remove handler (multi-photo flow). Dismissable via a Keep button so the
 * shopper can override and proceed; a dismissed banner re-appears on a new
 * upload (different qualityReasons → different content key → dismissal
 * cleared, mirrors the `wsRenderCategoryHint` dismissal contract).
 */
function wsSyncUploadTipsPanel(){
  const aside=
    typeof document!=='undefined'&&document.querySelector
      ?document.querySelector('#wallstraight-generator aside.ws-upload-tips')
      :null;
  if(!aside)return;
  aside.hidden=wsQualityDetectionHint()===null;
}
function wsRenderQualityHint(){
  const el=typeof document!=='undefined'&&document.getElementById?document.getElementById('ws-quality-hint'):null;
  if(!el){
    if(typeof wsSyncUploadTipsPanel==='function')wsSyncUploadTipsPanel();
    return;
  }
  const h=wsQualityDetectionHint();
  while(el.firstChild)el.removeChild(el.firstChild);
  if(!h){
    el.hidden=true;
    el.removeAttribute('data-variant');
    el.classList.remove('ws-quality-hint--dismissed');
    S.qualityHintShownKey=null;
    if(typeof wsSyncUploadTipsPanel==='function')wsSyncUploadTipsPanel();
    return;
  }
  if(S.qualityHintShownKey!==h.key)el.classList.remove('ws-quality-hint--dismissed');
  el.hidden=false;
  el.setAttribute('data-variant',h.primaryReason);
  S.qualityHintShownKey=h.key;
  const body=document.createElement('div');
  body.className='ws-quality-hint__body';
  body.textContent=String(wsT(h.key)||'');
  el.appendChild(body);
  const act=document.createElement('div');
  act.className='ws-quality-hint__act';
  const reupload=document.createElement('button');
  reupload.type='button';
  reupload.className='ws-quality-hint__btn ws-quality-hint__btn--primary';
  reupload.textContent=wsT('quality.hint.action_reupload');
  reupload.onclick=()=>{
    wsOpenPrimaryUploadPicker();
  };
  act.appendChild(reupload);
  const keep=document.createElement('button');
  keep.type='button';
  keep.className='ws-quality-hint__keep';
  keep.textContent=wsT('quality.hint.keep');
  keep.onclick=()=>el.classList.add('ws-quality-hint--dismissed');
  act.appendChild(keep);
  el.appendChild(act);
  if(typeof wsSyncUploadTipsPanel==='function')wsSyncUploadTipsPanel();
}

/** Style slug normalization map. Canonical keys: royal, baroque, watercolor,
 *  popart, anime, nordic, lineart. Legacy aliases: renaissance→royal,
 *  belle/oil→watercolor, modern→popart, midsummer→nordic.
 *
 *  Baroque Slice 1 (2026-05-23) — removed `baroque:'royal'` legacy alias.
 *  Baroque is now a canonical own-recipe style with its own `PROMPT_BODY`
 *  branch. Stale storefront bookmarks / cart copy carrying `baroque` will
 *  pass through unchanged via the `baroque:'baroque'` self-mapping below
 *  rather than silently routing to royal regalia. */
const WS_LEGACY_STYLE_MAP={
  renaissance:'royal',belle:'watercolor',oil:'watercolor',modern:'popart',
  royal:'royal',baroque:'baroque',watercolor:'watercolor',popart:'popart',anime:'anime',midsummer:'nordic',nordic:'nordic',
  lineart:'lineart',superhero:'superhero',vintage_fashion:'vintage_fashion',world_cup_football:'world_cup_football',
  wk_panini_held:'wk_panini_held',wk_stadionlegende:'wk_stadionlegende',wk_vintage_poster:'wk_vintage_poster',wk_mancave_portret:'wk_mancave_portret',
  'wk-panini-held':'wk_panini_held','wk-stadionlegende':'wk_stadionlegende','wk-vintage-poster':'wk_vintage_poster','wk-mancave-portret':'wk_mancave_portret',
};
function wsNormalizeStyleKey(st){
  const k=String(st||'').trim().toLowerCase();
  if(!k)return'royal';
  return WS_LEGACY_STYLE_MAP[k]||k;
}

/** Push restored preview style into visible `.sty` tiles + radio inputs (inverse of wsSyncStyleAndCategoryFromDom). */
function wsApplyStyleToDom(styleKey){
  const st=wsNormalizeStyleKey(styleKey);
  S.style=st;
  const scope=document.getElementById('wallstraight-generator')||document;
  scope.querySelectorAll('.sty').forEach(el=>{
    const inp=el.querySelector('input[type="radio"]');
    const raw=(el.dataset&&el.dataset.s)||(inp&&inp.value)||'';
    const match=wsNormalizeStyleKey(raw)===st;
    el.classList.toggle('on',match);
    if(inp)inp.checked=match;
  });
  if(typeof wsRefreshScenePicker==='function')wsRefreshScenePicker();
}

/** Align S.style / S.cat with visible `.sty.on` + checked radio and `.pill.on` before POST (avoids stale state). */
function wsSyncStyleAndCategoryFromDom(){
  const scope=document.getElementById('wallstraight-generator')||document;
  let checked=null;
  let onTile=null;
  if(wsIsWkOranjeMode()){
    const wkGrid=scope.querySelector('#wkOranjeStyleGrid');
    if(wkGrid){
      checked=wkGrid.querySelector('input[name="s"]:checked');
      onTile=wkGrid.querySelector('.sty.on');
    }
  }
  if(!checked)checked=scope.querySelector('input[name="s"]:checked');
  if(!onTile)onTile=scope.querySelector('.sty.on');
  const stRaw=(checked&&checked.value)||(onTile&&onTile.dataset&&onTile.dataset.s)||null;
  if(stRaw){
    S.style=wsNormalizeStyleKey(stRaw);
    scope.querySelectorAll('.sty').forEach(el=>{
      const inp=el.querySelector('input[type="radio"]');
      if(!inp)return;
      const match=wsNormalizeStyleKey(inp.value)===S.style;
      el.classList.toggle('on',match);
      inp.checked=match;
    });
  }else{
    S.style=null;
    scope.querySelectorAll('.sty').forEach(el=>{
      el.classList.remove('on');
      const inp=el.querySelector('input[type="radio"]');
      if(inp)inp.checked=false;
    });
  }
  const pill=scope.querySelector('.pill.on');
  if(pill&&pill.dataset&&pill.dataset.c)S.cat=pill.dataset.c;
  else S.cat=null;
}

function wsApplyStyleTiles(){
  const lang=wsGetLang();
  const lab=WS_STYLE_LABELS[lang]||WS_STYLE_LABELS.en||WS_STYLE_LABELS.nl;
  const scope=document.getElementById('wallstraight-generator')||document;
  scope.querySelectorAll('.stl-g .sty[data-s]').forEach(el=>{
    const s=el.dataset.s;
    const row=lab[s];
    if(!row)return;
    const nm=el.querySelector('.nm'),desc=el.querySelector('.desc');
    if(nm)nm.textContent=row.nm;
    if(desc)desc.textContent=row.desc;
  });
}
function wsStyleName(styleKey){
  const k=wsNormalizeStyleKey(styleKey);
  const wkI18n={
    wk_panini_held:'wk.oranje.style.panini',
    wk_stadionlegende:'wk.oranje.style.stadion',
    wk_vintage_poster:'wk.oranje.style.vintage',
    wk_mancave_portret:'wk.oranje.style.mancave',
  };
  if(wkI18n[k]){
    const t=wsT(wkI18n[k]);
    if(t)return t;
  }
  const lang=wsGetLang();
  const row=(WS_STYLE_LABELS[lang]&&WS_STYLE_LABELS[lang][k])||WS_STYLE_LABELS.en[k]||WS_STYLE_LABELS.nl[k];
  return row?row.nm:'';
}
function wsApplyStyPlaceholders(l){
  const lab=WS_STYLE_LABELS[l]||WS_STYLE_LABELS.en||WS_STYLE_LABELS.nl;
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap)return;
  wrap.querySelectorAll('[data-i18n-sty]').forEach(el=>{
    const raw=el.getAttribute('data-i18n-sty');
    const k=wsNormalizeStyleKey(raw||'');
    const row=lab[k];
    if(row)el.textContent=row.nm;
  });
}
function wsApplyUiLang(lang){
  const l=(lang==='en'||lang==='el'||lang==='nl'||lang==='es'||lang==='it')?lang:'nl';
  try{localStorage.setItem(WS_LANG_STORAGE_KEY,l);}catch(_){}
  document.documentElement.setAttribute('lang',(l==='en'||l==='el'||l==='es'||l==='it')?l:'nl');
  const wrap=document.getElementById('wallstraight-generator');
  if(wrap){
    wrap.querySelectorAll('[data-i18n]').forEach(el=>{
      const k=el.getAttribute('data-i18n');
      if(!k)return;
      if(el.id==='wsWkCountdown'||el.id==='wsWkCountdownDays')return;
      el.textContent=wsT(k);
    });
    wrap.querySelectorAll('[data-i18n-placeholder]').forEach(el=>{
      const k=el.getAttribute('data-i18n-placeholder');
      if(!k)return;
      if('placeholder'in el)el.placeholder=wsT(k);
    });
    wrap.querySelectorAll('[data-i18n-aria-label]').forEach(el=>{
      const k=el.getAttribute('data-i18n-aria-label');
      if(!k)return;
      el.setAttribute('aria-label',wsT(k));
    });
    wrap.querySelectorAll('[data-i18n-alt]').forEach(el=>{
      const k=el.getAttribute('data-i18n-alt');
      if(!k)return;
      el.setAttribute('alt',wsT(k));
    });
    wsSyncHeroH1A11y(l);
    wsApplyCheckoutTrust();
  }
  wsApplyCartSuccessDialogI18n();
  wsApplyCartDrawerI18n();
  wsSyncResCartFabHref();
  const closeBtns=['retryClose','petNameClose','welcomeOfferClose','studioRecoveryClose'];
  const closeLbl=String(wsT('modal.close')||'').trim();
  if(closeLbl){
    closeBtns.forEach(id=>{const b=document.getElementById(id);if(b)b.setAttribute('aria-label',closeLbl);});
  }
  wsApplyStyPlaceholders(l);
  document.querySelectorAll('.ws-lang-btn').forEach(b=>{
    const on=b.getAttribute('data-ws-lang')===l;
    b.classList.toggle('is-active',on);
    b.setAttribute('aria-pressed',on?'true':'false');
  });
  document.querySelectorAll('.ws-lang-select').forEach(sel=>{
    if(sel&&sel.tagName==='SELECT'){
      const val=(l==='en'||l==='es'||l==='it')?l:'nl';
      if(sel.value!==val)sel.value=val;
    }
  });
  wsApplyStyleTiles();
  const ls=$('#ldSubtitle');
  if(ls)ls.textContent=wsT('loader.sub');
  if(ldEl&&ldEl.classList.contains('show')&&ldMsg){
    if(loaderPollRealMode&&loaderPollLastPayload){
      wsApplyServerPollProgress(loaderPollLastPayload);
    }
    if(loaderStatusMode==='hold'){
      wsLoaderClearPart4MessageSwapState(ldMsg);
      wsLoaderPart4RefreshHoldSubFromState(ldMsg);
    }else if(loaderStatusMode==='seven'){
      ldMsg.removeAttribute('role');
      ldMsg.classList.remove('ld-msg--hold-split');
      ldMsg.textContent=wsT(wsLoaderStatusLineKey(loaderSevenLineIdx));
    }
  }else if(loaderPollRealMode&&loaderPollLastPayload){
    wsApplyServerPollProgress(loaderPollLastPayload);
  }
  if(typeof updateGenerateButton==='function')updateGenerateButton();
  const rt=$('#resTag'),rp=$('#resPage');
  if(rt&&rp&&rp.classList.contains('show')&&typeof S!=='undefined'&&S.style)rt.textContent=wsStyleName(S.style);
  wsRefreshPreviewBranding();
  wsRefreshOpenFaqPanels();
  wsWelcomeOfferSyncMerchantCopy();
  wsStudioRecoverySyncMerchantCopy();
  if(typeof wsRefreshUploadReviewDotAria==='function')wsRefreshUploadReviewDotAria();
  if(typeof wsRefreshWizardChoiceSummary==='function')wsRefreshWizardChoiceSummary();
  if(typeof wsMaatkeuzeRefreshAllCartBtns==='function')wsMaatkeuzeRefreshAllCartBtns();
  /* Finishing cards (eyebrow, geen, paid labels, total) are innerHTML-built — not
   * [data-i18n] — so re-render whenever locale changes (Weglot + .ws-lang-btn). */
  if(typeof wsFinishingInitAll==='function')wsFinishingInitAll();
  if(wsIsWkOranjeMode())wsInitWkCountdown();
}
function wsRefreshOpenFaqPanels(){
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap)return;
  wrap.querySelectorAll('.faq-i.open .faq-a').forEach(a=>{
    a.style.maxHeight=a.scrollHeight+'px';
  });
}

// Pills
$$('.pill').forEach(p=>p.onclick=()=>{$$('.pill').forEach(x=>x.classList.remove('on'));p.classList.add('on');const prevCat=S.cat;const nextCat=p.dataset.c;if(nextCat==='koppel'&&(prevCat==='gezin'||prevCat==='kind')){const r=S.royalSceneTemplate;if(r==='noble_lineage'||r==='court_of_equals'||r==='royal_heir_baby_prince'||r==='royal_heir_baby_princess')S.royalSceneExplicitPick=true;}S.cat=nextCat;if(nextCat!=='huisdier')S.petName='';if(typeof wsRefreshAddPhotoCta==='function')wsRefreshAddPhotoCta();if(typeof wsRefreshScenePicker==='function')wsRefreshScenePicker();});
$$('.sty').forEach(s=>s.onclick=()=>{$$('.sty').forEach(x=>x.classList.remove('on'));s.classList.add('on');S.style=wsNormalizeStyleKey(s.dataset.s);try{wsRecordFunnelEvent('style_card_selected',{style:S.style,layout:(window.__WS_AB__&&window.__WS_AB__.styleCardLayout)||'images_always'});}catch(_){}if(typeof wsRefreshScenePicker==='function')wsRefreshScenePicker();});

// File — raw FileReader upload (unchanged wire from pre–JPEG-recovery work).
// SOS / progressive JPEG fixes live on the worker (`rasterToSquarePng` failOn none), not here.
// Client canvas re-encode was removed: it caused image_too_large and file_read regressions.
function wsReadUploadAsDataUrl(file){
  return new Promise((resolve,reject)=>{
    const r=new FileReader();
    r.onload=e=>resolve(String(e.target.result||''));
    r.onerror=()=>reject(new Error('read_failed'));
    r.readAsDataURL(file);
  });
}
async function wsLoadUploadFile(file,onLoaded){
  let funnelEpoch=null;try{funnelEpoch=window.wsFunnelAnalytics?.capture()??null;}catch(_){}
  hideErr();
  try{
    const dataUrl=await wsReadUploadAsDataUrl(file);
    const b64=String(dataUrl.split(',')[1]||'');
    if(!b64){try{window.wsFunnelAnalytics?.record('upload_rejected',{reason:'invalid_file'},funnelEpoch);}catch(_){}showErr(wsT('err.file_read'));return;}
    onLoaded(file,dataUrl,b64,funnelEpoch);
  }catch(_e){
    try{window.wsFunnelAnalytics?.record('upload_rejected',{reason:'invalid_file'},funnelEpoch);}catch(_){}
    showErr(wsT('err.file_read'));
  }
}
function wsApplyPrimaryUpload(file,dataUrl,b64,funnelEpoch){
    S._wsFunnelAttemptPending=false;
    try{window.wsFunnelAnalytics?.cancelPreview();}catch(_){}
    if(prev)prev.src=dataUrl;
    if(uz)uz.classList.add('has');
    S.b64=b64;
    if(wsIsCategoryInferEnabled()){
      S.cat=null;
      const inferWrap=document.getElementById('wallstraight-generator');
      if(inferWrap)inferWrap.querySelectorAll('.pill').forEach(x=>x.classList.remove('on'));
    }
    S.previewClientAttempt=0;
    S.previewHistory=[];
    S.baroqueNudgeDismissed=false;
    const baroqueNudgeEl=document.getElementById('ws-baroque-nudge');
    if(baroqueNudgeEl)delete baroqueNudgeEl.dataset.wsNudgeLogged;
    S.faceCount=null;
    S.faceDetStatus='pending';
    S.faceDetScore=null;
    S.faceDetName=WS_AI_DETECTOR_NAME;
    S.faceDetCompletedAt=null;
    S.faceBoxes=null;
    S.faceDetPassStats=null;
    S.subjectClass=null;
    S.subjectClassStatus='pending';
    // Phase 2 / Slice P2.C — reset aux signal alongside subjectClass on every
    // new primary upload so a stale "yes" from a prior photo cannot leak.
    S.containsPetSubject=null;
    S.petClassifierMaxScore=null;
    // Phase 2 / Slice P2.D — every new primary upload resets the opt-in
    // composition flag too. The shopper has to re-accept the mixed-subject
    // banner for THIS upload (it might not even be a mixed-subject photo).
    S.compositionMode=null;
    S.aiVerifyPromise=null;S.aiVerifyResult=null;S.aiVerifyStatus=null;S.verifyCacheId=null;
    S.catAutoRouted=false;
    S.catManualHuisdier=false;
    S.catInferredFromAi=false;
    S.catInferenceConfidence=null;
    S.catInferenceReason=null;
    S.catInferenceNeedsConfirm=false;
    S.catInferenceChoices=null;
    S.catInferMixedFocusOpen=false;
    // Phase 3 / Slice P3.A — every new primary upload also resets the
    // photo-quality mirrors so a stale `too_dark` from a prior photo
    // cannot leak into the new submission. The mirror block in
    // wsCreateSlot rehydrates these when the new primary slot's
    // qualityPromise resolves.
    S.qualityScore=null;
    S.qualityReasons=null;
    // Phase 3 / Slice P3.B — also clear the dismissed-state tracker so
    // a fresh upload always re-renders the quality banner from scratch
    // (matches the hintShownKey reset for the category hint).
    S.qualityHintShownKey=null;
    // Multi-photo (Slice A.3) — when the primary changes, RESET the entire
    // slot stack and seed slot 0 from this upload. Mirroring is the simplest
    // way to keep single-photo semantics intact while making `S.slots` the
    // source of truth for multi-photo POSTs.
    const primaryRole=wsPrimarySlotRoleAtUpload();
    void wsStartAiSubjectVerify(b64,(file&&file.type)?file.type:'image/jpeg');
    const slot0=wsCreateSlot(file,dataUrl,b64,primaryRole,/*isPrimary=*/true);
    S.slots=[slot0];
    S.faceDetPromise=slot0.faceDetPromise||Promise.resolve();
    void (S.aiVerifyPromise||Promise.resolve()).then(()=>{upd();}).catch(()=>{upd();});
    // Phase 3 / Slice P3.B — also refresh once the quality scan settles so
    // the new ws-quality-hint banner can appear without waiting for the
    // shopper to interact with the form. Quality promise chains AFTER
    // faceDetPromise inside wsCreateSlot.
    if(slot0.qualityPromise)void slot0.qualityPromise.then(()=>upd()).catch(()=>upd());
    // R-GOAL-4 / Phase 7 (May 2026) — pre-Phase-7 pet-primary uploads
    // hardcoded `S.subjectClass='likely_pet'` + `faceDetStatus='skipped_pet'`
    // here, bypassing the classifier entirely and emitting `likely_pet` on
    // the wire even when the shopper uploaded humans to the Pet portrait
    // category. The wsCreateSlot pet-role early return that backed that
    // shortcut is gone — `slot0.faceDetPromise` + `slot0.subjectClassPromise`
    // now both run real MediaPipe inference (face count + ObjectDetector
    // classifier) and their .then(upd) chains above mirror the measured
    // verdict back onto S.* via the existing mirror blocks inside
    // wsCreateSlot. So this block is intentionally empty: S.* fields
    // start at their default `null` / `'pending'` initial values and
    // converge to the truthful pixel-evidence verdict as the promises
    // settle. The category banner stays neutral (no `ok_pet` flash)
    // until the classifier resolves — see `wsCategoryHintFromState`
    // huisdier branch updated in this slice.
    upd();
    wsRefreshAddPhotoCta();
    if(typeof wsRenderPhotoSlots==='function')wsRenderPhotoSlots();
    try{
      const fileType=(file&&file.type)?String(file.type):'';
      const fileSize=(file&&typeof file.size==='number')?file.size:0;
      wsRecordFunnelEvent('photo_uploaded',{file_type:fileType,file_size:fileSize,slot_count:Array.isArray(S.slots)?S.slots.length:1});
      window.wsFunnelAnalytics?.record('photo_uploaded',{style:S.style,category:S.cat,slotCount:Array.isArray(S.slots)?S.slots.length:1},funnelEpoch);
    }catch(_){/* telemetry must never affect upload */}
}
function handleFile(f){
  if(!f)return;
  if(f.size>10485760){try{window.wsFunnelAnalytics?.record('upload_rejected',{reason:'file_too_large'});}catch(_){}showErr(wsT('err.file_big'));return;}
  if(!f.type.match(/^image\/(jpeg|png|webp)$/)){try{window.wsFunnelAnalytics?.record('upload_rejected',{reason:'invalid_file'});}catch(_){}showErr(wsT('err.file_type'));return;}
  void wsLoadUploadFile(f,(file,dataUrl,b64,funnelEpoch)=>{
    S.file=file;
    wsApplyPrimaryUpload(file,dataUrl,b64,funnelEpoch);
  });
}
if(uz)uz.onclick=()=>{if(!uz.classList.contains('has'))fi&&fi.click();};
if(fi)fi.onchange=()=>{if(fi.files[0])handleFile(fi.files[0]);};
if(uz){uz.ondragover=e=>{e.preventDefault();uz.classList.add('drag');};uz.ondragleave=()=>uz.classList.remove('drag');uz.ondrop=e=>{e.preventDefault();uz.classList.remove('drag');if(e.dataTransfer.files[0])handleFile(e.dataTransfer.files[0]);};}
// Multi-photo (Slice A.3) — wire the additive "+ Add another photo" button.
// Click opens the hidden #fileInExtra picker; on change we append a slot.
const addPhotoBtnEl=document.getElementById('addPhotoBtn');
const fileInExtraEl=document.getElementById('fileInExtra');
if(addPhotoBtnEl&&fileInExtraEl){
  addPhotoBtnEl.addEventListener('click',()=>{fileInExtraEl.click();});
  fileInExtraEl.addEventListener('change',()=>{
    const f=fileInExtraEl.files&&fileInExtraEl.files[0];
    fileInExtraEl.value='';// reset so the same file can be re-picked after remove
    if(f)wsAddSlotFromFile(f);
  });
}
/**
 * Clear staged upload everywhere (preview, file input, state). Called when removing photo or restarting from step 1.
 *
 * Pet name (`S.petName`) — session-only (R4); not persisted in localStorage/sessionStorage (R3 full reload → empty `S`).
 * Cleared with this function when: Step 1 navigation / Start over / remove photo (R1–R2); also hide `#petNameModal` and clear `#petNameInput` so DOM matches `S`.
 * Category off `huisdier` and pet-name modal Skip clear `S.petName` in their own handlers; new primary upload does not clear the name unless product adds that rule.
 */
function wsClearUploadedPhoto(){
  S._wsFunnelAttemptPending=false;
  try{window.wsFunnelAnalytics?.cancelPreview();}catch(_){}
  S.file=null;S.b64=null;S.petName='';S.previewClientAttempt=0;S.previewHistory=[];S.baroqueNudgeDismissed=false;S.faceCount=null;
  S.faceDetStatus=null;S.faceDetScore=null;S.faceDetName=null;S.faceDetCompletedAt=null;S.faceDetPromise=null;S.faceBoxes=null;S.faceDetPassStats=null;
  S.subjectClass=null;S.subjectClassStatus=null;
  // Phase 2 / Slice P2.C — clear the aux signal when the user removes the
  // upload entirely (mirrors the subjectClass reset on the line above).
  S.containsPetSubject=null;
  S.petClassifierMaxScore=null;
  // Phase 2 / Slice P2.D — clear the opt-in composition flag too; a fresh
  // upload starts with no special composition mode.
  S.compositionMode=null;
  S.aiVerifyPromise=null;S.aiVerifyResult=null;S.aiVerifyStatus=null;S.verifyCacheId=null;
  S.catAutoRouted=false;
  S.catManualHuisdier=false;
  S.catInferredFromAi=false;
  S.catInferenceConfidence=null;
  S.catInferenceReason=null;
  S.catInferenceNeedsConfirm=false;
  S.catInferenceChoices=null;
  S.catInferMixedFocusOpen=false;
  if(wsIsCategoryInferEnabled()){
    S.cat=null;
    S.catInferredFromAi=false;
    const inferWrap=document.getElementById('wallstraight-generator');
    if(inferWrap)inferWrap.querySelectorAll('.pill').forEach(x=>x.classList.remove('on'));
  }
  // Phase 3 / Slice P3.A — clear photo-quality mirrors when the user
  // removes the upload entirely (mirrors the containsPetSubject reset).
  S.qualityScore=null;
  S.qualityReasons=null;
  // Phase 3 / Slice P3.B — clear the quality-banner dismissed-state too.
  S.qualityHintShownKey=null;
  S.hintShownKey=null;S.hintAccepted=false;S.hintKeptAfterWarn=false;
  // Multi-photo (Slice A.3) — clear the entire slot stack. Slot 0 (primary)
  // tracks the current upload; removing the primary collapses every extra too.
  S.slots=[];
  // Slice B.3 — reset scene template to default when the user starts over.
  S.royalSceneTemplate='noble_lineage';
  S.royalSceneExplicitPick=false;
  if(prev)prev.src='';
  if(uz)uz.classList.remove('has');
  if(fi)fi.value='';
  const fiX=document.getElementById('fileInExtra');if(fiX)fiX.value='';
  if(typeof wsRenderPhotoSlots==='function')wsRenderPhotoSlots();
  wsRefreshAddPhotoCta();
  if(typeof wsRefreshScenePicker==='function')wsRefreshScenePicker();
  const pm=$('#petNameModal'),pi=$('#petNameInput');
  if(pm)pm.classList.remove('show');
  if(pi)pi.value='';
}
const chgBtn=$('#chgBtn'), rmBtn=$('#rmBtn');
if(chgBtn&&fi)chgBtn.onclick=()=>fi.click();
if(rmBtn&&uz&&fi&&prev)rmBtn.onclick=()=>{wsClearUploadedPhoto();hideErr();upd();};

/**
 * Multi-photo (A1 Bond-extended) — Slice A.2 visibility controller.
 *
 * Show "+ Add another photo" CTA only when ALL of:
 *   • Feature flag ON (window.WS_FEATURE_MULTI_PHOTO from section setting).
 *   • Primary photo uploaded (S.b64 truthy).
 *   • Fewer than 2 extras already added (S.slots.length < 3 — slot 0 is primary).
 *   • Category is NOT pet-only (huisdier already runs single-photo with full count guards).
 *
 * Idempotent and safe to call from multiple hook points (handleFile success,
 * wsClearUploadedPhoto, pill click, wsAddSlotFromFile in A.3, wsRemoveSlot in A.3).
 * Pure DOM toggling — no state writes — so A.3 can extend without conflict.
 * R13: When the feature flag is on and a primary photo exists on a people
 * category, shows distinct-subjects guidance (#ws-multi-photo-notes: short line +
 * optional #ws-multi-photo-distinct-more details) so shoppers don't treat
 * multi-photo as duplicate selfies for likeness
 * (plan §§2b, R10–R14). Pet category (`huisdier`) keeps the strip hidden.
 *
 * @see Slice A.3 will add S.slots state + click/change wiring;
 *      Slice A.4 sends body.images to the server (transport already accepts it from A.1).
 */
function wsRefreshAddPhotoCta(){
  const btn=document.getElementById('addPhotoBtn');
  const grid=document.getElementById('ws-photo-slots');
  if(!btn||!grid)return;
  const flagOn=window.WS_FEATURE_MULTI_PHOTO===true;
  const hasPrimary=!!(S&&S.b64);
  const slotsArr=(S&&Array.isArray(S.slots))?S.slots:[];
  const totalCount=hasPrimary?Math.max(1,slotsArr.length):0;
  const extrasCount=Math.max(0,totalCount-1);
  const catBlocks=(S&&S.cat==='huisdier');
  const inferSoloComposer=wsIsCategoryInferEnabled()
    &&!(S.cat==='gezin'||S.cat==='koppel'||S.cat==='kind');
  const showBtn=flagOn&&hasPrimary&&!catBlocks&&extrasCount<2&&!inferSoloComposer;
  btn.hidden=!showBtn;
  // Grid is visible only when at least one extra slot exists. A.3 populates it.
  grid.hidden=!(flagOn&&extrasCount>0);
  const notesWrap=document.getElementById('ws-multi-photo-notes');
  const distNote=document.getElementById('ws-multi-photo-distinct-note');
  const distMore=document.getElementById('ws-multi-photo-distinct-more');
  if(notesWrap&&distNote){
    const showDistinct=flagOn&&hasPrimary&&!catBlocks&&!inferSoloComposer;
    distNote.hidden=!showDistinct;
    notesWrap.hidden=!showDistinct;
    if(distMore)distMore.hidden=!showDistinct;
  }
}

/**
 * Slice B.3 — Royal scene-template picker visibility & per-option enablement.
 *
 * Eligibility mirrors the server-side `royalSceneAugmentClause` (Slice B.2)
 * exactly so the UI never offers a template the server will silently drop:
 *
 *   • Picker is visible only when canonical style === "royal" AND a face count
 *     was confidently resolved (status === "ok" AND N >= 2).
 *   • `noble_lineage` & `court_of_equals` enabled when category ∈ { gezin,
 *     kind+N≥3 }, or when category === "koppel" AND N === 2 (parent+child etc.).
 *   • Heir presets (`royal_heir_*`) enabled when category === "gezin" AND N ∈
 *     { 2, 3 }, or when category === "koppel" AND N === 2 (same two-face slot
 *     as gezin+N=2; face detection does not assert infant age).
 *   • `royal_romance` & `monarchs_pair` enabled when category === "koppel" AND N === 2.
 *   • If the currently-selected template becomes ineligible (e.g. category or
 *     face-count change), we auto-promote to the first eligible option in
 *     `WS_ROYAL_TEMPLATES` order. For fresh koppel+N=2, the generic HTML default
 *     `noble_lineage` is coerced to `royal_romance` until the shopper picks
 *     explicitly or pivots from gezin/kind with lineage/court still selected.
 *
 * Called from style/category click handlers and after every detection promise
 * settles (mirrors `wsRenderCategoryHint` / `wsRefreshAddPhotoCta` cadence).
 *
 * R-PET-MULTI-5 / R-wizard-funnel-order invariant (auditable lock-in):
 *
 *   Storefront wizard order is **category (step 1) → style (step 2) → upload
 *   (step 3)**. The picker MUST NOT appear before a photo is uploaded.
 *   The `okStatus === 'ok'` gate (and the `aggStatus` aggregation below)
 *   guarantees this: BlazeFace `_wsFaceDetPromise` only resolves after the
 *   shopper uploads, so `aggStatus` is `null` / `'unknown'` pre-upload and
 *   every eligibility predicate evaluates to `false`. Do NOT introduce a
 *   pre-upload code path that surfaces `court_of_equals` (or any other
 *   scene_template slug) from a heuristic — the plan §1.i explicitly bans
 *   pre-upload auto-recommendation. See
 *   `docs/requirements-human-portraits.md § R-PET-MULTI-5`.
 */
// R-FEED-5 — single source of truth for the seven royal scene-template slugs
// the storefront knows about. Must stay in lockstep with:
//   • `ALLOWED_ROYAL_SCENE_TEMPLATES` in
//     wallstraight-app/app/lib/openai-image-edit.server.ts (server augment).
//   • `ALLOWED_SCENE_TEMPLATES_B4` in app-proxy/server.js (dev proxy
//     telemetry / lenient parser).
//   • The seven `data-template` slugs in
//     sections/wallstraight-generator.liquid.
// The order also determines the picker auto-promote priority when the
// previously-selected template becomes ineligible (see `wsRefreshScenePicker`).
const WS_ROYAL_TEMPLATES=Object.freeze([
  'noble_lineage',
  'court_of_equals',
  'royal_romance',
  'monarchs_pair',
  'royal_heir_baby_prince',
  'royal_heir_baby_princess',
  'royal_children_court'
]);
const WS_ROYAL_TEMPLATE_SET=new Set(WS_ROYAL_TEMPLATES);

function wsRefreshScenePicker(){
  const fs=document.getElementById('ws-scene-picker');
  if(!fs)return;
  const style=(S&&typeof wsNormalizeStyleKey==='function')?wsNormalizeStyleKey(S.style):S&&S.style;
  const styleOk=style==='royal';
  const cat=S&&S.cat;
  const slotsArr=(S&&Array.isArray(S.slots))?S.slots:[];
  const hasExtras=slotsArr.length>1;
  const aggCount=hasExtras?wsAggregatedPeopleFaceCount(slotsArr):S&&S.faceCount;
  const aggStatus=hasExtras?(wsAggregatedDetStatus(slotsArr)||'unknown'):S&&S.faceDetStatus;
  const okStatus=aggStatus==='ok';
  const n=(typeof aggCount==='number'&&Number.isFinite(aggCount))?aggCount:null;
  // Shape predicates strive to mirror the server's `royalSceneAugmentClause`;
  // koppel+N=2 soft-default + `royalSceneExplicitPick` are storefront UX only.
  const isFamilyShape=okStatus&&n!=null&&((cat==='gezin'&&n>=2)||(cat==='kind'&&n>=3));
  const isCoupleShape=okStatus&&cat==='koppel'&&n===2;
  const isMonarchPairShape=isCoupleShape;
  const isHeirInfantShape=okStatus&&n!=null&&(n===2||n===3)&&
    (cat==='gezin'||(cat==='koppel'&&n===2));
  const isManyHeirsShape=okStatus&&n!=null&&((cat==='gezin'&&n>=4)||(cat==='kind'&&n>=3));
  const eligibility={
    noble_lineage:isFamilyShape||isCoupleShape,
    court_of_equals:isFamilyShape||isCoupleShape,
    royal_romance:isCoupleShape,
    monarchs_pair:isMonarchPairShape,
    royal_heir_baby_prince:isHeirInfantShape,
    royal_heir_baby_princess:isHeirInfantShape,
    royal_children_court:isManyHeirsShape
  };
  const anyEligible=WS_ROYAL_TEMPLATES.some(t=>eligibility[t]);
  const showPicker=styleOk&&anyEligible;
  fs.hidden=!showPicker;
  if(!showPicker)return;
  // R-FEED-10 — detection-ranked recommendation without expanding the catalog.
  // We keep the existing seven lockstep templates and only mark the most
  // appropriate eligible option. This avoids UI clutter and avoids adding
  // prompt branches the server does not yet own.
  let recommended=null;
  if(isCoupleShape)recommended='royal_romance';
  else if(isManyHeirsShape)recommended='royal_children_court';
  else if(isFamilyShape)recommended='noble_lineage';

  // If currently-selected template is ineligible for the resolved scene,
  // auto-promote to the first eligible option in `WS_ROYAL_TEMPLATES` order.
  // The order is stable: lineage/court win for any family shape; romance
  // wins for couple shapes; new R-FEED-5 presets are last so a returning
  // shopper's classic selection is never silently overwritten.
  // Fresh koppel+N=2 defaults to romance so true couples are not silently
  // cast into a generational hierarchy; `royalSceneExplicitPick` + gezin/kind
  // pivot handling preserves lineage/court for parent+child on "Couple".
  if(isCoupleShape&&!S.royalSceneExplicitPick){
    const soft=S.royalSceneTemplate;
    if(soft==='noble_lineage'||soft==='court_of_equals')S.royalSceneTemplate='royal_romance';
  }
  let current=S.royalSceneTemplate||'noble_lineage';
  if(!eligibility[current]){
    current=WS_ROYAL_TEMPLATES.find(t=>eligibility[t])||'noble_lineage';
    S.royalSceneTemplate=current;
  }

  const opts=fs.querySelectorAll('.ws-scene-opt');
  opts.forEach(opt=>{
    const t=opt.getAttribute('data-template');
    const eligible=!!eligibility[t];
    const inp=opt.querySelector('input[type="radio"]');
    const rec=eligible&&t===recommended;
    if(eligible){
      opt.classList.remove('is-disabled');
      opt.removeAttribute('aria-disabled');
      if(inp)inp.disabled=false;
    }else{
      opt.classList.add('is-disabled');
      opt.setAttribute('aria-disabled','true');
      if(inp)inp.disabled=true;
    }
    opt.classList.toggle('is-recommended',rec);
    const sel=t===current&&eligible;
    opt.classList.toggle('is-selected',sel);
    if(inp)inp.checked=sel;
  });
}

/**
 * Slice B.3 — wire scene-picker option clicks (idempotent: safe to re-run).
 * Uses `change` on the radios + `click` on the label for keyboard + mouse.
 * Validates against `WS_ROYAL_TEMPLATE_SET` so a future template-name typo
 * in DOM/translation cannot silently leak into `S.royalSceneTemplate`.
 */
function wsBindScenePicker(){
  const fs=document.getElementById('ws-scene-picker');
  if(!fs||fs.dataset.wsBound==='1')return;
  fs.dataset.wsBound='1';
  fs.addEventListener('change',e=>{
    const tgt=e.target;
    if(!tgt||tgt.name!=='ws_scene_template'||!tgt.value)return;
    if(tgt.disabled)return;// belt+braces: disabled radios should not reach here
    if(!WS_ROYAL_TEMPLATE_SET.has(tgt.value))return;
    S.royalSceneExplicitPick=true;
    S.royalSceneTemplate=tgt.value;
    wsRefreshScenePicker();
  });
}

// Bind scene-picker once on module load. The initial render is hidden by
// default (no eligible state yet) and `wsRenderCategoryHint` re-runs it as
// soon as detection settles + a category is chosen.
wsBindScenePicker();

/**
 * R-FEED-2 — Optional first-run shopper notes binder. Idempotent. Mirrors
 * the lifecycle of `wsBindScenePicker`: bind once on module load, no
 * teardown needed. The textarea / counter / clear button are part of the
 * static section markup (`<details id="ws-notes">`), so a guard on
 * `dataset.wsBound` prevents double-binding if the section is ever
 * re-rendered (Shopify section rendering API).
 *
 * Behavior contract:
 *   • Input: `S.userNotes` mirrors the textarea value, trimmed to 200 chars
 *     (matches `maxlength` and the sanitizer / retry budget).
 *   • Counter: live char count to match the retry textarea pattern.
 *   • Clear: empties textarea + state + counter and keeps the disclosure
 *     open so the shopper can immediately start over.
 * Generation merge happens in `generate()` — this binder is purely the UI
 * surface; the prompt-stitch decision lives next to `wireExtraBeforePrompt`.
 */
function wsBindUserNotes(){
  const root=document.getElementById('ws-notes');
  if(!root||root.dataset.wsBound==='1')return;
  root.dataset.wsBound='1';
  const ta=document.getElementById('ws-notes-text');
  const count=document.getElementById('ws-notes-count');
  const clear=document.getElementById('ws-notes-clear');
  function sync(){
    const v=String(ta&&ta.value||'').slice(0,200);
    S.userNotes=v;
    if(count)count.textContent=String(v.length);
  }
  if(ta){
    ta.addEventListener('input',sync);
    // Guard against pre-fill from autofill / browser back-button restore;
    // we want `S.userNotes` to mirror DOM truth on load.
    sync();
  }
  if(clear){
    clear.addEventListener('click',()=>{
      if(ta)ta.value='';
      S.userNotes='';
      if(count)count.textContent='0';
      if(ta)ta.focus();
    });
  }
}
wsBindUserNotes();

const apiTog=$('#apiTog');
if(apiTog&&apiBox)apiTog.onclick=()=>apiBox.classList.toggle('open');
function upd(){
  if(typeof updateGenerateButton==='function'&&typeof currentStep==='number')updateGenerateButton();
  else if(genBtn){
    genBtn.hidden=!S.b64;
    genBtn.disabled=!S.b64||S.busy;
  }
}

// Loading — typographic progress only (no bar); dots + status are decorative / secondary
/** Minimum time each `wsLoaderMsgs()` line stays visible while p≤85 (paired with p thresholds). */
const WS_LOADER_EARLY_DWELL_MS=4000;
/** Late-phase `#ldMsg` rotation: craft then hold (quotes retired — halftone carries “tail” UX). See {@link wsLoaderLateStepDwellMs}. */
const WS_LOADER_LATE_BASE_MS=4000;
const WS_LOADER_LATE_STEP_COUNT=2;
/** Halftone card stays hidden until fake ≥ this (avoids flash at 85–88% while hold copy is pending). */
const WS_LOADER_HALFTONE_MIN_PCT=89;
function wsLoaderLateStepDwellMs(){
  return WS_LOADER_LATE_BASE_MS;
}
let ldT,ldStatusRotT,loaderLateStepIdx=0;
/** Set when the final late-step dwell has fired; prevents re-init while `ldStatusRotT` is idle. See {@link wsArmLateStepRotation}. */
let loaderLateSequenceComplete=false;
/** Last simulated % (for easing into 100% when the API returns). */
let loaderFakePctLast=0;
/** When true: async polling drives `#ldPct` / `#ldMsg` via server timestamps; faux % ticker is paused. */
let loaderPollRealMode=false;
/** SPEED-EARLY-POLL — first 202 while Part 3 seven-line rotator is active (or pending): enter Part 4 when Part 3 floor satisfied. */
let loaderPollSkipPart3Requested=false;
/** Wall-clock anchor for EARLY-POLL-REFINE Part 3 min floor ({@link wsLoaderStartSevenLineRotation}). */
let loaderPart3StartedAt=0;
/** Min Part 3 time before early-poll Part 4 handoff (lines 1–3 or ~18s). Rollback: `window.WS_EARLY_POLL_MIN_PART3=false`. */
const WS_EARLY_POLL_MIN_PART3_MS=18000;
/** Snapshot of last 202 payload so {@link wsApplyUiLang} can re-layer localized poll copy without waiting for the next poll tick. */
let loaderPollLastPayload=null;
/** Seven-line status rotator in `#ldMsg` (exclusive with legacy late-step quotes). */
let loaderSevenLineHandle=null;
let loaderSevenLineIdx=0;
/** `setInterval` toggling {@link WS_LD_ORB_MODE_TOGGLE_MS} / `ld--orb-mode-hold` during Part 3. */
let loaderOrbModeHandle=null;
/** `seven` | `hold` | `idle` — controls {@link #ldMsg} copy source ({@link wsLoaderStartSevenLineRotation}, {@link wsLoaderSetLdMsgRenderingHold}). */
let loaderStatusMode='idle';
const WS_ACTIVE_JOB_STORAGE_KEY='ws_active_job';
const WS_PART4_TICK_MS=500;
const WS_PART4_SUB_DELAY_MS_DEFAULT=5000;
const WS_PART4_EMAIL_DELAY_MS_DEFAULT=10000;
const WS_PART4_LONG_WAIT_MS_DEFAULT=30000;
const WS_PART4_PUNCHLINE_DELAY_MS_DEFAULT=20000;
const WS_PART4_SAFE_LEAVE_MS_DEFAULT=60000;
const WS_PART4_SUCCESS_DISMISS_MS_DEFAULT=5000;
const WS_PART3_POST_POLL_DWELL_MS=3000;
/** Part 3 seven-line rotator — pre-poll dwell per line (idx 0 = `loader.status.1`). */
const WS_PART3_LINE_EARLY_DWELL_MS=6000;
const WS_PART3_LINE_LATE_DWELL_MS=10000;
const WS_LOADER_RENDERING_SUB_VARIANT_COUNT=5;
const WS_PART4_PUNCHLINE_SEQ_KEY='ws_part4_punchline_seq_v1';
const WS_PART4_PUNCHLINE_PIN_KEY='ws_part4_punchline_pin_v1';
let wsLoaderPart4Epoch=0;
let wsLoaderPart4TickHandle=null;
let wsLoaderPart4SubRevealed=false;
let wsLoaderPart4TapCopyActive=false;
/** `hidden` | `patience` | `punchline` | `tap` — active Part 4 hold sub tier. */
let wsLoaderPart4SubTier='hidden';
/** 0-based punchline index for current Part 4 episode; cleared on stop, restored from session pin. */
let loaderRenderingHoldSubVariant=null;
const WS_LD_MSG_FADE_MS=220;
let wsLoaderMsgFadeToken=0;
/** Timeouts driving cinematic intro (hands + burst). */
let loaderIntroTimeouts=[];
let loaderIntroBurstFallbackId=null;
let loaderIntroPostBurstScheduled=false;
/** When `ld-cinematic--hands-out` was applied (for Part 2 sequential beat vs `.ld-cinematic__photo-shell` fade). */
let loaderIntroHandsOutAt=0;
/** Shard burst animation length matches `.ld-cinematic__shard` keyframes in ws-generator.css. */
const WS_LD_SHARD_ANIM_MS=850;
const WS_LD_SHARD_STAGGER_MS=26;
/** Extra beat after last shard so near-touch pose + particles read before cinematic hides. */
const WS_LD_POST_SHARD_LINGER_MS=220;
/** Part 2 — hero “Creating your masterpiece” dwell before crossfade to seven-line status. */
const WS_LD_CINEMA_HERO_DWELL_MS=3500;
/** Matches `.ld-cinematic__photo-shell { transition: opacity … }` in ws-generator.css — do not desync. */
const WS_LD_PHOTO_SHELL_FADE_MS=400;
/** Cinematic hand fade-out after burst — must match `.ld-cinematic__hand { … opacity … }` in ws-generator.css. */
const WS_LD_HANDS_FADE_MS=700;
/** When `window.WS_LOADER_FAST_CINEMATIC` skips burst: extra beat after `hands-in` transform settles before `wsLoaderIntroAfterBurst`. */
const WS_LD_FAST_INTRO_HANDS_DWELL_MS=220;
/** Allow transform transition to finish before final shell class swap. */
const WS_LD_CINEMA_STATUS_TO_DONE_MS=340;
/** Part 3 → Part 4: fade particle orb out before fullscreen + hold copy (must cover CSS orb `transition` + paint). */
const WS_LD_STATUS_ORB_FADE_MS=400;
/** Part 3: alternate particle modes (burst vs compact shell) — one full GgONKy `14s` cycle per mode. */
const WS_LD_ORB_MODE_TOGGLE_MS=14000;
/** Fake % at halftone reveal (`late_hold`); remap cover 0→1 from baseline→100 so intensity animates after deferral. */
let loaderHalftoneRevealBaselinePct=null;
/** Arm next advance from current `loaderLateStepIdx` after its dwell time. Stops after hold (no quotes). */
function wsArmLateStepRotation(){
  if(ldStatusRotT){clearTimeout(ldStatusRotT);ldStatusRotT=undefined;}
  const advance=()=>{
    ldStatusRotT=undefined;
    if(loaderLateStepIdx===WS_LOADER_LATE_STEP_COUNT-1){
      loaderLateSequenceComplete=true;
      return;
    }
    loaderLateStepIdx++;
    if(ldMsg){
      ldMsg.textContent=wsLoaderLateStepContent(loaderLateStepIdx);
      wsSyncLoaderMsgVisuals(loaderLateStepIdx);
    }
    if(loaderLateStepIdx===1)wsRevealLoaderHalftoneForHoldStep();
    wsArmLateStepRotation();
  };
  ldStatusRotT=setTimeout(advance,wsLoaderLateStepDwellMs());
}
function wsResetLateLoaderExtras(){
  if(ldStatusRotT){clearTimeout(ldStatusRotT);ldStatusRotT=undefined;}
  loaderLateSequenceComplete=false;
  loaderLateStepIdx=0;
  const m=document.getElementById('ldMsg');
  if(m){
    m.removeAttribute('role');
    m.classList.remove('ld-msg--quote','ld-msg--hold','ld-msg--hold-split');
  }
  const late=document.getElementById('ldLate'),hold=document.getElementById('ldHold'),q1=document.getElementById('ldQuote1'),q2=document.getElementById('ldQuote2');
  if(late){
    late.hidden=true;
    if(hold)hold.textContent='';
    if(q1)q1.textContent='';
    if(q2)q2.textContent='';
  }
}
/** Stops faux loader % advances (still used ahead of synchronous 200 completions). */
function wsPauseFakeLoaderTicker(){
  if(ldT){clearInterval(ldT);ldT=undefined;}
}
/** Restores `ldPct` to the default `"0–100%"` semantics after async poll UX. */
function wsRestoreLdPctProgressbarSemantics(){
  if(ldEl){
    ldEl.classList.remove('ld--poll-hope','ld--pct-idle');
  }
  if(ldPct){
    ldPct.classList.remove('ld-pct--hope');
    ldPct.removeAttribute('aria-hidden');
    ldPct.removeAttribute('aria-label');
    ldPct.setAttribute('role','progressbar');
    ldPct.setAttribute('aria-valuemin','0');
    ldPct.setAttribute('aria-valuemax','100');
  }
  if(ldSub)ldSub.textContent=wsT('loader.sub');
  loaderPollLastPayload=null;
}
/**
 * Mirrors `ws_generation_phase` / wall-clock elapsed from the proxy onto the overlay.
 * Updates `#ldSubtitle`, `data-ws-generation-phase`, poll-hope chrome — **not** `{@link #ldMsg}`.
 * Part 3 (`loader.status.1`–`7`) then Part 4 rendering copy are owned only by the cinematic loader
 * ({@link wsLoaderStartSevenLineRotation} → {@link wsLoaderSetLdMsgRenderingHold}); see `docs/part4-loader-requirements.md`.
 */
function wsApplyServerPollProgress(payload){
  if(!ldEl||!ldMsg||!payload||typeof payload!=='object')return;
  if(!loaderPollRealMode){
    if(ldEl&&loaderStatusMode!=='seven'){
      ldEl.classList.remove('ld--status-orb-on','ld--status-orb-fadeout','ld--orb-mode-hold');
      wsLoaderStopOrbModeAlternation();
    }
    wsLoaderFlowfieldInvoke('stop');
    loaderPollRealMode=true;
    loaderPollSkipPart3Requested=true;
    if(loaderStatusMode==='seven'){
      wsLoaderMaybeEnterPart4FromActivePoll();
    }
    if(ldEl)ldEl.classList.remove('ld--pct-idle');
    /* Poll active: enter Part 4 when Part 3 floor satisfied (202 only; poll 200 uses R1 exit path). */
    wsPauseFakeLoaderTicker();
    wsResetLateLoaderExtras();
    wsResetLoaderHalftone();
    ldEl.style.removeProperty('--ws-hf-cover');
    ldEl.classList.add('ld--poll-hope');
    if(ldPct){
      ldPct.classList.add('ld-pct--hope');
      ldPct.textContent='';
      ldPct.setAttribute('aria-hidden','true');
      ldPct.removeAttribute('aria-valuenow');
      ldPct.removeAttribute('aria-valuemin');
      ldPct.removeAttribute('aria-valuemax');
      ldPct.removeAttribute('role');
      ldPct.setAttribute('role','presentation');
      ldPct.removeAttribute('aria-label');
    }
    ['d1','d2','d3','d4'].forEach(id=>{const el=$('#'+id);if(el)el.classList.remove('on');});
  }
  var phaseRaw=typeof payload.ws_generation_phase==='string'?payload.ws_generation_phase:'';
  var elapsedMs=(typeof payload.ws_generation_elapsed_ms==='number'&&Number.isFinite(payload.ws_generation_elapsed_ms))?Math.max(0,payload.ws_generation_elapsed_ms):0;
  var sec=Math.floor(elapsedMs/1000);
  ldEl.setAttribute('data-ws-generation-phase',phaseRaw||'');
  if(ldSub)ldSub.textContent=wsT('loader.sub');
  wsLoaderRevealElapsedUpdate(sec);
  if(wsLoaderRevealEnabled()&&loaderPollRealMode){
    const partialB64=typeof payload.partial_image_base64==='string'?payload.partial_image_base64.trim():'';
    if(partialB64){
      wsLoaderRevealApplyPartial({
        data:partialB64,
        mime:typeof payload.mimeType==='string'&&payload.mimeType?payload.mimeType:'image/png',
        index:typeof payload.partial_image_index==='number'&&Number.isFinite(payload.partial_image_index)?payload.partial_image_index:0,
      });
    }
  }
  try{loaderPollLastPayload=Object.assign({},payload);}catch(_){loaderPollLastPayload=null;}
}
/** Maps loader percent (0–100) to halftone dot-layer intensity (0–1); slower ramp early (early‑phase halftone only; deferred path uses {@link wsLoaderHalftoneCoverFromRevealProgress}). */
function wsLoaderHalftoneCoverFromPct(raw){
  const n=Math.min(100,Math.max(0,Math.floor(Number(raw)||0)))/100;
  return Math.min(1,Math.pow(n,0.72));
}
/** After halftone is deferred to `late_hold`, fake % is already high — intensity ramps from reveal baseline through 100%. */
function wsLoaderHalftoneCoverFromRevealProgress(raw){
  const base=loaderHalftoneRevealBaselinePct;
  const x=Math.min(100,Math.max(0,Math.floor(Number(raw)||0)));
  if(base==null)return wsLoaderHalftoneCoverFromPct(x);
  const b=Math.min(96,Math.max(0,Math.floor(Number(base)||0)));
  if(x<=b)return 0;
  const span=Math.max(1,100-b);
  const t=Math.min(1,(x-b)/span);
  return Math.min(1,Math.pow(t,0.72));
}
function wsResetLoaderHalftone(){
  loaderHalftoneRevealBaselinePct=null;
  if(ldEl)ldEl.style.removeProperty('--ws-hf-cover');
  const wrap=ldEl&&ldEl.querySelector('.ld-visual');
  const hf=document.getElementById('ldHalftoneImg');
  if(hf){
    hf.removeAttribute('src');
    hf.src='';
  }
  if(wrap)wrap.setAttribute('hidden','');
}
function wsLoaderHalftoneLayerActive(){
  const wrap=ldEl&&ldEl.querySelector('.ld-visual');
  return !!(wrap&&!wrap.hasAttribute('hidden'));
}
/** Clone `#preview` into the halftone `<img>` after hold copy arms; wrapper stays `[hidden]` until {@link wsTryRevealLoaderHalftoneAtPct}. */
function wsPrimeLoaderHalftoneImgFromPreview(){
  const wrap=ldEl&&ldEl.querySelector('.ld-visual');
  const hf=document.getElementById('ldHalftoneImg');
  const pv=document.getElementById('preview');
  if(!wrap||!hf)return;
  const src=pv&&(pv.currentSrc||pv.src||'');
  if(String(src||'').trim()){
    hf.src=src;
    wrap.setAttribute('hidden','');
  }else{
    hf.removeAttribute('src');
    hf.src='';
    wrap.setAttribute('hidden','');
  }
}
/** Once hold step is active and fake % ≥ {@link WS_LOADER_HALFTONE_MIN_PCT}, show the card and start cover ramp. */
function wsTryRevealLoaderHalftoneAtPct(rawPct){
  if(!ldEl)return;
  if(loaderLateStepIdx<1)return;
  const wrap=ldEl.querySelector('.ld-visual');
  const hf=document.getElementById('ldHalftoneImg');
  if(!wrap||!hf)return;
  if(!String(hf.currentSrc||hf.src||'').trim()){
    wrap.setAttribute('hidden','');
    return;
  }
  const pct=Math.min(100,Math.max(0,Math.floor(Number(rawPct)||0)));
  if(pct<WS_LOADER_HALFTONE_MIN_PCT){
    wrap.setAttribute('hidden','');
    return;
  }
  wrap.removeAttribute('hidden');
  if(loaderHalftoneRevealBaselinePct==null){
    loaderHalftoneRevealBaselinePct=Math.min(96,Math.max(0,pct));
  }
}
/** Prime preview → halftone img on hold step; visibility gated by % (see {@link WS_LOADER_HALFTONE_MIN_PCT}). */
function wsRevealLoaderHalftoneForHoldStep(){
  wsPrimeLoaderHalftoneImgFromPreview();
  if(!ldEl||!ldPct)return;
  const rn=parseInt(ldPct.getAttribute('aria-valuenow'),10);
  const snap=Number.isFinite(rn)?rn:Math.floor(Number(loaderFakePctLast)||0);
  wsTryRevealLoaderHalftoneAtPct(snap);
}
function wsSetLoaderPct(raw){
  if(!ldPct)return;
  const n=Math.min(100,Math.max(0,Math.floor(Number(raw)||0)));
  ldPct.textContent=n+'%';
  ldPct.setAttribute('aria-valuenow',String(n));
  if(loaderLateStepIdx>=1)wsTryRevealLoaderHalftoneAtPct(n);
  if(ldEl){
    if(wsLoaderHalftoneLayerActive()){
      ldEl.style.setProperty('--ws-hf-cover',String(wsLoaderHalftoneCoverFromRevealProgress(n)));
    }else{
      ldEl.style.removeProperty('--ws-hf-cover');
    }
  }
}
/** Calls window.wsLoaderFlowfield (ws-loader-flowfield.js) when present. */
function wsLoaderFlowfieldInvoke(method){
  try{
    const api=(typeof window!=='undefined'?window.wsLoaderFlowfield:null);
    if(!api||typeof api[method]!=='function')return;
    api[method]();
  }catch(_){}
}
/* ──────────────────────────────────────────────────────────────────────────
 * Part 4 progressive portrait reveal (`#ldReveal` slot)
 * Plan: /Users/jhpalen/.cursor/plans/part_4_progressive_reveal_bc4d048d.plan.md
 * Replaces the flowfield particle canvas as Part 4's background. Shopper's
 * own upload (S.b64) becomes a heavy-blurred ghost while we wait, then we
 * crossfade to the real generated portrait on HTTP 200 (img.decode-gated).
 * Honesty: no fake percentage tied to nothing; partials only render if the
 * server actually sends `partial_image_base64` (Phase B). Feature-flag
 * `window.WS_PART4_REVEAL !== false` for one-deploy rollback (G8).
 * ────────────────────────────────────────────────────────────────────────── */
let wsLoaderRevealToken=0;
/** Part 4 alive spinner — show gold indicator once poll is active (≥1s elapsed)
 *  instead of a wall-clock counter that discourages shoppers after ~30s.
 *  Double-gated on `loaderPollRealMode && ld--flowfield-fullscreen`. */
const WS_LOADER_REVEAL_ELAPSED_MIN_SEC=1;
function wsLoaderRevealElapsedUpdate(sec){
  const el=document.getElementById('ldRevealElapsed');
  if(!el)return;
  const show=!!(
    loaderPollRealMode&&
    ldEl&&
    ldEl.classList.contains('show')&&
    ldEl.classList.contains('ld--flowfield-fullscreen')&&
    typeof sec==='number'&&Number.isFinite(sec)&&
    sec>=WS_LOADER_REVEAL_ELAPSED_MIN_SEC
  );
  if(!show){
    el.hidden=true;
    el.removeAttribute('aria-label');
    return;
  }
  el.hidden=false;
  el.setAttribute('aria-label',wsT('loader.real.hope_working_aria'));
}
function wsLoaderRevealElapsedHide(){
  const el=document.getElementById('ldRevealElapsed');
  if(!el)return;
  el.hidden=true;
  el.removeAttribute('aria-label');
}
/** Part 4 tap acknowledgment — ripple + debounced hint; never retriggers generate. */
let wsLoaderRevealTapBound=false;
let wsLoaderRevealTapLastHintAt=0;
let wsLoaderRevealTapTimes=[];
let wsLoaderRevealTapEscalated=false;
let wsLoaderRevealTapHintTimer=null;
function wsLoaderRevealTapAckEnabled(){
  if(typeof window==='undefined')return false;
  return window.WS_PART4_TAP_ACK!==false;
}
function wsLoaderRevealTapActive(){
  if(!wsLoaderRevealTapAckEnabled()||!wsLoaderRevealEnabled())return false;
  const wrap=document.getElementById('ldReveal');
  if(!wrap||!wrap.classList.contains('ld-reveal--ghost')||wrap.classList.contains('ld-reveal--ready'))return false;
  if(!ldEl||!ldEl.classList.contains('show')||!loaderPollRealMode)return false;
  if(!ldEl.classList.contains('ld--flowfield-fullscreen'))return false;
  return true;
}
function wsLoaderRevealTapHintHide(){
  if(wsLoaderRevealTapHintTimer!==null){
    clearTimeout(wsLoaderRevealTapHintTimer);
    wsLoaderRevealTapHintTimer=null;
  }
  const hint=document.getElementById('ldRevealTapHint');
  if(!hint)return;
  hint.textContent='';
  hint.classList.remove('ld-reveal__tap-hint--show');
  hint.hidden=true;
}
function wsLoaderRevealTapHintShow(message){
  const hint=document.getElementById('ldRevealTapHint');
  if(hint){
    hint.textContent=message;
    hint.hidden=false;
    hint.classList.add('ld-reveal__tap-hint--show');
    if(wsLoaderRevealTapHintTimer!==null)clearTimeout(wsLoaderRevealTapHintTimer);
    wsLoaderRevealTapHintTimer=setTimeout(()=>{
      wsLoaderRevealTapHintTimer=null;
      wsLoaderRevealTapHintHide();
    },3200);
    return;
  }
  if(typeof wsToastShow==='function'){
    wsToastShow({type:'info',message:message,duration:2800});
  }
}
function wsLoaderRevealTapSpawnRipple(frame,ev){
  if(!frame||!ev)return;
  const rect=frame.getBoundingClientRect();
  const x=((ev.clientX!=null?ev.clientX:0)-rect.left);
  const y=((ev.clientY!=null?ev.clientY:0)-rect.top);
  const ripple=document.createElement('span');
  ripple.className='ld-reveal__ripple';
  ripple.setAttribute('aria-hidden','true');
  ripple.style.left=Math.max(0,Math.min(rect.width,x))+'px';
  ripple.style.top=Math.max(0,Math.min(rect.height,y))+'px';
  frame.appendChild(ripple);
  const remove=()=>{try{ripple.remove();}catch(_){}};
  ripple.addEventListener('animationend',remove,{once:true});
  setTimeout(remove,520);
}
function wsLoaderRevealTapOnPointerDown(ev){
  if(!wsLoaderRevealTapActive())return;
  const frame=ev.currentTarget;
  if(!frame||!frame.classList||!frame.classList.contains('ld-reveal__frame'))return;
  wsLoaderRevealTapSpawnRipple(frame,ev);
  const now=Date.now();
  wsLoaderRevealTapTimes=wsLoaderRevealTapTimes.filter(t=>now-t<8000);
  wsLoaderRevealTapTimes.push(now);
  if(now-wsLoaderRevealTapLastHintAt<2500)return;
  wsLoaderRevealTapLastHintAt=now;
  if(wsLoaderRevealTapTimes.length>=3){
    if(!wsLoaderRevealTapEscalated){
      wsLoaderRevealTapEscalated=true;
      wsLoaderPart4TapReassure();
      return;
    }
    wsLoaderPart4TapReassure();
    return;
  }
  wsLoaderRevealTapHintShow(wsT('loader.tap.still_working'));
}
function wsLoaderRevealTapBind(){
  if(wsLoaderRevealTapBound||typeof document==='undefined')return;
  const frame=document.querySelector('#wallstraight-generator .ld-reveal__frame');
  if(!frame)return;
  frame.addEventListener('pointerdown',wsLoaderRevealTapOnPointerDown,{passive:true});
  wsLoaderRevealTapBound=true;
}
function wsLoaderRevealTapResetSession(){
  wsLoaderRevealTapLastHintAt=0;
  wsLoaderRevealTapTimes=[];
  wsLoaderRevealTapEscalated=false;
  wsLoaderRevealTapHintHide();
}
function wsLoaderClearAriaBusy(){
  if(ldEl)ldEl.removeAttribute('aria-busy');
}
function wsLoaderRevealEnabled(){
  if(typeof window==='undefined')return false;
  return window.WS_PART4_REVEAL!==false;
}
function wsLoaderRevealSourceFromUpload(){
  try{
    if(typeof S!=='undefined'&&S&&S.b64){
      const mime=(S.file&&S.file.type)||'image/jpeg';
      return 'data:'+mime+';base64,'+S.b64;
    }
  }catch(_){}
  const cinematicPhoto=document.getElementById('ldCinematicPhoto');
  if(cinematicPhoto){
    const cs=cinematicPhoto.currentSrc||cinematicPhoto.src||'';
    if(cs&&cs.indexOf('data:')===0)return cs;
  }
  return '';
}
/** Begin reveal: show shopper's upload as blurred ghost. Honest "working" cue. */
function wsLoaderRevealBegin(){
  if(!wsLoaderRevealEnabled())return;
  const wrap=document.getElementById('ldReveal');
  const img=document.getElementById('ldRevealImg');
  if(!wrap||!img)return;
  wsLoaderRevealToken+=1;
  wrap.classList.remove('ld-reveal--ready');
  wrap.setAttribute('aria-hidden','false');
  const src=wsLoaderRevealSourceFromUpload();
  if(!src){
    wrap.classList.remove('ld-reveal--ghost','ld-reveal--partial');
    img.removeAttribute('src');
    img.src='';
    return;
  }
  wrap.classList.add('ld-reveal--ghost');
  if(img.getAttribute('src')!==src){
    img.src=src;
  }
  wsLoaderRevealTapBind();
}
let wsLoaderRevealLastPartialIndex=-1;
/** Apply a server-sent partial image (Phase B). Overlay only — never touches #resImg. G6: no-op without data. */
function wsLoaderRevealApplyPartial(payload){
  if(!wsLoaderRevealEnabled())return;
  if(!payload||typeof payload!=='object')return;
  const data=payload.data;
  if(typeof data!=='string'||!data)return;
  const idx=typeof payload.index==='number'&&Number.isFinite(payload.index)?Math.floor(payload.index):0;
  if(idx<wsLoaderRevealLastPartialIndex)return;
  wsLoaderRevealLastPartialIndex=idx;
  const mime=typeof payload.mime==='string'&&payload.mime?payload.mime:'image/png';
  const img=document.getElementById('ldRevealImg');
  const wrap=document.getElementById('ldReveal');
  if(!img||!wrap)return;
  wrap.classList.remove('ld-reveal--ready');
  wrap.classList.add('ld-reveal--ghost','ld-reveal--partial');
  wrap.setAttribute('aria-hidden','false');
  const url='data:'+mime+';base64,'+data;
  if(img.getAttribute('src')!==url){
    img.src=url;
    if(typeof img.decode==='function'){
      try{void img.decode();}catch(_){}
    }
  }
}
/** Finalize reveal: decode then crossfade ghost → sharp. Mirrors wsSetResImage decode pattern. */
async function wsLoaderRevealFinalize(url){
  if(!wsLoaderRevealEnabled())return;
  const wrap=document.getElementById('ldReveal');
  const img=document.getElementById('ldRevealImg');
  if(!wrap||!img||!url)return;
  const my=++wsLoaderRevealToken;
  wrap.setAttribute('aria-hidden','false');
  try{
    if(img.src!==url){
      img.src=url;
      if(typeof img.decode==='function'){
        try{await img.decode();}catch(_){}
      }
    }
  }catch(_){}
  if(my!==wsLoaderRevealToken)return;
  wrap.classList.remove('ld-reveal--ghost','ld-reveal--partial');
  wrap.classList.add('ld-reveal--ready');
}
/** Reset reveal slot. Called from startLd / stopLd / error paths. */
function wsLoaderRevealReset(){
  wsLoaderRevealToken+=1;
  wsLoaderRevealLastPartialIndex=-1;
  wsLoaderRevealElapsedHide();
  wsLoaderRevealTapResetSession();
  wsLoaderPart4Stop();
  const wrap=document.getElementById('ldReveal');
  const img=document.getElementById('ldRevealImg');
  if(wrap){
    wrap.classList.remove('ld-reveal--ghost','ld-reveal--partial','ld-reveal--ready');
    wrap.setAttribute('aria-hidden','true');
  }
  if(img){
    img.removeAttribute('src');
    img.src='';
  }
}
function wsLoaderPrefersReducedMotion(){
  try{return window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(_){return false;}
}
function wsLoaderClearPart4MessageSwapState(el){
  if(!el)return;
  el.classList.remove('ld-msg--part4-swap','ld-msg--part4-reveal','ld-msg--part4-reveal-on');
  if(ldEl)ldEl.classList.remove('ld--part4-copy-swap');
}
function wsLoaderPrimePart4MessageSwap(el){
  if(!el)return;
  wsLoaderClearPart4MessageSwapState(el);
  if(ldEl)ldEl.classList.add('ld--part4-copy-swap');
  el.classList.add('ld-msg--part4-swap','ld-msg--part4-reveal');
}
/** Updates {@link #ldMsg} with a short opacity fade (honors reduced motion). */
function wsLoaderSetLdMsgResolved(text){
  const el=document.getElementById('ldMsg');
  if(!el)return;
  wsLoaderClearPart4MessageSwapState(el);
  el.removeAttribute('role');
  el.classList.remove('ld-msg--hold-split');
  if(wsLoaderPrefersReducedMotion()){
    el.textContent=text;
    el.classList.remove('ld-msg--fade-out');
    return;
  }
  const my=++wsLoaderMsgFadeToken;
  el.classList.add('ld-msg--fade-out');
  setTimeout(()=>{
    if(my!==wsLoaderMsgFadeToken)return;
    el.textContent=text;
    el.classList.remove('ld-msg--fade-out');
  },WS_LD_MSG_FADE_MS);
}
function wsPart4WaitUxEnabled(){
  if(typeof window==='undefined')return false;
  return window.WS_PART4_WAIT_UX!==false;
}
function wsPart4PunchlineEnabled(){
  if(typeof window==='undefined')return true;
  return window.WS_PART4_PUNCHLINE!==false;
}
function wsPart4CfgMs(key,fallback){
  const c=typeof window.WS_PART4_WAIT_UX==='object'&&window.WS_PART4_WAIT_UX?window.WS_PART4_WAIT_UX:null;
  const v=c&&typeof c[key]==='number'&&Number.isFinite(c[key])?Math.max(0,Math.floor(c[key])):fallback;
  return v;
}
function wsActiveJobWrite(jobId){
  if(!jobId)return;
  try{
    sessionStorage.setItem(WS_ACTIVE_JOB_STORAGE_KEY,JSON.stringify({
      jobId:String(jobId).slice(0,128),
      status:'pending',
      startedAt:Date.now(),
      style:S&&S.style?String(S.style):'',
      cat:S&&S.cat?String(S.cat):''
    }));
  }catch(_){}
}
function wsActiveJobClear(){
  try{sessionStorage.removeItem(WS_ACTIVE_JOB_STORAGE_KEY);}catch(_){}
}
function wsActiveJobRead(){
  try{
    const raw=sessionStorage.getItem(WS_ACTIVE_JOB_STORAGE_KEY);
    if(!raw)return null;
    const parsed=JSON.parse(raw);
    if(!parsed||typeof parsed!=='object')return null;
    return parsed;
  }catch(_){return null;}
}
/** Stable fingerprint for idempotency reuse while the same generate attempt is in flight. */
function wsGenerateAttemptFingerprint(){
  const b64=S&&S.b64?String(S.b64):'';
  const style=S&&S.style?String(S.style):'';
  const cat=S&&S.cat?String(S.cat):'';
  const extra=S&&S.extraPrompt?String(S.extraPrompt).trim():'';
  return [style,cat,String(b64.length),b64.slice(0,48),b64.slice(-16),extra.slice(0,64)].join('|');
}
/** Reuse Idempotency-Key for duplicate taps / double POST while busy on the same attempt. */
function wsResolveGenerateIdempotencyKey(){
  const fp=wsGenerateAttemptFingerprint();
  if(S.generateIdempotencyKey&&S._generateIdempotencyFp===fp&&(S.busy||S.generateLock||S.inFlightAsyncJobId)){
    return S.generateIdempotencyKey;
  }
  const key=(window.crypto&&window.crypto.randomUUID)?window.crypto.randomUUID():String(Date.now())+'-'+Math.random().toString(36).slice(2,12);
  S.generateIdempotencyKey=key;
  S._generateIdempotencyFp=fp;
  return key;
}
const WS_ACTIVE_JOB_MAX_AGE_MS=28*60*1000;
/** Show loader shell for poll resume — skip cinematic intro / seven-line rotation. */
function wsLoaderStartPollResumeShell(){
  if(!ldEl||!ldPct||!ldMsg)return;
  if(ldT)clearInterval(ldT);
  ldT=undefined;
  wsLoaderClearIntroTimers();
  wsLoaderStopSevenLineRotation();
  wsLoaderResetCinematicUi();
  wsResetLateLoaderExtras();
  wsResetLoaderHalftone();
  loaderFakePctLast=0;
  loaderPollRealMode=false;
  wsRestoreLdPctProgressbarSemantics();
  ldEl.classList.add('show');
  ldEl.setAttribute('aria-hidden','false');
  ldEl.setAttribute('aria-busy','true');
  document.body.style.overflow='hidden';
  wsSetLoaderPct(0);
  ldEl.classList.add('ld--pct-idle','ld--cinematic-done');
  ldEl.classList.remove('ld--cinematic-active','ld--cinematic-show-hero','ld--cinematic-show-status');
  ldMsg.textContent='';
  ldMsg.classList.remove('ld-msg--quote','ld-msg--hold','ld-msg--hold-split');
  wsLoaderRevealTapResetSession();
  ['d1','d2','d3','d4'].forEach(id=>{const el=$('#'+id);if(el)el.classList.remove('on');});
  wsLoaderEnterPart4FromPollResume();
}
/** Re-enter Part 4 poll UI after refresh when an async job is still pending. */
function wsLoaderEnterPart4FromPollResume(){
  if(!ldEl||!ldEl.classList.contains('show'))return;
  wsLoaderStopSevenLineRotation();
  wsLoaderStopOrbModeAlternation();
  loaderStatusMode='hold';
  loaderPollRealMode=true;
  loaderLateSequenceComplete=true;
  if(ldEl){
    ldEl.classList.remove('ld--status-orb-on','ld--status-orb-fadeout','ld--cinematic-active','ld--cinematic-done');
    ldEl.classList.add('ld--flowfield-fullscreen','ld--poll-hope');
    ldEl.setAttribute('data-ws-generation-phase','openai_pending');
  }
  wsLoaderSetLdMsgRenderingHold();
  wsLoaderRevealBegin();
}
async function wsApplySuccessfulGeneratePayload(res,d,opt){
  opt=opt&&typeof opt==='object'?opt:{};
  const wasAsyncPath=opt.async_path!==false;
  if(d&&d.ws_generation_meta)console.info('[Wallstraight]',d.ws_generation_meta);
  if(d&&typeof d.ws_preview_remaining==='number'&&Number.isFinite(d.ws_preview_remaining)){
    S.previewRemaining=Math.max(0,Math.floor(d.ws_preview_remaining));
    updRetryUI();
  }
  S.lastJobId=(d&&(d.ws_job_id||d.jobId||d.job_id))?String(d.ws_job_id||d.jobId||d.job_id):'';
  const hostedRaw=(d&&(d.preview_url||d.previewUrl))?String(d.preview_url||d.previewUrl).trim():'';
  S.lastPreviewUrl=/^https?:\/\//i.test(hostedRaw)?hostedRaw:'';
  const shareRaw=(d&&(d.share_url||d.shareUrl))?String(d.share_url||d.shareUrl).trim():'';
  S.lastShareUrl=/^https?:\/\//i.test(shareRaw)?shareRaw:'';
  const funnelRaw=(d&&(d.funnel_resume_url||d.funnelResumeUrl))?String(d.funnel_resume_url||d.funnelResumeUrl).trim():'';
  S.lastFunnelResumeUrl=/^https?:\/\//i.test(funnelRaw)?funnelRaw:'';
  const generated=extractGeneratedImage(d);
  if(!S.lastPreviewUrl&&!generated)throw new Error(wsT('err.no_image'));
  const inlineUrl=wsGeneratedDataUrl(generated);
  if(inlineUrl)S.imgUrl=inlineUrl;
  else if(S.lastPreviewUrl)S.imgUrl=S.lastPreviewUrl;
  else if(generated&&generated.kind==='url')S.imgUrl=generated.url;
  else if(generated)S.imgUrl=`data:${wsPreviewDataMime(generated.mime)};base64,${generated.data}`;
  if(resTag)resTag.textContent=wsStyleName(S.style)||wsStyleName('royal');
  try{window.wsFunnelAnalytics?.bindJob(opt.funnelAttempt,S.lastJobId);}catch(_){}
  const settleJobId=S.lastJobId;
  const settleImgUrl=S.imgUrl;
  const resumePath=opt.resume_path===true;
  void wsLoaderRevealFinalize(settleImgUrl).catch(function(){});
  try{wsRecordFunnelEvent('preview_generated',{job_id:settleJobId||null,async_path:wasAsyncPath,attempt:S._generateAttemptId|0});}catch(_){}
  showResult();
  try{wsPortraitSessionWrite({jobId:S.lastJobId,previewUrl:S.lastPreviewUrl,shareUrl:S.lastShareUrl,funnelResumeUrl:S.lastFunnelResumeUrl,style:S.style,cat:S.cat});}catch(_){}
  stopLd(true,{immediateReveal:true});
  wsRefreshPreviewBranding();
  toast(wsT('toast.ready'));
  wsWelcomeOfferArmFromGenerationSuccess();
  wsActiveJobClear();
  wsPushPreviewHistory({
    jobId:S.lastJobId,
    previewUrl:S.lastPreviewUrl,
    imgUrl:S.imgUrl,
    attempt:S.previewClientAttempt,
    style:S.style,
    ts:Date.now(),
  });
  if(resImg&&settleImgUrl){
    void wsSetResImageWithTimeout(resImg,settleImgUrl,WS_SET_RES_IMAGE_DECODE_TIMEOUT_MS).then(function(ok){
      if(!wsGenerateImageStillCurrent(settleJobId,settleImgUrl))return;
      if(ok)wsPerfMark('t_image_decoded');
      try{wsPerfReport({job_id:settleJobId||null,async_path:wasAsyncPath,resume_path:resumePath});}catch(_){}
    });
  }else{
    try{wsPerfReport({job_id:settleJobId||null,async_path:wasAsyncPath,resume_path:resumePath});}catch(_){}
  }
}
async function wsActiveJobTryResume(){
  if(typeof window==='undefined'||typeof S==='undefined')return null;
  if(S.busy||S.generateLock)return null;
  if(window.__WS_CONTRACT_TEST__===true)return null;
  const rec=wsActiveJobRead();
  if(!rec||typeof rec.jobId!=='string'||!rec.jobId.trim())return null;
  const startedAt=typeof rec.startedAt==='number'?rec.startedAt:0;
  if(!startedAt||Date.now()-startedAt>WS_ACTIVE_JOB_MAX_AGE_MS){
    wsActiveJobClear();
    return null;
  }
  S.inFlightAsyncJobId=String(rec.jobId).trim();
  if(rec.style)S.style=String(rec.style);
  if(rec.cat)S.cat=String(rec.cat);
  S.busy=true;
  S.generateLock=true;
  if(genBtn){genBtn.classList.add('ld');genBtn.disabled=true;}
  hideErr();
  wsPerfStart();
  wsLoaderStartPollResumeShell();
  const deviceHdrs=(typeof window.__WS_DEVICE_ID__==='string'&&window.__WS_DEVICE_ID__?{'X-WS-Device-Id':window.__WS_DEVICE_ID__}:{});
  try{
    wsApplyServerPollProgress({status:'processing',ws_async_job_id:rec.jobId});
    const polled=await wsPollGenerationUntilReady(String(rec.jobId),deviceHdrs,wsApplyServerPollProgress);
    wsPerfMark('t_async_resolved');
    if(!polled.res.ok){
      const detail=polled.d?.error?.message||polled.d?.message||'';
      const code=polled.d?.error?.code||polled.d?.code||'';
      throw Object.assign(new Error(wsErrorMessage(polled.res.status,code,detail)),{status:polled.res.status,code:code||'provider_error'});
    }
    await wsApplySuccessfulGeneratePayload(polled.res,polled.d,{async_path:true,resume_path:true});
    return{jobId:S.lastJobId,previewUrl:S.lastPreviewUrl};
  }catch(e){
    console.warn('Active job resume failed',e);
    stopLd(false);
    showErr(wsShopperSafeErrorMessage(e,wsT('generic_err')));
    wsActiveJobClear();
    return null;
  }finally{
    S.busy=false;
    S.generateLock=false;
    S.inFlightAsyncJobId=null;
    if(genBtn){genBtn.classList.remove('ld');genBtn.disabled=false;}
    upd();
  }
}
function wsLoaderPart4GetHoldSubEl(){
  const el=document.getElementById('ldMsg');
  if(!el)return null;
  return el.querySelector('.ld-msg__hold-sub');
}
function wsLoaderResetRenderingHoldSubVariant(){
  loaderRenderingHoldSubVariant=null;
}
function wsPart4PunchlinePinMapRead(){
  try{
    const raw=sessionStorage.getItem(WS_PART4_PUNCHLINE_PIN_KEY);
    if(!raw)return {};
    const parsed=JSON.parse(raw);
    return parsed&&typeof parsed==='object'?parsed:{};
  }catch(_){return {};}
}
function wsPart4PunchlinePinMapWrite(map){
  try{sessionStorage.setItem(WS_PART4_PUNCHLINE_PIN_KEY,JSON.stringify(map||{}));}catch(_){}
}
function wsPart4PunchlinePinWrite(jobId,idx){
  const id=String(jobId||'').trim();
  if(!id)return;
  const map=wsPart4PunchlinePinMapRead();
  map[id]=idx;
  wsPart4PunchlinePinMapWrite(map);
}
/** Round-robin v1–v5 once per job; pinned in sessionStorage for poll refresh. */
function wsLoaderEnsureRenderingHoldSubVariantIndex(jobId){
  if(loaderRenderingHoldSubVariant!==null&&loaderRenderingHoldSubVariant!==undefined)return loaderRenderingHoldSubVariant;
  const id=String(jobId||'').trim();
  if(id){
    const map=wsPart4PunchlinePinMapRead();
    const pinned=map[id];
    if(typeof pinned==='number'&&pinned>=0&&pinned<WS_LOADER_RENDERING_SUB_VARIANT_COUNT){
      loaderRenderingHoldSubVariant=pinned;
      return loaderRenderingHoldSubVariant;
    }
  }
  let seq=0;
  try{
    const raw=localStorage.getItem(WS_PART4_PUNCHLINE_SEQ_KEY);
    const parsed=parseInt(raw,10);
    if(Number.isFinite(parsed)&&parsed>=0)seq=parsed;
  }catch(_){seq=0;}
  const idx=seq%WS_LOADER_RENDERING_SUB_VARIANT_COUNT;
  try{localStorage.setItem(WS_PART4_PUNCHLINE_SEQ_KEY,String(seq+1));}catch(_){}
  loaderRenderingHoldSubVariant=idx;
  if(id)wsPart4PunchlinePinWrite(id,idx);
  return idx;
}
function wsLoaderRenderingHoldSubKey(){
  return'loader.poll.status.rendering_sub.v'+(wsLoaderEnsureRenderingHoldSubVariantIndex(S.inFlightAsyncJobId)+1);
}
function wsLoaderPart4SetSub(text,extraClass){
  const sub=wsLoaderPart4GetHoldSubEl();
  if(!sub)return;
  sub.textContent=text;
  sub.classList.remove('ld-msg__hold-sub--deferred');
  sub.hidden=false;
  sub.classList.remove('ld-msg__hold-sub--tap','ld-msg__hold-sub--long-wait','ld-msg__hold-sub--punchline');
  if(extraClass)sub.classList.add(extraClass);
}
function wsLoaderPart4RevealPatienceSub(){
  if(wsLoaderPart4TapCopyActive||wsLoaderPart4SubTier!=='hidden')return;
  wsLoaderPart4SubTier='patience';
  wsLoaderPart4SubRevealed=true;
  wsLoaderPart4SetSub(wsT('loader.part4.patience_sub'));
}
function wsLoaderPart4RevealPunchlineSub(){
  if(!wsPart4PunchlineEnabled())return;
  if(wsLoaderPart4TapCopyActive||wsLoaderPart4SubTier==='tap'||wsLoaderPart4SubTier==='punchline')return;
  const notifySheet=document.getElementById('part4NotifySheet');
  const notifySheetOpen=!!(notifySheet&&notifySheet.classList.contains('show')&&!notifySheet.hidden);
  if(notifySheetOpen)return;
  wsLoaderPart4SubTier='punchline';
  wsLoaderPart4SubRevealed=true;
  if(ldEl)ldEl.classList.add('ld--part4-punchline');
  wsLoaderPart4SetSub(wsT(wsLoaderRenderingHoldSubKey()),'ld-msg__hold-sub--punchline');
}
function wsLoaderPart4TapReassure(){
  wsLoaderPart4TapCopyActive=true;
  wsLoaderPart4SubRevealed=true;
  wsLoaderPart4SubTier='tap';
  wsLoaderPart4SetSub(wsT('loader.part4.tap_reassure'),'ld-msg__hold-sub--tap');
  wsLoaderRevealTapHintHide();
}
function wsLoaderPart4Tick(){
  if(!wsPart4WaitUxEnabled()||!wsLoaderPart4Epoch)return;
  if(!ldEl||!ldEl.classList.contains('ld--flowfield-fullscreen')||!loaderPollRealMode)return;
  const elapsed=Date.now()-wsLoaderPart4Epoch;
  if(elapsed>=wsPart4CfgMs('subDelayMs',WS_PART4_SUB_DELAY_MS_DEFAULT)){
    ldEl.classList.add('ld--part4-slow-5s');
    wsLoaderPart4RevealPatienceSub();
  }
  if(elapsed>=wsPart4CfgMs('emailDelayMs',WS_PART4_EMAIL_DELAY_MS_DEFAULT)){
    ldEl.classList.add('ld--part4-email-offer');
    if(typeof wsPart4NotifyTryShow==='function')wsPart4NotifyTryShow();
  }
  if(elapsed>=wsPart4CfgMs('punchlineDelayMs',WS_PART4_PUNCHLINE_DELAY_MS_DEFAULT)){
    wsLoaderPart4RevealPunchlineSub();
  }
  if(elapsed>=wsPart4CfgMs('longWaitMs',WS_PART4_LONG_WAIT_MS_DEFAULT)){
    ldEl.classList.add('ld--part4-long-wait');
  }
  if(elapsed>=wsPart4CfgMs('safeLeaveMs',WS_PART4_SAFE_LEAVE_MS_DEFAULT)){
    ldEl.classList.add('ld--part4-safe-leave');
  }
}
function wsLoaderPart4Start(){
  wsLoaderPart4Stop(false);
  wsLoaderPart4Epoch=Date.now();
  wsLoaderPart4SubRevealed=false;
  wsLoaderPart4TapCopyActive=false;
  wsLoaderPart4SubTier='hidden';
  wsPart4NotifyArm();
  if(wsLoaderPrefersReducedMotion()){
    if(ldEl){
      ldEl.classList.add('ld--part4-slow-5s','ld--part4-email-offer');
    }
    wsLoaderPart4RevealPatienceSub();
    if(typeof wsPart4NotifyTryShow==='function')wsPart4NotifyTryShow();
  }
  if(!wsPart4WaitUxEnabled())return;
  wsLoaderPart4TickHandle=setInterval(wsLoaderPart4Tick,WS_PART4_TICK_MS);
  wsLoaderPart4Tick();
}
function wsLoaderPart4Stop(disarmNotify){
  wsLoaderPart4Epoch=0;
  if(wsLoaderPart4TickHandle){
    clearInterval(wsLoaderPart4TickHandle);
    wsLoaderPart4TickHandle=null;
  }
  if(ldEl){
    ldEl.classList.remove('ld--part4-slow-5s','ld--part4-email-offer','ld--part4-long-wait','ld--part4-safe-leave','ld--part4-punchline');
  }
  wsLoaderPart4SubTier='hidden';
  wsLoaderResetRenderingHoldSubVariant();
  if(disarmNotify!==false&&typeof wsPart4NotifyDisarm==='function')wsPart4NotifyDisarm();
}
const WS_PART4_NOTIFY_CAPTURE_KEY='ws_part4_notify_capture_v1';
let wsPart4NotifyArmed=false;
let wsPart4NotifyDismissed=false;
let wsPart4NotifySubmitted=false;
let wsPart4NotifySuccessDismissTimer=null;
let wsPart4NotifyHasSelectorSupport=null;
function wsPart4NotifyClearSuccessDismissTimer(){
  if(wsPart4NotifySuccessDismissTimer!==null){
    clearTimeout(wsPart4NotifySuccessDismissTimer);
    wsPart4NotifySuccessDismissTimer=null;
  }
}
function wsPart4NotifySupportsHas(){
  if(wsPart4NotifyHasSelectorSupport!==null)return wsPart4NotifyHasSelectorSupport;
  try{
    wsPart4NotifyHasSelectorSupport=typeof CSS!=='undefined'&&!!CSS.supports&&CSS.supports('selector(:has(*))');
  }catch(_){wsPart4NotifyHasSelectorSupport=false;}
  return wsPart4NotifyHasSelectorSupport;
}
function wsPart4NotifySetLdOpenClass(open){
  if(wsPart4NotifySupportsHas())return;
  if(ldEl)ldEl.classList.toggle('ld--part4-notify-open',!!open);
}
function wsPart4NotifyCaptureMapRead(){
  try{
    const raw=sessionStorage.getItem(WS_PART4_NOTIFY_CAPTURE_KEY);
    if(!raw)return {};
    const parsed=JSON.parse(raw);
    return parsed&&typeof parsed==='object'?parsed:{};
  }catch(_){return {};}
}
function wsPart4NotifyCaptureMapWrite(map){
  try{sessionStorage.setItem(WS_PART4_NOTIFY_CAPTURE_KEY,JSON.stringify(map||{}));}catch(_){}
}
function wsPart4NotifyCapturePrune(map){
  const now=Date.now();
  const out={};
  Object.keys(map||{}).forEach(k=>{
    const rec=map[k];
    const at=rec&&typeof rec==='object'&&typeof rec.at==='number'?rec.at:0;
    if(at&&now-at<=WS_ACTIVE_JOB_MAX_AGE_MS)out[k]=rec;
  });
  return out;
}
function wsPart4NotifyCaptureHas(jobId){
  const id=String(jobId||'').trim();
  if(!id)return false;
  const map=wsPart4NotifyCapturePrune(wsPart4NotifyCaptureMapRead());
  wsPart4NotifyCaptureMapWrite(map);
  return !!map[id];
}
function wsPart4NotifyCaptureWrite(jobId){
  const id=String(jobId||'').trim();
  if(!id)return;
  const map=wsPart4NotifyCapturePrune(wsPart4NotifyCaptureMapRead());
  map[id]={at:Date.now()};
  wsPart4NotifyCaptureMapWrite(map);
}
function wsPart4NotifyCapturedForCurrentJob(){
  if(wsPart4NotifySubmitted)return true;
  return wsPart4NotifyCaptureHas(S.inFlightAsyncJobId);
}
function wsFmtPart4NotifyBody(email){
  return String(wsT('part4_notify.body_account')||'').replace(/\{email\}/g,String(email||'').trim());
}
function wsPart4NotifySyncBodyCopy(){
  const bodyEl=document.querySelector('#part4NotifyPanelForm .part4-notify-sheet__body');
  if(!bodyEl)return;
  const cfg=wsPart4NotifyCfg();
  const em=cfg&&cfg.customerEmail?cfg.customerEmail:'';
  if(em)bodyEl.textContent=wsFmtPart4NotifyBody(em);
  else bodyEl.textContent=wsT('part4_notify.body');
}
function wsPart4NotifyResetUiState(opts){
  opts=opts&&typeof opts==='object'?opts:{};
  wsPart4NotifyClearSuccessDismissTimer();
  const formP=document.getElementById('part4NotifyPanelForm');
  const okP=document.getElementById('part4NotifyPanelSuccess');
  const errEl=document.getElementById('part4NotifyErr');
  const subBtn=document.getElementById('part4NotifySubmit');
  const consentEl=document.getElementById('part4NotifyConsent');
  const emailEl=document.getElementById('part4NotifyEmail');
  if(formP){formP.hidden=false;formP.removeAttribute('hidden');}
  if(okP){okP.hidden=true;okP.setAttribute('hidden','');}
  if(errEl){errEl.hidden=true;errEl.textContent='';}
  if(subBtn)subBtn.disabled=false;
  if(consentEl)consentEl.checked=false;
  if(emailEl&&opts.keepEmail!==true)emailEl.value='';
  wsPart4NotifySyncBodyCopy();
}
function wsPart4NotifyShowSuccessPanel(){
  const formP=document.getElementById('part4NotifyPanelForm');
  const okP=document.getElementById('part4NotifyPanelSuccess');
  if(formP){formP.hidden=true;formP.setAttribute('hidden','');}
  if(okP){okP.hidden=false;okP.removeAttribute('hidden');}
}
function wsPart4NotifyScheduleSuccessDismiss(){
  wsPart4NotifyClearSuccessDismissTimer();
  const dismissMs=wsPart4CfgMs('successDismissMs',WS_PART4_SUCCESS_DISMISS_MS_DEFAULT);
  wsPart4NotifySuccessDismissTimer=setTimeout(()=>{
    wsPart4NotifySuccessDismissTimer=null;
    wsPart4NotifyDisarm();
  },dismissMs);
}
function wsPart4NotifyCfg(){
  if(typeof window==='undefined')return null;
  const c=typeof window.WS_PART4_NOTIFY==='object'&&window.WS_PART4_NOTIFY?window.WS_PART4_NOTIFY:null;
  if(!c||c.enabled===false)return null;
  return{
    requireConsent:c.requireConsent!==false,
    consentLabel:String(c.consentLabel||'').trim(),
    customerEmail:String(c.customerEmail||'').trim(),
    customerId:c.customerId!=null&&c.customerId!==''?String(c.customerId).trim():'',
    contactTags:String(c.contactTags||'part4-wait-notify,newsletter').trim()
  };
}
function wsPart4NotifySyncMerchantCopy(){
  const cfg=wsPart4NotifyCfg();
  const el=document.getElementById('part4NotifyConsentText');
  if(!el)return;
  if(cfg&&cfg.requireConsent)el.textContent=cfg.consentLabel?cfg.consentLabel:wsT('welcome.consent_label');
  else el.textContent='';
  const wrap=document.getElementById('part4NotifyConsentWrap');
  if(wrap)wrap.style.display=cfg&&cfg.requireConsent?'flex':'none';
}
function wsPart4NotifyPrefillEmail(){
  const cfg=wsPart4NotifyCfg();
  const fallback=typeof wsStudioRecoveryCfg==='function'?wsStudioRecoveryCfg():null;
  const em=(cfg&&cfg.customerEmail)||(fallback&&fallback.customerEmail)||'';
  const input=document.getElementById('part4NotifyEmail');
  if(input&&em&&!input.value)input.value=em;
}
function wsPart4NotifyArm(){
  if(!wsPart4NotifyCfg())return;
  if(!document.getElementById('part4NotifySheet'))return;
  wsPart4NotifyArmed=true;
  wsPart4NotifyDismissed=false;
  wsPart4NotifyResetUiState();
  const jobId=String(S.inFlightAsyncJobId||'').trim();
  wsPart4NotifySubmitted=jobId?wsPart4NotifyCaptureHas(jobId):false;
}
function wsPart4NotifyDisarm(){
  wsPart4NotifyClearSuccessDismissTimer();
  wsPart4NotifyArmed=false;
  wsPart4NotifyResetUiState();
  wsPart4NotifySetLdOpenClass(false);
  const sheet=document.getElementById('part4NotifySheet');
  if(!sheet)return;
  sheet.classList.remove('show');
  sheet.setAttribute('aria-hidden','true');
  sheet.hidden=true;
}
function wsPart4NotifyTryShow(){
  if(!wsPart4NotifyArmed||wsPart4NotifyDismissed)return;
  if(!wsPart4NotifyCfg())return;
  const sheet=document.getElementById('part4NotifySheet');
  if(!sheet)return;
  if(sheet.classList.contains('show')&&!sheet.hidden)return;
  if(!S.inFlightAsyncJobId&&!S.busy)return;
  const jobId=String(S.inFlightAsyncJobId||'').trim();
  wsPart4NotifySyncMerchantCopy();
  if(jobId&&wsPart4NotifyCaptureHas(jobId)){
    wsPart4NotifySubmitted=true;
    wsPart4NotifyShowSuccessPanel();
    wsPart4NotifySetLdOpenClass(true);
    sheet.hidden=false;
    sheet.classList.add('show');
    sheet.setAttribute('aria-hidden','false');
    wsPart4NotifyScheduleSuccessDismiss();
    return;
  }
  if(wsPart4NotifySubmitted)return;
  wsPart4NotifyResetUiState();
  wsPart4NotifyPrefillEmail();
  wsPart4NotifySyncBodyCopy();
  wsPart4NotifySetLdOpenClass(true);
  sheet.hidden=false;
  sheet.classList.add('show');
  sheet.setAttribute('aria-hidden','false');
}
async function wsPart4NotifySubmitEmail(){
  const cfg=wsPart4NotifyCfg();
  const emailEl=document.getElementById('part4NotifyEmail');
  const errEl=document.getElementById('part4NotifyErr');
  const subBtn=document.getElementById('part4NotifySubmit');
  const consentEl=document.getElementById('part4NotifyConsent');
  const jobId=S.inFlightAsyncJobId||'';
  if(!cfg||!emailEl||!jobId)return;
  if(wsPart4NotifySubmitted)return;
  const email=String(emailEl.value||'').trim();
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
    if(errEl){errEl.hidden=false;errEl.textContent=wsT('welcome.email_invalid');}
    return;
  }
  if(cfg.requireConsent&&consentEl&&!consentEl.checked){
    if(errEl){errEl.hidden=false;errEl.textContent=wsT('welcome.consent_required');}
    return;
  }
  if(errEl){errEl.hidden=true;errEl.textContent='';}
  if(subBtn)subBtn.disabled=true;
  try{
    const payload={job_id:jobId,email,consent:cfg.requireConsent?!!consentEl?.checked:true};
    if(cfg.customerId)payload.shopify_customer_id=cfg.customerId;
    const res=await fetch(WS_PROXY_GENERATE_NOTIFY,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify(payload)
    });
    const d=await readProxyJson(res);
    if(!res.ok)throw new Error((d&&d.error&&d.error.message)||wsT('part4_notify.err_submit'));
    const form=document.getElementById('wsPart4NotifyCustomerForm');
    const mirror=document.getElementById('part4NotifyEmailField');
    const shouldStorefrontForm=form&&mirror&&((cfg.requireConsent&&consentEl?.checked)||!cfg.requireConsent);
    if(shouldStorefrontForm){
      try{
        await wsShopifyCustomerNewsletterSubmit({
          form,
          mirrorInput:mirror,
          emailInput:emailEl,
          errEl:null,
          submitBtn:null,
          consentInput:consentEl,
          requireConsent:!!cfg.requireConsent,
          messages:{emailInvalid:wsT('welcome.email_invalid'),consentRequired:wsT('welcome.consent_required'),errSubmit:wsT('welcome.err_submit'),errCaptcha:wsT('welcome.err_captcha'),errNetwork:wsT('welcome.err_network'),errRate:wsT('welcome.err_rate'),errWait:wsT('welcome.err_wait')},
          minDwellMs:0,
          modalShownAt:Date.now(),
          rateLimitOk:()=>true,
          rateLimitRecord:()=>{},
          onSuccess:async()=>{}
        });
      }catch(_){/* storefront newsletter tag is best-effort after worker notify */}
    }
    if(d&&d.shopify_customer_bound===false&&typeof console!=='undefined'&&console.warn){
      console.warn('[Wallstraight] Part 4 notify: worker Shopify customer bind failed; storefront form attempted.');
    }
    if(d&&(d.shopify_customer_bound===false||d.note_written===false)&&typeof console!=='undefined'&&console.warn){
      console.warn('[Wallstraight] Part 4 notify: worker customer bind incomplete.',d);
    }
    wsPart4NotifyCaptureWrite(jobId);
    wsPart4NotifySubmitted=true;
    wsPart4NotifyShowSuccessPanel();
    wsPart4NotifyScheduleSuccessDismiss();
  }catch(e){
    if(errEl){errEl.hidden=false;errEl.textContent=String(e&&e.message||wsT('part4_notify.err_submit'));}
  }finally{
    if(subBtn&&!wsPart4NotifySubmitted)subBtn.disabled=false;
  }
}
(function wsPart4NotifyInit(){
  const sheet=document.getElementById('part4NotifySheet');
  if(!sheet)return;
  const dismiss=document.getElementById('part4NotifyDismiss');
  const submit=document.getElementById('part4NotifySubmit');
  if(dismiss)dismiss.addEventListener('click',()=>{wsPart4NotifyDismissed=true;wsPart4NotifyDisarm();});
  if(submit)submit.addEventListener('click',()=>{void wsPart4NotifySubmitEmail();});
  wsPart4NotifySyncMerchantCopy();
})();
/** Re-layer Part 4 hold copy after lang toggle without resetting punchline variant or tier. */
function wsLoaderPart4RefreshHoldSubFromState(el){
  if(!el)return;
  el.classList.remove('ld-msg--quote');
  el.classList.add('ld-msg--hold','ld-msg--hold-split');
  el.setAttribute('role','status');
  let head=el.querySelector('.ld-msg__hold-head');
  let sub=el.querySelector('.ld-msg__hold-sub');
  if(!head||!sub){
    wsLoaderApplyRenderingHoldDom(el);
    head=el.querySelector('.ld-msg__hold-head');
    sub=el.querySelector('.ld-msg__hold-sub');
  }
  if(head)head.textContent=wsT('loader.poll.status.rendering_head');
  if(wsLoaderPart4TapCopyActive){
    wsLoaderPart4SetSub(wsT('loader.part4.tap_reassure'),'ld-msg__hold-sub--tap');
    return;
  }
  const elapsed=wsLoaderPart4Epoch?Date.now()-wsLoaderPart4Epoch:0;
  const punchlineMs=wsPart4CfgMs('punchlineDelayMs',WS_PART4_PUNCHLINE_DELAY_MS_DEFAULT);
  if(wsLoaderPart4SubTier==='punchline'||(wsPart4PunchlineEnabled()&&elapsed>=punchlineMs)){
    wsLoaderPart4SubTier='punchline';
    if(ldEl)ldEl.classList.add('ld--part4-punchline');
    wsLoaderPart4SetSub(wsT(wsLoaderRenderingHoldSubKey()),'ld-msg__hold-sub--punchline');
    return;
  }
  if(wsLoaderPart4SubTier==='patience'||elapsed>=wsPart4CfgMs('subDelayMs',WS_PART4_SUB_DELAY_MS_DEFAULT)){
    wsLoaderPart4SubTier='patience';
    wsLoaderPart4SetSub(wsT('loader.part4.patience_sub'));
    return;
  }
  if(sub){
    sub.textContent='';
    sub.hidden=true;
    sub.classList.add('ld-msg__hold-sub--deferred');
    sub.classList.remove('ld-msg__hold-sub--tap','ld-msg__hold-sub--long-wait','ld-msg__hold-sub--punchline');
  }
}
/** Part 4 final-screen copy (head + deferred sub). */
function wsLoaderApplyRenderingHoldDom(el){
  if(!el)return;
  el.textContent='';
  el.classList.add('ld-msg--hold-split');
  el.setAttribute('role','status');
  const head=document.createElement('span');
  head.className='ld-msg__hold-head';
  head.textContent=wsT('loader.poll.status.rendering_head');
  const br=document.createElement('br');
  br.setAttribute('aria-hidden','true');
  const sub=document.createElement('span');
  sub.className='ld-msg__hold-sub ld-msg__hold-sub--deferred';
  sub.hidden=true;
  sub.textContent='';
  el.appendChild(head);
  el.appendChild(br);
  el.appendChild(sub);
}
function wsLoaderSetLdMsgRenderingHold(){
  const el=document.getElementById('ldMsg');
  if(!el)return;
  const apply=()=>{
    el.classList.remove('ld-msg--quote');
    el.classList.add('ld-msg--hold');
    wsLoaderApplyRenderingHoldDom(el);
    el.classList.remove('ld-msg--fade-out');
  };
  if(wsLoaderPrefersReducedMotion()){
    apply();
    wsLoaderClearPart4MessageSwapState(el);
    el.classList.add('ld-msg--part4-reveal-on');
    wsLoaderPart4Start();
    return;
  }
  const my=++wsLoaderMsgFadeToken;
  const nextFrame=typeof requestAnimationFrame==='function'
    ? requestAnimationFrame.bind(window)
    : cb=>setTimeout(cb,16);
  wsLoaderPrimePart4MessageSwap(el);
  apply();
  nextFrame(()=>{
    if(my!==wsLoaderMsgFadeToken)return;
    el.classList.remove('ld-msg--part4-swap');
    if(ldEl)ldEl.classList.remove('ld--part4-copy-swap');
    el.classList.add('ld-msg--part4-reveal-on');
    wsLoaderPart4Start();
  });
}
function wsLoaderStatusLineKey(i){
  return'loader.status.'+String((i%7)+1);
}
function wsLoaderStatusDwellForLineIdx(idx){
  // Post-poll: uniform 3000ms once `loaderPollRealMode` is active (PR8).
  // Pre-poll: lines 1–3 = 6s; lines 4–7 = 10s (operator Jun 2026).
  if(loaderPollRealMode){
    return WS_PART3_POST_POLL_DWELL_MS;
  }
  if(idx>=3)return WS_PART3_LINE_LATE_DWELL_MS;
  return WS_PART3_LINE_EARLY_DWELL_MS;
}
function wsLoaderClearIntroTimers(){
  loaderIntroTimeouts.forEach(t=>{clearTimeout(t);});
  loaderIntroTimeouts=[];
  if(loaderIntroBurstFallbackId!==null){
    clearTimeout(loaderIntroBurstFallbackId);
    loaderIntroBurstFallbackId=null;
  }
}
function wsLoaderStopOrbModeAlternation(){
  if(loaderOrbModeHandle!==null){
    clearInterval(loaderOrbModeHandle);
    loaderOrbModeHandle=null;
  }
  if(ldEl)ldEl.classList.remove('ld--orb-mode-hold');
}
/** Burst-style orb (default) vs compact shell (`ws-loader-orb-particles.css` Hold keyframes) — reduced motion: off. */
function wsLoaderStartOrbModeAlternation(){
  wsLoaderStopOrbModeAlternation();
  if(wsLoaderPrefersReducedMotion()||!ldEl)return;
  loaderOrbModeHandle=setInterval(()=>{
    if(!ldEl||!ldEl.classList.contains('ld--status-orb-on')||ldEl.classList.contains('ld--flowfield-fullscreen')){
      wsLoaderStopOrbModeAlternation();
      return;
    }
    if(ldEl.classList.contains('ld--status-orb-fadeout'))return;
    ldEl.classList.toggle('ld--orb-mode-hold');
  },WS_LD_ORB_MODE_TOGGLE_MS);
}
function wsLoaderStopSevenLineRotation(){
  if(loaderSevenLineHandle!==null){
    clearTimeout(loaderSevenLineHandle);
    loaderSevenLineHandle=null;
  }
  wsLoaderStopOrbModeAlternation();
}
function wsLoaderResetCinematicUi(){
  wsLoaderPart4Stop();
  wsLoaderFlowfieldInvoke('stop');
  wsLoaderClearIntroTimers();
  wsLoaderStopSevenLineRotation();
  loaderIntroPostBurstScheduled=false;
  loaderIntroHandsOutAt=0;
  loaderStatusMode='idle';
  if(ldEl){
    ldEl.classList.remove('ld--cinematic-active','ld--cinematic-done','ld-cinematic--hands-in','ld-cinematic--burst','ld-cinematic--hands-out','ld--cinematic-show-hero','ld--cinematic-show-status','ld--status-orb-on','ld--status-orb-fadeout','ld--orb-mode-hold','ld--loader-skip-photo-burst','ld--flowfield-active','ld--flowfield-fullscreen');
    ldEl.removeAttribute('data-ws-generation-phase');
  }
  const burst=document.getElementById('ldCinematicBurst');
  if(burst){burst.innerHTML='';burst.setAttribute('hidden','');}
  const ph=document.getElementById('ldCinematicPhoto');
  if(ph){ph.removeAttribute('src');ph.src='';}
  const msg=document.getElementById('ldMsg');
  if(msg){
    wsLoaderClearPart4MessageSwapState(msg);
    msg.removeAttribute('aria-hidden');
  }
}
function wsLoaderShardCountForViewport(){
  try{
    if(typeof window.matchMedia==='function'&&window.matchMedia('(max-width:600px)').matches)return 10;
  }catch(_){}
  return 18;
}
function wsLoaderIntroDelayAfterBurstMs(){
  const n=wsLoaderShardCountForViewport();
  const maxStagger=Math.max(0,n-1)*WS_LD_SHARD_STAGGER_MS;
  return WS_LD_SHARD_ANIM_MS+maxStagger+WS_LD_POST_SHARD_LINGER_MS;
}
/** @see wsLoaderBeginIntro */
function wsLoaderIsFastCinematicIntro(){
  return typeof window.WS_LOADER_FAST_CINEMATIC==='boolean'&&window.WS_LOADER_FAST_CINEMATIC===true;
}
function wsLoaderFireBurstFromHands(){
  if(ldEl&&ldEl.classList.contains('ld--loader-skip-photo-burst'))return;
  if(!ldEl||!ldEl.classList.contains('show'))return;
  if(!ldEl.classList.contains('ld-cinematic--burst')){
    ldEl.classList.add('ld-cinematic--burst');
    wsLoaderFillBurstShards();
  }
  if(loaderIntroPostBurstScheduled)return;
  loaderIntroPostBurstScheduled=true;
  loaderIntroTimeouts.push(setTimeout(wsLoaderIntroAfterBurst,wsLoaderIntroDelayAfterBurstMs()));
}
function wsLoaderFillBurstShards(){
  const root=document.getElementById('ldCinematicBurst');
  if(!root||wsLoaderPrefersReducedMotion())return;
  if(ldEl&&ldEl.classList.contains('ld--loader-skip-photo-burst'))return;
  root.innerHTML='';
  root.removeAttribute('hidden');
  const narrow=typeof window.matchMedia==='function'&&window.matchMedia('(max-width:600px)').matches;
  const n=narrow?10:18;
  const frag=document.createDocumentFragment();
  for(let i=0;i<n;i++){
    const s=document.createElement('span');
    s.className='ld-cinematic__shard';
    const ang=(Math.PI*2*i)/n+Math.random()*0.35;
    const dist=72+Math.random()*88;
    s.style.setProperty('--shard-x',(Math.cos(ang)*dist).toFixed(1)+'px');
    s.style.setProperty('--shard-y',(Math.sin(ang)*dist).toFixed(1)+'px');
    s.style.setProperty('--shard-r',(Math.random()*140-70).toFixed(1)+'deg');
    s.style.setProperty('--shard-d',String(i*26)+'ms');
    frag.appendChild(s);
  }
  root.appendChild(frag);
}
function wsEarlyPollMinPart3Enabled(){
  return typeof window.WS_EARLY_POLL_MIN_PART3!=='boolean'||window.WS_EARLY_POLL_MIN_PART3!==false;
}
function wsLoaderPart3FloorSatisfied(){
  if(!wsEarlyPollMinPart3Enabled())return true;
  if(loaderSevenLineIdx>=3)return true;
  if(loaderPart3StartedAt>0&&Date.now()-loaderPart3StartedAt>=WS_EARLY_POLL_MIN_PART3_MS)return true;
  return false;
}
/** Defer Part 4 until Part 3 floor when first 202 arrives during seven-line mode (EARLY-POLL-REFINE). */
function wsLoaderMaybeEnterPart4FromActivePoll(){
  if(!loaderPollSkipPart3Requested||!loaderPollRealMode)return;
  if(!wsLoaderPart3FloorSatisfied())return;
  wsLoaderEnterPart4FromActivePoll();
}
/** Enter Part 4 fullscreen + rendering hold when async poll is active (skip remaining Part 3 dwells). */
function wsLoaderEnterPart4FromActivePoll(){
  if(!ldEl||!ldEl.classList.contains('show'))return;
  if(ldEl.classList.contains('ld--flowfield-fullscreen'))return;
  const m=document.getElementById('ldMsg');
  if(!m)return;
  if(loaderSevenLineHandle!==null){
    clearTimeout(loaderSevenLineHandle);
    loaderSevenLineHandle=null;
  }
  loaderStatusMode='hold';
  const goPart4=()=>{
    wsLoaderStopOrbModeAlternation();
    if(ldEl){
      ldEl.classList.remove('ld--status-orb-on','ld--status-orb-fadeout');
      ldEl.classList.add('ld--flowfield-fullscreen');
    }
    wsLoaderPrimePart4MessageSwap(m);
    m.classList.remove('ld-msg--quote');
    wsLoaderSetLdMsgRenderingHold();
    wsLoaderRevealBegin();
  };
  if(wsLoaderPrefersReducedMotion()){
    goPart4();
    return;
  }
  if(ldEl)ldEl.classList.add('ld--status-orb-fadeout');
  loaderSevenLineHandle=setTimeout(()=>{
    loaderSevenLineHandle=null;
    goPart4();
  },WS_LD_STATUS_ORB_FADE_MS);
}
function wsLoaderStartSevenLineRotation(){
  wsLoaderStopSevenLineRotation();
  const m=document.getElementById('ldMsg');
  if(!m)return;
  wsLoaderClearPart4MessageSwapState(m);
  m.removeAttribute('role');
  m.classList.remove('ld-msg--quote','ld-msg--hold','ld-msg--hold-split','ld-msg--fade-out');
  loaderSevenLineIdx=0;
  loaderPart3StartedAt=Date.now();
  loaderStatusMode='seven';
  wsLoaderMsgFadeToken++;
  m.textContent=wsT(wsLoaderStatusLineKey(0));
  if(ldEl&&!wsLoaderPrefersReducedMotion())ldEl.classList.add('ld--status-orb-on');
  wsLoaderStartOrbModeAlternation();
  if(loaderPollSkipPart3Requested){
    wsLoaderMaybeEnterPart4FromActivePoll();
    if(loaderStatusMode!=='seven')return;
  }
  const step=()=>{
    if(!m||!ldEl||!ldEl.classList.contains('show')){
      loaderSevenLineHandle=null;
      return;
    }
    if(loaderStatusMode!=='seven'){
      loaderSevenLineHandle=null;
      return;
    }
    if(loaderSevenLineIdx>=6){
      loaderStatusMode='hold';
      loaderSevenLineHandle=null;
      /* Part 4: fade orb out, then fullscreen layout + hold copy + progressive
         portrait reveal (R-PART4-REVEAL; replaces flowfield particle canvas).
         Layout chrome uses `ld--flowfield-fullscreen` on `#ld` inline — the
         external ws-loader-flowfield.js script is no longer loaded. */
      const goPart4=()=>{
        wsLoaderStopOrbModeAlternation();
        if(ldEl){
          ldEl.classList.remove('ld--status-orb-on','ld--status-orb-fadeout');
          ldEl.classList.add('ld--flowfield-fullscreen');
        }
        wsLoaderPrimePart4MessageSwap(m);
        m.classList.remove('ld-msg--quote');
        wsLoaderSetLdMsgRenderingHold();
        wsLoaderRevealBegin();
      };
      if(wsLoaderPrefersReducedMotion()){
        goPart4();
        return;
      }
      if(ldEl)ldEl.classList.add('ld--status-orb-fadeout');
      loaderSevenLineHandle=setTimeout(()=>{
        loaderSevenLineHandle=null;
        goPart4();
      },WS_LD_STATUS_ORB_FADE_MS);
      return;
    }
    loaderSevenLineIdx++;
    wsLoaderSetLdMsgResolved(wsT(wsLoaderStatusLineKey(loaderSevenLineIdx)));
    if(loaderPollSkipPart3Requested){
      wsLoaderMaybeEnterPart4FromActivePoll();
      if(loaderStatusMode!=='seven')return;
    }
    loaderSevenLineHandle=setTimeout(step,wsLoaderStatusDwellForLineIdx(loaderSevenLineIdx));
  };
  loaderSevenLineHandle=setTimeout(step,wsLoaderStatusDwellForLineIdx(0));
}
function wsLoaderIntroReducedMotionFinish(){
  if(!ldEl||!ldEl.classList.contains('show'))return;
  wsLoaderClearIntroTimers();
  if(loaderIntroBurstFallbackId!==null){clearTimeout(loaderIntroBurstFallbackId);loaderIntroBurstFallbackId=null;}
  ldEl.classList.remove('ld-cinematic--hands-in','ld-cinematic--burst','ld-cinematic--hands-out','ld--cinematic-show-hero','ld--cinematic-show-status');
  ldEl.classList.remove('ld--cinematic-active');
  ldEl.classList.add('ld--cinematic-done');
  const burst=document.getElementById('ldCinematicBurst');
  if(burst){burst.innerHTML='';burst.setAttribute('hidden','');}
  const m=document.getElementById('ldMsg');
  if(m)m.removeAttribute('aria-hidden');
  wsLoaderStartSevenLineRotation();
}
/** Wait until shopper photo column fade (hands-out → hidden shell) has had its CSS duration before Part 2 hero. */
function wsLoaderScheduleRevealHeroAfterPhotoShellFade(){
  if(!ldEl||!ldEl.classList.contains('show'))return;
  if(ldEl.classList.contains('ld--cinematic-done'))return;
  const slackMs=50;
  const elapsed=loaderIntroHandsOutAt?(typeof performance!=='undefined'&&performance.now?performance.now():Date.now())-loaderIntroHandsOutAt:0;
  const remain=Math.max(0,WS_LD_PHOTO_SHELL_FADE_MS+slackMs-Math.max(0,elapsed));
  const go=()=>wsLoaderIntroRevealHero();
  if(remain<=0){
    if(typeof requestAnimationFrame==='function')requestAnimationFrame(go);
    else go();
    return;
  }
  loaderIntroTimeouts.push(setTimeout(go,remain));
}
function wsLoaderIntroAfterBurst(){
  if(!ldEl||!ldEl.classList.contains('show'))return;
  if(ldEl.classList.contains('ld--cinematic-done'))return;
  wsLoaderClearIntroTimers();
  if(loaderIntroBurstFallbackId!==null){clearTimeout(loaderIntroBurstFallbackId);loaderIntroBurstFallbackId=null;}
  const burst=document.getElementById('ldCinematicBurst');
  if(burst){burst.innerHTML='';burst.setAttribute('hidden','');}
  ldEl.classList.remove('ld-cinematic--hands-in','ld-cinematic--burst');
  ldEl.classList.add('ld-cinematic--hands-out');
  loaderIntroHandsOutAt=typeof performance!=='undefined'&&performance.now?performance.now():Date.now();
  const handL=ldEl.querySelector('.ld-cinematic__hand--left');
  if(!handL){wsLoaderScheduleRevealHeroAfterPhotoShellFade();return;}
  let handsOutSettled=false;
  let fallbackId=null;
  const finishHandsOut=()=>{
    if(handsOutSettled)return;
    handsOutSettled=true;
    handL.removeEventListener('transitionend',onHandsOut);
    if(fallbackId!==null){
      clearTimeout(fallbackId);
      fallbackId=null;
    }
    wsLoaderScheduleRevealHeroAfterPhotoShellFade();
  };
  const onHandsOut=(ev)=>{
    if(ev.propertyName!=='opacity')return;
    finishHandsOut();
  };
  handL.addEventListener('transitionend',onHandsOut);
  fallbackId=setTimeout(finishHandsOut,WS_LD_HANDS_FADE_MS+180);
  loaderIntroTimeouts.push(fallbackId);
}
function wsLoaderIntroRevealHero(){
  if(!ldEl||!ldEl.classList.contains('show'))return;
  if(ldEl.classList.contains('ld--cinematic-done'))return;
  if(ldEl.classList.contains('ld--cinematic-show-hero'))return;
  /*
    Keep `ld-cinematic--hands-out` here: removing it lets `.ld-cinematic__hand--*` fall back to
    off-screen transforms + opacity 1 with a 1.15s transform transition — reads as hands
    reappearing and sliding away. Fade-out pose stays pinned until wsLoaderIntroFinishCinematicShell.
  */
  ldEl.classList.add('ld--cinematic-show-hero');
  loaderIntroTimeouts.push(setTimeout(wsLoaderIntroCrossfadeToStatus,WS_LD_CINEMA_HERO_DWELL_MS));
}
function wsLoaderIntroCrossfadeToStatus(){
  if(!ldEl||!ldEl.classList.contains('show'))return;
  if(ldEl.classList.contains('ld--cinematic-done'))return;
  if(ldEl.classList.contains('ld--cinematic-show-status'))return;
  ldEl.classList.remove('ld--cinematic-show-hero');
  ldEl.classList.add('ld--cinematic-show-status');
  const m=document.getElementById('ldMsg');
  if(m)m.removeAttribute('aria-hidden');
  wsLoaderStartSevenLineRotation();
  loaderIntroTimeouts.push(setTimeout(wsLoaderIntroFinishCinematicShell,WS_LD_CINEMA_STATUS_TO_DONE_MS));
}
function wsLoaderIntroFinishCinematicShell(){
  if(!ldEl||!ldEl.classList.contains('show'))return;
  if(ldEl.classList.contains('ld--cinematic-done'))return;
  ldEl.classList.remove('ld--cinematic-active','ld--cinematic-show-status','ld-cinematic--hands-out','ld-cinematic--hands-in','ld-cinematic--burst','ld--loader-skip-photo-burst');
  ldEl.classList.add('ld--cinematic-done');
}
function wsLoaderBeginIntro(){
  wsLoaderResetCinematicUi();
  if(!ldEl)return;
  const m=document.getElementById('ldMsg');
  if(m){
    m.textContent='';
    m.setAttribute('aria-hidden','true');
  }
  ldEl.classList.remove('ld--cinematic-done');
  ldEl.classList.add('ld--cinematic-active');
  const ph=document.getElementById('ldCinematicPhoto');
  const fastSkip=wsLoaderIsFastCinematicIntro();
  if(wsLoaderPrefersReducedMotion()&&!fastSkip){
    if(ph){
      if(typeof S!=='undefined'&&S&&S.b64){
        const mime=S.file&&S.file.type||'image/jpeg';
        ph.src='data:'+mime+';base64,'+S.b64;
      }else{
        const pv=document.getElementById('preview');
        const src=pv&&(pv.currentSrc||pv.src||'');
        if(String(src||'').trim())ph.src=src;
      }
    }
    loaderIntroTimeouts.push(setTimeout(wsLoaderIntroReducedMotionFinish,300));
    return;
  }
  if(fastSkip)ldEl.classList.add('ld--loader-skip-photo-burst');
  if(!fastSkip&&ph){
    if(typeof S!=='undefined'&&S&&S.b64){
      const mime=S.file&&S.file.type||'image/jpeg';
      ph.src='data:'+mime+';base64,'+S.b64;
    }else{
      const pv=document.getElementById('preview');
      const src=pv&&(pv.currentSrc||pv.src||'');
      if(String(src||'').trim())ph.src=src;
    }
  }
  if(fastSkip){
    requestAnimationFrame(()=>{
      if(!ldEl||!ldEl.classList.contains('ld--cinematic-active'))return;
      ldEl.classList.add('ld-cinematic--hands-in');
      const handL=ldEl.querySelector('.ld-cinematic__hand--left');
      const scheduleAfterBurstPhase=()=>{
        loaderIntroTimeouts.push(setTimeout(wsLoaderIntroAfterBurst,WS_LD_FAST_INTRO_HANDS_DWELL_MS));
      };
      if(!handL){
        scheduleAfterBurstPhase();
        return;
      }
      const onHandsTe=(ev)=>{
        if(ev.propertyName!=='transform')return;
        handL.removeEventListener('transitionend',onHandsTe);
        if(loaderIntroBurstFallbackId!==null){clearTimeout(loaderIntroBurstFallbackId); loaderIntroBurstFallbackId=null;}
        if(!ldEl||!ldEl.classList.contains('ld-cinematic--hands-in'))return;
        scheduleAfterBurstPhase();
      };
      handL.addEventListener('transitionend',onHandsTe);
      loaderIntroBurstFallbackId=setTimeout(()=>{
        loaderIntroBurstFallbackId=null;
        handL.removeEventListener('transitionend',onHandsTe);
        scheduleAfterBurstPhase();
      },1200);
    });
    return;
  }
  requestAnimationFrame(()=>{
    requestAnimationFrame(()=>{
      if(ldEl)ldEl.classList.add('ld-cinematic--hands-in');
      const handL=ldEl&&ldEl.querySelector('.ld-cinematic__hand--left');
      if(!handL||!ldEl.classList.contains('ld--cinematic-active'))return;
      const onHandsTe=(ev)=>{
        if(ev.propertyName!=='transform')return;
        handL.removeEventListener('transitionend',onHandsTe);
        if(loaderIntroBurstFallbackId!==null){
          clearTimeout(loaderIntroBurstFallbackId);
          loaderIntroBurstFallbackId=null;
        }
        if(!ldEl||!ldEl.classList.contains('ld-cinematic--hands-in'))return;
        wsLoaderFireBurstFromHands();
      };
      handL.addEventListener('transitionend',onHandsTe);
      loaderIntroBurstFallbackId=setTimeout(()=>{
        loaderIntroBurstFallbackId=null;
        handL.removeEventListener('transitionend',onHandsTe);
        wsLoaderFireBurstFromHands();
      },2000);
    });
  });
}
function startLd(){
  if(ldT)clearInterval(ldT);
  loaderPollRealMode=false;
  loaderPollSkipPart3Requested=false;
  loaderPart3StartedAt=0;
  wsRestoreLdPctProgressbarSemantics();
  wsResetLateLoaderExtras();
  if(!ldEl||!ldPct||!ldMsg)return;
  wsResetLoaderHalftone();
  ldEl.classList.add('show');
  ldEl.setAttribute('aria-hidden','false');
  ldEl.setAttribute('aria-busy','true');
  document.body.style.overflow='hidden';
  loaderFakePctLast=0;
  wsSetLoaderPct(0);
  if(ldEl)ldEl.classList.add('ld--pct-idle');
  ldMsg.textContent='';
  ldMsg.removeAttribute('role');
  ldMsg.classList.remove('ld-msg--quote','ld-msg--hold','ld-msg--hold-split');
  wsLoaderPart4Stop();
  wsLoaderRevealReset();
  wsLoaderRevealTapResetSession();
  ['d1','d2','d3','d4'].forEach(id=>{const el=$('#'+id);if(el)el.classList.remove('on');});
  wsLoaderBeginIntro();
}
function stopLd(ok, opt){
  opt=opt&&typeof opt==='object'?opt:{};
  if(ldT)clearInterval(ldT);
  ldT=undefined;
  wsLoaderStopSevenLineRotation();
  wsLoaderResetCinematicUi();
  const usedPollProgressUx=loaderPollRealMode;
  if(loaderPollRealMode){
    loaderPollRealMode=false;
    wsRestoreLdPctProgressbarSemantics();
  }
  wsResetLateLoaderExtras();
  if(!ldEl||!ldPct||!ldMsg){document.body.style.overflow='';return;}
  if(ok&&opt.immediateReveal){
    wsResetLoaderHalftone();
    ldEl.classList.remove('show');
    ldEl.setAttribute('aria-hidden','true');
    wsLoaderClearAriaBusy();
    document.body.style.overflow='';
    return;
  }
  const raw=parseInt(ldPct.getAttribute('aria-valuenow'),10);
  const closingFromPct=usedPollProgressUx
    ?92
    :(Number.isFinite(raw)?Math.min(99,Math.max(0,raw)):Math.min(99,Math.max(0,loaderFakePctLast||0)));
  if(ok){
    const tail=[];
    for(const t of [94,95,96,97,98,99]){
      if(t>closingFromPct)tail.push(t);
    }
    let i=0;
    const finishOk=()=>{
      wsSetLoaderPct(100);
      ldMsg.textContent=wsT('loader.done');
      ldMsg.removeAttribute('role');
      ldMsg.classList.remove('ld-msg--quote','ld-msg--hold','ld-msg--hold-split');
      ['d1','d2','d3','d4'].forEach(id=>{const el=$('#'+id);if(el)el.classList.add('on');});
      setTimeout(()=>{
        wsResetLoaderHalftone();
        ldEl.classList.remove('show');
        ldEl.setAttribute('aria-hidden','true');
        wsLoaderClearAriaBusy();
        document.body.style.overflow='';
      },600);
    };
    const tick=()=>{
      if(i<tail.length){
        wsSetLoaderPct(tail[i]);
        loaderFakePctLast=tail[i];
        i++;
        setTimeout(tick,135);
      }else{
        finishOk();
      }
    };
    tick();
  }else{
    wsResetLoaderHalftone();
    ldEl.classList.remove('show');
    ldEl.setAttribute('aria-hidden','true');
    wsLoaderClearAriaBusy();
    document.body.style.overflow='';
  }
}

/** Phase 2 publish bridge — Meta + Shopify customer events allowlist.
 *  Custom events only (Shopify forbids publishing standard events from theme
 *  per https://shopify.dev/docs/api/web-pixels-api/emitting-data; Meta custom
 *  events use `fbq('trackCustom', ...)` per
 *  https://developers.facebook.com/docs/meta-pixel/advanced).
 *  The `ViewContent` standard event is fired separately by
 *  `wsFireViewContentOnce()` via `fbq('track', ...)`. */
const WS_FUNNEL_PUBLISH_ALLOWLIST=new Set([
  'photo_uploaded',
  'generate_clicked',
  'generate_started',
  'preview_generated',
  'generate_failed',
  'result_shown',
  'add_to_cart_attempt',
  'add_to_cart_success',
  'add_to_cart_error',
  'checkout_click',
  'material_size_selected',
  'style_nudge_shown',
  'style_nudge_accepted',
  'style_nudge_dismissed',
  'category_auto_routed',
  'portrait_inscription_offered',
  'portrait_inscription_confirmed',
  'portrait_inscription_skipped',
  'portrait_inscription_dismissed',
  'portrait_inscription_rejected',
  'cart_drawer_opened',
  'style_card_exposed',
  'style_card_selected'
]);
function wsPublishCustomerEvent(name,data){
  if(typeof window==='undefined')return;
  const evtName=String(name||'').trim();
  if(!evtName)return;
  const payload=(data&&typeof data==='object')?data:{};
  try{
    if(window.Shopify&&window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function'){
      window.Shopify.analytics.publish('wallstraight:'+evtName,payload);
    }
  }catch(_){/* never break the funnel for telemetry */}
  try{
    if(typeof window.fbq==='function'){
      window.fbq('trackCustom','WS_'+evtName,payload);
    }
  }catch(_){/* never break the funnel for telemetry */}
}
/** R-ROYAL-CHECKOUT v17 — browser-side funnel breadcrumbs for QA + Phase 2 Meta bridge.
 *  Inspect `window.__WS_FUNNEL_EVENTS__` after a session to separate
 *  image-quality questions from product/checkout interaction friction. */
const WS_WK_UTM_STORAGE_KEY='ws_utm_v1';
const WS_WK_FINAL_MS=Date.parse('2026-07-19T23:59:59+02:00');
function wsIsWkOranjeMode(){
  try{
    return !!(typeof window!=='undefined'&&(window.WS_WK_ORANJE_MODE===true||window.WS_WK_ORANJE===true));
  }catch(_){return false;}
}
function wsCaptureWkUtmParams(){
  if(!wsIsWkOranjeMode())return;
  try{
    const u=new URL(window.location.href);
    const campaign=String(u.searchParams.get('utm_campaign')||'').trim();
    const source=String(u.searchParams.get('utm_source')||'').trim();
    const medium=String(u.searchParams.get('utm_medium')||'').trim();
    if(!campaign&&!source&&!medium)return;
    let prev={};
    try{prev=JSON.parse(sessionStorage.getItem(WS_WK_UTM_STORAGE_KEY)||'{}');}catch(_){prev={};}
    const next={...(prev&&typeof prev==='object'?prev:{})};
    if(campaign)next.utm_campaign=campaign.slice(0,120);
    if(source)next.utm_source=source.slice(0,120);
    if(medium)next.utm_medium=medium.slice(0,120);
    sessionStorage.setItem(WS_WK_UTM_STORAGE_KEY,JSON.stringify(next));
  }catch(_){/* attribution is best-effort */}
}
function wsReadWkUtmAttribution(){
  try{
    const raw=sessionStorage.getItem(WS_WK_UTM_STORAGE_KEY);
    if(!raw)return null;
    const o=JSON.parse(raw);
    return (o&&typeof o==='object')?o:null;
  }catch(_){return null;}
}
function wsApplyWkOranjeBuyDefaults(){
  if(!wsIsWkOranjeMode())return;
  const root=document.getElementById('wallstraight-generator');
  if(!root)return;
  const canvasSel=root.querySelector('select[data-ws-variant-select="canvas"]');
  if(canvasSel){
    const sOpt=Array.from(canvasSel.options).find(o=>String(o.value||'').toLowerCase()==='s'&&!o.disabled);
    if(sOpt){
      wsSyncTwinVariantSelects('canvas','s');
      wsRememberPrintIntent('canvas',canvasSel);
      try{updPrice('canvas');}catch(_){}
    }
  }
}
function wsInitWkCountdown(){
  const daysEl=document.getElementById('wsWkCountdownDays');
  const srEl=document.getElementById('wsWkCountdown');
  if(!daysEl||!wsIsWkOranjeMode())return;
  const tick=()=>{
    const ms=WS_WK_FINAL_MS-Date.now();
    if(ms<=0){
      daysEl.textContent=wsT('wk.oranje.countdown.final_label');
      if(srEl)srEl.textContent=wsT('wk.oranje.countdown.done');
      return;
    }
    const d=Math.floor(ms/86400000);
    const h=Math.floor((ms%86400000)/3600000);
    daysEl.textContent=String(wsT('wk.oranje.countdown.days')||'').replace(/\{0\}/g,String(d));
    if(srEl)srEl.textContent=String(wsT('wk.oranje.countdown.line')||'').replace(/\{0\}/g,String(d)).replace(/\{1\}/g,String(h));
  };
  tick();
  window.setInterval(tick,60000);
}
function wsApplyWkOranjeColdStart(){
  if(!wsIsWkOranjeMode())return;
  if(typeof wsRecoveryDeferredWizard!=='undefined'&&wsRecoveryDeferredWizard)return;
  const parsed=wsRecoveryParseUrl(window.location.href);
  const inferEnabled=wsIsCategoryInferEnabled();
  const inferUploadFirst=inferEnabled&&wsFunnelOrder()==='upload_style';
  const inferStyleFirst=inferEnabled&&wsFunnelOrder()==='style_upload';
  const allowedCat=['huisdier','gezin','koppel','kind','zelf'];
  const catFromUrl=(parsed.cat&&allowedCat.includes(parsed.cat))?parsed.cat:null;
  if(catFromUrl){
    const pill=document.querySelector('#pills .pill[data-c="'+catFromUrl+'"]');
    if(pill){
      $$('.pill').forEach(x=>x.classList.remove('on'));
      pill.classList.add('on');
      S.cat=catFromUrl;
    }
  }else if(!inferUploadFirst&&!inferStyleFirst){
    const cat='zelf';
    const pill=document.querySelector('#pills .pill[data-c="'+cat+'"]');
    if(pill){
      $$('.pill').forEach(x=>x.classList.remove('on'));
      pill.classList.add('on');
      S.cat=cat;
    }
  }
  const styleSlug=String(parsed.style||'').trim();
  const wkSlugs=['wk_panini_held','wk_stadionlegende','wk_vintage_poster','wk_mancave_portret','world_cup_football'];
  let sty=null;
  if(styleSlug&&wkSlugs.includes(styleSlug)){
    sty=document.querySelector('#wkOranjeStyleGrid .sty[data-s="'+styleSlug+'"]');
  }
  if(!sty&&!inferUploadFirst&&!inferStyleFirst){
    sty=document.querySelector('#wkOranjeStyleGrid .sty[data-s="wk_stadionlegende"]')||document.querySelector('#wkOranjeStyleGrid .sty');
  }
  if(sty){
    $$('.sty').forEach(x=>x.classList.remove('on'));
    sty.classList.add('on');
    sty.querySelectorAll('input[name="s"]').forEach(inp=>{inp.checked=false;});
    const inp=sty.querySelector('input[name="s"]');
    if(inp)inp.checked=true;
    S.style=wsNormalizeStyleKey(sty.dataset.s||'wk_stadionlegende');
  }
  if(inferUploadFirst){
    if(typeof updateGenerateButton==='function')updateGenerateButton();
    return;
  }
  if(inferStyleFirst){
    if(S.style){
      try{showStep(2);}catch(_){/* wizard may not be ready yet */}
    }
    if(typeof updateGenerateButton==='function')updateGenerateButton();
    return;
  }
  if(S.cat&&S.style){
    try{showStep(styleSlug?3:2);}catch(_){/* wizard may not be ready yet */}
  }else if(S.cat){
    try{showStep(2);}catch(_){}
  }
}
function wsInitWkOranjeLanding(){
  if(!wsIsWkOranjeMode())return;
  wsCaptureWkUtmParams();
  wsInitWkCountdown();
  try{
    document.querySelectorAll('#styleGrid .sty').forEach(el=>el.classList.remove('on'));
    document.querySelectorAll('#styleGrid input[name="s"]').forEach(inp=>{inp.checked=false;inp.disabled=true;});
  }catch(_){}
  try{wsRecordFunnelEvent('wk_oranje_landing_view',{utm_campaign:(wsReadWkUtmAttribution()||{}).utm_campaign||null});}catch(_){}
  wsApplyWkOranjeColdStart();
  wsApplyWkOranjeBuyDefaults();
}
function wsRecordFunnelEvent(name,detail){
  try{
    if(typeof window==='undefined')return;
    try{
      if(name==='style_card_selected'||name==='category_infer_selected')window.wsFunnelAnalytics?.record('generator_interaction',{style:S.style,category:S.cat,compositionMode:S.compositionMode});
    }catch(_){}
    let mergedDetail=detail&&typeof detail==='object'?{...detail}:{};
    if(wsIsWkOranjeMode()){
      const utm=wsReadWkUtmAttribution();
      if(utm){
        if(utm.utm_campaign&&!mergedDetail.utm_campaign)mergedDetail.utm_campaign=utm.utm_campaign;
        if(utm.utm_source&&!mergedDetail.utm_source)mergedDetail.utm_source=utm.utm_source;
        if(utm.utm_medium&&!mergedDetail.utm_medium)mergedDetail.utm_medium=utm.utm_medium;
      }
      mergedDetail.wk_oranje_mode=true;
    }
    const event={name:String(name||''),ts:new Date().toISOString(),jobId:S.lastJobId||null,style:S.style||null,category:S.cat||null,promptVersion:WS_PROMPT_VERSION,royalVariant:(S.style==='royal'&&S.cat==='huisdier'&&typeof wsResolveRoyalVariant==='function')?wsResolveRoyalVariant():null,styleCardVariant:(window.__WS_AB__&&window.__WS_AB__.styleCard)||null,detail:Object.keys(mergedDetail).length?mergedDetail:null};
    const list=Array.isArray(window.__WS_FUNNEL_EVENTS__)?window.__WS_FUNNEL_EVENTS__:[];
    list.push(event);
    window.__WS_FUNNEL_EVENTS__=list.slice(-80);
    const counts=window.__WS_FUNNEL_EVENT_COUNTS__&&typeof window.__WS_FUNNEL_EVENT_COUNTS__==='object'?window.__WS_FUNNEL_EVENT_COUNTS__:{};
    counts[event.name]=(counts[event.name]||0)+1;
    window.__WS_FUNNEL_EVENT_COUNTS__=counts;
    if(WS_FUNNEL_PUBLISH_ALLOWLIST.has(event.name)){
      const pubPayload={category:event.category,style:event.style,prompt_version:event.promptVersion,style_card_variant:event.styleCardVariant};
      if(mergedDetail&&typeof mergedDetail==='object'){
        Object.keys(mergedDetail).forEach(k=>{
          const v=mergedDetail[k];
          if(v==null)return;
          if(typeof v==='string'||typeof v==='number'||typeof v==='boolean')pubPayload[k]=v;
        });
      }
      wsPublishCustomerEvent(event.name,pubPayload);
    }
  }catch(_){/* telemetry must never affect checkout */}
}
/** ViewContent (Meta standard event) — fires once per page load on the funnel
 *  landing using `WS_VIEWCONTENT_PAYLOAD` bootstrapped from
 *  `sections/wallstraight-generator.liquid` (ai_product id + price_min).
 *  Standard event per https://developers.facebook.com/docs/meta-pixel/reference. */
let wsViewContentFired=false;
function wsFireViewContentOnce(){
  if(wsViewContentFired)return;
  if(typeof window==='undefined')return;
  if(typeof window.fbq!=='function')return;
  const p=(window.WS_VIEWCONTENT_PAYLOAD&&typeof window.WS_VIEWCONTENT_PAYLOAD==='object')?window.WS_VIEWCONTENT_PAYLOAD:null;
  if(!p)return;
  try{
    const payload={};
    if(p.content_ids)payload.content_ids=Array.isArray(p.content_ids)?p.content_ids:[String(p.content_ids)];
    if(p.content_type)payload.content_type=String(p.content_type);
    if(p.content_name)payload.content_name=String(p.content_name);
    if(typeof p.value==='number'&&Number.isFinite(p.value))payload.value=p.value;
    if(p.currency)payload.currency=String(p.currency);
    window.fbq('track','ViewContent',payload);
    wsViewContentFired=true;
  }catch(_){/* never break funnel */}
}
if(typeof document!=='undefined'){
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wsFireViewContentOnce,{once:true});
  else wsFireViewContentOnce();
}

/** Slice B (Phase 6) — fire WS_style_card_variant exposure event once per
 *  session when the style grid first becomes visible. Uses
 *  IntersectionObserver to avoid firing for users who never scroll to the
 *  wizard. Bucket comes from inline pre-paint script in
 *  sections/wallstraight-generator.liquid. */
let wsStyleCardExposureFired=false;
function wsArmStyleCardExposureOnce(){
  if(wsStyleCardExposureFired)return;
  if(typeof window==='undefined')return;
  if(typeof IntersectionObserver==='undefined'){
    wsFireStyleCardExposure();
    return;
  }
  const grid=document.getElementById('styleGrid');
  if(!grid)return;
  const io=new IntersectionObserver((entries,obs)=>{
    for(const e of entries){
      if(e.isIntersecting){
        wsFireStyleCardExposure();
        obs.disconnect();
        break;
      }
    }
  },{threshold:0.3});
  io.observe(grid);
}
function wsFireStyleCardExposure(){
  if(wsStyleCardExposureFired)return;
  const bucket=(window.__WS_AB__&&window.__WS_AB__.styleCard)||'B';
  if(bucket!=='A'&&bucket!=='B')return;
  wsStyleCardExposureFired=true;
  const layout=(window.__WS_AB__&&window.__WS_AB__.styleCardLayout)||(bucket==='A'?'icons_text':'images_always');
  try{wsRecordFunnelEvent('style_card_exposed',{variant:bucket,layout:layout,forced:!!(window.__WS_AB__&&window.__WS_AB__.styleCardForced)});}catch(_){}
}
/** Preload Step 2 styletile CDN URLs once (mirror Maatkeuze material preload). */
let wsStyletilePreloaded=false;
function wsPreloadStyletilesOnce(){
  if(wsStyletilePreloaded)return;
  const urls=(typeof window!=='undefined'&&window.WS_STYLETILE_URLS&&typeof window.WS_STYLETILE_URLS==='object')?window.WS_STYLETILE_URLS:null;
  if(!urls)return;
  wsStyletilePreloaded=true;
  const head=(typeof document!=='undefined'&&(document.head||document.getElementsByTagName('head')[0]))||null;
  if(!head)return;
  Object.keys(urls).forEach(k=>{
    const url=urls[k];
    if(typeof url!=='string'||!url.trim())return;
    const link=document.createElement('link');
    link.rel='preload';
    link.as='image';
    link.href=url;
    try{link.fetchPriority='low';}catch(_){/* legacy browser */}
    head.appendChild(link);
  });
}
if(typeof document!=='undefined'){
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wsArmStyleCardExposureOnce,{once:true});
  else wsArmStyleCardExposureOnce();
}

// Show result page
/** Slice E — ring buffer of recent successful previews (max 5) for restore-before-checkout. */
const WS_PREVIEW_HISTORY_MAX=5;
function wsFmtPreviewHistoryLabel(item){
  const st=wsStyleName(item.style)||item.style||'';
  const att=item.attempt!=null?item.attempt:'?';
  return '#'+att+(st?' · '+st:'');
}
function wsPushPreviewHistory(entry){
  if(!Array.isArray(S.previewHistory))S.previewHistory=[];
  const jobId=String(entry&&entry.jobId||'').trim();
  if(!jobId)return;
  S.previewHistory=S.previewHistory.filter(e=>e.jobId!==jobId);
  S.previewHistory.push({
    jobId:jobId,
    previewUrl:String(entry.previewUrl||''),
    imgUrl:String(entry.imgUrl||entry.previewUrl||''),
    attempt:Number(entry.attempt)||0,
    style:String(entry.style||''),
    ts:Number(entry.ts)||Date.now(),
  });
  if(S.previewHistory.length>WS_PREVIEW_HISTORY_MAX){
    S.previewHistory=S.previewHistory.slice(-WS_PREVIEW_HISTORY_MAX);
  }
  wsRenderPreviewHistory();
}
function wsRenderPreviewHistory(){
  const root=document.getElementById('resPreviewHistory');
  const strip=document.getElementById('resPreviewHistoryStrip');
  if(!root||!strip)return;
  while(strip.firstChild)strip.removeChild(strip.firstChild);
  const hist=Array.isArray(S.previewHistory)?S.previewHistory:[];
  if(hist.length<2){root.hidden=true;return;}
  root.hidden=false;
  const label=root.querySelector('.res-preview-history__label');
  if(label)label.textContent=wsT('res.preview_history');
  hist.forEach(item=>{
    const btn=document.createElement('button');
    btn.type='button';
    btn.className='res-preview-history__thumb';
    btn.setAttribute('data-ws-protected-preview','');
    if(item.jobId===S.lastJobId)btn.classList.add('is-active');
    btn.title=wsFmtPreviewHistoryLabel(item);
    btn.setAttribute('aria-label',wsFmtPreviewHistoryLabel(item));
    const img=document.createElement('img');
    img.src=item.imgUrl||item.previewUrl||'';
    img.alt='';
    img.loading='lazy';
    img.draggable=false;
    btn.appendChild(img);
    btn.onclick=()=>{void wsRestorePreviewFromHistory(item.jobId);};
    strip.appendChild(btn);
  });
}
async function wsRestorePreviewFromHistory(jobId){
  const id=String(jobId||'').trim();
  const item=(S.previewHistory||[]).find(e=>e.jobId===id);
  if(!item)return;
  S.lastJobId=item.jobId;
  S.lastPreviewUrl=item.previewUrl||'';
  S.imgUrl=item.imgUrl||item.previewUrl||'';
  if(item.style)wsApplyStyleToDom(item.style);
  if(resTag)resTag.textContent=wsStyleName(item.style)||wsStyleName(S.style);
  if(resImg)await wsSetResImage(resImg,S.imgUrl);
  try{
    wsPortraitSessionWrite({jobId:S.lastJobId,previewUrl:S.lastPreviewUrl,shareUrl:S.lastShareUrl,funnelResumeUrl:S.lastFunnelResumeUrl,style:S.style,cat:S.cat});
  }catch(_){}
  wsRefreshPreviewBranding();
  wsRenderPreviewHistory();
  wsRecordFunnelEvent('preview_history_restored',{jobId:id,attempt:item.attempt});
  toast(wsT('toast.preview_restored'));
}

/* ============================================================
   Superhero Storytelling Phase 1 — "Try Again as imagination"
   (plan superhero_storytelling_upgrade_b8e15a7b §3, Track B).

   Theme-only: shopper picks "another story" on #resPage; the tap rides the
   existing retryGenerate('User edit request: …') text_edit path — no new wire
   field (R-TRY2 precedent, R11). CTA copy is evocative; `promptEn` is the
   portrait-safe, reference-conditional reinterpretation the model actually
   receives (R13b dual copy). Seeds are scoped to SUPERHERO — the style lacking
   a storytelling hook; royal already has #ws-scene-picker (do not double up).
   Audience routing: pet = cat 'huisdier'; people = every other category.
   Empty-name pet seeds introduce NO inscription text → corner gate intact
   (no PET PORTRAIT COMPOSITION marker added anywhere here). ============== */
const WS_STORY_SEEDS=[
  {id:'victory_selfie',family:'celebration',audience:'people',styles:['superhero'],promptEn:'Interpret as heroes celebrating right after victory — keep selfie angle, drinks, and smiles; warm sunset sky beyond.'},
  {id:'rooftop_heroes',family:'cinematic',audience:'people',styles:['superhero'],promptEn:'When the reference shows urban or indoor party energy, recompose as a cinematic rooftop sunset celebration — preserve faces, props, and bond.'},
  {id:'sunset_guardians',family:'cinematic',audience:'people',styles:['superhero'],promptEn:'Frame as the final scene of an epic film — golden-hour sky, cape updraft, same poses and expressions.'},
  {id:'above_clouds',family:'flight',audience:'any',styles:['superhero'],promptEn:'Amplify as legendary figures soaring above soft golden clouds — preserve pose, species anatomy, and likeness.'},
  {id:'guardian_leap',family:'flight',audience:'pet',styles:['superhero'],promptEn:'When the reference shows motion, amplify as a guardian mid-leap at golden hour — keep quadruped anatomy and breed markings.'},
  {id:'protector_family',family:'guardian',audience:'pet',styles:['superhero'],promptEn:'Interpret as a devoted protector of the family — heroic warmth, never humanoid pet body.'}
];
/** Seeds eligible for the current style + category (audience match). */
function wsStorySeedsEligible(){
  const style=(typeof wsNormalizeStyleKey==='function')?wsNormalizeStyleKey(S.style||''):String(S.style||'');
  const isPet=String(S.cat||'')==='huisdier';
  return WS_STORY_SEEDS.filter(s=>{
    if(s.styles.indexOf(style)<0)return false;
    if(s.audience==='pet')return isPet;
    if(s.audience==='people')return !isPet;
    return true;
  });
}
/** Deterministic rotate by preview attempt; avoid repeating the last shown seed. */
function wsPickStoryInspiration(){
  const eligible=wsStorySeedsEligible();
  if(!eligible.length)return null;
  const attempt=(typeof S.previewClientAttempt==='number'&&S.previewClientAttempt>0)?S.previewClientAttempt:0;
  let idx=attempt%eligible.length;
  let pick=eligible[idx];
  if(eligible.length>1&&pick&&pick.id===S._lastStorySeedId){
    idx=(idx+1)%eligible.length;
    pick=eligible[idx];
  }
  return pick||null;
}
/** Render/refresh the #resPage story-inspiration card. Called from showResult()
    after preview history. Hidden when no preview budget or no eligible seed. */
function wsRenderStoryInspiration(){
  const card=document.getElementById('wsStoryInspire');
  if(!card)return;
  const noBudget=typeof S.previewRemaining==='number'&&S.previewRemaining<=0;
  const seed=noBudget?null:wsPickStoryInspiration();
  if(!seed){card.hidden=true;return;}
  const titleEl=document.getElementById('wsStoryInspireTitle');
  const descEl=document.getElementById('wsStoryInspireDesc');
  const ctaEl=document.getElementById('wsStoryInspireCta');
  card.hidden=false;
  if(titleEl)titleEl.textContent=wsT('inspire.'+seed.id+'.title');
  if(descEl)descEl.textContent=wsT('inspire.'+seed.id+'.desc');
  if(ctaEl)ctaEl.textContent=wsT('inspire.cta');
  S._lastStorySeedId=seed.id;
  /* Impression — once per (preview, seed) so re-renders of the same view do not spam. */
  const shownKey=(S.lastJobId||'')+':'+seed.id;
  if(S._lastStoryShownKey!==shownKey){
    S._lastStoryShownKey=shownKey;
    wsRecordFunnelEvent('story_inspiration_shown',{story_seed_id:seed.id,story_seed_family:seed.family,surface:'res_card'});
  }
  if(ctaEl){
    ctaEl.onclick=()=>{
      S._pendingStorySeedId=seed.id;
      wsRecordFunnelEvent('story_inspiration_clicked',{story_seed_id:seed.id,story_seed_family:seed.family,surface:'res_card'});
      wsRecordFunnelEvent('story_seed_retry_started',{story_seed_id:seed.id,story_seed_family:seed.family});
      retryGenerate('User edit request: '+seed.promptEn);
    };
  }
}
function showResult(){
  if(landing)landing.style.display='none';
  if(resPage)resPage.classList.add('show');
  window.scrollTo(0,0);
  /* Re-sync all [data-i18n] (including checkout tiers) once this view is active — avoids NL copy
     lingering when EN was chosen earlier or when delayed Weglot/sync runs raced the hidden subtree. */
  wsApplyUiLang(wsDetectLangFromProviders());
  wsSyncResultTierPrices();
  if(wsIsWkOranjeMode())wsApplyWkOranjeBuyDefaults();
  if(typeof wsFinishingInitAll==='function')wsFinishingInitAll();
  if(typeof wsBindResVariantJumpTabs==='function')wsBindResVariantJumpTabs();
  wsSyncResCartFabHref();
  try{
    if(window.wsCartDrawer&&typeof window.wsCartDrawer.refresh==='function'){
      const badge=document.getElementById('wsResCartBadge');
      const n=badge&&!badge.hidden?parseInt(badge.textContent||'0',10):0;
      if(n>0)void window.wsCartDrawer.refresh();
    }
  }catch(_){/* no-op */}
  void wsRefreshResCartFabBadge();
  wsRecordFunnelEvent('result_shown',{hasImage:!!S.imgUrl});
  wsRenderPreviewHistory();
  /* Story-seed retry landed successfully (Phase 1 telemetry). */
  if(S._pendingStorySeedId){
    wsRecordFunnelEvent('story_seed_retry_completed',{story_seed_id:S._pendingStorySeedId});
    S._pendingStorySeedId=null;
  }
  if(typeof wsRenderStoryInspiration==='function')wsRenderStoryInspiration();
  if(typeof wsMaatkeuzeRefreshAllCartBtns==='function')wsMaatkeuzeRefreshAllCartBtns();
}
function showLanding(){
  wsWelcomeOfferOnLeaveResultView();
  wsStudioRecoveryShut();
  if(resPage)resPage.classList.remove('show');
  if(landing)landing.style.display='';
  window.scrollTo(0,0);
  wsApplyUiLang(wsDetectLangFromProviders());
  try{wsLandingCartChipRefresh();}catch(_){/* no-op */}
  try{if(window.wsCartDrawer&&typeof window.wsCartDrawer.refresh==='function')void window.wsCartDrawer.refresh();}catch(_){/* no-op */}
}

function wsErrorMessage(status,code,detail){
  // Existing intentional re-mappings (e.g. quota_exceeded -> err.quota_weekly)
  // keep precedence so brand voice is preserved across legacy and new codes.
  const byCode={
    invalid_signature:wsT('err.invalid_signature'),
    invalid_request:wsT('err.invalid_request'),
    rate_limited:wsT('err.rate_limited'),
    quota_exceeded:wsT('err.quota_weekly'),
    // Slice A.7 cost discipline — shop-wide daily hard cap (photo-unit accounting).
    quota_exceeded_hard_cap:wsT('err.quota_hard_cap'),
    // Slice C.3 guardrails Layer 2 — moderation block. Map the verbose server
    // code to the friendlier `err.content_blocked` UX copy key so brand voice
    // stays consistent. Per D3 contract, repeated triggers fall through to
    // `rate_limited` silently — handled server-side, no client change needed.
    content_policy_blocked:wsT('err.content_blocked'),
    provider_error:wsT('err.provider_error'),
    billing_hard_limit:wsT('err.billing_upstream')
  };
  if(code&&byCode[code])return byCode[code];
  // Generic premium-copy fallback: any server `error.code` with a matching
  // `err.<code>` entry in WS_STR.{nl,en} wins over status-only mapping.
  // Adding a new server code REQUIRES adding a matching dictionary entry
  // or the user falls through to status-based / err.unexpected.
  if(code){
    const k='err.'+code;
    const localized=wsT(k);
    if(localized&&localized!==k)return localized;
  }
  const detailStr=(typeof detail==='string'?detail:'').trim();
  if(wsLooksLikeUpstreamBillingHardLimit(status,code,detailStr,[])){
    return wsT('err.billing_upstream');
  }
  if(status===404)return wsT('err.http404');
  if(status===401||status===403)return wsT('err.http401');
  if(status===413)return wsT('err.http413');
  if(status===415)return wsT('err.unsupported_image_type');
  if(status===429&&!(code&&byCode[code]))return byCode.rate_limited;
  if(status>=500)return byCode.provider_error;
  return detail||wsT('err.unexpected');
}

/** Snapshot job context for studio-recovery worker bind (R-JOB-LINK). Call in generate catch before finally clears state. */
function wsCaptureJobContext(meta){
  let activeRec=null;
  try{activeRec=wsActiveJobRead();}catch(_){}
  const asyncJobId=String(S.inFlightAsyncJobId||activeRec?.jobId||'').trim()||null;
  const wsJobId=String(S.lastJobId||'').trim()||null;
  const errorCode=meta&&meta.code?String(meta.code).trim()||null:null;
  return{
    asyncJobId,
    wsJobId,
    errorCode,
    style:S.style?String(S.style):null,
    category:S.cat?String(S.cat):null
  };
}

/** Reads optional `code` / `status` on Errors augmented via Object.assign (generate / poll paths). */
function wsErrShopperMeta(err){
  if(err==null||typeof err!=='object')return{status:NaN,code:''};
  const st=err.status;
  const status=typeof st==='number'&&Number.isFinite(st)?st:NaN;
  const raw=err.code;
  const code=typeof raw==='string'?raw:'';
  return{status,code};
}
/** True when UX should offer studio recovery (capacity / provider-class failures). */
function wsIsStudioRecoveryClass(meta){
  const code=String(meta&&meta.code||'');
  if(code==='provider_error'||code==='billing_upstream'||code==='billing_hard_limit')return true;
  const st=meta&&meta.status;
  if(typeof st==='number'&&Number.isFinite(st)&&st>=500)return true;
  return false;
}

async function readProxyJson(res){
  const st=res.status;
  const ctRaw=res.headers.get('content-type')||'';
  const type=(ctRaw||'').toLowerCase();
  const declaredJson=type.includes('application/json');
  var rawText='';
  try{rawText=await res.text();}catch(_){rawText='';}
  var trimmed=(rawText||'').trim();
  const previewTrim=(rawText||'').slice(0,400).trim()||'(empty)';
  var parsed=null;
  if(trimmed){
    try{parsed=JSON.parse(trimmed);}catch(_){parsed=null;}
  }
  var isParsedObj=parsed&&typeof parsed==='object'&&!Array.isArray(parsed);
  if(declaredJson){
    if(isParsedObj)return parsed;
    if(wsLooksLikeUpstreamBillingHardLimit(st,'','',[rawText])){
      console.warn('[Wallstraight] generate proxy: billing hard limit',{httpStatus:st,contentType:ctRaw,bodyPreview:previewTrim});
      throw Object.assign(new Error(wsT('err.billing_upstream')),{status:st,code:'billing_upstream'});
    }
    console.warn('[Wallstraight] generate proxy: not valid JSON',{httpStatus:st,contentType:ctRaw,bodyPreview:previewTrim});
    throw Object.assign(new Error(wsT('err.bad_json')),{status:st,code:'invalid_json'});
  }
  if(isParsedObj)return parsed;
  if(st>=400&&wsLooksLikeUpstreamBillingHardLimit(st,'','',[rawText])){
    console.warn('[Wallstraight] generate proxy: billing hard limit',{httpStatus:st,contentType:ctRaw,bodyPreview:previewTrim});
    throw Object.assign(new Error(wsT('err.billing_upstream')),{status:st,code:'billing_upstream'});
  }
  console.warn('[Wallstraight] generate proxy: not application/json',{httpStatus:st,contentType:ctRaw,bodyPreview:previewTrim});
  throw Object.assign(new Error(wsT('err.proxy_non_json')), { status:st, code:'non_json_response' });
}

const WS_INLINE_RESULT_DATA_MAX_CHARS=12*1024*1024;
function wsPreviewDataMime(raw){
  const mime=String(raw||'').toLowerCase().split(';')[0].trim();
  if(mime==='image/jpeg'||mime==='image/jpg'||mime==='jpeg'||mime==='jpg'||mime==='image/pjpeg')return'image/jpeg';
  if(mime==='image/webp'||mime==='webp')return'image/webp';
  if(mime==='image/png'||mime==='png')return'image/png';
  if(mime==='image/avif'||mime==='avif')return'image/avif';
  if(mime==='image/gif'||mime==='gif')return'image/gif';
  if(mime==='image/svg+xml'||mime==='svg'||mime==='svg+xml')return'image/svg+xml';
  return'image/png';
}
function wsGeneratedDataUrl(g){
  if(!g||g.kind!=='data')return'';
  const data=String(g.data||'').trim();
  if(!data||data.length>WS_INLINE_RESULT_DATA_MAX_CHARS)return'';
  if(!/^[A-Za-z0-9+/=\s]+$/.test(data))return'';
  return`data:${wsPreviewDataMime(g.mime)};base64,${data.replace(/\s+/g,'')}`;
}
function extractGeneratedImage(d){
  if(!d||typeof d!=='object')return null;
  const normalized=d.imageBase64||d.image_base64;
  if(normalized)return{kind:'data',data:String(normalized),mime:String(d.mimeType||d.mime_type||'image/png')};
  const parts=d?.candidates?.[0]?.content?.parts;
  if(Array.isArray(parts)){
    for(let i=0;i<parts.length;i++){
      const p=parts[i];
      const id=p&&(p.inlineData||p.inline_data);
      if(id&&typeof id.data==='string'&&id.data.length)return{kind:'data',data:id.data,mime:String(id.mimeType||id.mime_type||'image/png')};
    }
  }
  const previewUrl=d.preview_url||d.previewUrl;
  if(typeof previewUrl==='string'&&/^https?:\/\//i.test(previewUrl.trim()))return{kind:'url',url:String(previewUrl).trim()};
  return null;
}

// Portrait inscription modal — vision-first gate; copy via wsApplyInscriptionModalCopy (Slice B).
function wsInscriptionModalCell(cat){
  if(cat==='huisdier'){
    if(S.compositionMode==='mixed_single_photo')return 'bond';
    if(wsIsIntentionalHumanPetPortrait())return 'bond';
    const slotsArr=Array.isArray(S.slots)?S.slots:[];
    if(slotsArr.length>=2){
      let people=false,pet=false;
      for(let i=0;i<slotsArr.length;i++){
        const r=slotsArr[i]&&slotsArr[i].role;
        if(r==='people')people=true;
        if(r==='pet')pet=true;
      }
      if(people&&pet)return 'bond';
    }
    return 'pet';
  }
  if(cat==='gezin'||cat==='koppel')return 'group';
  return 'solo';
}

function wsFmtInscriptionCta(key,name){
  return String(wsT(key)||'').replace(/\{name\}/g,name);
}

function wsRefreshInscriptionConfirmCta(inp,go,cell){
  if(!go)return;
  const raw=inp?String(inp.value||''):'';
  const name=raw.trim().slice(0,48).replace(/[\r\n<>\"]/g,'');
  const filled=!!name;
  const ineligible=filled?wsIsIneligibleInscriptionText(name):false;
  if(inp)wsSyncInscriptionInputError(inp,ineligible||null);
  go.disabled=!filled||!!ineligible;
  if(cell==='pet'){
    const pk=filled?'inscription.confirm.pet.filled':'inscription.confirm.pet.empty';
    go.textContent=wsT(pk);
    go.setAttribute('data-i18n',pk);
    return;
  }
  if(filled){
    go.textContent=wsFmtInscriptionCta('inscription.confirm.filled',name);
    go.removeAttribute('data-i18n');
  }else{
    go.textContent=wsT('inscription.confirm.empty');
    go.setAttribute('data-i18n','inscription.confirm.empty');
  }
}

function wsApplyInscriptionModalCopy(cell){
  const title=$('#petNameModalTitle');
  const prompt=$('#petNameModalPrompt');
  const sub=$('#petNameModalSubtitle');
  const inp=$('#petNameInput');
  const sk=$('#petNameSkip');
  const go=$('#petNameConfirm');
  const c=cell||wsInscriptionModalCell(S.cat);
  S._inscriptionModalCell=c;
  /* Name-only UX (35+ readability): single title carries the ask; secondary
     prompt + subtitle are always hidden. Cell-specific title keys retained
     so each subject (pet/bond/group/solo) gets the correct phrasing without
     a second paragraph. i18n string values for the now-hidden keys are kept
     intact for SR / future reuse. */
  if(title){
    if(c==='pet'){
      title.textContent=wsT('inscription.pet.title');
      title.setAttribute('data-i18n','inscription.pet.title');
    }else if(c==='bond'){
      title.textContent=wsT('inscription.bond.prompt');
      title.setAttribute('data-i18n','inscription.bond.prompt');
    }else if(c==='group'){
      const pk='inscription.'+c+'.prompt';
      title.textContent=wsT(pk);
      title.setAttribute('data-i18n',pk);
    }else{
      title.textContent=wsT('inscription.headline');
      title.setAttribute('data-i18n','inscription.headline');
    }
  }
  if(prompt)prompt.hidden=true;
  if(sub)sub.hidden=true;
  if(inp){
    let pk='inscription.placeholder.solo';
    if(c==='pet')pk='inscription.placeholder.pet';
    else if(c==='group'||c==='bond')pk='inscription.placeholder.group';
    inp.setAttribute('data-i18n-placeholder',pk);
    inp.placeholder=wsT(pk);
    /* Hidden subtitle is no longer a useful description target; let
       wsSyncInscriptionInputError add petNameInputError when validation
       fails, otherwise no aria-describedby is set. */
    inp.removeAttribute('aria-describedby');
  }
  if(sk){
    sk.textContent=wsT('inscription.skip');
    sk.setAttribute('data-i18n','inscription.skip');
  }
  wsRefreshInscriptionConfirmCta(inp,go,c);
}

function wsShowPetNameModal(){
  const m=$('#petNameModal'),inp=$('#petNameInput'),go=$('#petNameConfirm');
  if(!m||!inp)return false;
  wsSyncStyleAndCategoryFromDom();
  wsApplyInscriptionModalCopy(wsInscriptionModalCell(S.cat));
  inp.value=S.petName||'';
  wsSyncInscriptionInputError(inp,null);
  wsRefreshInscriptionConfirmCta(inp,go,S._inscriptionModalCell);
  m.classList.add('show');
  setTimeout(()=>{try{inp.focus();if(inp.select)inp.select();}catch(_){}},30);
  return true;
}

function wsInscriptionFunnelDetail(extra){
  const base={
    cell:typeof wsInscriptionModalCell==='function'?wsInscriptionModalCell(S.cat):null,
    style:S.style||null,
    category:S.cat||null,
    subjectClass:S.subjectClass||null,
  };
  if(extra&&typeof extra==='object')Object.assign(base,extra);
  return base;
}

function wsRecordPortraitInscriptionEvent(name,extra){
  if(typeof wsRecordFunnelEvent==='function')wsRecordFunnelEvent(name,wsInscriptionFunnelDetail(extra));
}

function wsRefreshPetNameEditLink(){
  const link=document.getElementById('petNameEditLink');
  if(!link)return;
  let step;
  try{
    step=currentStep;
  }catch(_){
    return;
  }
  wsSyncStyleAndCategoryFromDom();
  const hasName=String(S.petName||'').trim()!=='';
  const stepOk=(typeof step==='number'&&step===3);
  const eligible=typeof wsShouldOfferPortraitInscription==='function'&&wsShouldOfferPortraitInscription({cat:S.cat,b64:S.b64,extraPrompt:S.extraPrompt,subjectClass:S.subjectClass,slots:S.slots,compositionMode:S.compositionMode,containsPetSubject:S.containsPetSubject,aiVerifyResult:S.aiVerifyResult});
  const show=stepOk&&eligible;
  link.hidden=!show;
  if(!show)return;
  const i18nKey=hasName?'inscription.edit_link.has_name':'inscription.edit_link';
  link.textContent=wsT(i18nKey);
  link.setAttribute('data-i18n',i18nKey);
}

// Generate — vision-first inscription gate, then generate()
async function startGenerateAttempt(){
  if(S.busy||S.generateLock||!S.b64)return;
  S.generateLock=true;
  S._wsFunnelAttempt=null;S._wsFunnelAttemptPending=true;
  try{S._wsFunnelAttempt=window.wsFunnelAnalytics?.beginAttempt({style:S.style,category:S.cat,compositionMode:S.compositionMode,retryKind:/^User\s+edit\s+request:/i.test(String(S.extraPrompt||'').trim())?'text_edit':'fresh_render',slotCount:Array.isArray(S.slots)?S.slots.length:undefined})??null;}catch(_){}
  try{
  try{if(typeof performance!=='undefined'&&performance.mark)performance.mark('ws_funnel_generate_click');}catch(_){}
  try{wsRecordFunnelEvent('generate_clicked',{attempt:(S._generateAttemptId|0)+1});}catch(_){}
  // Inscription prep uses the Generate button spinner only (`genBtn.classList.add('ld')`
  // below) so the cinematic hands loader does not flash before the modal.
  // Actual generation still calls `startLd()` inside `generate()`.
  wsSyncStyleAndCategoryFromDom();
  S._generateAttemptId=(S._generateAttemptId|0)+1;
  S._generatePrepDone=false;
  S._generateVisionMetaCache=null;
  const offer=wsShouldOfferPortraitInscription();
  if(offer&&String(S.petName||'').trim()!==''){
    await generate();
    return;
  }
  if(offer){
    let prepBusy=false;
    if(genBtn&&!S.busy){
      genBtn.classList.add('ld');
      genBtn.disabled=true;
      prepBusy=true;
    }
    try{
      await wsPrepareGenerateBeforePrompt();
      if(!wsShouldOfferPortraitInscription()){
        await generate();
        return;
      }
      if(!wsShowPetNameModal()){
        await generate();
        return;
      }
      wsRecordPortraitInscriptionEvent('portrait_inscription_offered');
    }finally{
      if(prepBusy&&genBtn&&!S.busy){
        genBtn.classList.remove('ld');
        genBtn.disabled=false;
      }
    }
    return;
  }
  await generate();
  }catch(e){
    // generate() handles its own failures; this covers inscription preparation/setup.
    try{window.wsFunnelAnalytics?.attemptEvent(S._wsFunnelAttempt,'generate_failed',{reason:e&&e.name==='AbortError'?'cancelled':'preparation_failed'});}catch(_){}
    S._wsFunnelAttemptPending=false;
    console.warn('Generate preparation failed',e);
    showErr(wsShopperSafeErrorMessage(e,wsT('generic_err')));
  }finally{S.generateLock=false;}
}
// Attempt metadata is computed explicitly; consuming the ordinal remains a lifecycle action.
function wsBuildPreviewAttemptContext(previousAttempt,retryKind){
  return {clientPreviewAttempt:Math.min(9999,(Number(previousAttempt)||0)+1),retryKind};
}

async function generate(){
  if(S.busy||!S.b64)return;
  if(!genBtn)return;
  // Contract Phase B (style_category_contract_audit_111d9c6d.plan.md §4 / §17):
  // wsSyncStyleAndCategoryFromDom may set S.cat=null when no `.pill.on` exists
  // (browser extension toggling classes, race vs step navigation, scripted POST).
  // Without this guard the storefront posts `category: null`, the server reads
  // `typeof null === "object"` (not "string"), trims to "", and rejects with
  // `missing_category` — burning a roundtrip + Shopify proxy auth + quota tick on
  // a guaranteed failure with English server text instead of localized client toast.
  // Block before POST; require explicit shopper style selection (no silent royal default).
  wsSyncStyleAndCategoryFromDom();
  if(!S.cat){showErr(wsT('err.missing_category'));return;}
  if(!S.style){showErr(wsT('err.missing_style'));return;}
  if(!S._wsFunnelAttemptPending){
    S._wsFunnelAttempt=null;
    try{S._wsFunnelAttempt=window.wsFunnelAnalytics?.beginAttempt({style:S.style,category:S.cat,compositionMode:S.compositionMode,retryKind:/^User\s+edit\s+request:/i.test(String(S.extraPrompt||'').trim())?'text_edit':'fresh_render',slotCount:Array.isArray(S.slots)?S.slots.length:undefined})??null;}catch(_){}
  }
  S._wsFunnelAttemptPending=false;
  const funnelAttempt=S._wsFunnelAttempt;
  let funnelPhase='preparation',funnelHttpStatus,funnelAsyncJobId;
  // Preparation and request setup share the existing generation error/cleanup boundary.
  try{
  S.busy=true;genBtn.classList.add('ld');genBtn.disabled=true;hideErr();
  try{wsRecordFunnelEvent('generate_started',{attempt:S._generateAttemptId|0});}catch(_){}
  // R-FEED-1 — open a fresh perf-trace run. `wsPerfStart()` clears prior
  // marks (so multiple rerolls do not bleed into each other's numbers) and
  // stamps `t_generate_start` as the run anchor.
  wsPerfStart();
  // SPEED-EARLY-POLL — settle vision on step 3 (button spinner) before fullscreen loader;
  // POST + poll then run during cinematic Part 3 overlay on the upload step.
  const visionMeta=await wsPrepareGenerateBeforePrompt();
  startLd();
  // R-FEED-2 — Layer optional first-run notes into the same `extraPrompt`
  // slot used by the retry modal. Retry text always wins (`User edit
  // request:` takes priority over `User notes:`) so a shopper iterating in
  // the retry flow never gets two competing instruction blocks. Notes
  // persist on `S.userNotes`, so subsequent fresh rerolls re-pull them
  // automatically. Sanitizer-side framing matches `extractAndFrameUserExtra`
  // in wallstraight-app — no new server contract needed.
  const queuedRetryText=String(S.extraPrompt||'').trim();
  const isRetryTurn=/^User\s+edit\s+request:/i.test(queuedRetryText);
  const trimmedNotes=String(S.userNotes||'').trim().slice(0,200);
  if(!isRetryTurn&&trimmedNotes){
    S.extraPrompt='User notes: '+trimmedNotes;
  }
  const wireExtraBeforePrompt=String(S.extraPrompt||'');
  const shopperRetryKind=/^User\s+edit\s+request:/i.test(wireExtraBeforePrompt.trim())?'text_edit':'fresh_render';
  const optionalNotesUsedThisTurn=!isRetryTurn&&!!trimmedNotes;
  // R-PET-MULTI-2 (Layer A) — capture the shopper-declared multi-pet
  // count BEFORE composing the prompt so every builder
  // (`wsCatsTail`, `wsIdentityAnchorFor` via `wsUsesGroupIdentityAnchor`,
  // `wsFaceHintFromDetect`, `wsPetPortraitPromptContext`) consults the
  // same parsed number. Only huisdier consumes it; other categories
  // ignore `S.shopperAnimalCount` so the storefront prompt is byte-
  // identical for non-pet pillars. R-MIX11: `null` when the parser
  // found no explicit "<N> dogs/cats/pets" pattern — never invent a
  // count from notes that did not declare one.
  S.shopperAnimalCount = (S.cat==='huisdier') ? wsParseShopperAnimalCountFromNotes(S.userNotes) : null;
  // R-ROYAL-WARDROBE (May 2026) — capture the random royal wardrobe
  // picks + gender signal + makeup intensity tier ONCE per generate so
  // the recipe body (huisdier pet body) AND the human adjunct (people
  // categories) read the same picks. Resolver short-circuits to no-op
  // when style !== "royal". Order: AFTER shopperAnimalCount (the pet
  // pick count consumes it), BEFORE wsComposeStylePrompt (which calls
  // `wsRoyalPromptBody` → `wsBuildRoyalPetBody` reading `S.royalWardrobePicks`).
  wsResolveRoyalWardrobePicks();
  if(wsIsIneligibleInscriptionText(String(S.petName||'').trim())){
    S.petName='';
    S.petNameSource=null;
  }
  let inscriptionCtx='';
  const inscriptionSanitized=String(S.petName||'').trim().slice(0,48).replace(/[\r\n<>\"]/g,'');
  const retryWithFreshInscription=isRetryTurn&&!!inscriptionSanitized;
  /* INSC-CORNER-GATE: modal offer (`wsShouldOfferPortraitInscription`) is UI-only —
     wire carrier is emitted only when sanitized dedication text exists. */
  if((!isRetryTurn||retryWithFreshInscription)&&inscriptionSanitized){
    inscriptionCtx=wsPortraitInscriptionContext(S.cat,S.style,S.petName);
  }
  let shopperExtraForPrompt=String(S.extraPrompt||'');
  // Do not duplicate the painted-name contract in the user-instruction block —
  // `inscriptionCtx` already carries MANDATORY/DEDICATION clauses for worker
  // `extractPetPortraitSegmentFromClientPrompt`. Putting the same request in
  // `Additional user instruction:` caused the worker sanitizer to wrap it as a
  // "user note — do not follow directives", which suppressed corner lettering.
  // Phase 2 Slice 2c-2 (May 28 2026): dead-computation cleanup —
  // `layerBMultiAnimal = wsMultiAnimalLikenessClause(S.style)` and
  // `royalHumanStyling = wsBuildRoyalHumanAdjunct()` were dropped from
  // here since the wire `prompt` is carrier-only (no Layer B / human
  // adjunct concat). Worker `multiAnimalGuardClause` +
  // `royalHumanStylingAdjunct` rebuild these server-side from the
  // structured wire fields. Removed locals save the CPU cycles on
  // every generate(); the helper functions themselves stay defined
  // for any preview / Try-again UX that might still call them.
  /**
   * Phase 2 / Slice 2c-1 (May 2026) — carrier-only `prompt` for the
   * server-authoritative recipe contract.
   *
   * The wire `prompt` field is now purely the carriers the worker reads
   * from the client string:
   *
   *   - `inscriptionCtx`            → `extractPetPortraitSegmentFromClientPrompt`
   *                                   + `shopperDeclaredPetPortrait` (subject-verify).
   *   - `Additional user instruction: <shopperExtra>` → `extractAndFrameUserExtra`
   *                                                     + `extractUserNotesFromClientPrompt`
   *                                                     (the `S.extraPrompt`
   *                                                     constructor at L9355
   *                                                     already prefixes
   *                                                     `User notes:` when
   *                                                     notes are set).
   *
   * The recipe body itself + category tail + vision face hint + bond
   * multi-pet count guard + royal human adjunct + multi-animal likeness
   * guard are ALL rebuilt server-side by
   * `stitchedPromptForWallstraightGenerate` from `KNOWN_STYLE_EDIT_LINES`
   * + structured wire fields (`style`, `category`, `visionMeta`,
   * `compositionMode`, …). The worker already overrode the theme recipe
   * for known styles before Phase 2 (`openai-image-edit.server.ts:4324`).
   *
   * Slice 2b kept the pre-Phase-2 full-prompt assembly as a dead else
   * branch behind `WS_PROMPT_MODE === 'server_only'` for one canary
   * cycle. Slice 2c-1 removes that branch — rollback is now via the
   * worker-side flag handling (a hot-rollback via the wire `prompt_mode`
   * is still possible: set `WS_PROMPT_MODE = null` at L397 and the
   * worker silently drops the field, returning to pre-Phase-2 wire
   * semantics; but the theme will still send a carrier-only `prompt`).
   *
   * Plan: `simplify_portrait_funnel_73f8876b.plan.md §4 Phase 2 Slice 2c`
   * + §3.5 R4 ("theme sends routing + options only") + §7 success
   * criteria ("One authoritative prompt surface (worker)").
   */
  const prompt = inscriptionCtx + (shopperExtraForPrompt ? ' Additional user instruction: ' + shopperExtraForPrompt : '');
  S.extraPrompt=''; // clear after use
  const mime=S.file?.type||'image/jpeg';
  const idempotencyKey=wsResolveGenerateIdempotencyKey();
  const deviceHdrs=(typeof window.__WS_DEVICE_ID__==='string'&&window.__WS_DEVICE_ID__?{'X-WS-Device-Id':window.__WS_DEVICE_ID__}:{});
    wsPerfMark('t_post_started');
    const requestHeaders=Object.assign({
      'Content-Type':'application/json',
      'Idempotency-Key': idempotencyKey
    },deviceHdrs);
    const requestBody=(function(){
        // Multi-photo (Slice A.4) — when extras exist, send `images: string[]`
        // (server reads `o.images` first per Slice A.1). Always include the
        // primary `image` field so old proxies / loggers / mirrors stay happy
        // (single-photo path = strict superset, zero regression risk).
        const slotsArr=Array.isArray(S.slots)?S.slots:[];
        const hasExtras=slotsArr.length>1;
        const implicitMixedBond=!hasExtras&&
          (S.cat==='huisdier'||S.cat==='zelf'||S.cat==='gezin'||S.cat==='kind'||S.cat==='koppel')&&
          wsVisionMetaHasPetSignal(visionMeta)&&
          wsIsIntentionalHumanPetPortrait(S,visionMeta);
        const attemptContext=wsBuildPreviewAttemptContext(S.previewClientAttempt,shopperRetryKind);
        S.previewClientAttempt=attemptContext.clientPreviewAttempt;
        try{window.wsFunnelAnalytics?.ordinal(funnelAttempt,attemptContext.clientPreviewAttempt,attemptContext.retryKind);}catch(_){}
        const post={
          prompt: prompt,
          // Phase 2 / Slice 2a-theme — opt the wire payload into the
          // server-authoritative recipe contract. Worker honours the flag
          // (commit d64a729 on bitbucket/main); a pre-Phase-2 worker that
          // doesn't know the field silently drops it (back-compat).
          prompt_mode: WS_PROMPT_MODE,
          promptVersion: WS_PROMPT_VERSION,
          image: S.b64,
          mimeType: mime,
          style: S.style,
          category: S.cat,
          visionMeta: visionMeta,
          verifyCacheId: S.verifyCacheId||undefined,
          // CAW.C — `keptAfterWarn` distinguishes active dismissal (shopper
          // clicked Continue anyway) from passive ignore (shopper pressed
          // Generate without ever interacting with the soft-warn affordance).
          // Strict-true contract: only emitted as true when S.hintKeptAfterWarn
          // is true, otherwise false. Pre-CAW.C themes / agents that don't
          // set the field still serialise false — wire byte-identical for
          // the >99% of shoppers who never see a banner. Server-side prompt
          // is unchanged (TRUTH-IN-REFERENCE GUARD continues to gate on
          // `accepted !== true`); the new field is pure telemetry.
          // Implicit human+pet bond (single-photo, visionMeta): same accepted
          // semantics as wsAcceptMixedSubjectBond — suppress contradictory
          // truth guard while POSTing compositionMode (R-MIX2 slice extension).
          categoryHint: { shown: S.hintShownKey || null, accepted: S.hintAccepted === true || implicitMixedBond, keptAfterWarn: S.hintKeptAfterWarn === true, autoRouted: S.catAutoRouted === true },
          generationConfig:{responseModalities:['TEXT','IMAGE']},
          clientPreviewAttempt:attemptContext.clientPreviewAttempt,
          retryKind:attemptContext.retryKind,
          styleCardVariant:(window.__WS_AB__&&window.__WS_AB__.styleCard)||'B'
        };
        if(S.style==='royal'&&S.cat==='huisdier'){
          post.royalVariant=wsResolveRoyalVariant();
        }
        // R-FEED-2 telemetry — explicit boolean so dashboards can slice
        // engagement (notes used vs not) without parsing the prompt body.
        // Only set when notes actually shaped this turn's `extraPrompt`;
        // omitted otherwise to keep the wire byte-identical for the >99%
        // of shoppers who never open the disclosure. Backend parser is
        // `readOptionalNotesPresent` in wallstraight-app
        // (`app/lib/openai-image-edit.server.ts`); strict-true contract,
        // surfaces on `ws_generation_meta.optional_notes_present`.
        if(optionalNotesUsedThisTurn){
          post.optionalNotesPresent=true;
        }
        // R-PET-MULTI-2 (Layer A) — shopper-declared distinct-animal
        // count parsed from notes. Only emitted when the parser found
        // an explicit "<N> dogs/cats/pets/honden/katten" pattern in
        // S.userNotes AND the category is huisdier (other categories
        // never consume the field server-side). Strict integer in
        // [1, 99] — mirrors `readShopperAnimalCount` on the worker.
        // Wire byte-identical for the >99% of pet uploads that do not
        // declare a count.
        if(typeof S.shopperAnimalCount==='number'&&Number.isFinite(S.shopperAnimalCount)&&S.shopperAnimalCount>=1&&S.shopperAnimalCount<=99){
          post.shopperAnimalCount=Math.floor(S.shopperAnimalCount);
        }
        // Audit Fix C0 (2026-05-23) — `petNameSource` records how the
        // shopper supplied `petName`. Possible values:
        //   - 'modal'  : `wsShowPetNameModal()` confirmation (default
        //                opt-in path; dominant in production).
        //   - 'notes'  : parsed from optional notes (future automation).
        //   - 'manual' : direct edit via the inline edit link.
        // Field is emitted only when `petName` is non-empty; value
        // defaults to 'modal' for back-compat with pre-C0 traffic that
        // captured names exclusively through the modal flow. Surfaces
        // on `ws_generation_meta.pet_name_source` so ops can audit
        // dual-name dashboard entries (BA-007 "Tim & Tom"). R-MIX11
        // safe — the storefront never fabricates a name; this field
        // only attributes the existing capture.
        if(typeof S.petName==='string'&&S.petName.trim()!==''){
          post.petNameSource=(typeof S.petNameSource==='string'&&S.petNameSource)?S.petNameSource:'modal';
        }
        if(wsPendingPrintIntent&&typeof wsPendingPrintIntent==='object'){
          post.printIntent=wsPendingPrintIntent;
        }
        // R-FEED-1 telemetry — pre-POST perf buckets so production logs
        // can correlate face-detect wait + composition cost with backend
        // duration (`ws_generation_meta.duration_ms`) on a per-job basis.
        // Only fields with a finite ms value are emitted; the entire
        // block is omitted when neither bucket is computable so the wire
        // stays byte-identical for SSR / sandboxed contexts where
        // `performance.now()` is not available. Backend parser is
        // `readClientPerfPre` in wallstraight-app
        // (`app/lib/openai-image-edit.server.ts`); both inner buckets
        // surface on `ws_generation_meta.client_perf_pre`.
        const _faceMs=wsPerfDelta('t_generate_start','t_vision_resolved');
        const _composeMs=wsPerfDelta('t_vision_resolved','t_post_started');
        if(typeof _faceMs==='number'||typeof _composeMs==='number'){
          const cpp={};
          if(typeof _faceMs==='number')cpp.face_detect_ms=_faceMs;
          if(typeof _composeMs==='number')cpp.vision_to_post_ms=_composeMs;
          post.clientPerfPre=cpp;
        }
        if(hasExtras){
          post.images=slotsArr.map(s=>s&&s.b64).filter(b=>typeof b==='string'&&b.length>0);
        }
        // Phase 2 / Slice P2.E — mixed_single_photo for human+pet on one photo.
        // Legacy: shopper clicked Include both (wsAcceptMixedSubjectBond).
        // Current: same wire when visionMeta shows likely_human + containsPet
        // on a people category (single-photo) — implicit bond on Generate.
        if(wsIsIntentionalHumanPetPortrait(S,visionMeta)){
          post.compositionMode='mixed_single_photo';
        }
        // Slice B.3 + R-FEED-5 — Royal scene-template picker. Only emit on
        // royal style; server is lenient (drops unknown values) but we keep
        // the wire small and gated. The allow-list comes from
        // `WS_ROYAL_TEMPLATE_SET` so adding a new preset only needs the
        // single source-of-truth list to be edited.
        // Server-side eligibility (`royalSceneAugmentClause`) remains the
        // authoritative gate; this client gate just guarantees we never POST
        // a typo or stale enum value.
        if(S.style==='royal'&&typeof S.royalSceneTemplate==='string'&&
           WS_ROYAL_TEMPLATE_SET.has(S.royalSceneTemplate)){
          post.royalSceneTemplate=S.royalSceneTemplate;
        }
        // R-ROYAL-WARDROBE (May 2026) — opaque indices of the wardrobe
        // variants picked this turn (0-based into the gender-routed pool).
        // Server uses these for dashboards (`ws_generation_meta.
        // royal_wardrobe_indices`) so we can audit variety distribution
        // across the user base. Only emitted on royal — wire byte-
        // identical for every other style. Server is lenient: a future
        // pool reorder/expansion never breaks ingestion (indices are
        // stored as-is). Pool definitions live in
        // `assets/ws-generator.js` ROYAL_WARDROBE_VARIANTS_*.
        if(S.style==='royal'&&Array.isArray(S.royalWardrobePicks)&&S.royalWardrobePicks.length>0){
          // Re-derive indices from the source pool so the wire carries
          // {indices,pool} pairs (compact, append-only schema). Cheap O(N·M)
          // lookup — N≤7, M≤7 in practice.
          //
          // R-ROYAL-WARDROBE-BOND (May 2026) — pool dispatch must mirror
          // `wsResolveRoyalWardrobePicks`: PET pool only on true solo-pet
          // huisdier (`wsIsRoyalPetSoloHuisdier()`), otherwise gender-
          // routed people pool. Without this parity, bond / mixed_single_
          // photo / human-primary on huisdier rendered people picks but
          // the wire told the worker dashboard the pool was 'pet' — a
          // silent telemetry lie that broke `ws_generation_meta.royal_
          // wardrobe_pool` audits.
          const isSoloHuisdier=typeof wsIsRoyalPetSoloHuisdier==='function'&&wsIsRoyalPetSoloHuisdier();
          const pickIndices=[];
          const pool=isSoloHuisdier?(wsResolveRoyalVariant()==='classic'?ROYAL_WARDROBE_VARIANTS_PET_CLASSIC:ROYAL_WARDROBE_VARIANTS_PET)
                    :(S.royalGenderSignal==='female'?ROYAL_WARDROBE_VARIANTS_FEMALE
                    :(S.royalGenderSignal==='male'?ROYAL_WARDROBE_VARIANTS_MALE
                    :ROYAL_WARDROBE_VARIANTS_NEUTRAL));
          for(const pick of S.royalWardrobePicks){
            const idx=pool.indexOf(pick);
            if(idx>=0)pickIndices.push(idx);
          }
          if(pickIndices.length>0){
            const poolName=isSoloHuisdier?(wsResolveRoyalVariant()==='classic'?'pet_classic':'pet')
                          :(S.royalGenderSignal==='female'?'female'
                          :(S.royalGenderSignal==='male'?'male':'neutral'));
            post.royalWardrobeIndices=pickIndices;
            post.royalWardrobePool=poolName;
          }
        }
        // R-ROYAL-WARDROBE — gender signal source-of-record. Only emitted
        // when the parser found an explicit signal (notes keyword or
        // explicit royalSceneTemplate slug); never inferred from pixels
        // (R-MIX11). Server uses for `ws_generation_meta.royal_gender_signal`.
        if(S.style==='royal'&&(S.royalGenderSignal==='female'||S.royalGenderSignal==='male')){
          post.royalGenderSignal=S.royalGenderSignal;
        }
        // R-ROYAL-WARDROBE — makeup intensity tier. Only emitted when
        // shopper notes carried an explicit keyword OR default 'refined'
        // on solo people categories. Server validates with
        // `readRoyalMakeupIntensity` (drops unknowns).
        if(S.style==='royal'&&S.cat!=='huisdier'&&typeof S.royalMakeupIntensity==='string'&&
           (S.royalMakeupIntensity==='natural'||S.royalMakeupIntensity==='refined'||S.royalMakeupIntensity==='queen')){
          post.royalMakeupIntensity=S.royalMakeupIntensity;
        }
        // Admin log column "Extra" + GenerationLog.shopperExtraInstruction:
        // pre-stitch shopper line (retry / optional notes) for dashboards only.
        // Capped 500 chars to match wallstraight-app VARCHAR(500).
        const wireShopper=String(wireExtraBeforePrompt||'').trim().replace(/[\x00-\x08\x0b\x0c\x0e-\x1f]/g,'');
        if(wireShopper){
          post.shopperExtraInstruction=wireShopper.slice(0,500);
        }
        return post;
    })();
    const requestJson=JSON.stringify(requestBody);
    try{window.wsFunnelAnalytics?.requestSubject(funnelAttempt,{style:requestBody.style,category:requestBody.category,compositionMode:requestBody.compositionMode});}catch(_){}
    funnelPhase='request';
    let res=await fetch(WS_PROXY_GENERATE,{
      method:'POST',
      headers:requestHeaders,
      body:requestJson
    });
    funnelPhase='response';funnelHttpStatus=res.status;
    wsPerfMark('t_post_first_byte');
    let d=await readProxyJson(res);
    try{window.wsFunnelAnalytics?.attemptEvent(funnelAttempt,'generation_response_received',{asyncJobId:d&&d.ws_async_job_id,wsJobId:d&&(d.ws_job_id||d.jobId||d.job_id),httpStatus:res.status});}catch(_){}
    wsPerfMark('t_post_body_parsed');
    // R-FEED-1 — capture the async/sync routing decision BEFORE the polling
    // branch reassigns `res`/`d` to the polled 200 response (which carries
    // the final image, not `ws_async_job_id`). Without this snapshot the
    // downstream perf report's async_path bool would always read `false`
    // (sync) because the post-poll `res.status===200` and
    // `!d?.ws_async_job_id` are both true on the async path too.
    const wasAsyncPath=res.status===202;
    if(wasAsyncPath){
      const jobId=d&&d.ws_async_job_id;
      if(!jobId)throw new Error(wsT('err.unexpected'));
      S.inFlightAsyncJobId=String(jobId);
      funnelAsyncJobId=String(jobId);
      wsActiveJobWrite(jobId);
      wsApplyServerPollProgress(d);
      const polled=await wsPollGenerationUntilReady(String(jobId),deviceHdrs,wsApplyServerPollProgress);
      res=polled.res;
      d=polled.d;
      funnelHttpStatus=res.status;
    }
    // Mark async resolution AFTER the polling branch so a synchronous
    // 200 response collapses `async_poll_ms` to ~0 (parsed → resolved are
    // adjacent) and the asynchronous case captures the full poll duration.
    wsPerfMark('t_async_resolved');
    if(!res.ok){
      const detail=d?.error?.message||d?.message||d?.description||'';
      const code=d?.error?.code||d?.code||'';
      console.warn('Generate proxy HTTP',res.status,code||detail||'(no body)');
      if(d&&d.ws_generation_meta)console.warn('[Wallstraight]',d.ws_generation_meta);
      if(res.status===429&&code==='quota_exceeded'){
        S.previewRemaining=0;
        updRetryUI();
      }
      const resolvedGenCode=(typeof code==='string'&&code)?code:(res.status>=500?'provider_error':'');
      throw Object.assign(new Error(wsErrorMessage(res.status,code,detail)),{status:res.status,code:resolvedGenCode});
    }
    await wsApplySuccessfulGeneratePayload(res,d,{async_path:wasAsyncPath,funnelAttempt});
  }catch(e){
    try{window.wsFunnelAnalytics?.attemptEvent(funnelAttempt,'generate_failed',{reason:window.wsFunnelAnalytics.failureReason(e,funnelPhase),httpStatus:e&&typeof e.status==='number'?e.status:funnelHttpStatus,asyncJobId:funnelAsyncJobId});}catch(_){}
    console.warn('Generate failed',e);
    try{
      const errCode=(e&&typeof e==='object'&&typeof e.code==='string'&&e.code)?e.code:'unknown';
      const errStatus=(e&&typeof e==='object'&&typeof e.status==='number')?e.status:0;
      wsRecordFunnelEvent('generate_failed',{error_code:errCode,status:errStatus,attempt:S._generateAttemptId|0});
      /* Story-seed retry failed (Phase 1 telemetry). */
      if(S._pendingStorySeedId){
        wsRecordFunnelEvent('story_seed_retry_failed',{story_seed_id:S._pendingStorySeedId,error_code:errCode});
        S._pendingStorySeedId=null;
      }
    }catch(_){}
    stopLd(false);
    const msg=wsShopperSafeErrorMessage(e,wsT('generic_err'));
    const meta=wsErrShopperMeta(e);
    wsStudioRecoveryState.capture=wsCaptureJobContext(meta);
    if(wsPhotoDecodeRecoveryShouldOfferModal(meta)){
      wsStudioRecoveryModalCooldownTouch();
      wsStudioRecoveryOpen('photo_decode');
    }else if(wsStudioRecoveryShouldOfferModal(meta)){
      wsStudioRecoveryModalCooldownTouch();
      wsStudioRecoveryOpen('capacity');
    }else{
      showErr(msg);
    }
    wsActiveJobClear();
  }finally{S.busy=false;S.generateLock=false;S.inFlightAsyncJobId=null;S.generateIdempotencyKey=null;S._generateIdempotencyFp=null;if(genBtn)genBtn.classList.remove('ld');upd();if(typeof wsMaatkeuzeRefreshAllCartBtns==='function')wsMaatkeuzeRefreshAllCartBtns();}
}
(function initPetNameModal(){
  const m=$('#petNameModal'),inp=$('#petNameInput'),go=$('#petNameConfirm'),sk=$('#petNameSkip'),cl=$('#petNameClose');
  if(!m||!inp||!go||!sk)return;
  const shut=()=>{m.classList.remove('show');};
  const doDismiss=()=>{
    shut();
    if(typeof updateGenerateButton==='function')updateGenerateButton();
  };
  // Audit Fix C0 — when shopper skips the modal, also clear the source so
  // a later automated path (e.g. notes parser) does not inherit a stale
  // 'modal' attribution from a previous attempt.
  const doSkip=()=>{S.petName='';S.petNameSource=null;shut();if(typeof updateGenerateButton==='function')updateGenerateButton();if(S._pendingRetryExtraPrompt!=null){S.extraPrompt=S._pendingRetryExtraPrompt;S._pendingRetryExtraPrompt=null;}generate();};
  go.onclick=()=>{
    if(go.disabled)return;
    const candidate=String(inp.value||'').trim().slice(0,48).replace(/[\r\n<>\"]/g,'');
    const rejectReason=wsIsIneligibleInscriptionText(candidate);
    if(rejectReason){
      wsSyncInscriptionInputError(inp,rejectReason);
      wsRecordPortraitInscriptionEvent('portrait_inscription_rejected',{reason:rejectReason});
      wsRefreshInscriptionConfirmCta(inp,go,S._inscriptionModalCell||'solo');
      return;
    }
    S.petName=candidate;
    // Audit Fix C0 — record source for ops attribution
    // (`ws_generation_meta.pet_name_source`).
    S.petNameSource='modal';
    wsSyncInscriptionInputError(inp,null);
    wsRecordPortraitInscriptionEvent('portrait_inscription_confirmed',{cta_variant:S._inscriptionModalCell==='pet'?'pet_honor':'generic_add'});
    shut();
    if(typeof updateGenerateButton==='function')updateGenerateButton();
    if(S._pendingRetryExtraPrompt!=null){S.extraPrompt=S._pendingRetryExtraPrompt;S._pendingRetryExtraPrompt=null;}
    generate();
  };
  sk.onclick=()=>{wsRecordPortraitInscriptionEvent('portrait_inscription_skipped');doSkip();};
  if(cl)cl.onclick=()=>{wsRecordPortraitInscriptionEvent('portrait_inscription_dismissed');doDismiss();};
  m.onclick=e=>{if(e.target===m){wsRecordPortraitInscriptionEvent('portrait_inscription_dismissed');doDismiss();}};
  document.addEventListener('keydown',e=>{
    if(e.code!=='Escape'||!m.classList.contains('show'))return;
    wsRecordPortraitInscriptionEvent('portrait_inscription_dismissed',{via:'escape'});
    doDismiss();
  });
  inp.addEventListener('input',()=>wsRefreshInscriptionConfirmCta(inp,go,S._inscriptionModalCell||'solo'));
  inp.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();if(!go.disabled)go.click();}});
})();
(function initPetNameEditLink(){
  const link=document.getElementById('petNameEditLink');
  if(!link)return;
  link.addEventListener('click',e=>{
    e.preventDefault();
    wsSyncStyleAndCategoryFromDom();
    if(typeof wsShouldOfferPortraitInscription!=='function'||!wsShouldOfferPortraitInscription({cat:S.cat,b64:S.b64,extraPrompt:S.extraPrompt,subjectClass:S.subjectClass,slots:S.slots,compositionMode:S.compositionMode,containsPetSubject:S.containsPetSubject,aiVerifyResult:S.aiVerifyResult}))return;
    wsShowPetNameModal();
  });
})();
if(genBtn)genBtn.onclick=startGenerateAttempt;

/* Slice E.2 — Share + Save-for-Later CTAs.
   Prefer the public share URL emitted by the backend (Slice E.1) when present;
   fall back to window.location.href so legacy theme builds + missing-share-url
   responses degrade to the original storefront-product-page share. */
function wsResolveShareUrl(){
  if(typeof S!=='undefined' && S && typeof S.lastShareUrl==='string' && /^https?:\/\//i.test(S.lastShareUrl))return S.lastShareUrl;
  return typeof window.location?.href==='string'?window.location.href:'';
}
/** Slice R.6 — mailto / Save-for-Later: prefer the storefront funnel deep-link
   (?ws_job, ws_t, #resPage). Falls back to share_url for legacy backends. */
function wsResolveFunnelResumeUrl(){
  if(typeof S!=='undefined' && S && typeof S.lastFunnelResumeUrl==='string' && /^https?:\/\//i.test(S.lastFunnelResumeUrl))return S.lastFunnelResumeUrl;
  return wsResolveShareUrl();
}
(function initResultShare(){
  const root=document.getElementById('wallstraight-generator');
  if(!root)return;
  root.querySelectorAll('.share-send').forEach(btn=>{
    btn.addEventListener('click',async()=>{
      const url=wsResolveShareUrl();
      const payload={title:document.title||'Wallstraight',text:wsT('share.page_blurb'),url};
      if(navigator.share){
        try{
          await navigator.share(payload);
          return;
        }catch(e){
          if(e&&e.name==='AbortError')return;
        }
      }
      try{
        if(url&&navigator.clipboard&&navigator.clipboard.writeText){
          await navigator.clipboard.writeText(url);
          toast(wsT('toast.link_copied'));
        }else{
          toast(wsT('toast.share_failed'));
        }
      }catch(_){
        toast(wsT('toast.share_failed'));
      }
    });
  });
  /* Slice E.2 — Save for Later (mailto:). Per RFC 6068 the mailto: scheme opens
     the user's default mail client with the message pre-filled — zero backend,
     zero abuse surface, works on every device that has a mail handler. Fallback
     when no handler is registered or the click is blocked: copy URL to clipboard
     so the user can paste it into whatever they prefer. */
  root.querySelectorAll('.share-save').forEach(btn=>{
    btn.addEventListener('click',async()=>{
      const url=wsResolveFunnelResumeUrl();
      if(!url){toast(wsT('toast.share_failed'));return;}
      const subject=wsT('email.subject');
      const body=wsT('email.body').replace('{url}',url);
      const href='mailto:?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body);
      let opened=false;
      try{
        const a=document.createElement('a');
        a.href=href;a.target='_self';a.rel='noopener';
        document.body.appendChild(a);
        a.click();
        a.remove();
        opened=true;
      }catch(_){opened=false;}
      if(!opened){
        try{
          if(navigator.clipboard&&navigator.clipboard.writeText){
            await navigator.clipboard.writeText(url);
            toast(wsT('toast.saved_link_copied'));
          }else{
            toast(wsT('toast.share_failed'));
          }
        }catch(_){toast(wsT('toast.share_failed'));}
      }
    });
  });
})();

// Retry / preview quota: enforced by app proxy (`ws_preview_remaining`, `quota_exceeded`). Legacy client counter removed.
(function purgeLegacyRetryCounter(){
  try{localStorage.removeItem('ws_retries');}catch(_){}
})();
function updRetryUI(){
  const rem=S.previewRemaining;
  const trackQuota=typeof rem==='number';
  const rl=$('#retriesLeft');
  const sub=document.getElementById('retryQuotaSub');
  if(sub)sub.hidden=!trackQuota;
  if(rl){
    if(trackQuota)rl.textContent=String(rem);
    else rl.textContent='';
  }
  const grid=$('.retry-grid'),sep=$('.retry-sep'),edit=$('#retryEditToggle');
  const wrapIn=$('#retryInputWrap'), lim=$('#retryLimit'), send=$('#retrySend');
  const out=trackQuota&&rem<=0;
  if(out){
    if(grid)grid.classList.add('disabled');if(sep)sep.classList.add('disabled');if(edit)edit.classList.add('disabled');
    if(wrapIn)wrapIn.style.display='none';
    if(lim)lim.style.display='block';
    if(send)send.disabled=true;
  }else{
    if(grid)grid.classList.remove('disabled');if(sep)sep.classList.remove('disabled');if(edit)edit.classList.remove('disabled');
    if(lim)lim.style.display='none';
  }
}

function wsPrefersReducedMotionScroll(){
  try{
    return typeof matchMedia==='function'&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  }catch(_){
    return false;
  }
}
/** Scroll into view; behavior instant vs smooth (https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView). */
function wsScrollElIntoView(el, block){
  if(!el)return;
  const b=block||'start';
  const behavior=wsPrefersReducedMotionScroll()?'instant':'smooth';
  try{
    el.scrollIntoView({behavior, block: b, inline: 'nearest'});
  }catch(_){
    try{
      el.scrollIntoView(b==='end'?false:true);
    }catch(__){/* no-op */}
  }
}
/** Hero mosaic: optional result-view exit, style priming, scroll #maker (scroll-margin handles sticky header). */
function wsHeroGalleryJump(styleKey){
  if(resPage&&resPage.classList.contains('show'))showLanding();
  const wrap=document.getElementById('wallstraight-generator');
  if(styleKey&&wrap){
    const sty=wrap.querySelector('.sty[data-s="'+styleKey+'"]');
    if(sty)sty.click();
  }
  requestAnimationFrame(()=>{
    requestAnimationFrame(()=>{
      const m=document.getElementById('maker');
      if(m)wsScrollElIntoView(m,'start');
      try{
        if(m&&typeof m.focus==='function')m.focus({preventScroll:true});
      }catch(_){/* no-op */}
    });
  });
}
/** Oranje lookbook: preselect category + wk style, open upload step, scroll #maker. */
function wsWkApplyMakerChoices(cat,styleKey){
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap)return false;
  const allowedCat=['huisdier','gezin','koppel','kind','zelf'];
  if(cat&&allowedCat.includes(cat)){
    const pill=wrap.querySelector('#pills .pill[data-c="'+cat+'"]');
    if(pill){
      $$('.pill').forEach(x=>x.classList.remove('on'));
      pill.classList.add('on');
      S.cat=cat;
    }
  }
  const wkSlugs=['wk_panini_held','wk_stadionlegende','wk_vintage_poster','wk_mancave_portret','world_cup_football'];
  if(styleKey&&wkSlugs.includes(styleKey)){
    let sty=wrap.querySelector('#wkOranjeStyleGrid .sty[data-s="'+styleKey+'"]');
    if(!sty)sty=wrap.querySelector('.sty[data-s="'+styleKey+'"]');
    if(sty){
      wrap.querySelectorAll('input[name="s"]').forEach(inp=>{inp.checked=false;});
      $$('.sty').forEach(x=>x.classList.remove('on'));
      sty.classList.add('on');
      const inp=sty.querySelector('input[name="s"]');
      if(inp)inp.checked=true;
      S.style=wsNormalizeStyleKey(sty.dataset.s||styleKey);
    }
  }
  if(typeof wsSyncStyleAndCategoryFromDom==='function')wsSyncStyleAndCategoryFromDom();
  if(typeof updateGenerateButton==='function')updateGenerateButton();
  return !!(S.cat&&S.style);
}
/** Wizard step after Oranje lookbook / hero priming (infer-aware). */
function wsWkLookbookWizardStep(){
  if(wsIsCategoryInferEnabled()){
    if(wsFunnelOrder()==='upload_style')return 1;
    return S.style?2:1;
  }
  if(S.cat&&S.style)return 3;
  if(S.cat||S.style)return 2;
  return 1;
}
function wsWkLookbookJump(cat,styleKey){
  if(typeof wsIsWkOranjeMode==='function'&&!wsIsWkOranjeMode())return;
  if(resPage&&resPage.classList.contains('show'))showLanding();
  wsWkApplyMakerChoices(cat,styleKey);
  try{
    showStep(wsWkLookbookWizardStep());
  }catch(_){/* wizard may not be ready */}
  if(typeof wsRefreshWizardChoiceSummary==='function')wsRefreshWizardChoiceSummary();
  requestAnimationFrame(()=>{
    requestAnimationFrame(()=>{
      const m=document.getElementById('maker');
      if(m)wsScrollElIntoView(m,'start');
      try{
        if(m&&typeof m.focus==='function')m.focus({preventScroll:true});
      }catch(_){/* no-op */}
    });
  });
  try{wsRecordFunnelEvent('wk_oranje_lookbook_jump',{category:S.cat||null,style:S.style||null});}catch(_){}
}

function retryGenerate(extraPrompt){
  const modal=$('#retryModal');
  if(modal)modal.classList.remove('show');
  if(S.busy||S.generateLock){
    toast(wsT('loader.part4.already_generating'));
    return;
  }
  if(!S.b64){
    toast(wsT('retry.no_photo'));
    showLanding();
    requestAnimationFrame(()=>{const m=document.querySelector('#maker');if(m)wsScrollElIntoView(m,'start');});
    return;
  }
  if(typeof S.previewRemaining==='number'&&S.previewRemaining<=0){
    toast(wsT('toast.no_retries'));
    return;
  }
  // INS-4 / Fix C1 — drop stale contact-shaped inscription before text_edit retry.
  const ineligibleName=wsIsIneligibleInscriptionText(String(S.petName||'').trim());
  if(ineligibleName){
    S.petName='';
    S.petNameSource=null;
    const offerRetryInscription=typeof wsShouldOfferPortraitInscription==='function'&&wsShouldOfferPortraitInscription({cat:S.cat,b64:S.b64,extraPrompt:extraPrompt||S.extraPrompt||'',subjectClass:S.subjectClass,slots:S.slots,compositionMode:S.compositionMode,containsPetSubject:S.containsPetSubject,aiVerifyResult:S.aiVerifyResult});
    if(offerRetryInscription){
      S._pendingRetryExtraPrompt=extraPrompt||'';
      if(wsShowPetNameModal()){
        wsRecordPortraitInscriptionEvent('portrait_inscription_offered',{source:'retry_ineligible_clear'});
        return;
      }
    }
  }
  S._pendingRetryExtraPrompt=null;
  S.extraPrompt=extraPrompt||'';
  void generate();
}

const retryModal=$('#retryModal');
const retryBtn=$('#retryBtn'), retryClose=$('#retryClose');
if(retryBtn&&retryModal)retryBtn.onclick=()=>{updRetryUI();retryModal.classList.add('show');};
if(retryClose&&retryModal)retryClose.onclick=()=>retryModal.classList.remove('show');
if(retryModal)retryModal.onclick=e=>{if(e.target===retryModal)retryModal.classList.remove('show');};

const ra=$('#retryAgain'), rImg=$('#retryChangeImg'), rSt=$('#retryStyle'), rSo=$('#retryStartOver');
if(ra)ra.onclick=()=>retryGenerate();
if(rImg&&retryModal&&fi)rImg.onclick=()=>{retryModal.classList.remove('show');showLanding();fi.click();};
if(rSt&&retryModal)rSt.onclick=()=>{
  retryModal.classList.remove('show');
  showLanding();
  showStep(2);
  requestAnimationFrame(()=>{
    wsScrollElIntoView(document.getElementById('step2'),'nearest');
  });
};
if(rSo&&retryModal)rSo.onclick=()=>{
  retryModal.classList.remove('show');
  if(typeof wsPart4NotifyDisarm==='function')wsPart4NotifyDisarm();
  wsPart4NotifyDismissed=false;
  wsPart4NotifySubmitted=false;
  showLanding();
  showStep(1);
  requestAnimationFrame(()=>{
    wsScrollElIntoView(document.getElementById('step1'),'nearest');
  });
};

// Custom edit toggle & submit
const retEdit=$('#retryEditToggle'), retText=$('#retryText'), retChars=$('#retryChars'), retSend=$('#retrySend'), retWrap=$('#retryInputWrap');
if(retEdit&&retWrap&&retText)retEdit.onclick=()=>{
  const show=retWrap.style.display==='none';
  retWrap.style.display=show?'block':'none';
  if(show)retText.focus();
};
if(retText&&retChars)retText.oninput=()=>{retChars.textContent=String(retText.value.length);};
if(retSend&&retText&&retChars&&retWrap)retSend.onclick=()=>{
  const txt=retText.value.trim();
  if(!txt){toast(wsT('toast.edit_empty'));return;}
  retryGenerate('User edit request: '+txt);
  retText.value='';retChars.textContent='0';
  retWrap.style.display='none';
};

/* R-TRY2 — opt-in shopper boost (Try-again plan Tier 2 #3 of the
 * per-slice critical review). Adds a category-aware identity-anchor
 * sentence to the existing prompt by routing through the same
 * `User edit request:` sanitiser path as the modal text-edit retry.
 *
 * Design constraints (R-HUMAN non-regression, anti-pattern guardrail):
 *   - SAME `/edits` call shape — no new wire field, no new env, no
 *     `n>1`, no `quality`/`size`/`input_fidelity` change. The ONLY
 *     conditioning delta is ~30-50 extra tokens at the END of the
 *     stitched prompt body, framed by the production sanitiser.
 *   - Consumes one normal preview slot — NO silent extra spend, NO
 *     auto-retry trigger, NO bypass of `WS_PREVIEW_HARD_CAP_PER_DAY`.
 *   - Marker prefix "Maximum identity fidelity rerender:" makes
 *     boost clicks identifiable in the FULL stitched prompt
 *     server-side (NOT in `ws_generation_meta.prompt_head_ascii` —
 *     that field is the first 140 chars of the prompt and the
 *     boost marker rides on `S.extraPrompt`, which is appended
 *     to the END of the composed prompt and therefore truncated
 *     out for any non-trivial style recipe). Dashboards that need
 *     boost-vs-free-form distinction today must match the full
 *     stitched prompt server-side via `GenerationLog.promptHash`
 *     (one SHA-256 per category × style × canned-line combination,
 *     ~5 categories × ~10 styles × 6 canned lines ≈ 300 hashes).
 *     R-WF3b's `client_retry_kind: 'text_edit'` already separates
 *     ALL text-refinement retries (boost OR free-form) from
 *     `fresh_render` retries, which is the bigger funnel question.
 *   - English text because the OpenAI model is conditioned on English
 *     prompt patterns in `wsComposeStylePrompt` / `CATS[...]`.
 *   - Per-category lines because R-MIX1 / R-MIX2 / R-MIX3 already
 *     prove that mixed-subject and per-category guards are what
 *     actually move likeness. Generic "preserve identity" lines
 *     are the lowest-yield variant. */
const WS_STRONGER_RENDER_PROMPTS={
  zelf:"Maximum identity fidelity rerender: preserve the subject's exact facial structure, eye color, age, hair color, and skin tone from the uploaded reference photo; the chosen artistic style must not alter recognizable identity features. Court-polish hairstyle in noble oil — gathered or pinned when the source shows long casual hair.",
  kind:"Maximum identity fidelity rerender: preserve the child's exact age, facial proportions, hair color, and distinctive features from the uploaded reference; render the artistic style without aging up or generalizing the face. Age-appropriate court-neat hair — princess polish, not adult ball updo.",
  koppel:"Maximum identity fidelity rerender: preserve BOTH individuals as distinct, recognizable people from the uploaded reference — same hair color, same age, same facial structure for each — without merging features or symmetrizing them.",
  gezin:"Maximum identity fidelity rerender: preserve every figure in the uploaded reference as a distinct individual — match each person's age, hair color, and facial features one-to-one with the reference; do NOT generate a generic family or duplicate people.",
  huisdier:"Maximum identity fidelity rerender: preserve the pet's exact breed proportions, coat color and pattern, eye color, body pose silhouette, seated or standing stance, long-body proportions, and ground contact from the uploaded reference; render the artistic style without altering recognizable breed, markings, or body geometry.",
  huisdier_bond:"Maximum identity fidelity rerender: preserve the human's exact facial structure, age, hair color, and skin tone and the pet's breed, coat, markings, and pose from the uploaded reference. Identity fidelity applies to face and pet; the human's hair should still read as court-polished noble styling in oil, not casual outdoor snapshot hair."
};
const WS_STRONGER_RENDER_DEFAULT="Maximum identity fidelity rerender: treat the uploaded photo as the strict identity ground truth — preserve every recognizable feature of each subject; the artistic style must not override identity.";
function wsBoostPromptForCategory(cat){
  const k=String(cat||'').trim().toLowerCase();
  if(k==='huisdier'&&typeof wsHasRoyalPetCompanion==='function'&&wsHasRoyalPetCompanion()){
    return WS_STRONGER_RENDER_PROMPTS.huisdier_bond;
  }
  if(k==='huisdier'&&typeof wsIsHumanPrimaryOnPetCategory==='function'&&wsIsHumanPrimaryOnPetCategory()){
    return WS_STRONGER_RENDER_PROMPTS.zelf;
  }
  return Object.prototype.hasOwnProperty.call(WS_STRONGER_RENDER_PROMPTS,k)
    ? WS_STRONGER_RENDER_PROMPTS[k]
    : WS_STRONGER_RENDER_DEFAULT;
}
const retryStronger=$('#retryStronger');
if(retryStronger)retryStronger.onclick=()=>{
  const canned=wsBoostPromptForCategory(S.cat);
  retryGenerate('User edit request: '+canned);
};

// Variant map from Liquid (option1/option2 → poster_s_geen, digital, …). Used as addToCart fallback only.
window.WS_VARIANTS=window.WS_VARIANTS&&typeof window.WS_VARIANTS==='object'?window.WS_VARIANTS:{};
let wsPendingPrintIntent=null;

function wsPrintIntentFromSelection(material,sourceEl){
  const mat=String(material||'').trim().toLowerCase();
  if(mat!=='poster'&&mat!=='canvas'&&mat!=='glass')return null;
  const select=sourceEl||document.querySelector('#wallstraight-generator select[data-ws-variant-select="'+mat+'"]')||$('#'+mat+'Size');
  const sizeTier=String(select&&select.value||'').trim().toLowerCase();
  if(sizeTier!=='s'&&sizeTier!=='m'&&sizeTier!=='l')return null;
  const opt=select&&select.selectedOptions&&select.selectedOptions[0];
  const rawVariant=opt&&(opt.dataset?.variantId||opt.getAttribute('data-variant-id'));
  const variantId=String(rawVariant||'').trim();
  const out={material:mat,sizeTier:sizeTier};
  if(/^\d{1,30}$/.test(variantId))out.variantId=variantId;
  return out;
}

function wsRememberPrintIntent(material,sourceEl){
  const next=wsPrintIntentFromSelection(material,sourceEl);
  if(next)wsPendingPrintIntent=next;
}

function wsResolveVariantId(material){
  if(material==='digital'){
    const id=parseInt($('#dlBtn')?.dataset?.variantId||'0',10);
    if(Number.isFinite(id)&&id>0)return id;
    const map=window.WS_VARIANTS||{};
    const d=parseInt(map.digital,10);
    return Number.isFinite(d)&&d>0?d:0;
  }
  const sizeEl=document.querySelector('#wallstraight-generator select[data-ws-variant-select="'+material+'"]')||$('#'+material+'Size');
  const opt=sizeEl?.selectedOptions?.[0];
  let id=parseInt(opt?.dataset?.variantId||opt?.getAttribute('data-variant-id')||'0',10);
  if(Number.isFinite(id)&&id>0)return id;
  const size=(sizeEl?.value||'s').toLowerCase();
  const map=window.WS_VARIANTS||{};
  const fallback=map[material+'_'+size+'_geen'];
  id=parseInt(fallback,10);
  return Number.isFinite(id)&&id>0?id:0;
}

/** Format cents as €E<sup>CC</sup> to match legacy tier card typography. */
function wsFormatPriceCentsSup(cents){
  const n=Math.max(0,parseInt(cents,10)||0);
  const euros=Math.floor(n/100);
  const c=String(n%100).padStart(2,'0');
  return '€'+euros+'<sup>'+c+'</sup>';
}

function wsUpdDigitalPromoPrice(){
  const priceEl=document.getElementById('digitalPrice');
  if(!priceEl)return;
  const full=parseInt(priceEl.getAttribute('data-full-cents')||'0',10);
  if(!Number.isFinite(full)||full<0)return;
  priceEl.innerHTML=wsFormatPriceCentsSup(full);
}

function wsSyncResultTierPrices(){
  ['poster','canvas','glass'].forEach(m=>{
    try{updPrice(m);}catch(_){/* noop */}
  });
  try{wsUpdDigitalPromoPrice();}catch(_){/* noop */}
}

function wsSyncTwinVariantSelects(mat,val){
  const root=document.getElementById('wallstraight-generator');
  if(!root)return;
  const lc=String(val||'').toLowerCase();
  root.querySelectorAll('select[data-ws-variant-select="'+mat+'"]').forEach(sel=>{
    const opt=Array.from(sel.options).find(o=>String(o.value).toLowerCase()===lc);
    if(opt&&!opt.disabled&&sel.value!==opt.value)sel.value=opt.value;
  });
}

/** Kept for Liquid `onchange`; syncs landing + result selects, refreshes all tier prices. */
function wsOnVariantSelectChange(mat,sourceEl){
  if(!sourceEl)return;
  wsSyncTwinVariantSelects(mat,sourceEl.value);
  wsRememberPrintIntent(mat,sourceEl);
  wsRecordFunnelEvent('material_size_selected',{material:mat,size:String(sourceEl.value||'')});
  try{window.wsFunnelAnalytics?.record('material_size_selected',{material:mat,size:String(sourceEl.value||'').toLowerCase(),wsJobId:S.lastJobId,style:S.style,category:S.cat});}catch(_){}
  updPrice(mat);
  try{wsRefreshFinishingOptions(mat);}catch(_){/* noop */}
}

// Price updater — reads first `[data-ws-variant-select]` + writes every `[data-ws-variant-price]`
function updPrice(mat){
  const root=document.getElementById('wallstraight-generator');
  if(!root)return;
  const sizeEl=root.querySelector('select[data-ws-variant-select="'+mat+'"]');
  const priceEls=root.querySelectorAll('[data-ws-variant-price="'+mat+'"]');
  if(!sizeEl||priceEls.length===0)return;
  const opt=sizeEl.selectedOptions[0];
  const full=parseInt(opt?.dataset?.p||'0',10);
  if(!Number.isFinite(full)||full<0)return;
  const html=wsFormatPriceCentsSup(full);
  priceEls.forEach(el=>{el.innerHTML=html;});
  const compare=parseInt(opt?.dataset?.cp||opt?.getAttribute('data-cp')||'0',10);
  root.querySelectorAll('[data-ws-variant-compare="'+mat+'"]').forEach(el=>{
    if(Number.isFinite(compare)&&compare>full){
      el.innerHTML=wsFormatPriceCentsSup(compare);
      el.hidden=false;
    }else{
      el.hidden=true;
    }
  });
}

/* ----- AF-1/AF-2 PrintAPI finishing picker (Wave C) -----
 * Reads the per-main-variant contract emitted in window.WS_FINISHING (AF-0) and renders a
 * radiogroup of finishing cards on each physical result tier. Selection drives addToCart:
 * geen → main line only (with _printapi_options from geen); paid → main line + addon carrier
 * line sharing a _ws_bundle_id. Picker hidden when no finishing applies (Poster L / Canvas L /
 * digital / unpublished addon). PrintAPI option values come straight from the AF-0 contract
 * (poster geen=standard, canvas geen=none, canvas paid=canvas_type+hanging_system, etc.). */
const wsFinishingSel=Object.create(null); /* material -> selected paid variantId (string) | null(geen) */
function wsFinEsc(s){return String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
function wsFinishingData(){return (window.WS_FINISHING&&window.WS_FINISHING.byMainVariantId)||{};}
function wsFinishingEntry(material){
  const id=String(wsResolveVariantId(material)||'');
  if(!id||id==='0')return null;
  const e=wsFinishingData()[id];
  return e?Object.assign({mainVariantId:id},e):null;
}
function wsFinishingEyebrow(material){
  const k=material==='canvas'?'finish.eyebrow.canvas':(material==='glass'?'finish.eyebrow.glass':'finish.eyebrow.poster');
  return wsT(k);
}
/** Resolve the active finishing choice for a material: {entry, isPaid, option}. */
function wsFinishingSelected(material){
  const e=wsFinishingEntry(material);
  if(!e)return {entry:null,isPaid:false,option:null};
  const want=wsFinishingSel[material];
  if(want){
    const opt=(e.paid||[]).find(p=>String(p.variantId)===String(want));
    if(opt)return {entry:e,isPaid:true,option:opt};
  }
  return {entry:e,isPaid:false,option:e.geen||null};
}
/* AF-P2: deterministic inline-SVG per finishing kind so paid options are visually
 * distinct without fabricated product photos (curated photos override — see wsFinishingCardHtml). */
function wsFinishingIcon(kind){
  const o='<svg viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">';
  if(kind==='hanger')return o+'<rect x="9" y="13" width="30" height="3.6" rx="1.5" fill="currentColor"/><circle cx="13" cy="11.5" r="1.8" fill="currentColor"/><circle cx="35" cy="11.5" r="1.8" fill="currentColor"/><rect x="13" y="18" width="22" height="20" rx="1.5" stroke="currentColor" stroke-width="2"/></svg>';
  if(kind==='spacers')return o+'<rect x="11" y="11" width="26" height="26" rx="2" stroke="currentColor" stroke-width="2"/><circle cx="16" cy="16" r="2.4" fill="currentColor"/><circle cx="32" cy="16" r="2.4" fill="currentColor"/><circle cx="16" cy="32" r="2.4" fill="currentColor"/><circle cx="32" cy="32" r="2.4" fill="currentColor"/></svg>';
  /* frame / frame_wood / frame_black */
  return o+'<rect x="9" y="9" width="30" height="30" rx="2" stroke="currentColor" stroke-width="3"/><rect x="16" y="16" width="16" height="16" rx="1" stroke="currentColor" stroke-width="1.5" opacity=".55"/></svg>';
}
/* AF-P2: drop the "<Material> <Size> - " prefix so 108px cards aren't cramped
 * (e.g. "Poster S – Fotolijst 30x40" -> "Fotolijst 30x40"). Falls back to full title. */
function wsFinishingShortLabel(title){
  const t=String(title==null?'':title);
  return t.replace(/^\s*(?:poster|canvas|plexiglas|acrylglas)\s+[sml]\b\s*[–-]\s*/i,'').trim()||t;
}
/** PrintAPI barcode → i18n (hanging_system / canvas_type values; see WS_FINISHING §3.2a). */
const WS_FINISHING_PAID_LABEL_BY_BARCODE={
  photo_frame_30x40:'finish.paid.photo_frame_30x40',
  photo_frame_40x50:'finish.paid.photo_frame_40x50',
  photo_frame_50x70:'finish.paid.photo_frame_50x70',
  poster_hanger:'finish.paid.poster_hanger',
  box_frame_wood_texture:'finish.paid.box_frame_wood',
  box_frame_color_black:'finish.paid.box_frame_black',
  box_frame_black:'finish.paid.box_frame_black',
  spacers:'finish.paid.spacers',
};
const WS_FINISHING_PAID_LABEL_BY_KIND={
  frame_wood:'finish.paid.frame_wood',
  frame_black:'finish.paid.frame_black',
  hanger:'finish.paid.hanger',
  frame:'finish.paid.frame',
  spacers:'finish.paid.spacers_kind',
};
function wsFinishingPaidLabel(p){
  const bc=String(p&&p.barcode||'').trim().toLowerCase();
  const kind=String(p&&p.finishKind||'').trim().toLowerCase();
  const key=WS_FINISHING_PAID_LABEL_BY_BARCODE[bc]||WS_FINISHING_PAID_LABEL_BY_KIND[kind]||'';
  if(key){
    const t=wsT(key);
    if(t)return t;
  }
  return wsFinishingShortLabel(p&&p.title);
}
function wsFinishingNoneLabel(material){
  if(material==='glass'){
    const g=wsT('finish.none.glass');
    if(g&&g!=='finish.none.glass')return g;
  }
  return wsT('finish.none');
}
function wsFinishingCardHtml(o){
  const priceHtml=o.price>0?'<span class="ws-finishing-card__price">+ '+wsFormatPriceCentsSup(o.price)+'</span>':'';
  let thumb='';
  if(o.img){
    thumb='<span class="ws-finishing-card__thumb"><img src="'+wsFinEsc(o.img)+'" alt="" loading="lazy" decoding="async" width="108" height="108"></span>';
  }else if(o.kind){
    thumb='<span class="ws-finishing-card__thumb ws-finishing-card__icon ws-finishing-card__icon--'+wsFinEsc(o.kind)+'">'+wsFinishingIcon(o.kind)+'</span>';
  }
  return '<button type="button" class="ws-finishing-card'+(o.checked?' is-selected':'')+'" data-ws-fin-card role="radio" aria-checked="'+(o.checked?'true':'false')+'" tabindex="'+(o.checked?'0':'-1')+'" data-ws-fin-val="'+wsFinEsc(o.val)+'">'+thumb+'<span class="ws-finishing-card__label">'+wsFinEsc(o.label)+'</span>'+priceHtml+'</button>';
}
/** Rebuild the finishing card DOM for a material from WS_FINISHING; hide when not applicable. */
function wsRefreshFinishingOptions(material){
  /* Query document-wide so both the result-tier mounts and the Maatkeuze modal mirror
   * (rendered as a <dialog> that may sit outside #wallstraight-generator) are populated. */
  document.querySelectorAll('[data-ws-finishing="'+material+'"]').forEach(mount=>{
    const e=wsFinishingEntry(material);
    const paid=(e&&e.hasFinishingPicker&&Array.isArray(e.paid))?e.paid:[];
    if(!e||!e.hasFinishingPicker||paid.length===0){mount.hidden=true;mount.innerHTML='';return;}
    const want=wsFinishingSel[material];
    if(want&&!paid.some(p=>String(p.variantId)===String(want)))wsFinishingSel[material]=null;
    const selVar=wsFinishingSel[material];
    const noneImg=e.fallbackImage||'';
    const eyebrow=wsFinishingEyebrow(material);
    const cards=[wsFinishingCardHtml({checked:!selVar,img:noneImg,label:wsFinishingNoneLabel(material),price:0,val:'',material})];
    /* AF-P2 theme-first priority (plan R2): curated section/theme photo wins; otherwise a
     * deterministic kind icon (Admin featured_image is shared per material, so it is NOT
     * used as the paid thumb — it would duplicate). Geen keeps the material macro above. */
    paid.forEach(p=>{cards.push(wsFinishingCardHtml({checked:String(selVar)===String(p.variantId),img:p.sectionImage||p.themeImage||'',kind:p.finishKind||'frame',label:wsFinishingPaidLabel(p),price:p.priceCents||0,val:String(p.variantId),material}));});
    /* AF-P3: indicative total (base size price + selected addon), TIER-SCOPED only.
     * Skipped inside the Maatkeuze <dialog> (plan R3 — no base-price element there).
     * Base comes from the tier's size <select> data-p (cents), same source as updPrice. */
    const selOptForTotal=selVar?paid.find(p=>String(p.variantId)===String(selVar)):null;
    const addCents=selOptForTotal?(parseInt(selOptForTotal.priceCents,10)||0):0;
    let totalHtml='';
    if(!(mount.closest&&mount.closest('dialog'))){
      const scope=mount.closest&&mount.closest('.tier,.pr-c');
      const sizeSel=scope&&scope.querySelector('select[data-ws-variant-select]');
      const baseOpt=sizeSel&&sizeSel.selectedOptions&&sizeSel.selectedOptions[0];
      const baseCents=baseOpt?parseInt(baseOpt.dataset.p||'0',10):NaN;
      if(Number.isFinite(baseCents)&&baseCents>0){
        totalHtml='<div class="ws-finishing-picker__total">'+wsFinEsc(wsT('finish.total_estimate'))+' <span class="ws-finishing-picker__total-val">'+wsFormatPriceCentsSup(baseCents+addCents)+'</span></div>';
      }
    }
    mount.hidden=false;
    mount.innerHTML='<div class="ws-finishing-picker__eyebrow">'+wsFinEsc(eyebrow)+'</div>'+
      '<div class="ws-finishing-rail">'+
      '<span class="ws-finishing-edge ws-finishing-edge-l" aria-hidden="true"></span>'+
      '<div class="ws-finishing-picker__row" role="radiogroup" aria-label="'+wsFinEsc(eyebrow)+'" tabindex="0">'+cards.join('')+'</div>'+
      '<span class="ws-finishing-edge ws-finishing-edge-r" aria-hidden="true"></span>'+
      '</div>'+totalHtml;
    mount.querySelectorAll('[data-ws-fin-card]').forEach(card=>{
      card.addEventListener('click',()=>{
        const v=card.getAttribute('data-ws-fin-val');
        wsFinishingSel[material]=v?v:null;
        wsRefreshFinishingOptions(material);
        try{wsRecordFunnelEvent('finishing_selected',{material,finishing:v||'none'});}catch(_){/* noop */}
      });
      card.addEventListener('keydown',ev=>{
        if(ev.key==='Enter'||ev.key===' '){ev.preventDefault();card.click();return;}
        if(ev.key!=='ArrowLeft'&&ev.key!=='ArrowRight'&&ev.key!=='ArrowUp'&&ev.key!=='ArrowDown')return;
        ev.preventDefault();
        const row=card.closest('[role="radiogroup"]');
        if(!row)return;
        const cards=Array.from(row.querySelectorAll('[data-ws-fin-card]'));
        const i=cards.indexOf(card);
        if(i<0)return;
        const delta=(ev.key==='ArrowRight'||ev.key==='ArrowDown')?1:-1;
        const next=cards[(i+delta+cards.length)%cards.length];
        if(next)next.click();
      });
    });
  });
}
function wsFinishingInitAll(){['poster','canvas','glass'].forEach(m=>{try{wsRefreshFinishingOptions(m);}catch(_){/* noop */}});}

/**
 * Slice M.1 / M.2.A — Maatkeuze hulp (size-choice helper).
 *
 * Material-agnostic dispatcher: triggers carry `data-ws-maatkeuze-open=
 * "${material}"` (e.g. "poster", "canvas"); each material has its own
 * `<dialog id="wsMaatkeuze${Material}">` rendered from
 * `snippets/ws-maatkeuze-modal.liquid` once per material. JS finds the
 * right dialog by ID, syncs the cart-driving `<select id="${material}
 * Size">` on open + on each pill pick, and preloads the other two
 * sizes on open so subsequent pill clicks swap without a network
 * blink.
 *
 * Native `<dialog>` + `showModal()` gives us the focus trap, Esc-to-
 * close, `inert` everywhere else, `aria-modal=true`, and a `::backdrop`
 * scrim for free. We only wire:
 *   1. trigger click → `wsMaatkeuzeOpen(material)` + sync to current
 *      `<select>` value
 *   2. pill click → `wsMaatkeuzePick(material, size)` swap + sync
 *      `<select>` so the cart variant follows the modal choice
 *      (hybrid wiring per practitioner sign-off — modal IS the
 *      conversion tool, not a detached info popup)
 *   3. close button + click-on-backdrop → `dialog.close()`
 *
 * Defensive: if the dialog or the select isn't present (e.g. when
 * `ai_product` is blank in Liquid), every entrypoint is a no-op.
 */
/** Move #wsMatSampleDialog under document.body (avoids overflow:hidden clip in WebKit). */
function wsPortalMatSampleDialogToBody(){
  const dlg=document.getElementById('wsMatSampleDialog');
  if(!dlg||dlg.dataset.wsPortaled==='1')return;
  if(dlg.parentElement!==document.body)document.body.appendChild(dlg);
  dlg.dataset.wsPortaled='1';
}
/** Finish-tier material sample — zoom dialog (read-only; not Maatkeuze). */
function wsMatSampleCloseOtherDialogs(){
  ['poster','canvas','glass'].forEach(m=>{try{wsMaatkeuzeClose(m);}catch(_){/* noop */}});
  const ours=document.getElementById('wsMatSampleDialog');
  if(typeof document!=='undefined'){
    document.querySelectorAll('dialog[open]').forEach(d=>{
      if(d!==ours){try{d.close();}catch(_){/* noop */}}
    });
  }
}
const wsMatSampleDetailByMaterial={
  canvas:{desc:'tier.desc.c',bullets:['tier.ul.c1','tier.ul.c2','tier.ul.c3','tier.ul.c4','tier.ul.c5']},
  poster:{desc:'tier.desc.p',bullets:['tier.ul.p1','tier.ul.p2','tier.ul.p3','tier.ul.p4','tier.ul.p5']},
  glass:{desc:'tier.desc.g',bullets:['tier.ul.g1','tier.ul.g2','tier.ul.g3','tier.ul.g4','tier.ul.g5']},
  digital:{desc:'tier.dig.lede',bullets:['tier.ul.d1','tier.ul.d2','tier.ul.d3']},
};
const wsMatSampleWkOranjeDetailByMaterial={
  canvas:{desc:'wk.oranje.pr.canvas.d',bullets:['tier.ul.c1','tier.ul.c2','tier.ul.c3','tier.ul.c4','tier.ul.c5']},
  poster:{desc:'wk.oranje.pr.poster.d',bullets:['tier.ul.p1','tier.ul.p2','tier.ul.p3','tier.ul.p4','tier.ul.p5']},
  glass:{desc:'pr.gls.d',bullets:['tier.ul.g1','tier.ul.g2','tier.ul.g3','tier.ul.g4','tier.ul.g5']},
};
const wsMatSampleWkOranjeCapByMaterial={
  canvas:'wk.oranje.pr.canvas.nm',
  poster:'wk.oranje.pr.poster.nm',
  glass:'tier.nm.g',
};
function wsMatSampleResolveDetail(btn,material){
  const base=wsMatSampleDetailByMaterial[material]||null;
  if(typeof wsIsWkOranjeMode==='function'&&wsIsWkOranjeMode()&&btn&&btn.classList&&btn.classList.contains('ws-wk-pr-mockup-btn')){
    return wsMatSampleWkOranjeDetailByMaterial[material]||base;
  }
  return base;
}
/** Read-only size pills in material preview modal (from data-ws-mat-sizes or live <select>). */
function wsMatSampleRenderSizes(btn,material){
  const wrap=document.getElementById('wsMatSampleDialogSizes');
  const list=document.getElementById('wsMatSampleDialogSizesList');
  const labelEl=wrap?wrap.querySelector('.ws-mat-sample-dialog__sizes-label'):null;
  if(!wrap||!list)return;
  if(material==='digital'){
    wrap.hidden=true;
    list.innerHTML='';
    return;
  }
  let raw=String(btn.getAttribute('data-ws-mat-sizes')||'').trim();
  if(!raw){
    const sel=document.querySelector(`[data-ws-variant-select="${material}"]`);
    if(sel&&sel.options&&sel.options.length){
      raw=Array.from(sel.options).map(o=>{
        const t=String(o.textContent||'').trim();
        const dash=t.indexOf(' - ');
        return dash>=0?t.slice(dash+3).trim():t;
      }).filter(Boolean).join(' · ');
    }
  }
  list.innerHTML='';
  if(labelEl)labelEl.textContent=wsT('tier.mat_sample.sizes_label')||'';
  if(!raw){
    wrap.hidden=true;
    return;
  }
  raw.split('·').map(s=>s.trim()).filter(Boolean).forEach(dim=>{
    const pill=document.createElement('span');
    pill.className='ws-mat-sample-dialog__size-pill';
    pill.setAttribute('role','listitem');
    pill.textContent=dim;
    list.appendChild(pill);
  });
  wrap.hidden=!list.children.length;
}
function wsMatSampleOpen(btn){
  wsPortalMatSampleDialogToBody();
  const dlg=document.getElementById('wsMatSampleDialog');
  if(!dlg||typeof dlg.showModal!=='function')return;
  const material=String(btn.getAttribute('data-ws-mat-sample-open')||'');
  const full=String(btn.getAttribute('data-ws-mat-sample-full')||'');
  if(!full)return;
  wsMatSampleCloseOtherDialogs();
  const img=document.getElementById('wsMatSampleDialogImg');
  const finishWrap=document.getElementById('wsMatSampleDialogFinishWrap');
  const finishImg=document.getElementById('wsMatSampleDialogFinishImg');
  const cap=document.getElementById('wsMatSampleDialogCap');
  const descEl=document.getElementById('wsMatSampleDialogDesc');
  const bulletsEl=document.getElementById('wsMatSampleDialogBullets');
  const previewLabel=wsT('tier.mat_preview.'+material)||wsT('tier.mat_sample.'+material)||'';
  const finishLabel=wsT('tier.mat_sample.'+material)||'';
  const detail=wsMatSampleResolveDetail(btn,material);
  const finishUrl=String(btn.getAttribute('data-ws-mat-finish-url')||'');
  if(img){img.src=full;img.alt=previewLabel;}
  if(finishWrap&&finishImg){
    if(finishUrl&&material!=='digital'){
      finishImg.src=finishUrl;
      finishImg.alt=finishLabel;
      finishWrap.hidden=false;
    }else{
      finishWrap.hidden=true;
      finishImg.removeAttribute('src');
      finishImg.alt='';
    }
  }
  let capText=previewLabel;
  if(typeof wsIsWkOranjeMode==='function'&&wsIsWkOranjeMode()&&btn.classList.contains('ws-wk-pr-mockup-btn')){
    const capKey=wsMatSampleWkOranjeCapByMaterial[material];
    if(capKey){const t=wsT(capKey);if(t)capText=t;}
  }
  if(cap)cap.textContent=capText;
  if(descEl){
    descEl.textContent=detail&&detail.desc?wsT(detail.desc)||'':'';
    descEl.hidden=!descEl.textContent;
  }
  wsMatSampleRenderSizes(btn,material);
  if(bulletsEl){
    bulletsEl.innerHTML='';
    if(detail&&Array.isArray(detail.bullets)){
      detail.bullets.forEach(key=>{
        const text=wsT(key);
        if(!text)return;
        const li=document.createElement('li');
        li.textContent=text;
        bulletsEl.appendChild(li);
      });
    }
    bulletsEl.hidden=!bulletsEl.children.length;
  }
  try{
    dlg.showModal();
    wsMaatkeuzeScrollLock.acquire();
    const closeBtn=dlg.querySelector('[data-ws-mat-sample-close]');
    if(closeBtn&&typeof closeBtn.focus==='function')closeBtn.focus({preventScroll:true});
  }catch(err){
    if(typeof console!=='undefined'&&console.warn)console.warn('[Wallstraight] mat sample showModal failed',err);
  }
}
function wsMatSampleInit(){
  const root=document.getElementById('wallstraight-generator');
  if(!root)return;
  wsPortalMatSampleDialogToBody();
  const dlg=document.getElementById('wsMatSampleDialog');
  if(!dlg)return;
  if(root.dataset.wsMatSampleClickBound!=='1'){
    root.dataset.wsMatSampleClickBound='1';
    root.addEventListener('click',e=>{
      const btn=e.target&&e.target.closest?e.target.closest('[data-ws-mat-sample-open]'):null;
      if(!btn||!root.contains(btn))return;
      e.preventDefault();
      e.stopPropagation();
      wsMatSampleOpen(btn);
    },true);
  }
  if(dlg.dataset.wsMatSampleDlgBound==='1')return;
  dlg.dataset.wsMatSampleDlgBound='1';
  const closeBtn=dlg.querySelector('[data-ws-mat-sample-close]');
  if(closeBtn)closeBtn.addEventListener('click',()=>{try{dlg.close();}catch(_){/* noop */}});
  dlg.addEventListener('click',e=>{if(e.target===dlg)try{dlg.close();}catch(_){/* noop */}});
  dlg.addEventListener('close',()=>{wsMaatkeuzeScrollLock.release();});
}

function wsMaatkeuzeDialogId(material){
  const m=String(material||'');
  if(!m)return '';
  return 'wsMaatkeuze'+m.charAt(0).toUpperCase()+m.slice(1).toLowerCase();
}
/* Slice MX.B — body scroll lock while any Maatkeuze dialog is open.
   Native <dialog> + showModal() makes the rest of the page `inert`
   for a11y but does NOT block document scroll on iOS Safari (see
   WHATWG html#7732, an explicit known UX gap the spec leaves to
   authors). We supplement with a reference-counted overflow-hidden
   lock on <html> + <body> so:
     - touch scroll on the dialog backdrop never chains to the page
     - Esc / back-button / close-button / outside-click all release
       exactly once.
   We bind to the `close` event ONLY (not `cancel`). Per MDN, `cancel`
   fires when the user makes a close request (Esc / requestClose /
   mobile back) BEFORE the dialog actually closes; if the default is
   not prevented, the dialog closes and `close` fires after. Listening
   to both would decrement the counter twice on Esc. Binding to `close`
   alone is the universal terminator AND correctly skips the counter
   when a future code path calls `event.preventDefault()` in `cancel`.
   https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement/cancel_event
   Idempotent: `wsMaatkeuzeBound` flag in `wsMaatkeuzeInit` already
   ensures each dialog binds its close listener exactly once. The
   counter is module-level and survives focus re-renders. Restoration
   uses the inline-style snapshot taken on the 0→1 transition so we
   coexist cleanly with any other code that mutates overflow. */
const wsMaatkeuzeScrollLock=(function(){
  let count=0;
  let priorHtmlOverflow='';
  let priorBodyOverflow='';
  return {
    acquire:function(){
      if(typeof document==='undefined')return;
      const root=document.getElementById('wallstraight-generator');
      if(!root)return; /* never leak styles on pages without the generator */
      if(count===0){
        priorHtmlOverflow=document.documentElement.style.overflow||'';
        priorBodyOverflow=document.body?(document.body.style.overflow||''):'';
        document.documentElement.style.overflow='hidden';
        if(document.body)document.body.style.overflow='hidden';
      }
      count+=1;
    },
    release:function(){
      if(typeof document==='undefined')return;
      if(count===0)return;
      count-=1;
      if(count===0){
        document.documentElement.style.overflow=priorHtmlOverflow;
        if(document.body)document.body.style.overflow=priorBodyOverflow;
        priorHtmlOverflow='';
        priorBodyOverflow='';
      }
    },
    _count:function(){return count;}
  };
})();
/** MX.F — portrait checkpoint required before funnel cart-add. */
function wsPreviewReadyForCart(){
  if(S&&S.lastJobId&&S.lastPreviewUrl&&/^https?:\/\//i.test(String(S.lastPreviewUrl)))return true;
  const sess=typeof wsPortraitSessionRead==='function'?wsPortraitSessionRead():null;
  return !!(sess&&sess.jobId&&(sess.previewUrl||sess.shareUrl));
}
function wsCartRequiresPreview(material){
  return material==='poster'||material==='canvas'||material==='glass'||material==='digital';
}
function wsMaatkeuzeActivePillDim(dlg){
  if(!dlg)return '';
  const sz=dlg.getAttribute('data-active-size')||'m';
  const pill=dlg.querySelector('.ws-maatkeuze-pill[data-size="'+sz+'"]');
  return pill?String(pill.getAttribute('data-dim')||''):'';
}
function wsMaatkeuzeRefreshCartBtn(material){
  const dlg=document.getElementById(wsMaatkeuzeDialogId(material));
  if(!dlg)return;
  const btn=dlg.querySelector('[data-ws-maatkeuze-cart]');
  if(!btn)return;
  if(btn.getAttribute('aria-busy')==='true')return;
  const sz=dlg.getAttribute('data-active-size')||'m';
  const activePill=dlg.querySelector('.ws-maatkeuze-pill[data-size="'+sz+'"]');
  const pillDisabled=!activePill||activePill.getAttribute('aria-disabled')==='true'||activePill.disabled;
  const generating=!!(S&&(S.busy||S.generateLock));
  const ready=wsPreviewReadyForCart();
  btn.disabled=false;
  btn.removeAttribute('aria-busy');
  if(generating){
    btn.disabled=true;
    btn.setAttribute('data-ws-maatkeuze-mode','generating');
    btn.textContent=wsT('maatkeuze.cta_generating');
    return;
  }
  if(!ready){
    btn.setAttribute('data-ws-maatkeuze-mode','funnel');
    btn.textContent=wsT('maatkeuze.cta_generate_first');
    return;
  }
  btn.setAttribute('data-ws-maatkeuze-mode','purchase');
  const dim=wsMaatkeuzeActivePillDim(dlg);
  btn.textContent=wsT('maatkeuze.add_to_cart').replace('{0}',dim);
  if(pillDisabled||!wsResolveVariantId(material))btn.disabled=true;
}
function wsMaatkeuzeRefreshAllCartBtns(){
  ['poster','canvas','glass'].forEach(m=>{try{wsMaatkeuzeRefreshCartBtn(m);}catch(_){/* noop */}});
}
function wsMaatkeuzeScrollToGenerate(material){
  if(material){
    wsMaatkeuzeClose(material);
    try{wsRememberPrintIntent(material);}catch(_){/* noop */}
  }
  if(resPage&&resPage.classList.contains('show'))showLanding();
  try{wsRecordFunnelEvent('maatkeuze_generate_first_click',{material:material||null});}catch(_){/* noop */}
  requestAnimationFrame(()=>{
    requestAnimationFrame(()=>{
      const m=document.getElementById('maker');
      if(m)wsScrollElIntoView(m,'start');
      try{if(m&&typeof m.focus==='function')m.focus({preventScroll:true});}catch(_){/* noop */}
    });
  });
}
function wsMaatkeuzeOpen(material){
  const dlg=document.getElementById(wsMaatkeuzeDialogId(material));
  if(!dlg||typeof dlg.showModal!=='function'){
    wsToastShow({type:'error',message:wsT('maatkeuze.open_failed'),duration:6500});
    if(typeof console!=='undefined'&&console.warn)console.warn('[Wallstraight] Maatkeuze: dialog missing or showModal unsupported',material);
    return;
  }
  /* Resolve initial active size against the rendered pills (M.2.C.3
     refactor — replaces the M→S→L Liquid fallback that previously
     duplicated this logic in the snippet). The merchant's available
     variants drive which pills render; the cart `<select>` reflects
     the same set. We trust the rendered DOM as the single source of
     truth: prefer the live `<select>` value if it matches an
     ENABLED pill; otherwise fall through M → S → L through whatever
     enabled pills exist. M.2.D.2 — sold-out variants render as
     disabled pills (aria-disabled="true") and are excluded from
     this resolver so the modal never opens with an un-purchaseable
     pill marked active. */
  const enabledSizes=Array.from(dlg.querySelectorAll('.ws-maatkeuze-pill'))
    .filter(p=>p.getAttribute('aria-disabled')!=='true')
    .map(p=>p.getAttribute('data-size'));
  if(enabledSizes.length===0){
    wsToastShow({type:'error',message:wsT('maatkeuze.none_enabled'),duration:7000});
    return;
  }
  const gen=document.getElementById('wallstraight-generator');
  const select=gen?gen.querySelector('select[data-ws-variant-select="'+material+'"]'):document.getElementById(material+'Size');
  const sel=select&&select.value?String(select.value).toLowerCase():'';
  let initial=(sel==='s'||sel==='m'||sel==='l')&&enabledSizes.indexOf(sel)>-1?sel:'';
  if(!initial){
    if(enabledSizes.indexOf('m')>-1)initial='m';
    else if(enabledSizes.indexOf('s')>-1)initial='s';
    else initial='l';
  }
  wsMaatkeuzePick(material,initial,{syncSelect:false});
  /* Preload the other renders on open so a subsequent pill click
     swaps instantly instead of waiting on a lazy network fetch.
     Preload skips any size for which Liquid omitted the data-img
     (e.g. a merchant who dropped a variant — the pill won't render
     either, so this just avoids a junk request).
     Use `<link rel="preload" fetchpriority="low">` so the browser
     schedules these in idle bandwidth instead of competing with
     critical resources — important on 3G/4G where a 6 MB triple-
     fetch on every modal open could starve LCP/INP work elsewhere
     on the page. fetchPriority is documented at
     https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/fetchPriority
     and is a no-op on browsers that don't support it (the preload
     still works at default priority). */
  const img=dlg.querySelector('.ws-maatkeuze-img');
  if(img&&!dlg.dataset.wsMaatkeuzePreloaded){
    dlg.dataset.wsMaatkeuzePreloaded='1';
    const head=document.head||document.getElementsByTagName('head')[0];
    ['s','m','l'].forEach(sz=>{
      const url=img.getAttribute('data-img-'+sz);
      if(!url)return;
      const link=document.createElement('link');
      link.rel='preload';
      link.as='image';
      link.href=url;
      try{link.fetchPriority='low';}catch(_){/* legacy browser */}
      if(head)head.appendChild(link);
    });
  }
  try{
    dlg.showModal();
    /* MX.B: acquire the document scroll lock only AFTER showModal
       succeeds, so a thrown call (e.g. dialog already open) does not
       leak the counter. The matching release lives on the `close`
       event listener bound in `wsMaatkeuzeInit`. */
    wsMaatkeuzeScrollLock.acquire();
    /* M.2.D.3: per WAI-ARIA APG dialog pattern, send initial focus
       to the most contextually relevant element. For a size guide,
       that's the active pill — users can immediately Arrow between
       sizes. Default <dialog> behavior would focus the first
       focusable (the close button), which fights the radio-pattern
       arrow flow. We override after showModal() so the browser's
       initial focus runs first, then we reroute. */
    const activePill=dlg.querySelector('.ws-maatkeuze-pill[tabindex="0"]');
    if(activePill)activePill.focus();
    wsMaatkeuzeRefreshCartBtn(material);
  }catch(err){
    wsToastShow({type:'error',message:wsT('maatkeuze.open_failed'),duration:6500});
    if(typeof console!=='undefined'&&console.warn)console.warn('[Wallstraight] Maatkeuze showModal failed',material,err);
  }
}
function wsMaatkeuzeClose(material){
  const dlg=document.getElementById(wsMaatkeuzeDialogId(material));
  if(!dlg)return;
  try{dlg.close();}catch(_){/* not open */}
}
function wsMaatkeuzePick(material,size,opts){
  const dlg=document.getElementById(wsMaatkeuzeDialogId(material));
  if(!dlg)return;
  const sz=String(size||'').toLowerCase();
  if(sz!=='s'&&sz!=='m'&&sz!=='l')return;
  dlg.setAttribute('data-active-size',sz);
  const img=dlg.querySelector('.ws-maatkeuze-img');
  if(img){
    const next=img.getAttribute('data-img-'+sz);
    if(next)img.setAttribute('src',next);
  }
  /* Roving tabindex per WAI-ARIA APG radio pattern (M.2.D.3): only
     the active enabled pill is in the Tab order; arrow keys then
     navigate between pills. Disabled pills are never focusable
     (tabindex=-1) regardless of active state — if the active size
     is somehow disabled, we still set its tabindex=0 so focus has
     somewhere to land, but `wsMaatkeuzeNav` skips disabled pills
     when stepping. https://www.w3.org/WAI/ARIA/apg/patterns/radio/ */
  dlg.querySelectorAll('.ws-maatkeuze-pill').forEach(p=>{
    const isActive=p.getAttribute('data-size')===sz;
    const isDisabled=p.getAttribute('aria-disabled')==='true';
    p.setAttribute('aria-checked',isActive?'true':'false');
    p.setAttribute('tabindex',isActive&&!isDisabled?'0':'-1');
  });
  if(opts&&opts.syncSelect===false){
    try{wsRefreshFinishingOptions(material);}catch(_){/* noop */}
    wsMaatkeuzeRefreshCartBtn(material);
    return;
  }
  /* Sync all cart-driving selects (landing + results) + recompute tier prices.
     Only applies if the matching option exists AND is enabled. */
  wsSyncTwinVariantSelects(material,sz);
  wsRememberPrintIntent(material);
  try{updPrice(material);}catch(_){/* noop */}
  try{wsRefreshFinishingOptions(material);}catch(_){/* noop */}
  wsMaatkeuzeRefreshCartBtn(material);
}
/* M.2.D.3: WAI-ARIA APG radio pattern — arrow-key navigation
   between pills. `dir` is +1 (next) or -1 (previous); 'home' / 'end'
   jump to first/last enabled pill. Wraps at boundaries. Skips
   disabled pills (sold-out variants per M.2.D.2). Selection moves
   with focus per the spec ("Selection Follows Focus"). Calls
   wsMaatkeuzePick which (a) updates aria-checked + tabindex,
   (b) syncs the cart `<select>`, (c) updates the figure image. */
function wsMaatkeuzeNav(material,dir){
  const dlg=document.getElementById(wsMaatkeuzeDialogId(material));
  if(!dlg)return;
  const enabled=Array.from(dlg.querySelectorAll('.ws-maatkeuze-pill'))
    .filter(p=>p.getAttribute('aria-disabled')!=='true');
  if(enabled.length===0)return;
  const cur=dlg.getAttribute('data-active-size');
  let idx=enabled.findIndex(p=>p.getAttribute('data-size')===cur);
  if(idx===-1)idx=0;
  let next;
  if(dir==='home')next=0;
  else if(dir==='end')next=enabled.length-1;
  else next=(idx+dir+enabled.length)%enabled.length;
  const nextSize=enabled[next].getAttribute('data-size');
  wsMaatkeuzePick(material,nextSize);
  enabled[next].focus();
}
function wsMaatkeuzeInit(){
  const root=document.getElementById('wallstraight-generator');
  if(!root)return;
  root.querySelectorAll('[data-ws-maatkeuze-open]').forEach(btn=>{
    if(btn.dataset.wsMaatkeuzeBound==='1')return;
    btn.dataset.wsMaatkeuzeBound='1';
    const material=btn.getAttribute('data-ws-maatkeuze-open');
    btn.addEventListener('click',e=>{e.preventDefault();wsMaatkeuzeOpen(material);});
  });
  /* Bind every dialog instance once (poster, canvas, future glass).
     Idempotent via the `wsMaatkeuzeBound` dataset flag. */
  root.querySelectorAll('.ws-maatkeuze[data-material]').forEach(dlg=>{
    if(dlg.dataset.wsMaatkeuzeBound==='1')return;
    dlg.dataset.wsMaatkeuzeBound='1';
    const material=dlg.getAttribute('data-material');
    dlg.querySelectorAll('.ws-maatkeuze-pill').forEach(pill=>{
      pill.addEventListener('click',e=>{
        /* M.2.D.2: silently ignore clicks on sold-out pills. The
           native `disabled` attribute already suppresses click in
           most browsers, but we belt-and-braces with the aria check
           in case a screen-reader or AT injects a synthetic click. */
        if(pill.getAttribute('aria-disabled')==='true'||pill.disabled){
          e.preventDefault();
          return;
        }
        wsMaatkeuzePick(material,pill.getAttribute('data-size'));
      });
    });
    /* M.2.D.3: keyboard navigation on the radiogroup per WAI-ARIA APG.
       Bound on the radiogroup container (not per-pill) so it fires
       even while focus moves between pills. PageUp/PageDown are NOT
       included because the spec only lists Arrow / Home / End for
       single-orientation radio groups. */
    const radiogroup=dlg.querySelector('.ws-maatkeuze-pillrow[role="radiogroup"]');
    if(radiogroup){
      radiogroup.addEventListener('keydown',e=>{
        if(!e.target.classList||!e.target.classList.contains('ws-maatkeuze-pill'))return;
        let handled=true;
        switch(e.key){
          case 'ArrowRight':
          case 'ArrowDown':
            wsMaatkeuzeNav(material,1);
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            wsMaatkeuzeNav(material,-1);
            break;
          case 'Home':
            wsMaatkeuzeNav(material,'home');
            break;
          case 'End':
            wsMaatkeuzeNav(material,'end');
            break;
          default:
            handled=false;
        }
        if(handled)e.preventDefault();
      });
    }
    const closeBtn=dlg.querySelector('[data-ws-maatkeuze-close]');
    if(closeBtn)closeBtn.addEventListener('click',()=>{wsMaatkeuzeClose(material);});
    /* Click on the dark area outside the frame (the `::backdrop` proxy:
       when the click target IS the dialog element itself, the user is
       clicking past the frame). Native dialog also exposes `cancel`
       via Esc — handled by the browser; we do not bind it. */
    dlg.addEventListener('click',e=>{if(e.target===dlg)wsMaatkeuzeClose(material);});
    /* MX.B: release the document scroll lock when the dialog actually
       closes — covers Esc, programmatic close, button close, outside-
       click, and the (currently-unimplemented) future cancel→close
       path. See `wsMaatkeuzeScrollLock` block above for why we listen
       to `close` and not `cancel`. */
    dlg.addEventListener('close',()=>{wsMaatkeuzeScrollLock.release();});
    const cartBtn=dlg.querySelector('[data-ws-maatkeuze-cart]');
    if(cartBtn){
      cartBtn.addEventListener('click',async()=>{
        if(cartBtn.disabled||cartBtn.getAttribute('aria-busy')==='true')return;
        if(S.busy||S.generateLock)return;
        if(!wsPreviewReadyForCart()){
          wsMaatkeuzeScrollToGenerate(material);
          return;
        }
        const ok=await addToCart(material,cartBtn);
        if(ok)wsMaatkeuzeClose(material);
      });
    }
  });
}

/** R03: pure cart lines from resolved inputs; orchestration owns identity, selection and effects. */
function wsBuildCartItems({variantId,material,styleLabel,category,jobId,previewUrl,finishing,bundleId}){
  const isDigital=material==='digital';
  const props={
    '_Stijl':styleLabel,
    '_Categorie':category,
    '_Preview':isDigital?'HD digital download (paid order)':'AI portret (preview)'
  };
  if(jobId)props['_ws_job_id']=jobId;
  if(previewUrl)props['_ws_preview_url']=previewUrl;
  const extraItems=[];
  if(!isDigital&&finishing&&finishing.entry){
    const fin=finishing;
    const opts=fin.isPaid?(fin.option&&fin.option.printApiOptions):(fin.entry.geen&&fin.entry.geen.printApiOptions);
    if(!fin.entry.omitOptionsKey&&Array.isArray(opts)&&opts.length){
      props['_printapi_options']=JSON.stringify(opts);
    }
    if(fin.isPaid&&fin.option&&fin.option.variantId){
      props['_ws_bundle_id']=bundleId;
      if(fin.option.title)props['_finish_label']=fin.option.title;
      extraItems.push({
        id:Number(fin.option.variantId),
        quantity:1,
        properties:{'_addon_for':String(variantId),'_ws_bundle_id':bundleId,'_finish_for_label':fin.option.title||''}
      });
    }
  }
  return [{id:Number(variantId),quantity:1,properties:props}].concat(extraItems);
}

// Add to Shopify cart (variant id from select / dlBtn data-variant-id, or WS_VARIANTS fallback)
async function addToCart(material,triggerBtn){
  wsPortalToastToBody();
  wsRecordFunnelEvent('add_to_cart_attempt',{material:material||null});
  let funnelEpoch=null;const funnelCart={material,style:S.style,category:S.cat};
  try{funnelEpoch=window.wsFunnelAnalytics?.capture()??null;const selection=wsPrintIntentFromSelection(material);if(selection)funnelCart.size=selection.sizeTier;window.wsFunnelAnalytics?.record('add_to_cart_attempt',funnelCart,funnelEpoch);}catch(_){}
  const variantId=wsResolveVariantId(material);
  if(!variantId){
    try{window.wsFunnelAnalytics?.record('add_to_cart_error',{...funnelCart,reason:'variant_unavailable'},funnelEpoch);}catch(_){}
    wsToastShow({type:'error',message:wsT('cart.variant_missing'),duration:7500});
    console.warn('[Wallstraight] No variant id for tier',material);
    return false;
  }
  if(wsCartRequiresPreview(material)&&!wsPreviewReadyForCart()){
    try{window.wsFunnelAnalytics?.record('add_to_cart_error',{...funnelCart,reason:'preview_required'},funnelEpoch);}catch(_){}
    wsToastShow({type:'info',message:wsT('maatkeuze.need_preview'),duration:7000});
    wsMaatkeuzeScrollToGenerate(material);
    return false;
  }

  const root=document.getElementById('wallstraight-generator');
  const tierBtns=root?Array.from(root.querySelectorAll('.res-pricing .tier-btn')):[];
  const btn=triggerBtn&&triggerBtn.closest?triggerBtn.closest('button'):triggerBtn;
  const isMaatkeuzeBtn=btn&&btn.matches&&btn.matches('[data-ws-maatkeuze-cart]');
  const materialForRestore=isMaatkeuzeBtn?(btn.getAttribute('data-material')||material):null;

  const restoreTierButtons=()=>{
    tierBtns.forEach(el=>{
      el.disabled=false;
      el.removeAttribute('aria-busy');
      const k=el.getAttribute('data-i18n');
      if(k) el.textContent=wsT(k);
    });
  };

  wsCartWriteState.pending++;
  wsCartWriteState.epoch++;
  try{
    if(isMaatkeuzeBtn&&btn){
      btn.setAttribute('aria-busy','true');
      btn.disabled=true;
      btn.textContent=wsT('cart.adding');
    }else{
      tierBtns.forEach(el=>{ el.disabled=true; });
      if(btn&&tierBtns.includes(btn)){
        btn.setAttribute('aria-busy','true');
        btn.textContent=wsT('cart.adding');
      }
    }

    const isDigital=material==='digital';
    let jobId=S.lastJobId||'';
    let previewUrl=S.lastPreviewUrl||'';
    if((!jobId||!previewUrl)&&typeof wsPortraitSessionRead==='function'){
      const sess=wsPortraitSessionRead();
      if(sess){
        if(!jobId)jobId=sess.jobId;
        if(!previewUrl)previewUrl=sess.previewUrl||'';
      }
    }
    funnelCart.wsJobId=jobId;
    const itemInput={
      variantId,material,
      styleLabel:wsStyleName(S.style)||wsStyleName('royal'),
      category:S.cat||'huisdier',jobId,previewUrl
    };
    // Keep the existing main-line fallback if finishing resolution or construction fails.
    let cartItems=wsBuildCartItems(itemInput);
    if(!isDigital){
      try{
        const finishing=wsFinishingSelected(material);
        if(finishing.entry&&finishing.isPaid&&finishing.option&&finishing.option.variantId){
          const bundleId='wsfin-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);
          cartItems=wsBuildCartItems({...itemInput,finishing,bundleId});
        }else{
          cartItems=wsBuildCartItems({...itemInput,finishing});
        }
      }catch(e){console.warn('[Wallstraight] finishing cart build failed',e);}
    }
    const cartPayload={items:cartItems};
  /* AI funnel: always bundle ws-cart-drawer even when Dawn header mounts
   * `<cart-notification>` — otherwise add-to-cart refreshes Dawn popup only
   * and manual drawer opens show stale SSR empty markup. Catalog pages keep
   * cart-notification when the funnel section is absent. */
    const wsFunnelRoot=document.getElementById('wallstraight-generator');
    const wsDrawerEl=document.getElementById('ws-cart-drawer');
    if(wsFunnelRoot&&wsDrawerEl){
      cartPayload.sections=['ws-cart-drawer','cart-icon-bubble'];
      cartPayload.sections_url=wsCartSectionsUrl();
    }else if(document.querySelector('cart-notification')){
      cartPayload.sections=WS_CART_NOTIFICATION_BUNDLE_IDS;
      cartPayload.sections_url=wsCartSectionsUrl();
    }else if(wsDrawerEl){
      cartPayload.sections=['ws-cart-drawer','cart-icon-bubble'];
      cartPayload.sections_url=wsCartSectionsUrl();
    }
    const res=await fetch(wsCartAddUrl(),{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      credentials:'same-origin',
      body:JSON.stringify(cartPayload)
    });

    let parsed=null;
    try{
      parsed=await res.json();
    }catch(_){parsed=null;}
    parsed=wsNormalizeCartAddJson(parsed);

    /** Shopify returns `{ status: 422, description }` for errors — see Cart API. */
    if(parsed!=null&&Number(parsed.status)===422){
      wsRecordFunnelEvent('add_to_cart_error',{material:material||null,status:422});
      try{window.wsFunnelAnalytics?.record('add_to_cart_error',{...funnelCart,reason:'http_error',httpStatus:422},funnelEpoch);}catch(_){}
      wsToastShow({type:'error',message:wsCartErrorUserMessage(parsed)});
      return false;
    }
    if(!res.ok){
      const cartMsg=parsed?.description||parsed?.message||'';
      console.warn('Cart add failed',res.status,cartMsg||'(no body)');
      wsRecordFunnelEvent('add_to_cart_error',{material:material||null,status:res.status});
      try{window.wsFunnelAnalytics?.record('add_to_cart_error',{...funnelCart,reason:'http_error',httpStatus:res.status},funnelEpoch);}catch(_){}
      wsToastShow({type:'error',message:wsCartErrorUserMessage(parsed)});
      return false;
    }
    if(!wsCartAddSucceeded(res,parsed)){
      console.warn('[Wallstraight] Unexpected cart/add response',parsed);
      wsRecordFunnelEvent('add_to_cart_error',{material:material||null,status:'unexpected_response'});
      try{window.wsFunnelAnalytics?.record('add_to_cart_error',{...funnelCart,reason:'invalid_response',httpStatus:res.status},funnelEpoch);}catch(_){}
      wsToastShow({type:'error',message:wsT('cart.fail')});
      return false;
    }

    wsRecordFunnelEvent('add_to_cart_success',{material:material||null});
    try{
      const confirmedMain=Array.isArray(parsed.items)&&parsed.items.some(item=>item&&Number(item.variant_id||item.id)===Number(variantId)&&item.quantity>0&&item.properties?._ws_job_id===jobId&&item.properties?._ws_preview_url===previewUrl);
      if(confirmedMain)window.wsFunnelAnalytics?.record('add_to_cart_success',{...funnelCart,httpStatus:res.status},funnelEpoch);
    }catch(_){}
    try{
      const sizeEl=document.querySelector('#wallstraight-generator select[data-ws-variant-select="'+material+'"]')||document.getElementById(material+'Size');
      const selOpt=sizeEl&&sizeEl.selectedOptions&&sizeEl.selectedOptions[0];
      const fallbackCents=parseInt(selOpt&&(selOpt.dataset&&selOpt.dataset.p||selOpt.getAttribute('data-p'))||'0',10);
      if(window.wsMetaStandardEvents&&typeof window.wsMetaStandardEvents.trackAddToCart==='function'){
        window.wsMetaStandardEvents.trackAddToCart(variantId,parsed,fallbackCents);
      }
    }catch(_){/* meta must not break cart */}
    const cartSuccessCtx=wsBuildCartAddSuccessCtx(material,isDigital);
    const openedCartNotification=wsTryOpenCartNotificationFromAddResponse(parsed);
    if(!openedCartNotification){
      wsNotifyCartAddSuccess(cartSuccessCtx);
    }
    try{
      document.dispatchEvent(new CustomEvent('wallstraight:cart-added',{detail:{items:parsed.items,material,sections:parsed&&parsed.sections?parsed.sections:null}}));
    }catch(_){/* optional theme integration */}
    wsApplyResCartFabBadgeFromCartAdd(parsed);
    void wsRefreshResCartFabBadge();
    if(!openedCartNotification){
      wsHydrateCartBubbleFromAddResponse(parsed);
    }
    return true;
  }catch(e){
    wsRecordFunnelEvent('add_to_cart_error',{material:material||null,status:'network_or_exception'});
      try{window.wsFunnelAnalytics?.record('add_to_cart_error',{...funnelCart,reason:e&&e.name==='AbortError'?'timeout':'network_error'},funnelEpoch);}catch(_){}
    wsToastShow({type:'error',message:wsShopperSafeErrorMessage(e,wsT('cart.fail'))});
    console.warn('Cart add failed');
    return false;
  }finally{
    wsCartWriteState.pending--;
    wsCartWriteState.epoch++;
    restoreTierButtons();
    if(materialForRestore)wsMaatkeuzeRefreshCartBtn(materialForRestore);
  }
}

// Navigation (backLink is type=button — no href="#" navigation)
const backLink=$('#backLink'), backHome=$('#backHome');
if(backLink)backLink.addEventListener('click',()=>{showLanding();});
if(backHome)backHome.addEventListener('click',e=>{e.preventDefault();showLanding();});
const wsResCartFabEl=document.getElementById('wsResCartFab');
if(wsResCartFabEl)wsResCartFabEl.addEventListener('click',()=>{wsRecordFunnelEvent('cart_drawer_open_click',{surface:'result_fab'});},{capture:true});

// FAQ
$$('.faq-q').forEach(q=>q.onclick=()=>{const i=q.closest('.faq-i'),a=i&&i.querySelector('.faq-a'),o=i&&i.classList.contains('open');$$('.faq-i').forEach(x=>{x.classList.remove('open');const p=x.querySelector('.faq-a');if(p)p.style.maxHeight=null;});if(i&&a&&!o){i.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}});

// Smooth in-page anchors only — skip bare "#" / "#/" (invalid querySelector breaks handlers on some anchors)
$$('a[href^="#"]').forEach(a=>{
  const sel=(a.getAttribute('href')||'').trim();
  if(sel.length<=1)return;
  try{document.querySelector(sel);}catch(_){return;}
  a.onclick=e=>{
    let t=null;
    try{t=document.querySelector(sel);}catch(_){return;}
    if(t){e.preventDefault();wsScrollElIntoView(t,'start');}
  };
});

(function wsBindHeroGalleryJump(){
  const gal=document.querySelector('#wallstraight-generator .hero .gal');
  if(!gal)return;
  gal.addEventListener('click',e=>{
    const btn=e.target.closest('[data-ws-jump-style]');
    if(!btn||!gal.contains(btn))return;
    const key=btn.getAttribute('data-ws-jump-style');
    if(!key)return;
    wsHeroGalleryJump(key);
  });
})();

(function wsBindWkLookbookGallery(){
  if(typeof wsIsWkOranjeMode==='function'&&!wsIsWkOranjeMode())return;
  const track=document.querySelector('#landingPage.ws-wk-oranje .ws-wk-gallery-track');
  if(!track)return;
  track.addEventListener('click',e=>{
    const card=e.target.closest('[data-ws-wk-lookbook-style]');
    if(!card||!track.contains(card))return;
    const styleKey=card.getAttribute('data-ws-wk-lookbook-style');
    const cat=card.getAttribute('data-ws-wk-lookbook-cat');
    if(!styleKey)return;
    wsWkLookbookJump(cat,styleKey);
  });
})();

/**
 * Royal hero tile: keep sample `<img>` + video `poster` visible until the clip
 * actually plays. `playing` marks real playback start (MDN HTMLMediaElement
 * playing event). `play()` may still reject — https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play
 * Video `poster` while downloading — https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video
 */
(function wsBindHeroRoyalPreviewVideo(){
  const btn=document.querySelector('#wallstraight-generator .hero .gal button[data-ws-jump-style="royal"]');
  const vid=btn&&btn.querySelector('video.gi-vid');
  if(!btn||!vid)return;
  if(typeof wsLoaderPrefersReducedMotion==='function'&&wsLoaderPrefersReducedMotion())return;
  let loaded=false;
  let playToken=0;
  let playingListener=null;
  function clearPlayingListener(){
    if(playingListener){
      vid.removeEventListener('playing', playingListener);
      playingListener=null;
    }
  }
  function ensureLoaded(){
    if(loaded)return;
    loaded=true;
    vid.preload='auto';
    try{vid.load();}catch(_){/* no-op */}
  }
  function setPreviewActive(want){
    if(!want){
      playToken++;
      clearPlayingListener();
      vid.pause();
      try{vid.currentTime=0;}catch(_){/* no-op */}
      btn.classList.remove('gi--vid-active');
      return;
    }
    const token=++playToken;
    clearPlayingListener();
    ensureLoaded();
    playingListener=function wsRoyalVidOnPlaying(){
      if(token!==playToken)return;
      btn.classList.add('gi--vid-active');
      clearPlayingListener();
    };
    vid.addEventListener('playing', playingListener);
    let p=null;
    try{
      p=vid.play();
    }catch(_){
      clearPlayingListener();
      if(token===playToken)btn.classList.remove('gi--vid-active');
      return;
    }
    if(p&&typeof p.then==='function'){
      p.catch(()=>{
        clearPlayingListener();
        if(token===playToken)btn.classList.remove('gi--vid-active');
      });
    }
  }
  const mqHover=typeof window.matchMedia==='function'
    ?window.matchMedia('(hover: hover) and (pointer: fine)')
    :{matches:false};
  if(mqHover.matches){
    let pointerInside=false, focusInside=false, lastWant=false;
    function recomputeWant(){
      const want=pointerInside||focusInside;
      if(want===lastWant)return;
      lastWant=want;
      setPreviewActive(want);
    }
    btn.addEventListener('mouseenter',()=>{pointerInside=true;recomputeWant();});
    btn.addEventListener('mouseleave',()=>{pointerInside=false;recomputeWant();});
    btn.addEventListener('focus',()=>{focusInside=true;recomputeWant();});
    btn.addEventListener('blur',()=>{focusInside=false;recomputeWant();});
    return;
  }
  if(typeof IntersectionObserver!=='function')return;
  let lastIoWant=false;
  const io=new IntersectionObserver(entries=>{
    const ent=entries&&entries.length?entries[entries.length-1]:null;
    if(!ent)return;
    const want=ent.isIntersecting&&ent.intersectionRatio>=0.35;
    if(want===lastIoWant)return;
    lastIoWant=want;
    setPreviewActive(want);
  },{threshold:[0,0.1,0.25,0.35,0.5,0.75,1]});
  io.observe(btn);
})();

// Wizard: fresh landing opens step 1 with no category/style pre-selected.
function wsBootstrapWizardFreshStart(){
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap)return;
  wrap.querySelectorAll('.pill').forEach(x=>x.classList.remove('on'));
  wrap.querySelectorAll('.sty').forEach(el=>el.classList.remove('on'));
  wrap.querySelectorAll('input[name="s"]').forEach(inp=>{inp.checked=false;});
  S.cat=null;
  S.style=null;
  if(typeof wsRefreshAddPhotoCta==='function')wsRefreshAddPhotoCta();
  if(typeof wsRefreshScenePicker==='function')wsRefreshScenePicker();
}
function wsSyncWizardDefaultsHint(){
  const el=document.getElementById('wsWizardDefaultsHint');
  if(!el)return;
  /* Step 3 uses explicit “change category / style” nav actions instead. */
  el.hidden=true;
}

/** Choice summary only on upload step (step 3). Hidden entirely in infer composer mode. */
function wsMountChoiceSummary(step){
  const sum=document.getElementById('ws-wizard-choice-summary');
  const park=document.getElementById('ws-wizard-summary-park');
  if(!sum)return;
  if(wsIsCategoryInferEnabled()){
    sum.hidden=true;
    if(park&&sum.parentElement!==park)park.appendChild(sum);
    return;
  }
  if(step!==3){
    sum.hidden=true;
    if(park&&sum.parentElement!==park)park.appendChild(sum);
    return;
  }
  sum.hidden=false;
  const slot=document.getElementById('ws-wizard-summary-slot-3');
  if(slot&&sum.parentElement!==slot)slot.appendChild(sum);
}

let currentStep = 1;

/**
 * Whether step `stepNum` may be opened via the breadcrumb, based on DOM choices (not the
 * fake "completed" class from initial HTML). Needed because `showStep(1)` strips `completed`
 * from all crumbs — otherwise step 2+ stay pointer-events-locked while a category is already chosen.
 */
function wsWizardStepPrereqsMet(stepNum){
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap||stepNum<=1)return true;
  const hasStyle=wrap.querySelector('.sty.on')!==null;
  const hasFile=!!S.b64;
  const hasCat=!!S.cat||wrap.querySelector('.pill.on')!==null;
  if(wsIsCategoryInferEnabled()){
    const total=wsLogicalWizardStepCount();
    if(stepNum>total)return false;
    if(wsFunnelOrder()==='upload_style'){
      if(stepNum===2)return hasFile;
      return hasFile&&hasStyle;
    }
    if(stepNum===2)return hasStyle;
    return hasStyle&&hasFile&&hasCat;
  }
  if(stepNum===2)return hasCat;
  if(stepNum===3)return hasCat&&hasStyle;
  return false;
}
function wsWizardCrumbReachable(stepNum){
  return stepNum<=currentStep||wsWizardStepPrereqsMet(stepNum);
}

/** “Step 2 of 3 · Style” compact header; follows {@link currentStep} + locale. */
function wsFormatStepNOfM(step,total){
  return String(wsT('wiz.step_n_of_m')||'').replace(/\{0\}/g,String(step)).replace(/\{1\}/g,String(total));
}
function wsWizardStepTitleKey(step){
  if(wsIsCategoryInferEnabled()){
    if(wsFunnelOrder()==='upload_style'){
      if(step===1)return 'wiz.ind3.title';
      if(step===2)return 'wiz.ind2.title';
    }else{
      if(step===1)return 'wiz.ind2.title';
      if(step===2)return 'wiz.ind3.title';
    }
    return 'wiz.ind3.title';
  }
  if(step===1)return 'wiz.ind1.title';
  if(step===2)return 'wiz.ind2.title';
  return 'wiz.ind3.title';
}
function wsRefreshWizardStepProgress(){
  const el=document.getElementById('ws-wizard-step-progress');
  if(!el)return;
  let s;
  try{s=currentStep;}catch(_){el.hidden=true;return;}
  if(typeof s!=='number'||s<1||s>wsLogicalWizardStepCount()){
    el.textContent='';
    el.hidden=true;
    return;
  }
  el.hidden=false;
  const title=wsT(wsWizardStepTitleKey(s));
  const sep=wsT('wiz.step_title_sep')||' · ';
  el.textContent=wsFormatStepNOfM(s,wsLogicalWizardStepCount())+(title?sep+title:'');
}
function wsSyncCategoryInferDomClass(){
  const wrap=document.getElementById('wallstraight-generator');
  if(!wrap)return;
  wrap.classList.toggle('ws-cat-infer-enabled',wsIsCategoryInferEnabled());
  const step1=document.getElementById('step1');
  if(step1)step1.hidden=wsIsCategoryInferEnabled();
}
function wsSyncWizardDots(){
  const total=wsLogicalWizardStepCount();
  document.querySelectorAll('#ws-wizard-dots .ws-wizard-dot').forEach(dot=>{
    const n=parseInt(String(dot.getAttribute('data-ws-wizard-dot')||''),10);
    dot.classList.toggle('ws-wizard-dot--infer-hidden',wsIsCategoryInferEnabled()&&n>total);
    dot.classList.remove('is-active','is-complete');
    if(n<currentStep)dot.classList.add('is-complete');
    else if(n===currentStep)dot.classList.add('is-active');
  });
  for(let i=1;i<=3;i++){
    const ind=document.getElementById('step'+i+'-indicator');
    if(!ind)continue;
    const physical=wsIsCategoryInferEnabled()?wsResolvePhysicalStepId(currentStep):currentStep;
    if(i===physical)ind.setAttribute('aria-current','step');
    else ind.removeAttribute('aria-current');
  }
}
function wsWizardHelpKey(step){
  if(wsIsCategoryInferEnabled()){
    if(wsFunnelOrder()==='upload_style'&&step===1)return null;
    if(wsFunnelOrder()==='style_upload'&&step===1){
      if(typeof wsIsWkOranjeMode==='function'&&wsIsWkOranjeMode())return 'wk.oranje.styles.h2';
      return 'wiz.help2';
    }
    if(step===2&&wsFunnelOrder()==='upload_style'){
      if(typeof wsIsWkOranjeMode==='function'&&wsIsWkOranjeMode())return 'wk.oranje.styles.h2';
      return 'wiz.help2';
    }
    return null;
  }
  if(step===1)return 'wiz.help1';
  if(step===2){
    if(typeof wsIsWkOranjeMode==='function'&&wsIsWkOranjeMode())return 'wk.oranje.styles.h2';
    return 'wiz.help2';
  }
  return null;
}
function wsRefreshWizardHelp(){
  const el=document.getElementById('ws-wizard-help');
  if(!el)return;
  if(wsInferComposerShowsInlineStyle()){
    el.hidden=true;
    el.textContent='';
    el.classList.remove('ws-wizard-help--wk-style');
    return;
  }
  const key=wsWizardHelpKey(currentStep);
  const wkStyleHelp=!!(key==='wk.oranje.styles.h2');
  el.classList.toggle('ws-wizard-help--wk-style',wkStyleHelp);
  if(!key){
    el.hidden=true;
    el.textContent='';
    return;
  }
  el.hidden=false;
  el.textContent=wsT(key);
}
function wsRefreshWizardNav(){
  const back=document.getElementById('wsWizardBack');
  const next=document.getElementById('wsWizardNext');
  const chgCat=document.getElementById('wsWizardChgCat');
  const chgStyle=document.getElementById('wsWizardChgStyle');
  const nav=document.getElementById('ws-wizard-nav');
  if(wsIsCategoryInferEnabled()){
    if(nav)nav.hidden=true;
    return;
  }
  if(!back||!next)return;
  const s=typeof currentStep==='number'?currentStep:1;
  const total=wsLogicalWizardStepCount();
  const onFinalStep=s>=total;
  const onUploadPhysical=wsResolvePhysicalStepId(s)===3;
  back.hidden=onFinalStep||s<=1;
  if(!back.hidden)back.setAttribute('aria-label',wsT('wiz.back_aria'));
  next.hidden=onFinalStep||s>=total;
  if(chgCat){
    chgCat.hidden=!onUploadPhysical||!wsIsCategoryInferEnabled();
    if(!chgCat.hidden){
      chgCat.textContent=wsT('wiz.chg_cat');
      chgCat.setAttribute('aria-label',wsT('cat.infer.change_aria'));
    }
  }
  if(chgStyle){
    chgStyle.hidden=!onUploadPhysical;
    if(onFinalStep){
      chgStyle.textContent=wsT('wiz.chg_style');
      chgStyle.setAttribute('aria-label',wsT('wiz.chg_style_aria'));
    }
  }
  if(nav)nav.classList.toggle('ws-wizard-nav--upload',onUploadPhysical);
  const nextNum=s+1;
  next.disabled=!(s<total&&wsWizardStepPrereqsMet(nextNum));
  if(s===1)next.textContent=wsT('wiz.next1');
  else if(s===2)next.textContent=wsT('wiz.next2');
}
function wsSyncStepCrumbLockState(){
  /* Legacy breadcrumb pills removed; dots + Back/Next replace lock UI. */
}

/** Opens the hidden primary file picker (#fileIn). Shared by upload zone, quality hint, and wizard summary. */
function wsOpenPrimaryUploadPicker(){
  const fi=typeof document!=='undefined'?document.getElementById('fileIn'):null;
  if(fi)fi.click();
}

/** Logical wizard step that holds the style grid (infer-aware). */
function wsLogicalStyleStep(){
  if(wsIsCategoryInferEnabled())return wsFunnelOrder()==='style_upload'?1:2;
  return 2;
}

/** Live summary row: category, style, upload status (display-only; does not mutate generation state). */
function wsRefreshWizardChoiceSummary(){
  const catEl=document.getElementById('ws-wiz-sum-cat');
  const styEl=document.getElementById('ws-wiz-sum-style');
  const phEl=document.getElementById('ws-wiz-sum-photo');
  if(!catEl||!styEl||!phEl)return;
  const infer=wsIsCategoryInferEnabled();
  const catRow=catEl.closest('.ws-wizard-choice-summary__row');
  const styRow=styEl.closest('.ws-wizard-choice-summary__row');
  const phRow=phEl.closest('.ws-wizard-choice-summary__row');
  if(catRow)catRow.hidden=infer;
  if(styRow){
    const styLbl=styRow.querySelector('.ws-wiz-sum__k');
    if(styLbl)styLbl.textContent=wsT(infer?'wiz.summary.style_lbl_infer':'wiz.summary.style_lbl');
  }
  if(phRow){
    const phLbl=phRow.querySelector('.ws-wiz-sum__k');
    if(phLbl)phLbl.textContent=wsT(infer?'wiz.summary.photo_lbl_infer':'wiz.summary.photo_lbl');
  }
  styEl.setAttribute('data-ws-wizard-goto',String(wsLogicalStyleStep()));
  try{wsSyncStyleAndCategoryFromDom();}catch(_){/* non-fatal */}
  let cat=S.cat;
  const pill=document.querySelector('#wallstraight-generator .pill.on');
  if(!cat&&pill&&pill.dataset&&pill.dataset.c)cat=pill.dataset.c;
  catEl.textContent=cat?wsT('pill.'+cat):wsT('wiz.summary.not_chosen');
  let sk=S.style;
  const rad=document.querySelector('#wallstraight-generator input[name="s"]:checked');
  if(!sk&&rad&&rad.value)sk=rad.value;
  const sn=sk?wsStyleName(sk):'';
  styEl.textContent=sn?sn:wsT('wiz.summary.not_chosen');
  phEl.textContent=S.b64?wsT('wiz.summary.photo_ok'):wsT('wiz.summary.photo_none');
  phEl.disabled=!!S.b64;
  if(S.b64)phEl.removeAttribute('aria-label');
  else phEl.setAttribute('aria-label',wsT('wiz.summary.upload_photo_aria'));
}

function showStep(step) {
  const physical = wsResolvePhysicalStepId(step);
  const stepEl = document.getElementById('step' + physical);
  const indEl = document.getElementById('step' + physical + '-indicator');
  if (!stepEl || !indEl) return;

  if (wsShouldClearUploadOnWizardStep(step)) {
    wsClearUploadedPhoto();
    hideErr();
  }

  document.querySelectorAll('.step-section').forEach(s => {
    s.classList.remove('active');
  });

  stepEl.classList.add('active');

  currentStep = step;
  wsSyncCategoryInferDomClass();
  wsMountChoiceSummary(step);
  wsSyncWizardDots();
  wsRefreshWizardStepProgress();
  wsRefreshWizardHelp();
  wsRefreshWizardNav();
  updateGenerateButton();
  if(typeof wsSyncUploadReviewsStep==='function')wsSyncUploadReviewsStep(step);
  if(wsResolvePhysicalStepId(step)===2){
    if(typeof wsPreloadStyletilesOnce==='function')wsPreloadStyletilesOnce();
    if(typeof wsFireStyleCardExposure==='function')wsFireStyleCardExposure();
  }
}

function prevStep() {
  if (typeof currentStep !== 'number' || currentStep <= 1) return;
  const target = currentStep - 1;
  showStep(target);
  requestAnimationFrame(() => {
    const el = document.getElementById('step' + wsResolvePhysicalStepId(target));
    if (el) wsScrollElIntoView(el, 'nearest');
  });
}

// Auto advance to next step (scroll new step into view for mobile)
function nextStep() {
  const total = wsLogicalWizardStepCount();
  if (currentStep >= total) return;
  const next = currentStep + 1;
  if (!wsWizardStepPrereqsMet(next)) return;
  showStep(next);
  requestAnimationFrame(()=>{
    wsScrollElIntoView(document.getElementById('step' + wsResolvePhysicalStepId(next)), 'nearest');
  });
}

function updateGenerateButton() {
  const wrap=document.getElementById('wallstraight-generator');
  const hasCategory=wsIsCategoryInferEnabled()
    ?(!S.b64||!!S.cat)
   :(wrap&&wrap.querySelector('.pill.on')!==null);
  const hasFile = S.b64 !== null;
  const hasStyle = wrap&&wrap.querySelector('.sty.on') !== null;
  const stepOk = wsIsCategoryInferEnabled()
    ?wsInferGenerateStepOk()
    :(typeof currentStep === 'number' && currentStep === wsLogicalWizardStepCount());
  const inferBlocksGenerate=S.b64&&(S.catInferenceNeedsConfirm===true&&!S.cat);

  if(genBtn){
    genBtn.hidden=!hasFile;
    genBtn.disabled =
      !(hasCategory && hasFile && hasStyle && stepOk && !inferBlocksGenerate) || S.busy;
  }
  if(typeof wsRenderCategoryInferChip==='function')wsRenderCategoryInferChip();
  if(typeof wsRenderInferStyleReminder==='function')wsRenderInferStyleReminder();
  if(typeof wsRenderCategoryHint==='function')wsRenderCategoryHint();
  if(typeof wsRefreshPetNameEditLink==='function')wsRefreshPetNameEditLink();
  wsSyncWizardDefaultsHint();
  if(typeof wsRefreshWizardChoiceSummary==='function')wsRefreshWizardChoiceSummary();
  if(typeof wsSyncStepCrumbLockState==='function')wsSyncStepCrumbLockState();
  if(typeof wsRefreshWizardStepProgress==='function')wsRefreshWizardStepProgress();
  if(typeof wsRefreshWizardHelp==='function')wsRefreshWizardHelp();
  if(typeof wsRefreshWizardNav==='function')wsRefreshWizardNav();
  if(typeof wsSyncInferComposerLayout==='function')wsSyncInferComposerLayout();
}

// Pill selection: step 1 advances immediately (no default category → one tap to proceed)
document.querySelectorAll('.pill').forEach(p=>{
  const existingHandler=p.onclick;
  p.onclick=()=>{
    if(existingHandler)existingHandler();
    const slug=p.getAttribute('data-c');
    try{window.wsFunnelAnalytics?.record('generator_interaction',{style:S.style,category:slug});}catch(_){}
    const prevCat=S.cat;
    const wasAutoRouted=S.catAutoRouted===true;
    if(slug==='huisdier'&&wasAutoRouted)S.catManualHuisdier=true;
    else if(slug!=='huisdier')S.catManualHuisdier=false;
    if(slug&&slug!==prevCat)S.catAutoRouted=false;
    updateGenerateButton();
    if(typeof currentStep==='number'&&currentStep===1&&!wsIsCategoryInferEnabled())nextStep();
  };
});

// Modified file upload handler — no auto skip to step 3
const originalHandleFile = handleFile;
handleFile = function(f){
  originalHandleFile(f);
  updateGenerateButton();
};
try{window.handleFile=handleFile;}catch(_){/* non-browser */}

// Style selection — advance upload step after pick (classic flow)
document.querySelectorAll('.sty').forEach(s => {
  const existingHandler = s.onclick;
  s.onclick = () => {
    if (existingHandler) existingHandler();
    updateGenerateButton();
    if (typeof currentStep === 'number' && typeof nextStep === 'function') {
      const inferStyleFirst=wsIsCategoryInferEnabled()&&wsFunnelOrder()==='style_upload'&&currentStep===1;
      const classicStyleStep=!wsIsCategoryInferEnabled()&&currentStep===2;
      if(inferStyleFirst||classicStyleStep)requestAnimationFrame(() => nextStep());
    }
  };
});
document.querySelectorAll('#wallstraight-generator input[name="s"]').forEach(inp=>{
  inp.addEventListener('change',()=>{
    wsSyncStyleAndCategoryFromDom();
    updateGenerateButton();
    if (typeof currentStep === 'number' && typeof nextStep === 'function') {
      const inferStyleFirst=wsIsCategoryInferEnabled()&&wsFunnelOrder()==='style_upload'&&currentStep===1;
      const classicStyleStep=!wsIsCategoryInferEnabled()&&currentStep===2;
      if(inferStyleFirst||classicStyleStep)requestAnimationFrame(() => nextStep());
    }
  });
});

const wsWizardBackBtn=document.getElementById('wsWizardBack');
const wsWizardNextBtn=document.getElementById('wsWizardNext');
const wsWizardChgCatBtn=document.getElementById('wsWizardChgCat');
const wsWizardChgStyleBtn=document.getElementById('wsWizardChgStyle');
if(wsWizardBackBtn)wsWizardBackBtn.addEventListener('click',()=>prevStep());
if(wsWizardNextBtn)wsWizardNextBtn.addEventListener('click',()=>nextStep());
function wsWizardGoToStep(stepNum){
  const max=wsLogicalWizardStepCount();
  if(stepNum<1||stepNum>max)return;
  showStep(stepNum);
  requestAnimationFrame(()=>{
    const physical=wsResolvePhysicalStepId(stepNum);
    const el=document.getElementById('step'+physical);
    if(el)wsScrollElIntoView(el,'nearest');
  });
}
if(wsWizardChgCatBtn)wsWizardChgCatBtn.addEventListener('click',()=>{
  if(wsIsCategoryInferEnabled())wsOpenCategoryInferChooser();
  else wsWizardGoToStep(1);
});
if(wsWizardChgStyleBtn)wsWizardChgStyleBtn.addEventListener('click',()=>{
  const styleStep=wsIsCategoryInferEnabled()
    ?(wsFunnelOrder()==='style_upload'?1:2)
    :2;
  wsWizardGoToStep(styleStep);
});

/* Slice R.7 — skip wizard defaults while a recovery path is in flight so
   ?ws_job / sessionStorage restore does not flash step 3 before #resPage. */
let wsRecoveryDeferredWizard=false;
function wsShouldDeferWizardForRecovery(){
  if(typeof window==='undefined')return false;
  if(window.__WS_CONTRACT_TEST__===true)return false;
  const parsed=wsRecoveryParseUrl(window.location.href);
  if(parsed.isNew)return false;
  if(parsed.jobId&&parsed.token)return true;
  try{
    const h=window.location.hash;
    if(h==='#resPage'||h==='#resFinish'){
      const rec=wsPortraitSessionRead();
      if(rec&&rec.jobId&&rec.previewUrl)return true;
    }
  }catch(_){/* session read is best-effort */}
  return false;
}
if(typeof window!=='undefined'){
  wsRecoveryDeferredWizard=wsShouldDeferWizardForRecovery();
}
// Initialize step wizard: step 1 fresh start (contract tests may override DOM only).
if (typeof window !== 'undefined' &&
    window.__WS_CONTRACT_TEST__ &&
    document.getElementById('step3-indicator') &&
    document.getElementById('step3')) {
  showStep(3);
} else if (typeof window !== 'undefined'&&!wsRecoveryDeferredWizard) {
  wsBootstrapWizardFreshStart();
  if(typeof wsSyncCategoryInferDomClass==='function')wsSyncCategoryInferDomClass();
  if(typeof wsSyncInferComposerLayout==='function')wsSyncInferComposerLayout();
  showStep(1);
  wsInitWkOranjeLanding();
}
updateGenerateButton();

(function wsBindWizardGoto(){
  document.querySelectorAll('[data-ws-wizard-goto]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const stepNum = parseInt(String(btn.getAttribute('data-ws-wizard-goto')||''),10);
      if(stepNum>=1&&stepNum<=wsLogicalWizardStepCount())wsWizardGoToStep(stepNum);
    });
  });
})();

(function wsBindWizardPhotoSummary(){
  const phEl=document.getElementById('ws-wiz-sum-photo');
  if(!phEl)return;
  phEl.addEventListener('click',()=>{
    if(S.b64||phEl.disabled)return;
    wsOpenPrimaryUploadPicker();
  });
})();

document.querySelectorAll('.ws-lang-btn').forEach(btn=>{
  btn.addEventListener('click',()=>{
    const v=btn.getAttribute('data-ws-lang');
    if(v==='en'||v==='nl'||v==='es'||v==='it'){
      wsApplyUiLang(v);
      wsSyncResultTierPrices();
    }
    if(typeof window.Weglot!== 'undefined' && typeof window.Weglot.switchTo === 'function'){
      try{
        window.Weglot.switchTo(v);
      }catch(_){/* Weglot optional */}
    }
  });
});
document.querySelectorAll('.ws-lang-select').forEach(sel=>{
  sel.addEventListener('change',()=>{
    const v=sel.value;
    if(v==='en'||v==='nl'||v==='es'||v==='it'){
      wsApplyUiLang(v);
      wsSyncResultTierPrices();
    }
    if(typeof window.Weglot!== 'undefined' && typeof window.Weglot.switchTo === 'function'){
      try{
        window.Weglot.switchTo(v);
      }catch(_){/* Weglot optional */}
    }
  });
});
wsGeoSuggestLang();
wsBindWeglot();
wsScheduleLangResync();
wsSyncResultTierPrices();
wsMaatkeuzeInit();
wsMatSampleInit();

/* ─────────────────────────────────────────────────────────────────────────
   Slice R.1 — Portrait Recovery (sessionStorage layer)

   Three-layer recovery model defined in
   ~/.cursor/plans/portrait_recovery_checkout_988dfe7e.plan.md §4:
     Durable  → signed share_url (+ ?ws_job / ?ws_t query params)
     Session  → window.sessionStorage[WS_PORTRAIT_SESSION_KEY]
     Commerce → cart FAB + landing cart chip (Slice R.3)

   This layer answers "I refreshed or hit Back on the same tab" without a
   network round-trip. MDN — sessionStorage is partitioned per
   (origin, top-level browsing context), survives reload, is cleared on
   tab close (https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage).

   Guardrails (G1, G7, G8 in the plan):
     - Never persist upload bytes / base64 — only public preview URLs.
     - 24h TTL so stale tabs do not re-show last week's portrait.
     - Storage access is wrapped in try/catch: MDN documents a SecurityError
       throw when the user has disabled cookies / site storage, and Safari
       in private mode historically threw QuotaExceededError on setItem.
   ───────────────────────────────────────────────────────────────────────── */
const WS_PORTRAIT_SESSION_KEY='ws_portrait_session';
/** 24h TTL — long enough to cover dinner-break drop-off, short enough to
    avoid re-surfacing a stale portrait the next day. */
const WS_PORTRAIT_SESSION_TTL_MS=24*60*60*1000;

/** Persist a generated-portrait checkpoint to sessionStorage. Returns true
    on success, false on any storage failure or invalid payload (no throws). */
function wsPortraitSessionWrite(payload){
  try{
    if(typeof window==='undefined'||!window.sessionStorage)return false;
    if(!payload||typeof payload!=='object')return false;
    const jobId=String(payload.jobId||'').trim();
    if(!jobId)return false;
    const previewRaw=typeof payload.previewUrl==='string'?payload.previewUrl.trim():'';
    const shareRaw=typeof payload.shareUrl==='string'?payload.shareUrl.trim():'';
    const funnelRaw=typeof payload.funnelResumeUrl==='string'?payload.funnelResumeUrl.trim():'';
    /* Reject non-HTTPS preview URLs — we won't try to restore via data: URLs
       (those are upload bytes — G1) and we won't accept anything we can't
       safely set as <img src> on a reload. */
    const previewUrl=/^https?:\/\//i.test(previewRaw)?previewRaw:'';
    const shareUrl=/^https?:\/\//i.test(shareRaw)?shareRaw:'';
    const funnelResumeUrl=/^https?:\/\//i.test(funnelRaw)?funnelRaw:'';
    if(!previewUrl&&!shareUrl)return false;
    const record={
      jobId:jobId.slice(0,128),
      previewUrl,
      shareUrl,
      funnelResumeUrl,
      style:String(payload.style||'').trim().slice(0,40),
      cat:String(payload.cat||'').trim().slice(0,40),
      savedAt:Date.now()
    };
    window.sessionStorage.setItem(WS_PORTRAIT_SESSION_KEY,JSON.stringify(record));
    return true;
  }catch(_){return false;/* SecurityError, QuotaExceededError, JSON edge cases */}
}

/** Read + validate the sessionStorage checkpoint. Returns the parsed record
    or null when missing / malformed / expired. Auto-clears expired entries. */
function wsPortraitSessionRead(){
  try{
    if(typeof window==='undefined'||!window.sessionStorage)return null;
    const raw=window.sessionStorage.getItem(WS_PORTRAIT_SESSION_KEY);
    if(!raw)return null;
    const parsed=JSON.parse(raw);
    if(!parsed||typeof parsed!=='object')return null;
    if(typeof parsed.jobId!=='string'||!parsed.jobId)return null;
    if(typeof parsed.savedAt!=='number'||!Number.isFinite(parsed.savedAt))return null;
    if(Date.now()-parsed.savedAt>WS_PORTRAIT_SESSION_TTL_MS){
      wsPortraitSessionClear();
      return null;
    }
    /* Re-validate URL fields on read so a hand-edited storage entry can
       never inject a javascript: URL into <img src> on restore (defence
       in depth on top of the write-time check). */
    const previewUrl=typeof parsed.previewUrl==='string'&&/^https?:\/\//i.test(parsed.previewUrl)?parsed.previewUrl:'';
    const shareUrl=typeof parsed.shareUrl==='string'&&/^https?:\/\//i.test(parsed.shareUrl)?parsed.shareUrl:'';
    const funnelResumeUrl=typeof parsed.funnelResumeUrl==='string'&&/^https?:\/\//i.test(parsed.funnelResumeUrl)?parsed.funnelResumeUrl:'';
    if(!previewUrl&&!shareUrl)return null;
    return{
      jobId:String(parsed.jobId).slice(0,128),
      previewUrl,
      shareUrl,
      funnelResumeUrl,
      style:typeof parsed.style==='string'?parsed.style.slice(0,40):'',
      cat:typeof parsed.cat==='string'?parsed.cat.slice(0,40):'',
      savedAt:parsed.savedAt
    };
  }catch(_){return null;}
}

/** Clear the sessionStorage checkpoint. Idempotent; never throws. */
function wsPortraitSessionClear(){
  try{
    if(typeof window!=='undefined'&&window.sessionStorage){
      window.sessionStorage.removeItem(WS_PORTRAIT_SESSION_KEY);
    }
  }catch(_){/* ignore */}
}

/** Expose for test harnesses / debug — non-enumerable on window to avoid
    polluting autocomplete on the storefront. */
try{
  if(typeof window!=='undefined'){
    window.wsPortraitSessionWrite=wsPortraitSessionWrite;
    window.wsPortraitSessionRead=wsPortraitSessionRead;
    window.wsPortraitSessionClear=wsPortraitSessionClear;
  }
}catch(_){/* SSR */}

/* ─────────────────────────────────────────────────────────────────────────
   Slice R.2 — Portrait Recovery (bootstrap layer)

   On page load, restore #resPage + checkout tiers without a re-upload when:
     1. URL carries  ?ws_job=<uuid>&ws_t=<token>           (durable share link)
     2. sessionStorage holds a valid ws_portrait_session   (same-tab refresh)
     3. ?ws_new=1                                          → clear session, do nothing

   Query params win over sessionStorage because they represent the most
   explicit shopper intent (clicked a saved/shared link). Plan §6 A2.

   Network call (1) targets the app-proxy preview JSON endpoint that the
   wallstraight-app companion is shipping in lockstep
   (plan §6 B1). Backward-compat: if the route 404s / 403s / times out,
   we silently fall through to the sessionStorage layer, then to the
   default landing flow — no regression for old links / old app builds.

   Guardrails:
     G3 — never trust ws_t client-side; the app validates the token
     G8 — never auto-call POST /ai/generate from restore (quota / cost)
   ───────────────────────────────────────────────────────────────────────── */

/** Max wait for the preview JSON hydration call before we give up and fall
    back to the sessionStorage path. 5s mirrors the perceptible-latency
    threshold used in our existing studio recovery flows. */
const WS_RECOVERY_FETCH_TIMEOUT_MS=5000;

/** Derive the preview JSON URL from the configured generate URL:
    /apps/wallstraight/ai/generate  →  /apps/wallstraight/preview/<jobId>
    Falls back to the storefront-relative default. */
function wsRecoveryPreviewUrl(jobId,token){
  const base=(typeof WS_PROXY_GENERATE==='string'&&WS_PROXY_GENERATE.trim())?WS_PROXY_GENERATE.trim():'/apps/wallstraight/ai/generate';
  /* Strip a trailing /ai/generate (with or without a slash) so we land on
     the app-proxy root, then append /preview/<jobId>. */
  const root=base.replace(/\/(?:ai\/generate)\/?$/,'');
  const safeId=encodeURIComponent(String(jobId||''));
  const safeT=encodeURIComponent(String(token||''));
  return root+'/preview/'+safeId+(safeT?('?t='+safeT):'');
}

/** RFC 4122 UUID v1-v5 (case-insensitive). The app-proxy enforces strict
    validation server-side; this is a cheap client-side sanity gate so we
    do not trigger a fetch for obviously malformed URLs. */
const WS_UUID_RE=/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Parse the recovery query string. Returns {jobId, token, style, cat, isNew}
    with empty strings / false when params are missing or malformed. */
function wsRecoveryParseUrl(href){
  const out={jobId:'',token:'',style:'',cat:'',isNew:false};
  try{
    const u=new URL(href||window.location.href);
    const j=String(u.searchParams.get('ws_job')||'').trim();
    const t=String(u.searchParams.get('ws_t')||u.searchParams.get('t')||'').trim();
    const s=String(u.searchParams.get('ws_style')||'').trim();
    const c=String(u.searchParams.get('ws_cat')||'').trim();
    out.isNew=String(u.searchParams.get('ws_new')||'').trim()==='1';
    if(WS_UUID_RE.test(j))out.jobId=j;
    /* Token is opaque to the theme; accept strict 64-hex HMAC or extract
       a 64-hex prefix when share URLs were polluted (e.g. Web Share blurb
       appended to ?t=). Worker re-signs canonical links; this is defense
       in depth for legacy polluted bookmarks. */
    const WS_SHARE_TOKEN_HEX_RE=/^[a-f0-9]{64}$/i;
    const WS_SHARE_TOKEN_HEX_PREFIX_RE=/^([a-f0-9]{64})/i;
    if(WS_SHARE_TOKEN_HEX_RE.test(t))out.token=t;
    else{
      const hexPrefix=WS_SHARE_TOKEN_HEX_PREFIX_RE.exec(t);
      if(hexPrefix)out.token=hexPrefix[1];
    }
    if(s&&s.length<=40&&/^[a-z0-9_-]+$/i.test(s))out.style=s;
    if(c&&c.length<=40&&/^[a-z0-9_-]+$/i.test(c))out.cat=c;
  }catch(_){/* malformed URL — return empty struct */}
  return out;
}

/** Apply a recovered portrait record onto S + DOM. Synchronous state writes
    only; the caller awaits wsSetResImage to decode + paint. Returns the
    record on success, null when required fields are missing. */
function wsRecoveryApplyRecord(record){
  if(!record||typeof record!=='object')return null;
  const jobId=String(record.jobId||'').trim();
  const previewUrl=typeof record.previewUrl==='string'&&/^https?:\/\//i.test(record.previewUrl)?record.previewUrl.trim():'';
  const shareUrl=typeof record.shareUrl==='string'&&/^https?:\/\//i.test(record.shareUrl)?record.shareUrl.trim():'';
  const funnelResumeUrl=typeof record.funnelResumeUrl==='string'&&/^https?:\/\//i.test(record.funnelResumeUrl)?record.funnelResumeUrl.trim():'';
  if(!jobId||!previewUrl)return null;
  if(typeof S==='undefined'||!S)return null;
  S.lastJobId=jobId;
  S.lastPreviewUrl=previewUrl;
  S.lastShareUrl=shareUrl;
  S.lastFunnelResumeUrl=funnelResumeUrl;
  S.imgUrl=previewUrl;
  if(record.style)S.style=String(record.style).trim().slice(0,40);
  if(record.cat)S.cat=String(record.cat).trim().slice(0,40);
  return{jobId,previewUrl,shareUrl,funnelResumeUrl,style:S.style,cat:S.cat};
}

/** Network-backed hydration via app-proxy preview endpoint. Returns the
    record on 2xx with a usable preview_url, otherwise null. Errors are
    swallowed — every failure path must fall through to the sessionStorage
    layer so a flaky network never blocks the landing wizard. */
async function wsRecoveryFetchByToken(jobId,token){
  if(!jobId||!token)return null;
  if(typeof window==='undefined'||typeof window.fetch!=='function')return null;
  const url=wsRecoveryPreviewUrl(jobId,token);
  const ac=(typeof AbortController!=='undefined')?new AbortController():null;
  const timer=ac?setTimeout(()=>{try{ac.abort();}catch(_){/* ignore */}},WS_RECOVERY_FETCH_TIMEOUT_MS):0;
  try{
    const res=await fetch(url,{
      method:'GET',
      headers:{Accept:'application/json'},
      credentials:'same-origin',
      signal:ac?ac.signal:undefined
    });
    if(res.status===410)return{error:'expired'};
    if(!res.ok)return{error:'failed'};
    const data=await res.json().catch(()=>null);
    if(!data||typeof data!=='object')return null;
    const previewRaw=String(data.preview_url||data.previewUrl||'').trim();
    const shareRaw=String(data.share_url||data.shareUrl||'').trim();
    const funnelRaw=String(data.funnel_resume_url||data.funnelResumeUrl||'').trim();
    if(!/^https?:\/\//i.test(previewRaw))return null;
    return{
      jobId:String(data.job_id||data.jobId||jobId).trim(),
      previewUrl:previewRaw,
      shareUrl:/^https?:\/\//i.test(shareRaw)?shareRaw:'',
      funnelResumeUrl:/^https?:\/\//i.test(funnelRaw)?funnelRaw:'',
      style:String(data.style||'').trim(),
      cat:String(data.category||data.cat||'').trim()
    };
  }catch(_){return null;/* abort / network / JSON / CORS — fall through */}
  finally{if(timer)clearTimeout(timer);}
}

/** Scroll to the tier / finish section after share-link funnel resume.
    Skipped on fresh generate (showResult keeps portrait hero at top). */
function wsScrollToResultFinish(){
  if(typeof document==='undefined')return;
  const el=document.getElementById('resFinish')||document.querySelector('.res-pricing');
  if(!el)return;
  let smooth=false;
  try{
    smooth=!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }catch(_){/* matchMedia unavailable */}
  const run=()=>{
    try{
      el.scrollIntoView({behavior:smooth?'smooth':'auto',block:'start'});
    }catch(_){
      try{el.scrollIntoView(true);}catch(_){/* scroll best-effort */}
    }
  };
  if(typeof requestAnimationFrame==='function'){
    requestAnimationFrame(()=>requestAnimationFrame(run));
  }else{
    setTimeout(run,0);
  }
}

/** Victor checkout — res-variant-jump-tabs Slice B. Upgrade the in-page
    jump nav (Slice A) from native `#anchor` jumps to smooth scroll +
    active state. Idempotent: showResult() calls this on every result view,
    so the nav is flagged (`data-ws-res-jump-bound`) and uses one delegated
    listener. Reduced motion is honored by wsScrollElIntoView (which reads
    wsPrefersReducedMotionScroll → 'instant' vs 'smooth'). */
function wsBindResVariantJumpTabs(){
  if(typeof document==='undefined')return;
  const nav=document.querySelector('[data-ws-res-variant-jump]');
  if(!nav)return;
  const tabs=Array.prototype.slice.call(nav.querySelectorAll('.res-variant-jump__tab'));
  if(!tabs.length)return;
  const setActive=(tab)=>{
    tabs.forEach(t=>{
      const on=t===tab;
      t.classList.toggle('is-active',on);
      if(on)t.setAttribute('aria-current','true');else t.removeAttribute('aria-current');
    });
  };
  const targetFor=(tab)=>{
    const id=tab.getAttribute('data-ws-res-jump-target')||(tab.getAttribute('href')||'').replace(/^#/,'');
    return id?document.getElementById(id):null;
  };
  const jump=(tab)=>{
    if(!tab)return;
    const el=targetFor(tab);
    if(!el)return;
    setActive(tab);
    /* wsScrollElIntoView picks 'instant' when prefers-reduced-motion: reduce. */
    wsScrollElIntoView(el,'start');
  };
  if(nav.dataset.wsResJumpBound!=='1'){
    nav.dataset.wsResJumpBound='1';
    nav.addEventListener('click',(e)=>{
      const tab=e.target&&e.target.closest?e.target.closest('.res-variant-jump__tab'):null;
      if(!tab||!nav.contains(tab))return;
      e.preventDefault();
      jump(tab);
    });
    nav.addEventListener('keydown',(e)=>{
      if(e.key!=='Enter'&&e.key!==' '&&e.key!=='Spacebar')return;
      const tab=e.target&&e.target.closest?e.target.closest('.res-variant-jump__tab'):null;
      if(!tab||!nav.contains(tab))return;
      e.preventDefault();
      jump(tab);
    });
    /* R6 (nice-to-have): reflect manual scroll position in the active tab. */
    if(typeof IntersectionObserver==='function'){
      try{
        const byId={};
        tabs.forEach(t=>{const id=t.getAttribute('data-ws-res-jump-target');if(id)byId[id]=t;});
        const io=new IntersectionObserver((entries)=>{
          entries.forEach(en=>{
            if(en.isIntersecting&&byId[en.target.id])setActive(byId[en.target.id]);
          });
        },{rootMargin:'-45% 0px -45% 0px',threshold:0});
        Object.keys(byId).forEach(id=>{const el=document.getElementById(id);if(el)io.observe(el);});
        nav.__wsResJumpIO=io;
      }catch(_){/* IntersectionObserver best-effort */}
    }
  }
}

/** Top-level recovery entrypoint — invoked once at script bottom.
    Priority: ?ws_new=1 → URL params → sessionStorage → no-op landing. */
async function wsBootstrapPortraitRecovery(){
  if(typeof window==='undefined'||typeof document==='undefined')return null;
  if(typeof showResult!=='function')return null;
  if(typeof S==='undefined')return null;
  /* Skip restore inside contract-test harness so existing wizard test
     setups (showStep(3)) keep deterministic DOM state. */
  if(window.__WS_CONTRACT_TEST__===true)return null;

  const parsed=wsRecoveryParseUrl(window.location.href);

  /* ?ws_new=1 — explicit "start a fresh portrait" intent (e.g. the
     secondary CTA on the share preview page). Wipe the session so a
     prior tab restore does not race the wizard. */
  if(parsed.isNew){
    wsPortraitSessionClear();
    return null;
  }

  /* Layer 1 — durable share link with signed token. */
  let record=null;
  let urlRestoreAttempted=false;
  let urlRestoreError='';
  if(parsed.jobId&&parsed.token){
    urlRestoreAttempted=true;
    const fetched=await wsRecoveryFetchByToken(parsed.jobId,parsed.token);
    if(fetched&&fetched.error)urlRestoreError=fetched.error;
    else if(fetched&&!fetched.error)record=fetched;
    if(record){
      /* Carry optional context from the URL through to S even if the
         server omitted them, so wsStyleName / addToCart properties
         render with the right label. */
      if(parsed.style&&!record.style)record.style=parsed.style;
      if(parsed.cat&&!record.cat)record.cat=parsed.cat;
    }
  }

  /* Layer 2 — sessionStorage checkpoint from a prior generate(). */
  if(!record||record.error)record=wsPortraitSessionRead();

  if(!record){
    if(urlRestoreAttempted&&typeof toast==='function'&&typeof wsT==='function'){
      const key=urlRestoreError==='expired'?'res.recover.expired':'res.recover.failed';
      try{toast(wsT(key));}catch(_){/* toast is best-effort */}
    }
    return null;
  }

  const applied=wsRecoveryApplyRecord(record);
  if(!applied)return null;

  /* Mirror the post-generate success path (assets/ws-generator.js
     ~L7603–7613) so the restored view looks identical to a fresh
     generation: tag, showResult chrome, image decode, branding refresh. */
  try{
    if(typeof resTag!=='undefined'&&resTag&&typeof wsStyleName==='function'){
      resTag.textContent=wsStyleName(applied.style)||wsStyleName('royal');
    }
    showResult();
    if(typeof resImg!=='undefined'&&resImg&&typeof wsSetResImage==='function'){
      try{await wsSetResImage(resImg,applied.previewUrl);}catch(_){/* decode failure tolerated */}
    }
    if(typeof wsRefreshPreviewBranding==='function')wsRefreshPreviewBranding();
    /* Share-link / mailto funnel resume: shopper already saw the portrait;
       land on tier cards ("Kies jouw afwerking") not the hero duplicate. */
    if(urlRestoreAttempted&&parsed.jobId&&parsed.token){
      wsScrollToResultFinish();
    }
    /* Re-write the session so TTL is refreshed on every successful restore
       (the shopper is actively using the portrait). */
    wsPortraitSessionWrite(applied);
    try{
      const banner=document.getElementById('wsRecoveryBanner');
      if(banner){
        banner.hidden=true;
        banner.setAttribute('aria-busy','false');
      }
    }catch(_){/* banner hide is best-effort */}
  }catch(_){/* best-effort UX restore — do not throw into init */}

  return applied;
}

try{
  if(typeof window!=='undefined'){
    window.wsBootstrapPortraitRecovery=wsBootstrapPortraitRecovery;
    window.wsActiveJobTryResume=wsActiveJobTryResume;
    window.wsRecoveryParseUrl=wsRecoveryParseUrl;
    window.wsRecoveryPreviewUrl=wsRecoveryPreviewUrl;
    window.wsScrollToResultFinish=wsScrollToResultFinish;
    window.wsBindResVariantJumpTabs=wsBindResVariantJumpTabs;
    window.wsIsWkOranjeMode=wsIsWkOranjeMode;
    window.wsCaptureWkUtmParams=wsCaptureWkUtmParams;
    window.wsApplyWkOranjeColdStart=wsApplyWkOranjeColdStart;
    window.wsApplyWkOranjeBuyDefaults=wsApplyWkOranjeBuyDefaults;
    window.wsInitWkOranjeLanding=wsInitWkOranjeLanding;
  }
}catch(_){/* SSR */}

/* Fire-and-forget recovery after init bindings. When wsRecoveryDeferredWizard
   is true the wizard was skipped above; on failure we run the normal defaults. */
void (async function wsPortraitRecoveryBootstrap(){
  let applied=null;
  try{applied=await wsActiveJobTryResume();}catch(_){applied=null;}
  if(!applied){
    try{applied=await wsBootstrapPortraitRecovery();}catch(_){applied=null;}
  }
  if(wsRecoveryDeferredWizard&&!applied){
    try{
      wsBootstrapWizardFreshStart();
      showStep(1);
      wsInitWkOranjeLanding();
    }catch(_){/* wizard fallback is best-effort */}
  }
})();

/* ─────────────────────────────────────────────────────────────────────────
   Slice R.3 — Portrait Recovery (landing layer)

   Two landing-only UI affordances that close the gap between "I have a
   portrait waiting" and "let me reach checkout from anywhere":

     1. #wsRecoveryBanner   — appears when sessionStorage holds a valid
                              ws_portrait_session AND the shopper is on
                              landing (#resPage not visible). One click
                              re-runs the bootstrap and lands on tiers.
     2. #wsLandingCartChip  — mirrors the result-page FAB count from
                              `GET /cart.js` (Shopify Cart API:
                              https://shopify.dev/docs/api/ajax/reference/cart).
                              Visible only when item_count > 0.

   Together they answer the two pre-existing shopper drop-off paths:
     - "I refreshed and lost everything" → banner
     - "I already added a print, where's my cart?" → chip
   ───────────────────────────────────────────────────────────────────────── */

/** True when #resPage is currently visible (post-generate / restored). */
function wsLandingIsVisible(){
  try{
    const rp=document.getElementById('resPage');
    if(rp&&rp.classList&&rp.classList.contains('show'))return false;
    const lp=document.getElementById('landingPage');
    if(!lp)return false;
    /* Inline style 'none' is what showResult() sets; default '' means visible. */
    return lp.style.display!=='none';
  }catch(_){return false;}
}

/** Mount the recovery banner. Reads the same sessionStorage record used by
    wsBootstrapPortraitRecovery, so the banner cannot show stale data after
    a TTL expiry (read auto-clears expired entries). */
function wsLandingRecoveryInit(){
  if(typeof document==='undefined')return;
  const banner=document.getElementById('wsRecoveryBanner');
  if(!banner)return;
  const btn=document.getElementById('wsRecoveryBannerBtn');
  const close=document.getElementById('wsRecoveryBannerClose');

  const refresh=()=>{
    if(!wsLandingIsVisible()){
      banner.hidden=true;
      return;
    }
    const rec=wsPortraitSessionRead();
    if(rec&&rec.jobId&&rec.previewUrl){
      banner.hidden=false;
      banner.removeAttribute('hidden');
    }else{
      banner.hidden=true;
    }
  };

  if(btn){
    btn.addEventListener('click',async()=>{
      btn.disabled=true;
      banner.setAttribute('aria-busy','true');
      try{
        const r=await wsBootstrapPortraitRecovery();
        if(!r){
          /* Session vanished between paint and click — clear UI and let the
             shopper continue with the wizard rather than show a broken state. */
          wsPortraitSessionClear();
          banner.hidden=true;
        }
      }catch(_){/* swallow — bootstrap is best-effort */}
      finally{
        btn.disabled=false;
        banner.setAttribute('aria-busy','false');
      }
    });
  }
  if(close){
    close.addEventListener('click',()=>{
      /* Dismiss is session-local only — refresh re-surfaces the banner so
         the shopper never loses their checkout path. */
      banner.hidden=true;
    });
  }

  refresh();
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
  window.addEventListener('pageshow',refresh);
  /* When the bootstrap promotes the shopper to #resPage, hide the banner.
     showResult() does not emit an event, so we re-evaluate on the same
     ticks as the FAB lifecycle. */
}

/** Cart chip on landing — same count source as the result-page FAB. */
function wsLandingCartChipRefresh(){/* assigned in wsLandingCartChipInit */}

function wsLandingCartChipInit(){
  if(typeof document==='undefined')return;
  const chip=document.getElementById('wsLandingCartChip');
  const badge=document.getElementById('wsLandingCartChipBadge');
  if(!chip||!badge)return;

  let drawerPrefetchTimer=null;
  const prefetchDrawer=()=>{
    if(drawerPrefetchTimer)clearTimeout(drawerPrefetchTimer);
    drawerPrefetchTimer=setTimeout(()=>{
      drawerPrefetchTimer=null;
      try{if(window.wsCartDrawer&&typeof window.wsCartDrawer.refresh==='function')void window.wsCartDrawer.refresh();}catch(_){/* no-op */}
    },200);
  };

  const applyCount=(n)=>{
    let v=typeof n==='number'&&Number.isFinite(n)?Math.round(n):NaN;
    if(!Number.isFinite(v)||v<0)v=0;
    badge.textContent=v>99?'99+':String(v);
    badge.hidden=v===0;
    const showChip=v>0&&wsLandingIsVisible();
    chip.hidden=!showChip;
    if(showChip)chip.removeAttribute('hidden');
    chip.setAttribute('aria-hidden',showChip?'false':'true');
    try{
      const label=(typeof wsT==='function')?wsT('cart.chip_aria').replace('{0}',String(v)):('View cart ('+v+')');
      chip.setAttribute('aria-label',label);
    }catch(_){/* i18n best-effort */}
    if(showChip)prefetchDrawer();
  };

  const refresh=async()=>{
    if(!wsLandingIsVisible()){
      chip.hidden=true;
      return;
    }
    try{
      const res=await fetch(wsCartJsUrl(),{credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!res.ok){applyCount(0);return;}
      const data=await res.json().catch(()=>null);
      const n=wsCartItemCountFromParsedCartJson(data);
      applyCount(Number.isFinite(n)?n:0);
    }catch(_){applyCount(0);/* offline / transient */}
  };

  wsLandingCartChipRefresh=refresh;

  chip.addEventListener('click',()=>{
    wsRecordFunnelEvent('cart_drawer_open_click',{surface:'landing_chip'});
  },{capture:true});

  void refresh();
  document.addEventListener('visibilitychange',()=>{
    if(!document.hidden){
      void refresh();
      prefetchDrawer();
    }
  });
  window.addEventListener('pageshow',()=>{
    void refresh();
    prefetchDrawer();
  });
  try{document.addEventListener('wallstraight:cart-added',()=>{void refresh();});}catch(_){/* no-op */}
}

try{wsLandingRecoveryInit();}catch(_){/* never block landing on recovery UI */}
try{wsLandingCartChipInit();}catch(_){/* never block landing on cart chip */}
